
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireae80"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireae80"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jTtr8", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /**
   * Module constructor
   * @param  {Object} target Target object to extends methods and properties into
   * @return {Object}        Target after with extended methods and properties
   */ function Happens(target) {
        var nu = this instanceof Happens;
        if (target) {
            if (!nu) for(var prop in Happens.prototype)target[prop] = Happens.prototype[prop];
            else throw new Error("You can't pass a target when instantiating with the `new` keyword");
        } else if (!nu) return new Happens;
    }
    /**
   * Initializes event
   * @param  {String} event Event name to initialize
   * @return {Array}        Initialized event pool
   */ Happens.prototype.__init = function(event) {
        var tmp = this.__listeners || (this.__listeners = []);
        return tmp[event] || (tmp[event] = []);
    };
    /**
   * Adds listener
   * @param  {String}   event Event name
   * @param  {Function} fn    Event handler
   */ Happens.prototype.on = function(event, fn) {
        validate(fn);
        this.__init(event).push(fn);
    };
    /**
   * Removes listener
   * @param  {String}   event Event name
   * @param  {Function} fn    Event handler
   */ Happens.prototype.off = function(event, fn) {
        var pool = this.__init(event);
        pool.splice(pool.indexOf(fn), 1);
    };
    /**
   * Add listener the fires once and auto-removes itself
   * @param  {String}   event Event name
   * @param  {Function} fn    Event handler
   */ Happens.prototype.once = function(event, fn) {
        validate(fn);
        var self = this, wrapper = function() {
            self.off(event, wrapper);
            fn.apply(this, arguments);
        };
        this.on(event, wrapper);
    };
    /**
   * Emit some event
   * @param  {String} event Event name -- subsequent params after `event` will
   * be passed along to the event's handlers
   */ Happens.prototype.emit = function(event /*, arg1, arg2 */ ) {
        var i, pool = this.__init(event).slice(0);
        for(i in pool)pool[i].apply(this, [].slice.call(arguments, 1));
    };
    /**
   * Validates if a function exists and is an instanceof Function, and throws
   * an error if needed
   * @param  {Function} fn Function to validate
   */ function validate(fn) {
        if (!(fn && fn instanceof Function)) throw new Error(fn + ' is not a Function');
    }
    return Happens;
});

});

parcelRegister("iUhcu", function(module, exports) {
var $dc3acc9be2433fb0$var$u = 'undefined', $dc3acc9be2433fb0$var$o = 'object';
(function(klass) {
    $dc3acc9be2433fb0$var$o === "object" ? module.exports = klass : $dc3acc9be2433fb0$var$o === typeof Package && Package.meteor ? WaysWay = klass : this.WaysWay = klass;
})($dc3acc9be2433fb0$var$_module());
function $dc3acc9be2433fb0$var$_module() {
    'use strict';
    var _params_regex = {
        named: /:\w+/g,
        splat: /\*\w+/g,
        optional: /\/(?:\:|\*)(\w+)\?/g
    };
    function Way(pattern, runner, destroyer, dependency) {
        this.matcher = null;
        this.pattern = pattern;
        this.runner = runner;
        this.destroyer = destroyer;
        this.dependency = dependency;
        var _params_regex = {
            named: /:\w+/g,
            splat: /\*\w+/g,
            optional: /\/(\:|\*)(\w+)\?/g
        };
        if (pattern === '*') this.matcher = /.*/;
        else {
            this.matcher = pattern.replace(_params_regex.optional, '(?:\/)?$1$2?');
            this.matcher = this.matcher.replace(_params_regex.named, '([^\/]+)');
            this.matcher = this.matcher.replace(_params_regex.splat, '(.*?)');
            this.matcher = new RegExp("^" + this.matcher + "$", 'm');
        }
    }
    Way.prototype.extract_params = function(url) {
        var name, names, params, vals, i, len;
        names = this.pattern.match(/(?::|\*)(\w+)/g);
        if (names == null) return {};
        vals = url.match(this.matcher);
        params = {};
        for(i = 0, len = names.length; i < len; i++){
            name = names[i];
            params[name.substr(1)] = vals[i + 1];
        }
        return params;
    };
    Way.prototype.rewrite_pattern = function(pattern, url) {
        var key, value, reg, params;
        params = this.extract_params(url);
        for(key in params){
            value = params[key];
            reg = new RegExp("[\:\*]+" + key, 'g');
            pattern = pattern.replace(reg, value);
        }
        return pattern;
    };
    Way.prototype.computed_dependency = function(url) {
        return this.rewrite_pattern(this.dependency, url);
    };
    Way.prototype.run = function(url, done) {
        var req = {
            url: url,
            pattern: this.pattern,
            params: this.extract_params(url)
        };
        this.runner(req, done);
        return req;
    };
    Way.prototype.destroy = function(req, done) {
        this.destroyer(req, done);
    };
    return Way;
}

});

parcelRegister("kikqP", function(module, exports) {
var $ec65566c3fb6cb5b$var$u = 'undefined', $ec65566c3fb6cb5b$var$o = 'object';


(function(klass) {
    $ec65566c3fb6cb5b$var$o === "object" ? module.exports = klass : $ec65566c3fb6cb5b$var$o === typeof Package && Package.meteor ? WaysFlow = klass : this.WaysFlow = klass;
})($ec65566c3fb6cb5b$var$_module($ec65566c3fb6cb5b$var$u !== typeof Happens ? Happens : (parcelRequire("jTtr8")), $ec65566c3fb6cb5b$var$u !== typeof WaysFluid ? WaysFluid : (parcelRequire("16oPE"))));
function $ec65566c3fb6cb5b$var$_module(Happens1, Fluid) {
    'use strict';
    function Flow(routes, mode) {
        Happens1(this);
        this.routes = routes;
        this.mode = mode;
        this.deads = [];
        this.actives = [];
        this.pendings = [];
        this.status = 'free';
    }
    Flow.prototype.run = function(url, route) {
        var flu, self = this;
        if (this.status == 'busy') this.actives.splice(-1, 1);
        this.emit('status:busy');
        this.deads = [];
        this.pendings = [];
        flu = new Fluid(route, url);
        this.filter_pendings(flu);
        this.filter_deads();
        this.status = 'busy';
        if (this.mode === 'run+destroy') this.run_pendings(function() {
            self.destroy_deads(function() {
                self.status = 'free';
                self.emit('status:free', self.mode);
            });
        });
        else if (this.mode === 'destroy+run') this.destroy_deads(function() {
            self.run_pendings(function() {
                self.status = 'free';
                self.emit('status:free', self.mode);
            });
        });
    };
    Flow.prototype.find_dependency = function(parent) {
        var route, flu;
        flu = find(this.actives, function(f) {
            return f.url === parent.dependency;
        });
        if (flu != null) return flu;
        route = find(this.routes, function(r) {
            return r.matcher.test(parent.route.dependency);
        });
        if (route != null) return new Fluid(route, parent.dependency);
        return null;
    };
    Flow.prototype.filter_pendings = function(parent) {
        var err, flu, route, dep;
        this.pendings.unshift(parent);
        if (parent.dependency == null) return;
        if ((flu = this.find_dependency(parent)) != null) return this.filter_pendings(flu);
        route = parent.route.pattern;
        dep = parent.dependency;
        err = "Dependency '" + dep + "' not found for route '" + route + "'";
        throw new Error(err);
    };
    Flow.prototype.filter_deads = function() {
        var flu, is_pending, i, len;
        for(i = 0, len = this.actives.length; i < len; i++){
            flu = this.actives[i];
            is_pending = find(this.pendings, function(f) {
                return f.url === flu.url;
            });
            if (!is_pending) this.deads.push(flu);
        }
    };
    Flow.prototype.run_pendings = function(done) {
        var flu, is_active, self = this;
        if (this.pendings.length === 0) return done();
        flu = this.pendings.shift();
        is_active = find(this.actives, function(f) {
            return f.url === flu.url;
        });
        if (is_active) return this.run_pendings(done);
        this.actives.push(flu);
        this.emit('run:pending', flu.url);
        flu.run(function() {
            self.run_pendings(done);
        });
    };
    Flow.prototype.destroy_deads = function(done) {
        var flu, self = this;
        if (this.deads.length === 0) return done();
        flu = this.deads.pop();
        this.actives = reject(this.actives, function(f) {
            return f.url === flu.url;
        });
        flu.destroy(function() {
            self.destroy_deads(done);
        });
    };
    function find(arr, filter) {
        for(var item, i = 0, len = arr.length; i < len; i++){
            if (filter(item = arr[i])) return item;
        }
    }
    function reject(arr, filter) {
        for(var item, copy = [], i = 0, len = arr.length; i < len; i++)if (!filter(item = arr[i])) copy.push(item);
        return copy;
    }
    return Flow;
}

});
parcelRegister("16oPE", function(module, exports) {
var $0cd99d220456a6bf$var$u = 'undefined', $0cd99d220456a6bf$var$o = 'object';
(function(klass) {
    $0cd99d220456a6bf$var$o === "object" ? module.exports = klass : $0cd99d220456a6bf$var$o === typeof Package && Package.meteor ? WaysFluid = klass : this.WaysFluid = klass;
})($0cd99d220456a6bf$var$_module());
function $0cd99d220456a6bf$var$_module() {
    'use strict';
    function Fluid(route, url) {
        this.route = route;
        this.url = url;
        if (route.dependency) this.dependency = route.computed_dependency(url);
    }
    Fluid.prototype.run = function(done) {
        this.req = this.route.run(this.url, done);
    };
    Fluid.prototype.destroy = function(done) {
        if (this.req) this.route.destroy(this.req, done);
    };
    return Fluid;
}

});


parcelRegister("1sNs2", function(module, exports) {
var $110ec3f099818749$var$u = 'undefined', $110ec3f099818749$var$o = 'object';



(function(klass) {
    $110ec3f099818749$var$o === "object" ? module.exports = klass : $110ec3f099818749$var$o === typeof Package && Package.meteor ? WaysAddressBar = klass : this.WaysAddressBar = klass;
})($110ec3f099818749$var$_module.apply(null, [
    $110ec3f099818749$var$u !== typeof Happens ? Happens : (parcelRequire("jTtr8")),
    $110ec3f099818749$var$u !== typeof WaysAddressBarHash ? WaysAddressBarHash : (parcelRequire("1Z5pr")),
    $110ec3f099818749$var$u !== typeof WaysAddressBarHistory ? WaysAddressBarHistory : (parcelRequire("5ihZR"))
]));
function $110ec3f099818749$var$_module(Happens1, Hash, History) {
    'use strict';
    function AddressBar() {
        Happens1(this);
        var self = this;
        var use_history_api = !!(window && window.history && window.history.pushState);
        this.api = new (use_history_api ? History : Hash);
        this.api.on('url:change', function(pathname) {
            self.emit('url:change', pathname);
        });
        this.history = this.api.history;
    }
    AddressBar.prototype.pathname = function() {
        return this.api.pathname();
    };
    AddressBar.prototype.push = function(url, title, state) {
        this.api.push(url, title, state);
    };
    AddressBar.prototype.replace = function(url, title, state) {
        this.api.replace(url, title, state);
    };
    return AddressBar;
}

});
parcelRegister("1Z5pr", function(module, exports) {
var $171faf270c841c8b$var$u = 'undefined', $171faf270c841c8b$var$o = 'object';

(function(klass) {
    $171faf270c841c8b$var$o === "object" ? module.exports = klass : $171faf270c841c8b$var$o === typeof Package && Package.meteor ? WaysAddressBarHash = klass : this.WaysAddressBarHash = klass;
})($171faf270c841c8b$var$_module.apply(null, [
    $171faf270c841c8b$var$u !== typeof Happens ? Happens : (parcelRequire("jTtr8"))
]));
function $171faf270c841c8b$var$_module(Happens1) {
    'use strict';
    function Hash() {
        Happens1(this);
        this.history = [];
        this.history.state = null;
        var self = this;
        var hash = window.location.hash;
        var pathname = window.location.pathname;
        if (hash === '') {
            if (pathname.length > 1) window.location.href = '/#' + pathname;
            else window.location.href = '#/';
        }
        window.attachEvent('onhashchange', function() {
            self.emit('url:change', self.pathname());
        }, false);
    }
    Hash.prototype.pathname = function() {
        return window.location.hash;
    };
    Hash.prototype.push = function(url, title, state) {
        this.history.push(this.history.state = state);
        window.location.hash = url;
        if (title) document.title = title;
        this.emit('url:change', this.pathname());
    };
    Hash.prototype.replace = function(url, title, state) {
        this.history[this.history.length - 1] = this.history.state = state;
        if (title) document.title = title;
        window.location.hash.replace(url);
    };
    return Hash;
}

});

parcelRegister("5ihZR", function(module, exports) {
var $3dac97fc5d241490$var$u = 'undefined', $3dac97fc5d241490$var$o = 'object';

(function(klass) {
    $3dac97fc5d241490$var$o === "object" ? module.exports = klass : $3dac97fc5d241490$var$o === typeof Package && Package.meteor ? WaysAddressBarHistory = klass : this.WaysAddressBarHistory = klass;
})($3dac97fc5d241490$var$_module.apply(null, [
    $3dac97fc5d241490$var$u !== typeof Happens ? Happens : (parcelRequire("jTtr8"))
]));
function $3dac97fc5d241490$var$_module(Happens1) {
    'use strict';
    function History() {
        Happens1(this);
        this.history = window.history;
        var self = this;
        var popped = false;
        var initial = this.pathname();
        var hash = window.location.hash || null;
        if (hash && hash.length) this.replace(window.location.hash.substr(1));
        window.addEventListener('popstate', function() {
            // skips first pop if present
            if (initial == self.pathname() && !popped) return popped = true;
            self.emit('url:change', self.pathname());
        }, false);
    }
    History.prototype.pathname = function() {
        return window.location.pathname;
    };
    History.prototype.push = function(url, title, state) {
        window.history.pushState(state, title, url);
        if (title) document.title = title;
        this.emit('url:change', window.location.pathname);
    };
    History.prototype.replace = function(url, title, state) {
        window.history.replaceState(state, title, url);
        if (title) document.title = title;
    };
    return History;
}

});


parcelRegister("f1z04", function(module, exports) {

$parcel$export(module.exports, "_config", () => _config);
$parcel$export(module.exports, "_isString", () => _isString);
$parcel$export(module.exports, "_isUndefined", () => _isUndefined);
$parcel$export(module.exports, "_numExp", () => _numExp);
$parcel$export(module.exports, "_numWithUnitExp", () => _numWithUnitExp);
$parcel$export(module.exports, "_relExp", () => _relExp);
$parcel$export(module.exports, "gsap", () => gsap);
$parcel$export(module.exports, "_missingPlugin", () => _missingPlugin);
$parcel$export(module.exports, "_plugins", () => _plugins);
$parcel$export(module.exports, "GSCache", () => GSCache);
$parcel$export(module.exports, "_getCache", () => _getCache);
$parcel$export(module.exports, "toArray", () => toArray);
$parcel$export(module.exports, "_getProperty", () => _getProperty);
$parcel$export(module.exports, "_forEachName", () => _forEachName);
$parcel$export(module.exports, "_round", () => _round);
$parcel$export(module.exports, "_parseRelative", () => _parseRelative);
$parcel$export(module.exports, "_setDefaults", () => _setDefaults);
$parcel$export(module.exports, "_removeLinkedListItem", () => _removeLinkedListItem);
$parcel$export(module.exports, "_ticker", () => _ticker);
$parcel$export(module.exports, "Timeline", () => Timeline);
$parcel$export(module.exports, "Tween", () => Tween);
$parcel$export(module.exports, "getUnit", () => getUnit);
$parcel$export(module.exports, "clamp", () => clamp);
$parcel$export(module.exports, "selector", () => selector);
$parcel$export(module.exports, "shuffle", () => shuffle);
$parcel$export(module.exports, "distribute", () => distribute);
$parcel$export(module.exports, "_roundModifier", () => _roundModifier);
$parcel$export(module.exports, "snap", () => snap);
$parcel$export(module.exports, "random", () => random);
$parcel$export(module.exports, "pipe", () => pipe);
$parcel$export(module.exports, "unitize", () => unitize);
$parcel$export(module.exports, "normalize", () => normalize);
$parcel$export(module.exports, "mapRange", () => mapRange);
$parcel$export(module.exports, "wrap", () => wrap);
$parcel$export(module.exports, "wrapYoyo", () => wrapYoyo);
$parcel$export(module.exports, "_replaceRandom", () => _replaceRandom);
$parcel$export(module.exports, "interpolate", () => interpolate);
$parcel$export(module.exports, "_getSetter", () => _getSetter);
$parcel$export(module.exports, "PropTween", () => PropTween);
$parcel$export(module.exports, "splitColor", () => splitColor);
$parcel$export(module.exports, "_colorExp", () => _colorExp);
$parcel$export(module.exports, "_colorStringFilter", () => _colorStringFilter);
$parcel$export(module.exports, "Animation", () => Animation);
$parcel$export(module.exports, "_renderComplexString", () => _renderComplexString);
$parcel$export(module.exports, "_checkPlugin", () => _checkPlugin);
$parcel$export(module.exports, "_sortPropTweensByPriority", () => _sortPropTweensByPriority);
$parcel$export(module.exports, "Power0", () => Power0);
$parcel$export(module.exports, "Power1", () => Power1);
$parcel$export(module.exports, "Power2", () => Power2);
$parcel$export(module.exports, "Power3", () => Power3);
$parcel$export(module.exports, "Power4", () => Power4);
$parcel$export(module.exports, "Linear", () => Linear);
$parcel$export(module.exports, "Quad", () => Quad);
$parcel$export(module.exports, "Cubic", () => Cubic);
$parcel$export(module.exports, "Quart", () => Quart);
$parcel$export(module.exports, "Quint", () => Quint);
$parcel$export(module.exports, "Strong", () => Strong);
$parcel$export(module.exports, "Elastic", () => Elastic);
$parcel$export(module.exports, "Back", () => Back);
$parcel$export(module.exports, "SteppedEase", () => SteppedEase);
$parcel$export(module.exports, "Bounce", () => Bounce);
$parcel$export(module.exports, "Sine", () => Sine);
$parcel$export(module.exports, "Expo", () => Expo);
$parcel$export(module.exports, "Circ", () => Circ);
$parcel$export(module.exports, "TweenMax", () => Tween);
$parcel$export(module.exports, "TweenLite", () => Tween);
$parcel$export(module.exports, "TimelineMax", () => Timeline);
$parcel$export(module.exports, "TimelineLite", () => Timeline);
$parcel$export(module.exports, "default", () => gsap);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.13.0";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("52JaZ", function(module, exports) {

var $jqQ9y = parcelRequire("jqQ9y");

var $jczub = parcelRequire("jczub");

var $2xuQP = parcelRequire("2xuQP");
function $3ac02eba4d4c2533$var$createRandom(defaultSeed) {
    defaultSeed = $2xuQP(defaultSeed, null);
    var defaultRandom = Math.random;
    var currentSeed;
    var currentRandom;
    var noiseGenerator;
    var _nextGaussian = null;
    var _hasNextGaussian = false;
    setSeed(defaultSeed);
    return {
        value: value,
        createRandom: function(defaultSeed) {
            return $3ac02eba4d4c2533$var$createRandom(defaultSeed);
        },
        setSeed: setSeed,
        getSeed: getSeed,
        getRandomSeed: getRandomSeed,
        valueNonZero: valueNonZero,
        permuteNoise: permuteNoise,
        noise1D: noise1D,
        noise2D: noise2D,
        noise3D: noise3D,
        noise4D: noise4D,
        sign: sign,
        boolean: boolean,
        chance: chance,
        range: range,
        rangeFloor: rangeFloor,
        pick: pick,
        shuffle: shuffle,
        onCircle: onCircle,
        insideCircle: insideCircle,
        onSphere: onSphere,
        insideSphere: insideSphere,
        quaternion: quaternion,
        weighted: weighted,
        weightedSet: weightedSet,
        weightedSetIndex: weightedSetIndex,
        gaussian: gaussian
    };
    function setSeed(seed, opt) {
        if (typeof seed === 'number' || typeof seed === 'string') {
            currentSeed = seed;
            currentRandom = $jqQ9y(currentSeed, opt);
        } else {
            currentSeed = undefined;
            currentRandom = defaultRandom;
        }
        noiseGenerator = createNoise();
        _nextGaussian = null;
        _hasNextGaussian = false;
    }
    function value() {
        return currentRandom();
    }
    function valueNonZero() {
        var u = 0;
        while(u === 0)u = value();
        return u;
    }
    function getSeed() {
        return currentSeed;
    }
    function getRandomSeed() {
        var seed = String(Math.floor(Math.random() * 1000000));
        return seed;
    }
    function createNoise() {
        return new $jczub(currentRandom);
    }
    function permuteNoise() {
        noiseGenerator = createNoise();
    }
    function noise1D(x, frequency, amplitude) {
        if (!isFinite(x)) throw new TypeError('x component for noise() must be finite');
        frequency = $2xuQP(frequency, 1);
        amplitude = $2xuQP(amplitude, 1);
        return amplitude * noiseGenerator.noise2D(x * frequency, 0);
    }
    function noise2D(x, y, frequency, amplitude) {
        if (!isFinite(x)) throw new TypeError('x component for noise() must be finite');
        if (!isFinite(y)) throw new TypeError('y component for noise() must be finite');
        frequency = $2xuQP(frequency, 1);
        amplitude = $2xuQP(amplitude, 1);
        return amplitude * noiseGenerator.noise2D(x * frequency, y * frequency);
    }
    function noise3D(x, y, z, frequency, amplitude) {
        if (!isFinite(x)) throw new TypeError('x component for noise() must be finite');
        if (!isFinite(y)) throw new TypeError('y component for noise() must be finite');
        if (!isFinite(z)) throw new TypeError('z component for noise() must be finite');
        frequency = $2xuQP(frequency, 1);
        amplitude = $2xuQP(amplitude, 1);
        return amplitude * noiseGenerator.noise3D(x * frequency, y * frequency, z * frequency);
    }
    function noise4D(x, y, z, w, frequency, amplitude) {
        if (!isFinite(x)) throw new TypeError('x component for noise() must be finite');
        if (!isFinite(y)) throw new TypeError('y component for noise() must be finite');
        if (!isFinite(z)) throw new TypeError('z component for noise() must be finite');
        if (!isFinite(w)) throw new TypeError('w component for noise() must be finite');
        frequency = $2xuQP(frequency, 1);
        amplitude = $2xuQP(amplitude, 1);
        return amplitude * noiseGenerator.noise4D(x * frequency, y * frequency, z * frequency, w * frequency);
    }
    function sign() {
        return boolean() ? 1 : -1;
    }
    function boolean() {
        return value() > 0.5;
    }
    function chance(n) {
        n = $2xuQP(n, 0.5);
        if (typeof n !== 'number') throw new TypeError('expected n to be a number');
        return value() < n;
    }
    function range(min, max) {
        if (max === undefined) {
            max = min;
            min = 0;
        }
        if (typeof min !== 'number' || typeof max !== 'number') throw new TypeError('Expected all arguments to be numbers');
        return value() * (max - min) + min;
    }
    function rangeFloor(min, max) {
        if (max === undefined) {
            max = min;
            min = 0;
        }
        if (typeof min !== 'number' || typeof max !== 'number') throw new TypeError('Expected all arguments to be numbers');
        return Math.floor(range(min, max));
    }
    function pick(array) {
        if (array.length === 0) return undefined;
        return array[rangeFloor(0, array.length)];
    }
    function shuffle(arr) {
        if (!Array.isArray(arr)) throw new TypeError('Expected Array, got ' + typeof arr);
        var rand;
        var tmp;
        var len = arr.length;
        var ret = arr.slice();
        while(len){
            rand = Math.floor(value() * len--);
            tmp = ret[len];
            ret[len] = ret[rand];
            ret[rand] = tmp;
        }
        return ret;
    }
    function onCircle(radius, out) {
        radius = $2xuQP(radius, 1);
        out = out || [];
        var theta = value() * 2.0 * Math.PI;
        out[0] = radius * Math.cos(theta);
        out[1] = radius * Math.sin(theta);
        return out;
    }
    function insideCircle(radius, out) {
        radius = $2xuQP(radius, 1);
        out = out || [];
        onCircle(1, out);
        var r = radius * Math.sqrt(value());
        out[0] *= r;
        out[1] *= r;
        return out;
    }
    function onSphere(radius, out) {
        radius = $2xuQP(radius, 1);
        out = out || [];
        var u = value() * Math.PI * 2;
        var v = value() * 2 - 1;
        var phi = u;
        var theta = Math.acos(v);
        out[0] = radius * Math.sin(theta) * Math.cos(phi);
        out[1] = radius * Math.sin(theta) * Math.sin(phi);
        out[2] = radius * Math.cos(theta);
        return out;
    }
    function insideSphere(radius, out) {
        radius = $2xuQP(radius, 1);
        out = out || [];
        var u = value() * Math.PI * 2;
        var v = value() * 2 - 1;
        var k = value();
        var phi = u;
        var theta = Math.acos(v);
        var r = radius * Math.cbrt(k);
        out[0] = r * Math.sin(theta) * Math.cos(phi);
        out[1] = r * Math.sin(theta) * Math.sin(phi);
        out[2] = r * Math.cos(theta);
        return out;
    }
    function quaternion(out) {
        out = out || [];
        var u1 = value();
        var u2 = value();
        var u3 = value();
        var sq1 = Math.sqrt(1 - u1);
        var sq2 = Math.sqrt(u1);
        var theta1 = Math.PI * 2 * u2;
        var theta2 = Math.PI * 2 * u3;
        var x = Math.sin(theta1) * sq1;
        var y = Math.cos(theta1) * sq1;
        var z = Math.sin(theta2) * sq2;
        var w = Math.cos(theta2) * sq2;
        out[0] = x;
        out[1] = y;
        out[2] = z;
        out[3] = w;
        return out;
    }
    function weightedSet(set) {
        set = set || [];
        if (set.length === 0) return null;
        return set[weightedSetIndex(set)].value;
    }
    function weightedSetIndex(set) {
        set = set || [];
        if (set.length === 0) return -1;
        return weighted(set.map(function(s) {
            return s.weight;
        }));
    }
    function weighted(weights) {
        weights = weights || [];
        if (weights.length === 0) return -1;
        var totalWeight = 0;
        var i;
        for(i = 0; i < weights.length; i++)totalWeight += weights[i];
        if (totalWeight <= 0) throw new Error('Weights must sum to > 0');
        var random = value() * totalWeight;
        for(i = 0; i < weights.length; i++){
            if (random < weights[i]) return i;
            random -= weights[i];
        }
        return 0;
    }
    function gaussian(mean, standardDerivation) {
        mean = $2xuQP(mean, 0);
        standardDerivation = $2xuQP(standardDerivation, 1);
        // https://github.com/openjdk-mirror/jdk7u-jdk/blob/f4d80957e89a19a29bb9f9807d2a28351ed7f7df/src/share/classes/java/util/Random.java#L496
        if (_hasNextGaussian) {
            _hasNextGaussian = false;
            var result = _nextGaussian;
            _nextGaussian = null;
            return mean + standardDerivation * result;
        } else {
            var v1 = 0;
            var v2 = 0;
            var s = 0;
            do {
                v1 = value() * 2 - 1; // between -1 and 1
                v2 = value() * 2 - 1; // between -1 and 1
                s = v1 * v1 + v2 * v2;
            }while (s >= 1 || s === 0);
            var multiplier = Math.sqrt(-2 * Math.log(s) / s);
            _nextGaussian = v2 * multiplier;
            _hasNextGaussian = true;
            return mean + standardDerivation * (v1 * multiplier);
        }
    }
}
module.exports = $3ac02eba4d4c2533$var$createRandom();

});
parcelRegister("jqQ9y", function(module, exports) {
'use strict';
var $e258e68a5d2a4e4d$var$width = 256; // each RC4 output is 0 <= x < 256
var $e258e68a5d2a4e4d$var$chunks = 6; // at least six RC4 outputs for each double
var $e258e68a5d2a4e4d$var$digits = 52; // there are 52 significant digits in a double
var $e258e68a5d2a4e4d$var$pool = []; // pool: entropy pool starts empty
var $e258e68a5d2a4e4d$var$GLOBAL = typeof $parcel$global === 'undefined' ? window : $parcel$global;
//
// The following constants are related to IEEE 754 limits.
//
var $e258e68a5d2a4e4d$var$startdenom = Math.pow($e258e68a5d2a4e4d$var$width, $e258e68a5d2a4e4d$var$chunks), $e258e68a5d2a4e4d$var$significance = Math.pow(2, $e258e68a5d2a4e4d$var$digits), $e258e68a5d2a4e4d$var$overflow = $e258e68a5d2a4e4d$var$significance * 2, $e258e68a5d2a4e4d$var$mask = $e258e68a5d2a4e4d$var$width - 1;
var $e258e68a5d2a4e4d$var$oldRandom = Math.random;
//
// seedrandom()
// This is the seedrandom function described above.
//
module.exports = function(seed, options) {
    if (options && options.global === true) {
        options.global = false;
        Math.random = module.exports(seed, options);
        options.global = true;
        return Math.random;
    }
    var use_entropy = options && options.entropy || false;
    var key = [];
    // Flatten the seed string or build one from local entropy if needed.
    var shortseed = $e258e68a5d2a4e4d$var$mixkey($e258e68a5d2a4e4d$var$flatten(use_entropy ? [
        seed,
        $e258e68a5d2a4e4d$var$tostring($e258e68a5d2a4e4d$var$pool)
    ] : 0 in arguments ? seed : $e258e68a5d2a4e4d$var$autoseed(), 3), key);
    // Use the seed to initialize an ARC4 generator.
    var arc4 = new $e258e68a5d2a4e4d$var$ARC4(key);
    // Mix the randomness into accumulated entropy.
    $e258e68a5d2a4e4d$var$mixkey($e258e68a5d2a4e4d$var$tostring(arc4.S), $e258e68a5d2a4e4d$var$pool);
    // Override Math.random
    // This function returns a random double in [0, 1) that contains
    // randomness in every bit of the mantissa of the IEEE 754 value.
    return function() {
        var n = arc4.g($e258e68a5d2a4e4d$var$chunks), d = $e258e68a5d2a4e4d$var$startdenom, x = 0; //   and no 'extra last byte'.
        while(n < $e258e68a5d2a4e4d$var$significance){
            n = (n + x) * $e258e68a5d2a4e4d$var$width; //   shifting numerator and
            d *= $e258e68a5d2a4e4d$var$width; //   denominator and generating a
            x = arc4.g(1); //   new least-significant-byte.
        }
        while(n >= $e258e68a5d2a4e4d$var$overflow){
            n /= 2; //   last byte, shift everything
            d /= 2; //   right using integer Math until
            x >>>= 1; //   we have exactly the desired bits.
        }
        return (n + x) / d; // Form the number within [0, 1).
    };
};
module.exports.resetGlobal = function() {
    Math.random = $e258e68a5d2a4e4d$var$oldRandom;
};
//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
/** @constructor */ function $e258e68a5d2a4e4d$var$ARC4(key) {
    var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
    // The empty key [] is treated as [0].
    if (!keylen) key = [
        keylen++
    ];
    // Set up S using the standard key scheduling algorithm.
    while(i < $e258e68a5d2a4e4d$var$width)s[i] = i++;
    for(i = 0; i < $e258e68a5d2a4e4d$var$width; i++){
        s[i] = s[j = $e258e68a5d2a4e4d$var$mask & j + key[i % keylen] + (t = s[i])];
        s[j] = t;
    }
    // The "g" method returns the next (count) outputs as one number.
    (me.g = function(count) {
        // Using instance members instead of closure state nearly doubles speed.
        var t, r = 0, i = me.i, j = me.j, s = me.S;
        while(count--){
            t = s[i = $e258e68a5d2a4e4d$var$mask & i + 1];
            r = r * $e258e68a5d2a4e4d$var$width + s[$e258e68a5d2a4e4d$var$mask & (s[i] = s[j = $e258e68a5d2a4e4d$var$mask & j + t]) + (s[j] = t)];
        }
        me.i = i;
        me.j = j;
        return r;
    // For robust unpredictability discard an initial batch of values.
    // See http://www.rsa.com/rsalabs/node.asp?id=2009
    })($e258e68a5d2a4e4d$var$width);
}
//
// flatten()
// Converts an object tree to nested arrays of strings.
//
function $e258e68a5d2a4e4d$var$flatten(obj, depth) {
    var result = [], typ = (typeof obj)[0], prop;
    if (depth && typ == 'o') {
        for(prop in obj)try {
            result.push($e258e68a5d2a4e4d$var$flatten(obj[prop], depth - 1));
        } catch (e) {}
    }
    return result.length ? result : typ == 's' ? obj : obj + '\0';
}
//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
function $e258e68a5d2a4e4d$var$mixkey(seed, key) {
    var stringseed = seed + '', smear, j = 0;
    while(j < stringseed.length)key[$e258e68a5d2a4e4d$var$mask & j] = $e258e68a5d2a4e4d$var$mask & (smear ^= key[$e258e68a5d2a4e4d$var$mask & j] * 19) + stringseed.charCodeAt(j++);
    return $e258e68a5d2a4e4d$var$tostring(key);
}
//
// autoseed()
// Returns an object for autoseeding, using window.crypto if available.
//
/** @param {Uint8Array=} seed */ function $e258e68a5d2a4e4d$var$autoseed(seed) {
    try {
        $e258e68a5d2a4e4d$var$GLOBAL.crypto.getRandomValues(seed = new Uint8Array($e258e68a5d2a4e4d$var$width));
        return $e258e68a5d2a4e4d$var$tostring(seed);
    } catch (e) {
        return [
            +new Date,
            $e258e68a5d2a4e4d$var$GLOBAL,
            $e258e68a5d2a4e4d$var$GLOBAL.navigator && $e258e68a5d2a4e4d$var$GLOBAL.navigator.plugins,
            $e258e68a5d2a4e4d$var$GLOBAL.screen,
            $e258e68a5d2a4e4d$var$tostring($e258e68a5d2a4e4d$var$pool)
        ];
    }
}
//
// tostring()
// Converts an array of charcodes to a string
//
function $e258e68a5d2a4e4d$var$tostring(a) {
    return String.fromCharCode.apply(0, a);
}
//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to intefere with determinstic PRNG state later,
// seedrandom will not call Math.random on its own again after
// initialization.
//
$e258e68a5d2a4e4d$var$mixkey(Math.random(), $e258e68a5d2a4e4d$var$pool);

});

parcelRegister("jczub", function(module, exports) {
/*
 * A fast javascript implementation of simplex noise by Jonas Wagner

Based on a speed-improved simplex noise algorithm for 2D, 3D and 4D in Java.
Which is based on example code by Stefan Gustavson (stegu@itn.liu.se).
With Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
Better rank ordering method by Stefan Gustavson in 2012.


 Copyright (c) 2018 Jonas Wagner

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */ (function() {
    'use strict';
    var F2 = 0.5 * (Math.sqrt(3.0) - 1.0);
    var G2 = (3.0 - Math.sqrt(3.0)) / 6.0;
    var F3 = 1.0 / 3.0;
    var G3 = 1.0 / 6.0;
    var F4 = (Math.sqrt(5.0) - 1.0) / 4.0;
    var G4 = (5.0 - Math.sqrt(5.0)) / 20.0;
    function SimplexNoise(randomOrSeed) {
        var random;
        if (typeof randomOrSeed == 'function') random = randomOrSeed;
        else if (randomOrSeed) random = alea(randomOrSeed);
        else random = Math.random;
        this.p = buildPermutationTable(random);
        this.perm = new Uint8Array(512);
        this.permMod12 = new Uint8Array(512);
        for(var i = 0; i < 512; i++){
            this.perm[i] = this.p[i & 255];
            this.permMod12[i] = this.perm[i] % 12;
        }
    }
    SimplexNoise.prototype = {
        grad3: new Float32Array([
            1,
            1,
            0,
            -1,
            1,
            0,
            1,
            -1,
            0,
            -1,
            -1,
            0,
            1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            1,
            -1,
            0,
            -1,
            -1
        ]),
        grad4: new Float32Array([
            0,
            1,
            1,
            1,
            0,
            1,
            1,
            -1,
            0,
            1,
            -1,
            1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            0,
            -1,
            -1,
            -1,
            1,
            0,
            1,
            1,
            1,
            0,
            1,
            -1,
            1,
            0,
            -1,
            1,
            1,
            0,
            -1,
            -1,
            -1,
            0,
            1,
            1,
            -1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            1,
            0,
            1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            0,
            1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            0,
            1,
            -1,
            1,
            0,
            -1,
            -1,
            -1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            1,
            1,
            0,
            1,
            1,
            -1,
            0,
            1,
            -1,
            1,
            0,
            1,
            -1,
            -1,
            0,
            -1,
            1,
            1,
            0,
            -1,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            0,
            -1,
            -1,
            -1,
            0
        ]),
        noise2D: function(xin, yin) {
            var permMod12 = this.permMod12;
            var perm = this.perm;
            var grad3 = this.grad3;
            var n0 = 0; // Noise contributions from the three corners
            var n1 = 0;
            var n2 = 0;
            // Skew the input space to determine which simplex cell we're in
            var s = (xin + yin) * F2; // Hairy factor for 2D
            var i = Math.floor(xin + s);
            var j = Math.floor(yin + s);
            var t = (i + j) * G2;
            var X0 = i - t; // Unskew the cell origin back to (x,y) space
            var Y0 = j - t;
            var x0 = xin - X0; // The x,y distances from the cell origin
            var y0 = yin - Y0;
            // For the 2D case, the simplex shape is an equilateral triangle.
            // Determine which simplex we are in.
            var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
            if (x0 > y0) {
                i1 = 1;
                j1 = 0;
            } else {
                i1 = 0;
                j1 = 1;
            } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
            // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
            // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
            // c = (3-sqrt(3))/6
            var x1 = x0 - i1 + G2; // Offsets for middle corner in (x,y) unskewed coords
            var y1 = y0 - j1 + G2;
            var x2 = x0 - 1.0 + 2.0 * G2; // Offsets for last corner in (x,y) unskewed coords
            var y2 = y0 - 1.0 + 2.0 * G2;
            // Work out the hashed gradient indices of the three simplex corners
            var ii = i & 255;
            var jj = j & 255;
            // Calculate the contribution from the three corners
            var t0 = 0.5 - x0 * x0 - y0 * y0;
            if (t0 >= 0) {
                var gi0 = permMod12[ii + perm[jj]] * 3;
                t0 *= t0;
                n0 = t0 * t0 * (grad3[gi0] * x0 + grad3[gi0 + 1] * y0); // (x,y) of grad3 used for 2D gradient
            }
            var t1 = 0.5 - x1 * x1 - y1 * y1;
            if (t1 >= 0) {
                var gi1 = permMod12[ii + i1 + perm[jj + j1]] * 3;
                t1 *= t1;
                n1 = t1 * t1 * (grad3[gi1] * x1 + grad3[gi1 + 1] * y1);
            }
            var t2 = 0.5 - x2 * x2 - y2 * y2;
            if (t2 >= 0) {
                var gi2 = permMod12[ii + 1 + perm[jj + 1]] * 3;
                t2 *= t2;
                n2 = t2 * t2 * (grad3[gi2] * x2 + grad3[gi2 + 1] * y2);
            }
            // Add contributions from each corner to get the final noise value.
            // The result is scaled to return values in the interval [-1,1].
            return 70.0 * (n0 + n1 + n2);
        },
        // 3D simplex noise
        noise3D: function(xin, yin, zin) {
            var permMod12 = this.permMod12;
            var perm = this.perm;
            var grad3 = this.grad3;
            var n0, n1, n2, n3; // Noise contributions from the four corners
            // Skew the input space to determine which simplex cell we're in
            var s = (xin + yin + zin) * F3; // Very nice and simple skew factor for 3D
            var i = Math.floor(xin + s);
            var j = Math.floor(yin + s);
            var k = Math.floor(zin + s);
            var t = (i + j + k) * G3;
            var X0 = i - t; // Unskew the cell origin back to (x,y,z) space
            var Y0 = j - t;
            var Z0 = k - t;
            var x0 = xin - X0; // The x,y,z distances from the cell origin
            var y0 = yin - Y0;
            var z0 = zin - Z0;
            // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
            // Determine which simplex we are in.
            var i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
            var i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
            if (x0 >= y0) {
                if (y0 >= z0) {
                    i1 = 1;
                    j1 = 0;
                    k1 = 0;
                    i2 = 1;
                    j2 = 1;
                    k2 = 0;
                } else if (x0 >= z0) {
                    i1 = 1;
                    j1 = 0;
                    k1 = 0;
                    i2 = 1;
                    j2 = 0;
                    k2 = 1;
                } else {
                    i1 = 0;
                    j1 = 0;
                    k1 = 1;
                    i2 = 1;
                    j2 = 0;
                    k2 = 1;
                } // Z X Y order
            } else {
                if (y0 < z0) {
                    i1 = 0;
                    j1 = 0;
                    k1 = 1;
                    i2 = 0;
                    j2 = 1;
                    k2 = 1;
                } else if (x0 < z0) {
                    i1 = 0;
                    j1 = 1;
                    k1 = 0;
                    i2 = 0;
                    j2 = 1;
                    k2 = 1;
                } else {
                    i1 = 0;
                    j1 = 1;
                    k1 = 0;
                    i2 = 1;
                    j2 = 1;
                    k2 = 0;
                } // Y X Z order
            }
            // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
            // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
            // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
            // c = 1/6.
            var x1 = x0 - i1 + G3; // Offsets for second corner in (x,y,z) coords
            var y1 = y0 - j1 + G3;
            var z1 = z0 - k1 + G3;
            var x2 = x0 - i2 + 2.0 * G3; // Offsets for third corner in (x,y,z) coords
            var y2 = y0 - j2 + 2.0 * G3;
            var z2 = z0 - k2 + 2.0 * G3;
            var x3 = x0 - 1.0 + 3.0 * G3; // Offsets for last corner in (x,y,z) coords
            var y3 = y0 - 1.0 + 3.0 * G3;
            var z3 = z0 - 1.0 + 3.0 * G3;
            // Work out the hashed gradient indices of the four simplex corners
            var ii = i & 255;
            var jj = j & 255;
            var kk = k & 255;
            // Calculate the contribution from the four corners
            var t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
            if (t0 < 0) n0 = 0.0;
            else {
                var gi0 = permMod12[ii + perm[jj + perm[kk]]] * 3;
                t0 *= t0;
                n0 = t0 * t0 * (grad3[gi0] * x0 + grad3[gi0 + 1] * y0 + grad3[gi0 + 2] * z0);
            }
            var t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
            if (t1 < 0) n1 = 0.0;
            else {
                var gi1 = permMod12[ii + i1 + perm[jj + j1 + perm[kk + k1]]] * 3;
                t1 *= t1;
                n1 = t1 * t1 * (grad3[gi1] * x1 + grad3[gi1 + 1] * y1 + grad3[gi1 + 2] * z1);
            }
            var t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
            if (t2 < 0) n2 = 0.0;
            else {
                var gi2 = permMod12[ii + i2 + perm[jj + j2 + perm[kk + k2]]] * 3;
                t2 *= t2;
                n2 = t2 * t2 * (grad3[gi2] * x2 + grad3[gi2 + 1] * y2 + grad3[gi2 + 2] * z2);
            }
            var t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
            if (t3 < 0) n3 = 0.0;
            else {
                var gi3 = permMod12[ii + 1 + perm[jj + 1 + perm[kk + 1]]] * 3;
                t3 *= t3;
                n3 = t3 * t3 * (grad3[gi3] * x3 + grad3[gi3 + 1] * y3 + grad3[gi3 + 2] * z3);
            }
            // Add contributions from each corner to get the final noise value.
            // The result is scaled to stay just inside [-1,1]
            return 32.0 * (n0 + n1 + n2 + n3);
        },
        // 4D simplex noise, better simplex rank ordering method 2012-03-09
        noise4D: function(x, y, z, w) {
            var perm = this.perm;
            var grad4 = this.grad4;
            var n0, n1, n2, n3, n4; // Noise contributions from the five corners
            // Skew the (x,y,z,w) space to determine which cell of 24 simplices we're in
            var s = (x + y + z + w) * F4; // Factor for 4D skewing
            var i = Math.floor(x + s);
            var j = Math.floor(y + s);
            var k = Math.floor(z + s);
            var l = Math.floor(w + s);
            var t = (i + j + k + l) * G4; // Factor for 4D unskewing
            var X0 = i - t; // Unskew the cell origin back to (x,y,z,w) space
            var Y0 = j - t;
            var Z0 = k - t;
            var W0 = l - t;
            var x0 = x - X0; // The x,y,z,w distances from the cell origin
            var y0 = y - Y0;
            var z0 = z - Z0;
            var w0 = w - W0;
            // For the 4D case, the simplex is a 4D shape I won't even try to describe.
            // To find out which of the 24 possible simplices we're in, we need to
            // determine the magnitude ordering of x0, y0, z0 and w0.
            // Six pair-wise comparisons are performed between each possible pair
            // of the four coordinates, and the results are used to rank the numbers.
            var rankx = 0;
            var ranky = 0;
            var rankz = 0;
            var rankw = 0;
            if (x0 > y0) rankx++;
            else ranky++;
            if (x0 > z0) rankx++;
            else rankz++;
            if (x0 > w0) rankx++;
            else rankw++;
            if (y0 > z0) ranky++;
            else rankz++;
            if (y0 > w0) ranky++;
            else rankw++;
            if (z0 > w0) rankz++;
            else rankw++;
            var i1, j1, k1, l1; // The integer offsets for the second simplex corner
            var i2, j2, k2, l2; // The integer offsets for the third simplex corner
            var i3, j3, k3, l3; // The integer offsets for the fourth simplex corner
            // simplex[c] is a 4-vector with the numbers 0, 1, 2 and 3 in some order.
            // Many values of c will never occur, since e.g. x>y>z>w makes x<z, y<w and x<w
            // impossible. Only the 24 indices which have non-zero entries make any sense.
            // We use a thresholding to set the coordinates in turn from the largest magnitude.
            // Rank 3 denotes the largest coordinate.
            i1 = rankx >= 3 ? 1 : 0;
            j1 = ranky >= 3 ? 1 : 0;
            k1 = rankz >= 3 ? 1 : 0;
            l1 = rankw >= 3 ? 1 : 0;
            // Rank 2 denotes the second largest coordinate.
            i2 = rankx >= 2 ? 1 : 0;
            j2 = ranky >= 2 ? 1 : 0;
            k2 = rankz >= 2 ? 1 : 0;
            l2 = rankw >= 2 ? 1 : 0;
            // Rank 1 denotes the second smallest coordinate.
            i3 = rankx >= 1 ? 1 : 0;
            j3 = ranky >= 1 ? 1 : 0;
            k3 = rankz >= 1 ? 1 : 0;
            l3 = rankw >= 1 ? 1 : 0;
            // The fifth corner has all coordinate offsets = 1, so no need to compute that.
            var x1 = x0 - i1 + G4; // Offsets for second corner in (x,y,z,w) coords
            var y1 = y0 - j1 + G4;
            var z1 = z0 - k1 + G4;
            var w1 = w0 - l1 + G4;
            var x2 = x0 - i2 + 2.0 * G4; // Offsets for third corner in (x,y,z,w) coords
            var y2 = y0 - j2 + 2.0 * G4;
            var z2 = z0 - k2 + 2.0 * G4;
            var w2 = w0 - l2 + 2.0 * G4;
            var x3 = x0 - i3 + 3.0 * G4; // Offsets for fourth corner in (x,y,z,w) coords
            var y3 = y0 - j3 + 3.0 * G4;
            var z3 = z0 - k3 + 3.0 * G4;
            var w3 = w0 - l3 + 3.0 * G4;
            var x4 = x0 - 1.0 + 4.0 * G4; // Offsets for last corner in (x,y,z,w) coords
            var y4 = y0 - 1.0 + 4.0 * G4;
            var z4 = z0 - 1.0 + 4.0 * G4;
            var w4 = w0 - 1.0 + 4.0 * G4;
            // Work out the hashed gradient indices of the five simplex corners
            var ii = i & 255;
            var jj = j & 255;
            var kk = k & 255;
            var ll = l & 255;
            // Calculate the contribution from the five corners
            var t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
            if (t0 < 0) n0 = 0.0;
            else {
                var gi0 = perm[ii + perm[jj + perm[kk + perm[ll]]]] % 32 * 4;
                t0 *= t0;
                n0 = t0 * t0 * (grad4[gi0] * x0 + grad4[gi0 + 1] * y0 + grad4[gi0 + 2] * z0 + grad4[gi0 + 3] * w0);
            }
            var t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
            if (t1 < 0) n1 = 0.0;
            else {
                var gi1 = perm[ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]]] % 32 * 4;
                t1 *= t1;
                n1 = t1 * t1 * (grad4[gi1] * x1 + grad4[gi1 + 1] * y1 + grad4[gi1 + 2] * z1 + grad4[gi1 + 3] * w1);
            }
            var t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
            if (t2 < 0) n2 = 0.0;
            else {
                var gi2 = perm[ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]]] % 32 * 4;
                t2 *= t2;
                n2 = t2 * t2 * (grad4[gi2] * x2 + grad4[gi2 + 1] * y2 + grad4[gi2 + 2] * z2 + grad4[gi2 + 3] * w2);
            }
            var t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
            if (t3 < 0) n3 = 0.0;
            else {
                var gi3 = perm[ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]]] % 32 * 4;
                t3 *= t3;
                n3 = t3 * t3 * (grad4[gi3] * x3 + grad4[gi3 + 1] * y3 + grad4[gi3 + 2] * z3 + grad4[gi3 + 3] * w3);
            }
            var t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
            if (t4 < 0) n4 = 0.0;
            else {
                var gi4 = perm[ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]]] % 32 * 4;
                t4 *= t4;
                n4 = t4 * t4 * (grad4[gi4] * x4 + grad4[gi4 + 1] * y4 + grad4[gi4 + 2] * z4 + grad4[gi4 + 3] * w4);
            }
            // Sum up and scale the result to cover the range [-1,1]
            return 27.0 * (n0 + n1 + n2 + n3 + n4);
        }
    };
    function buildPermutationTable(random) {
        var i;
        var p = new Uint8Array(256);
        for(i = 0; i < 256; i++)p[i] = i;
        for(i = 0; i < 255; i++){
            var r = i + ~~(random() * (256 - i));
            var aux = p[i];
            p[i] = p[r];
            p[r] = aux;
        }
        return p;
    }
    SimplexNoise._buildPermutationTable = buildPermutationTable;
    function alea() {
        // Johannes Baagøe <baagoe@baagoe.com>, 2010
        var s0 = 0;
        var s1 = 0;
        var s2 = 0;
        var c = 1;
        var mash = masher();
        s0 = mash(' ');
        s1 = mash(' ');
        s2 = mash(' ');
        for(var i = 0; i < arguments.length; i++){
            s0 -= mash(arguments[i]);
            if (s0 < 0) s0 += 1;
            s1 -= mash(arguments[i]);
            if (s1 < 0) s1 += 1;
            s2 -= mash(arguments[i]);
            if (s2 < 0) s2 += 1;
        }
        mash = null;
        return function() {
            var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
            s0 = s1;
            s1 = s2;
            return s2 = t - (c = t | 0);
        };
    }
    function masher() {
        var n = 0xefc8249d;
        return function(data) {
            data = data.toString();
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
    }
    // amd
    if (typeof define !== 'undefined' && define.amd) define(function() {
        return SimplexNoise;
    });
    module.exports.SimplexNoise = SimplexNoise;
    module.exports = SimplexNoise;
})();

});

parcelRegister("2xuQP", function(module, exports) {
'use strict';
module.exports = function defined() {
    for(var i = 0; i < arguments.length; i++){
        if (typeof arguments[i] !== 'undefined') return arguments[i];
    }
};

});


parcelRegister("loLE8", function(module, exports) {

var $2xuQP = parcelRequire("2xuQP");

var $6HPEi = parcelRequire("6HPEi");
var $f940cc6e8a9617dd$var$EPSILON = Number.EPSILON;
function $f940cc6e8a9617dd$var$clamp(value, min, max) {
    return min < max ? value < min ? min : value > max ? max : value : value < max ? max : value > min ? min : value;
}
function $f940cc6e8a9617dd$var$clamp01(v) {
    return $f940cc6e8a9617dd$var$clamp(v, 0, 1);
}
function $f940cc6e8a9617dd$var$lerp(min, max, t) {
    return min * (1 - t) + max * t;
}
function $f940cc6e8a9617dd$var$inverseLerp(min, max, t) {
    if (Math.abs(min - max) < $f940cc6e8a9617dd$var$EPSILON) return 0;
    else return (t - min) / (max - min);
}
function $f940cc6e8a9617dd$var$smoothstep(min, max, t) {
    var x = $f940cc6e8a9617dd$var$clamp($f940cc6e8a9617dd$var$inverseLerp(min, max, t), 0, 1);
    return x * x * (3 - 2 * x);
}
function $f940cc6e8a9617dd$var$toFinite(n, defaultValue) {
    defaultValue = $2xuQP(defaultValue, 0);
    return typeof n === 'number' && isFinite(n) ? n : defaultValue;
}
function $f940cc6e8a9617dd$var$expandVector(dims) {
    if (typeof dims !== 'number') throw new TypeError('Expected dims argument');
    return function(p, defaultValue) {
        defaultValue = $2xuQP(defaultValue, 0);
        var scalar;
        if (p == null) // No vector, create a default one
        scalar = defaultValue;
        else if (typeof p === 'number' && isFinite(p)) // Expand single channel to multiple vector
        scalar = p;
        var out = [];
        var i;
        if (scalar == null) for(i = 0; i < dims; i++)out[i] = $f940cc6e8a9617dd$var$toFinite(p[i], defaultValue);
        else for(i = 0; i < dims; i++)out[i] = scalar;
        return out;
    };
}
function $f940cc6e8a9617dd$var$lerpArray(min, max, t, out) {
    out = out || [];
    if (min.length !== max.length) throw new TypeError('min and max array are expected to have the same length');
    for(var i = 0; i < min.length; i++)out[i] = $f940cc6e8a9617dd$var$lerp(min[i], max[i], t);
    return out;
}
function $f940cc6e8a9617dd$var$newArray(n, initialValue) {
    n = $2xuQP(n, 0);
    if (typeof n !== 'number') throw new TypeError('Expected n argument to be a number');
    var out = [];
    for(var i = 0; i < n; i++)out.push(initialValue);
    return out;
}
function $f940cc6e8a9617dd$var$linspace(n, opts) {
    n = $2xuQP(n, 0);
    if (typeof n !== 'number') throw new TypeError('Expected n argument to be a number');
    opts = opts || {};
    if (typeof opts === 'boolean') opts = {
        endpoint: true
    };
    var offset = $2xuQP(opts.offset, 0);
    if (opts.endpoint) return $f940cc6e8a9617dd$var$newArray(n).map(function(_, i) {
        return n <= 1 ? 0 : (i + offset) / (n - 1);
    });
    else return $f940cc6e8a9617dd$var$newArray(n).map(function(_, i) {
        return (i + offset) / n;
    });
}
function $f940cc6e8a9617dd$var$lerpFrames(values, t, out) {
    t = $f940cc6e8a9617dd$var$clamp(t, 0, 1);
    var len = values.length - 1;
    var whole = t * len;
    var frame = Math.floor(whole);
    var fract = whole - frame;
    var nextFrame = Math.min(frame + 1, len);
    var a = values[frame % values.length];
    var b = values[nextFrame % values.length];
    if (typeof a === 'number' && typeof b === 'number') return $f940cc6e8a9617dd$var$lerp(a, b, fract);
    else if (Array.isArray(a) && Array.isArray(b)) return $f940cc6e8a9617dd$var$lerpArray(a, b, fract, out);
    else throw new TypeError('Mismatch in value type of two array elements: ' + frame + ' and ' + nextFrame);
}
function $f940cc6e8a9617dd$var$mod(a, b) {
    return (a % b + b) % b;
}
function $f940cc6e8a9617dd$var$degToRad(n) {
    return n * Math.PI / 180;
}
function $f940cc6e8a9617dd$var$radToDeg(n) {
    return n * 180 / Math.PI;
}
function $f940cc6e8a9617dd$var$fract(n) {
    return n - Math.floor(n);
}
function $f940cc6e8a9617dd$var$sign(n) {
    if (n > 0) return 1;
    else if (n < 0) return -1;
    else return 0;
}
// Specific function from Unity / ofMath, not sure its needed?
// function lerpWrap (a, b, t, min, max) {
//   return wrap(a + wrap(b - a, min, max) * t, min, max)
// }
function $f940cc6e8a9617dd$var$pingPong(t, length) {
    t = $f940cc6e8a9617dd$var$mod(t, length * 2);
    return length - Math.abs(t - length);
}
function $f940cc6e8a9617dd$var$damp(a, b, lambda, dt) {
    return $f940cc6e8a9617dd$var$lerp(a, b, 1 - Math.exp(-lambda * dt));
}
function $f940cc6e8a9617dd$var$dampArray(a, b, lambda, dt, out) {
    out = out || [];
    for(var i = 0; i < a.length; i++)out[i] = $f940cc6e8a9617dd$var$damp(a[i], b[i], lambda, dt);
    return out;
}
function $f940cc6e8a9617dd$var$mapRange(value, inputMin, inputMax, outputMin, outputMax, clamp) {
    // Reference:
    // https://openframeworks.cc/documentation/math/ofMath/
    if (Math.abs(inputMin - inputMax) < $f940cc6e8a9617dd$var$EPSILON) return outputMin;
    else {
        var outVal = (value - inputMin) / (inputMax - inputMin) * (outputMax - outputMin) + outputMin;
        if (clamp) {
            if (outputMax < outputMin) {
                if (outVal < outputMax) outVal = outputMax;
                else if (outVal > outputMin) outVal = outputMin;
            } else {
                if (outVal > outputMax) outVal = outputMax;
                else if (outVal < outputMin) outVal = outputMin;
            }
        }
        return outVal;
    }
}
module.exports = {
    mod: $f940cc6e8a9617dd$var$mod,
    fract: $f940cc6e8a9617dd$var$fract,
    sign: $f940cc6e8a9617dd$var$sign,
    degToRad: $f940cc6e8a9617dd$var$degToRad,
    radToDeg: $f940cc6e8a9617dd$var$radToDeg,
    wrap: $6HPEi,
    pingPong: $f940cc6e8a9617dd$var$pingPong,
    linspace: $f940cc6e8a9617dd$var$linspace,
    lerp: $f940cc6e8a9617dd$var$lerp,
    lerpArray: $f940cc6e8a9617dd$var$lerpArray,
    inverseLerp: $f940cc6e8a9617dd$var$inverseLerp,
    lerpFrames: $f940cc6e8a9617dd$var$lerpFrames,
    clamp: $f940cc6e8a9617dd$var$clamp,
    clamp01: $f940cc6e8a9617dd$var$clamp01,
    smoothstep: $f940cc6e8a9617dd$var$smoothstep,
    damp: $f940cc6e8a9617dd$var$damp,
    dampArray: $f940cc6e8a9617dd$var$dampArray,
    mapRange: $f940cc6e8a9617dd$var$mapRange,
    expand2D: $f940cc6e8a9617dd$var$expandVector(2),
    expand3D: $f940cc6e8a9617dd$var$expandVector(3),
    expand4D: $f940cc6e8a9617dd$var$expandVector(4)
};

});
parcelRegister("6HPEi", function(module, exports) {
module.exports = $4e1ed2a4f1f6aa63$var$wrap;
function $4e1ed2a4f1f6aa63$var$wrap(value, from, to) {
    if (typeof from !== 'number' || typeof to !== 'number') throw new TypeError('Must specify "to" and "from" arguments as numbers');
    // algorithm from http://stackoverflow.com/a/5852628/599884
    if (from > to) {
        var t = from;
        from = to;
        to = t;
    }
    var cycle = to - from;
    if (cycle === 0) return to;
    return value - cycle * Math.floor((value - from) / cycle);
}

});


parcelRegister("bOzLK", function(module, exports) {

$parcel$export(module.exports, "createPath", () => $89a01c3418c622d9$export$fe53371bee54353d, (v) => $89a01c3418c622d9$export$fe53371bee54353d = v);
$parcel$export(module.exports, "pathsToSVGPaths", () => $89a01c3418c622d9$export$a861c819fda5d746, (v) => $89a01c3418c622d9$export$a861c819fda5d746 = v);
$parcel$export(module.exports, "pathsToPolylines", () => $89a01c3418c622d9$export$3d92c6dc6af5599f, (v) => $89a01c3418c622d9$export$3d92c6dc6af5599f = v);
$parcel$export(module.exports, "pathsToSVG", () => $89a01c3418c622d9$export$88a807bd6c4ce468, (v) => $89a01c3418c622d9$export$88a807bd6c4ce468 = v);
$parcel$export(module.exports, "renderPaths", () => $89a01c3418c622d9$export$4f16e7c39dd2c689, (v) => $89a01c3418c622d9$export$4f16e7c39dd2c689 = v);
$parcel$export(module.exports, "convertToSVGPath", () => $89a01c3418c622d9$export$aadfb4baccd0083d, (v) => $89a01c3418c622d9$export$aadfb4baccd0083d = v);
$parcel$export(module.exports, "eachPath", () => $89a01c3418c622d9$export$4e2aa3b0aa35703b, (v) => $89a01c3418c622d9$export$4e2aa3b0aa35703b = v);
$parcel$export(module.exports, "drawSVGPath", () => $89a01c3418c622d9$export$d8b1c81d11b980f9, (v) => $89a01c3418c622d9$export$d8b1c81d11b980f9 = v);
$parcel$export(module.exports, "polylineToSVGPath", () => $89a01c3418c622d9$export$9c362ab56e7470c9, (v) => $89a01c3418c622d9$export$9c362ab56e7470c9 = v);
$parcel$export(module.exports, "polylinesToSVG", () => $89a01c3418c622d9$export$a3fcc069284ff8b5, (v) => $89a01c3418c622d9$export$a3fcc069284ff8b5 = v);
$parcel$export(module.exports, "renderPolylines", () => $89a01c3418c622d9$export$ef2dfd08a0518db9, (v) => $89a01c3418c622d9$export$ef2dfd08a0518db9 = v);
// A Path helper for arcs, curves and lineTo commands
var $89a01c3418c622d9$export$fe53371bee54353d;
var $89a01c3418c622d9$export$a861c819fda5d746;
var $89a01c3418c622d9$export$3d92c6dc6af5599f;
var $89a01c3418c622d9$export$88a807bd6c4ce468;
var $89a01c3418c622d9$export$4f16e7c39dd2c689;
// Not documented...
var $89a01c3418c622d9$export$aadfb4baccd0083d;
var $89a01c3418c622d9$export$4e2aa3b0aa35703b;
var $89a01c3418c622d9$export$d8b1c81d11b980f9;
var $89a01c3418c622d9$export$9c362ab56e7470c9;
// @deprecated
var $89a01c3418c622d9$export$a3fcc069284ff8b5;
// @deprecated
var $89a01c3418c622d9$export$ef2dfd08a0518db9;

var $2xuQP = parcelRequire("2xuQP");

var $KcjeI = parcelRequire("KcjeI");

var $dsog7 = parcelRequire("dsog7");

var $12pmW = parcelRequire("12pmW");

var $81ETv = parcelRequire("81ETv");

var $d5uJw = parcelRequire("d5uJw");

var $jRBr9 = parcelRequire("jRBr9");

var $gQ3ba = parcelRequire("gQ3ba");

var $gBee2 = parcelRequire("gBee2");
var $89a01c3418c622d9$var$DEFAULT_PEN_THICKNESS = 0.03;
var $89a01c3418c622d9$var$DEFAULT_PEN_THICKNESS_UNIT = 'cm';
var $89a01c3418c622d9$var$DEFAULT_PIXELS_PER_INCH = 90;
$89a01c3418c622d9$export$fe53371bee54353d = $89a01c3418c622d9$var$createPath;
function $89a01c3418c622d9$var$createPath(fn) {
    var path = $dsog7.default();
    if (typeof fn === 'function') fn(path);
    path.lineTo = wrap(path.lineTo);
    path.quadraticCurveTo = wrap(path.quadraticCurveTo);
    path.bezierCurveTo = wrap(path.bezierCurveTo);
    return path;
    // Patch a bug in d3-path that doesn't handle
    // lineTo and so on without an initial moveTo
    function wrap(fn) {
        return function() {
            var args = Array.prototype.slice.call(arguments);
            if (path._x1 == null && path._y1 == null) path.moveTo(args[0], args[1]);
            return fn.apply(path, args);
        };
    }
}
$89a01c3418c622d9$export$a861c819fda5d746 = $89a01c3418c622d9$var$pathsToSVGPaths;
function $89a01c3418c622d9$var$pathsToSVGPaths(inputs, opt) {
    opt = opt || {};
    var svgPath = $89a01c3418c622d9$var$convertToSVGPath(inputs, opt);
    var svgPaths = Array.isArray(svgPath) ? svgPath : [
        svgPath
    ];
    return svgPaths.filter(Boolean);
}
$89a01c3418c622d9$export$3d92c6dc6af5599f = $89a01c3418c622d9$var$pathsToPolylines;
function $89a01c3418c622d9$var$pathsToPolylines(inputs, opt) {
    opt = opt || {};
    var scale;
    if (opt.curveResolution != null && isFinite(opt.curveResolution) && typeof opt.curveResolution === 'number') scale = opt.curveResolution;
    else {
        var units = opt.units || 'px';
        scale = Math.max(1, $KcjeI(4, units, 'px'));
    }
    var contours = [];
    $89a01c3418c622d9$var$eachPath(inputs, function(feature) {
        if (typeof feature === 'string') {
            var commands = $81ETv(feature);
            var subContours = $12pmW(commands, scale);
            subContours.forEach(function(subContour) {
                contours.push(subContour);
            });
        } else {
            // output only 2D polylines
            var polyline = feature.map(function(point) {
                return [
                    point[0] || 0,
                    point[1] || 0
                ];
            });
            contours.push(polyline);
        }
    });
    return contours;
}
$89a01c3418c622d9$export$88a807bd6c4ce468 = $89a01c3418c622d9$var$pathsToSVG;
function $89a01c3418c622d9$var$pathsToSVG(inputs, opt) {
    opt = opt || {};
    var width = opt.width;
    var height = opt.height;
    var computeBounds = typeof width === 'undefined' || typeof height === 'undefined';
    if (computeBounds) throw new Error('Must specify "width" and "height" options');
    var viewUnits = 'px';
    var units = opt.units || viewUnits;
    var convertOptions = {
        units: units,
        viewUnits: 'px',
        roundPixel: false,
        precision: $2xuQP(opt.precision, 5),
        pixelsPerInch: $89a01c3418c622d9$var$DEFAULT_PIXELS_PER_INCH
    };
    // Convert all SVGPaths/paths/etc to polylines
    // This won't change their units so they are still in user space
    inputs = $89a01c3418c622d9$var$pathsToPolylines(inputs, Object.assign({}, convertOptions, {
        curveResolution: opt.curveResolution || undefined
    }));
    // TODO: allow for 'repeat' option
    if (opt.optimize) {
        var optimizeOpts = typeof opt.optimize === 'object' ? opt.optimize : {
            sort: true,
            merge: true,
            removeDuplicates: true,
            removeCollinear: true
        };
        var shouldSort = optimizeOpts.sort !== false;
        var shouldMerge = optimizeOpts.merge !== false;
        var shouldRemoveDuplicate = optimizeOpts.removeDuplicates !== false;
        var shouldRemoveCollinear = optimizeOpts.removeCollinear !== false;
        if (shouldRemoveDuplicate) inputs = inputs.map(function(line) {
            return $gBee2.removeDuplicatePoints(line);
        });
        if (shouldRemoveCollinear) inputs = inputs.map(function(line) {
            return $gBee2.removeCollinearPoints(line);
        });
        // now do sorting & merging
        if (shouldSort) inputs = $gQ3ba.sort(inputs);
        if (shouldMerge) {
            var mergeThreshold = optimizeOpts.mergeThreshold != null ? optimizeOpts.mergeThreshold : $KcjeI(0.25, 'mm', units, {
                pixelsPerInch: $89a01c3418c622d9$var$DEFAULT_PIXELS_PER_INCH
            });
            inputs = $gQ3ba.merge(inputs, mergeThreshold);
        }
    }
    // now we convert all polylines in user space units into view units
    var svgPaths = $89a01c3418c622d9$var$pathsToSVGPaths(inputs, convertOptions);
    var viewWidth = $KcjeI(width, units, viewUnits, convertOptions).toString();
    var viewHeight = $KcjeI(height, units, viewUnits, convertOptions).toString();
    var fillStyle = opt.fillStyle || 'none';
    var strokeStyle = opt.strokeStyle || 'black';
    var lineWidth = opt.lineWidth;
    var lineJoin = opt.lineJoin;
    var lineCap = opt.lineCap;
    // Choose a default line width based on a relatively fine-tip pen
    if (typeof lineWidth === 'undefined') // Convert to user units
    lineWidth = $KcjeI($89a01c3418c622d9$var$DEFAULT_PEN_THICKNESS, $89a01c3418c622d9$var$DEFAULT_PEN_THICKNESS_UNIT, units, convertOptions).toString();
    var pathElements = svgPaths.map(function(d) {
        var attrs = $89a01c3418c622d9$var$toAttrList([
            [
                'd',
                d
            ]
        ]);
        return '    <path ' + attrs + ' />';
    }).join('\n');
    var groupAttrs = $89a01c3418c622d9$var$toAttrList([
        [
            'fill',
            fillStyle
        ],
        [
            'stroke',
            strokeStyle
        ],
        [
            'stroke-width',
            lineWidth + '' + units
        ],
        lineJoin ? [
            'stroke-linejoin',
            lineJoin
        ] : false,
        lineCap ? [
            'stroke-linecap',
            lineCap
        ] : false
    ]);
    return [
        '<?xml version="1.0" standalone="no"?>',
        '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
        '    "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">',
        '<svg width="' + width + units + '" height="' + height + units + '"',
        '    xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ' + viewWidth + ' ' + viewHeight + '">',
        '  <g ' + groupAttrs + '>',
        pathElements,
        '  </g>',
        '</svg>'
    ].join('\n');
}
function $89a01c3418c622d9$var$toAttrList(args) {
    return args.filter(Boolean).map(function(attr) {
        return attr[0] + '="' + attr[1] + '"';
    }).join(' ');
}
$89a01c3418c622d9$export$4f16e7c39dd2c689 = $89a01c3418c622d9$var$renderPaths;
function $89a01c3418c622d9$var$renderPaths(inputs, opt) {
    opt = opt || {};
    var context = opt.context;
    if (!context) throw new Error('Must specify "context" options');
    var units = opt.units || 'px';
    var width = opt.width;
    var height = opt.height;
    if (typeof width === 'undefined' || typeof height === 'undefined') throw new Error('Must specify "width" and "height" options');
    // Choose a default line width based on a relatively fine-tip pen
    var lineWidth = opt.lineWidth;
    if (typeof lineWidth === 'undefined') // Convert to user units
    lineWidth = $KcjeI($89a01c3418c622d9$var$DEFAULT_PEN_THICKNESS, $89a01c3418c622d9$var$DEFAULT_PEN_THICKNESS_UNIT, units, {
        roundPixel: false,
        pixelsPerInch: $89a01c3418c622d9$var$DEFAULT_PIXELS_PER_INCH
    });
    // Clear canvas
    context.clearRect(0, 0, width, height);
    // Fill with white
    context.fillStyle = opt.background || 'white';
    context.fillRect(0, 0, width, height);
    context.strokeStyle = opt.foreground || opt.strokeStyle || 'black';
    context.lineWidth = lineWidth;
    context.lineJoin = opt.lineJoin || 'miter';
    context.lineCap = opt.lineCap || 'butt';
    // Draw lines
    $89a01c3418c622d9$var$eachPath(inputs, function(feature) {
        context.beginPath();
        if (typeof feature === 'string') // SVG string = drawSVGPath;
        $89a01c3418c622d9$var$drawSVGPath(context, feature);
        else // list of points
        feature.forEach(function(p) {
            context.lineTo(p[0], p[1]);
        });
        context.stroke();
    });
    // Save layers
    return [
        // Export PNG as first layer
        context.canvas,
        // Export SVG for pen plotter as second layer
        {
            data: $89a01c3418c622d9$var$pathsToSVG(inputs, opt),
            extension: '.svg'
        }
    ];
}
$89a01c3418c622d9$export$aadfb4baccd0083d = $89a01c3418c622d9$var$convertToSVGPath;
function $89a01c3418c622d9$var$convertToSVGPath(input, opt) {
    // Input can be a single 'path' (string, object or polyline),
    // or nested 'path' elements
    // non-path
    if ($89a01c3418c622d9$var$isEmpty(input)) return '';
    // strings are just returned as-is
    if (typeof input === 'string') return input;
    // assume a path instance
    if ($89a01c3418c622d9$var$isPath(input)) return input.toString();
    if ($89a01c3418c622d9$var$isPolyline(input)) return $89a01c3418c622d9$var$polylineToSVGPath(input, opt);
    // assume a list of 'path' features or a list of polylines
    if (Array.isArray(input)) return input.map(function(feature) {
        return $89a01c3418c622d9$var$convertToSVGPath(feature, opt);
    }).reduce(function(a, b) {
        return a.concat(b);
    }, []);
    // Wasn't clear... let's return an empty path
    return '';
}
$89a01c3418c622d9$export$4e2aa3b0aa35703b = $89a01c3418c622d9$var$eachPath;
function $89a01c3418c622d9$var$eachPath(input, cb) {
    if ($89a01c3418c622d9$var$isEmpty(input)) ;
    else if (typeof input === 'string' || $89a01c3418c622d9$var$isPath(input)) cb(input.toString());
    else if ($89a01c3418c622d9$var$isPolyline(input)) cb(input);
    else if (Array.isArray(input)) input.forEach(function(feature) {
        return $89a01c3418c622d9$var$eachPath(feature, cb);
    });
}
$89a01c3418c622d9$export$d8b1c81d11b980f9 = $89a01c3418c622d9$var$drawSVGPath;
function $89a01c3418c622d9$var$drawSVGPath(context, svgPath) {
    var commands = $jRBr9($d5uJw($81ETv(svgPath)));
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        var type = c[0];
        if (type === 'M') context.moveTo(c[1], c[2]);
        else if (type === 'C') context.bezierCurveTo(c[1], c[2], c[3], c[4], c[5], c[6]);
        else throw new Error('Illegal type "' + type + '" in SVG commands');
    }
}
$89a01c3418c622d9$export$9c362ab56e7470c9 = $89a01c3418c622d9$var$polylineToSVGPath;
function $89a01c3418c622d9$var$polylineToSVGPath(polyline, opt) {
    opt = opt || {};
    var units = opt.units || 'px';
    var viewUnits = opt.viewUnits || units;
    var commands = [];
    var convertOptions = {
        roundPixel: false,
        precision: $2xuQP(opt.precision, 5),
        pixelsPerInch: $89a01c3418c622d9$var$DEFAULT_PIXELS_PER_INCH
    };
    polyline.forEach(function(point, j) {
        var type = j === 0 ? 'M' : 'L';
        var x = $KcjeI(point[0], units, viewUnits, convertOptions).toString();
        var y = $KcjeI(point[1], units, viewUnits, convertOptions).toString();
        commands.push(type + x + ' ' + y);
    });
    return commands.join(' ');
}
function $89a01c3418c622d9$var$isEmpty(input) {
    return !input || Array.isArray(input) && input.length === 0;
}
function $89a01c3418c622d9$var$isPath(input) {
    return typeof input === 'object' && input && !Array.isArray(input);
}
function $89a01c3418c622d9$var$isPolyline(input) {
    // empty array or not an array
    if (!input || !Array.isArray(input) || input.length === 0) return false;
    // if at least one of the inputs is a point, assume they all are
    return $89a01c3418c622d9$var$isPoint(input[0]);
}
function $89a01c3418c622d9$var$isPoint(point) {
    return Array.isArray(point) && point.length >= 2 && point.every(function(p) {
        return typeof p === 'number';
    });
}
$89a01c3418c622d9$export$a3fcc069284ff8b5 = function polylinesToSVG(polylines, opt) {
    if (!Array.isArray(polylines)) throw new Error('Expected array of arrays for polylines');
    console.warn('polylinesToSVG is deprecated, use pathsToSVG instead which has the same functionality');
    // Create a single string from polylines
    return $89a01c3418c622d9$var$pathsToSVG(polylines, opt);
};
$89a01c3418c622d9$export$ef2dfd08a0518db9 = function renderPolylines(polylines, opt) {
    if (!Array.isArray(polylines)) throw new Error('Expected array of arrays for polylines');
    console.warn('renderPolylines is deprecated, use renderPaths instead which has the same functionality');
    // Create a single string from polylines
    return $89a01c3418c622d9$var$renderPaths(polylines, opt);
};

});
parcelRegister("KcjeI", function(module, exports) {

var $2xuQP = parcelRequire("2xuQP");
var $08add85b1961ec33$var$units = [
    'mm',
    'cm',
    'm',
    'pc',
    'pt',
    'in',
    'ft',
    'px'
];
var $08add85b1961ec33$var$conversions = {
    // metric
    m: {
        system: 'metric',
        factor: 1
    },
    cm: {
        system: 'metric',
        factor: 0.01
    },
    mm: {
        system: 'metric',
        factor: 0.001
    },
    // imperial
    pt: {
        system: 'imperial',
        factor: 1 / 72
    },
    pc: {
        system: 'imperial',
        factor: 1 / 6
    },
    in: {
        system: 'imperial',
        factor: 1
    },
    ft: {
        system: 'imperial',
        factor: 12
    }
};
const $08add85b1961ec33$var$anchors = {
    metric: {
        unit: 'm',
        ratio: 1 / 0.0254
    },
    imperial: {
        unit: 'in',
        ratio: 0.0254
    }
};
function $08add85b1961ec33$var$round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
}
function $08add85b1961ec33$var$convertDistance(value, fromUnit, toUnit, opts) {
    if (typeof value !== 'number' || !isFinite(value)) throw new Error('Value must be a finite number');
    if (!fromUnit || !toUnit) throw new Error('Must specify from and to units');
    opts = opts || {};
    var pixelsPerInch = $2xuQP(opts.pixelsPerInch, 96);
    var precision = opts.precision;
    var roundPixel = opts.roundPixel !== false;
    fromUnit = fromUnit.toLowerCase();
    toUnit = toUnit.toLowerCase();
    if ($08add85b1961ec33$var$units.indexOf(fromUnit) === -1) throw new Error('Invalid from unit "' + fromUnit + '", must be one of: ' + $08add85b1961ec33$var$units.join(', '));
    if ($08add85b1961ec33$var$units.indexOf(toUnit) === -1) throw new Error('Invalid from unit "' + toUnit + '", must be one of: ' + $08add85b1961ec33$var$units.join(', '));
    if (fromUnit === toUnit) // We don't need to convert from A to B since they are the same already
    return value;
    var toFactor = 1;
    var fromFactor = 1;
    var isToPixel = false;
    if (fromUnit === 'px') {
        fromFactor = 1 / pixelsPerInch;
        fromUnit = 'in';
    }
    if (toUnit === 'px') {
        isToPixel = true;
        toFactor = pixelsPerInch;
        toUnit = 'in';
    }
    var fromUnitData = $08add85b1961ec33$var$conversions[fromUnit];
    var toUnitData = $08add85b1961ec33$var$conversions[toUnit];
    // source to anchor inside source's system
    var anchor = value * fromUnitData.factor * fromFactor;
    // if systems differ, convert one to another
    if (fromUnitData.system !== toUnitData.system) // regular 'm' to 'in' and so forth
    anchor *= $08add85b1961ec33$var$anchors[fromUnitData.system].ratio;
    var result = anchor / toUnitData.factor * toFactor;
    if (isToPixel && roundPixel) result = Math.round(result);
    else if (typeof precision === 'number' && isFinite(precision)) result = $08add85b1961ec33$var$round(result, precision);
    return result;
}
module.exports = $08add85b1961ec33$var$convertDistance;
module.exports.units = $08add85b1961ec33$var$units;

});

parcelRegister("dsog7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cc0b53572fa3025$export$2e2bcd8739ae039);
var $9cc0b53572fa3025$var$pi = Math.PI, $9cc0b53572fa3025$var$tau = 2 * $9cc0b53572fa3025$var$pi, $9cc0b53572fa3025$var$epsilon = 1e-6, $9cc0b53572fa3025$var$tauEpsilon = $9cc0b53572fa3025$var$tau - $9cc0b53572fa3025$var$epsilon;
function $9cc0b53572fa3025$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $9cc0b53572fa3025$var$path() {
    return new $9cc0b53572fa3025$var$Path;
}
$9cc0b53572fa3025$var$Path.prototype = $9cc0b53572fa3025$var$path.prototype = {
    constructor: $9cc0b53572fa3025$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $9cc0b53572fa3025$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $9cc0b53572fa3025$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($9cc0b53572fa3025$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $9cc0b53572fa3025$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $9cc0b53572fa3025$var$epsilon || Math.abs(this._y1 - y0) > $9cc0b53572fa3025$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $9cc0b53572fa3025$var$tau + $9cc0b53572fa3025$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $9cc0b53572fa3025$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $9cc0b53572fa3025$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $9cc0b53572fa3025$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $9cc0b53572fa3025$export$2e2bcd8739ae039 = $9cc0b53572fa3025$var$path;

});

parcelRegister("12pmW", function(module, exports) {

var $l0qKb = parcelRequire("l0qKb");

var $d5uJw = parcelRequire("d5uJw");

var $eh7KR = parcelRequire("eh7KR");

var $bjIoC = parcelRequire("bjIoC");
function $0c19a819e7ba3cf2$var$set(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
var $0c19a819e7ba3cf2$var$tmp1 = [
    0,
    0
], $0c19a819e7ba3cf2$var$tmp2 = [
    0,
    0
], $0c19a819e7ba3cf2$var$tmp3 = [
    0,
    0
];
function $0c19a819e7ba3cf2$var$bezierTo(points, scale, start, seg) {
    $l0qKb(start, $0c19a819e7ba3cf2$var$set($0c19a819e7ba3cf2$var$tmp1, seg[1], seg[2]), $0c19a819e7ba3cf2$var$set($0c19a819e7ba3cf2$var$tmp2, seg[3], seg[4]), $0c19a819e7ba3cf2$var$set($0c19a819e7ba3cf2$var$tmp3, seg[5], seg[6]), scale, points);
}
module.exports = function contours(svg, scale) {
    var paths = [];
    var points = [];
    var pen = [
        0,
        0
    ];
    $eh7KR($d5uJw(svg)).forEach(function(segment, i, self) {
        if (segment[0] === 'M') {
            $bjIoC(pen, segment.slice(1));
            if (points.length > 0) {
                paths.push(points);
                points = [];
            }
        } else if (segment[0] === 'C') {
            $0c19a819e7ba3cf2$var$bezierTo(points, scale, pen, segment);
            $0c19a819e7ba3cf2$var$set(pen, segment[5], segment[6]);
        } else throw new Error('illegal type in SVG: ' + segment[0]);
    });
    if (points.length > 0) paths.push(points);
    return paths;
};

});
parcelRegister("l0qKb", function(module, exports) {

module.exports = (parcelRequire("gqxSh"))();

});
parcelRegister("gqxSh", function(module, exports) {
function $bf5959cdcc19793a$var$clone(point) {
    return [
        point[0],
        point[1]
    ];
}
function $bf5959cdcc19793a$var$vec2(x, y) {
    return [
        x,
        y
    ];
}
module.exports = function createBezierBuilder(opt) {
    opt = opt || {};
    var RECURSION_LIMIT = typeof opt.recursion === 'number' ? opt.recursion : 8;
    var FLT_EPSILON = typeof opt.epsilon === 'number' ? opt.epsilon : 1.19209290e-7;
    var PATH_DISTANCE_EPSILON = typeof opt.pathEpsilon === 'number' ? opt.pathEpsilon : 1.0;
    var curve_angle_tolerance_epsilon = typeof opt.angleEpsilon === 'number' ? opt.angleEpsilon : 0.01;
    var m_angle_tolerance = opt.angleTolerance || 0;
    var m_cusp_limit = opt.cuspLimit || 0;
    return function bezierCurve(start, c1, c2, end, scale, points) {
        if (!points) points = [];
        scale = typeof scale === 'number' ? scale : 1.0;
        var distanceTolerance = PATH_DISTANCE_EPSILON / scale;
        distanceTolerance *= distanceTolerance;
        begin(start, c1, c2, end, points, distanceTolerance);
        return points;
    };
    ////// Based on:
    ////// https://github.com/pelson/antigrain/blob/master/agg-2.4/src/agg_curves.cpp
    function begin(start, c1, c2, end, points, distanceTolerance) {
        points.push($bf5959cdcc19793a$var$clone(start));
        var x1 = start[0], y1 = start[1], x2 = c1[0], y2 = c1[1], x3 = c2[0], y3 = c2[1], x4 = end[0], y4 = end[1];
        recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, 0);
        points.push($bf5959cdcc19793a$var$clone(end));
    }
    function recursive(x1, y1, x2, y2, x3, y3, x4, y4, points, distanceTolerance, level) {
        if (level > RECURSION_LIMIT) return;
        var pi = Math.PI;
        // Calculate all the mid-points of the line segments
        //----------------------
        var x12 = (x1 + x2) / 2;
        var y12 = (y1 + y2) / 2;
        var x23 = (x2 + x3) / 2;
        var y23 = (y2 + y3) / 2;
        var x34 = (x3 + x4) / 2;
        var y34 = (y3 + y4) / 2;
        var x123 = (x12 + x23) / 2;
        var y123 = (y12 + y23) / 2;
        var x234 = (x23 + x34) / 2;
        var y234 = (y23 + y34) / 2;
        var x1234 = (x123 + x234) / 2;
        var y1234 = (y123 + y234) / 2;
        if (level > 0) {
            // Try to approximate the full cubic curve by a single straight line
            //------------------
            var dx = x4 - x1;
            var dy = y4 - y1;
            var d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
            var d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
            var da1, da2;
            if (d2 > FLT_EPSILON && d3 > FLT_EPSILON) // Regular care
            //-----------------
            {
                if ((d2 + d3) * (d2 + d3) <= distanceTolerance * (dx * dx + dy * dy)) {
                    // If the curvature doesn't exceed the distanceTolerance value
                    // we tend to finish subdivisions.
                    //----------------------
                    if (m_angle_tolerance < curve_angle_tolerance_epsilon) {
                        points.push($bf5959cdcc19793a$var$vec2(x1234, y1234));
                        return;
                    }
                    // Angle & Cusp Condition
                    //----------------------
                    var a23 = Math.atan2(y3 - y2, x3 - x2);
                    da1 = Math.abs(a23 - Math.atan2(y2 - y1, x2 - x1));
                    da2 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - a23);
                    if (da1 >= pi) da1 = 2 * pi - da1;
                    if (da2 >= pi) da2 = 2 * pi - da2;
                    if (da1 + da2 < m_angle_tolerance) {
                        // Finally we can stop the recursion
                        //----------------------
                        points.push($bf5959cdcc19793a$var$vec2(x1234, y1234));
                        return;
                    }
                    if (m_cusp_limit !== 0.0) {
                        if (da1 > m_cusp_limit) {
                            points.push($bf5959cdcc19793a$var$vec2(x2, y2));
                            return;
                        }
                        if (da2 > m_cusp_limit) {
                            points.push($bf5959cdcc19793a$var$vec2(x3, y3));
                            return;
                        }
                    }
                }
            } else {
                if (d2 > FLT_EPSILON) // p1,p3,p4 are collinear, p2 is considerable
                //----------------------
                {
                    if (d2 * d2 <= distanceTolerance * (dx * dx + dy * dy)) {
                        if (m_angle_tolerance < curve_angle_tolerance_epsilon) {
                            points.push($bf5959cdcc19793a$var$vec2(x1234, y1234));
                            return;
                        }
                        // Angle Condition
                        //----------------------
                        da1 = Math.abs(Math.atan2(y3 - y2, x3 - x2) - Math.atan2(y2 - y1, x2 - x1));
                        if (da1 >= pi) da1 = 2 * pi - da1;
                        if (da1 < m_angle_tolerance) {
                            points.push($bf5959cdcc19793a$var$vec2(x2, y2));
                            points.push($bf5959cdcc19793a$var$vec2(x3, y3));
                            return;
                        }
                        if (m_cusp_limit !== 0.0) {
                            if (da1 > m_cusp_limit) {
                                points.push($bf5959cdcc19793a$var$vec2(x2, y2));
                                return;
                            }
                        }
                    }
                } else if (d3 > FLT_EPSILON) // p1,p2,p4 are collinear, p3 is considerable
                //----------------------
                {
                    if (d3 * d3 <= distanceTolerance * (dx * dx + dy * dy)) {
                        if (m_angle_tolerance < curve_angle_tolerance_epsilon) {
                            points.push($bf5959cdcc19793a$var$vec2(x1234, y1234));
                            return;
                        }
                        // Angle Condition
                        //----------------------
                        da1 = Math.abs(Math.atan2(y4 - y3, x4 - x3) - Math.atan2(y3 - y2, x3 - x2));
                        if (da1 >= pi) da1 = 2 * pi - da1;
                        if (da1 < m_angle_tolerance) {
                            points.push($bf5959cdcc19793a$var$vec2(x2, y2));
                            points.push($bf5959cdcc19793a$var$vec2(x3, y3));
                            return;
                        }
                        if (m_cusp_limit !== 0.0) {
                            if (da1 > m_cusp_limit) {
                                points.push($bf5959cdcc19793a$var$vec2(x3, y3));
                                return;
                            }
                        }
                    }
                } else {
                    // Collinear case
                    //-----------------
                    dx = x1234 - (x1 + x4) / 2;
                    dy = y1234 - (y1 + y4) / 2;
                    if (dx * dx + dy * dy <= distanceTolerance) {
                        points.push($bf5959cdcc19793a$var$vec2(x1234, y1234));
                        return;
                    }
                }
            }
        }
        // Continue subdivision
        //----------------------
        recursive(x1, y1, x12, y12, x123, y123, x1234, y1234, points, distanceTolerance, level + 1);
        recursive(x1234, y1234, x234, y234, x34, y34, x4, y4, points, distanceTolerance, level + 1);
    }
};

});


parcelRegister("d5uJw", function(module, exports) {
module.exports = $987394f5fac7e011$var$absolutize;
/**
 * redefine `path` with absolute coordinates
 *
 * @param {Array} path
 * @return {Array}
 */ function $987394f5fac7e011$var$absolutize(path) {
    var startX = 0;
    var startY = 0;
    var x = 0;
    var y = 0;
    return path.map(function(seg) {
        seg = seg.slice();
        var type = seg[0];
        var command = type.toUpperCase();
        // is relative
        if (type != command) {
            seg[0] = command;
            switch(type){
                case 'a':
                    seg[6] += x;
                    seg[7] += y;
                    break;
                case 'v':
                    seg[1] += y;
                    break;
                case 'h':
                    seg[1] += x;
                    break;
                default:
                    for(var i = 1; i < seg.length;){
                        seg[i++] += x;
                        seg[i++] += y;
                    }
            }
        }
        // update cursor state
        switch(command){
            case 'Z':
                x = startX;
                y = startY;
                break;
            case 'H':
                x = seg[1];
                break;
            case 'V':
                y = seg[1];
                break;
            case 'M':
                x = startX = seg[1];
                y = startY = seg[2];
                break;
            default:
                x = seg[seg.length - 2];
                y = seg[seg.length - 1];
        }
        return seg;
    });
}

});

parcelRegister("eh7KR", function(module, exports) {
var $a648ab2df28f01d0$var$\u03C0 = Math.PI;
var $a648ab2df28f01d0$var$_120 = $a648ab2df28f01d0$var$radians(120);
module.exports = $a648ab2df28f01d0$var$normalize;
/**
 * describe `path` in terms of cubic bézier 
 * curves and move commands
 *
 * @param {Array} path
 * @return {Array}
 */ function $a648ab2df28f01d0$var$normalize(path) {
    // init state
    var prev;
    var result = [];
    var bezierX = 0;
    var bezierY = 0;
    var startX = 0;
    var startY = 0;
    var quadX = null;
    var quadY = null;
    var x = 0;
    var y = 0;
    for(var i = 0, len = path.length; i < len; i++){
        var seg = path[i];
        var command = seg[0];
        switch(command){
            case 'M':
                startX = seg[1];
                startY = seg[2];
                break;
            case 'A':
                seg = $a648ab2df28f01d0$var$arc(x, y, seg[1], seg[2], $a648ab2df28f01d0$var$radians(seg[3]), seg[4], seg[5], seg[6], seg[7]);
                // split multi part
                seg.unshift('C');
                if (seg.length > 7) {
                    result.push(seg.splice(0, 7));
                    seg.unshift('C');
                }
                break;
            case 'S':
                // default control point
                var cx = x;
                var cy = y;
                if (prev == 'C' || prev == 'S') {
                    cx += cx - bezierX // reflect the previous command's control
                    ;
                    cy += cy - bezierY // point relative to the current point
                    ;
                }
                seg = [
                    'C',
                    cx,
                    cy,
                    seg[1],
                    seg[2],
                    seg[3],
                    seg[4]
                ];
                break;
            case 'T':
                if (prev == 'Q' || prev == 'T') {
                    quadX = x * 2 - quadX // as with 'S' reflect previous control point
                    ;
                    quadY = y * 2 - quadY;
                } else {
                    quadX = x;
                    quadY = y;
                }
                seg = $a648ab2df28f01d0$var$quadratic(x, y, quadX, quadY, seg[1], seg[2]);
                break;
            case 'Q':
                quadX = seg[1];
                quadY = seg[2];
                seg = $a648ab2df28f01d0$var$quadratic(x, y, seg[1], seg[2], seg[3], seg[4]);
                break;
            case 'L':
                seg = $a648ab2df28f01d0$var$line(x, y, seg[1], seg[2]);
                break;
            case 'H':
                seg = $a648ab2df28f01d0$var$line(x, y, seg[1], y);
                break;
            case 'V':
                seg = $a648ab2df28f01d0$var$line(x, y, x, seg[1]);
                break;
            case 'Z':
                seg = $a648ab2df28f01d0$var$line(x, y, startX, startY);
                break;
        }
        // update state
        prev = command;
        x = seg[seg.length - 2];
        y = seg[seg.length - 1];
        if (seg.length > 4) {
            bezierX = seg[seg.length - 4];
            bezierY = seg[seg.length - 3];
        } else {
            bezierX = x;
            bezierY = y;
        }
        result.push(seg);
    }
    return result;
}
function $a648ab2df28f01d0$var$line(x1, y1, x2, y2) {
    return [
        'C',
        x1,
        y1,
        x2,
        y2,
        x2,
        y2
    ];
}
function $a648ab2df28f01d0$var$quadratic(x1, y1, cx, cy, x2, y2) {
    return [
        'C',
        x1 / 3 + 2 / 3 * cx,
        y1 / 3 + 2 / 3 * cy,
        x2 / 3 + 2 / 3 * cx,
        y2 / 3 + 2 / 3 * cy,
        x2,
        y2
    ];
}
// This function is ripped from 
// github.com/DmitryBaranovskiy/raphael/blob/4d97d4/raphael.js#L2216-L2304 
// which references w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
// TODO: make it human readable
function $a648ab2df28f01d0$var$arc(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
    if (!recursive) {
        var xy = $a648ab2df28f01d0$var$rotate(x1, y1, -angle);
        x1 = xy.x;
        y1 = xy.y;
        xy = $a648ab2df28f01d0$var$rotate(x2, y2, -angle);
        x2 = xy.x;
        y2 = xy.y;
        var x = (x1 - x2) / 2;
        var y = (y1 - y2) / 2;
        var h = x * x / (rx * rx) + y * y / (ry * ry);
        if (h > 1) {
            h = Math.sqrt(h);
            rx = h * rx;
            ry = h * ry;
        }
        var rx2 = rx * rx;
        var ry2 = ry * ry;
        var k = (large_arc_flag == sweep_flag ? -1 : 1) * Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)));
        if (k == Infinity) k = 1 // neutralize
        ;
        var cx = k * rx * y / ry + (x1 + x2) / 2;
        var cy = k * -ry * x / rx + (y1 + y2) / 2;
        var f1 = Math.asin(((y1 - cy) / ry).toFixed(9));
        var f2 = Math.asin(((y2 - cy) / ry).toFixed(9));
        f1 = x1 < cx ? $a648ab2df28f01d0$var$\u03C0 - f1 : f1;
        f2 = x2 < cx ? $a648ab2df28f01d0$var$\u03C0 - f2 : f2;
        if (f1 < 0) f1 = $a648ab2df28f01d0$var$\u03C0 * 2 + f1;
        if (f2 < 0) f2 = $a648ab2df28f01d0$var$\u03C0 * 2 + f2;
        if (sweep_flag && f1 > f2) f1 = f1 - $a648ab2df28f01d0$var$\u03C0 * 2;
        if (!sweep_flag && f2 > f1) f2 = f2 - $a648ab2df28f01d0$var$\u03C0 * 2;
    } else {
        f1 = recursive[0];
        f2 = recursive[1];
        cx = recursive[2];
        cy = recursive[3];
    }
    // greater than 120 degrees requires multiple segments
    if (Math.abs(f2 - f1) > $a648ab2df28f01d0$var$_120) {
        var f2old = f2;
        var x2old = x2;
        var y2old = y2;
        f2 = f1 + $a648ab2df28f01d0$var$_120 * (sweep_flag && f2 > f1 ? 1 : -1);
        x2 = cx + rx * Math.cos(f2);
        y2 = cy + ry * Math.sin(f2);
        var res = $a648ab2df28f01d0$var$arc(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [
            f2,
            f2old,
            cx,
            cy
        ]);
    }
    var t = Math.tan((f2 - f1) / 4);
    var hx = 4 / 3 * rx * t;
    var hy = 4 / 3 * ry * t;
    var curve = [
        2 * x1 - (x1 + hx * Math.sin(f1)),
        2 * y1 - (y1 - hy * Math.cos(f1)),
        x2 + hx * Math.sin(f2),
        y2 - hy * Math.cos(f2),
        x2,
        y2
    ];
    if (recursive) return curve;
    if (res) curve = curve.concat(res);
    for(var i = 0; i < curve.length;){
        var rot = $a648ab2df28f01d0$var$rotate(curve[i], curve[i + 1], angle);
        curve[i++] = rot.x;
        curve[i++] = rot.y;
    }
    return curve;
}
function $a648ab2df28f01d0$var$rotate(x, y, rad) {
    return {
        x: x * Math.cos(rad) - y * Math.sin(rad),
        y: x * Math.sin(rad) + y * Math.cos(rad)
    };
}
function $a648ab2df28f01d0$var$radians(degress) {
    return degress * ($a648ab2df28f01d0$var$\u03C0 / 180);
}

});

parcelRegister("bjIoC", function(module, exports) {
module.exports = function vec2Copy(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
};

});


parcelRegister("81ETv", function(module, exports) {
module.exports = $5d7e237873f38574$var$parse;
/**
 * expected argument lengths
 * @type {Object}
 */ var $5d7e237873f38574$var$length = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};
/**
 * segment pattern
 * @type {RegExp}
 */ var $5d7e237873f38574$var$segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
/**
 * parse an svg path data string. Generates an Array
 * of commands where each command is an Array of the
 * form `[command, arg1, arg2, ...]`
 *
 * @param {String} path
 * @return {Array}
 */ function $5d7e237873f38574$var$parse(path) {
    var data = [];
    path.replace($5d7e237873f38574$var$segment, function(_, command, args) {
        var type = command.toLowerCase();
        args = $5d7e237873f38574$var$parseValues(args);
        // overloaded moveTo
        if (type == 'm' && args.length > 2) {
            data.push([
                command
            ].concat(args.splice(0, 2)));
            type = 'l';
            command = command == 'm' ? 'l' : 'L';
        }
        while(true){
            if (args.length == $5d7e237873f38574$var$length[type]) {
                args.unshift(command);
                return data.push(args);
            }
            if (args.length < $5d7e237873f38574$var$length[type]) throw new Error('malformed path data');
            data.push([
                command
            ].concat(args.splice(0, $5d7e237873f38574$var$length[type])));
        }
    });
    return data;
}
var $5d7e237873f38574$var$number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
function $5d7e237873f38574$var$parseValues(args) {
    var numbers = args.match($5d7e237873f38574$var$number);
    return numbers ? numbers.map(Number) : [];
}

});

parcelRegister("jRBr9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb871d86c9e9e6d4$export$2e2bcd8739ae039);

var $3CTXs = parcelRequire("3CTXs");
function $fb871d86c9e9e6d4$export$2e2bcd8739ae039(path) {
    // init state
    var prev;
    var result = [];
    var bezierX = 0;
    var bezierY = 0;
    var startX = 0;
    var startY = 0;
    var quadX = null;
    var quadY = null;
    var x = 0;
    var y = 0;
    for(var i = 0, len = path.length; i < len; i++){
        var seg = path[i];
        var command = seg[0];
        switch(command){
            case 'M':
                startX = seg[1];
                startY = seg[2];
                break;
            case 'A':
                var curves = (0, $3CTXs.default)({
                    px: x,
                    py: y,
                    cx: seg[6],
                    cy: seg[7],
                    rx: seg[1],
                    ry: seg[2],
                    xAxisRotation: seg[3],
                    largeArcFlag: seg[4],
                    sweepFlag: seg[5]
                });
                // null-curves
                if (!curves.length) continue;
                for(var j = 0, c; j < curves.length; j++){
                    c = curves[j];
                    seg = [
                        'C',
                        c.x1,
                        c.y1,
                        c.x2,
                        c.y2,
                        c.x,
                        c.y
                    ];
                    if (j < curves.length - 1) result.push(seg);
                }
                break;
            case 'S':
                // default control point
                var cx = x;
                var cy = y;
                if (prev == 'C' || prev == 'S') {
                    cx += cx - bezierX // reflect the previous command's control
                    ;
                    cy += cy - bezierY // point relative to the current point
                    ;
                }
                seg = [
                    'C',
                    cx,
                    cy,
                    seg[1],
                    seg[2],
                    seg[3],
                    seg[4]
                ];
                break;
            case 'T':
                if (prev == 'Q' || prev == 'T') {
                    quadX = x * 2 - quadX // as with 'S' reflect previous control point
                    ;
                    quadY = y * 2 - quadY;
                } else {
                    quadX = x;
                    quadY = y;
                }
                seg = $fb871d86c9e9e6d4$var$quadratic(x, y, quadX, quadY, seg[1], seg[2]);
                break;
            case 'Q':
                quadX = seg[1];
                quadY = seg[2];
                seg = $fb871d86c9e9e6d4$var$quadratic(x, y, seg[1], seg[2], seg[3], seg[4]);
                break;
            case 'L':
                seg = $fb871d86c9e9e6d4$var$line(x, y, seg[1], seg[2]);
                break;
            case 'H':
                seg = $fb871d86c9e9e6d4$var$line(x, y, seg[1], y);
                break;
            case 'V':
                seg = $fb871d86c9e9e6d4$var$line(x, y, x, seg[1]);
                break;
            case 'Z':
                seg = $fb871d86c9e9e6d4$var$line(x, y, startX, startY);
                break;
        }
        // update state
        prev = command;
        x = seg[seg.length - 2];
        y = seg[seg.length - 1];
        if (seg.length > 4) {
            bezierX = seg[seg.length - 4];
            bezierY = seg[seg.length - 3];
        } else {
            bezierX = x;
            bezierY = y;
        }
        result.push(seg);
    }
    return result;
}
function $fb871d86c9e9e6d4$var$line(x1, y1, x2, y2) {
    return [
        'C',
        x1,
        y1,
        x2,
        y2,
        x2,
        y2
    ];
}
function $fb871d86c9e9e6d4$var$quadratic(x1, y1, cx, cy, x2, y2) {
    return [
        'C',
        x1 / 3 + 2 / 3 * cx,
        y1 / 3 + 2 / 3 * cy,
        x2 / 3 + 2 / 3 * cx,
        y2 / 3 + 2 / 3 * cy,
        x2,
        y2
    ];
}

});
parcelRegister("3CTXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a4053c651a1d856$export$2e2bcd8739ae039);
var $2a4053c651a1d856$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $2a4053c651a1d856$var$TAU = Math.PI * 2;
var $2a4053c651a1d856$var$mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
    var x = _ref.x, y = _ref.y;
    x *= rx;
    y *= ry;
    var xp = cosphi * x - sinphi * y;
    var yp = sinphi * x + cosphi * y;
    return {
        x: xp + centerx,
        y: yp + centery
    };
};
var $2a4053c651a1d856$var$approxUnitArc = function approxUnitArc(ang1, ang2) {
    // If 90 degree circular arc, use a constant
    // as derived from http://spencermortensen.com/articles/bezier-circle
    var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
    var x1 = Math.cos(ang1);
    var y1 = Math.sin(ang1);
    var x2 = Math.cos(ang1 + ang2);
    var y2 = Math.sin(ang1 + ang2);
    return [
        {
            x: x1 - y1 * a,
            y: y1 + x1 * a
        },
        {
            x: x2 + y2 * a,
            y: y2 - x2 * a
        },
        {
            x: x2,
            y: y2
        }
    ];
};
var $2a4053c651a1d856$var$vectorAngle = function vectorAngle(ux, uy, vx, vy) {
    var sign = ux * vy - uy * vx < 0 ? -1 : 1;
    var dot = ux * vx + uy * vy;
    if (dot > 1) dot = 1;
    if (dot < -1) dot = -1;
    return sign * Math.acos(dot);
};
var $2a4053c651a1d856$var$getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
    var rxsq = Math.pow(rx, 2);
    var rysq = Math.pow(ry, 2);
    var pxpsq = Math.pow(pxp, 2);
    var pypsq = Math.pow(pyp, 2);
    var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
    if (radicant < 0) radicant = 0;
    radicant /= rxsq * pypsq + rysq * pxpsq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
    var centerxp = radicant * rx / ry * pyp;
    var centeryp = radicant * -ry / rx * pxp;
    var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
    var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
    var vx1 = (pxp - centerxp) / rx;
    var vy1 = (pyp - centeryp) / ry;
    var vx2 = (-pxp - centerxp) / rx;
    var vy2 = (-pyp - centeryp) / ry;
    var ang1 = $2a4053c651a1d856$var$vectorAngle(1, 0, vx1, vy1);
    var ang2 = $2a4053c651a1d856$var$vectorAngle(vx1, vy1, vx2, vy2);
    if (sweepFlag === 0 && ang2 > 0) ang2 -= $2a4053c651a1d856$var$TAU;
    if (sweepFlag === 1 && ang2 < 0) ang2 += $2a4053c651a1d856$var$TAU;
    return [
        centerx,
        centery,
        ang1,
        ang2
    ];
};
var $2a4053c651a1d856$var$arcToBezier = function arcToBezier(_ref2) {
    var px = _ref2.px, py = _ref2.py, cx = _ref2.cx, cy = _ref2.cy, rx = _ref2.rx, ry = _ref2.ry, _ref2$xAxisRotation = _ref2.xAxisRotation, xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation, _ref2$largeArcFlag = _ref2.largeArcFlag, largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag, _ref2$sweepFlag = _ref2.sweepFlag, sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
    var curves = [];
    if (rx === 0 || ry === 0) return [];
    var sinphi = Math.sin(xAxisRotation * $2a4053c651a1d856$var$TAU / 360);
    var cosphi = Math.cos(xAxisRotation * $2a4053c651a1d856$var$TAU / 360);
    var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
    var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
    if (pxp === 0 && pyp === 0) return [];
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    var _getArcCenter = $2a4053c651a1d856$var$getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp), _getArcCenter2 = $2a4053c651a1d856$var$_slicedToArray(_getArcCenter, 4), centerx = _getArcCenter2[0], centery = _getArcCenter2[1], ang1 = _getArcCenter2[2], ang2 = _getArcCenter2[3];
    // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
    // 1.0000000001. This causes `segments` to be greater than one, which is an
    // unecessary split, and adds extra points to the bezier curve. To alleviate
    // this issue, we round to 1.0 when the ratio is close to 1.0.
    var ratio = Math.abs(ang2) / ($2a4053c651a1d856$var$TAU / 4);
    if (Math.abs(1.0 - ratio) < 0.0000001) ratio = 1.0;
    var segments = Math.max(Math.ceil(ratio), 1);
    ang2 /= segments;
    for(var i = 0; i < segments; i++){
        curves.push($2a4053c651a1d856$var$approxUnitArc(ang1, ang2));
        ang1 += ang2;
    }
    return curves.map(function(curve) {
        var _mapToEllipse = $2a4053c651a1d856$var$mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery), x1 = _mapToEllipse.x, y1 = _mapToEllipse.y;
        var _mapToEllipse2 = $2a4053c651a1d856$var$mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery), x2 = _mapToEllipse2.x, y2 = _mapToEllipse2.y;
        var _mapToEllipse3 = $2a4053c651a1d856$var$mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery), x = _mapToEllipse3.x, y = _mapToEllipse3.y;
        return {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            x: x,
            y: y
        };
    });
};
var $2a4053c651a1d856$export$2e2bcd8739ae039 = $2a4053c651a1d856$var$arcToBezier;

});


parcelRegister("gQ3ba", function(module, exports) {

$parcel$export(module.exports, "sort", () => $c423f7f760b82db7$export$97db5808d8f88186, (v) => $c423f7f760b82db7$export$97db5808d8f88186 = v);
$parcel$export(module.exports, "merge", () => $c423f7f760b82db7$export$4950aa0f605343fb, (v) => $c423f7f760b82db7$export$4950aa0f605343fb = v);
// I believe this was originally written by Taylor Baldwin (@taylorbaldwin / @rolyatmax)
// If that is miscredited please open an issue.
var $c423f7f760b82db7$export$97db5808d8f88186;
var $c423f7f760b82db7$export$4950aa0f605343fb;

var $41Xth = parcelRequire("41Xth");

var $jr2uV = parcelRequire("jr2uV");
var $c423f7f760b82db7$require$squaredDistance = $jr2uV.squaredDistance;
$c423f7f760b82db7$export$97db5808d8f88186 = function sort(paths) {
    paths = $41Xth(paths);
    if (!paths.length) return paths;
    var newPaths = [];
    newPaths.push(paths[0]);
    paths = paths.slice(1);
    while(paths.length){
        var lastPath = newPaths[newPaths.length - 1];
        var curPt = lastPath[lastPath.length - 1];
        var result = paths.reduce(function(closest, path, i) {
            var firstPt = path[0];
            var lastPt = path[path.length - 1];
            var distanceToFirst = $c423f7f760b82db7$require$squaredDistance(curPt, firstPt);
            var distanceToLast = $c423f7f760b82db7$require$squaredDistance(curPt, lastPt);
            if (!closest) return {
                idx: i,
                distance: Math.min(distanceToFirst, distanceToLast),
                reverse: distanceToLast < distanceToFirst
            };
            if (distanceToFirst < closest.distance) return {
                idx: i,
                distance: distanceToFirst,
                reverse: false
            };
            if (distanceToLast < closest.distance) return {
                idx: i,
                distance: distanceToLast,
                reverse: true
            };
            return closest;
        }, null);
        var idx = result.idx;
        var reverse = result.reverse;
        var closestPath = paths.splice(idx, 1)[0].slice();
        if (reverse) closestPath.reverse();
        newPaths.push(closestPath);
    }
    return newPaths;
};
$c423f7f760b82db7$export$4950aa0f605343fb = function merge(paths, mergeThrehsold) {
    mergeThrehsold = mergeThrehsold != null ? mergeThrehsold : 0.05;
    var mergeThrehsoldSq = mergeThrehsold * mergeThrehsold;
    paths = $41Xth(paths);
    for(var i = 1; i < paths.length; i++){
        var lastPath = paths[i - 1];
        var curPath = paths[i];
        if ($c423f7f760b82db7$require$squaredDistance(curPath[0], lastPath[lastPath.length - 1]) < mergeThrehsoldSq) {
            paths = $c423f7f760b82db7$var$mergePaths(paths, i - 1, i);
            i -= 1; // now that we've merged, var's correct i for the next round
        }
    }
    return paths;
};
function $c423f7f760b82db7$var$mergePaths(paths, path1Idx, path2Idx) {
    // this will help us keep things in order when we do the splicing
    var minIdx = Math.min(path1Idx, path2Idx);
    var maxIdx = Math.max(path1Idx, path2Idx);
    paths = paths.slice();
    var path1 = paths[minIdx];
    var path2 = paths[maxIdx];
    var mergedPath = path1.concat(path2.slice(1));
    paths.splice(maxIdx, 1);
    paths.splice(minIdx, 1, mergedPath);
    return paths;
} // this is the distance between paths - from the end of path 1 to the start of path 2
 // function getTravelingDistance (paths) {
 //   var total = 0;
 //   var lastPt = paths[0][paths[0].length - 1];
 //   for (var path of paths.slice(1)) {
 //     var squaredDist = squaredDistance(lastPt, path[0]);
 //     total += Math.sqrt(squaredDist);
 //     lastPt = path[path.length - 1];
 //   }
 //   return total;
 // }

});
parcelRegister("41Xth", function(module, exports) {

var $jf8P8 = parcelRequire("jf8P8");
var $2ef5632c11798cb7$require$Buffer = $jf8P8.Buffer;
var $2ef5632c11798cb7$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $2ef5632c11798cb7$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $2ef5632c11798cb7$require$Buffer.isBuffer(parent)) {
                if ($2ef5632c11798cb7$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $2ef5632c11798cb7$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $2ef5632c11798cb7$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (module.exports) module.exports = $2ef5632c11798cb7$var$clone;

});
parcelRegister("jf8P8", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $e026433afc3009c6$export$a143d493d941bafc, (v) => $e026433afc3009c6$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $e026433afc3009c6$export$f99ded8fe4b79145, (v) => $e026433afc3009c6$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e026433afc3009c6$export$a143d493d941bafc;
var $e026433afc3009c6$export$e4cf37d7f6fb9e0a;
var $e026433afc3009c6$export$f99ded8fe4b79145;
var $e026433afc3009c6$export$599f31c3813fae4d;
'use strict';

var $fsOOI = parcelRequire("fsOOI");

var $ewK1f = parcelRequire("ewK1f");
const $e026433afc3009c6$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$e026433afc3009c6$export$a143d493d941bafc = $e026433afc3009c6$var$Buffer;
$e026433afc3009c6$export$e4cf37d7f6fb9e0a = $e026433afc3009c6$var$SlowBuffer;
$e026433afc3009c6$export$f99ded8fe4b79145 = 50;
const $e026433afc3009c6$var$K_MAX_LENGTH = 0x7fffffff;
$e026433afc3009c6$export$599f31c3813fae4d = $e026433afc3009c6$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e026433afc3009c6$var$Buffer.TYPED_ARRAY_SUPPORT = $e026433afc3009c6$var$typedArraySupport();
if (!$e026433afc3009c6$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e026433afc3009c6$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e026433afc3009c6$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$e026433afc3009c6$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e026433afc3009c6$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$e026433afc3009c6$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e026433afc3009c6$var$createBuffer(length) {
    if (length > $e026433afc3009c6$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e026433afc3009c6$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e026433afc3009c6$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e026433afc3009c6$var$allocUnsafe(arg);
    }
    return $e026433afc3009c6$var$from(arg, encodingOrOffset, length);
}
$e026433afc3009c6$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e026433afc3009c6$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $e026433afc3009c6$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e026433afc3009c6$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e026433afc3009c6$var$isInstance(value, ArrayBuffer) || value && $e026433afc3009c6$var$isInstance(value.buffer, ArrayBuffer)) return $e026433afc3009c6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($e026433afc3009c6$var$isInstance(value, SharedArrayBuffer) || value && $e026433afc3009c6$var$isInstance(value.buffer, SharedArrayBuffer))) return $e026433afc3009c6$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e026433afc3009c6$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e026433afc3009c6$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $e026433afc3009c6$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e026433afc3009c6$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e026433afc3009c6$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e026433afc3009c6$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e026433afc3009c6$var$Buffer, Uint8Array);
function $e026433afc3009c6$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e026433afc3009c6$var$alloc(size, fill, encoding) {
    $e026433afc3009c6$var$assertSize(size);
    if (size <= 0) return $e026433afc3009c6$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $e026433afc3009c6$var$createBuffer(size).fill(fill, encoding) : $e026433afc3009c6$var$createBuffer(size).fill(fill);
    return $e026433afc3009c6$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e026433afc3009c6$var$Buffer.alloc = function(size, fill, encoding) {
    return $e026433afc3009c6$var$alloc(size, fill, encoding);
};
function $e026433afc3009c6$var$allocUnsafe(size) {
    $e026433afc3009c6$var$assertSize(size);
    return $e026433afc3009c6$var$createBuffer(size < 0 ? 0 : $e026433afc3009c6$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e026433afc3009c6$var$Buffer.allocUnsafe = function(size) {
    return $e026433afc3009c6$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e026433afc3009c6$var$Buffer.allocUnsafeSlow = function(size) {
    return $e026433afc3009c6$var$allocUnsafe(size);
};
function $e026433afc3009c6$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$e026433afc3009c6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $e026433afc3009c6$var$byteLength(string, encoding) | 0;
    let buf = $e026433afc3009c6$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e026433afc3009c6$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e026433afc3009c6$var$checked(array.length) | 0;
    const buf = $e026433afc3009c6$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e026433afc3009c6$var$fromArrayView(arrayView) {
    if ($e026433afc3009c6$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e026433afc3009c6$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e026433afc3009c6$var$fromArrayLike(arrayView);
}
function $e026433afc3009c6$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e026433afc3009c6$var$Buffer.prototype);
    return buf;
}
function $e026433afc3009c6$var$fromObject(obj) {
    if ($e026433afc3009c6$var$Buffer.isBuffer(obj)) {
        const len = $e026433afc3009c6$var$checked(obj.length) | 0;
        const buf = $e026433afc3009c6$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $e026433afc3009c6$var$numberIsNaN(obj.length)) return $e026433afc3009c6$var$createBuffer(0);
        return $e026433afc3009c6$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $e026433afc3009c6$var$fromArrayLike(obj.data);
}
function $e026433afc3009c6$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e026433afc3009c6$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e026433afc3009c6$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $e026433afc3009c6$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e026433afc3009c6$var$Buffer.alloc(+length);
}
$e026433afc3009c6$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e026433afc3009c6$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e026433afc3009c6$var$Buffer.compare = function compare(a, b) {
    if ($e026433afc3009c6$var$isInstance(a, Uint8Array)) a = $e026433afc3009c6$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e026433afc3009c6$var$isInstance(b, Uint8Array)) b = $e026433afc3009c6$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e026433afc3009c6$var$Buffer.isBuffer(a) || !$e026433afc3009c6$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e026433afc3009c6$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$e026433afc3009c6$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e026433afc3009c6$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e026433afc3009c6$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e026433afc3009c6$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e026433afc3009c6$var$Buffer.isBuffer(buf)) buf = $e026433afc3009c6$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e026433afc3009c6$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e026433afc3009c6$var$byteLength(string, encoding) {
    if ($e026433afc3009c6$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e026433afc3009c6$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $e026433afc3009c6$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $e026433afc3009c6$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e026433afc3009c6$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e026433afc3009c6$var$Buffer.byteLength = $e026433afc3009c6$var$byteLength;
function $e026433afc3009c6$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $e026433afc3009c6$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $e026433afc3009c6$var$utf8Slice(this, start, end);
        case 'ascii':
            return $e026433afc3009c6$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $e026433afc3009c6$var$latin1Slice(this, start, end);
        case 'base64':
            return $e026433afc3009c6$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e026433afc3009c6$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e026433afc3009c6$var$Buffer.prototype._isBuffer = true;
function $e026433afc3009c6$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e026433afc3009c6$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$e026433afc3009c6$var$swap(this, i, i + 1);
    return this;
};
$e026433afc3009c6$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $e026433afc3009c6$var$swap(this, i, i + 3);
        $e026433afc3009c6$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e026433afc3009c6$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $e026433afc3009c6$var$swap(this, i, i + 7);
        $e026433afc3009c6$var$swap(this, i + 1, i + 6);
        $e026433afc3009c6$var$swap(this, i + 2, i + 5);
        $e026433afc3009c6$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e026433afc3009c6$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $e026433afc3009c6$var$utf8Slice(this, 0, length);
    return $e026433afc3009c6$var$slowToString.apply(this, arguments);
};
$e026433afc3009c6$var$Buffer.prototype.toLocaleString = $e026433afc3009c6$var$Buffer.prototype.toString;
$e026433afc3009c6$var$Buffer.prototype.equals = function equals(b) {
    if (!$e026433afc3009c6$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $e026433afc3009c6$var$Buffer.compare(this, b) === 0;
};
$e026433afc3009c6$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $e026433afc3009c6$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($e026433afc3009c6$var$customInspectSymbol) $e026433afc3009c6$var$Buffer.prototype[$e026433afc3009c6$var$customInspectSymbol] = $e026433afc3009c6$var$Buffer.prototype.inspect;
$e026433afc3009c6$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e026433afc3009c6$var$isInstance(target, Uint8Array)) target = $e026433afc3009c6$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e026433afc3009c6$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e026433afc3009c6$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e026433afc3009c6$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $e026433afc3009c6$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e026433afc3009c6$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e026433afc3009c6$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e026433afc3009c6$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $e026433afc3009c6$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e026433afc3009c6$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e026433afc3009c6$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e026433afc3009c6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e026433afc3009c6$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e026433afc3009c6$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e026433afc3009c6$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e026433afc3009c6$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e026433afc3009c6$var$utf8Write(buf, string, offset, length) {
    return $e026433afc3009c6$var$blitBuffer($e026433afc3009c6$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e026433afc3009c6$var$asciiWrite(buf, string, offset, length) {
    return $e026433afc3009c6$var$blitBuffer($e026433afc3009c6$var$asciiToBytes(string), buf, offset, length);
}
function $e026433afc3009c6$var$base64Write(buf, string, offset, length) {
    return $e026433afc3009c6$var$blitBuffer($e026433afc3009c6$var$base64ToBytes(string), buf, offset, length);
}
function $e026433afc3009c6$var$ucs2Write(buf, string, offset, length) {
    return $e026433afc3009c6$var$blitBuffer($e026433afc3009c6$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e026433afc3009c6$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $e026433afc3009c6$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $e026433afc3009c6$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $e026433afc3009c6$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $e026433afc3009c6$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $e026433afc3009c6$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e026433afc3009c6$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e026433afc3009c6$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $fsOOI.fromByteArray(buf);
    else return $fsOOI.fromByteArray(buf.slice(start, end));
}
function $e026433afc3009c6$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e026433afc3009c6$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e026433afc3009c6$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e026433afc3009c6$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e026433afc3009c6$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e026433afc3009c6$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e026433afc3009c6$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e026433afc3009c6$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e026433afc3009c6$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $e026433afc3009c6$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e026433afc3009c6$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e026433afc3009c6$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e026433afc3009c6$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e026433afc3009c6$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$e026433afc3009c6$var$Buffer.prototype.readUintLE = $e026433afc3009c6$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e026433afc3009c6$var$Buffer.prototype.readUintBE = $e026433afc3009c6$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e026433afc3009c6$var$Buffer.prototype.readUint8 = $e026433afc3009c6$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e026433afc3009c6$var$Buffer.prototype.readUint16LE = $e026433afc3009c6$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e026433afc3009c6$var$Buffer.prototype.readUint16BE = $e026433afc3009c6$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e026433afc3009c6$var$Buffer.prototype.readUint32LE = $e026433afc3009c6$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e026433afc3009c6$var$Buffer.prototype.readUint32BE = $e026433afc3009c6$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e026433afc3009c6$var$Buffer.prototype.readBigUInt64LE = $e026433afc3009c6$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e026433afc3009c6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e026433afc3009c6$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e026433afc3009c6$var$Buffer.prototype.readBigUInt64BE = $e026433afc3009c6$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e026433afc3009c6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e026433afc3009c6$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e026433afc3009c6$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e026433afc3009c6$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e026433afc3009c6$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e026433afc3009c6$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e026433afc3009c6$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e026433afc3009c6$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e026433afc3009c6$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e026433afc3009c6$var$Buffer.prototype.readBigInt64LE = $e026433afc3009c6$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e026433afc3009c6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e026433afc3009c6$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e026433afc3009c6$var$Buffer.prototype.readBigInt64BE = $e026433afc3009c6$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e026433afc3009c6$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e026433afc3009c6$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e026433afc3009c6$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 4, this.length);
    return $ewK1f.read(this, offset, true, 23, 4);
};
$e026433afc3009c6$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 4, this.length);
    return $ewK1f.read(this, offset, false, 23, 4);
};
$e026433afc3009c6$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 8, this.length);
    return $ewK1f.read(this, offset, true, 52, 8);
};
$e026433afc3009c6$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkOffset(offset, 8, this.length);
    return $ewK1f.read(this, offset, false, 52, 8);
};
function $e026433afc3009c6$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e026433afc3009c6$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$e026433afc3009c6$var$Buffer.prototype.writeUintLE = $e026433afc3009c6$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e026433afc3009c6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e026433afc3009c6$var$Buffer.prototype.writeUintBE = $e026433afc3009c6$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e026433afc3009c6$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e026433afc3009c6$var$Buffer.prototype.writeUint8 = $e026433afc3009c6$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e026433afc3009c6$var$Buffer.prototype.writeUint16LE = $e026433afc3009c6$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e026433afc3009c6$var$Buffer.prototype.writeUint16BE = $e026433afc3009c6$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e026433afc3009c6$var$Buffer.prototype.writeUint32LE = $e026433afc3009c6$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e026433afc3009c6$var$Buffer.prototype.writeUint32BE = $e026433afc3009c6$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e026433afc3009c6$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e026433afc3009c6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e026433afc3009c6$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e026433afc3009c6$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e026433afc3009c6$var$Buffer.prototype.writeBigUInt64LE = $e026433afc3009c6$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e026433afc3009c6$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e026433afc3009c6$var$Buffer.prototype.writeBigUInt64BE = $e026433afc3009c6$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e026433afc3009c6$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$e026433afc3009c6$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e026433afc3009c6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e026433afc3009c6$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e026433afc3009c6$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e026433afc3009c6$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e026433afc3009c6$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e026433afc3009c6$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e026433afc3009c6$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e026433afc3009c6$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e026433afc3009c6$var$Buffer.prototype.writeBigInt64LE = $e026433afc3009c6$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e026433afc3009c6$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$e026433afc3009c6$var$Buffer.prototype.writeBigInt64BE = $e026433afc3009c6$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e026433afc3009c6$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $e026433afc3009c6$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $e026433afc3009c6$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ewK1f.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e026433afc3009c6$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e026433afc3009c6$var$writeFloat(this, value, offset, true, noAssert);
};
$e026433afc3009c6$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e026433afc3009c6$var$writeFloat(this, value, offset, false, noAssert);
};
function $e026433afc3009c6$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e026433afc3009c6$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ewK1f.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e026433afc3009c6$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e026433afc3009c6$var$writeDouble(this, value, offset, true, noAssert);
};
$e026433afc3009c6$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e026433afc3009c6$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e026433afc3009c6$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e026433afc3009c6$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e026433afc3009c6$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$e026433afc3009c6$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e026433afc3009c6$var$Buffer.isBuffer(val) ? val : $e026433afc3009c6$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e026433afc3009c6$var$errors = {};
function $e026433afc3009c6$var$E(sym, getMessage, Base) {
    $e026433afc3009c6$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$e026433afc3009c6$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$e026433afc3009c6$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e026433afc3009c6$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e026433afc3009c6$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e026433afc3009c6$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e026433afc3009c6$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e026433afc3009c6$var$checkBounds(buf, offset, byteLength) {
    $e026433afc3009c6$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e026433afc3009c6$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e026433afc3009c6$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e026433afc3009c6$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $e026433afc3009c6$var$checkBounds(buf, offset, byteLength);
}
function $e026433afc3009c6$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $e026433afc3009c6$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $e026433afc3009c6$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e026433afc3009c6$var$validateNumber(value, type);
        throw new $e026433afc3009c6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $e026433afc3009c6$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e026433afc3009c6$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e026433afc3009c6$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e026433afc3009c6$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e026433afc3009c6$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $e026433afc3009c6$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $e026433afc3009c6$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e026433afc3009c6$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e026433afc3009c6$var$base64ToBytes(str) {
    return $fsOOI.toByteArray($e026433afc3009c6$var$base64clean(str));
}
function $e026433afc3009c6$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e026433afc3009c6$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e026433afc3009c6$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e026433afc3009c6$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e026433afc3009c6$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $e026433afc3009c6$var$BufferBigIntNotDefined : fn;
}
function $e026433afc3009c6$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("fsOOI", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $b420e3c3027bbec9$export$d622b2ad8d90c771, (v) => $b420e3c3027bbec9$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $b420e3c3027bbec9$export$6100ba28696e12de, (v) => $b420e3c3027bbec9$export$6100ba28696e12de = v);
var $b420e3c3027bbec9$export$a48f0734ac7c2329;
var $b420e3c3027bbec9$export$d622b2ad8d90c771;
var $b420e3c3027bbec9$export$6100ba28696e12de;
'use strict';
$b420e3c3027bbec9$export$a48f0734ac7c2329 = $b420e3c3027bbec9$var$byteLength;
$b420e3c3027bbec9$export$d622b2ad8d90c771 = $b420e3c3027bbec9$var$toByteArray;
$b420e3c3027bbec9$export$6100ba28696e12de = $b420e3c3027bbec9$var$fromByteArray;
var $b420e3c3027bbec9$var$lookup = [];
var $b420e3c3027bbec9$var$revLookup = [];
var $b420e3c3027bbec9$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $b420e3c3027bbec9$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $b420e3c3027bbec9$var$i = 0, $b420e3c3027bbec9$var$len = $b420e3c3027bbec9$var$code.length; $b420e3c3027bbec9$var$i < $b420e3c3027bbec9$var$len; ++$b420e3c3027bbec9$var$i){
    $b420e3c3027bbec9$var$lookup[$b420e3c3027bbec9$var$i] = $b420e3c3027bbec9$var$code[$b420e3c3027bbec9$var$i];
    $b420e3c3027bbec9$var$revLookup[$b420e3c3027bbec9$var$code.charCodeAt($b420e3c3027bbec9$var$i)] = $b420e3c3027bbec9$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$b420e3c3027bbec9$var$revLookup['-'.charCodeAt(0)] = 62;
$b420e3c3027bbec9$var$revLookup['_'.charCodeAt(0)] = 63;
function $b420e3c3027bbec9$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $b420e3c3027bbec9$var$byteLength(b64) {
    var lens = $b420e3c3027bbec9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b420e3c3027bbec9$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $b420e3c3027bbec9$var$toByteArray(b64) {
    var tmp;
    var lens = $b420e3c3027bbec9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $b420e3c3027bbec9$var$Arr($b420e3c3027bbec9$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i)] << 18 | $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i)] << 2 | $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i)] << 10 | $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $b420e3c3027bbec9$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $b420e3c3027bbec9$var$tripletToBase64(num) {
    return $b420e3c3027bbec9$var$lookup[num >> 18 & 0x3F] + $b420e3c3027bbec9$var$lookup[num >> 12 & 0x3F] + $b420e3c3027bbec9$var$lookup[num >> 6 & 0x3F] + $b420e3c3027bbec9$var$lookup[num & 0x3F];
}
function $b420e3c3027bbec9$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($b420e3c3027bbec9$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $b420e3c3027bbec9$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($b420e3c3027bbec9$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($b420e3c3027bbec9$var$lookup[tmp >> 2] + $b420e3c3027bbec9$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($b420e3c3027bbec9$var$lookup[tmp >> 10] + $b420e3c3027bbec9$var$lookup[tmp >> 4 & 0x3F] + $b420e3c3027bbec9$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("ewK1f", function(module, exports) {

$parcel$export(module.exports, "read", () => $a937c04c85c9ffe4$export$aafa59e2e03f2942, (v) => $a937c04c85c9ffe4$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $a937c04c85c9ffe4$export$68d8715fc104d294, (v) => $a937c04c85c9ffe4$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a937c04c85c9ffe4$export$aafa59e2e03f2942;
var $a937c04c85c9ffe4$export$68d8715fc104d294;
$a937c04c85c9ffe4$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a937c04c85c9ffe4$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("jr2uV", function(module, exports) {

$parcel$export(module.exports, "squaredDistance", () => $e26279f184585566$export$88e6ebb4fe54f538, (v) => $e26279f184585566$export$88e6ebb4fe54f538 = v);
var $e26279f184585566$export$88e6ebb4fe54f538;
$e26279f184585566$export$88e6ebb4fe54f538 = $e26279f184585566$var$squaredDistance;
function $e26279f184585566$var$squaredDistance(pt1, pt2) {
    var dx = pt2[0] - pt1[0];
    var dy = pt2[1] - pt1[1];
    return dx * dx + dy * dy;
}

});


parcelRegister("gBee2", function(module, exports) {

$parcel$export(module.exports, "arePointsCollinear", () => $c15b22e4f9f836d2$export$fb1611baa9f955ae, (v) => $c15b22e4f9f836d2$export$fb1611baa9f955ae = v);
$parcel$export(module.exports, "removeDuplicatePoints", () => $c15b22e4f9f836d2$export$540ba8abf0b63e5d, (v) => $c15b22e4f9f836d2$export$540ba8abf0b63e5d = v);
$parcel$export(module.exports, "removeCollinearPoints", () => $c15b22e4f9f836d2$export$ba94a6b7ae09119a, (v) => $c15b22e4f9f836d2$export$ba94a6b7ae09119a = v);
$parcel$export(module.exports, "clipSegmentToCircle", () => $c15b22e4f9f836d2$export$a0313ff21b57576a, (v) => $c15b22e4f9f836d2$export$a0313ff21b57576a = v);
$parcel$export(module.exports, "clipLineToCircle", () => $c15b22e4f9f836d2$export$7d4dca234a56e354, (v) => $c15b22e4f9f836d2$export$7d4dca234a56e354 = v);
$parcel$export(module.exports, "clipPolylinesToBox", () => $c15b22e4f9f836d2$export$adffab73bfea9c4, (v) => $c15b22e4f9f836d2$export$adffab73bfea9c4 = v);
$parcel$export(module.exports, "createHatchLines", () => $c15b22e4f9f836d2$export$537b2153b0480e1e, (v) => $c15b22e4f9f836d2$export$537b2153b0480e1e = v);
$parcel$export(module.exports, "getBounds", () => $c15b22e4f9f836d2$export$becd1e645219fa23, (v) => $c15b22e4f9f836d2$export$becd1e645219fa23 = v);
var $c15b22e4f9f836d2$export$fb1611baa9f955ae;
var $c15b22e4f9f836d2$export$540ba8abf0b63e5d;
var $c15b22e4f9f836d2$export$ba94a6b7ae09119a;
var $c15b22e4f9f836d2$export$a0313ff21b57576a;
var $c15b22e4f9f836d2$export$7d4dca234a56e354;
var $c15b22e4f9f836d2$export$adffab73bfea9c4;
var $c15b22e4f9f836d2$export$537b2153b0480e1e;
var $c15b22e4f9f836d2$export$becd1e645219fa23;

var $azl9V = parcelRequire("azl9V");

var $8lreT = parcelRequire("8lreT");

var $3Dutx = parcelRequire("3Dutx");

var $41Xth = parcelRequire("41Xth");

var $jr2uV = parcelRequire("jr2uV");
var $c15b22e4f9f836d2$require$squaredDistance = $jr2uV.squaredDistance;
$c15b22e4f9f836d2$export$fb1611baa9f955ae = function(point0, point1, point2) {
    var x0 = point0[0];
    var y0 = point0[1];
    var x1 = point1[0];
    var y1 = point1[1];
    var x2 = point2[0];
    var y2 = point2[1];
    return $8lreT((y0 - y1) * (x0 - x2), (y0 - y2) * (x0 - x1));
};
$c15b22e4f9f836d2$export$540ba8abf0b63e5d = function(path) {
    var newPath = [];
    var lastPoint;
    for(var i = 0; i < path.length; i++){
        var curPoint = path[i];
        if (!lastPoint || !$3Dutx(lastPoint, curPoint)) {
            newPath.push(curPoint);
            lastPoint = curPoint;
        }
    }
    return $41Xth(newPath);
};
$c15b22e4f9f836d2$export$ba94a6b7ae09119a = function(path) {
    var newPath = [];
    var remainingPoints = $41Xth(path);
    while(remainingPoints.length >= 3){
        var p0 = remainingPoints[0];
        var p1 = remainingPoints[1];
        var p2 = remainingPoints[2];
        var collinear = $c15b22e4f9f836d2$export$fb1611baa9f955ae(p0, p1, p2);
        // one more check is to ensure that points are in a line:
        // A->B->C
        // not A->C->B or some variant
        if (collinear) {
            var distAB = $c15b22e4f9f836d2$require$squaredDistance(p0, p1);
            var distAC = $c15b22e4f9f836d2$require$squaredDistance(p0, p2);
            if (distAB > distAC) collinear = false;
        }
        if (collinear) // the first 3 points are collinear
        // remove the second point as it isn't needed
        remainingPoints.splice(1, 1);
        else // the 3 points are not collinear
        // add the first one as the others may still be collinear
        for(var i = 0; i < 1; i++)newPath.push(remainingPoints.shift());
    }
    // add any remaining points
    while(remainingPoints.length)newPath.push(remainingPoints.shift());
    return newPath;
};

$c15b22e4f9f836d2$export$a0313ff21b57576a = (parcelRequire("kEoec"));

$c15b22e4f9f836d2$export$7d4dca234a56e354 = (parcelRequire("4NxUC"));
$c15b22e4f9f836d2$export$adffab73bfea9c4 = function(polylines, bbox, border, closeLines) {
    if (!Array.isArray(bbox) || bbox.length !== 2 && bbox.length !== 4) throw new Error('Expected box to either be format [ minPoint, maxPoint ] or [ minX, minY, maxX, maxY ]');
    // Expand nested format to flat bounds
    if (bbox.length === 2) {
        var min = bbox[0];
        var max = bbox[1];
        bbox = [
            min[0],
            min[1],
            max[0],
            max[1]
        ];
    }
    closeLines = closeLines !== false;
    border = Boolean(border);
    if (border) return polylines.map(function(line) {
        var result = $azl9V.polygon(line, bbox);
        if (closeLines && result.length > 2) result.push(result[0]);
        return result;
    }).filter(function(lines) {
        return lines.length > 0;
    });
    else return polylines.map(function(line) {
        return $azl9V.polyline(line, bbox);
    }).reduce(function(a, b) {
        return a.concat(b);
    }, []);
};
$c15b22e4f9f836d2$export$537b2153b0480e1e = $c15b22e4f9f836d2$var$createHatchLines;
function $c15b22e4f9f836d2$var$createHatchLines(bounds, angle, spacing, out) {
    if (!Array.isArray(bounds) || bounds.length !== 2 && bounds.length !== 4) throw new Error('Expected box to either be format [ minPoint, maxPoint ] or [ minX, minY, maxX, maxY ]');
    // Expand nested format to flat bounds
    if (bounds.length === 2) {
        var min = bounds[0];
        var max = bounds[1];
        bounds = [
            min[0],
            min[1],
            max[0],
            max[1]
        ];
    }
    if (angle == null) angle = -Math.PI / 4;
    if (spacing == null) spacing = 0.5;
    if (out == null) out = [];
    // Reference:
    // https://github.com/evil-mad/EggBot/blob/master/inkscape_driver/eggbot_hatch.py
    spacing = Math.abs(spacing);
    if (spacing === 0) throw new Error('cannot use a spacing of zero as it will run an infinite loop!');
    var xmin = bounds[0];
    var ymin = bounds[1];
    var xmax = bounds[2];
    var ymax = bounds[3];
    var w = xmax - xmin;
    var h = ymax - ymin;
    if (w === 0 || h === 0) return out;
    var r = Math.sqrt(w * w + h * h) / 2;
    var rotAngle = Math.PI / 2 - angle;
    var ca = Math.cos(rotAngle);
    var sa = Math.sin(rotAngle);
    var cx = xmin + w / 2;
    var cy = ymin + h / 2;
    var i = -r;
    while(i <= r){
        // Line starts at (i, -r) and goes to (i, +r)
        var x1 = cx + i * ca + r * sa; //  i * ca - (-r) * sa
        var y1 = cy + i * sa - r * ca; //  i * sa + (-r) * ca
        var x2 = cx + i * ca - r * sa; //  i * ca - (+r) * sa
        var y2 = cy + i * sa + r * ca; //  i * sa + (+r) * ca
        i += spacing;
        // Remove any potential hatch lines which are entirely
        // outside of the bounding box
        if (x1 < xmin && x2 < xmin || x1 > xmax && x2 > xmax) continue;
        if (y1 < ymin && y2 < ymin || y1 > ymax && y2 > ymax) continue;
        out.push([
            [
                x1,
                y1
            ],
            [
                x2,
                y2
            ]
        ]);
    }
    return out;
}
$c15b22e4f9f836d2$export$becd1e645219fa23 = function getBounds(points) {
    var n = points.length;
    if (n === 0) throw new Error('Expected points to be a non-empty array');
    var d = points[0].length;
    var lo = points[0].slice();
    var hi = points[0].slice();
    for(var i = 1; i < n; ++i){
        var p = points[i];
        for(var j = 0; j < d; ++j){
            var x = p[j];
            lo[j] = Math.min(lo[j], x);
            hi[j] = Math.max(hi[j], x);
        }
    }
    return [
        lo,
        hi
    ];
};

});
parcelRegister("azl9V", function(module, exports) {
'use strict';
module.exports = $7b1d9606941cae25$var$lineclip;
$7b1d9606941cae25$var$lineclip.polyline = $7b1d9606941cae25$var$lineclip;
$7b1d9606941cae25$var$lineclip.polygon = $7b1d9606941cae25$var$polygonclip;
// Cohen-Sutherland line clippign algorithm, adapted to efficiently
// handle polylines rather than just segments
function $7b1d9606941cae25$var$lineclip(points, bbox, result) {
    var len = points.length, codeA = $7b1d9606941cae25$var$bitCode(points[0], bbox), part = [], i, a, b, codeB, lastCode;
    if (!result) result = [];
    for(i = 1; i < len; i++){
        a = points[i - 1];
        b = points[i];
        codeB = lastCode = $7b1d9606941cae25$var$bitCode(b, bbox);
        while(true){
            if (!(codeA | codeB)) {
                part.push(a);
                if (codeB !== lastCode) {
                    part.push(b);
                    if (i < len - 1) {
                        result.push(part);
                        part = [];
                    }
                } else if (i === len - 1) part.push(b);
                break;
            } else if (codeA & codeB) break;
            else if (codeA) {
                a = $7b1d9606941cae25$var$intersect(a, b, codeA, bbox);
                codeA = $7b1d9606941cae25$var$bitCode(a, bbox);
            } else {
                b = $7b1d9606941cae25$var$intersect(a, b, codeB, bbox);
                codeB = $7b1d9606941cae25$var$bitCode(b, bbox);
            }
        }
        codeA = lastCode;
    }
    if (part.length) result.push(part);
    return result;
}
// Sutherland-Hodgeman polygon clipping algorithm
function $7b1d9606941cae25$var$polygonclip(points, bbox) {
    var result, edge, prev, prevInside, i, p, inside;
    // clip against each side of the clip rectangle
    for(edge = 1; edge <= 8; edge *= 2){
        result = [];
        prev = points[points.length - 1];
        prevInside = !($7b1d9606941cae25$var$bitCode(prev, bbox) & edge);
        for(i = 0; i < points.length; i++){
            p = points[i];
            inside = !($7b1d9606941cae25$var$bitCode(p, bbox) & edge);
            // if segment goes through the clip window, add an intersection
            if (inside !== prevInside) result.push($7b1d9606941cae25$var$intersect(prev, p, edge, bbox));
            if (inside) result.push(p); // add a point if it's inside
            prev = p;
            prevInside = inside;
        }
        points = result;
        if (!points.length) break;
    }
    return result;
}
// intersect a segment against one of the 4 lines that make up the bbox
function $7b1d9606941cae25$var$intersect(a, b, edge, bbox) {
    return edge & 8 ? [
        a[0] + (b[0] - a[0]) * (bbox[3] - a[1]) / (b[1] - a[1]),
        bbox[3]
    ] : edge & 4 ? [
        a[0] + (b[0] - a[0]) * (bbox[1] - a[1]) / (b[1] - a[1]),
        bbox[1]
    ] : edge & 2 ? [
        bbox[2],
        a[1] + (b[1] - a[1]) * (bbox[2] - a[0]) / (b[0] - a[0])
    ] : edge & 1 ? [
        bbox[0],
        a[1] + (b[1] - a[1]) * (bbox[0] - a[0]) / (b[0] - a[0])
    ] : null;
}
// bit code reflects the point position relative to the bbox:
//         left  mid  right
//    top  1001  1000  1010
//    mid  0001  0000  0010
// bottom  0101  0100  0110
function $7b1d9606941cae25$var$bitCode(p, bbox) {
    var code = 0;
    if (p[0] < bbox[0]) code |= 1; // left
    else if (p[0] > bbox[2]) code |= 2; // right
    if (p[1] < bbox[1]) code |= 4; // bottom
    else if (p[1] > bbox[3]) code |= 8; // top
    return code;
}

});

parcelRegister("8lreT", function(module, exports) {
"use strict";
var $61356a09ab2c3189$var$abs = Math.abs, $61356a09ab2c3189$var$min = Math.min;
function $61356a09ab2c3189$var$almostEqual(a, b, absoluteError, relativeError) {
    var d = $61356a09ab2c3189$var$abs(a - b);
    if (absoluteError == null) absoluteError = $61356a09ab2c3189$var$almostEqual.DBL_EPSILON;
    if (relativeError == null) relativeError = absoluteError;
    if (d <= absoluteError) return true;
    if (d <= relativeError * $61356a09ab2c3189$var$min($61356a09ab2c3189$var$abs(a), $61356a09ab2c3189$var$abs(b))) return true;
    return a === b;
}
$61356a09ab2c3189$var$almostEqual.FLT_EPSILON = 1.19209290e-7;
$61356a09ab2c3189$var$almostEqual.DBL_EPSILON = 2.2204460492503131e-16;
module.exports = $61356a09ab2c3189$var$almostEqual;

});

parcelRegister("3Dutx", function(module, exports) {

var $7JTgC = parcelRequire("7JTgC");

var $gdDy1 = parcelRequire("gdDy1");
//determines whether two arrays are almost equal
module.exports = function(a, b, absoluteTolerance, relativeTolerance) {
    //will accept typed arrays
    if (!a || !b || !$7JTgC(a) || !$7JTgC(b)) return false;
    if (a.length !== b.length) return false;
    if (typeof absoluteTolerance !== 'number') absoluteTolerance = $gdDy1.FLT_EPSILON;
    if (typeof relativeTolerance !== 'number') relativeTolerance = absoluteTolerance;
    return Array.prototype.slice.call(a).every(function(a0, i) {
        var b0 = b[i];
        return a0 === b0 || $gdDy1(a0, b0, absoluteTolerance, relativeTolerance);
    });
};

});
parcelRegister("7JTgC", function(module, exports) {
var $5a279b3cb91ecda7$var$str = Object.prototype.toString;
module.exports = $5a279b3cb91ecda7$var$anArray;
function $5a279b3cb91ecda7$var$anArray(arr) {
    return arr.BYTES_PER_ELEMENT && $5a279b3cb91ecda7$var$str.call(arr.buffer) === '[object ArrayBuffer]' || Array.isArray(arr);
}

});

parcelRegister("gdDy1", function(module, exports) {
"use strict";
var $bcec8999869d84f0$var$abs = Math.abs, $bcec8999869d84f0$var$min = Math.min;
function $bcec8999869d84f0$var$almostEqual(a, b, absoluteError, relativeError) {
    var d = $bcec8999869d84f0$var$abs(a - b);
    if (d <= absoluteError) return true;
    if (d <= relativeError * $bcec8999869d84f0$var$min($bcec8999869d84f0$var$abs(a), $bcec8999869d84f0$var$abs(b))) return true;
    return a === b;
}
$bcec8999869d84f0$var$almostEqual.FLT_EPSILON = 1.19209290e-7;
$bcec8999869d84f0$var$almostEqual.DBL_EPSILON = 2.2204460492503131e-16;
module.exports = $bcec8999869d84f0$var$almostEqual;

});


parcelRegister("kEoec", function(module, exports) {

var $8lreT = parcelRequire("8lreT");
module.exports = $f08a564355571d26$var$intersectSegmentCircle;
function $f08a564355571d26$var$intersectSegmentCircle(p0, p1, circle, circleRadius, hits) {
    return $f08a564355571d26$var$intersect(p0[0], p0[1], p1[0], p1[1], circle[0], circle[1], circleRadius, hits);
}
function $f08a564355571d26$var$intersect(x1, y1, x2, y2, cx, cy, radius, hits) {
    if (hits == null) hits = [];
    var p1InCircle = $f08a564355571d26$var$pointInCircle(x1, y1, cx, cy, radius);
    var p2InCircle = $f08a564355571d26$var$pointInCircle(x2, y2, cx, cy, radius);
    if (p1InCircle && p2InCircle) {
        hits.push([
            x1,
            y1
        ]);
        hits.push([
            x2,
            y2
        ]);
        return true;
    }
    var h, a, closestPoint, px, py;
    if (p1InCircle || p2InCircle) {
        closestPoint = $f08a564355571d26$var$closestPointOnLineFromPoint(x1, y1, x2, y2, cx, cy);
        px = closestPoint[0];
        py = closestPoint[1];
        h = $f08a564355571d26$var$distance(px, py, cx, cy);
        a = Math.sqrt(radius * radius - h * h);
        var hitA = p1InCircle ? [
            x1,
            y1
        ] : [
            x2,
            y2
        ];
        var hitB = p1InCircle ? $f08a564355571d26$var$projectPoint(px, py, x2, y2, a) : $f08a564355571d26$var$projectPoint(px, py, x1, y1, a);
        if ($8lreT(hitA[0], hitB[0]) && $8lreT(hitA[1], hitB[1])) {
            // One point in the segment lies on the circle, the other is outside
            hits.push(hitA);
            return true;
        }
        hits.push(hitA);
        hits.push(hitB);
        return true;
    }
    closestPoint = $f08a564355571d26$var$closestPointOnSegmentFromPoint(x1, y1, x2, y2, cx, cy);
    px = closestPoint[0];
    py = closestPoint[1];
    if ($8lreT(x1, px) && $8lreT(y1, py) || $8lreT(x2, px) && $8lreT(y2, py)) return false;
    else {
        h = $f08a564355571d26$var$distance(px, py, cx, cy);
        if (h > radius) return false;
        else if ($8lreT(h, radius)) {
            hits.push([
                px,
                py
            ]);
            return true;
        } else if ($8lreT(h, 0.0)) {
            hits.push($f08a564355571d26$var$projectPoint(cx, cy, x1, y1, radius));
            hits.push($f08a564355571d26$var$projectPoint(cx, cy, x2, y2, radius));
            return true;
        } else {
            a = Math.sqrt(radius * radius - h * h);
            hits.push($f08a564355571d26$var$projectPoint(px, py, x1, y1, a));
            hits.push($f08a564355571d26$var$projectPoint(px, py, x2, y2, a));
            return true;
        }
    }
}
function $f08a564355571d26$var$layDistance(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $f08a564355571d26$var$pointInCircle(px, py, cx, cy, radius) {
    return $f08a564355571d26$var$layDistance(px, py, cx, cy) <= radius * radius;
}
function $f08a564355571d26$var$distance(x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return Math.sqrt(dx * dx + dy * dy);
}
function $f08a564355571d26$var$projectPoint(srcx, srcy, destx, desty, dist) {
    var t = dist / $f08a564355571d26$var$distance(srcx, srcy, destx, desty);
    return [
        srcx + t * (destx - srcx),
        srcy + t * (desty - srcy)
    ];
}
function $f08a564355571d26$var$closestPointOnLineFromPoint(x1, y1, x2, y2, px, py) {
    var vx = x2 - x1;
    var vy = y2 - y1;
    var wx = px - x1;
    var wy = py - y1;
    var c1 = vx * wx + vy * wy;
    var c2 = vx * vx + vy * vy;
    var ratio = c1 / c2;
    return [
        x1 + ratio * vx,
        y1 + ratio * vy
    ];
}
function $f08a564355571d26$var$closestPointOnSegmentFromPoint(x1, y1, x2, y2, px, py) {
    var vx = x2 - x1;
    var vy = y2 - y1;
    var wx = px - x1;
    var wy = py - y1;
    var c1 = vx * wx + vy * wy;
    if (c1 <= 0.0) return [
        x1,
        y1
    ];
    var c2 = vx * vx + vy * vy;
    if (c2 <= c1) return [
        x2,
        y2
    ];
    var ratio = c1 / c2;
    return [
        x1 + ratio * vx,
        y1 + ratio * vy
    ];
}

});

parcelRegister("4NxUC", function(module, exports) {

var $8lreT = parcelRequire("8lreT");
module.exports = $37e60b4f428f5367$var$intersectLineCircle;
function $37e60b4f428f5367$var$intersectLineCircle(p0, p1, circle, circleRadius, hits) {
    if (hits == null) hits = [];
    var a = $37e60b4f428f5367$var$sqr(p1[0] - p0[0]) + $37e60b4f428f5367$var$sqr(p1[1] - p0[1]);
    var b = 2.0 * ((p1[0] - p0[0]) * (p0[0] - circle[0]) + (p1[1] - p0[1]) * (p0[1] - circle[1]));
    var c = $37e60b4f428f5367$var$sqr(circle[0]) + $37e60b4f428f5367$var$sqr(circle[1]) + $37e60b4f428f5367$var$sqr(p0[0]) + $37e60b4f428f5367$var$sqr(p0[1]) - 2 * (circle[0] * p0[0] + circle[1] * p0[1]) - $37e60b4f428f5367$var$sqr(circleRadius);
    var det = b * b - 4.0 * a * c;
    var delta;
    if (det < 0) return false;
    else if ($8lreT(det, 0.0)) {
        delta = -b / (2.0 * a);
        hits.push([
            p0[0] + delta * (p1[0] - p0[0]),
            p0[1] + delta * (p1[1] - p0[1])
        ]);
        return true;
    } else if (det > 0.0) {
        var sqrtDet = Math.sqrt(det);
        delta = (-b + sqrtDet) / (2.0 * a);
        hits.push([
            p0[0] + delta * (p1[0] - p0[0]),
            p0[1] + delta * (p1[1] - p0[1])
        ]);
        delta = (-b - sqrtDet) / (2.0 * a);
        hits.push([
            p0[0] + delta * (p1[0] - p0[0]),
            p0[1] + delta * (p1[1] - p0[1])
        ]);
        return true;
    }
    return null;
}
function $37e60b4f428f5367$var$sqr(a) {
    return a * a;
}

});



parcelRegister("jFM7h", function(module, exports) {

var $yR7IU = parcelRequire("yR7IU");

var $2FgoB = parcelRequire("2FgoB");

var $iM60e = parcelRequire("iM60e");

var $2xuQP = parcelRequire("2xuQP");
module.exports = $e5272b976e840d99$var$createShader;
function $e5272b976e840d99$var$createShader(opt) {
    opt = opt || {};
    if (!opt.gl) throw new Error('Must specify { context: "webgl" } in sketch settings, or a WebGL-enabled canvas');
    var gl = opt.gl;
    var reglOpts = {
        gl: gl
    };
    // regl is strict on what options you pass in
    if (typeof opt.extensions !== 'undefined') reglOpts.extensions = opt.extensions;
    if (typeof opt.optionalExtensions !== 'undefined') reglOpts.optionalExtensions = opt.optionalExtensions;
    if (typeof opt.profile !== 'undefined') reglOpts.profile = opt.profile;
    if (typeof opt.onDone !== 'undefined') reglOpts.onDone = opt.onDone;
    // Create regl for handling GL stuff
    var regl = $yR7IU(reglOpts);
    // A mesh for a flat plane
    var quad = $2FgoB();
    var textureMap = new Map();
    // Wire up user uniforms nicely
    var uniformsMap = opt.uniforms || {};
    var uniforms = Object.assign({}, uniformsMap);
    Object.keys(uniformsMap).forEach(function(key) {
        var value = uniformsMap[key];
        if (typeof value === 'function') uniforms[key] = function(state, props, batchID) {
            var result = value.call(uniformsMap, props, batchID);
            // If user is using a function to wrap an image,
            // then we need to make sure we re-upload to same GL texture
            if ($e5272b976e840d99$var$isTextureLike(result)) {
                if (textureMap.has(value)) {
                    // Texture is already created, re-upload
                    var prevTex = textureMap.get(value);
                    prevTex(result);
                    // Return the texture
                    result = prevTex;
                } else {
                    // Creating the texture for the first time
                    var texture = regl.texture(result);
                    textureMap.set(value, texture);
                    // Return the texture, not the image
                    result = texture;
                }
            }
            return result;
        };
        else if ($e5272b976e840d99$var$isTextureLike(value)) uniforms[key] = regl.texture(value);
        else uniforms[key] = value;
    });
    // Get the drawing command
    var drawQuadCommand;
    try {
        drawQuadCommand = createDrawQuad();
    } catch (err) {
        handleError(err);
    }
    // Nicely get a clear color for the canvas
    var clearColor = $2xuQP(opt.clearColor, 'black');
    if (typeof clearColor === 'string') {
        var parsed = $iM60e(clearColor);
        if (!parsed.rgb) throw new Error('Error parsing { clearColor } color string "' + clearColor + '"');
        clearColor = parsed.rgb.slice(0, 3).map(function(n) {
            return n / 255;
        });
    } else if (clearColor && (!Array.isArray(clearColor) || clearColor.length < 3)) throw new Error('Error with { clearColor } option, must be a string or [ r, g, b ] float array');
    var clearAlpha = $2xuQP(opt.clearAlpha, 1);
    var clear = clearColor ? clearColor.concat([
        clearAlpha || 0
    ]) : false;
    // Return a renderer object
    return {
        render: function(props) {
            // On each tick, update regl timers and sizes
            regl.poll();
            // Clear backbuffer with color
            if (clear) regl.clear({
                color: clear,
                depth: 1,
                stencil: 0
            });
            // Submit draw command
            drawQuad(props);
            // Flush pending GL calls for this frame
            gl.flush();
        },
        regl: regl,
        drawQuad: drawQuad,
        unload: function() {
            // Remove GL texture mappings
            textureMap.clear();
            // Unload the current regl instance
            // TODO: We should probably also destroy textures created from this module!
            regl.destroy();
        }
    };
    // A user-friendly draw command that spits out errors
    function drawQuad(props) {
        props = props || {};
        // Draw generative / shader art
        if (drawQuadCommand) try {
            drawQuadCommand(props);
        } catch (err) {
            if (handleError(err)) {
                if (props == null) console.warn('Warning: shader.render() is not called with any "props" parameter');
            }
        }
    }
    // Draw command
    function createDrawQuad() {
        return regl({
            scissor: opt.scissor ? {
                enable: true,
                box: {
                    x: regl.prop('scissorX'),
                    y: regl.prop('scissorY'),
                    width: regl.prop('scissorWidth'),
                    height: regl.prop('scissorHeight')
                }
            } : false,
            // Pass down props from javascript
            uniforms: uniforms,
            // Fall back to a simple fragment shader
            frag: opt.frag || [
                'precision highp float;',
                '',
                'void main () {',
                '  gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);',
                '}'
            ].join('\n'),
            // Fall back to a simple vertex shader
            vert: opt.vert || [
                'precision highp float;',
                'attribute vec3 position;',
                'varying vec2 vUv;',
                '',
                'void main () {',
                '  gl_Position = vec4(position.xyz, 1.0);',
                '  vUv = gl_Position.xy * 0.5 + 0.5;',
                '}'
            ].join('\n'),
            // Setup transparency blending
            blend: opt.blend !== false ? {
                enable: true,
                func: {
                    srcRGB: 'src alpha',
                    srcAlpha: 1,
                    dstRGB: 'one minus src alpha',
                    dstAlpha: 1
                }
            } : undefined,
            // Send mesh vertex attributes to shader
            attributes: {
                position: quad.positions
            },
            // The indices for the quad mesh
            elements: quad.cells
        });
    }
    function handleError(err) {
        if (/^\(regl\)/.test(err.message)) // Regl already logs a message to the console :\
        // so let's just avoid re-printing the same thing
        return true;
        else throw err;
    }
}
function $e5272b976e840d99$var$isTextureLike(data) {
    return data && !Array.isArray(data) && typeof data === 'object';
}

});
parcelRegister("yR7IU", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    var isTypedArray = function(x) {
        return x instanceof Uint8Array || x instanceof Uint16Array || x instanceof Uint32Array || x instanceof Int8Array || x instanceof Int16Array || x instanceof Int32Array || x instanceof Float32Array || x instanceof Float64Array || x instanceof Uint8ClampedArray;
    };
    var extend = function(base, opts) {
        var keys = Object.keys(opts);
        for(var i = 0; i < keys.length; ++i)base[keys[i]] = opts[keys[i]];
        return base;
    };
    // Error checking and parameter validation.
    //
    // Statements for the form `check.someProcedure(...)` get removed by
    // a browserify transform for optimized/minified bundles.
    //
    /* globals atob */ var endl = '\n';
    // only used for extracting shader names.  if atob not present, then errors
    // will be slightly crappier
    function decodeB64(str) {
        if (typeof atob !== 'undefined') return atob(str);
        return 'base64:' + str;
    }
    function raise(message) {
        var error = new Error('(regl) ' + message);
        console.error(error);
        throw error;
    }
    function check(pred, message) {
        if (!pred) raise(message);
    }
    function encolon(message) {
        if (message) return ': ' + message;
        return '';
    }
    function checkParameter(param, possibilities, message) {
        if (!(param in possibilities)) raise('unknown parameter (' + param + ')' + encolon(message) + '. possible values: ' + Object.keys(possibilities).join());
    }
    function checkIsTypedArray(data, message) {
        if (!isTypedArray(data)) raise('invalid parameter type' + encolon(message) + '. must be a typed array');
    }
    function standardTypeEh(value, type) {
        switch(type){
            case 'number':
                return typeof value === 'number';
            case 'object':
                return typeof value === 'object';
            case 'string':
                return typeof value === 'string';
            case 'boolean':
                return typeof value === 'boolean';
            case 'function':
                return typeof value === 'function';
            case 'undefined':
                return typeof value === 'undefined';
            case 'symbol':
                return typeof value === 'symbol';
        }
    }
    function checkTypeOf(value, type, message) {
        if (!standardTypeEh(value, type)) raise('invalid parameter type' + encolon(message) + '. expected ' + type + ', got ' + typeof value);
    }
    function checkNonNegativeInt(value, message) {
        if (!(value >= 0 && (value | 0) === value)) raise('invalid parameter type, (' + value + ')' + encolon(message) + '. must be a nonnegative integer');
    }
    function checkOneOf(value, list, message) {
        if (list.indexOf(value) < 0) raise('invalid value' + encolon(message) + '. must be one of: ' + list);
    }
    var constructorKeys = [
        'gl',
        'canvas',
        'container',
        'attributes',
        'pixelRatio',
        'extensions',
        'optionalExtensions',
        'profile',
        'onDone'
    ];
    function checkConstructor(obj) {
        Object.keys(obj).forEach(function(key) {
            if (constructorKeys.indexOf(key) < 0) raise('invalid regl constructor argument "' + key + '". must be one of ' + constructorKeys);
        });
    }
    function leftPad(str, n) {
        str = str + '';
        while(str.length < n)str = ' ' + str;
        return str;
    }
    function ShaderFile() {
        this.name = 'unknown';
        this.lines = [];
        this.index = {};
        this.hasErrors = false;
    }
    function ShaderLine(number, line) {
        this.number = number;
        this.line = line;
        this.errors = [];
    }
    function ShaderError(fileNumber, lineNumber, message) {
        this.file = fileNumber;
        this.line = lineNumber;
        this.message = message;
    }
    function guessCommand() {
        var error = new Error();
        var stack = (error.stack || error).toString();
        var pat = /compileProcedure.*\n\s*at.*\((.*)\)/.exec(stack);
        if (pat) return pat[1];
        var pat2 = /compileProcedure.*\n\s*at\s+(.*)(\n|$)/.exec(stack);
        if (pat2) return pat2[1];
        return 'unknown';
    }
    function guessCallSite() {
        var error = new Error();
        var stack = (error.stack || error).toString();
        var pat = /at REGLCommand.*\n\s+at.*\((.*)\)/.exec(stack);
        if (pat) return pat[1];
        var pat2 = /at REGLCommand.*\n\s+at\s+(.*)\n/.exec(stack);
        if (pat2) return pat2[1];
        return 'unknown';
    }
    function parseSource(source, command) {
        var lines = source.split('\n');
        var lineNumber = 1;
        var fileNumber = 0;
        var files = {
            unknown: new ShaderFile(),
            0: new ShaderFile()
        };
        files.unknown.name = files[0].name = command || guessCommand();
        files.unknown.lines.push(new ShaderLine(0, ''));
        for(var i = 0; i < lines.length; ++i){
            var line = lines[i];
            var parts = /^\s*#\s*(\w+)\s+(.+)\s*$/.exec(line);
            if (parts) switch(parts[1]){
                case 'line':
                    var lineNumberInfo = /(\d+)(\s+\d+)?/.exec(parts[2]);
                    if (lineNumberInfo) {
                        lineNumber = lineNumberInfo[1] | 0;
                        if (lineNumberInfo[2]) {
                            fileNumber = lineNumberInfo[2] | 0;
                            if (!(fileNumber in files)) files[fileNumber] = new ShaderFile();
                        }
                    }
                    break;
                case 'define':
                    var nameInfo = /SHADER_NAME(_B64)?\s+(.*)$/.exec(parts[2]);
                    if (nameInfo) files[fileNumber].name = nameInfo[1] ? decodeB64(nameInfo[2]) : nameInfo[2];
                    break;
            }
            files[fileNumber].lines.push(new ShaderLine(lineNumber++, line));
        }
        Object.keys(files).forEach(function(fileNumber) {
            var file = files[fileNumber];
            file.lines.forEach(function(line) {
                file.index[line.number] = line;
            });
        });
        return files;
    }
    function parseErrorLog(errLog) {
        var result = [];
        errLog.split('\n').forEach(function(errMsg) {
            if (errMsg.length < 5) return;
            var parts = /^ERROR:\s+(\d+):(\d+):\s*(.*)$/.exec(errMsg);
            if (parts) result.push(new ShaderError(parts[1] | 0, parts[2] | 0, parts[3].trim()));
            else if (errMsg.length > 0) result.push(new ShaderError('unknown', 0, errMsg));
        });
        return result;
    }
    function annotateFiles(files, errors) {
        errors.forEach(function(error) {
            var file = files[error.file];
            if (file) {
                var line = file.index[error.line];
                if (line) {
                    line.errors.push(error);
                    file.hasErrors = true;
                    return;
                }
            }
            files.unknown.hasErrors = true;
            files.unknown.lines[0].errors.push(error);
        });
    }
    function checkShaderError(gl, shader, source, type, command) {
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            var errLog = gl.getShaderInfoLog(shader);
            var typeName = type === gl.FRAGMENT_SHADER ? 'fragment' : 'vertex';
            checkCommandType(source, 'string', typeName + ' shader source must be a string', command);
            var files = parseSource(source, command);
            var errors = parseErrorLog(errLog);
            annotateFiles(files, errors);
            Object.keys(files).forEach(function(fileNumber) {
                var file = files[fileNumber];
                if (!file.hasErrors) return;
                var strings = [
                    ''
                ];
                var styles = [
                    ''
                ];
                function push(str, style) {
                    strings.push(str);
                    styles.push(style || '');
                }
                push('file number ' + fileNumber + ': ' + file.name + '\n', 'color:red;text-decoration:underline;font-weight:bold');
                file.lines.forEach(function(line) {
                    if (line.errors.length > 0) {
                        push(leftPad(line.number, 4) + '|  ', 'background-color:yellow; font-weight:bold');
                        push(line.line + endl, 'color:red; background-color:yellow; font-weight:bold');
                        // try to guess token
                        var offset = 0;
                        line.errors.forEach(function(error) {
                            var message = error.message;
                            var token = /^\s*'(.*)'\s*:\s*(.*)$/.exec(message);
                            if (token) {
                                var tokenPat = token[1];
                                message = token[2];
                                switch(tokenPat){
                                    case 'assign':
                                        tokenPat = '=';
                                        break;
                                }
                                offset = Math.max(line.line.indexOf(tokenPat, offset), 0);
                            } else offset = 0;
                            push(leftPad('| ', 6));
                            push(leftPad('^^^', offset + 3) + endl, 'font-weight:bold');
                            push(leftPad('| ', 6));
                            push(message + endl, 'font-weight:bold');
                        });
                        push(leftPad('| ', 6) + endl);
                    } else {
                        push(leftPad(line.number, 4) + '|  ');
                        push(line.line + endl, 'color:red');
                    }
                });
                if (typeof document !== 'undefined' && !window.chrome) {
                    styles[0] = strings.join('%c');
                    console.log.apply(console, styles);
                } else console.log(strings.join(''));
            });
            check.raise('Error compiling ' + typeName + ' shader, ' + files[0].name);
        }
    }
    function checkLinkError(gl, program, fragShader, vertShader, command) {
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            var errLog = gl.getProgramInfoLog(program);
            var fragParse = parseSource(fragShader, command);
            var vertParse = parseSource(vertShader, command);
            var header = 'Error linking program with vertex shader, "' + vertParse[0].name + '", and fragment shader "' + fragParse[0].name + '"';
            if (typeof document !== 'undefined') console.log('%c' + header + endl + '%c' + errLog, 'color:red;text-decoration:underline;font-weight:bold', 'color:red');
            else console.log(header + endl + errLog);
            check.raise(header);
        }
    }
    function saveCommandRef(object) {
        object._commandRef = guessCommand();
    }
    function saveDrawCommandInfo(opts, uniforms, attributes, stringStore) {
        saveCommandRef(opts);
        function id(str) {
            if (str) return stringStore.id(str);
            return 0;
        }
        opts._fragId = id(opts.static.frag);
        opts._vertId = id(opts.static.vert);
        function addProps(dict, set) {
            Object.keys(set).forEach(function(u) {
                dict[stringStore.id(u)] = true;
            });
        }
        var uniformSet = opts._uniformSet = {};
        addProps(uniformSet, uniforms.static);
        addProps(uniformSet, uniforms.dynamic);
        var attributeSet = opts._attributeSet = {};
        addProps(attributeSet, attributes.static);
        addProps(attributeSet, attributes.dynamic);
        opts._hasCount = 'count' in opts.static || 'count' in opts.dynamic || 'elements' in opts.static || 'elements' in opts.dynamic;
    }
    function commandRaise(message, command) {
        var callSite = guessCallSite();
        raise(message + ' in command ' + (command || guessCommand()) + (callSite === 'unknown' ? '' : ' called from ' + callSite));
    }
    function checkCommand(pred, message, command) {
        if (!pred) commandRaise(message, command || guessCommand());
    }
    function checkParameterCommand(param, possibilities, message, command) {
        if (!(param in possibilities)) commandRaise('unknown parameter (' + param + ')' + encolon(message) + '. possible values: ' + Object.keys(possibilities).join(), command || guessCommand());
    }
    function checkCommandType(value, type, message, command) {
        if (!standardTypeEh(value, type)) commandRaise('invalid parameter type' + encolon(message) + '. expected ' + type + ', got ' + typeof value, command || guessCommand());
    }
    function checkOptional(block) {
        block();
    }
    function checkFramebufferFormat(attachment, texFormats, rbFormats) {
        if (attachment.texture) checkOneOf(attachment.texture._texture.internalformat, texFormats, 'unsupported texture format for attachment');
        else checkOneOf(attachment.renderbuffer._renderbuffer.format, rbFormats, 'unsupported renderbuffer format for attachment');
    }
    var GL_CLAMP_TO_EDGE = 0x812F;
    var GL_NEAREST = 0x2600;
    var GL_NEAREST_MIPMAP_NEAREST = 0x2700;
    var GL_LINEAR_MIPMAP_NEAREST = 0x2701;
    var GL_NEAREST_MIPMAP_LINEAR = 0x2702;
    var GL_LINEAR_MIPMAP_LINEAR = 0x2703;
    var GL_BYTE = 5120;
    var GL_UNSIGNED_BYTE = 5121;
    var GL_SHORT = 5122;
    var GL_UNSIGNED_SHORT = 5123;
    var GL_INT = 5124;
    var GL_UNSIGNED_INT = 5125;
    var GL_FLOAT = 5126;
    var GL_UNSIGNED_SHORT_4_4_4_4 = 0x8033;
    var GL_UNSIGNED_SHORT_5_5_5_1 = 0x8034;
    var GL_UNSIGNED_SHORT_5_6_5 = 0x8363;
    var GL_UNSIGNED_INT_24_8_WEBGL = 0x84FA;
    var GL_HALF_FLOAT_OES = 0x8D61;
    var TYPE_SIZE = {};
    TYPE_SIZE[GL_BYTE] = TYPE_SIZE[GL_UNSIGNED_BYTE] = 1;
    TYPE_SIZE[GL_SHORT] = TYPE_SIZE[GL_UNSIGNED_SHORT] = TYPE_SIZE[GL_HALF_FLOAT_OES] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_6_5] = TYPE_SIZE[GL_UNSIGNED_SHORT_4_4_4_4] = TYPE_SIZE[GL_UNSIGNED_SHORT_5_5_5_1] = 2;
    TYPE_SIZE[GL_INT] = TYPE_SIZE[GL_UNSIGNED_INT] = TYPE_SIZE[GL_FLOAT] = TYPE_SIZE[GL_UNSIGNED_INT_24_8_WEBGL] = 4;
    function pixelSize(type, channels) {
        if (type === GL_UNSIGNED_SHORT_5_5_5_1 || type === GL_UNSIGNED_SHORT_4_4_4_4 || type === GL_UNSIGNED_SHORT_5_6_5) return 2;
        else if (type === GL_UNSIGNED_INT_24_8_WEBGL) return 4;
        else return TYPE_SIZE[type] * channels;
    }
    function isPow2(v) {
        return !(v & v - 1) && !!v;
    }
    function checkTexture2D(info, mipData, limits) {
        var i;
        var w = mipData.width;
        var h = mipData.height;
        var c = mipData.channels;
        // Check texture shape
        check(w > 0 && w <= limits.maxTextureSize && h > 0 && h <= limits.maxTextureSize, 'invalid texture shape');
        // check wrap mode
        if (info.wrapS !== GL_CLAMP_TO_EDGE || info.wrapT !== GL_CLAMP_TO_EDGE) check(isPow2(w) && isPow2(h), 'incompatible wrap mode for texture, both width and height must be power of 2');
        if (mipData.mipmask === 1) {
            if (w !== 1 && h !== 1) check(info.minFilter !== GL_NEAREST_MIPMAP_NEAREST && info.minFilter !== GL_NEAREST_MIPMAP_LINEAR && info.minFilter !== GL_LINEAR_MIPMAP_NEAREST && info.minFilter !== GL_LINEAR_MIPMAP_LINEAR, 'min filter requires mipmap');
        } else {
            // texture must be power of 2
            check(isPow2(w) && isPow2(h), 'texture must be a square power of 2 to support mipmapping');
            check(mipData.mipmask === (w << 1) - 1, 'missing or incomplete mipmap data');
        }
        if (mipData.type === GL_FLOAT) {
            if (limits.extensions.indexOf('oes_texture_float_linear') < 0) check(info.minFilter === GL_NEAREST && info.magFilter === GL_NEAREST, 'filter not supported, must enable oes_texture_float_linear');
            check(!info.genMipmaps, 'mipmap generation not supported with float textures');
        }
        // check image complete
        var mipimages = mipData.images;
        for(i = 0; i < 16; ++i){
            if (mipimages[i]) {
                var mw = w >> i;
                var mh = h >> i;
                check(mipData.mipmask & 1 << i, 'missing mipmap data');
                var img = mipimages[i];
                check(img.width === mw && img.height === mh, 'invalid shape for mip images');
                check(img.format === mipData.format && img.internalformat === mipData.internalformat && img.type === mipData.type, 'incompatible type for mip image');
                if (img.compressed) ;
                else if (img.data) {
                    // check(img.data.byteLength === mw * mh *
                    // Math.max(pixelSize(img.type, c), img.unpackAlignment),
                    var rowSize = Math.ceil(pixelSize(img.type, c) * mw / img.unpackAlignment) * img.unpackAlignment;
                    check(img.data.byteLength === rowSize * mh, 'invalid data for image, buffer size is inconsistent with image format');
                } else if (img.element) ;
                else img.copy;
            } else if (!info.genMipmaps) check((mipData.mipmask & 1 << i) === 0, 'extra mipmap data');
        }
        if (mipData.compressed) check(!info.genMipmaps, 'mipmap generation for compressed images not supported');
    }
    function checkTextureCube(texture, info, faces, limits) {
        var w = texture.width;
        var h = texture.height;
        var c = texture.channels;
        // Check texture shape
        check(w > 0 && w <= limits.maxTextureSize && h > 0 && h <= limits.maxTextureSize, 'invalid texture shape');
        check(w === h, 'cube map must be square');
        check(info.wrapS === GL_CLAMP_TO_EDGE && info.wrapT === GL_CLAMP_TO_EDGE, 'wrap mode not supported by cube map');
        for(var i = 0; i < faces.length; ++i){
            var face = faces[i];
            check(face.width === w && face.height === h, 'inconsistent cube map face shape');
            if (info.genMipmaps) {
                check(!face.compressed, 'can not generate mipmap for compressed textures');
                check(face.mipmask === 1, 'can not specify mipmaps and generate mipmaps');
            }
            var mipmaps = face.images;
            for(var j = 0; j < 16; ++j){
                var img = mipmaps[j];
                if (img) {
                    var mw = w >> j;
                    var mh = h >> j;
                    check(face.mipmask & 1 << j, 'missing mipmap data');
                    check(img.width === mw && img.height === mh, 'invalid shape for mip images');
                    check(img.format === texture.format && img.internalformat === texture.internalformat && img.type === texture.type, 'incompatible type for mip image');
                    if (img.compressed) ;
                    else if (img.data) check(img.data.byteLength === mw * mh * Math.max(pixelSize(img.type, c), img.unpackAlignment), 'invalid data for image, buffer size is inconsistent with image format');
                    else if (img.element) ;
                    else img.copy;
                }
            }
        }
    }
    var check$1 = extend(check, {
        optional: checkOptional,
        raise: raise,
        commandRaise: commandRaise,
        command: checkCommand,
        parameter: checkParameter,
        commandParameter: checkParameterCommand,
        constructor: checkConstructor,
        type: checkTypeOf,
        commandType: checkCommandType,
        isTypedArray: checkIsTypedArray,
        nni: checkNonNegativeInt,
        oneOf: checkOneOf,
        shaderError: checkShaderError,
        linkError: checkLinkError,
        callSite: guessCallSite,
        saveCommandRef: saveCommandRef,
        saveDrawInfo: saveDrawCommandInfo,
        framebufferFormat: checkFramebufferFormat,
        guessCommand: guessCommand,
        texture2D: checkTexture2D,
        textureCube: checkTextureCube
    });
    var VARIABLE_COUNTER = 0;
    var DYN_FUNC = 0;
    var DYN_CONSTANT = 5;
    var DYN_ARRAY = 6;
    function DynamicVariable(type, data) {
        this.id = VARIABLE_COUNTER++;
        this.type = type;
        this.data = data;
    }
    function escapeStr(str) {
        return str.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }
    function splitParts(str) {
        if (str.length === 0) return [];
        var firstChar = str.charAt(0);
        var lastChar = str.charAt(str.length - 1);
        if (str.length > 1 && firstChar === lastChar && (firstChar === '"' || firstChar === "'")) return [
            '"' + escapeStr(str.substr(1, str.length - 2)) + '"'
        ];
        var parts = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(str);
        if (parts) return splitParts(str.substr(0, parts.index)).concat(splitParts(parts[1])).concat(splitParts(str.substr(parts.index + parts[0].length)));
        var subparts = str.split('.');
        if (subparts.length === 1) return [
            '"' + escapeStr(str) + '"'
        ];
        var result = [];
        for(var i = 0; i < subparts.length; ++i)result = result.concat(splitParts(subparts[i]));
        return result;
    }
    function toAccessorString(str) {
        return '[' + splitParts(str).join('][') + ']';
    }
    function defineDynamic(type, data) {
        return new DynamicVariable(type, toAccessorString(data + ''));
    }
    function isDynamic(x) {
        return typeof x === 'function' && !x._reglType || x instanceof DynamicVariable;
    }
    function unbox(x, path) {
        if (typeof x === 'function') return new DynamicVariable(DYN_FUNC, x);
        else if (typeof x === 'number' || typeof x === 'boolean') return new DynamicVariable(DYN_CONSTANT, x);
        else if (Array.isArray(x)) return new DynamicVariable(DYN_ARRAY, x.map((y, i)=>unbox(y, path + '[' + i + ']')));
        else if (x instanceof DynamicVariable) return x;
        check$1(false, 'invalid option type in uniform ' + path);
    }
    var dynamic = {
        DynamicVariable: DynamicVariable,
        define: defineDynamic,
        isDynamic: isDynamic,
        unbox: unbox,
        accessor: toAccessorString
    };
    /* globals requestAnimationFrame, cancelAnimationFrame */ var raf = {
        next: typeof requestAnimationFrame === 'function' ? function(cb) {
            return requestAnimationFrame(cb);
        } : function(cb) {
            return setTimeout(cb, 16);
        },
        cancel: typeof cancelAnimationFrame === 'function' ? function(raf) {
            return cancelAnimationFrame(raf);
        } : clearTimeout
    };
    /* globals performance */ var clock = typeof performance !== 'undefined' && performance.now ? function() {
        return performance.now();
    } : function() {
        return +new Date();
    };
    function createStringStore() {
        var stringIds = {
            '': 0
        };
        var stringValues = [
            ''
        ];
        return {
            id: function(str) {
                var result = stringIds[str];
                if (result) return result;
                result = stringIds[str] = stringValues.length;
                stringValues.push(str);
                return result;
            },
            str: function(id) {
                return stringValues[id];
            }
        };
    }
    // Context and canvas creation helper functions
    function createCanvas(element, onDone, pixelRatio) {
        var canvas = document.createElement('canvas');
        extend(canvas.style, {
            border: 0,
            margin: 0,
            padding: 0,
            top: 0,
            left: 0
        });
        element.appendChild(canvas);
        if (element === document.body) {
            canvas.style.position = 'absolute';
            extend(element.style, {
                margin: 0,
                padding: 0
            });
        }
        function resize() {
            var w = window.innerWidth;
            var h = window.innerHeight;
            if (element !== document.body) {
                var bounds = element.getBoundingClientRect();
                w = bounds.right - bounds.left;
                h = bounds.bottom - bounds.top;
            }
            canvas.width = pixelRatio * w;
            canvas.height = pixelRatio * h;
            extend(canvas.style, {
                width: w + 'px',
                height: h + 'px'
            });
        }
        var resizeObserver;
        if (element !== document.body && typeof ResizeObserver === 'function') {
            // ignore 'ResizeObserver' is not defined
            // eslint-disable-next-line
            resizeObserver = new ResizeObserver(function() {
                // setTimeout to avoid flicker
                setTimeout(resize);
            });
            resizeObserver.observe(element);
        } else window.addEventListener('resize', resize, false);
        function onDestroy() {
            if (resizeObserver) resizeObserver.disconnect();
            else window.removeEventListener('resize', resize);
            element.removeChild(canvas);
        }
        resize();
        return {
            canvas: canvas,
            onDestroy: onDestroy
        };
    }
    function createContext(canvas, contextAttributes) {
        function get(name) {
            try {
                return canvas.getContext(name, contextAttributes);
            } catch (e) {
                return null;
            }
        }
        return get('webgl') || get('experimental-webgl') || get('webgl-experimental');
    }
    function isHTMLElement(obj) {
        return typeof obj.nodeName === 'string' && typeof obj.appendChild === 'function' && typeof obj.getBoundingClientRect === 'function';
    }
    function isWebGLContext(obj) {
        return typeof obj.drawArrays === 'function' || typeof obj.drawElements === 'function';
    }
    function parseExtensions(input) {
        if (typeof input === 'string') return input.split();
        check$1(Array.isArray(input), 'invalid extension array');
        return input;
    }
    function getElement(desc) {
        if (typeof desc === 'string') {
            check$1(typeof document !== 'undefined', 'not supported outside of DOM');
            return document.querySelector(desc);
        }
        return desc;
    }
    function parseArgs(args_) {
        var args = args_ || {};
        var element, container, canvas, gl;
        var contextAttributes = {};
        var extensions = [];
        var optionalExtensions = [];
        var pixelRatio = typeof window === 'undefined' ? 1 : window.devicePixelRatio;
        var profile = false;
        var onDone = function(err) {
            if (err) check$1.raise(err);
        };
        var onDestroy = function() {};
        if (typeof args === 'string') {
            check$1(typeof document !== 'undefined', 'selector queries only supported in DOM enviroments');
            element = document.querySelector(args);
            check$1(element, 'invalid query string for element');
        } else if (typeof args === 'object') {
            if (isHTMLElement(args)) element = args;
            else if (isWebGLContext(args)) {
                gl = args;
                canvas = gl.canvas;
            } else {
                check$1.constructor(args);
                if ('gl' in args) gl = args.gl;
                else if ('canvas' in args) canvas = getElement(args.canvas);
                else if ('container' in args) container = getElement(args.container);
                if ('attributes' in args) {
                    contextAttributes = args.attributes;
                    check$1.type(contextAttributes, 'object', 'invalid context attributes');
                }
                if ('extensions' in args) extensions = parseExtensions(args.extensions);
                if ('optionalExtensions' in args) optionalExtensions = parseExtensions(args.optionalExtensions);
                if ('onDone' in args) {
                    check$1.type(args.onDone, 'function', 'invalid or missing onDone callback');
                    onDone = args.onDone;
                }
                if ('profile' in args) profile = !!args.profile;
                if ('pixelRatio' in args) {
                    pixelRatio = +args.pixelRatio;
                    check$1(pixelRatio > 0, 'invalid pixel ratio');
                }
            }
        } else check$1.raise('invalid arguments to regl');
        if (element) {
            if (element.nodeName.toLowerCase() === 'canvas') canvas = element;
            else container = element;
        }
        if (!gl) {
            if (!canvas) {
                check$1(typeof document !== 'undefined', 'must manually specify webgl context outside of DOM environments');
                var result = createCanvas(container || document.body, onDone, pixelRatio);
                if (!result) return null;
                canvas = result.canvas;
                onDestroy = result.onDestroy;
            }
            // workaround for chromium bug, premultiplied alpha value is platform dependent
            if (contextAttributes.premultipliedAlpha === undefined) contextAttributes.premultipliedAlpha = true;
            gl = createContext(canvas, contextAttributes);
        }
        if (!gl) {
            onDestroy();
            onDone('webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org');
            return null;
        }
        return {
            gl: gl,
            canvas: canvas,
            container: container,
            extensions: extensions,
            optionalExtensions: optionalExtensions,
            pixelRatio: pixelRatio,
            profile: profile,
            onDone: onDone,
            onDestroy: onDestroy
        };
    }
    function createExtensionCache(gl, config) {
        var extensions = {};
        function tryLoadExtension(name_) {
            check$1.type(name_, 'string', 'extension name must be string');
            var name = name_.toLowerCase();
            var ext;
            try {
                ext = extensions[name] = gl.getExtension(name);
            } catch (e) {}
            return !!ext;
        }
        for(var i = 0; i < config.extensions.length; ++i){
            var name = config.extensions[i];
            if (!tryLoadExtension(name)) {
                config.onDestroy();
                config.onDone('"' + name + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser');
                return null;
            }
        }
        config.optionalExtensions.forEach(tryLoadExtension);
        return {
            extensions: extensions,
            restore: function() {
                Object.keys(extensions).forEach(function(name) {
                    if (extensions[name] && !tryLoadExtension(name)) throw new Error('(regl): error restoring extension ' + name);
                });
            }
        };
    }
    function loop(n, f) {
        var result = Array(n);
        for(var i = 0; i < n; ++i)result[i] = f(i);
        return result;
    }
    var GL_BYTE$1 = 5120;
    var GL_UNSIGNED_BYTE$2 = 5121;
    var GL_SHORT$1 = 5122;
    var GL_UNSIGNED_SHORT$1 = 5123;
    var GL_INT$1 = 5124;
    var GL_UNSIGNED_INT$1 = 5125;
    var GL_FLOAT$2 = 5126;
    function nextPow16(v) {
        for(var i = 16; i <= 268435456; i *= 16){
            if (v <= i) return i;
        }
        return 0;
    }
    function log2(v) {
        var r, shift;
        r = (v > 0xFFFF) << 4;
        v >>>= r;
        shift = (v > 0xFF) << 3;
        v >>>= shift;
        r |= shift;
        shift = (v > 0xF) << 2;
        v >>>= shift;
        r |= shift;
        shift = (v > 0x3) << 1;
        v >>>= shift;
        r |= shift;
        return r | v >> 1;
    }
    function createPool() {
        var bufferPool = loop(8, function() {
            return [];
        });
        function alloc(n) {
            var sz = nextPow16(n);
            var bin = bufferPool[log2(sz) >> 2];
            if (bin.length > 0) return bin.pop();
            return new ArrayBuffer(sz);
        }
        function free(buf) {
            bufferPool[log2(buf.byteLength) >> 2].push(buf);
        }
        function allocType(type, n) {
            var result = null;
            switch(type){
                case GL_BYTE$1:
                    result = new Int8Array(alloc(n), 0, n);
                    break;
                case GL_UNSIGNED_BYTE$2:
                    result = new Uint8Array(alloc(n), 0, n);
                    break;
                case GL_SHORT$1:
                    result = new Int16Array(alloc(2 * n), 0, n);
                    break;
                case GL_UNSIGNED_SHORT$1:
                    result = new Uint16Array(alloc(2 * n), 0, n);
                    break;
                case GL_INT$1:
                    result = new Int32Array(alloc(4 * n), 0, n);
                    break;
                case GL_UNSIGNED_INT$1:
                    result = new Uint32Array(alloc(4 * n), 0, n);
                    break;
                case GL_FLOAT$2:
                    result = new Float32Array(alloc(4 * n), 0, n);
                    break;
                default:
                    return null;
            }
            if (result.length !== n) return result.subarray(0, n);
            return result;
        }
        function freeType(array) {
            free(array.buffer);
        }
        return {
            alloc: alloc,
            free: free,
            allocType: allocType,
            freeType: freeType
        };
    }
    var pool = createPool();
    // zero pool for initial zero data
    pool.zero = createPool();
    var GL_SUBPIXEL_BITS = 0x0D50;
    var GL_RED_BITS = 0x0D52;
    var GL_GREEN_BITS = 0x0D53;
    var GL_BLUE_BITS = 0x0D54;
    var GL_ALPHA_BITS = 0x0D55;
    var GL_DEPTH_BITS = 0x0D56;
    var GL_STENCIL_BITS = 0x0D57;
    var GL_ALIASED_POINT_SIZE_RANGE = 0x846D;
    var GL_ALIASED_LINE_WIDTH_RANGE = 0x846E;
    var GL_MAX_TEXTURE_SIZE = 0x0D33;
    var GL_MAX_VIEWPORT_DIMS = 0x0D3A;
    var GL_MAX_VERTEX_ATTRIBS = 0x8869;
    var GL_MAX_VERTEX_UNIFORM_VECTORS = 0x8DFB;
    var GL_MAX_VARYING_VECTORS = 0x8DFC;
    var GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS = 0x8B4D;
    var GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS = 0x8B4C;
    var GL_MAX_TEXTURE_IMAGE_UNITS = 0x8872;
    var GL_MAX_FRAGMENT_UNIFORM_VECTORS = 0x8DFD;
    var GL_MAX_CUBE_MAP_TEXTURE_SIZE = 0x851C;
    var GL_MAX_RENDERBUFFER_SIZE = 0x84E8;
    var GL_VENDOR = 0x1F00;
    var GL_RENDERER = 0x1F01;
    var GL_VERSION = 0x1F02;
    var GL_SHADING_LANGUAGE_VERSION = 0x8B8C;
    var GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT = 0x84FF;
    var GL_MAX_COLOR_ATTACHMENTS_WEBGL = 0x8CDF;
    var GL_MAX_DRAW_BUFFERS_WEBGL = 0x8824;
    var GL_TEXTURE_2D = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP = 0x8513;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X = 0x8515;
    var GL_TEXTURE0 = 0x84C0;
    var GL_RGBA = 0x1908;
    var GL_FLOAT$1 = 0x1406;
    var GL_UNSIGNED_BYTE$1 = 0x1401;
    var GL_FRAMEBUFFER = 0x8D40;
    var GL_FRAMEBUFFER_COMPLETE = 0x8CD5;
    var GL_COLOR_ATTACHMENT0 = 0x8CE0;
    var GL_COLOR_BUFFER_BIT$1 = 0x4000;
    var wrapLimits = function(gl, extensions) {
        var maxAnisotropic = 1;
        if (extensions.ext_texture_filter_anisotropic) maxAnisotropic = gl.getParameter(GL_MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        var maxDrawbuffers = 1;
        var maxColorAttachments = 1;
        if (extensions.webgl_draw_buffers) {
            maxDrawbuffers = gl.getParameter(GL_MAX_DRAW_BUFFERS_WEBGL);
            maxColorAttachments = gl.getParameter(GL_MAX_COLOR_ATTACHMENTS_WEBGL);
        }
        // detect if reading float textures is available (Safari doesn't support)
        var readFloat = !!extensions.oes_texture_float;
        if (readFloat) {
            var readFloatTexture = gl.createTexture();
            gl.bindTexture(GL_TEXTURE_2D, readFloatTexture);
            gl.texImage2D(GL_TEXTURE_2D, 0, GL_RGBA, 1, 1, 0, GL_RGBA, GL_FLOAT$1, null);
            var fbo = gl.createFramebuffer();
            gl.bindFramebuffer(GL_FRAMEBUFFER, fbo);
            gl.framebufferTexture2D(GL_FRAMEBUFFER, GL_COLOR_ATTACHMENT0, GL_TEXTURE_2D, readFloatTexture, 0);
            gl.bindTexture(GL_TEXTURE_2D, null);
            if (gl.checkFramebufferStatus(GL_FRAMEBUFFER) !== GL_FRAMEBUFFER_COMPLETE) readFloat = false;
            else {
                gl.viewport(0, 0, 1, 1);
                gl.clearColor(1.0, 0.0, 0.0, 1.0);
                gl.clear(GL_COLOR_BUFFER_BIT$1);
                var pixels = pool.allocType(GL_FLOAT$1, 4);
                gl.readPixels(0, 0, 1, 1, GL_RGBA, GL_FLOAT$1, pixels);
                if (gl.getError()) readFloat = false;
                else {
                    gl.deleteFramebuffer(fbo);
                    gl.deleteTexture(readFloatTexture);
                    readFloat = pixels[0] === 1.0;
                }
                pool.freeType(pixels);
            }
        }
        // detect non power of two cube textures support (IE doesn't support)
        var isIE = typeof navigator !== 'undefined' && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent));
        var npotTextureCube = true;
        if (!isIE) {
            var cubeTexture = gl.createTexture();
            var data = pool.allocType(GL_UNSIGNED_BYTE$1, 36);
            gl.activeTexture(GL_TEXTURE0);
            gl.bindTexture(GL_TEXTURE_CUBE_MAP, cubeTexture);
            gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X, 0, GL_RGBA, 3, 3, 0, GL_RGBA, GL_UNSIGNED_BYTE$1, data);
            pool.freeType(data);
            gl.bindTexture(GL_TEXTURE_CUBE_MAP, null);
            gl.deleteTexture(cubeTexture);
            npotTextureCube = !gl.getError();
        }
        return {
            // drawing buffer bit depth
            colorBits: [
                gl.getParameter(GL_RED_BITS),
                gl.getParameter(GL_GREEN_BITS),
                gl.getParameter(GL_BLUE_BITS),
                gl.getParameter(GL_ALPHA_BITS)
            ],
            depthBits: gl.getParameter(GL_DEPTH_BITS),
            stencilBits: gl.getParameter(GL_STENCIL_BITS),
            subpixelBits: gl.getParameter(GL_SUBPIXEL_BITS),
            // supported extensions
            extensions: Object.keys(extensions).filter(function(ext) {
                return !!extensions[ext];
            }),
            // max aniso samples
            maxAnisotropic: maxAnisotropic,
            // max draw buffers
            maxDrawbuffers: maxDrawbuffers,
            maxColorAttachments: maxColorAttachments,
            // point and line size ranges
            pointSizeDims: gl.getParameter(GL_ALIASED_POINT_SIZE_RANGE),
            lineWidthDims: gl.getParameter(GL_ALIASED_LINE_WIDTH_RANGE),
            maxViewportDims: gl.getParameter(GL_MAX_VIEWPORT_DIMS),
            maxCombinedTextureUnits: gl.getParameter(GL_MAX_COMBINED_TEXTURE_IMAGE_UNITS),
            maxCubeMapSize: gl.getParameter(GL_MAX_CUBE_MAP_TEXTURE_SIZE),
            maxRenderbufferSize: gl.getParameter(GL_MAX_RENDERBUFFER_SIZE),
            maxTextureUnits: gl.getParameter(GL_MAX_TEXTURE_IMAGE_UNITS),
            maxTextureSize: gl.getParameter(GL_MAX_TEXTURE_SIZE),
            maxAttributes: gl.getParameter(GL_MAX_VERTEX_ATTRIBS),
            maxVertexUniforms: gl.getParameter(GL_MAX_VERTEX_UNIFORM_VECTORS),
            maxVertexTextureUnits: gl.getParameter(GL_MAX_VERTEX_TEXTURE_IMAGE_UNITS),
            maxVaryingVectors: gl.getParameter(GL_MAX_VARYING_VECTORS),
            maxFragmentUniforms: gl.getParameter(GL_MAX_FRAGMENT_UNIFORM_VECTORS),
            // vendor info
            glsl: gl.getParameter(GL_SHADING_LANGUAGE_VERSION),
            renderer: gl.getParameter(GL_RENDERER),
            vendor: gl.getParameter(GL_VENDOR),
            version: gl.getParameter(GL_VERSION),
            // quirks
            readFloat: readFloat,
            npotTextureCube: npotTextureCube
        };
    };
    function isNDArrayLike(obj) {
        return !!obj && typeof obj === 'object' && Array.isArray(obj.shape) && Array.isArray(obj.stride) && typeof obj.offset === 'number' && obj.shape.length === obj.stride.length && (Array.isArray(obj.data) || isTypedArray(obj.data));
    }
    var values = function(obj) {
        return Object.keys(obj).map(function(key) {
            return obj[key];
        });
    };
    var flattenUtils = {
        shape: arrayShape$1,
        flatten: flattenArray
    };
    function flatten1D(array, nx, out) {
        for(var i = 0; i < nx; ++i)out[i] = array[i];
    }
    function flatten2D(array, nx, ny, out) {
        var ptr = 0;
        for(var i = 0; i < nx; ++i){
            var row = array[i];
            for(var j = 0; j < ny; ++j)out[ptr++] = row[j];
        }
    }
    function flatten3D(array, nx, ny, nz, out, ptr_) {
        var ptr = ptr_;
        for(var i = 0; i < nx; ++i){
            var row = array[i];
            for(var j = 0; j < ny; ++j){
                var col = row[j];
                for(var k = 0; k < nz; ++k)out[ptr++] = col[k];
            }
        }
    }
    function flattenRec(array, shape, level, out, ptr) {
        var stride = 1;
        for(var i = level + 1; i < shape.length; ++i)stride *= shape[i];
        var n = shape[level];
        if (shape.length - level === 4) {
            var nx = shape[level + 1];
            var ny = shape[level + 2];
            var nz = shape[level + 3];
            for(i = 0; i < n; ++i){
                flatten3D(array[i], nx, ny, nz, out, ptr);
                ptr += stride;
            }
        } else for(i = 0; i < n; ++i){
            flattenRec(array[i], shape, level + 1, out, ptr);
            ptr += stride;
        }
    }
    function flattenArray(array, shape, type, out_) {
        var sz = 1;
        if (shape.length) for(var i = 0; i < shape.length; ++i)sz *= shape[i];
        else sz = 0;
        var out = out_ || pool.allocType(type, sz);
        switch(shape.length){
            case 0:
                break;
            case 1:
                flatten1D(array, shape[0], out);
                break;
            case 2:
                flatten2D(array, shape[0], shape[1], out);
                break;
            case 3:
                flatten3D(array, shape[0], shape[1], shape[2], out, 0);
                break;
            default:
                flattenRec(array, shape, 0, out, 0);
        }
        return out;
    }
    function arrayShape$1(array_) {
        var shape = [];
        for(var array = array_; array.length; array = array[0])shape.push(array.length);
        return shape;
    }
    var arrayTypes = {
        "[object Int8Array]": 5120,
        "[object Int16Array]": 5122,
        "[object Int32Array]": 5124,
        "[object Uint8Array]": 5121,
        "[object Uint8ClampedArray]": 5121,
        "[object Uint16Array]": 5123,
        "[object Uint32Array]": 5125,
        "[object Float32Array]": 5126,
        "[object Float64Array]": 5121,
        "[object ArrayBuffer]": 5121
    };
    var int8 = 5120;
    var int16 = 5122;
    var int32 = 5124;
    var uint8 = 5121;
    var uint16 = 5123;
    var uint32 = 5125;
    var float = 5126;
    var float32 = 5126;
    var glTypes = {
        int8: int8,
        int16: int16,
        int32: int32,
        uint8: uint8,
        uint16: uint16,
        uint32: uint32,
        float: float,
        float32: float32
    };
    var dynamic$1 = 35048;
    var stream = 35040;
    var usageTypes = {
        dynamic: dynamic$1,
        stream: stream,
        "static": 35044
    };
    var arrayFlatten = flattenUtils.flatten;
    var arrayShape = flattenUtils.shape;
    var GL_STATIC_DRAW = 0x88E4;
    var GL_STREAM_DRAW = 0x88E0;
    var GL_UNSIGNED_BYTE$3 = 5121;
    var GL_FLOAT$3 = 5126;
    var DTYPES_SIZES = [];
    DTYPES_SIZES[5120] = 1 // int8
    ;
    DTYPES_SIZES[5122] = 2 // int16
    ;
    DTYPES_SIZES[5124] = 4 // int32
    ;
    DTYPES_SIZES[5121] = 1 // uint8
    ;
    DTYPES_SIZES[5123] = 2 // uint16
    ;
    DTYPES_SIZES[5125] = 4 // uint32
    ;
    DTYPES_SIZES[5126] = 4 // float32
    ;
    function typedArrayCode(data) {
        return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function copyArray(out, inp) {
        for(var i = 0; i < inp.length; ++i)out[i] = inp[i];
    }
    function transpose(result, data, shapeX, shapeY, strideX, strideY, offset) {
        var ptr = 0;
        for(var i = 0; i < shapeX; ++i)for(var j = 0; j < shapeY; ++j)result[ptr++] = data[strideX * i + strideY * j + offset];
    }
    function wrapBufferState(gl, stats, config, destroyBuffer) {
        var bufferCount = 0;
        var bufferSet = {};
        function REGLBuffer(type) {
            this.id = bufferCount++;
            this.buffer = gl.createBuffer();
            this.type = type;
            this.usage = GL_STATIC_DRAW;
            this.byteLength = 0;
            this.dimension = 1;
            this.dtype = GL_UNSIGNED_BYTE$3;
            this.persistentData = null;
            if (config.profile) this.stats = {
                size: 0
            };
        }
        REGLBuffer.prototype.bind = function() {
            gl.bindBuffer(this.type, this.buffer);
        };
        REGLBuffer.prototype.destroy = function() {
            destroy(this);
        };
        var streamPool = [];
        function createStream(type, data) {
            var buffer = streamPool.pop();
            if (!buffer) buffer = new REGLBuffer(type);
            buffer.bind();
            initBufferFromData(buffer, data, GL_STREAM_DRAW, 0, 1, false);
            return buffer;
        }
        function destroyStream(stream$$1) {
            streamPool.push(stream$$1);
        }
        function initBufferFromTypedArray(buffer, data, usage) {
            buffer.byteLength = data.byteLength;
            gl.bufferData(buffer.type, data, usage);
        }
        function initBufferFromData(buffer, data, usage, dtype, dimension, persist) {
            var shape;
            buffer.usage = usage;
            if (Array.isArray(data)) {
                buffer.dtype = dtype || GL_FLOAT$3;
                if (data.length > 0) {
                    var flatData;
                    if (Array.isArray(data[0])) {
                        shape = arrayShape(data);
                        var dim = 1;
                        for(var i = 1; i < shape.length; ++i)dim *= shape[i];
                        buffer.dimension = dim;
                        flatData = arrayFlatten(data, shape, buffer.dtype);
                        initBufferFromTypedArray(buffer, flatData, usage);
                        if (persist) buffer.persistentData = flatData;
                        else pool.freeType(flatData);
                    } else if (typeof data[0] === 'number') {
                        buffer.dimension = dimension;
                        var typedData = pool.allocType(buffer.dtype, data.length);
                        copyArray(typedData, data);
                        initBufferFromTypedArray(buffer, typedData, usage);
                        if (persist) buffer.persistentData = typedData;
                        else pool.freeType(typedData);
                    } else if (isTypedArray(data[0])) {
                        buffer.dimension = data[0].length;
                        buffer.dtype = dtype || typedArrayCode(data[0]) || GL_FLOAT$3;
                        flatData = arrayFlatten(data, [
                            data.length,
                            data[0].length
                        ], buffer.dtype);
                        initBufferFromTypedArray(buffer, flatData, usage);
                        if (persist) buffer.persistentData = flatData;
                        else pool.freeType(flatData);
                    } else check$1.raise('invalid buffer data');
                }
            } else if (isTypedArray(data)) {
                buffer.dtype = dtype || typedArrayCode(data);
                buffer.dimension = dimension;
                initBufferFromTypedArray(buffer, data, usage);
                if (persist) buffer.persistentData = new Uint8Array(new Uint8Array(data.buffer));
            } else if (isNDArrayLike(data)) {
                shape = data.shape;
                var stride = data.stride;
                var offset = data.offset;
                var shapeX = 0;
                var shapeY = 0;
                var strideX = 0;
                var strideY = 0;
                if (shape.length === 1) {
                    shapeX = shape[0];
                    shapeY = 1;
                    strideX = stride[0];
                    strideY = 0;
                } else if (shape.length === 2) {
                    shapeX = shape[0];
                    shapeY = shape[1];
                    strideX = stride[0];
                    strideY = stride[1];
                } else check$1.raise('invalid shape');
                buffer.dtype = dtype || typedArrayCode(data.data) || GL_FLOAT$3;
                buffer.dimension = shapeY;
                var transposeData = pool.allocType(buffer.dtype, shapeX * shapeY);
                transpose(transposeData, data.data, shapeX, shapeY, strideX, strideY, offset);
                initBufferFromTypedArray(buffer, transposeData, usage);
                if (persist) buffer.persistentData = transposeData;
                else pool.freeType(transposeData);
            } else if (data instanceof ArrayBuffer) {
                buffer.dtype = GL_UNSIGNED_BYTE$3;
                buffer.dimension = dimension;
                initBufferFromTypedArray(buffer, data, usage);
                if (persist) buffer.persistentData = new Uint8Array(new Uint8Array(data));
            } else check$1.raise('invalid buffer data');
        }
        function destroy(buffer) {
            stats.bufferCount--;
            // remove attribute link
            destroyBuffer(buffer);
            var handle = buffer.buffer;
            check$1(handle, 'buffer must not be deleted already');
            gl.deleteBuffer(handle);
            buffer.buffer = null;
            delete bufferSet[buffer.id];
        }
        function createBuffer(options, type, deferInit, persistent) {
            stats.bufferCount++;
            var buffer = new REGLBuffer(type);
            bufferSet[buffer.id] = buffer;
            function reglBuffer(options) {
                var usage = GL_STATIC_DRAW;
                var data = null;
                var byteLength = 0;
                var dtype = 0;
                var dimension = 1;
                if (Array.isArray(options) || isTypedArray(options) || isNDArrayLike(options) || options instanceof ArrayBuffer) data = options;
                else if (typeof options === 'number') byteLength = options | 0;
                else if (options) {
                    check$1.type(options, 'object', 'buffer arguments must be an object, a number or an array');
                    if ('data' in options) {
                        check$1(data === null || Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data), 'invalid data for buffer');
                        data = options.data;
                    }
                    if ('usage' in options) {
                        check$1.parameter(options.usage, usageTypes, 'invalid buffer usage');
                        usage = usageTypes[options.usage];
                    }
                    if ('type' in options) {
                        check$1.parameter(options.type, glTypes, 'invalid buffer type');
                        dtype = glTypes[options.type];
                    }
                    if ('dimension' in options) {
                        check$1.type(options.dimension, 'number', 'invalid dimension');
                        dimension = options.dimension | 0;
                    }
                    if ('length' in options) {
                        check$1.nni(byteLength, 'buffer length must be a nonnegative integer');
                        byteLength = options.length | 0;
                    }
                }
                buffer.bind();
                if (!data) {
                    // #475
                    if (byteLength) gl.bufferData(buffer.type, byteLength, usage);
                    buffer.dtype = dtype || GL_UNSIGNED_BYTE$3;
                    buffer.usage = usage;
                    buffer.dimension = dimension;
                    buffer.byteLength = byteLength;
                } else initBufferFromData(buffer, data, usage, dtype, dimension, persistent);
                if (config.profile) buffer.stats.size = buffer.byteLength * DTYPES_SIZES[buffer.dtype];
                return reglBuffer;
            }
            function setSubData(data, offset) {
                check$1(offset + data.byteLength <= buffer.byteLength, "invalid buffer subdata call, buffer is too small.  Can't write data of size " + data.byteLength + ' starting from offset ' + offset + ' to a buffer of size ' + buffer.byteLength);
                gl.bufferSubData(buffer.type, offset, data);
            }
            function subdata(data, offset_) {
                var offset = (offset_ || 0) | 0;
                var shape;
                buffer.bind();
                if (isTypedArray(data) || data instanceof ArrayBuffer) setSubData(data, offset);
                else if (Array.isArray(data)) {
                    if (data.length > 0) {
                        if (typeof data[0] === 'number') {
                            var converted = pool.allocType(buffer.dtype, data.length);
                            copyArray(converted, data);
                            setSubData(converted, offset);
                            pool.freeType(converted);
                        } else if (Array.isArray(data[0]) || isTypedArray(data[0])) {
                            shape = arrayShape(data);
                            var flatData = arrayFlatten(data, shape, buffer.dtype);
                            setSubData(flatData, offset);
                            pool.freeType(flatData);
                        } else check$1.raise('invalid buffer data');
                    }
                } else if (isNDArrayLike(data)) {
                    shape = data.shape;
                    var stride = data.stride;
                    var shapeX = 0;
                    var shapeY = 0;
                    var strideX = 0;
                    var strideY = 0;
                    if (shape.length === 1) {
                        shapeX = shape[0];
                        shapeY = 1;
                        strideX = stride[0];
                        strideY = 0;
                    } else if (shape.length === 2) {
                        shapeX = shape[0];
                        shapeY = shape[1];
                        strideX = stride[0];
                        strideY = stride[1];
                    } else check$1.raise('invalid shape');
                    var dtype = Array.isArray(data.data) ? buffer.dtype : typedArrayCode(data.data);
                    var transposeData = pool.allocType(dtype, shapeX * shapeY);
                    transpose(transposeData, data.data, shapeX, shapeY, strideX, strideY, data.offset);
                    setSubData(transposeData, offset);
                    pool.freeType(transposeData);
                } else check$1.raise('invalid data for buffer subdata');
                return reglBuffer;
            }
            if (!deferInit) reglBuffer(options);
            reglBuffer._reglType = 'buffer';
            reglBuffer._buffer = buffer;
            reglBuffer.subdata = subdata;
            if (config.profile) reglBuffer.stats = buffer.stats;
            reglBuffer.destroy = function() {
                destroy(buffer);
            };
            return reglBuffer;
        }
        function restoreBuffers() {
            values(bufferSet).forEach(function(buffer) {
                buffer.buffer = gl.createBuffer();
                gl.bindBuffer(buffer.type, buffer.buffer);
                gl.bufferData(buffer.type, buffer.persistentData || buffer.byteLength, buffer.usage);
            });
        }
        if (config.profile) stats.getTotalBufferSize = function() {
            var total = 0;
            // TODO: Right now, the streams are not part of the total count.
            Object.keys(bufferSet).forEach(function(key) {
                total += bufferSet[key].stats.size;
            });
            return total;
        };
        return {
            create: createBuffer,
            createStream: createStream,
            destroyStream: destroyStream,
            clear: function() {
                values(bufferSet).forEach(destroy);
                streamPool.forEach(destroy);
            },
            getBuffer: function(wrapper) {
                if (wrapper && wrapper._buffer instanceof REGLBuffer) return wrapper._buffer;
                return null;
            },
            restore: restoreBuffers,
            _initBuffer: initBufferFromData
        };
    }
    var points = 0;
    var point = 0;
    var lines = 1;
    var line = 1;
    var triangles = 4;
    var triangle = 4;
    var primTypes = {
        points: points,
        point: point,
        lines: lines,
        line: line,
        triangles: triangles,
        triangle: triangle,
        "line loop": 2,
        "line strip": 3,
        "triangle strip": 5,
        "triangle fan": 6
    };
    var GL_POINTS = 0;
    var GL_LINES = 1;
    var GL_TRIANGLES = 4;
    var GL_BYTE$2 = 5120;
    var GL_UNSIGNED_BYTE$4 = 5121;
    var GL_SHORT$2 = 5122;
    var GL_UNSIGNED_SHORT$2 = 5123;
    var GL_INT$2 = 5124;
    var GL_UNSIGNED_INT$2 = 5125;
    var GL_ELEMENT_ARRAY_BUFFER = 34963;
    var GL_STREAM_DRAW$1 = 0x88E0;
    var GL_STATIC_DRAW$1 = 0x88E4;
    function wrapElementsState(gl, extensions, bufferState, stats) {
        var elementSet = {};
        var elementCount = 0;
        var elementTypes = {
            'uint8': GL_UNSIGNED_BYTE$4,
            'uint16': GL_UNSIGNED_SHORT$2
        };
        if (extensions.oes_element_index_uint) elementTypes.uint32 = GL_UNSIGNED_INT$2;
        function REGLElementBuffer(buffer) {
            this.id = elementCount++;
            elementSet[this.id] = this;
            this.buffer = buffer;
            this.primType = GL_TRIANGLES;
            this.vertCount = 0;
            this.type = 0;
        }
        REGLElementBuffer.prototype.bind = function() {
            this.buffer.bind();
        };
        var bufferPool = [];
        function createElementStream(data) {
            var result = bufferPool.pop();
            if (!result) result = new REGLElementBuffer(bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true, false)._buffer);
            initElements(result, data, GL_STREAM_DRAW$1, -1, -1, 0, 0);
            return result;
        }
        function destroyElementStream(elements) {
            bufferPool.push(elements);
        }
        function initElements(elements, data, usage, prim, count, byteLength, type) {
            elements.buffer.bind();
            var dtype;
            if (data) {
                var predictedType = type;
                if (!type && (!isTypedArray(data) || isNDArrayLike(data) && !isTypedArray(data.data))) predictedType = extensions.oes_element_index_uint ? GL_UNSIGNED_INT$2 : GL_UNSIGNED_SHORT$2;
                bufferState._initBuffer(elements.buffer, data, usage, predictedType, 3);
            } else {
                gl.bufferData(GL_ELEMENT_ARRAY_BUFFER, byteLength, usage);
                elements.buffer.dtype = dtype || GL_UNSIGNED_BYTE$4;
                elements.buffer.usage = usage;
                elements.buffer.dimension = 3;
                elements.buffer.byteLength = byteLength;
            }
            dtype = type;
            if (!type) {
                switch(elements.buffer.dtype){
                    case GL_UNSIGNED_BYTE$4:
                    case GL_BYTE$2:
                        dtype = GL_UNSIGNED_BYTE$4;
                        break;
                    case GL_UNSIGNED_SHORT$2:
                    case GL_SHORT$2:
                        dtype = GL_UNSIGNED_SHORT$2;
                        break;
                    case GL_UNSIGNED_INT$2:
                    case GL_INT$2:
                        dtype = GL_UNSIGNED_INT$2;
                        break;
                    default:
                        check$1.raise('unsupported type for element array');
                }
                elements.buffer.dtype = dtype;
            }
            elements.type = dtype;
            // Check oes_element_index_uint extension
            check$1(dtype !== GL_UNSIGNED_INT$2 || !!extensions.oes_element_index_uint, '32 bit element buffers not supported, enable oes_element_index_uint first');
            // try to guess default primitive type and arguments
            var vertCount = count;
            if (vertCount < 0) {
                vertCount = elements.buffer.byteLength;
                if (dtype === GL_UNSIGNED_SHORT$2) vertCount >>= 1;
                else if (dtype === GL_UNSIGNED_INT$2) vertCount >>= 2;
            }
            elements.vertCount = vertCount;
            // try to guess primitive type from cell dimension
            var primType = prim;
            if (prim < 0) {
                primType = GL_TRIANGLES;
                var dimension = elements.buffer.dimension;
                if (dimension === 1) primType = GL_POINTS;
                if (dimension === 2) primType = GL_LINES;
                if (dimension === 3) primType = GL_TRIANGLES;
            }
            elements.primType = primType;
        }
        function destroyElements(elements) {
            stats.elementsCount--;
            check$1(elements.buffer !== null, 'must not double destroy elements');
            delete elementSet[elements.id];
            elements.buffer.destroy();
            elements.buffer = null;
        }
        function createElements(options, persistent) {
            var buffer = bufferState.create(null, GL_ELEMENT_ARRAY_BUFFER, true);
            var elements = new REGLElementBuffer(buffer._buffer);
            stats.elementsCount++;
            function reglElements(options) {
                if (!options) {
                    buffer();
                    elements.primType = GL_TRIANGLES;
                    elements.vertCount = 0;
                    elements.type = GL_UNSIGNED_BYTE$4;
                } else if (typeof options === 'number') {
                    buffer(options);
                    elements.primType = GL_TRIANGLES;
                    elements.vertCount = options | 0;
                    elements.type = GL_UNSIGNED_BYTE$4;
                } else {
                    var data = null;
                    var usage = GL_STATIC_DRAW$1;
                    var primType = -1;
                    var vertCount = -1;
                    var byteLength = 0;
                    var dtype = 0;
                    if (Array.isArray(options) || isTypedArray(options) || isNDArrayLike(options)) data = options;
                    else {
                        check$1.type(options, 'object', 'invalid arguments for elements');
                        if ('data' in options) {
                            data = options.data;
                            check$1(Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data), 'invalid data for element buffer');
                        }
                        if ('usage' in options) {
                            check$1.parameter(options.usage, usageTypes, 'invalid element buffer usage');
                            usage = usageTypes[options.usage];
                        }
                        if ('primitive' in options) {
                            check$1.parameter(options.primitive, primTypes, 'invalid element buffer primitive');
                            primType = primTypes[options.primitive];
                        }
                        if ('count' in options) {
                            check$1(typeof options.count === 'number' && options.count >= 0, 'invalid vertex count for elements');
                            vertCount = options.count | 0;
                        }
                        if ('type' in options) {
                            check$1.parameter(options.type, elementTypes, 'invalid buffer type');
                            dtype = elementTypes[options.type];
                        }
                        if ('length' in options) byteLength = options.length | 0;
                        else {
                            byteLength = vertCount;
                            if (dtype === GL_UNSIGNED_SHORT$2 || dtype === GL_SHORT$2) byteLength *= 2;
                            else if (dtype === GL_UNSIGNED_INT$2 || dtype === GL_INT$2) byteLength *= 4;
                        }
                    }
                    initElements(elements, data, usage, primType, vertCount, byteLength, dtype);
                }
                return reglElements;
            }
            reglElements(options);
            reglElements._reglType = 'elements';
            reglElements._elements = elements;
            reglElements.subdata = function(data, offset) {
                buffer.subdata(data, offset);
                return reglElements;
            };
            reglElements.destroy = function() {
                destroyElements(elements);
            };
            return reglElements;
        }
        return {
            create: createElements,
            createStream: createElementStream,
            destroyStream: destroyElementStream,
            getElements: function(elements) {
                if (typeof elements === 'function' && elements._elements instanceof REGLElementBuffer) return elements._elements;
                return null;
            },
            clear: function() {
                values(elementSet).forEach(destroyElements);
            }
        };
    }
    var FLOAT = new Float32Array(1);
    var INT = new Uint32Array(FLOAT.buffer);
    var GL_UNSIGNED_SHORT$4 = 5123;
    function convertToHalfFloat(array) {
        var ushorts = pool.allocType(GL_UNSIGNED_SHORT$4, array.length);
        for(var i = 0; i < array.length; ++i){
            if (isNaN(array[i])) ushorts[i] = 0xffff;
            else if (array[i] === Infinity) ushorts[i] = 0x7c00;
            else if (array[i] === -Infinity) ushorts[i] = 0xfc00;
            else {
                FLOAT[0] = array[i];
                var x = INT[0];
                var sgn = x >>> 31 << 15;
                var exp = (x << 1 >>> 24) - 127;
                var frac = x >> 13 & 1023;
                if (exp < -24) // round non-representable denormals to 0
                ushorts[i] = sgn;
                else if (exp < -14) {
                    // handle denormals
                    var s = -14 - exp;
                    ushorts[i] = sgn + (frac + 1024 >> s);
                } else if (exp > 15) // round overflow to +/- Infinity
                ushorts[i] = sgn + 0x7c00;
                else // otherwise convert directly
                ushorts[i] = sgn + (exp + 15 << 10) + frac;
            }
        }
        return ushorts;
    }
    function isArrayLike(s) {
        return Array.isArray(s) || isTypedArray(s);
    }
    var isPow2$1 = function(v) {
        return !(v & v - 1) && !!v;
    };
    var GL_COMPRESSED_TEXTURE_FORMATS = 0x86A3;
    var GL_TEXTURE_2D$1 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP$1 = 0x8513;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 = 0x8515;
    var GL_RGBA$1 = 0x1908;
    var GL_ALPHA = 0x1906;
    var GL_RGB = 0x1907;
    var GL_LUMINANCE = 0x1909;
    var GL_LUMINANCE_ALPHA = 0x190A;
    var GL_RGBA4 = 0x8056;
    var GL_RGB5_A1 = 0x8057;
    var GL_RGB565 = 0x8D62;
    var GL_UNSIGNED_SHORT_4_4_4_4$1 = 0x8033;
    var GL_UNSIGNED_SHORT_5_5_5_1$1 = 0x8034;
    var GL_UNSIGNED_SHORT_5_6_5$1 = 0x8363;
    var GL_UNSIGNED_INT_24_8_WEBGL$1 = 0x84FA;
    var GL_DEPTH_COMPONENT = 0x1902;
    var GL_DEPTH_STENCIL = 0x84F9;
    var GL_SRGB_EXT = 0x8C40;
    var GL_SRGB_ALPHA_EXT = 0x8C42;
    var GL_HALF_FLOAT_OES$1 = 0x8D61;
    var GL_COMPRESSED_RGB_S3TC_DXT1_EXT = 0x83F0;
    var GL_COMPRESSED_RGBA_S3TC_DXT1_EXT = 0x83F1;
    var GL_COMPRESSED_RGBA_S3TC_DXT3_EXT = 0x83F2;
    var GL_COMPRESSED_RGBA_S3TC_DXT5_EXT = 0x83F3;
    var GL_COMPRESSED_RGB_ATC_WEBGL = 0x8C92;
    var GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 0x8C93;
    var GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 0x87EE;
    var GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 0x8C00;
    var GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 0x8C01;
    var GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 0x8C02;
    var GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 0x8C03;
    var GL_COMPRESSED_RGB_ETC1_WEBGL = 0x8D64;
    var GL_UNSIGNED_BYTE$5 = 0x1401;
    var GL_UNSIGNED_SHORT$3 = 0x1403;
    var GL_UNSIGNED_INT$3 = 0x1405;
    var GL_FLOAT$4 = 0x1406;
    var GL_TEXTURE_WRAP_S = 0x2802;
    var GL_TEXTURE_WRAP_T = 0x2803;
    var GL_REPEAT = 0x2901;
    var GL_CLAMP_TO_EDGE$1 = 0x812F;
    var GL_MIRRORED_REPEAT = 0x8370;
    var GL_TEXTURE_MAG_FILTER = 0x2800;
    var GL_TEXTURE_MIN_FILTER = 0x2801;
    var GL_NEAREST$1 = 0x2600;
    var GL_LINEAR = 0x2601;
    var GL_NEAREST_MIPMAP_NEAREST$1 = 0x2700;
    var GL_LINEAR_MIPMAP_NEAREST$1 = 0x2701;
    var GL_NEAREST_MIPMAP_LINEAR$1 = 0x2702;
    var GL_LINEAR_MIPMAP_LINEAR$1 = 0x2703;
    var GL_GENERATE_MIPMAP_HINT = 0x8192;
    var GL_DONT_CARE = 0x1100;
    var GL_FASTEST = 0x1101;
    var GL_NICEST = 0x1102;
    var GL_TEXTURE_MAX_ANISOTROPY_EXT = 0x84FE;
    var GL_UNPACK_ALIGNMENT = 0x0CF5;
    var GL_UNPACK_FLIP_Y_WEBGL = 0x9240;
    var GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL = 0x9241;
    var GL_UNPACK_COLORSPACE_CONVERSION_WEBGL = 0x9243;
    var GL_BROWSER_DEFAULT_WEBGL = 0x9244;
    var GL_TEXTURE0$1 = 0x84C0;
    var MIPMAP_FILTERS = [
        GL_NEAREST_MIPMAP_NEAREST$1,
        GL_NEAREST_MIPMAP_LINEAR$1,
        GL_LINEAR_MIPMAP_NEAREST$1,
        GL_LINEAR_MIPMAP_LINEAR$1
    ];
    var CHANNELS_FORMAT = [
        0,
        GL_LUMINANCE,
        GL_LUMINANCE_ALPHA,
        GL_RGB,
        GL_RGBA$1
    ];
    var FORMAT_CHANNELS = {};
    FORMAT_CHANNELS[GL_LUMINANCE] = FORMAT_CHANNELS[GL_ALPHA] = FORMAT_CHANNELS[GL_DEPTH_COMPONENT] = 1;
    FORMAT_CHANNELS[GL_DEPTH_STENCIL] = FORMAT_CHANNELS[GL_LUMINANCE_ALPHA] = 2;
    FORMAT_CHANNELS[GL_RGB] = FORMAT_CHANNELS[GL_SRGB_EXT] = 3;
    FORMAT_CHANNELS[GL_RGBA$1] = FORMAT_CHANNELS[GL_SRGB_ALPHA_EXT] = 4;
    function objectName(str) {
        return '[object ' + str + ']';
    }
    var CANVAS_CLASS = objectName('HTMLCanvasElement');
    var OFFSCREENCANVAS_CLASS = objectName('OffscreenCanvas');
    var CONTEXT2D_CLASS = objectName('CanvasRenderingContext2D');
    var BITMAP_CLASS = objectName('ImageBitmap');
    var IMAGE_CLASS = objectName('HTMLImageElement');
    var VIDEO_CLASS = objectName('HTMLVideoElement');
    var PIXEL_CLASSES = Object.keys(arrayTypes).concat([
        CANVAS_CLASS,
        OFFSCREENCANVAS_CLASS,
        CONTEXT2D_CLASS,
        BITMAP_CLASS,
        IMAGE_CLASS,
        VIDEO_CLASS
    ]);
    // for every texture type, store
    // the size in bytes.
    var TYPE_SIZES = [];
    TYPE_SIZES[GL_UNSIGNED_BYTE$5] = 1;
    TYPE_SIZES[GL_FLOAT$4] = 4;
    TYPE_SIZES[GL_HALF_FLOAT_OES$1] = 2;
    TYPE_SIZES[GL_UNSIGNED_SHORT$3] = 2;
    TYPE_SIZES[GL_UNSIGNED_INT$3] = 4;
    var FORMAT_SIZES_SPECIAL = [];
    FORMAT_SIZES_SPECIAL[GL_RGBA4] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB5_A1] = 2;
    FORMAT_SIZES_SPECIAL[GL_RGB565] = 2;
    FORMAT_SIZES_SPECIAL[GL_DEPTH_STENCIL] = 4;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT1_EXT] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT3_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_S3TC_DXT5_EXT] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ATC_WEBGL] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL] = 1;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG] = 0.5;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG] = 0.25;
    FORMAT_SIZES_SPECIAL[GL_COMPRESSED_RGB_ETC1_WEBGL] = 0.5;
    function isNumericArray(arr) {
        return Array.isArray(arr) && (arr.length === 0 || typeof arr[0] === 'number');
    }
    function isRectArray(arr) {
        if (!Array.isArray(arr)) return false;
        var width = arr.length;
        if (width === 0 || !isArrayLike(arr[0])) return false;
        return true;
    }
    function classString(x) {
        return Object.prototype.toString.call(x);
    }
    function isCanvasElement(object) {
        return classString(object) === CANVAS_CLASS;
    }
    function isOffscreenCanvas(object) {
        return classString(object) === OFFSCREENCANVAS_CLASS;
    }
    function isContext2D(object) {
        return classString(object) === CONTEXT2D_CLASS;
    }
    function isBitmap(object) {
        return classString(object) === BITMAP_CLASS;
    }
    function isImageElement(object) {
        return classString(object) === IMAGE_CLASS;
    }
    function isVideoElement(object) {
        return classString(object) === VIDEO_CLASS;
    }
    function isPixelData(object) {
        if (!object) return false;
        var className = classString(object);
        if (PIXEL_CLASSES.indexOf(className) >= 0) return true;
        return isNumericArray(object) || isRectArray(object) || isNDArrayLike(object);
    }
    function typedArrayCode$1(data) {
        return arrayTypes[Object.prototype.toString.call(data)] | 0;
    }
    function convertData(result, data) {
        var n = data.length;
        switch(result.type){
            case GL_UNSIGNED_BYTE$5:
            case GL_UNSIGNED_SHORT$3:
            case GL_UNSIGNED_INT$3:
            case GL_FLOAT$4:
                var converted = pool.allocType(result.type, n);
                converted.set(data);
                result.data = converted;
                break;
            case GL_HALF_FLOAT_OES$1:
                result.data = convertToHalfFloat(data);
                break;
            default:
                check$1.raise('unsupported texture type, must specify a typed array');
        }
    }
    function preConvert(image, n) {
        return pool.allocType(image.type === GL_HALF_FLOAT_OES$1 ? GL_FLOAT$4 : image.type, n);
    }
    function postConvert(image, data) {
        if (image.type === GL_HALF_FLOAT_OES$1) {
            image.data = convertToHalfFloat(data);
            pool.freeType(data);
        } else image.data = data;
    }
    function transposeData(image, array, strideX, strideY, strideC, offset) {
        var w = image.width;
        var h = image.height;
        var c = image.channels;
        var n = w * h * c;
        var data = preConvert(image, n);
        var p = 0;
        for(var i = 0; i < h; ++i){
            for(var j = 0; j < w; ++j)for(var k = 0; k < c; ++k)data[p++] = array[strideX * j + strideY * i + strideC * k + offset];
        }
        postConvert(image, data);
    }
    function getTextureSize(format, type, width, height, isMipmap, isCube) {
        var s;
        if (typeof FORMAT_SIZES_SPECIAL[format] !== 'undefined') // we have a special array for dealing with weird color formats such as RGB5A1
        s = FORMAT_SIZES_SPECIAL[format];
        else s = FORMAT_CHANNELS[format] * TYPE_SIZES[type];
        if (isCube) s *= 6;
        if (isMipmap) {
            // compute the total size of all the mipmaps.
            var total = 0;
            var w = width;
            while(w >= 1){
                // we can only use mipmaps on a square image,
                // so we can simply use the width and ignore the height:
                total += s * w * w;
                w /= 2;
            }
            return total;
        } else return s * width * height;
    }
    function createTextureSet(gl, extensions, limits, reglPoll, contextState, stats, config) {
        // -------------------------------------------------------
        // Initialize constants and parameter tables here
        // -------------------------------------------------------
        var mipmapHint = {
            "don't care": GL_DONT_CARE,
            'dont care': GL_DONT_CARE,
            'nice': GL_NICEST,
            'fast': GL_FASTEST
        };
        var wrapModes = {
            'repeat': GL_REPEAT,
            'clamp': GL_CLAMP_TO_EDGE$1,
            'mirror': GL_MIRRORED_REPEAT
        };
        var magFilters = {
            'nearest': GL_NEAREST$1,
            'linear': GL_LINEAR
        };
        var minFilters = extend({
            'mipmap': GL_LINEAR_MIPMAP_LINEAR$1,
            'nearest mipmap nearest': GL_NEAREST_MIPMAP_NEAREST$1,
            'linear mipmap nearest': GL_LINEAR_MIPMAP_NEAREST$1,
            'nearest mipmap linear': GL_NEAREST_MIPMAP_LINEAR$1,
            'linear mipmap linear': GL_LINEAR_MIPMAP_LINEAR$1
        }, magFilters);
        var colorSpace = {
            'none': 0,
            'browser': GL_BROWSER_DEFAULT_WEBGL
        };
        var textureTypes = {
            'uint8': GL_UNSIGNED_BYTE$5,
            'rgba4': GL_UNSIGNED_SHORT_4_4_4_4$1,
            'rgb565': GL_UNSIGNED_SHORT_5_6_5$1,
            'rgb5 a1': GL_UNSIGNED_SHORT_5_5_5_1$1
        };
        var textureFormats = {
            'alpha': GL_ALPHA,
            'luminance': GL_LUMINANCE,
            'luminance alpha': GL_LUMINANCE_ALPHA,
            'rgb': GL_RGB,
            'rgba': GL_RGBA$1,
            'rgba4': GL_RGBA4,
            'rgb5 a1': GL_RGB5_A1,
            'rgb565': GL_RGB565
        };
        var compressedTextureFormats = {};
        if (extensions.ext_srgb) {
            textureFormats.srgb = GL_SRGB_EXT;
            textureFormats.srgba = GL_SRGB_ALPHA_EXT;
        }
        if (extensions.oes_texture_float) textureTypes.float32 = textureTypes.float = GL_FLOAT$4;
        if (extensions.oes_texture_half_float) textureTypes['float16'] = textureTypes['half float'] = GL_HALF_FLOAT_OES$1;
        if (extensions.webgl_depth_texture) {
            extend(textureFormats, {
                'depth': GL_DEPTH_COMPONENT,
                'depth stencil': GL_DEPTH_STENCIL
            });
            extend(textureTypes, {
                'uint16': GL_UNSIGNED_SHORT$3,
                'uint32': GL_UNSIGNED_INT$3,
                'depth stencil': GL_UNSIGNED_INT_24_8_WEBGL$1
            });
        }
        if (extensions.webgl_compressed_texture_s3tc) extend(compressedTextureFormats, {
            'rgb s3tc dxt1': GL_COMPRESSED_RGB_S3TC_DXT1_EXT,
            'rgba s3tc dxt1': GL_COMPRESSED_RGBA_S3TC_DXT1_EXT,
            'rgba s3tc dxt3': GL_COMPRESSED_RGBA_S3TC_DXT3_EXT,
            'rgba s3tc dxt5': GL_COMPRESSED_RGBA_S3TC_DXT5_EXT
        });
        if (extensions.webgl_compressed_texture_atc) extend(compressedTextureFormats, {
            'rgb atc': GL_COMPRESSED_RGB_ATC_WEBGL,
            'rgba atc explicit alpha': GL_COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL,
            'rgba atc interpolated alpha': GL_COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL
        });
        if (extensions.webgl_compressed_texture_pvrtc) extend(compressedTextureFormats, {
            'rgb pvrtc 4bppv1': GL_COMPRESSED_RGB_PVRTC_4BPPV1_IMG,
            'rgb pvrtc 2bppv1': GL_COMPRESSED_RGB_PVRTC_2BPPV1_IMG,
            'rgba pvrtc 4bppv1': GL_COMPRESSED_RGBA_PVRTC_4BPPV1_IMG,
            'rgba pvrtc 2bppv1': GL_COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
        });
        if (extensions.webgl_compressed_texture_etc1) compressedTextureFormats['rgb etc1'] = GL_COMPRESSED_RGB_ETC1_WEBGL;
        // Copy over all texture formats
        var supportedCompressedFormats = Array.prototype.slice.call(gl.getParameter(GL_COMPRESSED_TEXTURE_FORMATS));
        Object.keys(compressedTextureFormats).forEach(function(name) {
            var format = compressedTextureFormats[name];
            if (supportedCompressedFormats.indexOf(format) >= 0) textureFormats[name] = format;
        });
        var supportedFormats = Object.keys(textureFormats);
        limits.textureFormats = supportedFormats;
        // associate with every format string its
        // corresponding GL-value.
        var textureFormatsInvert = [];
        Object.keys(textureFormats).forEach(function(key) {
            var val = textureFormats[key];
            textureFormatsInvert[val] = key;
        });
        // associate with every type string its
        // corresponding GL-value.
        var textureTypesInvert = [];
        Object.keys(textureTypes).forEach(function(key) {
            var val = textureTypes[key];
            textureTypesInvert[val] = key;
        });
        var magFiltersInvert = [];
        Object.keys(magFilters).forEach(function(key) {
            var val = magFilters[key];
            magFiltersInvert[val] = key;
        });
        var minFiltersInvert = [];
        Object.keys(minFilters).forEach(function(key) {
            var val = minFilters[key];
            minFiltersInvert[val] = key;
        });
        var wrapModesInvert = [];
        Object.keys(wrapModes).forEach(function(key) {
            var val = wrapModes[key];
            wrapModesInvert[val] = key;
        });
        // colorFormats[] gives the format (channels) associated to an
        // internalformat
        var colorFormats = supportedFormats.reduce(function(color, key) {
            var glenum = textureFormats[key];
            if (glenum === GL_LUMINANCE || glenum === GL_ALPHA || glenum === GL_LUMINANCE || glenum === GL_LUMINANCE_ALPHA || glenum === GL_DEPTH_COMPONENT || glenum === GL_DEPTH_STENCIL || extensions.ext_srgb && (glenum === GL_SRGB_EXT || glenum === GL_SRGB_ALPHA_EXT)) color[glenum] = glenum;
            else if (glenum === GL_RGB5_A1 || key.indexOf('rgba') >= 0) color[glenum] = GL_RGBA$1;
            else color[glenum] = GL_RGB;
            return color;
        }, {});
        function TexFlags() {
            // format info
            this.internalformat = GL_RGBA$1;
            this.format = GL_RGBA$1;
            this.type = GL_UNSIGNED_BYTE$5;
            this.compressed = false;
            // pixel storage
            this.premultiplyAlpha = false;
            this.flipY = false;
            this.unpackAlignment = 1;
            this.colorSpace = GL_BROWSER_DEFAULT_WEBGL;
            // shape info
            this.width = 0;
            this.height = 0;
            this.channels = 0;
        }
        function copyFlags(result, other) {
            result.internalformat = other.internalformat;
            result.format = other.format;
            result.type = other.type;
            result.compressed = other.compressed;
            result.premultiplyAlpha = other.premultiplyAlpha;
            result.flipY = other.flipY;
            result.unpackAlignment = other.unpackAlignment;
            result.colorSpace = other.colorSpace;
            result.width = other.width;
            result.height = other.height;
            result.channels = other.channels;
        }
        function parseFlags(flags, options) {
            if (typeof options !== 'object' || !options) return;
            if ('premultiplyAlpha' in options) {
                check$1.type(options.premultiplyAlpha, 'boolean', 'invalid premultiplyAlpha');
                flags.premultiplyAlpha = options.premultiplyAlpha;
            }
            if ('flipY' in options) {
                check$1.type(options.flipY, 'boolean', 'invalid texture flip');
                flags.flipY = options.flipY;
            }
            if ('alignment' in options) {
                check$1.oneOf(options.alignment, [
                    1,
                    2,
                    4,
                    8
                ], 'invalid texture unpack alignment');
                flags.unpackAlignment = options.alignment;
            }
            if ('colorSpace' in options) {
                check$1.parameter(options.colorSpace, colorSpace, 'invalid colorSpace');
                flags.colorSpace = colorSpace[options.colorSpace];
            }
            if ('type' in options) {
                var type = options.type;
                check$1(extensions.oes_texture_float || !(type === 'float' || type === 'float32'), 'you must enable the OES_texture_float extension in order to use floating point textures.');
                check$1(extensions.oes_texture_half_float || !(type === 'half float' || type === 'float16'), 'you must enable the OES_texture_half_float extension in order to use 16-bit floating point textures.');
                check$1(extensions.webgl_depth_texture || !(type === 'uint16' || type === 'uint32' || type === 'depth stencil'), 'you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures.');
                check$1.parameter(type, textureTypes, 'invalid texture type');
                flags.type = textureTypes[type];
            }
            var w = flags.width;
            var h = flags.height;
            var c = flags.channels;
            var hasChannels = false;
            if ('shape' in options) {
                check$1(Array.isArray(options.shape) && options.shape.length >= 2, 'shape must be an array');
                w = options.shape[0];
                h = options.shape[1];
                if (options.shape.length === 3) {
                    c = options.shape[2];
                    check$1(c > 0 && c <= 4, 'invalid number of channels');
                    hasChannels = true;
                }
                check$1(w >= 0 && w <= limits.maxTextureSize, 'invalid width');
                check$1(h >= 0 && h <= limits.maxTextureSize, 'invalid height');
            } else {
                if ('radius' in options) {
                    w = h = options.radius;
                    check$1(w >= 0 && w <= limits.maxTextureSize, 'invalid radius');
                }
                if ('width' in options) {
                    w = options.width;
                    check$1(w >= 0 && w <= limits.maxTextureSize, 'invalid width');
                }
                if ('height' in options) {
                    h = options.height;
                    check$1(h >= 0 && h <= limits.maxTextureSize, 'invalid height');
                }
                if ('channels' in options) {
                    c = options.channels;
                    check$1(c > 0 && c <= 4, 'invalid number of channels');
                    hasChannels = true;
                }
            }
            flags.width = w | 0;
            flags.height = h | 0;
            flags.channels = c | 0;
            var hasFormat = false;
            if ('format' in options) {
                var formatStr = options.format;
                check$1(extensions.webgl_depth_texture || !(formatStr === 'depth' || formatStr === 'depth stencil'), 'you must enable the WEBGL_depth_texture extension in order to use depth/stencil textures.');
                check$1.parameter(formatStr, textureFormats, 'invalid texture format');
                var internalformat = flags.internalformat = textureFormats[formatStr];
                flags.format = colorFormats[internalformat];
                if (formatStr in textureTypes) {
                    if (!('type' in options)) flags.type = textureTypes[formatStr];
                }
                if (formatStr in compressedTextureFormats) flags.compressed = true;
                hasFormat = true;
            }
            // Reconcile channels and format
            if (!hasChannels && hasFormat) flags.channels = FORMAT_CHANNELS[flags.format];
            else if (hasChannels && !hasFormat) {
                if (flags.channels !== CHANNELS_FORMAT[flags.format]) flags.format = flags.internalformat = CHANNELS_FORMAT[flags.channels];
            } else if (hasFormat && hasChannels) check$1(flags.channels === FORMAT_CHANNELS[flags.format], 'number of channels inconsistent with specified format');
        }
        function setFlags(flags) {
            gl.pixelStorei(GL_UNPACK_FLIP_Y_WEBGL, flags.flipY);
            gl.pixelStorei(GL_UNPACK_PREMULTIPLY_ALPHA_WEBGL, flags.premultiplyAlpha);
            gl.pixelStorei(GL_UNPACK_COLORSPACE_CONVERSION_WEBGL, flags.colorSpace);
            gl.pixelStorei(GL_UNPACK_ALIGNMENT, flags.unpackAlignment);
        }
        // -------------------------------------------------------
        // Tex image data
        // -------------------------------------------------------
        function TexImage() {
            TexFlags.call(this);
            this.xOffset = 0;
            this.yOffset = 0;
            // data
            this.data = null;
            this.needsFree = false;
            // html element
            this.element = null;
            // copyTexImage info
            this.needsCopy = false;
        }
        function parseImage(image, options) {
            var data = null;
            if (isPixelData(options)) data = options;
            else if (options) {
                check$1.type(options, 'object', 'invalid pixel data type');
                parseFlags(image, options);
                if ('x' in options) image.xOffset = options.x | 0;
                if ('y' in options) image.yOffset = options.y | 0;
                if (isPixelData(options.data)) data = options.data;
            }
            check$1(!image.compressed || data instanceof Uint8Array, 'compressed texture data must be stored in a uint8array');
            if (options.copy) {
                check$1(!data, 'can not specify copy and data field for the same texture');
                var viewW = contextState.viewportWidth;
                var viewH = contextState.viewportHeight;
                image.width = image.width || viewW - image.xOffset;
                image.height = image.height || viewH - image.yOffset;
                image.needsCopy = true;
                check$1(image.xOffset >= 0 && image.xOffset < viewW && image.yOffset >= 0 && image.yOffset < viewH && image.width > 0 && image.width <= viewW && image.height > 0 && image.height <= viewH, 'copy texture read out of bounds');
            } else if (!data) {
                image.width = image.width || 1;
                image.height = image.height || 1;
                image.channels = image.channels || 4;
            } else if (isTypedArray(data)) {
                image.channels = image.channels || 4;
                image.data = data;
                if (!('type' in options) && image.type === GL_UNSIGNED_BYTE$5) image.type = typedArrayCode$1(data);
            } else if (isNumericArray(data)) {
                image.channels = image.channels || 4;
                convertData(image, data);
                image.alignment = 1;
                image.needsFree = true;
            } else if (isNDArrayLike(data)) {
                var array = data.data;
                if (!Array.isArray(array) && image.type === GL_UNSIGNED_BYTE$5) image.type = typedArrayCode$1(array);
                var shape = data.shape;
                var stride = data.stride;
                var shapeX, shapeY, shapeC, strideX, strideY, strideC;
                if (shape.length === 3) {
                    shapeC = shape[2];
                    strideC = stride[2];
                } else {
                    check$1(shape.length === 2, 'invalid ndarray pixel data, must be 2 or 3D');
                    shapeC = 1;
                    strideC = 1;
                }
                shapeX = shape[0];
                shapeY = shape[1];
                strideX = stride[0];
                strideY = stride[1];
                image.alignment = 1;
                image.width = shapeX;
                image.height = shapeY;
                image.channels = shapeC;
                image.format = image.internalformat = CHANNELS_FORMAT[shapeC];
                image.needsFree = true;
                transposeData(image, array, strideX, strideY, strideC, data.offset);
            } else if (isCanvasElement(data) || isOffscreenCanvas(data) || isContext2D(data)) {
                if (isCanvasElement(data) || isOffscreenCanvas(data)) image.element = data;
                else image.element = data.canvas;
                image.width = image.element.width;
                image.height = image.element.height;
                image.channels = 4;
            } else if (isBitmap(data)) {
                image.element = data;
                image.width = data.width;
                image.height = data.height;
                image.channels = 4;
            } else if (isImageElement(data)) {
                image.element = data;
                image.width = data.naturalWidth;
                image.height = data.naturalHeight;
                image.channels = 4;
            } else if (isVideoElement(data)) {
                image.element = data;
                image.width = data.videoWidth;
                image.height = data.videoHeight;
                image.channels = 4;
            } else if (isRectArray(data)) {
                var w = image.width || data[0].length;
                var h = image.height || data.length;
                var c = image.channels;
                if (isArrayLike(data[0][0])) c = c || data[0][0].length;
                else c = c || 1;
                var arrayShape = flattenUtils.shape(data);
                var n = 1;
                for(var dd = 0; dd < arrayShape.length; ++dd)n *= arrayShape[dd];
                var allocData = preConvert(image, n);
                flattenUtils.flatten(data, arrayShape, '', allocData);
                postConvert(image, allocData);
                image.alignment = 1;
                image.width = w;
                image.height = h;
                image.channels = c;
                image.format = image.internalformat = CHANNELS_FORMAT[c];
                image.needsFree = true;
            }
            if (image.type === GL_FLOAT$4) check$1(limits.extensions.indexOf('oes_texture_float') >= 0, 'oes_texture_float extension not enabled');
            else if (image.type === GL_HALF_FLOAT_OES$1) check$1(limits.extensions.indexOf('oes_texture_half_float') >= 0, 'oes_texture_half_float extension not enabled');
        // do compressed texture  validation here.
        }
        function setImage(info, target, miplevel) {
            var element = info.element;
            var data = info.data;
            var internalformat = info.internalformat;
            var format = info.format;
            var type = info.type;
            var width = info.width;
            var height = info.height;
            setFlags(info);
            if (element) gl.texImage2D(target, miplevel, format, format, type, element);
            else if (info.compressed) gl.compressedTexImage2D(target, miplevel, internalformat, width, height, 0, data);
            else if (info.needsCopy) {
                reglPoll();
                gl.copyTexImage2D(target, miplevel, format, info.xOffset, info.yOffset, width, height, 0);
            } else gl.texImage2D(target, miplevel, format, width, height, 0, format, type, data || null);
        }
        function setSubImage(info, target, x, y, miplevel) {
            var element = info.element;
            var data = info.data;
            var internalformat = info.internalformat;
            var format = info.format;
            var type = info.type;
            var width = info.width;
            var height = info.height;
            setFlags(info);
            if (element) gl.texSubImage2D(target, miplevel, x, y, format, type, element);
            else if (info.compressed) gl.compressedTexSubImage2D(target, miplevel, x, y, internalformat, width, height, data);
            else if (info.needsCopy) {
                reglPoll();
                gl.copyTexSubImage2D(target, miplevel, x, y, info.xOffset, info.yOffset, width, height);
            } else gl.texSubImage2D(target, miplevel, x, y, width, height, format, type, data);
        }
        // texImage pool
        var imagePool = [];
        function allocImage() {
            return imagePool.pop() || new TexImage();
        }
        function freeImage(image) {
            if (image.needsFree) pool.freeType(image.data);
            TexImage.call(image);
            imagePool.push(image);
        }
        // -------------------------------------------------------
        // Mip map
        // -------------------------------------------------------
        function MipMap() {
            TexFlags.call(this);
            this.genMipmaps = false;
            this.mipmapHint = GL_DONT_CARE;
            this.mipmask = 0;
            this.images = Array(16);
        }
        function parseMipMapFromShape(mipmap, width, height) {
            var img = mipmap.images[0] = allocImage();
            mipmap.mipmask = 1;
            img.width = mipmap.width = width;
            img.height = mipmap.height = height;
            img.channels = mipmap.channels = 4;
        }
        function parseMipMapFromObject(mipmap, options) {
            var imgData = null;
            if (isPixelData(options)) {
                imgData = mipmap.images[0] = allocImage();
                copyFlags(imgData, mipmap);
                parseImage(imgData, options);
                mipmap.mipmask = 1;
            } else {
                parseFlags(mipmap, options);
                if (Array.isArray(options.mipmap)) {
                    var mipData = options.mipmap;
                    for(var i = 0; i < mipData.length; ++i){
                        imgData = mipmap.images[i] = allocImage();
                        copyFlags(imgData, mipmap);
                        imgData.width >>= i;
                        imgData.height >>= i;
                        parseImage(imgData, mipData[i]);
                        mipmap.mipmask |= 1 << i;
                    }
                } else {
                    imgData = mipmap.images[0] = allocImage();
                    copyFlags(imgData, mipmap);
                    parseImage(imgData, options);
                    mipmap.mipmask = 1;
                }
            }
            copyFlags(mipmap, mipmap.images[0]);
            // For textures of the compressed format WEBGL_compressed_texture_s3tc
            // we must have that
            //
            // "When level equals zero width and height must be a multiple of 4.
            // When level is greater than 0 width and height must be 0, 1, 2 or a multiple of 4. "
            //
            // but we do not yet support having multiple mipmap levels for compressed textures,
            // so we only test for level zero.
            if (mipmap.compressed && (mipmap.internalformat === GL_COMPRESSED_RGB_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT1_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT3_EXT || mipmap.internalformat === GL_COMPRESSED_RGBA_S3TC_DXT5_EXT)) check$1(mipmap.width % 4 === 0 && mipmap.height % 4 === 0, 'for compressed texture formats, mipmap level 0 must have width and height that are a multiple of 4');
        }
        function setMipMap(mipmap, target) {
            var images = mipmap.images;
            for(var i = 0; i < images.length; ++i){
                if (!images[i]) return;
                setImage(images[i], target, i);
            }
        }
        var mipPool = [];
        function allocMipMap() {
            var result = mipPool.pop() || new MipMap();
            TexFlags.call(result);
            result.mipmask = 0;
            for(var i = 0; i < 16; ++i)result.images[i] = null;
            return result;
        }
        function freeMipMap(mipmap) {
            var images = mipmap.images;
            for(var i = 0; i < images.length; ++i){
                if (images[i]) freeImage(images[i]);
                images[i] = null;
            }
            mipPool.push(mipmap);
        }
        // -------------------------------------------------------
        // Tex info
        // -------------------------------------------------------
        function TexInfo() {
            this.minFilter = GL_NEAREST$1;
            this.magFilter = GL_NEAREST$1;
            this.wrapS = GL_CLAMP_TO_EDGE$1;
            this.wrapT = GL_CLAMP_TO_EDGE$1;
            this.anisotropic = 1;
            this.genMipmaps = false;
            this.mipmapHint = GL_DONT_CARE;
        }
        function parseTexInfo(info, options) {
            if ('min' in options) {
                var minFilter = options.min;
                check$1.parameter(minFilter, minFilters);
                info.minFilter = minFilters[minFilter];
                if (MIPMAP_FILTERS.indexOf(info.minFilter) >= 0 && !('faces' in options)) info.genMipmaps = true;
            }
            if ('mag' in options) {
                var magFilter = options.mag;
                check$1.parameter(magFilter, magFilters);
                info.magFilter = magFilters[magFilter];
            }
            var wrapS = info.wrapS;
            var wrapT = info.wrapT;
            if ('wrap' in options) {
                var wrap = options.wrap;
                if (typeof wrap === 'string') {
                    check$1.parameter(wrap, wrapModes);
                    wrapS = wrapT = wrapModes[wrap];
                } else if (Array.isArray(wrap)) {
                    check$1.parameter(wrap[0], wrapModes);
                    check$1.parameter(wrap[1], wrapModes);
                    wrapS = wrapModes[wrap[0]];
                    wrapT = wrapModes[wrap[1]];
                }
            } else {
                if ('wrapS' in options) {
                    var optWrapS = options.wrapS;
                    check$1.parameter(optWrapS, wrapModes);
                    wrapS = wrapModes[optWrapS];
                }
                if ('wrapT' in options) {
                    var optWrapT = options.wrapT;
                    check$1.parameter(optWrapT, wrapModes);
                    wrapT = wrapModes[optWrapT];
                }
            }
            info.wrapS = wrapS;
            info.wrapT = wrapT;
            if ('anisotropic' in options) {
                var anisotropic = options.anisotropic;
                check$1(typeof anisotropic === 'number' && anisotropic >= 1 && anisotropic <= limits.maxAnisotropic, 'aniso samples must be between 1 and ');
                info.anisotropic = options.anisotropic;
            }
            if ('mipmap' in options) {
                var hasMipMap = false;
                switch(typeof options.mipmap){
                    case 'string':
                        check$1.parameter(options.mipmap, mipmapHint, 'invalid mipmap hint');
                        info.mipmapHint = mipmapHint[options.mipmap];
                        info.genMipmaps = true;
                        hasMipMap = true;
                        break;
                    case 'boolean':
                        hasMipMap = info.genMipmaps = options.mipmap;
                        break;
                    case 'object':
                        check$1(Array.isArray(options.mipmap), 'invalid mipmap type');
                        info.genMipmaps = false;
                        hasMipMap = true;
                        break;
                    default:
                        check$1.raise('invalid mipmap type');
                }
                if (hasMipMap && !('min' in options)) info.minFilter = GL_NEAREST_MIPMAP_NEAREST$1;
            }
        }
        function setTexInfo(info, target) {
            gl.texParameteri(target, GL_TEXTURE_MIN_FILTER, info.minFilter);
            gl.texParameteri(target, GL_TEXTURE_MAG_FILTER, info.magFilter);
            gl.texParameteri(target, GL_TEXTURE_WRAP_S, info.wrapS);
            gl.texParameteri(target, GL_TEXTURE_WRAP_T, info.wrapT);
            if (extensions.ext_texture_filter_anisotropic) gl.texParameteri(target, GL_TEXTURE_MAX_ANISOTROPY_EXT, info.anisotropic);
            if (info.genMipmaps) {
                gl.hint(GL_GENERATE_MIPMAP_HINT, info.mipmapHint);
                gl.generateMipmap(target);
            }
        }
        // -------------------------------------------------------
        // Full texture object
        // -------------------------------------------------------
        var textureCount = 0;
        var textureSet = {};
        var numTexUnits = limits.maxTextureUnits;
        var textureUnits = Array(numTexUnits).map(function() {
            return null;
        });
        function REGLTexture(target) {
            TexFlags.call(this);
            this.mipmask = 0;
            this.internalformat = GL_RGBA$1;
            this.id = textureCount++;
            this.refCount = 1;
            this.target = target;
            this.texture = gl.createTexture();
            this.unit = -1;
            this.bindCount = 0;
            this.texInfo = new TexInfo();
            if (config.profile) this.stats = {
                size: 0
            };
        }
        function tempBind(texture) {
            gl.activeTexture(GL_TEXTURE0$1);
            gl.bindTexture(texture.target, texture.texture);
        }
        function tempRestore() {
            var prev = textureUnits[0];
            if (prev) gl.bindTexture(prev.target, prev.texture);
            else gl.bindTexture(GL_TEXTURE_2D$1, null);
        }
        function destroy(texture) {
            var handle = texture.texture;
            check$1(handle, 'must not double destroy texture');
            var unit = texture.unit;
            var target = texture.target;
            if (unit >= 0) {
                gl.activeTexture(GL_TEXTURE0$1 + unit);
                gl.bindTexture(target, null);
                textureUnits[unit] = null;
            }
            gl.deleteTexture(handle);
            texture.texture = null;
            texture.params = null;
            texture.pixels = null;
            texture.refCount = 0;
            delete textureSet[texture.id];
            stats.textureCount--;
        }
        extend(REGLTexture.prototype, {
            bind: function() {
                var texture = this;
                texture.bindCount += 1;
                var unit = texture.unit;
                if (unit < 0) {
                    for(var i = 0; i < numTexUnits; ++i){
                        var other = textureUnits[i];
                        if (other) {
                            if (other.bindCount > 0) continue;
                            other.unit = -1;
                        }
                        textureUnits[i] = texture;
                        unit = i;
                        break;
                    }
                    if (unit >= numTexUnits) check$1.raise('insufficient number of texture units');
                    if (config.profile && stats.maxTextureUnits < unit + 1) stats.maxTextureUnits = unit + 1 // +1, since the units are zero-based
                    ;
                    texture.unit = unit;
                    gl.activeTexture(GL_TEXTURE0$1 + unit);
                    gl.bindTexture(texture.target, texture.texture);
                }
                return unit;
            },
            unbind: function() {
                this.bindCount -= 1;
            },
            decRef: function() {
                if (--this.refCount <= 0) destroy(this);
            }
        });
        function createTexture2D(a, b) {
            var texture = new REGLTexture(GL_TEXTURE_2D$1);
            textureSet[texture.id] = texture;
            stats.textureCount++;
            function reglTexture2D(a, b) {
                var texInfo = texture.texInfo;
                TexInfo.call(texInfo);
                var mipData = allocMipMap();
                if (typeof a === 'number') {
                    if (typeof b === 'number') parseMipMapFromShape(mipData, a | 0, b | 0);
                    else parseMipMapFromShape(mipData, a | 0, a | 0);
                } else if (a) {
                    check$1.type(a, 'object', 'invalid arguments to regl.texture');
                    parseTexInfo(texInfo, a);
                    parseMipMapFromObject(mipData, a);
                } else // empty textures get assigned a default shape of 1x1
                parseMipMapFromShape(mipData, 1, 1);
                if (texInfo.genMipmaps) mipData.mipmask = (mipData.width << 1) - 1;
                texture.mipmask = mipData.mipmask;
                copyFlags(texture, mipData);
                check$1.texture2D(texInfo, mipData, limits);
                texture.internalformat = mipData.internalformat;
                reglTexture2D.width = mipData.width;
                reglTexture2D.height = mipData.height;
                tempBind(texture);
                setMipMap(mipData, GL_TEXTURE_2D$1);
                setTexInfo(texInfo, GL_TEXTURE_2D$1);
                tempRestore();
                freeMipMap(mipData);
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, mipData.width, mipData.height, texInfo.genMipmaps, false);
                reglTexture2D.format = textureFormatsInvert[texture.internalformat];
                reglTexture2D.type = textureTypesInvert[texture.type];
                reglTexture2D.mag = magFiltersInvert[texInfo.magFilter];
                reglTexture2D.min = minFiltersInvert[texInfo.minFilter];
                reglTexture2D.wrapS = wrapModesInvert[texInfo.wrapS];
                reglTexture2D.wrapT = wrapModesInvert[texInfo.wrapT];
                return reglTexture2D;
            }
            function subimage(image, x_, y_, level_) {
                check$1(!!image, 'must specify image data');
                var x = x_ | 0;
                var y = y_ | 0;
                var level = level_ | 0;
                var imageData = allocImage();
                copyFlags(imageData, texture);
                imageData.width = 0;
                imageData.height = 0;
                parseImage(imageData, image);
                imageData.width = imageData.width || (texture.width >> level) - x;
                imageData.height = imageData.height || (texture.height >> level) - y;
                check$1(texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat, 'incompatible format for texture.subimage');
                check$1(x >= 0 && y >= 0 && x + imageData.width <= texture.width && y + imageData.height <= texture.height, 'texture.subimage write out of bounds');
                check$1(texture.mipmask & 1 << level, 'missing mipmap data');
                check$1(imageData.data || imageData.element || imageData.needsCopy, 'missing image data');
                tempBind(texture);
                setSubImage(imageData, GL_TEXTURE_2D$1, x, y, level);
                tempRestore();
                freeImage(imageData);
                return reglTexture2D;
            }
            function resize(w_, h_) {
                var w = w_ | 0;
                var h = h_ | 0 || w;
                if (w === texture.width && h === texture.height) return reglTexture2D;
                reglTexture2D.width = texture.width = w;
                reglTexture2D.height = texture.height = h;
                tempBind(texture);
                for(var i = 0; texture.mipmask >> i; ++i){
                    var _w = w >> i;
                    var _h = h >> i;
                    if (!_w || !_h) break;
                    gl.texImage2D(GL_TEXTURE_2D$1, i, texture.format, _w, _h, 0, texture.format, texture.type, null);
                }
                tempRestore();
                // also, recompute the texture size.
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, w, h, false, false);
                return reglTexture2D;
            }
            reglTexture2D(a, b);
            reglTexture2D.subimage = subimage;
            reglTexture2D.resize = resize;
            reglTexture2D._reglType = 'texture2d';
            reglTexture2D._texture = texture;
            if (config.profile) reglTexture2D.stats = texture.stats;
            reglTexture2D.destroy = function() {
                texture.decRef();
            };
            return reglTexture2D;
        }
        function createTextureCube(a0, a1, a2, a3, a4, a5) {
            var texture = new REGLTexture(GL_TEXTURE_CUBE_MAP$1);
            textureSet[texture.id] = texture;
            stats.cubeCount++;
            var faces = new Array(6);
            function reglTextureCube(a0, a1, a2, a3, a4, a5) {
                var i;
                var texInfo = texture.texInfo;
                TexInfo.call(texInfo);
                for(i = 0; i < 6; ++i)faces[i] = allocMipMap();
                if (typeof a0 === 'number' || !a0) {
                    var s = a0 | 0 || 1;
                    for(i = 0; i < 6; ++i)parseMipMapFromShape(faces[i], s, s);
                } else if (typeof a0 === 'object') {
                    if (a1) {
                        parseMipMapFromObject(faces[0], a0);
                        parseMipMapFromObject(faces[1], a1);
                        parseMipMapFromObject(faces[2], a2);
                        parseMipMapFromObject(faces[3], a3);
                        parseMipMapFromObject(faces[4], a4);
                        parseMipMapFromObject(faces[5], a5);
                    } else {
                        parseTexInfo(texInfo, a0);
                        parseFlags(texture, a0);
                        if ('faces' in a0) {
                            var faceInput = a0.faces;
                            check$1(Array.isArray(faceInput) && faceInput.length === 6, 'cube faces must be a length 6 array');
                            for(i = 0; i < 6; ++i){
                                check$1(typeof faceInput[i] === 'object' && !!faceInput[i], 'invalid input for cube map face');
                                copyFlags(faces[i], texture);
                                parseMipMapFromObject(faces[i], faceInput[i]);
                            }
                        } else for(i = 0; i < 6; ++i)parseMipMapFromObject(faces[i], a0);
                    }
                } else check$1.raise('invalid arguments to cube map');
                copyFlags(texture, faces[0]);
                if (!limits.npotTextureCube) check$1(isPow2$1(texture.width) && isPow2$1(texture.height), 'your browser does not support non power or two texture dimensions');
                if (texInfo.genMipmaps) texture.mipmask = (faces[0].width << 1) - 1;
                else texture.mipmask = faces[0].mipmask;
                check$1.textureCube(texture, texInfo, faces, limits);
                texture.internalformat = faces[0].internalformat;
                reglTextureCube.width = faces[0].width;
                reglTextureCube.height = faces[0].height;
                tempBind(texture);
                for(i = 0; i < 6; ++i)setMipMap(faces[i], GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i);
                setTexInfo(texInfo, GL_TEXTURE_CUBE_MAP$1);
                tempRestore();
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, reglTextureCube.width, reglTextureCube.height, texInfo.genMipmaps, true);
                reglTextureCube.format = textureFormatsInvert[texture.internalformat];
                reglTextureCube.type = textureTypesInvert[texture.type];
                reglTextureCube.mag = magFiltersInvert[texInfo.magFilter];
                reglTextureCube.min = minFiltersInvert[texInfo.minFilter];
                reglTextureCube.wrapS = wrapModesInvert[texInfo.wrapS];
                reglTextureCube.wrapT = wrapModesInvert[texInfo.wrapT];
                for(i = 0; i < 6; ++i)freeMipMap(faces[i]);
                return reglTextureCube;
            }
            function subimage(face, image, x_, y_, level_) {
                check$1(!!image, 'must specify image data');
                check$1(typeof face === 'number' && face === (face | 0) && face >= 0 && face < 6, 'invalid face');
                var x = x_ | 0;
                var y = y_ | 0;
                var level = level_ | 0;
                var imageData = allocImage();
                copyFlags(imageData, texture);
                imageData.width = 0;
                imageData.height = 0;
                parseImage(imageData, image);
                imageData.width = imageData.width || (texture.width >> level) - x;
                imageData.height = imageData.height || (texture.height >> level) - y;
                check$1(texture.type === imageData.type && texture.format === imageData.format && texture.internalformat === imageData.internalformat, 'incompatible format for texture.subimage');
                check$1(x >= 0 && y >= 0 && x + imageData.width <= texture.width && y + imageData.height <= texture.height, 'texture.subimage write out of bounds');
                check$1(texture.mipmask & 1 << level, 'missing mipmap data');
                check$1(imageData.data || imageData.element || imageData.needsCopy, 'missing image data');
                tempBind(texture);
                setSubImage(imageData, GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + face, x, y, level);
                tempRestore();
                freeImage(imageData);
                return reglTextureCube;
            }
            function resize(radius_) {
                var radius = radius_ | 0;
                if (radius === texture.width) return;
                reglTextureCube.width = texture.width = radius;
                reglTextureCube.height = texture.height = radius;
                tempBind(texture);
                for(var i = 0; i < 6; ++i)for(var j = 0; texture.mipmask >> j; ++j)gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + i, j, texture.format, radius >> j, radius >> j, 0, texture.format, texture.type, null);
                tempRestore();
                if (config.profile) texture.stats.size = getTextureSize(texture.internalformat, texture.type, reglTextureCube.width, reglTextureCube.height, false, true);
                return reglTextureCube;
            }
            reglTextureCube(a0, a1, a2, a3, a4, a5);
            reglTextureCube.subimage = subimage;
            reglTextureCube.resize = resize;
            reglTextureCube._reglType = 'textureCube';
            reglTextureCube._texture = texture;
            if (config.profile) reglTextureCube.stats = texture.stats;
            reglTextureCube.destroy = function() {
                texture.decRef();
            };
            return reglTextureCube;
        }
        // Called when regl is destroyed
        function destroyTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                gl.activeTexture(GL_TEXTURE0$1 + i);
                gl.bindTexture(GL_TEXTURE_2D$1, null);
                textureUnits[i] = null;
            }
            values(textureSet).forEach(destroy);
            stats.cubeCount = 0;
            stats.textureCount = 0;
        }
        if (config.profile) stats.getTotalTextureSize = function() {
            var total = 0;
            Object.keys(textureSet).forEach(function(key) {
                total += textureSet[key].stats.size;
            });
            return total;
        };
        function restoreTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                var tex = textureUnits[i];
                if (tex) {
                    tex.bindCount = 0;
                    tex.unit = -1;
                    textureUnits[i] = null;
                }
            }
            values(textureSet).forEach(function(texture) {
                texture.texture = gl.createTexture();
                gl.bindTexture(texture.target, texture.texture);
                for(var i = 0; i < 32; ++i){
                    if ((texture.mipmask & 1 << i) === 0) continue;
                    if (texture.target === GL_TEXTURE_2D$1) gl.texImage2D(GL_TEXTURE_2D$1, i, texture.internalformat, texture.width >> i, texture.height >> i, 0, texture.internalformat, texture.type, null);
                    else for(var j = 0; j < 6; ++j)gl.texImage2D(GL_TEXTURE_CUBE_MAP_POSITIVE_X$1 + j, i, texture.internalformat, texture.width >> i, texture.height >> i, 0, texture.internalformat, texture.type, null);
                }
                setTexInfo(texture.texInfo, texture.target);
            });
        }
        function refreshTextures() {
            for(var i = 0; i < numTexUnits; ++i){
                var tex = textureUnits[i];
                if (tex) {
                    tex.bindCount = 0;
                    tex.unit = -1;
                    textureUnits[i] = null;
                }
                gl.activeTexture(GL_TEXTURE0$1 + i);
                gl.bindTexture(GL_TEXTURE_2D$1, null);
                gl.bindTexture(GL_TEXTURE_CUBE_MAP$1, null);
            }
        }
        return {
            create2D: createTexture2D,
            createCube: createTextureCube,
            clear: destroyTextures,
            getTexture: function(wrapper) {
                return null;
            },
            restore: restoreTextures,
            refresh: refreshTextures
        };
    }
    var GL_RENDERBUFFER = 0x8D41;
    var GL_RGBA4$1 = 0x8056;
    var GL_RGB5_A1$1 = 0x8057;
    var GL_RGB565$1 = 0x8D62;
    var GL_DEPTH_COMPONENT16 = 0x81A5;
    var GL_STENCIL_INDEX8 = 0x8D48;
    var GL_DEPTH_STENCIL$1 = 0x84F9;
    var GL_SRGB8_ALPHA8_EXT = 0x8C43;
    var GL_RGBA32F_EXT = 0x8814;
    var GL_RGBA16F_EXT = 0x881A;
    var GL_RGB16F_EXT = 0x881B;
    var FORMAT_SIZES = [];
    FORMAT_SIZES[GL_RGBA4$1] = 2;
    FORMAT_SIZES[GL_RGB5_A1$1] = 2;
    FORMAT_SIZES[GL_RGB565$1] = 2;
    FORMAT_SIZES[GL_DEPTH_COMPONENT16] = 2;
    FORMAT_SIZES[GL_STENCIL_INDEX8] = 1;
    FORMAT_SIZES[GL_DEPTH_STENCIL$1] = 4;
    FORMAT_SIZES[GL_SRGB8_ALPHA8_EXT] = 4;
    FORMAT_SIZES[GL_RGBA32F_EXT] = 16;
    FORMAT_SIZES[GL_RGBA16F_EXT] = 8;
    FORMAT_SIZES[GL_RGB16F_EXT] = 6;
    function getRenderbufferSize(format, width, height) {
        return FORMAT_SIZES[format] * width * height;
    }
    var wrapRenderbuffers = function(gl, extensions, limits, stats, config) {
        var formatTypes = {
            'rgba4': GL_RGBA4$1,
            'rgb565': GL_RGB565$1,
            'rgb5 a1': GL_RGB5_A1$1,
            'depth': GL_DEPTH_COMPONENT16,
            'stencil': GL_STENCIL_INDEX8,
            'depth stencil': GL_DEPTH_STENCIL$1
        };
        if (extensions.ext_srgb) formatTypes['srgba'] = GL_SRGB8_ALPHA8_EXT;
        if (extensions.ext_color_buffer_half_float) {
            formatTypes['rgba16f'] = GL_RGBA16F_EXT;
            formatTypes['rgb16f'] = GL_RGB16F_EXT;
        }
        if (extensions.webgl_color_buffer_float) formatTypes['rgba32f'] = GL_RGBA32F_EXT;
        var formatTypesInvert = [];
        Object.keys(formatTypes).forEach(function(key) {
            var val = formatTypes[key];
            formatTypesInvert[val] = key;
        });
        var renderbufferCount = 0;
        var renderbufferSet = {};
        function REGLRenderbuffer(renderbuffer) {
            this.id = renderbufferCount++;
            this.refCount = 1;
            this.renderbuffer = renderbuffer;
            this.format = GL_RGBA4$1;
            this.width = 0;
            this.height = 0;
            if (config.profile) this.stats = {
                size: 0
            };
        }
        REGLRenderbuffer.prototype.decRef = function() {
            if (--this.refCount <= 0) destroy(this);
        };
        function destroy(rb) {
            var handle = rb.renderbuffer;
            check$1(handle, 'must not double destroy renderbuffer');
            gl.bindRenderbuffer(GL_RENDERBUFFER, null);
            gl.deleteRenderbuffer(handle);
            rb.renderbuffer = null;
            rb.refCount = 0;
            delete renderbufferSet[rb.id];
            stats.renderbufferCount--;
        }
        function createRenderbuffer(a, b) {
            var renderbuffer = new REGLRenderbuffer(gl.createRenderbuffer());
            renderbufferSet[renderbuffer.id] = renderbuffer;
            stats.renderbufferCount++;
            function reglRenderbuffer(a, b) {
                var w = 0;
                var h = 0;
                var format = GL_RGBA4$1;
                if (typeof a === 'object' && a) {
                    var options = a;
                    if ('shape' in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, 'invalid renderbuffer shape');
                        w = shape[0] | 0;
                        h = shape[1] | 0;
                    } else {
                        if ('radius' in options) w = h = options.radius | 0;
                        if ('width' in options) w = options.width | 0;
                        if ('height' in options) h = options.height | 0;
                    }
                    if ('format' in options) {
                        check$1.parameter(options.format, formatTypes, 'invalid renderbuffer format');
                        format = formatTypes[options.format];
                    }
                } else if (typeof a === 'number') {
                    w = a | 0;
                    if (typeof b === 'number') h = b | 0;
                    else h = w;
                } else if (!a) w = h = 1;
                else check$1.raise('invalid arguments to renderbuffer constructor');
                // check shape
                check$1(w > 0 && h > 0 && w <= limits.maxRenderbufferSize && h <= limits.maxRenderbufferSize, 'invalid renderbuffer size');
                if (w === renderbuffer.width && h === renderbuffer.height && format === renderbuffer.format) return;
                reglRenderbuffer.width = renderbuffer.width = w;
                reglRenderbuffer.height = renderbuffer.height = h;
                renderbuffer.format = format;
                gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, format, w, h);
                check$1(gl.getError() === 0, 'invalid render buffer format');
                if (config.profile) renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
                reglRenderbuffer.format = formatTypesInvert[renderbuffer.format];
                return reglRenderbuffer;
            }
            function resize(w_, h_) {
                var w = w_ | 0;
                var h = h_ | 0 || w;
                if (w === renderbuffer.width && h === renderbuffer.height) return reglRenderbuffer;
                // check shape
                check$1(w > 0 && h > 0 && w <= limits.maxRenderbufferSize && h <= limits.maxRenderbufferSize, 'invalid renderbuffer size');
                reglRenderbuffer.width = renderbuffer.width = w;
                reglRenderbuffer.height = renderbuffer.height = h;
                gl.bindRenderbuffer(GL_RENDERBUFFER, renderbuffer.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, renderbuffer.format, w, h);
                check$1(gl.getError() === 0, 'invalid render buffer format');
                // also, recompute size.
                if (config.profile) renderbuffer.stats.size = getRenderbufferSize(renderbuffer.format, renderbuffer.width, renderbuffer.height);
                return reglRenderbuffer;
            }
            reglRenderbuffer(a, b);
            reglRenderbuffer.resize = resize;
            reglRenderbuffer._reglType = 'renderbuffer';
            reglRenderbuffer._renderbuffer = renderbuffer;
            if (config.profile) reglRenderbuffer.stats = renderbuffer.stats;
            reglRenderbuffer.destroy = function() {
                renderbuffer.decRef();
            };
            return reglRenderbuffer;
        }
        if (config.profile) stats.getTotalRenderbufferSize = function() {
            var total = 0;
            Object.keys(renderbufferSet).forEach(function(key) {
                total += renderbufferSet[key].stats.size;
            });
            return total;
        };
        function restoreRenderbuffers() {
            values(renderbufferSet).forEach(function(rb) {
                rb.renderbuffer = gl.createRenderbuffer();
                gl.bindRenderbuffer(GL_RENDERBUFFER, rb.renderbuffer);
                gl.renderbufferStorage(GL_RENDERBUFFER, rb.format, rb.width, rb.height);
            });
            gl.bindRenderbuffer(GL_RENDERBUFFER, null);
        }
        return {
            create: createRenderbuffer,
            clear: function() {
                values(renderbufferSet).forEach(destroy);
            },
            restore: restoreRenderbuffers
        };
    };
    // We store these constants so that the minifier can inline them
    var GL_FRAMEBUFFER$1 = 0x8D40;
    var GL_RENDERBUFFER$1 = 0x8D41;
    var GL_TEXTURE_2D$2 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 = 0x8515;
    var GL_COLOR_ATTACHMENT0$1 = 0x8CE0;
    var GL_DEPTH_ATTACHMENT = 0x8D00;
    var GL_STENCIL_ATTACHMENT = 0x8D20;
    var GL_DEPTH_STENCIL_ATTACHMENT = 0x821A;
    var GL_FRAMEBUFFER_COMPLETE$1 = 0x8CD5;
    var GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT = 0x8CD6;
    var GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = 0x8CD7;
    var GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS = 0x8CD9;
    var GL_FRAMEBUFFER_UNSUPPORTED = 0x8CDD;
    var GL_HALF_FLOAT_OES$2 = 0x8D61;
    var GL_UNSIGNED_BYTE$6 = 0x1401;
    var GL_FLOAT$5 = 0x1406;
    var GL_RGB$1 = 0x1907;
    var GL_RGBA$2 = 0x1908;
    var GL_DEPTH_COMPONENT$1 = 0x1902;
    var colorTextureFormatEnums = [
        GL_RGB$1,
        GL_RGBA$2
    ];
    // for every texture format, store
    // the number of channels
    var textureFormatChannels = [];
    textureFormatChannels[GL_RGBA$2] = 4;
    textureFormatChannels[GL_RGB$1] = 3;
    // for every texture type, store
    // the size in bytes.
    var textureTypeSizes = [];
    textureTypeSizes[GL_UNSIGNED_BYTE$6] = 1;
    textureTypeSizes[GL_FLOAT$5] = 4;
    textureTypeSizes[GL_HALF_FLOAT_OES$2] = 2;
    var GL_RGBA4$2 = 0x8056;
    var GL_RGB5_A1$2 = 0x8057;
    var GL_RGB565$2 = 0x8D62;
    var GL_DEPTH_COMPONENT16$1 = 0x81A5;
    var GL_STENCIL_INDEX8$1 = 0x8D48;
    var GL_DEPTH_STENCIL$2 = 0x84F9;
    var GL_SRGB8_ALPHA8_EXT$1 = 0x8C43;
    var GL_RGBA32F_EXT$1 = 0x8814;
    var GL_RGBA16F_EXT$1 = 0x881A;
    var GL_RGB16F_EXT$1 = 0x881B;
    var colorRenderbufferFormatEnums = [
        GL_RGBA4$2,
        GL_RGB5_A1$2,
        GL_RGB565$2,
        GL_SRGB8_ALPHA8_EXT$1,
        GL_RGBA16F_EXT$1,
        GL_RGB16F_EXT$1,
        GL_RGBA32F_EXT$1
    ];
    var statusCode = {};
    statusCode[GL_FRAMEBUFFER_COMPLETE$1] = 'complete';
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT] = 'incomplete attachment';
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_DIMENSIONS] = 'incomplete dimensions';
    statusCode[GL_FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT] = 'incomplete, missing attachment';
    statusCode[GL_FRAMEBUFFER_UNSUPPORTED] = 'unsupported';
    function wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats) {
        var framebufferState = {
            cur: null,
            next: null,
            dirty: false,
            setFBO: null
        };
        var colorTextureFormats = [
            'rgba'
        ];
        var colorRenderbufferFormats = [
            'rgba4',
            'rgb565',
            'rgb5 a1'
        ];
        if (extensions.ext_srgb) colorRenderbufferFormats.push('srgba');
        if (extensions.ext_color_buffer_half_float) colorRenderbufferFormats.push('rgba16f', 'rgb16f');
        if (extensions.webgl_color_buffer_float) colorRenderbufferFormats.push('rgba32f');
        var colorTypes = [
            'uint8'
        ];
        if (extensions.oes_texture_half_float) colorTypes.push('half float', 'float16');
        if (extensions.oes_texture_float) colorTypes.push('float', 'float32');
        function FramebufferAttachment(target, texture, renderbuffer) {
            this.target = target;
            this.texture = texture;
            this.renderbuffer = renderbuffer;
            var w = 0;
            var h = 0;
            if (texture) {
                w = texture.width;
                h = texture.height;
            } else if (renderbuffer) {
                w = renderbuffer.width;
                h = renderbuffer.height;
            }
            this.width = w;
            this.height = h;
        }
        function decRef(attachment) {
            if (attachment) {
                if (attachment.texture) attachment.texture._texture.decRef();
                if (attachment.renderbuffer) attachment.renderbuffer._renderbuffer.decRef();
            }
        }
        function incRefAndCheckShape(attachment, width, height) {
            if (!attachment) return;
            if (attachment.texture) {
                var texture = attachment.texture._texture;
                var tw = Math.max(1, texture.width);
                var th = Math.max(1, texture.height);
                check$1(tw === width && th === height, 'inconsistent width/height for supplied texture');
                texture.refCount += 1;
            } else {
                var renderbuffer = attachment.renderbuffer._renderbuffer;
                check$1(renderbuffer.width === width && renderbuffer.height === height, 'inconsistent width/height for renderbuffer');
                renderbuffer.refCount += 1;
            }
        }
        function attach(location, attachment) {
            if (attachment) {
                if (attachment.texture) gl.framebufferTexture2D(GL_FRAMEBUFFER$1, location, attachment.target, attachment.texture._texture.texture, 0);
                else gl.framebufferRenderbuffer(GL_FRAMEBUFFER$1, location, GL_RENDERBUFFER$1, attachment.renderbuffer._renderbuffer.renderbuffer);
            }
        }
        function parseAttachment(attachment) {
            var target = GL_TEXTURE_2D$2;
            var texture = null;
            var renderbuffer = null;
            var data = attachment;
            if (typeof attachment === 'object') {
                data = attachment.data;
                if ('target' in attachment) target = attachment.target | 0;
            }
            check$1.type(data, 'function', 'invalid attachment data');
            var type = data._reglType;
            if (type === 'texture2d') {
                texture = data;
                check$1(target === GL_TEXTURE_2D$2);
            } else if (type === 'textureCube') {
                texture = data;
                check$1(target >= GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 && target < GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + 6, 'invalid cube map target');
            } else if (type === 'renderbuffer') {
                renderbuffer = data;
                target = GL_RENDERBUFFER$1;
            } else check$1.raise('invalid regl object for attachment');
            return new FramebufferAttachment(target, texture, renderbuffer);
        }
        function allocAttachment(width, height, isTexture, format, type) {
            if (isTexture) {
                var texture = textureState.create2D({
                    width: width,
                    height: height,
                    format: format,
                    type: type
                });
                texture._texture.refCount = 0;
                return new FramebufferAttachment(GL_TEXTURE_2D$2, texture, null);
            } else {
                var rb = renderbufferState.create({
                    width: width,
                    height: height,
                    format: format
                });
                rb._renderbuffer.refCount = 0;
                return new FramebufferAttachment(GL_RENDERBUFFER$1, null, rb);
            }
        }
        function unwrapAttachment(attachment) {
            return attachment && (attachment.texture || attachment.renderbuffer);
        }
        function resizeAttachment(attachment, w, h) {
            if (attachment) {
                if (attachment.texture) attachment.texture.resize(w, h);
                else if (attachment.renderbuffer) attachment.renderbuffer.resize(w, h);
                attachment.width = w;
                attachment.height = h;
            }
        }
        var framebufferCount = 0;
        var framebufferSet = {};
        function REGLFramebuffer() {
            this.id = framebufferCount++;
            framebufferSet[this.id] = this;
            this.framebuffer = gl.createFramebuffer();
            this.width = 0;
            this.height = 0;
            this.colorAttachments = [];
            this.depthAttachment = null;
            this.stencilAttachment = null;
            this.depthStencilAttachment = null;
        }
        function decFBORefs(framebuffer) {
            framebuffer.colorAttachments.forEach(decRef);
            decRef(framebuffer.depthAttachment);
            decRef(framebuffer.stencilAttachment);
            decRef(framebuffer.depthStencilAttachment);
        }
        function destroy(framebuffer) {
            var handle = framebuffer.framebuffer;
            check$1(handle, 'must not double destroy framebuffer');
            gl.deleteFramebuffer(handle);
            framebuffer.framebuffer = null;
            stats.framebufferCount--;
            delete framebufferSet[framebuffer.id];
        }
        function updateFramebuffer(framebuffer) {
            var i;
            gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebuffer.framebuffer);
            var colorAttachments = framebuffer.colorAttachments;
            for(i = 0; i < colorAttachments.length; ++i)attach(GL_COLOR_ATTACHMENT0$1 + i, colorAttachments[i]);
            for(i = colorAttachments.length; i < limits.maxColorAttachments; ++i)gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_COLOR_ATTACHMENT0$1 + i, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_DEPTH_STENCIL_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_DEPTH_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            gl.framebufferTexture2D(GL_FRAMEBUFFER$1, GL_STENCIL_ATTACHMENT, GL_TEXTURE_2D$2, null, 0);
            attach(GL_DEPTH_ATTACHMENT, framebuffer.depthAttachment);
            attach(GL_STENCIL_ATTACHMENT, framebuffer.stencilAttachment);
            attach(GL_DEPTH_STENCIL_ATTACHMENT, framebuffer.depthStencilAttachment);
            // Check status code
            var status = gl.checkFramebufferStatus(GL_FRAMEBUFFER$1);
            if (!gl.isContextLost() && status !== GL_FRAMEBUFFER_COMPLETE$1) check$1.raise('framebuffer configuration not supported, status = ' + statusCode[status]);
            gl.bindFramebuffer(GL_FRAMEBUFFER$1, framebufferState.next ? framebufferState.next.framebuffer : null);
            framebufferState.cur = framebufferState.next;
            // FIXME: Clear error code here.  This is a work around for a bug in
            // headless-gl
            gl.getError();
        }
        function createFBO(a0, a1) {
            var framebuffer = new REGLFramebuffer();
            stats.framebufferCount++;
            function reglFramebuffer(a, b) {
                var i;
                check$1(framebufferState.next !== framebuffer, 'can not update framebuffer which is currently in use');
                var width = 0;
                var height = 0;
                var needsDepth = true;
                var needsStencil = true;
                var colorBuffer = null;
                var colorTexture = true;
                var colorFormat = 'rgba';
                var colorType = 'uint8';
                var colorCount = 1;
                var depthBuffer = null;
                var stencilBuffer = null;
                var depthStencilBuffer = null;
                var depthStencilTexture = false;
                if (typeof a === 'number') {
                    width = a | 0;
                    height = b | 0 || width;
                } else if (!a) width = height = 1;
                else {
                    check$1.type(a, 'object', 'invalid arguments for framebuffer');
                    var options = a;
                    if ('shape' in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, 'invalid shape for framebuffer');
                        width = shape[0];
                        height = shape[1];
                    } else {
                        if ('radius' in options) width = height = options.radius;
                        if ('width' in options) width = options.width;
                        if ('height' in options) height = options.height;
                    }
                    if ('color' in options || 'colors' in options) {
                        colorBuffer = options.color || options.colors;
                        if (Array.isArray(colorBuffer)) check$1(colorBuffer.length === 1 || extensions.webgl_draw_buffers, 'multiple render targets not supported');
                    }
                    if (!colorBuffer) {
                        if ('colorCount' in options) {
                            colorCount = options.colorCount | 0;
                            check$1(colorCount > 0, 'invalid color buffer count');
                        }
                        if ('colorTexture' in options) {
                            colorTexture = !!options.colorTexture;
                            colorFormat = 'rgba4';
                        }
                        if ('colorType' in options) {
                            colorType = options.colorType;
                            if (!colorTexture) {
                                if (colorType === 'half float' || colorType === 'float16') {
                                    check$1(extensions.ext_color_buffer_half_float, 'you must enable EXT_color_buffer_half_float to use 16-bit render buffers');
                                    colorFormat = 'rgba16f';
                                } else if (colorType === 'float' || colorType === 'float32') {
                                    check$1(extensions.webgl_color_buffer_float, 'you must enable WEBGL_color_buffer_float in order to use 32-bit floating point renderbuffers');
                                    colorFormat = 'rgba32f';
                                }
                            } else {
                                check$1(extensions.oes_texture_float || !(colorType === 'float' || colorType === 'float32'), 'you must enable OES_texture_float in order to use floating point framebuffer objects');
                                check$1(extensions.oes_texture_half_float || !(colorType === 'half float' || colorType === 'float16'), 'you must enable OES_texture_half_float in order to use 16-bit floating point framebuffer objects');
                            }
                            check$1.oneOf(colorType, colorTypes, 'invalid color type');
                        }
                        if ('colorFormat' in options) {
                            colorFormat = options.colorFormat;
                            if (colorTextureFormats.indexOf(colorFormat) >= 0) colorTexture = true;
                            else if (colorRenderbufferFormats.indexOf(colorFormat) >= 0) colorTexture = false;
                            else if (colorTexture) check$1.oneOf(options.colorFormat, colorTextureFormats, 'invalid color format for texture');
                            else check$1.oneOf(options.colorFormat, colorRenderbufferFormats, 'invalid color format for renderbuffer');
                        }
                    }
                    if ('depthTexture' in options || 'depthStencilTexture' in options) {
                        depthStencilTexture = !!(options.depthTexture || options.depthStencilTexture);
                        check$1(!depthStencilTexture || extensions.webgl_depth_texture, 'webgl_depth_texture extension not supported');
                    }
                    if ('depth' in options) {
                        if (typeof options.depth === 'boolean') needsDepth = options.depth;
                        else {
                            depthBuffer = options.depth;
                            needsStencil = false;
                        }
                    }
                    if ('stencil' in options) {
                        if (typeof options.stencil === 'boolean') needsStencil = options.stencil;
                        else {
                            stencilBuffer = options.stencil;
                            needsDepth = false;
                        }
                    }
                    if ('depthStencil' in options) {
                        if (typeof options.depthStencil === 'boolean') needsDepth = needsStencil = options.depthStencil;
                        else {
                            depthStencilBuffer = options.depthStencil;
                            needsDepth = false;
                            needsStencil = false;
                        }
                    }
                }
                // parse attachments
                var colorAttachments = null;
                var depthAttachment = null;
                var stencilAttachment = null;
                var depthStencilAttachment = null;
                // Set up color attachments
                if (Array.isArray(colorBuffer)) colorAttachments = colorBuffer.map(parseAttachment);
                else if (colorBuffer) colorAttachments = [
                    parseAttachment(colorBuffer)
                ];
                else {
                    colorAttachments = new Array(colorCount);
                    for(i = 0; i < colorCount; ++i)colorAttachments[i] = allocAttachment(width, height, colorTexture, colorFormat, colorType);
                }
                check$1(extensions.webgl_draw_buffers || colorAttachments.length <= 1, 'you must enable the WEBGL_draw_buffers extension in order to use multiple color buffers.');
                check$1(colorAttachments.length <= limits.maxColorAttachments, 'too many color attachments, not supported');
                width = width || colorAttachments[0].width;
                height = height || colorAttachments[0].height;
                if (depthBuffer) depthAttachment = parseAttachment(depthBuffer);
                else if (needsDepth && !needsStencil) depthAttachment = allocAttachment(width, height, depthStencilTexture, 'depth', 'uint32');
                if (stencilBuffer) stencilAttachment = parseAttachment(stencilBuffer);
                else if (needsStencil && !needsDepth) stencilAttachment = allocAttachment(width, height, false, 'stencil', 'uint8');
                if (depthStencilBuffer) depthStencilAttachment = parseAttachment(depthStencilBuffer);
                else if (!depthBuffer && !stencilBuffer && needsStencil && needsDepth) depthStencilAttachment = allocAttachment(width, height, depthStencilTexture, 'depth stencil', 'depth stencil');
                check$1(!!depthBuffer + !!stencilBuffer + !!depthStencilBuffer <= 1, 'invalid framebuffer configuration, can specify exactly one depth/stencil attachment');
                var commonColorAttachmentSize = null;
                for(i = 0; i < colorAttachments.length; ++i){
                    incRefAndCheckShape(colorAttachments[i], width, height);
                    check$1(!colorAttachments[i] || colorAttachments[i].texture && colorTextureFormatEnums.indexOf(colorAttachments[i].texture._texture.format) >= 0 || colorAttachments[i].renderbuffer && colorRenderbufferFormatEnums.indexOf(colorAttachments[i].renderbuffer._renderbuffer.format) >= 0, 'framebuffer color attachment ' + i + ' is invalid');
                    if (colorAttachments[i] && colorAttachments[i].texture) {
                        var colorAttachmentSize = textureFormatChannels[colorAttachments[i].texture._texture.format] * textureTypeSizes[colorAttachments[i].texture._texture.type];
                        if (commonColorAttachmentSize === null) commonColorAttachmentSize = colorAttachmentSize;
                        else // We need to make sure that all color attachments have the same number of bitplanes
                        // (that is, the same numer of bits per pixel)
                        // This is required by the GLES2.0 standard. See the beginning of Chapter 4 in that document.
                        check$1(commonColorAttachmentSize === colorAttachmentSize, 'all color attachments much have the same number of bits per pixel.');
                    }
                }
                incRefAndCheckShape(depthAttachment, width, height);
                check$1(!depthAttachment || depthAttachment.texture && depthAttachment.texture._texture.format === GL_DEPTH_COMPONENT$1 || depthAttachment.renderbuffer && depthAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_COMPONENT16$1, 'invalid depth attachment for framebuffer object');
                incRefAndCheckShape(stencilAttachment, width, height);
                check$1(!stencilAttachment || stencilAttachment.renderbuffer && stencilAttachment.renderbuffer._renderbuffer.format === GL_STENCIL_INDEX8$1, 'invalid stencil attachment for framebuffer object');
                incRefAndCheckShape(depthStencilAttachment, width, height);
                check$1(!depthStencilAttachment || depthStencilAttachment.texture && depthStencilAttachment.texture._texture.format === GL_DEPTH_STENCIL$2 || depthStencilAttachment.renderbuffer && depthStencilAttachment.renderbuffer._renderbuffer.format === GL_DEPTH_STENCIL$2, 'invalid depth-stencil attachment for framebuffer object');
                // decrement references
                decFBORefs(framebuffer);
                framebuffer.width = width;
                framebuffer.height = height;
                framebuffer.colorAttachments = colorAttachments;
                framebuffer.depthAttachment = depthAttachment;
                framebuffer.stencilAttachment = stencilAttachment;
                framebuffer.depthStencilAttachment = depthStencilAttachment;
                reglFramebuffer.color = colorAttachments.map(unwrapAttachment);
                reglFramebuffer.depth = unwrapAttachment(depthAttachment);
                reglFramebuffer.stencil = unwrapAttachment(stencilAttachment);
                reglFramebuffer.depthStencil = unwrapAttachment(depthStencilAttachment);
                reglFramebuffer.width = framebuffer.width;
                reglFramebuffer.height = framebuffer.height;
                updateFramebuffer(framebuffer);
                return reglFramebuffer;
            }
            function resize(w_, h_) {
                check$1(framebufferState.next !== framebuffer, 'can not resize a framebuffer which is currently in use');
                var w = Math.max(w_ | 0, 1);
                var h = Math.max(h_ | 0 || w, 1);
                if (w === framebuffer.width && h === framebuffer.height) return reglFramebuffer;
                // resize all buffers
                var colorAttachments = framebuffer.colorAttachments;
                for(var i = 0; i < colorAttachments.length; ++i)resizeAttachment(colorAttachments[i], w, h);
                resizeAttachment(framebuffer.depthAttachment, w, h);
                resizeAttachment(framebuffer.stencilAttachment, w, h);
                resizeAttachment(framebuffer.depthStencilAttachment, w, h);
                framebuffer.width = reglFramebuffer.width = w;
                framebuffer.height = reglFramebuffer.height = h;
                updateFramebuffer(framebuffer);
                return reglFramebuffer;
            }
            reglFramebuffer(a0, a1);
            return extend(reglFramebuffer, {
                resize: resize,
                _reglType: 'framebuffer',
                _framebuffer: framebuffer,
                destroy: function() {
                    destroy(framebuffer);
                    decFBORefs(framebuffer);
                },
                use: function(block) {
                    framebufferState.setFBO({
                        framebuffer: reglFramebuffer
                    }, block);
                }
            });
        }
        function createCubeFBO(options) {
            var faces = Array(6);
            function reglFramebufferCube(a) {
                var i;
                check$1(faces.indexOf(framebufferState.next) < 0, 'can not update framebuffer which is currently in use');
                var params = {
                    color: null
                };
                var radius = 0;
                var colorBuffer = null;
                var colorFormat = 'rgba';
                var colorType = 'uint8';
                var colorCount = 1;
                if (typeof a === 'number') radius = a | 0;
                else if (!a) radius = 1;
                else {
                    check$1.type(a, 'object', 'invalid arguments for framebuffer');
                    var options = a;
                    if ('shape' in options) {
                        var shape = options.shape;
                        check$1(Array.isArray(shape) && shape.length >= 2, 'invalid shape for framebuffer');
                        check$1(shape[0] === shape[1], 'cube framebuffer must be square');
                        radius = shape[0];
                    } else {
                        if ('radius' in options) radius = options.radius | 0;
                        if ('width' in options) {
                            radius = options.width | 0;
                            if ('height' in options) check$1(options.height === radius, 'must be square');
                        } else if ('height' in options) radius = options.height | 0;
                    }
                    if ('color' in options || 'colors' in options) {
                        colorBuffer = options.color || options.colors;
                        if (Array.isArray(colorBuffer)) check$1(colorBuffer.length === 1 || extensions.webgl_draw_buffers, 'multiple render targets not supported');
                    }
                    if (!colorBuffer) {
                        if ('colorCount' in options) {
                            colorCount = options.colorCount | 0;
                            check$1(colorCount > 0, 'invalid color buffer count');
                        }
                        if ('colorType' in options) {
                            check$1.oneOf(options.colorType, colorTypes, 'invalid color type');
                            colorType = options.colorType;
                        }
                        if ('colorFormat' in options) {
                            colorFormat = options.colorFormat;
                            check$1.oneOf(options.colorFormat, colorTextureFormats, 'invalid color format for texture');
                        }
                    }
                    if ('depth' in options) params.depth = options.depth;
                    if ('stencil' in options) params.stencil = options.stencil;
                    if ('depthStencil' in options) params.depthStencil = options.depthStencil;
                }
                var colorCubes;
                if (colorBuffer) {
                    if (Array.isArray(colorBuffer)) {
                        colorCubes = [];
                        for(i = 0; i < colorBuffer.length; ++i)colorCubes[i] = colorBuffer[i];
                    } else colorCubes = [
                        colorBuffer
                    ];
                } else {
                    colorCubes = Array(colorCount);
                    var cubeMapParams = {
                        radius: radius,
                        format: colorFormat,
                        type: colorType
                    };
                    for(i = 0; i < colorCount; ++i)colorCubes[i] = textureState.createCube(cubeMapParams);
                }
                // Check color cubes
                params.color = Array(colorCubes.length);
                for(i = 0; i < colorCubes.length; ++i){
                    var cube = colorCubes[i];
                    check$1(typeof cube === 'function' && cube._reglType === 'textureCube', 'invalid cube map');
                    radius = radius || cube.width;
                    check$1(cube.width === radius && cube.height === radius, 'invalid cube map shape');
                    params.color[i] = {
                        target: GL_TEXTURE_CUBE_MAP_POSITIVE_X$2,
                        data: colorCubes[i]
                    };
                }
                for(i = 0; i < 6; ++i){
                    for(var j = 0; j < colorCubes.length; ++j)params.color[j].target = GL_TEXTURE_CUBE_MAP_POSITIVE_X$2 + i;
                    // reuse depth-stencil attachments across all cube maps
                    if (i > 0) {
                        params.depth = faces[0].depth;
                        params.stencil = faces[0].stencil;
                        params.depthStencil = faces[0].depthStencil;
                    }
                    if (faces[i]) faces[i](params);
                    else faces[i] = createFBO(params);
                }
                return extend(reglFramebufferCube, {
                    width: radius,
                    height: radius,
                    color: colorCubes
                });
            }
            function resize(radius_) {
                var i;
                var radius = radius_ | 0;
                check$1(radius > 0 && radius <= limits.maxCubeMapSize, 'invalid radius for cube fbo');
                if (radius === reglFramebufferCube.width) return reglFramebufferCube;
                var colors = reglFramebufferCube.color;
                for(i = 0; i < colors.length; ++i)colors[i].resize(radius);
                for(i = 0; i < 6; ++i)faces[i].resize(radius);
                reglFramebufferCube.width = reglFramebufferCube.height = radius;
                return reglFramebufferCube;
            }
            reglFramebufferCube(options);
            return extend(reglFramebufferCube, {
                faces: faces,
                resize: resize,
                _reglType: 'framebufferCube',
                destroy: function() {
                    faces.forEach(function(f) {
                        f.destroy();
                    });
                }
            });
        }
        function restoreFramebuffers() {
            framebufferState.cur = null;
            framebufferState.next = null;
            framebufferState.dirty = true;
            values(framebufferSet).forEach(function(fb) {
                fb.framebuffer = gl.createFramebuffer();
                updateFramebuffer(fb);
            });
        }
        return extend(framebufferState, {
            getFramebuffer: function(object) {
                if (typeof object === 'function' && object._reglType === 'framebuffer') {
                    var fbo = object._framebuffer;
                    if (fbo instanceof REGLFramebuffer) return fbo;
                }
                return null;
            },
            create: createFBO,
            createCube: createCubeFBO,
            clear: function() {
                values(framebufferSet).forEach(destroy);
            },
            restore: restoreFramebuffers
        });
    }
    var GL_FLOAT$6 = 5126;
    var GL_ARRAY_BUFFER$1 = 34962;
    function AttributeRecord() {
        this.state = 0;
        this.x = 0.0;
        this.y = 0.0;
        this.z = 0.0;
        this.w = 0.0;
        this.buffer = null;
        this.size = 0;
        this.normalized = false;
        this.type = GL_FLOAT$6;
        this.offset = 0;
        this.stride = 0;
        this.divisor = 0;
    }
    function wrapAttributeState(gl, extensions, limits, stats, bufferState) {
        var NUM_ATTRIBUTES = limits.maxAttributes;
        var attributeBindings = new Array(NUM_ATTRIBUTES);
        for(var i = 0; i < NUM_ATTRIBUTES; ++i)attributeBindings[i] = new AttributeRecord();
        var vaoCount = 0;
        var vaoSet = {};
        var state = {
            Record: AttributeRecord,
            scope: {},
            state: attributeBindings,
            currentVAO: null,
            targetVAO: null,
            restore: extVAO() ? restoreVAO : function() {},
            createVAO: createVAO,
            getVAO: getVAO,
            destroyBuffer: destroyBuffer,
            setVAO: extVAO() ? setVAOEXT : setVAOEmulated,
            clear: extVAO() ? destroyVAOEXT : function() {}
        };
        function destroyBuffer(buffer) {
            for(var i = 0; i < attributeBindings.length; ++i){
                var record = attributeBindings[i];
                if (record.buffer === buffer) {
                    gl.disableVertexAttribArray(i);
                    record.buffer = null;
                }
            }
        }
        function extVAO() {
            return extensions.oes_vertex_array_object;
        }
        function extInstanced() {
            return extensions.angle_instanced_arrays;
        }
        function getVAO(vao) {
            if (typeof vao === 'function' && vao._vao) return vao._vao;
            return null;
        }
        function setVAOEXT(vao) {
            if (vao === state.currentVAO) return;
            var ext = extVAO();
            if (vao) ext.bindVertexArrayOES(vao.vao);
            else ext.bindVertexArrayOES(null);
            state.currentVAO = vao;
        }
        function setVAOEmulated(vao) {
            if (vao === state.currentVAO) return;
            if (vao) vao.bindAttrs();
            else {
                var exti = extInstanced();
                for(var i = 0; i < attributeBindings.length; ++i){
                    var binding = attributeBindings[i];
                    if (binding.buffer) {
                        gl.enableVertexAttribArray(i);
                        gl.vertexAttribPointer(i, binding.size, binding.type, binding.normalized, binding.stride, binding.offfset);
                        if (exti && binding.divisor) exti.vertexAttribDivisorANGLE(i, binding.divisor);
                    } else {
                        gl.disableVertexAttribArray(i);
                        gl.vertexAttrib4f(i, binding.x, binding.y, binding.z, binding.w);
                    }
                }
            }
            state.currentVAO = vao;
        }
        function destroyVAOEXT() {
            values(vaoSet).forEach(function(vao) {
                vao.destroy();
            });
        }
        function REGLVAO() {
            this.id = ++vaoCount;
            this.attributes = [];
            var extension = extVAO();
            if (extension) this.vao = extension.createVertexArrayOES();
            else this.vao = null;
            vaoSet[this.id] = this;
            this.buffers = [];
        }
        REGLVAO.prototype.bindAttrs = function() {
            var exti = extInstanced();
            var attributes = this.attributes;
            for(var i = 0; i < attributes.length; ++i){
                var attr = attributes[i];
                if (attr.buffer) {
                    gl.enableVertexAttribArray(i);
                    gl.bindBuffer(GL_ARRAY_BUFFER$1, attr.buffer.buffer);
                    gl.vertexAttribPointer(i, attr.size, attr.type, attr.normalized, attr.stride, attr.offset);
                    if (exti && attr.divisor) exti.vertexAttribDivisorANGLE(i, attr.divisor);
                } else {
                    gl.disableVertexAttribArray(i);
                    gl.vertexAttrib4f(i, attr.x, attr.y, attr.z, attr.w);
                }
            }
            for(var j = attributes.length; j < NUM_ATTRIBUTES; ++j)gl.disableVertexAttribArray(j);
        };
        REGLVAO.prototype.refresh = function() {
            var ext = extVAO();
            if (ext) {
                ext.bindVertexArrayOES(this.vao);
                this.bindAttrs();
                state.currentVAO = this;
            }
        };
        REGLVAO.prototype.destroy = function() {
            if (this.vao) {
                var extension = extVAO();
                if (this === state.currentVAO) {
                    state.currentVAO = null;
                    extension.bindVertexArrayOES(null);
                }
                extension.deleteVertexArrayOES(this.vao);
                this.vao = null;
            }
            if (vaoSet[this.id]) {
                delete vaoSet[this.id];
                stats.vaoCount -= 1;
            }
        };
        function restoreVAO() {
            var ext = extVAO();
            if (ext) values(vaoSet).forEach(function(vao) {
                vao.refresh();
            });
        }
        function createVAO(_attr) {
            var vao = new REGLVAO();
            stats.vaoCount += 1;
            function updateVAO(attributes) {
                check$1(Array.isArray(attributes), 'arguments to vertex array constructor must be an array');
                check$1(attributes.length < NUM_ATTRIBUTES, 'too many attributes');
                check$1(attributes.length > 0, 'must specify at least one attribute');
                var bufUpdated = {};
                var nattributes = vao.attributes;
                nattributes.length = attributes.length;
                for(var i = 0; i < attributes.length; ++i){
                    var spec = attributes[i];
                    var rec = nattributes[i] = new AttributeRecord();
                    var data = spec.data || spec;
                    if (Array.isArray(data) || isTypedArray(data) || isNDArrayLike(data)) {
                        var buf;
                        if (vao.buffers[i]) {
                            buf = vao.buffers[i];
                            if (isTypedArray(data) && buf._buffer.byteLength >= data.byteLength) buf.subdata(data);
                            else {
                                buf.destroy();
                                vao.buffers[i] = null;
                            }
                        }
                        if (!vao.buffers[i]) buf = vao.buffers[i] = bufferState.create(spec, GL_ARRAY_BUFFER$1, false, true);
                        rec.buffer = bufferState.getBuffer(buf);
                        rec.size = rec.buffer.dimension | 0;
                        rec.normalized = false;
                        rec.type = rec.buffer.dtype;
                        rec.offset = 0;
                        rec.stride = 0;
                        rec.divisor = 0;
                        rec.state = 1;
                        bufUpdated[i] = 1;
                    } else if (bufferState.getBuffer(spec)) {
                        rec.buffer = bufferState.getBuffer(spec);
                        rec.size = rec.buffer.dimension | 0;
                        rec.normalized = false;
                        rec.type = rec.buffer.dtype;
                        rec.offset = 0;
                        rec.stride = 0;
                        rec.divisor = 0;
                        rec.state = 1;
                    } else if (bufferState.getBuffer(spec.buffer)) {
                        rec.buffer = bufferState.getBuffer(spec.buffer);
                        rec.size = (+spec.size || rec.buffer.dimension) | 0;
                        rec.normalized = !!spec.normalized || false;
                        if ('type' in spec) {
                            check$1.parameter(spec.type, glTypes, 'invalid buffer type');
                            rec.type = glTypes[spec.type];
                        } else rec.type = rec.buffer.dtype;
                        rec.offset = (spec.offset || 0) | 0;
                        rec.stride = (spec.stride || 0) | 0;
                        rec.divisor = (spec.divisor || 0) | 0;
                        rec.state = 1;
                        check$1(rec.size >= 1 && rec.size <= 4, 'size must be between 1 and 4');
                        check$1(rec.offset >= 0, 'invalid offset');
                        check$1(rec.stride >= 0 && rec.stride <= 255, 'stride must be between 0 and 255');
                        check$1(rec.divisor >= 0, 'divisor must be positive');
                        check$1(!rec.divisor || !!extensions.angle_instanced_arrays, 'ANGLE_instanced_arrays must be enabled to use divisor');
                    } else if ('x' in spec) {
                        check$1(i > 0, 'first attribute must not be a constant');
                        rec.x = +spec.x || 0;
                        rec.y = +spec.y || 0;
                        rec.z = +spec.z || 0;
                        rec.w = +spec.w || 0;
                        rec.state = 2;
                    } else check$1(false, 'invalid attribute spec for location ' + i);
                }
                // retire unused buffers
                for(var j = 0; j < vao.buffers.length; ++j)if (!bufUpdated[j] && vao.buffers[j]) {
                    vao.buffers[j].destroy();
                    vao.buffers[j] = null;
                }
                vao.refresh();
                return updateVAO;
            }
            updateVAO.destroy = function() {
                for(var j = 0; j < vao.buffers.length; ++j)if (vao.buffers[j]) vao.buffers[j].destroy();
                vao.buffers.length = 0;
                vao.destroy();
            };
            updateVAO._vao = vao;
            updateVAO._reglType = 'vao';
            return updateVAO(_attr);
        }
        return state;
    }
    var GL_FRAGMENT_SHADER = 35632;
    var GL_VERTEX_SHADER = 35633;
    var GL_ACTIVE_UNIFORMS = 0x8B86;
    var GL_ACTIVE_ATTRIBUTES = 0x8B89;
    function wrapShaderState(gl, stringStore, stats, config) {
        // ===================================================
        // glsl compilation and linking
        // ===================================================
        var fragShaders = {};
        var vertShaders = {};
        function ActiveInfo(name, id, location, info) {
            this.name = name;
            this.id = id;
            this.location = location;
            this.info = info;
        }
        function insertActiveInfo(list, info) {
            for(var i = 0; i < list.length; ++i)if (list[i].id === info.id) {
                list[i].location = info.location;
                return;
            }
            list.push(info);
        }
        function getShader(type, id, command) {
            var cache = type === GL_FRAGMENT_SHADER ? fragShaders : vertShaders;
            var shader = cache[id];
            if (!shader) {
                var source = stringStore.str(id);
                shader = gl.createShader(type);
                gl.shaderSource(shader, source);
                gl.compileShader(shader);
                check$1.shaderError(gl, shader, source, type, command);
                cache[id] = shader;
            }
            return shader;
        }
        // ===================================================
        // program linking
        // ===================================================
        var programCache = {};
        var programList = [];
        var PROGRAM_COUNTER = 0;
        function REGLProgram(fragId, vertId) {
            this.id = PROGRAM_COUNTER++;
            this.fragId = fragId;
            this.vertId = vertId;
            this.program = null;
            this.uniforms = [];
            this.attributes = [];
            this.refCount = 1;
            if (config.profile) this.stats = {
                uniformsCount: 0,
                attributesCount: 0
            };
        }
        function linkProgram(desc, command, attributeLocations) {
            var i, info;
            // -------------------------------
            // compile & link
            // -------------------------------
            var fragShader = getShader(GL_FRAGMENT_SHADER, desc.fragId);
            var vertShader = getShader(GL_VERTEX_SHADER, desc.vertId);
            var program = desc.program = gl.createProgram();
            gl.attachShader(program, fragShader);
            gl.attachShader(program, vertShader);
            if (attributeLocations) for(i = 0; i < attributeLocations.length; ++i){
                var binding = attributeLocations[i];
                gl.bindAttribLocation(program, binding[0], binding[1]);
            }
            gl.linkProgram(program);
            check$1.linkError(gl, program, stringStore.str(desc.fragId), stringStore.str(desc.vertId), command);
            // -------------------------------
            // grab uniforms
            // -------------------------------
            var numUniforms = gl.getProgramParameter(program, GL_ACTIVE_UNIFORMS);
            if (config.profile) desc.stats.uniformsCount = numUniforms;
            var uniforms = desc.uniforms;
            for(i = 0; i < numUniforms; ++i){
                info = gl.getActiveUniform(program, i);
                if (info) {
                    if (info.size > 1) for(var j = 0; j < info.size; ++j){
                        var name = info.name.replace('[0]', '[' + j + ']');
                        insertActiveInfo(uniforms, new ActiveInfo(name, stringStore.id(name), gl.getUniformLocation(program, name), info));
                    }
                    else insertActiveInfo(uniforms, new ActiveInfo(info.name, stringStore.id(info.name), gl.getUniformLocation(program, info.name), info));
                }
            }
            // -------------------------------
            // grab attributes
            // -------------------------------
            var numAttributes = gl.getProgramParameter(program, GL_ACTIVE_ATTRIBUTES);
            if (config.profile) desc.stats.attributesCount = numAttributes;
            var attributes = desc.attributes;
            for(i = 0; i < numAttributes; ++i){
                info = gl.getActiveAttrib(program, i);
                if (info) insertActiveInfo(attributes, new ActiveInfo(info.name, stringStore.id(info.name), gl.getAttribLocation(program, info.name), info));
            }
        }
        if (config.profile) {
            stats.getMaxUniformsCount = function() {
                var m = 0;
                programList.forEach(function(desc) {
                    if (desc.stats.uniformsCount > m) m = desc.stats.uniformsCount;
                });
                return m;
            };
            stats.getMaxAttributesCount = function() {
                var m = 0;
                programList.forEach(function(desc) {
                    if (desc.stats.attributesCount > m) m = desc.stats.attributesCount;
                });
                return m;
            };
        }
        function restoreShaders() {
            fragShaders = {};
            vertShaders = {};
            for(var i = 0; i < programList.length; ++i)linkProgram(programList[i], null, programList[i].attributes.map(function(info) {
                return [
                    info.location,
                    info.name
                ];
            }));
        }
        return {
            clear: function() {
                var deleteShader = gl.deleteShader.bind(gl);
                values(fragShaders).forEach(deleteShader);
                fragShaders = {};
                values(vertShaders).forEach(deleteShader);
                vertShaders = {};
                programList.forEach(function(desc) {
                    gl.deleteProgram(desc.program);
                });
                programList.length = 0;
                programCache = {};
                stats.shaderCount = 0;
            },
            program: function(vertId, fragId, command, attribLocations) {
                check$1.command(vertId >= 0, 'missing vertex shader', command);
                check$1.command(fragId >= 0, 'missing fragment shader', command);
                var cache = programCache[fragId];
                if (!cache) cache = programCache[fragId] = {};
                var prevProgram = cache[vertId];
                if (prevProgram) {
                    prevProgram.refCount++;
                    if (!attribLocations) return prevProgram;
                }
                var program = new REGLProgram(fragId, vertId);
                stats.shaderCount++;
                linkProgram(program, command, attribLocations);
                if (!prevProgram) cache[vertId] = program;
                programList.push(program);
                return extend(program, {
                    destroy: function() {
                        program.refCount--;
                        if (program.refCount <= 0) {
                            gl.deleteProgram(program.program);
                            var idx = programList.indexOf(program);
                            programList.splice(idx, 1);
                            stats.shaderCount--;
                        }
                        // no program is linked to this vert anymore
                        if (cache[program.vertId].refCount <= 0) {
                            gl.deleteShader(vertShaders[program.vertId]);
                            delete vertShaders[program.vertId];
                            delete programCache[program.fragId][program.vertId];
                        }
                        // no program is linked to this frag anymore
                        if (!Object.keys(programCache[program.fragId]).length) {
                            gl.deleteShader(fragShaders[program.fragId]);
                            delete fragShaders[program.fragId];
                            delete programCache[program.fragId];
                        }
                    }
                });
            },
            restore: restoreShaders,
            shader: getShader,
            frag: -1,
            vert: -1
        };
    }
    var GL_RGBA$3 = 6408;
    var GL_UNSIGNED_BYTE$7 = 5121;
    var GL_PACK_ALIGNMENT = 0x0D05;
    var GL_FLOAT$7 = 0x1406 // 5126
    ;
    function wrapReadPixels(gl, framebufferState, reglPoll, context, glAttributes, extensions, limits) {
        function readPixelsImpl(input) {
            var type;
            if (framebufferState.next === null) {
                check$1(glAttributes.preserveDrawingBuffer, 'you must create a webgl context with "preserveDrawingBuffer":true in order to read pixels from the drawing buffer');
                type = GL_UNSIGNED_BYTE$7;
            } else {
                check$1(framebufferState.next.colorAttachments[0].texture !== null, 'You cannot read from a renderbuffer');
                type = framebufferState.next.colorAttachments[0].texture._texture.type;
                if (extensions.oes_texture_float) {
                    check$1(type === GL_UNSIGNED_BYTE$7 || type === GL_FLOAT$7, 'Reading from a framebuffer is only allowed for the types \'uint8\' and \'float\'');
                    if (type === GL_FLOAT$7) check$1(limits.readFloat, 'Reading \'float\' values is not permitted in your browser. For a fallback, please see: https://www.npmjs.com/package/glsl-read-float');
                } else check$1(type === GL_UNSIGNED_BYTE$7, 'Reading from a framebuffer is only allowed for the type \'uint8\'');
            }
            var x = 0;
            var y = 0;
            var width = context.framebufferWidth;
            var height = context.framebufferHeight;
            var data = null;
            if (isTypedArray(input)) data = input;
            else if (input) {
                check$1.type(input, 'object', 'invalid arguments to regl.read()');
                x = input.x | 0;
                y = input.y | 0;
                check$1(x >= 0 && x < context.framebufferWidth, 'invalid x offset for regl.read');
                check$1(y >= 0 && y < context.framebufferHeight, 'invalid y offset for regl.read');
                width = (input.width || context.framebufferWidth - x) | 0;
                height = (input.height || context.framebufferHeight - y) | 0;
                data = input.data || null;
            }
            // sanity check input.data
            if (data) {
                if (type === GL_UNSIGNED_BYTE$7) check$1(data instanceof Uint8Array, 'buffer must be \'Uint8Array\' when reading from a framebuffer of type \'uint8\'');
                else if (type === GL_FLOAT$7) check$1(data instanceof Float32Array, 'buffer must be \'Float32Array\' when reading from a framebuffer of type \'float\'');
            }
            check$1(width > 0 && width + x <= context.framebufferWidth, 'invalid width for read pixels');
            check$1(height > 0 && height + y <= context.framebufferHeight, 'invalid height for read pixels');
            // Update WebGL state
            reglPoll();
            // Compute size
            var size = width * height * 4;
            // Allocate data
            if (!data) {
                if (type === GL_UNSIGNED_BYTE$7) data = new Uint8Array(size);
                else if (type === GL_FLOAT$7) data = data || new Float32Array(size);
            }
            // Type check
            check$1.isTypedArray(data, 'data buffer for regl.read() must be a typedarray');
            check$1(data.byteLength >= size, 'data buffer for regl.read() too small');
            // Run read pixels
            gl.pixelStorei(GL_PACK_ALIGNMENT, 4);
            gl.readPixels(x, y, width, height, GL_RGBA$3, type, data);
            return data;
        }
        function readPixelsFBO(options) {
            var result;
            framebufferState.setFBO({
                framebuffer: options.framebuffer
            }, function() {
                result = readPixelsImpl(options);
            });
            return result;
        }
        function readPixels(options) {
            if (!options || !('framebuffer' in options)) return readPixelsImpl(options);
            else return readPixelsFBO(options);
        }
        return readPixels;
    }
    function slice(x) {
        return Array.prototype.slice.call(x);
    }
    function join(x) {
        return slice(x).join('');
    }
    function createEnvironment() {
        // Unique variable id counter
        var varCounter = 0;
        // Linked values are passed from this scope into the generated code block
        // Calling link() passes a value into the generated scope and returns
        // the variable name which it is bound to
        var linkedNames = [];
        var linkedValues = [];
        function link(value) {
            for(var i = 0; i < linkedValues.length; ++i){
                if (linkedValues[i] === value) return linkedNames[i];
            }
            var name = 'g' + varCounter++;
            linkedNames.push(name);
            linkedValues.push(value);
            return name;
        }
        // create a code block
        function block() {
            var code = [];
            function push() {
                code.push.apply(code, slice(arguments));
            }
            var vars = [];
            function def() {
                var name = 'v' + varCounter++;
                vars.push(name);
                if (arguments.length > 0) {
                    code.push(name, '=');
                    code.push.apply(code, slice(arguments));
                    code.push(';');
                }
                return name;
            }
            return extend(push, {
                def: def,
                toString: function() {
                    return join([
                        vars.length > 0 ? 'var ' + vars.join(',') + ';' : '',
                        join(code)
                    ]);
                }
            });
        }
        function scope() {
            var entry = block();
            var exit = block();
            var entryToString = entry.toString;
            var exitToString = exit.toString;
            function save(object, prop) {
                exit(object, prop, '=', entry.def(object, prop), ';');
            }
            return extend(function() {
                entry.apply(entry, slice(arguments));
            }, {
                def: entry.def,
                entry: entry,
                exit: exit,
                save: save,
                set: function(object, prop, value) {
                    save(object, prop);
                    entry(object, prop, '=', value, ';');
                },
                toString: function() {
                    return entryToString() + exitToString();
                }
            });
        }
        function conditional() {
            var pred = join(arguments);
            var thenBlock = scope();
            var elseBlock = scope();
            var thenToString = thenBlock.toString;
            var elseToString = elseBlock.toString;
            return extend(thenBlock, {
                then: function() {
                    thenBlock.apply(thenBlock, slice(arguments));
                    return this;
                },
                else: function() {
                    elseBlock.apply(elseBlock, slice(arguments));
                    return this;
                },
                toString: function() {
                    var elseClause = elseToString();
                    if (elseClause) elseClause = 'else{' + elseClause + '}';
                    return join([
                        'if(',
                        pred,
                        '){',
                        thenToString(),
                        '}',
                        elseClause
                    ]);
                }
            });
        }
        // procedure list
        var globalBlock = block();
        var procedures = {};
        function proc(name, count) {
            var args = [];
            function arg() {
                var name = 'a' + args.length;
                args.push(name);
                return name;
            }
            count = count || 0;
            for(var i = 0; i < count; ++i)arg();
            var body = scope();
            var bodyToString = body.toString;
            var result = procedures[name] = extend(body, {
                arg: arg,
                toString: function() {
                    return join([
                        'function(',
                        args.join(),
                        '){',
                        bodyToString(),
                        '}'
                    ]);
                }
            });
            return result;
        }
        function compile() {
            var code = [
                '"use strict";',
                globalBlock,
                'return {'
            ];
            Object.keys(procedures).forEach(function(name) {
                code.push('"', name, '":', procedures[name].toString(), ',');
            });
            code.push('}');
            var src = join(code).replace(/;/g, ';\n').replace(/}/g, '}\n').replace(/{/g, '{\n');
            var proc = Function.apply(null, linkedNames.concat(src));
            return proc.apply(null, linkedValues);
        }
        return {
            global: globalBlock,
            link: link,
            block: block,
            proc: proc,
            scope: scope,
            cond: conditional,
            compile: compile
        };
    }
    // "cute" names for vector components
    var CUTE_COMPONENTS = 'xyzw'.split('');
    var GL_UNSIGNED_BYTE$8 = 5121;
    var ATTRIB_STATE_POINTER = 1;
    var ATTRIB_STATE_CONSTANT = 2;
    var DYN_FUNC$1 = 0;
    var DYN_PROP$1 = 1;
    var DYN_CONTEXT$1 = 2;
    var DYN_STATE$1 = 3;
    var DYN_THUNK = 4;
    var DYN_CONSTANT$1 = 5;
    var DYN_ARRAY$1 = 6;
    var S_DITHER = 'dither';
    var S_BLEND_ENABLE = 'blend.enable';
    var S_BLEND_COLOR = 'blend.color';
    var S_BLEND_EQUATION = 'blend.equation';
    var S_BLEND_FUNC = 'blend.func';
    var S_DEPTH_ENABLE = 'depth.enable';
    var S_DEPTH_FUNC = 'depth.func';
    var S_DEPTH_RANGE = 'depth.range';
    var S_DEPTH_MASK = 'depth.mask';
    var S_COLOR_MASK = 'colorMask';
    var S_CULL_ENABLE = 'cull.enable';
    var S_CULL_FACE = 'cull.face';
    var S_FRONT_FACE = 'frontFace';
    var S_LINE_WIDTH = 'lineWidth';
    var S_POLYGON_OFFSET_ENABLE = 'polygonOffset.enable';
    var S_POLYGON_OFFSET_OFFSET = 'polygonOffset.offset';
    var S_SAMPLE_ALPHA = 'sample.alpha';
    var S_SAMPLE_ENABLE = 'sample.enable';
    var S_SAMPLE_COVERAGE = 'sample.coverage';
    var S_STENCIL_ENABLE = 'stencil.enable';
    var S_STENCIL_MASK = 'stencil.mask';
    var S_STENCIL_FUNC = 'stencil.func';
    var S_STENCIL_OPFRONT = 'stencil.opFront';
    var S_STENCIL_OPBACK = 'stencil.opBack';
    var S_SCISSOR_ENABLE = 'scissor.enable';
    var S_SCISSOR_BOX = 'scissor.box';
    var S_VIEWPORT = 'viewport';
    var S_PROFILE = 'profile';
    var S_FRAMEBUFFER = 'framebuffer';
    var S_VERT = 'vert';
    var S_FRAG = 'frag';
    var S_ELEMENTS = 'elements';
    var S_PRIMITIVE = 'primitive';
    var S_COUNT = 'count';
    var S_OFFSET = 'offset';
    var S_INSTANCES = 'instances';
    var S_VAO = 'vao';
    var SUFFIX_WIDTH = 'Width';
    var SUFFIX_HEIGHT = 'Height';
    var S_FRAMEBUFFER_WIDTH = S_FRAMEBUFFER + SUFFIX_WIDTH;
    var S_FRAMEBUFFER_HEIGHT = S_FRAMEBUFFER + SUFFIX_HEIGHT;
    var S_VIEWPORT_WIDTH = S_VIEWPORT + SUFFIX_WIDTH;
    var S_VIEWPORT_HEIGHT = S_VIEWPORT + SUFFIX_HEIGHT;
    var S_DRAWINGBUFFER = 'drawingBuffer';
    var S_DRAWINGBUFFER_WIDTH = S_DRAWINGBUFFER + SUFFIX_WIDTH;
    var S_DRAWINGBUFFER_HEIGHT = S_DRAWINGBUFFER + SUFFIX_HEIGHT;
    var NESTED_OPTIONS = [
        S_BLEND_FUNC,
        S_BLEND_EQUATION,
        S_STENCIL_FUNC,
        S_STENCIL_OPFRONT,
        S_STENCIL_OPBACK,
        S_SAMPLE_COVERAGE,
        S_VIEWPORT,
        S_SCISSOR_BOX,
        S_POLYGON_OFFSET_OFFSET
    ];
    var GL_ARRAY_BUFFER$2 = 34962;
    var GL_ELEMENT_ARRAY_BUFFER$1 = 34963;
    var GL_FRAGMENT_SHADER$1 = 35632;
    var GL_VERTEX_SHADER$1 = 35633;
    var GL_TEXTURE_2D$3 = 0x0DE1;
    var GL_TEXTURE_CUBE_MAP$2 = 0x8513;
    var GL_CULL_FACE = 0x0B44;
    var GL_BLEND = 0x0BE2;
    var GL_DITHER = 0x0BD0;
    var GL_STENCIL_TEST = 0x0B90;
    var GL_DEPTH_TEST = 0x0B71;
    var GL_SCISSOR_TEST = 0x0C11;
    var GL_POLYGON_OFFSET_FILL = 0x8037;
    var GL_SAMPLE_ALPHA_TO_COVERAGE = 0x809E;
    var GL_SAMPLE_COVERAGE = 0x80A0;
    var GL_FLOAT$8 = 5126;
    var GL_FLOAT_VEC2 = 35664;
    var GL_FLOAT_VEC3 = 35665;
    var GL_FLOAT_VEC4 = 35666;
    var GL_INT$3 = 5124;
    var GL_INT_VEC2 = 35667;
    var GL_INT_VEC3 = 35668;
    var GL_INT_VEC4 = 35669;
    var GL_BOOL = 35670;
    var GL_BOOL_VEC2 = 35671;
    var GL_BOOL_VEC3 = 35672;
    var GL_BOOL_VEC4 = 35673;
    var GL_FLOAT_MAT2 = 35674;
    var GL_FLOAT_MAT3 = 35675;
    var GL_FLOAT_MAT4 = 35676;
    var GL_SAMPLER_2D = 35678;
    var GL_SAMPLER_CUBE = 35680;
    var GL_TRIANGLES$1 = 4;
    var GL_FRONT = 1028;
    var GL_BACK = 1029;
    var GL_CW = 0x0900;
    var GL_CCW = 0x0901;
    var GL_MIN_EXT = 0x8007;
    var GL_MAX_EXT = 0x8008;
    var GL_ALWAYS = 519;
    var GL_KEEP = 7680;
    var GL_ZERO = 0;
    var GL_ONE = 1;
    var GL_FUNC_ADD = 0x8006;
    var GL_LESS = 513;
    var GL_FRAMEBUFFER$2 = 0x8D40;
    var GL_COLOR_ATTACHMENT0$2 = 0x8CE0;
    var blendFuncs = {
        '0': 0,
        '1': 1,
        'zero': 0,
        'one': 1,
        'src color': 768,
        'one minus src color': 769,
        'src alpha': 770,
        'one minus src alpha': 771,
        'dst color': 774,
        'one minus dst color': 775,
        'dst alpha': 772,
        'one minus dst alpha': 773,
        'constant color': 32769,
        'one minus constant color': 32770,
        'constant alpha': 32771,
        'one minus constant alpha': 32772,
        'src alpha saturate': 776
    };
    // There are invalid values for srcRGB and dstRGB. See:
    // https://www.khronos.org/registry/webgl/specs/1.0/#6.13
    // https://github.com/KhronosGroup/WebGL/blob/0d3201f5f7ec3c0060bc1f04077461541f1987b9/conformance-suites/1.0.3/conformance/misc/webgl-specific.html#L56
    var invalidBlendCombinations = [
        'constant color, constant alpha',
        'one minus constant color, constant alpha',
        'constant color, one minus constant alpha',
        'one minus constant color, one minus constant alpha',
        'constant alpha, constant color',
        'constant alpha, one minus constant color',
        'one minus constant alpha, constant color',
        'one minus constant alpha, one minus constant color'
    ];
    var compareFuncs = {
        'never': 512,
        'less': 513,
        '<': 513,
        'equal': 514,
        '=': 514,
        '==': 514,
        '===': 514,
        'lequal': 515,
        '<=': 515,
        'greater': 516,
        '>': 516,
        'notequal': 517,
        '!=': 517,
        '!==': 517,
        'gequal': 518,
        '>=': 518,
        'always': 519
    };
    var stencilOps = {
        '0': 0,
        'zero': 0,
        'keep': 7680,
        'replace': 7681,
        'increment': 7682,
        'decrement': 7683,
        'increment wrap': 34055,
        'decrement wrap': 34056,
        'invert': 5386
    };
    var shaderType = {
        'frag': GL_FRAGMENT_SHADER$1,
        'vert': GL_VERTEX_SHADER$1
    };
    var orientationType = {
        'cw': GL_CW,
        'ccw': GL_CCW
    };
    function isBufferArgs(x) {
        return Array.isArray(x) || isTypedArray(x) || isNDArrayLike(x);
    }
    // Make sure viewport is processed first
    function sortState(state) {
        return state.sort(function(a, b) {
            if (a === S_VIEWPORT) return -1;
            else if (b === S_VIEWPORT) return 1;
            return a < b ? -1 : 1;
        });
    }
    function Declaration(thisDep, contextDep, propDep, append) {
        this.thisDep = thisDep;
        this.contextDep = contextDep;
        this.propDep = propDep;
        this.append = append;
    }
    function isStatic(decl) {
        return decl && !(decl.thisDep || decl.contextDep || decl.propDep);
    }
    function createStaticDecl(append) {
        return new Declaration(false, false, false, append);
    }
    function createDynamicDecl(dyn, append) {
        var type = dyn.type;
        if (type === DYN_FUNC$1) {
            var numArgs = dyn.data.length;
            return new Declaration(true, numArgs >= 1, numArgs >= 2, append);
        } else if (type === DYN_THUNK) {
            var data = dyn.data;
            return new Declaration(data.thisDep, data.contextDep, data.propDep, append);
        } else if (type === DYN_CONSTANT$1) return new Declaration(false, false, false, append);
        else if (type === DYN_ARRAY$1) {
            var thisDep = false;
            var contextDep = false;
            var propDep = false;
            for(var i = 0; i < dyn.data.length; ++i){
                var subDyn = dyn.data[i];
                if (subDyn.type === DYN_PROP$1) propDep = true;
                else if (subDyn.type === DYN_CONTEXT$1) contextDep = true;
                else if (subDyn.type === DYN_STATE$1) thisDep = true;
                else if (subDyn.type === DYN_FUNC$1) {
                    thisDep = true;
                    var subArgs = subDyn.data;
                    if (subArgs >= 1) contextDep = true;
                    if (subArgs >= 2) propDep = true;
                } else if (subDyn.type === DYN_THUNK) {
                    thisDep = thisDep || subDyn.data.thisDep;
                    contextDep = contextDep || subDyn.data.contextDep;
                    propDep = propDep || subDyn.data.propDep;
                }
            }
            return new Declaration(thisDep, contextDep, propDep, append);
        } else return new Declaration(type === DYN_STATE$1, type === DYN_CONTEXT$1, type === DYN_PROP$1, append);
    }
    var SCOPE_DECL = new Declaration(false, false, false, function() {});
    function reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config) {
        var AttributeRecord = attributeState.Record;
        var blendEquations = {
            'add': 32774,
            'subtract': 32778,
            'reverse subtract': 32779
        };
        if (extensions.ext_blend_minmax) {
            blendEquations.min = GL_MIN_EXT;
            blendEquations.max = GL_MAX_EXT;
        }
        var extInstancing = extensions.angle_instanced_arrays;
        var extDrawBuffers = extensions.webgl_draw_buffers;
        // ===================================================
        // ===================================================
        // WEBGL STATE
        // ===================================================
        // ===================================================
        var currentState = {
            dirty: true,
            profile: config.profile
        };
        var nextState = {};
        var GL_STATE_NAMES = [];
        var GL_FLAGS = {};
        var GL_VARIABLES = {};
        function propName(name) {
            return name.replace('.', '_');
        }
        function stateFlag(sname, cap, init) {
            var name = propName(sname);
            GL_STATE_NAMES.push(sname);
            nextState[name] = currentState[name] = !!init;
            GL_FLAGS[name] = cap;
        }
        function stateVariable(sname, func, init) {
            var name = propName(sname);
            GL_STATE_NAMES.push(sname);
            if (Array.isArray(init)) {
                currentState[name] = init.slice();
                nextState[name] = init.slice();
            } else currentState[name] = nextState[name] = init;
            GL_VARIABLES[name] = func;
        }
        // Dithering
        stateFlag(S_DITHER, GL_DITHER);
        // Blending
        stateFlag(S_BLEND_ENABLE, GL_BLEND);
        stateVariable(S_BLEND_COLOR, 'blendColor', [
            0,
            0,
            0,
            0
        ]);
        stateVariable(S_BLEND_EQUATION, 'blendEquationSeparate', [
            GL_FUNC_ADD,
            GL_FUNC_ADD
        ]);
        stateVariable(S_BLEND_FUNC, 'blendFuncSeparate', [
            GL_ONE,
            GL_ZERO,
            GL_ONE,
            GL_ZERO
        ]);
        // Depth
        stateFlag(S_DEPTH_ENABLE, GL_DEPTH_TEST, true);
        stateVariable(S_DEPTH_FUNC, 'depthFunc', GL_LESS);
        stateVariable(S_DEPTH_RANGE, 'depthRange', [
            0,
            1
        ]);
        stateVariable(S_DEPTH_MASK, 'depthMask', true);
        // Color mask
        stateVariable(S_COLOR_MASK, S_COLOR_MASK, [
            true,
            true,
            true,
            true
        ]);
        // Face culling
        stateFlag(S_CULL_ENABLE, GL_CULL_FACE);
        stateVariable(S_CULL_FACE, 'cullFace', GL_BACK);
        // Front face orientation
        stateVariable(S_FRONT_FACE, S_FRONT_FACE, GL_CCW);
        // Line width
        stateVariable(S_LINE_WIDTH, S_LINE_WIDTH, 1);
        // Polygon offset
        stateFlag(S_POLYGON_OFFSET_ENABLE, GL_POLYGON_OFFSET_FILL);
        stateVariable(S_POLYGON_OFFSET_OFFSET, 'polygonOffset', [
            0,
            0
        ]);
        // Sample coverage
        stateFlag(S_SAMPLE_ALPHA, GL_SAMPLE_ALPHA_TO_COVERAGE);
        stateFlag(S_SAMPLE_ENABLE, GL_SAMPLE_COVERAGE);
        stateVariable(S_SAMPLE_COVERAGE, 'sampleCoverage', [
            1,
            false
        ]);
        // Stencil
        stateFlag(S_STENCIL_ENABLE, GL_STENCIL_TEST);
        stateVariable(S_STENCIL_MASK, 'stencilMask', -1);
        stateVariable(S_STENCIL_FUNC, 'stencilFunc', [
            GL_ALWAYS,
            0,
            -1
        ]);
        stateVariable(S_STENCIL_OPFRONT, 'stencilOpSeparate', [
            GL_FRONT,
            GL_KEEP,
            GL_KEEP,
            GL_KEEP
        ]);
        stateVariable(S_STENCIL_OPBACK, 'stencilOpSeparate', [
            GL_BACK,
            GL_KEEP,
            GL_KEEP,
            GL_KEEP
        ]);
        // Scissor
        stateFlag(S_SCISSOR_ENABLE, GL_SCISSOR_TEST);
        stateVariable(S_SCISSOR_BOX, 'scissor', [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ]);
        // Viewport
        stateVariable(S_VIEWPORT, S_VIEWPORT, [
            0,
            0,
            gl.drawingBufferWidth,
            gl.drawingBufferHeight
        ]);
        // ===================================================
        // ===================================================
        // ENVIRONMENT
        // ===================================================
        // ===================================================
        var sharedState = {
            gl: gl,
            context: contextState,
            strings: stringStore,
            next: nextState,
            current: currentState,
            draw: drawState,
            elements: elementState,
            buffer: bufferState,
            shader: shaderState,
            attributes: attributeState.state,
            vao: attributeState,
            uniforms: uniformState,
            framebuffer: framebufferState,
            extensions: extensions,
            timer: timer,
            isBufferArgs: isBufferArgs
        };
        var sharedConstants = {
            primTypes: primTypes,
            compareFuncs: compareFuncs,
            blendFuncs: blendFuncs,
            blendEquations: blendEquations,
            stencilOps: stencilOps,
            glTypes: glTypes,
            orientationType: orientationType
        };
        check$1.optional(function() {
            sharedState.isArrayLike = isArrayLike;
        });
        if (extDrawBuffers) {
            sharedConstants.backBuffer = [
                GL_BACK
            ];
            sharedConstants.drawBuffer = loop(limits.maxDrawbuffers, function(i) {
                if (i === 0) return [
                    0
                ];
                return loop(i, function(j) {
                    return GL_COLOR_ATTACHMENT0$2 + j;
                });
            });
        }
        var drawCallCounter = 0;
        function createREGLEnvironment() {
            var env = createEnvironment();
            var link = env.link;
            var global = env.global;
            env.id = drawCallCounter++;
            env.batchId = '0';
            // link shared state
            var SHARED = link(sharedState);
            var shared = env.shared = {
                props: 'a0'
            };
            Object.keys(sharedState).forEach(function(prop) {
                shared[prop] = global.def(SHARED, '.', prop);
            });
            // Inject runtime assertion stuff for debug builds
            check$1.optional(function() {
                env.CHECK = link(check$1);
                env.commandStr = check$1.guessCommand();
                env.command = link(env.commandStr);
                env.assert = function(block, pred, message) {
                    block('if(!(', pred, '))', this.CHECK, '.commandRaise(', link(message), ',', this.command, ');');
                };
                sharedConstants.invalidBlendCombinations = invalidBlendCombinations;
            });
            // Copy GL state variables over
            var nextVars = env.next = {};
            var currentVars = env.current = {};
            Object.keys(GL_VARIABLES).forEach(function(variable) {
                if (Array.isArray(currentState[variable])) {
                    nextVars[variable] = global.def(shared.next, '.', variable);
                    currentVars[variable] = global.def(shared.current, '.', variable);
                }
            });
            // Initialize shared constants
            var constants = env.constants = {};
            Object.keys(sharedConstants).forEach(function(name) {
                constants[name] = global.def(JSON.stringify(sharedConstants[name]));
            });
            // Helper function for calling a block
            env.invoke = function(block, x) {
                switch(x.type){
                    case DYN_FUNC$1:
                        var argList = [
                            'this',
                            shared.context,
                            shared.props,
                            env.batchId
                        ];
                        return block.def(link(x.data), '.call(', argList.slice(0, Math.max(x.data.length + 1, 4)), ')');
                    case DYN_PROP$1:
                        return block.def(shared.props, x.data);
                    case DYN_CONTEXT$1:
                        return block.def(shared.context, x.data);
                    case DYN_STATE$1:
                        return block.def('this', x.data);
                    case DYN_THUNK:
                        x.data.append(env, block);
                        return x.data.ref;
                    case DYN_CONSTANT$1:
                        return x.data.toString();
                    case DYN_ARRAY$1:
                        return x.data.map(function(y) {
                            return env.invoke(block, y);
                        });
                }
            };
            env.attribCache = {};
            var scopeAttribs = {};
            env.scopeAttrib = function(name) {
                var id = stringStore.id(name);
                if (id in scopeAttribs) return scopeAttribs[id];
                var binding = attributeState.scope[id];
                if (!binding) binding = attributeState.scope[id] = new AttributeRecord();
                var result = scopeAttribs[id] = link(binding);
                return result;
            };
            return env;
        }
        // ===================================================
        // ===================================================
        // PARSING
        // ===================================================
        // ===================================================
        function parseProfile(options) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            var profileEnable;
            if (S_PROFILE in staticOptions) {
                var value = !!staticOptions[S_PROFILE];
                profileEnable = createStaticDecl(function(env, scope) {
                    return value;
                });
                profileEnable.enable = value;
            } else if (S_PROFILE in dynamicOptions) {
                var dyn = dynamicOptions[S_PROFILE];
                profileEnable = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            }
            return profileEnable;
        }
        function parseFramebuffer(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            if (S_FRAMEBUFFER in staticOptions) {
                var framebuffer = staticOptions[S_FRAMEBUFFER];
                if (framebuffer) {
                    framebuffer = framebufferState.getFramebuffer(framebuffer);
                    check$1.command(framebuffer, 'invalid framebuffer object');
                    return createStaticDecl(function(env, block) {
                        var FRAMEBUFFER = env.link(framebuffer);
                        var shared = env.shared;
                        block.set(shared.framebuffer, '.next', FRAMEBUFFER);
                        var CONTEXT = shared.context;
                        block.set(CONTEXT, '.' + S_FRAMEBUFFER_WIDTH, FRAMEBUFFER + '.width');
                        block.set(CONTEXT, '.' + S_FRAMEBUFFER_HEIGHT, FRAMEBUFFER + '.height');
                        return FRAMEBUFFER;
                    });
                } else return createStaticDecl(function(env, scope) {
                    var shared = env.shared;
                    scope.set(shared.framebuffer, '.next', 'null');
                    var CONTEXT = shared.context;
                    scope.set(CONTEXT, '.' + S_FRAMEBUFFER_WIDTH, CONTEXT + '.' + S_DRAWINGBUFFER_WIDTH);
                    scope.set(CONTEXT, '.' + S_FRAMEBUFFER_HEIGHT, CONTEXT + '.' + S_DRAWINGBUFFER_HEIGHT);
                    return 'null';
                });
            } else if (S_FRAMEBUFFER in dynamicOptions) {
                var dyn = dynamicOptions[S_FRAMEBUFFER];
                return createDynamicDecl(dyn, function(env, scope) {
                    var FRAMEBUFFER_FUNC = env.invoke(scope, dyn);
                    var shared = env.shared;
                    var FRAMEBUFFER_STATE = shared.framebuffer;
                    var FRAMEBUFFER = scope.def(FRAMEBUFFER_STATE, '.getFramebuffer(', FRAMEBUFFER_FUNC, ')');
                    check$1.optional(function() {
                        env.assert(scope, '!' + FRAMEBUFFER_FUNC + '||' + FRAMEBUFFER, 'invalid framebuffer object');
                    });
                    scope.set(FRAMEBUFFER_STATE, '.next', FRAMEBUFFER);
                    var CONTEXT = shared.context;
                    scope.set(CONTEXT, '.' + S_FRAMEBUFFER_WIDTH, FRAMEBUFFER + '?' + FRAMEBUFFER + '.width:' + CONTEXT + '.' + S_DRAWINGBUFFER_WIDTH);
                    scope.set(CONTEXT, '.' + S_FRAMEBUFFER_HEIGHT, FRAMEBUFFER + '?' + FRAMEBUFFER + '.height:' + CONTEXT + '.' + S_DRAWINGBUFFER_HEIGHT);
                    return FRAMEBUFFER;
                });
            } else return null;
        }
        function parseViewportScissor(options, framebuffer, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseBox(param) {
                if (param in staticOptions) {
                    var box = staticOptions[param];
                    check$1.commandType(box, 'object', 'invalid ' + param, env.commandStr);
                    var isStatic = true;
                    var x = box.x | 0;
                    var y = box.y | 0;
                    var w, h;
                    if ('width' in box) {
                        w = box.width | 0;
                        check$1.command(w >= 0, 'invalid ' + param, env.commandStr);
                    } else isStatic = false;
                    if ('height' in box) {
                        h = box.height | 0;
                        check$1.command(h >= 0, 'invalid ' + param, env.commandStr);
                    } else isStatic = false;
                    return new Declaration(!isStatic && framebuffer && framebuffer.thisDep, !isStatic && framebuffer && framebuffer.contextDep, !isStatic && framebuffer && framebuffer.propDep, function(env, scope) {
                        var CONTEXT = env.shared.context;
                        var BOX_W = w;
                        if (!('width' in box)) BOX_W = scope.def(CONTEXT, '.', S_FRAMEBUFFER_WIDTH, '-', x);
                        var BOX_H = h;
                        if (!('height' in box)) BOX_H = scope.def(CONTEXT, '.', S_FRAMEBUFFER_HEIGHT, '-', y);
                        return [
                            x,
                            y,
                            BOX_W,
                            BOX_H
                        ];
                    });
                } else if (param in dynamicOptions) {
                    var dynBox = dynamicOptions[param];
                    var result = createDynamicDecl(dynBox, function(env, scope) {
                        var BOX = env.invoke(scope, dynBox);
                        check$1.optional(function() {
                            env.assert(scope, BOX + '&&typeof ' + BOX + '==="object"', 'invalid ' + param);
                        });
                        var CONTEXT = env.shared.context;
                        var BOX_X = scope.def(BOX, '.x|0');
                        var BOX_Y = scope.def(BOX, '.y|0');
                        var BOX_W = scope.def('"width" in ', BOX, '?', BOX, '.width|0:', '(', CONTEXT, '.', S_FRAMEBUFFER_WIDTH, '-', BOX_X, ')');
                        var BOX_H = scope.def('"height" in ', BOX, '?', BOX, '.height|0:', '(', CONTEXT, '.', S_FRAMEBUFFER_HEIGHT, '-', BOX_Y, ')');
                        check$1.optional(function() {
                            env.assert(scope, BOX_W + '>=0&&' + BOX_H + '>=0', 'invalid ' + param);
                        });
                        return [
                            BOX_X,
                            BOX_Y,
                            BOX_W,
                            BOX_H
                        ];
                    });
                    if (framebuffer) {
                        result.thisDep = result.thisDep || framebuffer.thisDep;
                        result.contextDep = result.contextDep || framebuffer.contextDep;
                        result.propDep = result.propDep || framebuffer.propDep;
                    }
                    return result;
                } else if (framebuffer) return new Declaration(framebuffer.thisDep, framebuffer.contextDep, framebuffer.propDep, function(env, scope) {
                    var CONTEXT = env.shared.context;
                    return [
                        0,
                        0,
                        scope.def(CONTEXT, '.', S_FRAMEBUFFER_WIDTH),
                        scope.def(CONTEXT, '.', S_FRAMEBUFFER_HEIGHT)
                    ];
                });
                else return null;
            }
            var viewport = parseBox(S_VIEWPORT);
            if (viewport) {
                var prevViewport = viewport;
                viewport = new Declaration(viewport.thisDep, viewport.contextDep, viewport.propDep, function(env, scope) {
                    var VIEWPORT = prevViewport.append(env, scope);
                    var CONTEXT = env.shared.context;
                    scope.set(CONTEXT, '.' + S_VIEWPORT_WIDTH, VIEWPORT[2]);
                    scope.set(CONTEXT, '.' + S_VIEWPORT_HEIGHT, VIEWPORT[3]);
                    return VIEWPORT;
                });
            }
            return {
                viewport: viewport,
                scissor_box: parseBox(S_SCISSOR_BOX)
            };
        }
        function parseAttribLocations(options, attributes) {
            var staticOptions = options.static;
            var staticProgram = typeof staticOptions[S_FRAG] === 'string' && typeof staticOptions[S_VERT] === 'string';
            if (staticProgram) {
                if (Object.keys(attributes.dynamic).length > 0) return null;
                var staticAttributes = attributes.static;
                var sAttributes = Object.keys(staticAttributes);
                if (sAttributes.length > 0 && typeof staticAttributes[sAttributes[0]] === 'number') {
                    var bindings = [];
                    for(var i = 0; i < sAttributes.length; ++i){
                        check$1(typeof staticAttributes[sAttributes[i]] === 'number', 'must specify all vertex attribute locations when using vaos');
                        bindings.push([
                            staticAttributes[sAttributes[i]] | 0,
                            sAttributes[i]
                        ]);
                    }
                    return bindings;
                }
            }
            return null;
        }
        function parseProgram(options, env, attribLocations) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseShader(name) {
                if (name in staticOptions) {
                    var id = stringStore.id(staticOptions[name]);
                    check$1.optional(function() {
                        shaderState.shader(shaderType[name], id, check$1.guessCommand());
                    });
                    var result = createStaticDecl(function() {
                        return id;
                    });
                    result.id = id;
                    return result;
                } else if (name in dynamicOptions) {
                    var dyn = dynamicOptions[name];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var str = env.invoke(scope, dyn);
                        var id = scope.def(env.shared.strings, '.id(', str, ')');
                        check$1.optional(function() {
                            scope(env.shared.shader, '.shader(', shaderType[name], ',', id, ',', env.command, ');');
                        });
                        return id;
                    });
                }
                return null;
            }
            var frag = parseShader(S_FRAG);
            var vert = parseShader(S_VERT);
            var program = null;
            var progVar;
            if (isStatic(frag) && isStatic(vert)) {
                program = shaderState.program(vert.id, frag.id, null, attribLocations);
                progVar = createStaticDecl(function(env, scope) {
                    return env.link(program);
                });
            } else progVar = new Declaration(frag && frag.thisDep || vert && vert.thisDep, frag && frag.contextDep || vert && vert.contextDep, frag && frag.propDep || vert && vert.propDep, function(env, scope) {
                var SHADER_STATE = env.shared.shader;
                var fragId;
                if (frag) fragId = frag.append(env, scope);
                else fragId = scope.def(SHADER_STATE, '.', S_FRAG);
                var vertId;
                if (vert) vertId = vert.append(env, scope);
                else vertId = scope.def(SHADER_STATE, '.', S_VERT);
                var progDef = SHADER_STATE + '.program(' + vertId + ',' + fragId;
                check$1.optional(function() {
                    progDef += ',' + env.command;
                });
                return scope.def(progDef + ')');
            });
            return {
                frag: frag,
                vert: vert,
                progVar: progVar,
                program: program
            };
        }
        function parseDraw(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            function parseElements() {
                if (S_ELEMENTS in staticOptions) {
                    var elements = staticOptions[S_ELEMENTS];
                    if (isBufferArgs(elements)) elements = elementState.getElements(elementState.create(elements, true));
                    else if (elements) {
                        elements = elementState.getElements(elements);
                        check$1.command(elements, 'invalid elements', env.commandStr);
                    }
                    var result = createStaticDecl(function(env, scope) {
                        if (elements) {
                            var result = env.link(elements);
                            env.ELEMENTS = result;
                            return result;
                        }
                        env.ELEMENTS = null;
                        return null;
                    });
                    result.value = elements;
                    return result;
                } else if (S_ELEMENTS in dynamicOptions) {
                    var dyn = dynamicOptions[S_ELEMENTS];
                    return createDynamicDecl(dyn, function(env, scope) {
                        var shared = env.shared;
                        var IS_BUFFER_ARGS = shared.isBufferArgs;
                        var ELEMENT_STATE = shared.elements;
                        var elementDefn = env.invoke(scope, dyn);
                        var elements = scope.def('null');
                        var elementStream = scope.def(IS_BUFFER_ARGS, '(', elementDefn, ')');
                        var ifte = env.cond(elementStream).then(elements, '=', ELEMENT_STATE, '.createStream(', elementDefn, ');').else(elements, '=', ELEMENT_STATE, '.getElements(', elementDefn, ');');
                        check$1.optional(function() {
                            env.assert(ifte.else, '!' + elementDefn + '||' + elements, 'invalid elements');
                        });
                        scope.entry(ifte);
                        scope.exit(env.cond(elementStream).then(ELEMENT_STATE, '.destroyStream(', elements, ');'));
                        env.ELEMENTS = elements;
                        return elements;
                    });
                }
                return null;
            }
            var elements = parseElements();
            function parsePrimitive() {
                if (S_PRIMITIVE in staticOptions) {
                    var primitive = staticOptions[S_PRIMITIVE];
                    check$1.commandParameter(primitive, primTypes, 'invalid primitve', env.commandStr);
                    return createStaticDecl(function(env, scope) {
                        return primTypes[primitive];
                    });
                } else if (S_PRIMITIVE in dynamicOptions) {
                    var dynPrimitive = dynamicOptions[S_PRIMITIVE];
                    return createDynamicDecl(dynPrimitive, function(env, scope) {
                        var PRIM_TYPES = env.constants.primTypes;
                        var prim = env.invoke(scope, dynPrimitive);
                        check$1.optional(function() {
                            env.assert(scope, prim + ' in ' + PRIM_TYPES, 'invalid primitive, must be one of ' + Object.keys(primTypes));
                        });
                        return scope.def(PRIM_TYPES, '[', prim, ']');
                    });
                } else if (elements) {
                    if (isStatic(elements)) {
                        if (elements.value) return createStaticDecl(function(env, scope) {
                            return scope.def(env.ELEMENTS, '.primType');
                        });
                        else return createStaticDecl(function() {
                            return GL_TRIANGLES$1;
                        });
                    } else return new Declaration(elements.thisDep, elements.contextDep, elements.propDep, function(env, scope) {
                        var elements = env.ELEMENTS;
                        return scope.def(elements, '?', elements, '.primType:', GL_TRIANGLES$1);
                    });
                }
                return null;
            }
            function parseParam(param, isOffset) {
                if (param in staticOptions) {
                    var value = staticOptions[param] | 0;
                    check$1.command(!isOffset || value >= 0, 'invalid ' + param, env.commandStr);
                    return createStaticDecl(function(env, scope) {
                        if (isOffset) env.OFFSET = value;
                        return value;
                    });
                } else if (param in dynamicOptions) {
                    var dynValue = dynamicOptions[param];
                    return createDynamicDecl(dynValue, function(env, scope) {
                        var result = env.invoke(scope, dynValue);
                        if (isOffset) {
                            env.OFFSET = result;
                            check$1.optional(function() {
                                env.assert(scope, result + '>=0', 'invalid ' + param);
                            });
                        }
                        return result;
                    });
                } else if (isOffset && elements) return createStaticDecl(function(env, scope) {
                    env.OFFSET = '0';
                    return 0;
                });
                return null;
            }
            var OFFSET = parseParam(S_OFFSET, true);
            function parseVertCount() {
                if (S_COUNT in staticOptions) {
                    var count = staticOptions[S_COUNT] | 0;
                    check$1.command(typeof count === 'number' && count >= 0, 'invalid vertex count', env.commandStr);
                    return createStaticDecl(function() {
                        return count;
                    });
                } else if (S_COUNT in dynamicOptions) {
                    var dynCount = dynamicOptions[S_COUNT];
                    return createDynamicDecl(dynCount, function(env, scope) {
                        var result = env.invoke(scope, dynCount);
                        check$1.optional(function() {
                            env.assert(scope, 'typeof ' + result + '==="number"&&' + result + '>=0&&' + result + '===(' + result + '|0)', 'invalid vertex count');
                        });
                        return result;
                    });
                } else if (elements) {
                    if (isStatic(elements)) {
                        if (elements) {
                            if (OFFSET) return new Declaration(OFFSET.thisDep, OFFSET.contextDep, OFFSET.propDep, function(env, scope) {
                                var result = scope.def(env.ELEMENTS, '.vertCount-', env.OFFSET);
                                check$1.optional(function() {
                                    env.assert(scope, result + '>=0', 'invalid vertex offset/element buffer too small');
                                });
                                return result;
                            });
                            else return createStaticDecl(function(env, scope) {
                                return scope.def(env.ELEMENTS, '.vertCount');
                            });
                        } else {
                            var result = createStaticDecl(function() {
                                return -1;
                            });
                            check$1.optional(function() {
                                result.MISSING = true;
                            });
                            return result;
                        }
                    } else {
                        var variable = new Declaration(elements.thisDep || OFFSET.thisDep, elements.contextDep || OFFSET.contextDep, elements.propDep || OFFSET.propDep, function(env, scope) {
                            var elements = env.ELEMENTS;
                            if (env.OFFSET) return scope.def(elements, '?', elements, '.vertCount-', env.OFFSET, ':-1');
                            return scope.def(elements, '?', elements, '.vertCount:-1');
                        });
                        check$1.optional(function() {
                            variable.DYNAMIC = true;
                        });
                        return variable;
                    }
                }
                return null;
            }
            return {
                elements: elements,
                primitive: parsePrimitive(),
                count: parseVertCount(),
                instances: parseParam(S_INSTANCES, false),
                offset: OFFSET
            };
        }
        function parseGLState(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            var STATE = {};
            GL_STATE_NAMES.forEach(function(prop) {
                var param = propName(prop);
                function parseParam(parseStatic, parseDynamic) {
                    if (prop in staticOptions) {
                        var value = parseStatic(staticOptions[prop]);
                        STATE[param] = createStaticDecl(function() {
                            return value;
                        });
                    } else if (prop in dynamicOptions) {
                        var dyn = dynamicOptions[prop];
                        STATE[param] = createDynamicDecl(dyn, function(env, scope) {
                            return parseDynamic(env, scope, env.invoke(scope, dyn));
                        });
                    }
                }
                switch(prop){
                    case S_CULL_ENABLE:
                    case S_BLEND_ENABLE:
                    case S_DITHER:
                    case S_STENCIL_ENABLE:
                    case S_DEPTH_ENABLE:
                    case S_SCISSOR_ENABLE:
                    case S_POLYGON_OFFSET_ENABLE:
                    case S_SAMPLE_ALPHA:
                    case S_SAMPLE_ENABLE:
                    case S_DEPTH_MASK:
                        return parseParam(function(value) {
                            check$1.commandType(value, 'boolean', prop, env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, 'typeof ' + value + '==="boolean"', 'invalid flag ' + prop, env.commandStr);
                            });
                            return value;
                        });
                    case S_DEPTH_FUNC:
                        return parseParam(function(value) {
                            check$1.commandParameter(value, compareFuncs, 'invalid ' + prop, env.commandStr);
                            return compareFuncs[value];
                        }, function(env, scope, value) {
                            var COMPARE_FUNCS = env.constants.compareFuncs;
                            check$1.optional(function() {
                                env.assert(scope, value + ' in ' + COMPARE_FUNCS, 'invalid ' + prop + ', must be one of ' + Object.keys(compareFuncs));
                            });
                            return scope.def(COMPARE_FUNCS, '[', value, ']');
                        });
                    case S_DEPTH_RANGE:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number' && value[0] <= value[1], 'depth range is 2d array', env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + '(' + value + ')&&' + value + '.length===2&&' + 'typeof ' + value + '[0]==="number"&&' + 'typeof ' + value + '[1]==="number"&&' + value + '[0]<=' + value + '[1]', 'depth range must be a 2d array');
                            });
                            var Z_NEAR = scope.def('+', value, '[0]');
                            var Z_FAR = scope.def('+', value, '[1]');
                            return [
                                Z_NEAR,
                                Z_FAR
                            ];
                        });
                    case S_BLEND_FUNC:
                        return parseParam(function(value) {
                            check$1.commandType(value, 'object', 'blend.func', env.commandStr);
                            var srcRGB = 'srcRGB' in value ? value.srcRGB : value.src;
                            var srcAlpha = 'srcAlpha' in value ? value.srcAlpha : value.src;
                            var dstRGB = 'dstRGB' in value ? value.dstRGB : value.dst;
                            var dstAlpha = 'dstAlpha' in value ? value.dstAlpha : value.dst;
                            check$1.commandParameter(srcRGB, blendFuncs, param + '.srcRGB', env.commandStr);
                            check$1.commandParameter(srcAlpha, blendFuncs, param + '.srcAlpha', env.commandStr);
                            check$1.commandParameter(dstRGB, blendFuncs, param + '.dstRGB', env.commandStr);
                            check$1.commandParameter(dstAlpha, blendFuncs, param + '.dstAlpha', env.commandStr);
                            check$1.command(invalidBlendCombinations.indexOf(srcRGB + ', ' + dstRGB) === -1, 'unallowed blending combination (srcRGB, dstRGB) = (' + srcRGB + ', ' + dstRGB + ')', env.commandStr);
                            return [
                                blendFuncs[srcRGB],
                                blendFuncs[dstRGB],
                                blendFuncs[srcAlpha],
                                blendFuncs[dstAlpha]
                            ];
                        }, function(env, scope, value) {
                            var BLEND_FUNCS = env.constants.blendFuncs;
                            check$1.optional(function() {
                                env.assert(scope, value + '&&typeof ' + value + '==="object"', 'invalid blend func, must be an object');
                            });
                            function read(prefix, suffix) {
                                var func = scope.def('"', prefix, suffix, '" in ', value, '?', value, '.', prefix, suffix, ':', value, '.', prefix);
                                check$1.optional(function() {
                                    env.assert(scope, func + ' in ' + BLEND_FUNCS, 'invalid ' + prop + '.' + prefix + suffix + ', must be one of ' + Object.keys(blendFuncs));
                                });
                                return func;
                            }
                            var srcRGB = read('src', 'RGB');
                            var dstRGB = read('dst', 'RGB');
                            check$1.optional(function() {
                                var INVALID_BLEND_COMBINATIONS = env.constants.invalidBlendCombinations;
                                env.assert(scope, INVALID_BLEND_COMBINATIONS + '.indexOf(' + srcRGB + '+", "+' + dstRGB + ') === -1 ', 'unallowed blending combination for (srcRGB, dstRGB)');
                            });
                            var SRC_RGB = scope.def(BLEND_FUNCS, '[', srcRGB, ']');
                            var SRC_ALPHA = scope.def(BLEND_FUNCS, '[', read('src', 'Alpha'), ']');
                            var DST_RGB = scope.def(BLEND_FUNCS, '[', dstRGB, ']');
                            var DST_ALPHA = scope.def(BLEND_FUNCS, '[', read('dst', 'Alpha'), ']');
                            return [
                                SRC_RGB,
                                DST_RGB,
                                SRC_ALPHA,
                                DST_ALPHA
                            ];
                        });
                    case S_BLEND_EQUATION:
                        return parseParam(function(value) {
                            if (typeof value === 'string') {
                                check$1.commandParameter(value, blendEquations, 'invalid ' + prop, env.commandStr);
                                return [
                                    blendEquations[value],
                                    blendEquations[value]
                                ];
                            } else if (typeof value === 'object') {
                                check$1.commandParameter(value.rgb, blendEquations, prop + '.rgb', env.commandStr);
                                check$1.commandParameter(value.alpha, blendEquations, prop + '.alpha', env.commandStr);
                                return [
                                    blendEquations[value.rgb],
                                    blendEquations[value.alpha]
                                ];
                            } else check$1.commandRaise('invalid blend.equation', env.commandStr);
                        }, function(env, scope, value) {
                            var BLEND_EQUATIONS = env.constants.blendEquations;
                            var RGB = scope.def();
                            var ALPHA = scope.def();
                            var ifte = env.cond('typeof ', value, '==="string"');
                            check$1.optional(function() {
                                function checkProp(block, name, value) {
                                    env.assert(block, value + ' in ' + BLEND_EQUATIONS, 'invalid ' + name + ', must be one of ' + Object.keys(blendEquations));
                                }
                                checkProp(ifte.then, prop, value);
                                env.assert(ifte.else, value + '&&typeof ' + value + '==="object"', 'invalid ' + prop);
                                checkProp(ifte.else, prop + '.rgb', value + '.rgb');
                                checkProp(ifte.else, prop + '.alpha', value + '.alpha');
                            });
                            ifte.then(RGB, '=', ALPHA, '=', BLEND_EQUATIONS, '[', value, '];');
                            ifte.else(RGB, '=', BLEND_EQUATIONS, '[', value, '.rgb];', ALPHA, '=', BLEND_EQUATIONS, '[', value, '.alpha];');
                            scope(ifte);
                            return [
                                RGB,
                                ALPHA
                            ];
                        });
                    case S_BLEND_COLOR:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 4, 'blend.color must be a 4d array', env.commandStr);
                            return loop(4, function(i) {
                                return +value[i];
                            });
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + '(' + value + ')&&' + value + '.length===4', 'blend.color must be a 4d array');
                            });
                            return loop(4, function(i) {
                                return scope.def('+', value, '[', i, ']');
                            });
                        });
                    case S_STENCIL_MASK:
                        return parseParam(function(value) {
                            check$1.commandType(value, 'number', param, env.commandStr);
                            return value | 0;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, 'typeof ' + value + '==="number"', 'invalid stencil.mask');
                            });
                            return scope.def(value, '|0');
                        });
                    case S_STENCIL_FUNC:
                        return parseParam(function(value) {
                            check$1.commandType(value, 'object', param, env.commandStr);
                            var cmp = value.cmp || 'keep';
                            var ref = value.ref || 0;
                            var mask = 'mask' in value ? value.mask : -1;
                            check$1.commandParameter(cmp, compareFuncs, prop + '.cmp', env.commandStr);
                            check$1.commandType(ref, 'number', prop + '.ref', env.commandStr);
                            check$1.commandType(mask, 'number', prop + '.mask', env.commandStr);
                            return [
                                compareFuncs[cmp],
                                ref,
                                mask
                            ];
                        }, function(env, scope, value) {
                            var COMPARE_FUNCS = env.constants.compareFuncs;
                            check$1.optional(function() {
                                function assert() {
                                    env.assert(scope, Array.prototype.join.call(arguments, ''), 'invalid stencil.func');
                                }
                                assert(value + '&&typeof ', value, '==="object"');
                                assert('!("cmp" in ', value, ')||(', value, '.cmp in ', COMPARE_FUNCS, ')');
                            });
                            var cmp = scope.def('"cmp" in ', value, '?', COMPARE_FUNCS, '[', value, '.cmp]', ':', GL_KEEP);
                            var ref = scope.def(value, '.ref|0');
                            var mask = scope.def('"mask" in ', value, '?', value, '.mask|0:-1');
                            return [
                                cmp,
                                ref,
                                mask
                            ];
                        });
                    case S_STENCIL_OPFRONT:
                    case S_STENCIL_OPBACK:
                        return parseParam(function(value) {
                            check$1.commandType(value, 'object', param, env.commandStr);
                            var fail = value.fail || 'keep';
                            var zfail = value.zfail || 'keep';
                            var zpass = value.zpass || 'keep';
                            check$1.commandParameter(fail, stencilOps, prop + '.fail', env.commandStr);
                            check$1.commandParameter(zfail, stencilOps, prop + '.zfail', env.commandStr);
                            check$1.commandParameter(zpass, stencilOps, prop + '.zpass', env.commandStr);
                            return [
                                prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                                stencilOps[fail],
                                stencilOps[zfail],
                                stencilOps[zpass]
                            ];
                        }, function(env, scope, value) {
                            var STENCIL_OPS = env.constants.stencilOps;
                            check$1.optional(function() {
                                env.assert(scope, value + '&&typeof ' + value + '==="object"', 'invalid ' + prop);
                            });
                            function read(name) {
                                check$1.optional(function() {
                                    env.assert(scope, '!("' + name + '" in ' + value + ')||' + '(' + value + '.' + name + ' in ' + STENCIL_OPS + ')', 'invalid ' + prop + '.' + name + ', must be one of ' + Object.keys(stencilOps));
                                });
                                return scope.def('"', name, '" in ', value, '?', STENCIL_OPS, '[', value, '.', name, ']:', GL_KEEP);
                            }
                            return [
                                prop === S_STENCIL_OPBACK ? GL_BACK : GL_FRONT,
                                read('fail'),
                                read('zfail'),
                                read('zpass')
                            ];
                        });
                    case S_POLYGON_OFFSET_OFFSET:
                        return parseParam(function(value) {
                            check$1.commandType(value, 'object', param, env.commandStr);
                            var factor = value.factor | 0;
                            var units = value.units | 0;
                            check$1.commandType(factor, 'number', param + '.factor', env.commandStr);
                            check$1.commandType(units, 'number', param + '.units', env.commandStr);
                            return [
                                factor,
                                units
                            ];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '&&typeof ' + value + '==="object"', 'invalid ' + prop);
                            });
                            var FACTOR = scope.def(value, '.factor|0');
                            var UNITS = scope.def(value, '.units|0');
                            return [
                                FACTOR,
                                UNITS
                            ];
                        });
                    case S_CULL_FACE:
                        return parseParam(function(value) {
                            var face = 0;
                            if (value === 'front') face = GL_FRONT;
                            else if (value === 'back') face = GL_BACK;
                            check$1.command(!!face, param, env.commandStr);
                            return face;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '==="front"||' + value + '==="back"', 'invalid cull.face');
                            });
                            return scope.def(value, '==="front"?', GL_FRONT, ':', GL_BACK);
                        });
                    case S_LINE_WIDTH:
                        return parseParam(function(value) {
                            check$1.command(typeof value === 'number' && value >= limits.lineWidthDims[0] && value <= limits.lineWidthDims[1], 'invalid line width, must be a positive number between ' + limits.lineWidthDims[0] + ' and ' + limits.lineWidthDims[1], env.commandStr);
                            return value;
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, 'typeof ' + value + '==="number"&&' + value + '>=' + limits.lineWidthDims[0] + '&&' + value + '<=' + limits.lineWidthDims[1], 'invalid line width');
                            });
                            return value;
                        });
                    case S_FRONT_FACE:
                        return parseParam(function(value) {
                            check$1.commandParameter(value, orientationType, param, env.commandStr);
                            return orientationType[value];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '==="cw"||' + value + '==="ccw"', 'invalid frontFace, must be one of cw,ccw');
                            });
                            return scope.def(value + '==="cw"?' + GL_CW + ':' + GL_CCW);
                        });
                    case S_COLOR_MASK:
                        return parseParam(function(value) {
                            check$1.command(isArrayLike(value) && value.length === 4, 'color.mask must be length 4 array', env.commandStr);
                            return value.map(function(v) {
                                return !!v;
                            });
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, env.shared.isArrayLike + '(' + value + ')&&' + value + '.length===4', 'invalid color.mask');
                            });
                            return loop(4, function(i) {
                                return '!!' + value + '[' + i + ']';
                            });
                        });
                    case S_SAMPLE_COVERAGE:
                        return parseParam(function(value) {
                            check$1.command(typeof value === 'object' && value, param, env.commandStr);
                            var sampleValue = 'value' in value ? value.value : 1;
                            var sampleInvert = !!value.invert;
                            check$1.command(typeof sampleValue === 'number' && sampleValue >= 0 && sampleValue <= 1, 'sample.coverage.value must be a number between 0 and 1', env.commandStr);
                            return [
                                sampleValue,
                                sampleInvert
                            ];
                        }, function(env, scope, value) {
                            check$1.optional(function() {
                                env.assert(scope, value + '&&typeof ' + value + '==="object"', 'invalid sample.coverage');
                            });
                            var VALUE = scope.def('"value" in ', value, '?+', value, '.value:1');
                            var INVERT = scope.def('!!', value, '.invert');
                            return [
                                VALUE,
                                INVERT
                            ];
                        });
                }
            });
            return STATE;
        }
        function parseUniforms(uniforms, env) {
            var staticUniforms = uniforms.static;
            var dynamicUniforms = uniforms.dynamic;
            var UNIFORMS = {};
            Object.keys(staticUniforms).forEach(function(name) {
                var value = staticUniforms[name];
                var result;
                if (typeof value === 'number' || typeof value === 'boolean') result = createStaticDecl(function() {
                    return value;
                });
                else if (typeof value === 'function') {
                    var reglType = value._reglType;
                    if (reglType === 'texture2d' || reglType === 'textureCube') result = createStaticDecl(function(env) {
                        return env.link(value);
                    });
                    else if (reglType === 'framebuffer' || reglType === 'framebufferCube') {
                        check$1.command(value.color.length > 0, 'missing color attachment for framebuffer sent to uniform "' + name + '"', env.commandStr);
                        result = createStaticDecl(function(env) {
                            return env.link(value.color[0]);
                        });
                    } else check$1.commandRaise('invalid data for uniform "' + name + '"', env.commandStr);
                } else if (isArrayLike(value)) result = createStaticDecl(function(env) {
                    var ITEM = env.global.def('[', loop(value.length, function(i) {
                        check$1.command(typeof value[i] === 'number' || typeof value[i] === 'boolean', 'invalid uniform ' + name, env.commandStr);
                        return value[i];
                    }), ']');
                    return ITEM;
                });
                else check$1.commandRaise('invalid or missing data for uniform "' + name + '"', env.commandStr);
                result.value = value;
                UNIFORMS[name] = result;
            });
            Object.keys(dynamicUniforms).forEach(function(key) {
                var dyn = dynamicUniforms[key];
                UNIFORMS[key] = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            });
            return UNIFORMS;
        }
        function parseAttributes(attributes, env) {
            var staticAttributes = attributes.static;
            var dynamicAttributes = attributes.dynamic;
            var attributeDefs = {};
            Object.keys(staticAttributes).forEach(function(attribute) {
                var value = staticAttributes[attribute];
                var id = stringStore.id(attribute);
                var record = new AttributeRecord();
                if (isBufferArgs(value)) {
                    record.state = ATTRIB_STATE_POINTER;
                    record.buffer = bufferState.getBuffer(bufferState.create(value, GL_ARRAY_BUFFER$2, false, true));
                    record.type = 0;
                } else {
                    var buffer = bufferState.getBuffer(value);
                    if (buffer) {
                        record.state = ATTRIB_STATE_POINTER;
                        record.buffer = buffer;
                        record.type = 0;
                    } else {
                        check$1.command(typeof value === 'object' && value, 'invalid data for attribute ' + attribute, env.commandStr);
                        if ('constant' in value) {
                            var constant = value.constant;
                            record.buffer = 'null';
                            record.state = ATTRIB_STATE_CONSTANT;
                            if (typeof constant === 'number') record.x = constant;
                            else {
                                check$1.command(isArrayLike(constant) && constant.length > 0 && constant.length <= 4, 'invalid constant for attribute ' + attribute, env.commandStr);
                                CUTE_COMPONENTS.forEach(function(c, i) {
                                    if (i < constant.length) record[c] = constant[i];
                                });
                            }
                        } else {
                            if (isBufferArgs(value.buffer)) buffer = bufferState.getBuffer(bufferState.create(value.buffer, GL_ARRAY_BUFFER$2, false, true));
                            else buffer = bufferState.getBuffer(value.buffer);
                            check$1.command(!!buffer, 'missing buffer for attribute "' + attribute + '"', env.commandStr);
                            var offset = value.offset | 0;
                            check$1.command(offset >= 0, 'invalid offset for attribute "' + attribute + '"', env.commandStr);
                            var stride = value.stride | 0;
                            check$1.command(stride >= 0 && stride < 256, 'invalid stride for attribute "' + attribute + '", must be integer betweeen [0, 255]', env.commandStr);
                            var size = value.size | 0;
                            check$1.command(!('size' in value) || size > 0 && size <= 4, 'invalid size for attribute "' + attribute + '", must be 1,2,3,4', env.commandStr);
                            var normalized = !!value.normalized;
                            var type = 0;
                            if ('type' in value) {
                                check$1.commandParameter(value.type, glTypes, 'invalid type for attribute ' + attribute, env.commandStr);
                                type = glTypes[value.type];
                            }
                            var divisor = value.divisor | 0;
                            if ('divisor' in value) {
                                check$1.command(divisor === 0 || extInstancing, 'cannot specify divisor for attribute "' + attribute + '", instancing not supported', env.commandStr);
                                check$1.command(divisor >= 0, 'invalid divisor for attribute "' + attribute + '"', env.commandStr);
                            }
                            check$1.optional(function() {
                                var command = env.commandStr;
                                var VALID_KEYS = [
                                    'buffer',
                                    'offset',
                                    'divisor',
                                    'normalized',
                                    'type',
                                    'size',
                                    'stride'
                                ];
                                Object.keys(value).forEach(function(prop) {
                                    check$1.command(VALID_KEYS.indexOf(prop) >= 0, 'unknown parameter "' + prop + '" for attribute pointer "' + attribute + '" (valid parameters are ' + VALID_KEYS + ')', command);
                                });
                            });
                            record.buffer = buffer;
                            record.state = ATTRIB_STATE_POINTER;
                            record.size = size;
                            record.normalized = normalized;
                            record.type = type || buffer.dtype;
                            record.offset = offset;
                            record.stride = stride;
                            record.divisor = divisor;
                        }
                    }
                }
                attributeDefs[attribute] = createStaticDecl(function(env, scope) {
                    var cache = env.attribCache;
                    if (id in cache) return cache[id];
                    var result = {
                        isStream: false
                    };
                    Object.keys(record).forEach(function(key) {
                        result[key] = record[key];
                    });
                    if (record.buffer) {
                        result.buffer = env.link(record.buffer);
                        result.type = result.type || result.buffer + '.dtype';
                    }
                    cache[id] = result;
                    return result;
                });
            });
            Object.keys(dynamicAttributes).forEach(function(attribute) {
                var dyn = dynamicAttributes[attribute];
                function appendAttributeCode(env, block) {
                    var VALUE = env.invoke(block, dyn);
                    var shared = env.shared;
                    var constants = env.constants;
                    var IS_BUFFER_ARGS = shared.isBufferArgs;
                    var BUFFER_STATE = shared.buffer;
                    // Perform validation on attribute
                    check$1.optional(function() {
                        env.assert(block, VALUE + '&&(typeof ' + VALUE + '==="object"||typeof ' + VALUE + '==="function")&&(' + IS_BUFFER_ARGS + '(' + VALUE + ')||' + BUFFER_STATE + '.getBuffer(' + VALUE + ')||' + BUFFER_STATE + '.getBuffer(' + VALUE + '.buffer)||' + IS_BUFFER_ARGS + '(' + VALUE + '.buffer)||' + '("constant" in ' + VALUE + '&&(typeof ' + VALUE + '.constant==="number"||' + shared.isArrayLike + '(' + VALUE + '.constant))))', 'invalid dynamic attribute "' + attribute + '"');
                    });
                    // allocate names for result
                    var result = {
                        isStream: block.def(false)
                    };
                    var defaultRecord = new AttributeRecord();
                    defaultRecord.state = ATTRIB_STATE_POINTER;
                    Object.keys(defaultRecord).forEach(function(key) {
                        result[key] = block.def('' + defaultRecord[key]);
                    });
                    var BUFFER = result.buffer;
                    var TYPE = result.type;
                    block('if(', IS_BUFFER_ARGS, '(', VALUE, ')){', result.isStream, '=true;', BUFFER, '=', BUFFER_STATE, '.createStream(', GL_ARRAY_BUFFER$2, ',', VALUE, ');', TYPE, '=', BUFFER, '.dtype;', '}else{', BUFFER, '=', BUFFER_STATE, '.getBuffer(', VALUE, ');', 'if(', BUFFER, '){', TYPE, '=', BUFFER, '.dtype;', '}else if("constant" in ', VALUE, '){', result.state, '=', ATTRIB_STATE_CONSTANT, ';', 'if(typeof ' + VALUE + '.constant === "number"){', result[CUTE_COMPONENTS[0]], '=', VALUE, '.constant;', CUTE_COMPONENTS.slice(1).map(function(n) {
                        return result[n];
                    }).join('='), '=0;', '}else{', CUTE_COMPONENTS.map(function(name, i) {
                        return result[name] + '=' + VALUE + '.constant.length>' + i + '?' + VALUE + '.constant[' + i + ']:0;';
                    }).join(''), '}}else{', 'if(', IS_BUFFER_ARGS, '(', VALUE, '.buffer)){', BUFFER, '=', BUFFER_STATE, '.createStream(', GL_ARRAY_BUFFER$2, ',', VALUE, '.buffer);', '}else{', BUFFER, '=', BUFFER_STATE, '.getBuffer(', VALUE, '.buffer);', '}', TYPE, '="type" in ', VALUE, '?', constants.glTypes, '[', VALUE, '.type]:', BUFFER, '.dtype;', result.normalized, '=!!', VALUE, '.normalized;');
                    function emitReadRecord(name) {
                        block(result[name], '=', VALUE, '.', name, '|0;');
                    }
                    emitReadRecord('size');
                    emitReadRecord('offset');
                    emitReadRecord('stride');
                    emitReadRecord('divisor');
                    block('}}');
                    block.exit('if(', result.isStream, '){', BUFFER_STATE, '.destroyStream(', BUFFER, ');', '}');
                    return result;
                }
                attributeDefs[attribute] = createDynamicDecl(dyn, appendAttributeCode);
            });
            return attributeDefs;
        }
        function parseVAO(options, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            if (S_VAO in staticOptions) {
                var vao = staticOptions[S_VAO];
                if (vao !== null && attributeState.getVAO(vao) === null) vao = attributeState.createVAO(vao);
                return createStaticDecl(function(env) {
                    return env.link(attributeState.getVAO(vao));
                });
            } else if (S_VAO in dynamicOptions) {
                var dyn = dynamicOptions[S_VAO];
                return createDynamicDecl(dyn, function(env, scope) {
                    var vaoRef = env.invoke(scope, dyn);
                    return scope.def(env.shared.vao + '.getVAO(' + vaoRef + ')');
                });
            }
            return null;
        }
        function parseContext(context) {
            var staticContext = context.static;
            var dynamicContext = context.dynamic;
            var result = {};
            Object.keys(staticContext).forEach(function(name) {
                var value = staticContext[name];
                result[name] = createStaticDecl(function(env, scope) {
                    if (typeof value === 'number' || typeof value === 'boolean') return '' + value;
                    else return env.link(value);
                });
            });
            Object.keys(dynamicContext).forEach(function(name) {
                var dyn = dynamicContext[name];
                result[name] = createDynamicDecl(dyn, function(env, scope) {
                    return env.invoke(scope, dyn);
                });
            });
            return result;
        }
        function parseArguments(options, attributes, uniforms, context, env) {
            var staticOptions = options.static;
            var dynamicOptions = options.dynamic;
            check$1.optional(function() {
                var KEY_NAMES = [
                    S_FRAMEBUFFER,
                    S_VERT,
                    S_FRAG,
                    S_ELEMENTS,
                    S_PRIMITIVE,
                    S_OFFSET,
                    S_COUNT,
                    S_INSTANCES,
                    S_PROFILE,
                    S_VAO
                ].concat(GL_STATE_NAMES);
                function checkKeys(dict) {
                    Object.keys(dict).forEach(function(key) {
                        check$1.command(KEY_NAMES.indexOf(key) >= 0, 'unknown parameter "' + key + '"', env.commandStr);
                    });
                }
                checkKeys(staticOptions);
                checkKeys(dynamicOptions);
            });
            var attribLocations = parseAttribLocations(options, attributes);
            var framebuffer = parseFramebuffer(options, env);
            var viewportAndScissor = parseViewportScissor(options, framebuffer, env);
            var draw = parseDraw(options, env);
            var state = parseGLState(options, env);
            var shader = parseProgram(options, env, attribLocations);
            function copyBox(name) {
                var defn = viewportAndScissor[name];
                if (defn) state[name] = defn;
            }
            copyBox(S_VIEWPORT);
            copyBox(propName(S_SCISSOR_BOX));
            var dirty = Object.keys(state).length > 0;
            var result = {
                framebuffer: framebuffer,
                draw: draw,
                shader: shader,
                state: state,
                dirty: dirty,
                scopeVAO: null,
                drawVAO: null,
                useVAO: false,
                attributes: {}
            };
            result.profile = parseProfile(options, env);
            result.uniforms = parseUniforms(uniforms, env);
            result.drawVAO = result.scopeVAO = parseVAO(options, env);
            // special case: check if we can statically allocate a vertex array object for this program
            if (!result.drawVAO && shader.program && !attribLocations && extensions.angle_instanced_arrays) {
                var useVAO = true;
                var staticBindings = shader.program.attributes.map(function(attr) {
                    var binding = attributes.static[attr];
                    useVAO = useVAO && !!binding;
                    return binding;
                });
                if (useVAO && staticBindings.length > 0) {
                    var vao = attributeState.getVAO(attributeState.createVAO(staticBindings));
                    result.drawVAO = new Declaration(null, null, null, function(env, scope) {
                        return env.link(vao);
                    });
                    result.useVAO = true;
                }
            }
            if (attribLocations) result.useVAO = true;
            else result.attributes = parseAttributes(attributes, env);
            result.context = parseContext(context, env);
            return result;
        }
        // ===================================================
        // ===================================================
        // COMMON UPDATE FUNCTIONS
        // ===================================================
        // ===================================================
        function emitContext(env, scope, context) {
            var shared = env.shared;
            var CONTEXT = shared.context;
            var contextEnter = env.scope();
            Object.keys(context).forEach(function(name) {
                scope.save(CONTEXT, '.' + name);
                var defn = context[name];
                var value = defn.append(env, scope);
                if (Array.isArray(value)) contextEnter(CONTEXT, '.', name, '=[', value.join(), '];');
                else contextEnter(CONTEXT, '.', name, '=', value, ';');
            });
            scope(contextEnter);
        }
        // ===================================================
        // ===================================================
        // COMMON DRAWING FUNCTIONS
        // ===================================================
        // ===================================================
        function emitPollFramebuffer(env, scope, framebuffer, skipCheck) {
            var shared = env.shared;
            var GL = shared.gl;
            var FRAMEBUFFER_STATE = shared.framebuffer;
            var EXT_DRAW_BUFFERS;
            if (extDrawBuffers) EXT_DRAW_BUFFERS = scope.def(shared.extensions, '.webgl_draw_buffers');
            var constants = env.constants;
            var DRAW_BUFFERS = constants.drawBuffer;
            var BACK_BUFFER = constants.backBuffer;
            var NEXT;
            if (framebuffer) NEXT = framebuffer.append(env, scope);
            else NEXT = scope.def(FRAMEBUFFER_STATE, '.next');
            if (!skipCheck) scope('if(', NEXT, '!==', FRAMEBUFFER_STATE, '.cur){');
            scope('if(', NEXT, '){', GL, '.bindFramebuffer(', GL_FRAMEBUFFER$2, ',', NEXT, '.framebuffer);');
            if (extDrawBuffers) scope(EXT_DRAW_BUFFERS, '.drawBuffersWEBGL(', DRAW_BUFFERS, '[', NEXT, '.colorAttachments.length]);');
            scope('}else{', GL, '.bindFramebuffer(', GL_FRAMEBUFFER$2, ',null);');
            if (extDrawBuffers) scope(EXT_DRAW_BUFFERS, '.drawBuffersWEBGL(', BACK_BUFFER, ');');
            scope('}', FRAMEBUFFER_STATE, '.cur=', NEXT, ';');
            if (!skipCheck) scope('}');
        }
        function emitPollState(env, scope, args) {
            var shared = env.shared;
            var GL = shared.gl;
            var CURRENT_VARS = env.current;
            var NEXT_VARS = env.next;
            var CURRENT_STATE = shared.current;
            var NEXT_STATE = shared.next;
            var block = env.cond(CURRENT_STATE, '.dirty');
            GL_STATE_NAMES.forEach(function(prop) {
                var param = propName(prop);
                if (param in args.state) return;
                var NEXT, CURRENT;
                if (param in NEXT_VARS) {
                    NEXT = NEXT_VARS[param];
                    CURRENT = CURRENT_VARS[param];
                    var parts = loop(currentState[param].length, function(i) {
                        return block.def(NEXT, '[', i, ']');
                    });
                    block(env.cond(parts.map(function(p, i) {
                        return p + '!==' + CURRENT + '[' + i + ']';
                    }).join('||')).then(GL, '.', GL_VARIABLES[param], '(', parts, ');', parts.map(function(p, i) {
                        return CURRENT + '[' + i + ']=' + p;
                    }).join(';'), ';'));
                } else {
                    NEXT = block.def(NEXT_STATE, '.', param);
                    var ifte = env.cond(NEXT, '!==', CURRENT_STATE, '.', param);
                    block(ifte);
                    if (param in GL_FLAGS) ifte(env.cond(NEXT).then(GL, '.enable(', GL_FLAGS[param], ');').else(GL, '.disable(', GL_FLAGS[param], ');'), CURRENT_STATE, '.', param, '=', NEXT, ';');
                    else ifte(GL, '.', GL_VARIABLES[param], '(', NEXT, ');', CURRENT_STATE, '.', param, '=', NEXT, ';');
                }
            });
            if (Object.keys(args.state).length === 0) block(CURRENT_STATE, '.dirty=false;');
            scope(block);
        }
        function emitSetOptions(env, scope, options, filter) {
            var shared = env.shared;
            var CURRENT_VARS = env.current;
            var CURRENT_STATE = shared.current;
            var GL = shared.gl;
            sortState(Object.keys(options)).forEach(function(param) {
                var defn = options[param];
                if (filter && !filter(defn)) return;
                var variable = defn.append(env, scope);
                if (GL_FLAGS[param]) {
                    var flag = GL_FLAGS[param];
                    if (isStatic(defn)) {
                        if (variable) scope(GL, '.enable(', flag, ');');
                        else scope(GL, '.disable(', flag, ');');
                    } else scope(env.cond(variable).then(GL, '.enable(', flag, ');').else(GL, '.disable(', flag, ');'));
                    scope(CURRENT_STATE, '.', param, '=', variable, ';');
                } else if (isArrayLike(variable)) {
                    var CURRENT = CURRENT_VARS[param];
                    scope(GL, '.', GL_VARIABLES[param], '(', variable, ');', variable.map(function(v, i) {
                        return CURRENT + '[' + i + ']=' + v;
                    }).join(';'), ';');
                } else scope(GL, '.', GL_VARIABLES[param], '(', variable, ');', CURRENT_STATE, '.', param, '=', variable, ';');
            });
        }
        function injectExtensions(env, scope) {
            if (extInstancing) env.instancing = scope.def(env.shared.extensions, '.angle_instanced_arrays');
        }
        function emitProfile(env, scope, args, useScope, incrementCounter) {
            var shared = env.shared;
            var STATS = env.stats;
            var CURRENT_STATE = shared.current;
            var TIMER = shared.timer;
            var profileArg = args.profile;
            function perfCounter() {
                if (typeof performance === 'undefined') return 'Date.now()';
                else return 'performance.now()';
            }
            var CPU_START, QUERY_COUNTER;
            function emitProfileStart(block) {
                CPU_START = scope.def();
                block(CPU_START, '=', perfCounter(), ';');
                if (typeof incrementCounter === 'string') block(STATS, '.count+=', incrementCounter, ';');
                else block(STATS, '.count++;');
                if (timer) {
                    if (useScope) {
                        QUERY_COUNTER = scope.def();
                        block(QUERY_COUNTER, '=', TIMER, '.getNumPendingQueries();');
                    } else block(TIMER, '.beginQuery(', STATS, ');');
                }
            }
            function emitProfileEnd(block) {
                block(STATS, '.cpuTime+=', perfCounter(), '-', CPU_START, ';');
                if (timer) {
                    if (useScope) block(TIMER, '.pushScopeStats(', QUERY_COUNTER, ',', TIMER, '.getNumPendingQueries(),', STATS, ');');
                    else block(TIMER, '.endQuery();');
                }
            }
            function scopeProfile(value) {
                var prev = scope.def(CURRENT_STATE, '.profile');
                scope(CURRENT_STATE, '.profile=', value, ';');
                scope.exit(CURRENT_STATE, '.profile=', prev, ';');
            }
            var USE_PROFILE;
            if (profileArg) {
                if (isStatic(profileArg)) {
                    if (profileArg.enable) {
                        emitProfileStart(scope);
                        emitProfileEnd(scope.exit);
                        scopeProfile('true');
                    } else scopeProfile('false');
                    return;
                }
                USE_PROFILE = profileArg.append(env, scope);
                scopeProfile(USE_PROFILE);
            } else USE_PROFILE = scope.def(CURRENT_STATE, '.profile');
            var start = env.block();
            emitProfileStart(start);
            scope('if(', USE_PROFILE, '){', start, '}');
            var end = env.block();
            emitProfileEnd(end);
            scope.exit('if(', USE_PROFILE, '){', end, '}');
        }
        function emitAttributes(env, scope, args, attributes, filter) {
            var shared = env.shared;
            function typeLength(x) {
                switch(x){
                    case GL_FLOAT_VEC2:
                    case GL_INT_VEC2:
                    case GL_BOOL_VEC2:
                        return 2;
                    case GL_FLOAT_VEC3:
                    case GL_INT_VEC3:
                    case GL_BOOL_VEC3:
                        return 3;
                    case GL_FLOAT_VEC4:
                    case GL_INT_VEC4:
                    case GL_BOOL_VEC4:
                        return 4;
                    default:
                        return 1;
                }
            }
            function emitBindAttribute(ATTRIBUTE, size, record) {
                var GL = shared.gl;
                var LOCATION = scope.def(ATTRIBUTE, '.location');
                var BINDING = scope.def(shared.attributes, '[', LOCATION, ']');
                var STATE = record.state;
                var BUFFER = record.buffer;
                var CONST_COMPONENTS = [
                    record.x,
                    record.y,
                    record.z,
                    record.w
                ];
                var COMMON_KEYS = [
                    'buffer',
                    'normalized',
                    'offset',
                    'stride'
                ];
                function emitBuffer() {
                    scope('if(!', BINDING, '.buffer){', GL, '.enableVertexAttribArray(', LOCATION, ');}');
                    var TYPE = record.type;
                    var SIZE;
                    if (!record.size) SIZE = size;
                    else SIZE = scope.def(record.size, '||', size);
                    scope('if(', BINDING, '.type!==', TYPE, '||', BINDING, '.size!==', SIZE, '||', COMMON_KEYS.map(function(key) {
                        return BINDING + '.' + key + '!==' + record[key];
                    }).join('||'), '){', GL, '.bindBuffer(', GL_ARRAY_BUFFER$2, ',', BUFFER, '.buffer);', GL, '.vertexAttribPointer(', [
                        LOCATION,
                        SIZE,
                        TYPE,
                        record.normalized,
                        record.stride,
                        record.offset
                    ], ');', BINDING, '.type=', TYPE, ';', BINDING, '.size=', SIZE, ';', COMMON_KEYS.map(function(key) {
                        return BINDING + '.' + key + '=' + record[key] + ';';
                    }).join(''), '}');
                    if (extInstancing) {
                        var DIVISOR = record.divisor;
                        scope('if(', BINDING, '.divisor!==', DIVISOR, '){', env.instancing, '.vertexAttribDivisorANGLE(', [
                            LOCATION,
                            DIVISOR
                        ], ');', BINDING, '.divisor=', DIVISOR, ';}');
                    }
                }
                function emitConstant() {
                    scope('if(', BINDING, '.buffer){', GL, '.disableVertexAttribArray(', LOCATION, ');', BINDING, '.buffer=null;', '}if(', CUTE_COMPONENTS.map(function(c, i) {
                        return BINDING + '.' + c + '!==' + CONST_COMPONENTS[i];
                    }).join('||'), '){', GL, '.vertexAttrib4f(', LOCATION, ',', CONST_COMPONENTS, ');', CUTE_COMPONENTS.map(function(c, i) {
                        return BINDING + '.' + c + '=' + CONST_COMPONENTS[i] + ';';
                    }).join(''), '}');
                }
                if (STATE === ATTRIB_STATE_POINTER) emitBuffer();
                else if (STATE === ATTRIB_STATE_CONSTANT) emitConstant();
                else {
                    scope('if(', STATE, '===', ATTRIB_STATE_POINTER, '){');
                    emitBuffer();
                    scope('}else{');
                    emitConstant();
                    scope('}');
                }
            }
            attributes.forEach(function(attribute) {
                var name = attribute.name;
                var arg = args.attributes[name];
                var record;
                if (arg) {
                    if (!filter(arg)) return;
                    record = arg.append(env, scope);
                } else {
                    if (!filter(SCOPE_DECL)) return;
                    var scopeAttrib = env.scopeAttrib(name);
                    check$1.optional(function() {
                        env.assert(scope, scopeAttrib + '.state', 'missing attribute ' + name);
                    });
                    record = {};
                    Object.keys(new AttributeRecord()).forEach(function(key) {
                        record[key] = scope.def(scopeAttrib, '.', key);
                    });
                }
                emitBindAttribute(env.link(attribute), typeLength(attribute.info.type), record);
            });
        }
        function emitUniforms(env, scope, args, uniforms, filter) {
            var shared = env.shared;
            var GL = shared.gl;
            var infix;
            for(var i = 0; i < uniforms.length; ++i){
                var uniform = uniforms[i];
                var name = uniform.name;
                var type = uniform.info.type;
                var arg = args.uniforms[name];
                var UNIFORM = env.link(uniform);
                var LOCATION = UNIFORM + '.location';
                var VALUE;
                if (arg) {
                    if (!filter(arg)) continue;
                    if (isStatic(arg)) {
                        var value = arg.value;
                        check$1.command(value !== null && typeof value !== 'undefined', 'missing uniform "' + name + '"', env.commandStr);
                        if (type === GL_SAMPLER_2D || type === GL_SAMPLER_CUBE) {
                            check$1.command(typeof value === 'function' && (type === GL_SAMPLER_2D && (value._reglType === 'texture2d' || value._reglType === 'framebuffer') || type === GL_SAMPLER_CUBE && (value._reglType === 'textureCube' || value._reglType === 'framebufferCube')), 'invalid texture for uniform ' + name, env.commandStr);
                            var TEX_VALUE = env.link(value._texture || value.color[0]._texture);
                            scope(GL, '.uniform1i(', LOCATION, ',', TEX_VALUE + '.bind());');
                            scope.exit(TEX_VALUE, '.unbind();');
                        } else if (type === GL_FLOAT_MAT2 || type === GL_FLOAT_MAT3 || type === GL_FLOAT_MAT4) {
                            check$1.optional(function() {
                                check$1.command(isArrayLike(value), 'invalid matrix for uniform ' + name, env.commandStr);
                                check$1.command(type === GL_FLOAT_MAT2 && value.length === 4 || type === GL_FLOAT_MAT3 && value.length === 9 || type === GL_FLOAT_MAT4 && value.length === 16, 'invalid length for matrix uniform ' + name, env.commandStr);
                            });
                            var MAT_VALUE = env.global.def('new Float32Array([' + Array.prototype.slice.call(value) + '])');
                            var dim = 2;
                            if (type === GL_FLOAT_MAT3) dim = 3;
                            else if (type === GL_FLOAT_MAT4) dim = 4;
                            scope(GL, '.uniformMatrix', dim, 'fv(', LOCATION, ',false,', MAT_VALUE, ');');
                        } else {
                            switch(type){
                                case GL_FLOAT$8:
                                    check$1.commandType(value, 'number', 'uniform ' + name, env.commandStr);
                                    infix = '1f';
                                    break;
                                case GL_FLOAT_VEC2:
                                    check$1.command(isArrayLike(value) && value.length === 2, 'uniform ' + name, env.commandStr);
                                    infix = '2f';
                                    break;
                                case GL_FLOAT_VEC3:
                                    check$1.command(isArrayLike(value) && value.length === 3, 'uniform ' + name, env.commandStr);
                                    infix = '3f';
                                    break;
                                case GL_FLOAT_VEC4:
                                    check$1.command(isArrayLike(value) && value.length === 4, 'uniform ' + name, env.commandStr);
                                    infix = '4f';
                                    break;
                                case GL_BOOL:
                                    check$1.commandType(value, 'boolean', 'uniform ' + name, env.commandStr);
                                    infix = '1i';
                                    break;
                                case GL_INT$3:
                                    check$1.commandType(value, 'number', 'uniform ' + name, env.commandStr);
                                    infix = '1i';
                                    break;
                                case GL_BOOL_VEC2:
                                    check$1.command(isArrayLike(value) && value.length === 2, 'uniform ' + name, env.commandStr);
                                    infix = '2i';
                                    break;
                                case GL_INT_VEC2:
                                    check$1.command(isArrayLike(value) && value.length === 2, 'uniform ' + name, env.commandStr);
                                    infix = '2i';
                                    break;
                                case GL_BOOL_VEC3:
                                    check$1.command(isArrayLike(value) && value.length === 3, 'uniform ' + name, env.commandStr);
                                    infix = '3i';
                                    break;
                                case GL_INT_VEC3:
                                    check$1.command(isArrayLike(value) && value.length === 3, 'uniform ' + name, env.commandStr);
                                    infix = '3i';
                                    break;
                                case GL_BOOL_VEC4:
                                    check$1.command(isArrayLike(value) && value.length === 4, 'uniform ' + name, env.commandStr);
                                    infix = '4i';
                                    break;
                                case GL_INT_VEC4:
                                    check$1.command(isArrayLike(value) && value.length === 4, 'uniform ' + name, env.commandStr);
                                    infix = '4i';
                                    break;
                            }
                            scope(GL, '.uniform', infix, '(', LOCATION, ',', isArrayLike(value) ? Array.prototype.slice.call(value) : value, ');');
                        }
                        continue;
                    } else VALUE = arg.append(env, scope);
                } else {
                    if (!filter(SCOPE_DECL)) continue;
                    VALUE = scope.def(shared.uniforms, '[', stringStore.id(name), ']');
                }
                if (type === GL_SAMPLER_2D) {
                    check$1(!Array.isArray(VALUE), 'must specify a scalar prop for textures');
                    scope('if(', VALUE, '&&', VALUE, '._reglType==="framebuffer"){', VALUE, '=', VALUE, '.color[0];', '}');
                } else if (type === GL_SAMPLER_CUBE) {
                    check$1(!Array.isArray(VALUE), 'must specify a scalar prop for cube maps');
                    scope('if(', VALUE, '&&', VALUE, '._reglType==="framebufferCube"){', VALUE, '=', VALUE, '.color[0];', '}');
                }
                // perform type validation
                check$1.optional(function() {
                    function emitCheck(pred, message) {
                        env.assert(scope, pred, 'bad data or missing for uniform "' + name + '".  ' + message);
                    }
                    function checkType(type) {
                        check$1(!Array.isArray(VALUE), 'must not specify an array type for uniform');
                        emitCheck('typeof ' + VALUE + '==="' + type + '"', 'invalid type, expected ' + type);
                    }
                    function checkVector(n, type) {
                        if (Array.isArray(VALUE)) check$1(VALUE.length === n, 'must have length ' + n);
                        else emitCheck(shared.isArrayLike + '(' + VALUE + ')&&' + VALUE + '.length===' + n, 'invalid vector, should have length ' + n, env.commandStr);
                    }
                    function checkTexture(target) {
                        check$1(!Array.isArray(VALUE), 'must not specify a value type');
                        emitCheck('typeof ' + VALUE + '==="function"&&' + VALUE + '._reglType==="texture' + (target === GL_TEXTURE_2D$3 ? '2d' : 'Cube') + '"', 'invalid texture type', env.commandStr);
                    }
                    switch(type){
                        case GL_INT$3:
                            checkType('number');
                            break;
                        case GL_INT_VEC2:
                            checkVector(2, 'number');
                            break;
                        case GL_INT_VEC3:
                            checkVector(3, 'number');
                            break;
                        case GL_INT_VEC4:
                            checkVector(4, 'number');
                            break;
                        case GL_FLOAT$8:
                            checkType('number');
                            break;
                        case GL_FLOAT_VEC2:
                            checkVector(2, 'number');
                            break;
                        case GL_FLOAT_VEC3:
                            checkVector(3, 'number');
                            break;
                        case GL_FLOAT_VEC4:
                            checkVector(4, 'number');
                            break;
                        case GL_BOOL:
                            checkType('boolean');
                            break;
                        case GL_BOOL_VEC2:
                            checkVector(2, 'boolean');
                            break;
                        case GL_BOOL_VEC3:
                            checkVector(3, 'boolean');
                            break;
                        case GL_BOOL_VEC4:
                            checkVector(4, 'boolean');
                            break;
                        case GL_FLOAT_MAT2:
                            checkVector(4, 'number');
                            break;
                        case GL_FLOAT_MAT3:
                            checkVector(9, 'number');
                            break;
                        case GL_FLOAT_MAT4:
                            checkVector(16, 'number');
                            break;
                        case GL_SAMPLER_2D:
                            checkTexture(GL_TEXTURE_2D$3);
                            break;
                        case GL_SAMPLER_CUBE:
                            checkTexture(GL_TEXTURE_CUBE_MAP$2);
                            break;
                    }
                });
                var unroll = 1;
                switch(type){
                    case GL_SAMPLER_2D:
                    case GL_SAMPLER_CUBE:
                        var TEX = scope.def(VALUE, '._texture');
                        scope(GL, '.uniform1i(', LOCATION, ',', TEX, '.bind());');
                        scope.exit(TEX, '.unbind();');
                        continue;
                    case GL_INT$3:
                    case GL_BOOL:
                        infix = '1i';
                        break;
                    case GL_INT_VEC2:
                    case GL_BOOL_VEC2:
                        infix = '2i';
                        unroll = 2;
                        break;
                    case GL_INT_VEC3:
                    case GL_BOOL_VEC3:
                        infix = '3i';
                        unroll = 3;
                        break;
                    case GL_INT_VEC4:
                    case GL_BOOL_VEC4:
                        infix = '4i';
                        unroll = 4;
                        break;
                    case GL_FLOAT$8:
                        infix = '1f';
                        break;
                    case GL_FLOAT_VEC2:
                        infix = '2f';
                        unroll = 2;
                        break;
                    case GL_FLOAT_VEC3:
                        infix = '3f';
                        unroll = 3;
                        break;
                    case GL_FLOAT_VEC4:
                        infix = '4f';
                        unroll = 4;
                        break;
                    case GL_FLOAT_MAT2:
                        infix = 'Matrix2fv';
                        break;
                    case GL_FLOAT_MAT3:
                        infix = 'Matrix3fv';
                        break;
                    case GL_FLOAT_MAT4:
                        infix = 'Matrix4fv';
                        break;
                }
                scope(GL, '.uniform', infix, '(', LOCATION, ',');
                if (infix.charAt(0) === 'M') {
                    var matSize = Math.pow(type - GL_FLOAT_MAT2 + 2, 2);
                    var STORAGE = env.global.def('new Float32Array(', matSize, ')');
                    if (Array.isArray(VALUE)) scope('false,(', loop(matSize, function(i) {
                        return STORAGE + '[' + i + ']=' + VALUE[i];
                    }), ',', STORAGE, ')');
                    else scope('false,(Array.isArray(', VALUE, ')||', VALUE, ' instanceof Float32Array)?', VALUE, ':(', loop(matSize, function(i) {
                        return STORAGE + '[' + i + ']=' + VALUE + '[' + i + ']';
                    }), ',', STORAGE, ')');
                } else if (unroll > 1) scope(loop(unroll, function(i) {
                    return Array.isArray(VALUE) ? VALUE[i] : VALUE + '[' + i + ']';
                }));
                else {
                    check$1(!Array.isArray(VALUE), 'uniform value must not be an array');
                    scope(VALUE);
                }
                scope(');');
            }
        }
        function emitDraw(env, outer, inner, args) {
            var shared = env.shared;
            var GL = shared.gl;
            var DRAW_STATE = shared.draw;
            var drawOptions = args.draw;
            function emitElements() {
                var defn = drawOptions.elements;
                var ELEMENTS;
                var scope = outer;
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) scope = inner;
                    ELEMENTS = defn.append(env, scope);
                } else ELEMENTS = scope.def(DRAW_STATE, '.', S_ELEMENTS);
                if (ELEMENTS) scope('if(' + ELEMENTS + ')' + GL + '.bindBuffer(' + GL_ELEMENT_ARRAY_BUFFER$1 + ',' + ELEMENTS + '.buffer.buffer);');
                return ELEMENTS;
            }
            function emitCount() {
                var defn = drawOptions.count;
                var COUNT;
                var scope = outer;
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) scope = inner;
                    COUNT = defn.append(env, scope);
                    check$1.optional(function() {
                        if (defn.MISSING) env.assert(outer, 'false', 'missing vertex count');
                        if (defn.DYNAMIC) env.assert(scope, COUNT + '>=0', 'missing vertex count');
                    });
                } else {
                    COUNT = scope.def(DRAW_STATE, '.', S_COUNT);
                    check$1.optional(function() {
                        env.assert(scope, COUNT + '>=0', 'missing vertex count');
                    });
                }
                return COUNT;
            }
            var ELEMENTS = emitElements();
            function emitValue(name) {
                var defn = drawOptions[name];
                if (defn) {
                    if (defn.contextDep && args.contextDynamic || defn.propDep) return defn.append(env, inner);
                    else return defn.append(env, outer);
                } else return outer.def(DRAW_STATE, '.', name);
            }
            var PRIMITIVE = emitValue(S_PRIMITIVE);
            var OFFSET = emitValue(S_OFFSET);
            var COUNT = emitCount();
            if (typeof COUNT === 'number') {
                if (COUNT === 0) return;
            } else {
                inner('if(', COUNT, '){');
                inner.exit('}');
            }
            var INSTANCES, EXT_INSTANCING;
            if (extInstancing) {
                INSTANCES = emitValue(S_INSTANCES);
                EXT_INSTANCING = env.instancing;
            }
            var ELEMENT_TYPE = ELEMENTS + '.type';
            var elementsStatic = drawOptions.elements && isStatic(drawOptions.elements);
            function emitInstancing() {
                function drawElements() {
                    inner(EXT_INSTANCING, '.drawElementsInstancedANGLE(', [
                        PRIMITIVE,
                        COUNT,
                        ELEMENT_TYPE,
                        OFFSET + '<<((' + ELEMENT_TYPE + '-' + GL_UNSIGNED_BYTE$8 + ')>>1)',
                        INSTANCES
                    ], ');');
                }
                function drawArrays() {
                    inner(EXT_INSTANCING, '.drawArraysInstancedANGLE(', [
                        PRIMITIVE,
                        OFFSET,
                        COUNT,
                        INSTANCES
                    ], ');');
                }
                if (ELEMENTS) {
                    if (!elementsStatic) {
                        inner('if(', ELEMENTS, '){');
                        drawElements();
                        inner('}else{');
                        drawArrays();
                        inner('}');
                    } else drawElements();
                } else drawArrays();
            }
            function emitRegular() {
                function drawElements() {
                    inner(GL + '.drawElements(' + [
                        PRIMITIVE,
                        COUNT,
                        ELEMENT_TYPE,
                        OFFSET + '<<((' + ELEMENT_TYPE + '-' + GL_UNSIGNED_BYTE$8 + ')>>1)'
                    ] + ');');
                }
                function drawArrays() {
                    inner(GL + '.drawArrays(' + [
                        PRIMITIVE,
                        OFFSET,
                        COUNT
                    ] + ');');
                }
                if (ELEMENTS) {
                    if (!elementsStatic) {
                        inner('if(', ELEMENTS, '){');
                        drawElements();
                        inner('}else{');
                        drawArrays();
                        inner('}');
                    } else drawElements();
                } else drawArrays();
            }
            if (extInstancing && (typeof INSTANCES !== 'number' || INSTANCES >= 0)) {
                if (typeof INSTANCES === 'string') {
                    inner('if(', INSTANCES, '>0){');
                    emitInstancing();
                    inner('}else if(', INSTANCES, '<0){');
                    emitRegular();
                    inner('}');
                } else emitInstancing();
            } else emitRegular();
        }
        function createBody(emitBody, parentEnv, args, program, count) {
            var env = createREGLEnvironment();
            var scope = env.proc('body', count);
            check$1.optional(function() {
                env.commandStr = parentEnv.commandStr;
                env.command = env.link(parentEnv.commandStr);
            });
            if (extInstancing) env.instancing = scope.def(env.shared.extensions, '.angle_instanced_arrays');
            emitBody(env, scope, args, program);
            return env.compile().body;
        }
        // ===================================================
        // ===================================================
        // DRAW PROC
        // ===================================================
        // ===================================================
        function emitDrawBody(env, draw, args, program) {
            injectExtensions(env, draw);
            if (args.useVAO) {
                if (args.drawVAO) draw(env.shared.vao, '.setVAO(', args.drawVAO.append(env, draw), ');');
                else draw(env.shared.vao, '.setVAO(', env.shared.vao, '.targetVAO);');
            } else {
                draw(env.shared.vao, '.setVAO(null);');
                emitAttributes(env, draw, args, program.attributes, function() {
                    return true;
                });
            }
            emitUniforms(env, draw, args, program.uniforms, function() {
                return true;
            });
            emitDraw(env, draw, draw, args);
        }
        function emitDrawProc(env, args) {
            var draw = env.proc('draw', 1);
            injectExtensions(env, draw);
            emitContext(env, draw, args.context);
            emitPollFramebuffer(env, draw, args.framebuffer);
            emitPollState(env, draw, args);
            emitSetOptions(env, draw, args.state);
            emitProfile(env, draw, args, false, true);
            var program = args.shader.progVar.append(env, draw);
            draw(env.shared.gl, '.useProgram(', program, '.program);');
            if (args.shader.program) emitDrawBody(env, draw, args, args.shader.program);
            else {
                draw(env.shared.vao, '.setVAO(null);');
                var drawCache = env.global.def('{}');
                var PROG_ID = draw.def(program, '.id');
                var CACHED_PROC = draw.def(drawCache, '[', PROG_ID, ']');
                draw(env.cond(CACHED_PROC).then(CACHED_PROC, '.call(this,a0);').else(CACHED_PROC, '=', drawCache, '[', PROG_ID, ']=', env.link(function(program) {
                    return createBody(emitDrawBody, env, args, program, 1);
                }), '(', program, ');', CACHED_PROC, '.call(this,a0);'));
            }
            if (Object.keys(args.state).length > 0) draw(env.shared.current, '.dirty=true;');
        }
        // ===================================================
        // ===================================================
        // BATCH PROC
        // ===================================================
        // ===================================================
        function emitBatchDynamicShaderBody(env, scope, args, program) {
            env.batchId = 'a1';
            injectExtensions(env, scope);
            function all() {
                return true;
            }
            emitAttributes(env, scope, args, program.attributes, all);
            emitUniforms(env, scope, args, program.uniforms, all);
            emitDraw(env, scope, scope, args);
        }
        function emitBatchBody(env, scope, args, program) {
            injectExtensions(env, scope);
            var contextDynamic = args.contextDep;
            var BATCH_ID = scope.def();
            var PROP_LIST = 'a0';
            var NUM_PROPS = 'a1';
            var PROPS = scope.def();
            env.shared.props = PROPS;
            env.batchId = BATCH_ID;
            var outer = env.scope();
            var inner = env.scope();
            scope(outer.entry, 'for(', BATCH_ID, '=0;', BATCH_ID, '<', NUM_PROPS, ';++', BATCH_ID, '){', PROPS, '=', PROP_LIST, '[', BATCH_ID, '];', inner, '}', outer.exit);
            function isInnerDefn(defn) {
                return defn.contextDep && contextDynamic || defn.propDep;
            }
            function isOuterDefn(defn) {
                return !isInnerDefn(defn);
            }
            if (args.needsContext) emitContext(env, inner, args.context);
            if (args.needsFramebuffer) emitPollFramebuffer(env, inner, args.framebuffer);
            emitSetOptions(env, inner, args.state, isInnerDefn);
            if (args.profile && isInnerDefn(args.profile)) emitProfile(env, inner, args, false, true);
            if (!program) {
                var progCache = env.global.def('{}');
                var PROGRAM = args.shader.progVar.append(env, inner);
                var PROG_ID = inner.def(PROGRAM, '.id');
                var CACHED_PROC = inner.def(progCache, '[', PROG_ID, ']');
                inner(env.shared.gl, '.useProgram(', PROGRAM, '.program);', 'if(!', CACHED_PROC, '){', CACHED_PROC, '=', progCache, '[', PROG_ID, ']=', env.link(function(program) {
                    return createBody(emitBatchDynamicShaderBody, env, args, program, 2);
                }), '(', PROGRAM, ');}', CACHED_PROC, '.call(this,a0[', BATCH_ID, '],', BATCH_ID, ');');
            } else {
                if (args.useVAO) {
                    if (args.drawVAO) {
                        if (isInnerDefn(args.drawVAO)) // vao is a prop
                        inner(env.shared.vao, '.setVAO(', args.drawVAO.append(env, inner), ');');
                        else // vao is invariant
                        outer(env.shared.vao, '.setVAO(', args.drawVAO.append(env, outer), ');');
                    } else // scoped vao binding
                    outer(env.shared.vao, '.setVAO(', env.shared.vao, '.targetVAO);');
                } else {
                    outer(env.shared.vao, '.setVAO(null);');
                    emitAttributes(env, outer, args, program.attributes, isOuterDefn);
                    emitAttributes(env, inner, args, program.attributes, isInnerDefn);
                }
                emitUniforms(env, outer, args, program.uniforms, isOuterDefn);
                emitUniforms(env, inner, args, program.uniforms, isInnerDefn);
                emitDraw(env, outer, inner, args);
            }
        }
        function emitBatchProc(env, args) {
            var batch = env.proc('batch', 2);
            env.batchId = '0';
            injectExtensions(env, batch);
            // Check if any context variables depend on props
            var contextDynamic = false;
            var needsContext = true;
            Object.keys(args.context).forEach(function(name) {
                contextDynamic = contextDynamic || args.context[name].propDep;
            });
            if (!contextDynamic) {
                emitContext(env, batch, args.context);
                needsContext = false;
            }
            // framebuffer state affects framebufferWidth/height context vars
            var framebuffer = args.framebuffer;
            var needsFramebuffer = false;
            if (framebuffer) {
                if (framebuffer.propDep) contextDynamic = needsFramebuffer = true;
                else if (framebuffer.contextDep && contextDynamic) needsFramebuffer = true;
                if (!needsFramebuffer) emitPollFramebuffer(env, batch, framebuffer);
            } else emitPollFramebuffer(env, batch, null);
            // viewport is weird because it can affect context vars
            if (args.state.viewport && args.state.viewport.propDep) contextDynamic = true;
            function isInnerDefn(defn) {
                return defn.contextDep && contextDynamic || defn.propDep;
            }
            // set webgl options
            emitPollState(env, batch, args);
            emitSetOptions(env, batch, args.state, function(defn) {
                return !isInnerDefn(defn);
            });
            if (!args.profile || !isInnerDefn(args.profile)) emitProfile(env, batch, args, false, 'a1');
            // Save these values to args so that the batch body routine can use them
            args.contextDep = contextDynamic;
            args.needsContext = needsContext;
            args.needsFramebuffer = needsFramebuffer;
            // determine if shader is dynamic
            var progDefn = args.shader.progVar;
            if (progDefn.contextDep && contextDynamic || progDefn.propDep) emitBatchBody(env, batch, args, null);
            else {
                var PROGRAM = progDefn.append(env, batch);
                batch(env.shared.gl, '.useProgram(', PROGRAM, '.program);');
                if (args.shader.program) emitBatchBody(env, batch, args, args.shader.program);
                else {
                    batch(env.shared.vao, '.setVAO(null);');
                    var batchCache = env.global.def('{}');
                    var PROG_ID = batch.def(PROGRAM, '.id');
                    var CACHED_PROC = batch.def(batchCache, '[', PROG_ID, ']');
                    batch(env.cond(CACHED_PROC).then(CACHED_PROC, '.call(this,a0,a1);').else(CACHED_PROC, '=', batchCache, '[', PROG_ID, ']=', env.link(function(program) {
                        return createBody(emitBatchBody, env, args, program, 2);
                    }), '(', PROGRAM, ');', CACHED_PROC, '.call(this,a0,a1);'));
                }
            }
            if (Object.keys(args.state).length > 0) batch(env.shared.current, '.dirty=true;');
        }
        // ===================================================
        // ===================================================
        // SCOPE COMMAND
        // ===================================================
        // ===================================================
        function emitScopeProc(env, args) {
            var scope = env.proc('scope', 3);
            env.batchId = 'a2';
            var shared = env.shared;
            var CURRENT_STATE = shared.current;
            emitContext(env, scope, args.context);
            if (args.framebuffer) args.framebuffer.append(env, scope);
            sortState(Object.keys(args.state)).forEach(function(name) {
                var defn = args.state[name];
                var value = defn.append(env, scope);
                if (isArrayLike(value)) value.forEach(function(v, i) {
                    scope.set(env.next[name], '[' + i + ']', v);
                });
                else scope.set(shared.next, '.' + name, value);
            });
            emitProfile(env, scope, args, true, true);
            [
                S_ELEMENTS,
                S_OFFSET,
                S_COUNT,
                S_INSTANCES,
                S_PRIMITIVE
            ].forEach(function(opt) {
                var variable = args.draw[opt];
                if (!variable) return;
                scope.set(shared.draw, '.' + opt, '' + variable.append(env, scope));
            });
            Object.keys(args.uniforms).forEach(function(opt) {
                var value = args.uniforms[opt].append(env, scope);
                if (Array.isArray(value)) value = '[' + value.join() + ']';
                scope.set(shared.uniforms, '[' + stringStore.id(opt) + ']', value);
            });
            Object.keys(args.attributes).forEach(function(name) {
                var record = args.attributes[name].append(env, scope);
                var scopeAttrib = env.scopeAttrib(name);
                Object.keys(new AttributeRecord()).forEach(function(prop) {
                    scope.set(scopeAttrib, '.' + prop, record[prop]);
                });
            });
            if (args.scopeVAO) scope.set(shared.vao, '.targetVAO', args.scopeVAO.append(env, scope));
            function saveShader(name) {
                var shader = args.shader[name];
                if (shader) scope.set(shared.shader, '.' + name, shader.append(env, scope));
            }
            saveShader(S_VERT);
            saveShader(S_FRAG);
            if (Object.keys(args.state).length > 0) {
                scope(CURRENT_STATE, '.dirty=true;');
                scope.exit(CURRENT_STATE, '.dirty=true;');
            }
            scope('a1(', env.shared.context, ',a0,', env.batchId, ');');
        }
        function isDynamicObject(object) {
            if (typeof object !== 'object' || isArrayLike(object)) return;
            var props = Object.keys(object);
            for(var i = 0; i < props.length; ++i){
                if (dynamic.isDynamic(object[props[i]])) return true;
            }
            return false;
        }
        function splatObject(env, options, name) {
            var object = options.static[name];
            if (!object || !isDynamicObject(object)) return;
            var globals = env.global;
            var keys = Object.keys(object);
            var thisDep = false;
            var contextDep = false;
            var propDep = false;
            var objectRef = env.global.def('{}');
            keys.forEach(function(key) {
                var value = object[key];
                if (dynamic.isDynamic(value)) {
                    if (typeof value === 'function') value = object[key] = dynamic.unbox(value);
                    var deps = createDynamicDecl(value, null);
                    thisDep = thisDep || deps.thisDep;
                    propDep = propDep || deps.propDep;
                    contextDep = contextDep || deps.contextDep;
                } else {
                    globals(objectRef, '.', key, '=');
                    switch(typeof value){
                        case 'number':
                            globals(value);
                            break;
                        case 'string':
                            globals('"', value, '"');
                            break;
                        case 'object':
                            if (Array.isArray(value)) globals('[', value.join(), ']');
                            break;
                        default:
                            globals(env.link(value));
                            break;
                    }
                    globals(';');
                }
            });
            function appendBlock(env, block) {
                keys.forEach(function(key) {
                    var value = object[key];
                    if (!dynamic.isDynamic(value)) return;
                    var ref = env.invoke(block, value);
                    block(objectRef, '.', key, '=', ref, ';');
                });
            }
            options.dynamic[name] = new dynamic.DynamicVariable(DYN_THUNK, {
                thisDep: thisDep,
                contextDep: contextDep,
                propDep: propDep,
                ref: objectRef,
                append: appendBlock
            });
            delete options.static[name];
        }
        // ===========================================================================
        // ===========================================================================
        // MAIN DRAW COMMAND
        // ===========================================================================
        // ===========================================================================
        function compileCommand(options, attributes, uniforms, context, stats) {
            var env = createREGLEnvironment();
            // link stats, so that we can easily access it in the program.
            env.stats = env.link(stats);
            // splat options and attributes to allow for dynamic nested properties
            Object.keys(attributes.static).forEach(function(key) {
                splatObject(env, attributes, key);
            });
            NESTED_OPTIONS.forEach(function(name) {
                splatObject(env, options, name);
            });
            var args = parseArguments(options, attributes, uniforms, context, env);
            emitDrawProc(env, args);
            emitScopeProc(env, args);
            emitBatchProc(env, args);
            return extend(env.compile(), {
                destroy: function() {
                    args.shader.program.destroy();
                }
            });
        }
        // ===========================================================================
        // ===========================================================================
        // POLL / REFRESH
        // ===========================================================================
        // ===========================================================================
        return {
            next: nextState,
            current: currentState,
            procs: function() {
                var env = createREGLEnvironment();
                var poll = env.proc('poll');
                var refresh = env.proc('refresh');
                var common = env.block();
                poll(common);
                refresh(common);
                var shared = env.shared;
                var GL = shared.gl;
                var NEXT_STATE = shared.next;
                var CURRENT_STATE = shared.current;
                common(CURRENT_STATE, '.dirty=false;');
                emitPollFramebuffer(env, poll);
                emitPollFramebuffer(env, refresh, null, true);
                // Refresh updates all attribute state changes
                var INSTANCING;
                if (extInstancing) INSTANCING = env.link(extInstancing);
                // update vertex array bindings
                if (extensions.oes_vertex_array_object) refresh(env.link(extensions.oes_vertex_array_object), '.bindVertexArrayOES(null);');
                for(var i = 0; i < limits.maxAttributes; ++i){
                    var BINDING = refresh.def(shared.attributes, '[', i, ']');
                    var ifte = env.cond(BINDING, '.buffer');
                    ifte.then(GL, '.enableVertexAttribArray(', i, ');', GL, '.bindBuffer(', GL_ARRAY_BUFFER$2, ',', BINDING, '.buffer.buffer);', GL, '.vertexAttribPointer(', i, ',', BINDING, '.size,', BINDING, '.type,', BINDING, '.normalized,', BINDING, '.stride,', BINDING, '.offset);').else(GL, '.disableVertexAttribArray(', i, ');', GL, '.vertexAttrib4f(', i, ',', BINDING, '.x,', BINDING, '.y,', BINDING, '.z,', BINDING, '.w);', BINDING, '.buffer=null;');
                    refresh(ifte);
                    if (extInstancing) refresh(INSTANCING, '.vertexAttribDivisorANGLE(', i, ',', BINDING, '.divisor);');
                }
                refresh(env.shared.vao, '.currentVAO=null;', env.shared.vao, '.setVAO(', env.shared.vao, '.targetVAO);');
                Object.keys(GL_FLAGS).forEach(function(flag) {
                    var cap = GL_FLAGS[flag];
                    var NEXT = common.def(NEXT_STATE, '.', flag);
                    var block = env.block();
                    block('if(', NEXT, '){', GL, '.enable(', cap, ')}else{', GL, '.disable(', cap, ')}', CURRENT_STATE, '.', flag, '=', NEXT, ';');
                    refresh(block);
                    poll('if(', NEXT, '!==', CURRENT_STATE, '.', flag, '){', block, '}');
                });
                Object.keys(GL_VARIABLES).forEach(function(name) {
                    var func = GL_VARIABLES[name];
                    var init = currentState[name];
                    var NEXT, CURRENT;
                    var block = env.block();
                    block(GL, '.', func, '(');
                    if (isArrayLike(init)) {
                        var n = init.length;
                        NEXT = env.global.def(NEXT_STATE, '.', name);
                        CURRENT = env.global.def(CURRENT_STATE, '.', name);
                        block(loop(n, function(i) {
                            return NEXT + '[' + i + ']';
                        }), ');', loop(n, function(i) {
                            return CURRENT + '[' + i + ']=' + NEXT + '[' + i + '];';
                        }).join(''));
                        poll('if(', loop(n, function(i) {
                            return NEXT + '[' + i + ']!==' + CURRENT + '[' + i + ']';
                        }).join('||'), '){', block, '}');
                    } else {
                        NEXT = common.def(NEXT_STATE, '.', name);
                        CURRENT = common.def(CURRENT_STATE, '.', name);
                        block(NEXT, ');', CURRENT_STATE, '.', name, '=', NEXT, ';');
                        poll('if(', NEXT, '!==', CURRENT, '){', block, '}');
                    }
                    refresh(block);
                });
                return env.compile();
            }(),
            compile: compileCommand
        };
    }
    function stats() {
        return {
            vaoCount: 0,
            bufferCount: 0,
            elementsCount: 0,
            framebufferCount: 0,
            shaderCount: 0,
            textureCount: 0,
            cubeCount: 0,
            renderbufferCount: 0,
            maxTextureUnits: 0
        };
    }
    var GL_QUERY_RESULT_EXT = 0x8866;
    var GL_QUERY_RESULT_AVAILABLE_EXT = 0x8867;
    var GL_TIME_ELAPSED_EXT = 0x88BF;
    var createTimer = function(gl, extensions) {
        if (!extensions.ext_disjoint_timer_query) return null;
        // QUERY POOL BEGIN
        var queryPool = [];
        function allocQuery() {
            return queryPool.pop() || extensions.ext_disjoint_timer_query.createQueryEXT();
        }
        function freeQuery(query) {
            queryPool.push(query);
        }
        // QUERY POOL END
        var pendingQueries = [];
        function beginQuery(stats) {
            var query = allocQuery();
            extensions.ext_disjoint_timer_query.beginQueryEXT(GL_TIME_ELAPSED_EXT, query);
            pendingQueries.push(query);
            pushScopeStats(pendingQueries.length - 1, pendingQueries.length, stats);
        }
        function endQuery() {
            extensions.ext_disjoint_timer_query.endQueryEXT(GL_TIME_ELAPSED_EXT);
        }
        //
        // Pending stats pool.
        //
        function PendingStats() {
            this.startQueryIndex = -1;
            this.endQueryIndex = -1;
            this.sum = 0;
            this.stats = null;
        }
        var pendingStatsPool = [];
        function allocPendingStats() {
            return pendingStatsPool.pop() || new PendingStats();
        }
        function freePendingStats(pendingStats) {
            pendingStatsPool.push(pendingStats);
        }
        // Pending stats pool end
        var pendingStats = [];
        function pushScopeStats(start, end, stats) {
            var ps = allocPendingStats();
            ps.startQueryIndex = start;
            ps.endQueryIndex = end;
            ps.sum = 0;
            ps.stats = stats;
            pendingStats.push(ps);
        }
        // we should call this at the beginning of the frame,
        // in order to update gpuTime
        var timeSum = [];
        var queryPtr = [];
        function update() {
            var ptr, i;
            var n = pendingQueries.length;
            if (n === 0) return;
            // Reserve space
            queryPtr.length = Math.max(queryPtr.length, n + 1);
            timeSum.length = Math.max(timeSum.length, n + 1);
            timeSum[0] = 0;
            queryPtr[0] = 0;
            // Update all pending timer queries
            var queryTime = 0;
            ptr = 0;
            for(i = 0; i < pendingQueries.length; ++i){
                var query = pendingQueries[i];
                if (extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_AVAILABLE_EXT)) {
                    queryTime += extensions.ext_disjoint_timer_query.getQueryObjectEXT(query, GL_QUERY_RESULT_EXT);
                    freeQuery(query);
                } else pendingQueries[ptr++] = query;
                timeSum[i + 1] = queryTime;
                queryPtr[i + 1] = ptr;
            }
            pendingQueries.length = ptr;
            // Update all pending stat queries
            ptr = 0;
            for(i = 0; i < pendingStats.length; ++i){
                var stats = pendingStats[i];
                var start = stats.startQueryIndex;
                var end = stats.endQueryIndex;
                stats.sum += timeSum[end] - timeSum[start];
                var startPtr = queryPtr[start];
                var endPtr = queryPtr[end];
                if (endPtr === startPtr) {
                    stats.stats.gpuTime += stats.sum / 1e6;
                    freePendingStats(stats);
                } else {
                    stats.startQueryIndex = startPtr;
                    stats.endQueryIndex = endPtr;
                    pendingStats[ptr++] = stats;
                }
            }
            pendingStats.length = ptr;
        }
        return {
            beginQuery: beginQuery,
            endQuery: endQuery,
            pushScopeStats: pushScopeStats,
            update: update,
            getNumPendingQueries: function() {
                return pendingQueries.length;
            },
            clear: function() {
                queryPool.push.apply(queryPool, pendingQueries);
                for(var i = 0; i < queryPool.length; i++)extensions.ext_disjoint_timer_query.deleteQueryEXT(queryPool[i]);
                pendingQueries.length = 0;
                queryPool.length = 0;
            },
            restore: function() {
                pendingQueries.length = 0;
                queryPool.length = 0;
            }
        };
    };
    var GL_COLOR_BUFFER_BIT = 16384;
    var GL_DEPTH_BUFFER_BIT = 256;
    var GL_STENCIL_BUFFER_BIT = 1024;
    var GL_ARRAY_BUFFER = 34962;
    var CONTEXT_LOST_EVENT = 'webglcontextlost';
    var CONTEXT_RESTORED_EVENT = 'webglcontextrestored';
    var DYN_PROP = 1;
    var DYN_CONTEXT = 2;
    var DYN_STATE = 3;
    function find(haystack, needle) {
        for(var i = 0; i < haystack.length; ++i){
            if (haystack[i] === needle) return i;
        }
        return -1;
    }
    function wrapREGL(args) {
        var config = parseArgs(args);
        if (!config) return null;
        var gl = config.gl;
        var glAttributes = gl.getContextAttributes();
        var contextLost = gl.isContextLost();
        var extensionState = createExtensionCache(gl, config);
        if (!extensionState) return null;
        var stringStore = createStringStore();
        var stats$$1 = stats();
        var extensions = extensionState.extensions;
        var timer = createTimer(gl, extensions);
        var START_TIME = clock();
        var WIDTH = gl.drawingBufferWidth;
        var HEIGHT = gl.drawingBufferHeight;
        var contextState = {
            tick: 0,
            time: 0,
            viewportWidth: WIDTH,
            viewportHeight: HEIGHT,
            framebufferWidth: WIDTH,
            framebufferHeight: HEIGHT,
            drawingBufferWidth: WIDTH,
            drawingBufferHeight: HEIGHT,
            pixelRatio: config.pixelRatio
        };
        var uniformState = {};
        var drawState = {
            elements: null,
            primitive: 4,
            count: -1,
            offset: 0,
            instances: -1
        };
        var limits = wrapLimits(gl, extensions);
        var bufferState = wrapBufferState(gl, stats$$1, config, destroyBuffer);
        var attributeState = wrapAttributeState(gl, extensions, limits, stats$$1, bufferState);
        function destroyBuffer(buffer) {
            return attributeState.destroyBuffer(buffer);
        }
        var elementState = wrapElementsState(gl, extensions, bufferState, stats$$1);
        var shaderState = wrapShaderState(gl, stringStore, stats$$1, config);
        var textureState = createTextureSet(gl, extensions, limits, function() {
            core.procs.poll();
        }, contextState, stats$$1, config);
        var renderbufferState = wrapRenderbuffers(gl, extensions, limits, stats$$1, config);
        var framebufferState = wrapFBOState(gl, extensions, limits, textureState, renderbufferState, stats$$1);
        var core = reglCore(gl, stringStore, extensions, limits, bufferState, elementState, textureState, framebufferState, uniformState, attributeState, shaderState, drawState, contextState, timer, config);
        var readPixels = wrapReadPixels(gl, framebufferState, core.procs.poll, contextState, glAttributes, extensions, limits);
        var nextState = core.next;
        var canvas = gl.canvas;
        var rafCallbacks = [];
        var lossCallbacks = [];
        var restoreCallbacks = [];
        var destroyCallbacks = [
            config.onDestroy
        ];
        var activeRAF = null;
        function handleRAF() {
            if (rafCallbacks.length === 0) {
                if (timer) timer.update();
                activeRAF = null;
                return;
            }
            // schedule next animation frame
            activeRAF = raf.next(handleRAF);
            // poll for changes
            poll();
            // fire a callback for all pending rafs
            for(var i = rafCallbacks.length - 1; i >= 0; --i){
                var cb = rafCallbacks[i];
                if (cb) cb(contextState, null, 0);
            }
            // flush all pending webgl calls
            gl.flush();
            // poll GPU timers *after* gl.flush so we don't delay command dispatch
            if (timer) timer.update();
        }
        function startRAF() {
            if (!activeRAF && rafCallbacks.length > 0) activeRAF = raf.next(handleRAF);
        }
        function stopRAF() {
            if (activeRAF) {
                raf.cancel(handleRAF);
                activeRAF = null;
            }
        }
        function handleContextLoss(event) {
            event.preventDefault();
            // set context lost flag
            contextLost = true;
            // pause request animation frame
            stopRAF();
            // lose context
            lossCallbacks.forEach(function(cb) {
                cb();
            });
        }
        function handleContextRestored(event) {
            // clear error code
            gl.getError();
            // clear context lost flag
            contextLost = false;
            // refresh state
            extensionState.restore();
            shaderState.restore();
            bufferState.restore();
            textureState.restore();
            renderbufferState.restore();
            framebufferState.restore();
            attributeState.restore();
            if (timer) timer.restore();
            // refresh state
            core.procs.refresh();
            // restart RAF
            startRAF();
            // restore context
            restoreCallbacks.forEach(function(cb) {
                cb();
            });
        }
        if (canvas) {
            canvas.addEventListener(CONTEXT_LOST_EVENT, handleContextLoss, false);
            canvas.addEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored, false);
        }
        function destroy() {
            rafCallbacks.length = 0;
            stopRAF();
            if (canvas) {
                canvas.removeEventListener(CONTEXT_LOST_EVENT, handleContextLoss);
                canvas.removeEventListener(CONTEXT_RESTORED_EVENT, handleContextRestored);
            }
            shaderState.clear();
            framebufferState.clear();
            renderbufferState.clear();
            textureState.clear();
            elementState.clear();
            bufferState.clear();
            attributeState.clear();
            if (timer) timer.clear();
            destroyCallbacks.forEach(function(cb) {
                cb();
            });
        }
        function compileProcedure(options) {
            check$1(!!options, 'invalid args to regl({...})');
            check$1.type(options, 'object', 'invalid args to regl({...})');
            function flattenNestedOptions(options) {
                var result = extend({}, options);
                delete result.uniforms;
                delete result.attributes;
                delete result.context;
                delete result.vao;
                if ('stencil' in result && result.stencil.op) {
                    result.stencil.opBack = result.stencil.opFront = result.stencil.op;
                    delete result.stencil.op;
                }
                function merge(name) {
                    if (name in result) {
                        var child = result[name];
                        delete result[name];
                        Object.keys(child).forEach(function(prop) {
                            result[name + '.' + prop] = child[prop];
                        });
                    }
                }
                merge('blend');
                merge('depth');
                merge('cull');
                merge('stencil');
                merge('polygonOffset');
                merge('scissor');
                merge('sample');
                if ('vao' in options) result.vao = options.vao;
                return result;
            }
            function separateDynamic(object, useArrays) {
                var staticItems = {};
                var dynamicItems = {};
                Object.keys(object).forEach(function(option) {
                    var value = object[option];
                    if (dynamic.isDynamic(value)) {
                        dynamicItems[option] = dynamic.unbox(value, option);
                        return;
                    } else if (useArrays && Array.isArray(value)) {
                        for(var i = 0; i < value.length; ++i)if (dynamic.isDynamic(value[i])) {
                            dynamicItems[option] = dynamic.unbox(value, option);
                            return;
                        }
                    }
                    staticItems[option] = value;
                });
                return {
                    dynamic: dynamicItems,
                    static: staticItems
                };
            }
            // Treat context variables separate from other dynamic variables
            var context = separateDynamic(options.context || {}, true);
            var uniforms = separateDynamic(options.uniforms || {}, true);
            var attributes = separateDynamic(options.attributes || {}, false);
            var opts = separateDynamic(flattenNestedOptions(options), false);
            var stats$$1 = {
                gpuTime: 0.0,
                cpuTime: 0.0,
                count: 0
            };
            var compiled = core.compile(opts, attributes, uniforms, context, stats$$1);
            var draw = compiled.draw;
            var batch = compiled.batch;
            var scope = compiled.scope;
            // FIXME: we should modify code generation for batch commands so this
            // isn't necessary
            var EMPTY_ARRAY = [];
            function reserve(count) {
                while(EMPTY_ARRAY.length < count)EMPTY_ARRAY.push(null);
                return EMPTY_ARRAY;
            }
            function REGLCommand(args, body) {
                var i;
                if (contextLost) check$1.raise('context lost');
                if (typeof args === 'function') return scope.call(this, null, args, 0);
                else if (typeof body === 'function') {
                    if (typeof args === 'number') for(i = 0; i < args; ++i)scope.call(this, null, body, i);
                    else if (Array.isArray(args)) for(i = 0; i < args.length; ++i)scope.call(this, args[i], body, i);
                    else return scope.call(this, args, body, 0);
                } else if (typeof args === 'number') {
                    if (args > 0) return batch.call(this, reserve(args | 0), args | 0);
                } else if (Array.isArray(args)) {
                    if (args.length) return batch.call(this, args, args.length);
                } else return draw.call(this, args);
            }
            return extend(REGLCommand, {
                stats: stats$$1,
                destroy: function() {
                    compiled.destroy();
                }
            });
        }
        var setFBO = framebufferState.setFBO = compileProcedure({
            framebuffer: dynamic.define.call(null, DYN_PROP, 'framebuffer')
        });
        function clearImpl(_, options) {
            var clearFlags = 0;
            core.procs.poll();
            var c = options.color;
            if (c) {
                gl.clearColor(+c[0] || 0, +c[1] || 0, +c[2] || 0, +c[3] || 0);
                clearFlags |= GL_COLOR_BUFFER_BIT;
            }
            if ('depth' in options) {
                gl.clearDepth(+options.depth);
                clearFlags |= GL_DEPTH_BUFFER_BIT;
            }
            if ('stencil' in options) {
                gl.clearStencil(options.stencil | 0);
                clearFlags |= GL_STENCIL_BUFFER_BIT;
            }
            check$1(!!clearFlags, 'called regl.clear with no buffer specified');
            gl.clear(clearFlags);
        }
        function clear(options) {
            check$1(typeof options === 'object' && options, 'regl.clear() takes an object as input');
            if ('framebuffer' in options) {
                if (options.framebuffer && options.framebuffer_reglType === 'framebufferCube') for(var i = 0; i < 6; ++i)setFBO(extend({
                    framebuffer: options.framebuffer.faces[i]
                }, options), clearImpl);
                else setFBO(options, clearImpl);
            } else clearImpl(null, options);
        }
        function frame(cb) {
            check$1.type(cb, 'function', 'regl.frame() callback must be a function');
            rafCallbacks.push(cb);
            function cancel() {
                // FIXME:  should we check something other than equals cb here?
                // what if a user calls frame twice with the same callback...
                //
                var i = find(rafCallbacks, cb);
                check$1(i >= 0, 'cannot cancel a frame twice');
                function pendingCancel() {
                    var index = find(rafCallbacks, pendingCancel);
                    rafCallbacks[index] = rafCallbacks[rafCallbacks.length - 1];
                    rafCallbacks.length -= 1;
                    if (rafCallbacks.length <= 0) stopRAF();
                }
                rafCallbacks[i] = pendingCancel;
            }
            startRAF();
            return {
                cancel: cancel
            };
        }
        // poll viewport
        function pollViewport() {
            var viewport = nextState.viewport;
            var scissorBox = nextState.scissor_box;
            viewport[0] = viewport[1] = scissorBox[0] = scissorBox[1] = 0;
            contextState.viewportWidth = contextState.framebufferWidth = contextState.drawingBufferWidth = viewport[2] = scissorBox[2] = gl.drawingBufferWidth;
            contextState.viewportHeight = contextState.framebufferHeight = contextState.drawingBufferHeight = viewport[3] = scissorBox[3] = gl.drawingBufferHeight;
        }
        function poll() {
            contextState.tick += 1;
            contextState.time = now();
            pollViewport();
            core.procs.poll();
        }
        function refresh() {
            textureState.refresh();
            pollViewport();
            core.procs.refresh();
            if (timer) timer.update();
        }
        function now() {
            return (clock() - START_TIME) / 1000.0;
        }
        refresh();
        function addListener(event, callback) {
            check$1.type(callback, 'function', 'listener callback must be a function');
            var callbacks;
            switch(event){
                case 'frame':
                    return frame(callback);
                case 'lost':
                    callbacks = lossCallbacks;
                    break;
                case 'restore':
                    callbacks = restoreCallbacks;
                    break;
                case 'destroy':
                    callbacks = destroyCallbacks;
                    break;
                default:
                    check$1.raise('invalid event, must be one of frame,lost,restore,destroy');
            }
            callbacks.push(callback);
            return {
                cancel: function() {
                    for(var i = 0; i < callbacks.length; ++i)if (callbacks[i] === callback) {
                        callbacks[i] = callbacks[callbacks.length - 1];
                        callbacks.pop();
                        return;
                    }
                }
            };
        }
        var regl = extend(compileProcedure, {
            // Clear current FBO
            clear: clear,
            // Short cuts for dynamic variables
            prop: dynamic.define.bind(null, DYN_PROP),
            context: dynamic.define.bind(null, DYN_CONTEXT),
            this: dynamic.define.bind(null, DYN_STATE),
            // executes an empty draw command
            draw: compileProcedure({}),
            // Resources
            buffer: function(options) {
                return bufferState.create(options, GL_ARRAY_BUFFER, false, false);
            },
            elements: function(options) {
                return elementState.create(options, false);
            },
            texture: textureState.create2D,
            cube: textureState.createCube,
            renderbuffer: renderbufferState.create,
            framebuffer: framebufferState.create,
            framebufferCube: framebufferState.createCube,
            vao: attributeState.createVAO,
            // Expose context attributes
            attributes: glAttributes,
            // Frame rendering
            frame: frame,
            on: addListener,
            // System limits
            limits: limits,
            hasExtension: function(name) {
                return limits.extensions.indexOf(name.toLowerCase()) >= 0;
            },
            // Read pixels
            read: readPixels,
            // Destroy regl and all associated resources
            destroy: destroy,
            // Direct GL state manipulation
            _gl: gl,
            _refresh: refresh,
            poll: function() {
                poll();
                if (timer) timer.update();
            },
            // Current time
            now: now,
            // regl Statistics Information
            stats: stats$$1
        });
        config.onDone(null, regl);
        return regl;
    }
    return wrapREGL;
});

});

parcelRegister("2FgoB", function(module, exports) {
module.exports = $1f0c20f37ab0c85c$var$primitiveQuad;
function $1f0c20f37ab0c85c$var$primitiveQuad(scale) {
    scale = typeof scale !== 'undefined' ? scale : 1;
    if (!Array.isArray(scale)) scale = [
        scale,
        scale
    ];
    var positions = [
        [
            -scale[0],
            -scale[1],
            0
        ],
        [
            scale[0],
            -scale[1],
            0
        ],
        [
            scale[0],
            scale[1],
            0
        ],
        [
            -scale[0],
            scale[1],
            0
        ]
    ];
    var cells = [
        [
            0,
            1,
            2
        ],
        [
            2,
            3,
            0
        ]
    ];
    var uvs = [
        [
            0,
            0
        ],
        [
            1,
            0
        ],
        [
            1,
            1
        ],
        [
            0,
            1
        ]
    ];
    var n = [
        0,
        0,
        -1
    ];
    var normals = [
        n.slice(),
        n.slice(),
        n.slice(),
        n.slice()
    ];
    return {
        positions: positions,
        cells: cells,
        uvs: uvs,
        normals: normals
    };
}

});

parcelRegister("iM60e", function(module, exports) {

var $7Ayo6 = parcelRequire("7Ayo6");
module.exports = function(cstr) {
    var m, conv, parts, alpha;
    if (m = /^((?:rgb|hs[lv]|cmyk|xyz|lab)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        var base = name.replace(/a$/, '');
        var size = base === 'cmyk' ? 4 : 3;
        conv = $7Ayo6[base];
        parts = m[2].replace(/^\s+|\s+$/g, '').split(/\s*,\s*/).map(function(x, i) {
            if (/%$/.test(x) && i === size) return parseFloat(x) / 100;
            else if (/%$/.test(x)) return parseFloat(x);
            return parseFloat(x);
        });
        if (name === base) parts.push(1);
        alpha = parts[size] === undefined ? 1 : parts[size];
        parts = parts.slice(0, size);
        conv[base] = function() {
            return parts;
        };
    } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
        var base = cstr.replace(/^#/, '');
        var size = base.length;
        conv = $7Ayo6.rgb;
        parts = base.split(size === 3 ? /(.)/ : /(..)/);
        parts = parts.filter(Boolean).map(function(x) {
            if (size === 3) return parseInt(x + x, 16);
            else return parseInt(x, 16);
        });
        alpha = 1;
        conv.rgb = function() {
            return parts;
        };
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
    } else {
        conv = $7Ayo6.keyword;
        conv.keyword = function() {
            return cstr;
        };
        parts = cstr;
        alpha = 1;
    }
    var res = {
        rgb: undefined,
        hsl: undefined,
        hsv: undefined,
        cmyk: undefined,
        keyword: undefined,
        hex: undefined
    };
    try {
        res.rgb = conv.rgb(parts);
    } catch (e) {}
    try {
        res.hsl = conv.hsl(parts);
    } catch (e) {}
    try {
        res.hsv = conv.hsv(parts);
    } catch (e) {}
    try {
        res.cmyk = conv.cmyk(parts);
    } catch (e) {}
    try {
        res.keyword = conv.keyword(parts);
    } catch (e) {}
    if (res.rgb) res.hex = '#' + res.rgb.map(function(x) {
        var s = x.toString(16);
        if (s.length === 1) return '0' + s;
        return s;
    }).join('');
    if (res.rgb) res.rgba = res.rgb.concat(alpha);
    if (res.hsl) res.hsla = res.hsl.concat(alpha);
    if (res.hsv) res.hsva = res.hsv.concat(alpha);
    if (res.cmyk) res.cmyka = res.cmyk.concat(alpha);
    return res;
};

});
parcelRegister("7Ayo6", function(module, exports) {

var $iqQan = parcelRequire("iqQan");
var $586691e103710ac2$var$convert = function() {
    return new $586691e103710ac2$var$Converter();
};
for(var $586691e103710ac2$var$func in $iqQan){
    // export Raw versions
    $586691e103710ac2$var$convert[$586691e103710ac2$var$func + "Raw"] = function(func) {
        // accept array or plain args
        return function(arg) {
            if (typeof arg == "number") arg = Array.prototype.slice.call(arguments);
            return $iqQan[func](arg);
        };
    }($586691e103710ac2$var$func);
    var $586691e103710ac2$var$pair = /(\w+)2(\w+)/.exec($586691e103710ac2$var$func), $586691e103710ac2$var$from = $586691e103710ac2$var$pair[1], $586691e103710ac2$var$to = $586691e103710ac2$var$pair[2];
    // export rgb2hsl and ["rgb"]["hsl"]
    $586691e103710ac2$var$convert[$586691e103710ac2$var$from] = $586691e103710ac2$var$convert[$586691e103710ac2$var$from] || {};
    $586691e103710ac2$var$convert[$586691e103710ac2$var$from][$586691e103710ac2$var$to] = $586691e103710ac2$var$convert[$586691e103710ac2$var$func] = function(func) {
        return function(arg) {
            if (typeof arg == "number") arg = Array.prototype.slice.call(arguments);
            var val = $iqQan[func](arg);
            if (typeof val == "string" || val === undefined) return val; // keyword
            for(var i = 0; i < val.length; i++)val[i] = Math.round(val[i]);
            return val;
        };
    }($586691e103710ac2$var$func);
}
/* Converter does lazy conversion and caching */ var $586691e103710ac2$var$Converter = function() {
    this.convs = {};
};
/* Either get the values for a space or
  set the values for a space, depending on args */ $586691e103710ac2$var$Converter.prototype.routeSpace = function(space, args) {
    var values = args[0];
    if (values === undefined) // color.rgb()
    return this.getValues(space);
    // color.rgb(10, 10, 10)
    if (typeof values == "number") values = Array.prototype.slice.call(args);
    return this.setValues(space, values);
};
/* Set the values for a space, invalidating cache */ $586691e103710ac2$var$Converter.prototype.setValues = function(space, values) {
    this.space = space;
    this.convs = {};
    this.convs[space] = values;
    return this;
};
/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */ $586691e103710ac2$var$Converter.prototype.getValues = function(space) {
    var vals = this.convs[space];
    if (!vals) {
        var fspace = this.space, from = this.convs[fspace];
        vals = $586691e103710ac2$var$convert[fspace][space](from);
        this.convs[space] = vals;
    }
    return vals;
};
[
    "rgb",
    "hsl",
    "hsv",
    "cmyk",
    "keyword"
].forEach(function(space) {
    $586691e103710ac2$var$Converter.prototype[space] = function(vals) {
        return this.routeSpace(space, arguments);
    };
});
module.exports = $586691e103710ac2$var$convert;

});
parcelRegister("iqQan", function(module, exports) {
/* MIT license */ module.exports = {
    rgb2hsl: $0376807f52def52f$var$rgb2hsl,
    rgb2hsv: $0376807f52def52f$var$rgb2hsv,
    rgb2hwb: $0376807f52def52f$var$rgb2hwb,
    rgb2cmyk: $0376807f52def52f$var$rgb2cmyk,
    rgb2keyword: $0376807f52def52f$var$rgb2keyword,
    rgb2xyz: $0376807f52def52f$var$rgb2xyz,
    rgb2lab: $0376807f52def52f$var$rgb2lab,
    rgb2lch: $0376807f52def52f$var$rgb2lch,
    hsl2rgb: $0376807f52def52f$var$hsl2rgb,
    hsl2hsv: $0376807f52def52f$var$hsl2hsv,
    hsl2hwb: $0376807f52def52f$var$hsl2hwb,
    hsl2cmyk: $0376807f52def52f$var$hsl2cmyk,
    hsl2keyword: $0376807f52def52f$var$hsl2keyword,
    hsv2rgb: $0376807f52def52f$var$hsv2rgb,
    hsv2hsl: $0376807f52def52f$var$hsv2hsl,
    hsv2hwb: $0376807f52def52f$var$hsv2hwb,
    hsv2cmyk: $0376807f52def52f$var$hsv2cmyk,
    hsv2keyword: $0376807f52def52f$var$hsv2keyword,
    hwb2rgb: $0376807f52def52f$var$hwb2rgb,
    hwb2hsl: $0376807f52def52f$var$hwb2hsl,
    hwb2hsv: $0376807f52def52f$var$hwb2hsv,
    hwb2cmyk: $0376807f52def52f$var$hwb2cmyk,
    hwb2keyword: $0376807f52def52f$var$hwb2keyword,
    cmyk2rgb: $0376807f52def52f$var$cmyk2rgb,
    cmyk2hsl: $0376807f52def52f$var$cmyk2hsl,
    cmyk2hsv: $0376807f52def52f$var$cmyk2hsv,
    cmyk2hwb: $0376807f52def52f$var$cmyk2hwb,
    cmyk2keyword: $0376807f52def52f$var$cmyk2keyword,
    keyword2rgb: $0376807f52def52f$var$keyword2rgb,
    keyword2hsl: $0376807f52def52f$var$keyword2hsl,
    keyword2hsv: $0376807f52def52f$var$keyword2hsv,
    keyword2hwb: $0376807f52def52f$var$keyword2hwb,
    keyword2cmyk: $0376807f52def52f$var$keyword2cmyk,
    keyword2lab: $0376807f52def52f$var$keyword2lab,
    keyword2xyz: $0376807f52def52f$var$keyword2xyz,
    xyz2rgb: $0376807f52def52f$var$xyz2rgb,
    xyz2lab: $0376807f52def52f$var$xyz2lab,
    xyz2lch: $0376807f52def52f$var$xyz2lch,
    lab2xyz: $0376807f52def52f$var$lab2xyz,
    lab2rgb: $0376807f52def52f$var$lab2rgb,
    lab2lch: $0376807f52def52f$var$lab2lch,
    lch2lab: $0376807f52def52f$var$lch2lab,
    lch2xyz: $0376807f52def52f$var$lch2xyz,
    lch2rgb: $0376807f52def52f$var$lch2rgb
};
function $0376807f52def52f$var$rgb2hsl(rgb) {
    var r1 = rgb[0] / 255, g1 = rgb[1] / 255, b1 = rgb[2] / 255, min = Math.min(r1, g1, b1), max = Math.max(r1, g1, b1), delta = max - min, h, s, l;
    if (max == min) h = 0;
    else if (r1 == max) h = (g1 - b1) / delta;
    else if (g1 == max) h = 2 + (b1 - r1) / delta;
    else if (b1 == max) h = 4 + (r1 - g1) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max == min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
}
function $0376807f52def52f$var$rgb2hsv(rgb) {
    var r1 = rgb[0], g1 = rgb[1], b1 = rgb[2], min = Math.min(r1, g1, b1), max = Math.max(r1, g1, b1), delta = max - min, h, s, v;
    if (max == 0) s = 0;
    else s = delta / max * 1000 / 10;
    if (max == min) h = 0;
    else if (r1 == max) h = (g1 - b1) / delta;
    else if (g1 == max) h = 2 + (b1 - r1) / delta;
    else if (b1 == max) h = 4 + (r1 - g1) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    v = max / 255 * 1000 / 10;
    return [
        h,
        s,
        v
    ];
}
function $0376807f52def52f$var$rgb2hwb(rgb) {
    var r1 = rgb[0], g1 = rgb[1], b1 = rgb[2], h = $0376807f52def52f$var$rgb2hsl(rgb)[0], w = 1 / 255 * Math.min(r1, Math.min(g1, b1)), b1 = 1 - 1 / 255 * Math.max(r1, Math.max(g1, b1));
    return [
        h,
        w * 100,
        b1 * 100
    ];
}
function $0376807f52def52f$var$rgb2cmyk(rgb) {
    var r1 = rgb[0] / 255, g1 = rgb[1] / 255, b1 = rgb[2] / 255, c, m, y, k;
    k = Math.min(1 - r1, 1 - g1, 1 - b1);
    c = (1 - r1 - k) / (1 - k) || 0;
    m = (1 - g1 - k) / (1 - k) || 0;
    y = (1 - b1 - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
}
function $0376807f52def52f$var$rgb2keyword(rgb) {
    return $0376807f52def52f$var$reverseKeywords[JSON.stringify(rgb)];
}
function $0376807f52def52f$var$rgb2xyz(rgb) {
    var r1 = rgb[0] / 255, g1 = rgb[1] / 255, b1 = rgb[2] / 255;
    // assume sRGB
    r1 = r1 > 0.04045 ? Math.pow((r1 + 0.055) / 1.055, 2.4) : r1 / 12.92;
    g1 = g1 > 0.04045 ? Math.pow((g1 + 0.055) / 1.055, 2.4) : g1 / 12.92;
    b1 = b1 > 0.04045 ? Math.pow((b1 + 0.055) / 1.055, 2.4) : b1 / 12.92;
    var x = r1 * 0.4124 + g1 * 0.3576 + b1 * 0.1805;
    var y = r1 * 0.2126 + g1 * 0.7152 + b1 * 0.0722;
    var z = r1 * 0.0193 + g1 * 0.1192 + b1 * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
}
function $0376807f52def52f$var$rgb2lab(rgb) {
    var xyz = $0376807f52def52f$var$rgb2xyz(rgb), x = xyz[0], y = xyz[1], z = xyz[2], l, a, b1;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b1 = 200 * (y - z);
    return [
        l,
        a,
        b1
    ];
}
function $0376807f52def52f$var$rgb2lch(args) {
    return $0376807f52def52f$var$lab2lch($0376807f52def52f$var$rgb2lab(args));
}
function $0376807f52def52f$var$hsl2rgb(hsl) {
    var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val;
    if (s == 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        t3 < 0 && t3++;
        t3 > 1 && t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
}
function $0376807f52def52f$var$hsl2hsv(hsl) {
    var h = hsl[0], s = hsl[1] / 100, l = hsl[2] / 100, sv, v;
    if (l === 0) // no need to do calc on black
    // also avoids divide by 0 error
    return [
        0,
        0,
        0
    ];
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    v = (l + s) / 2;
    sv = 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
}
function $0376807f52def52f$var$hsl2hwb(args) {
    return $0376807f52def52f$var$rgb2hwb($0376807f52def52f$var$hsl2rgb(args));
}
function $0376807f52def52f$var$hsl2cmyk(args) {
    return $0376807f52def52f$var$rgb2cmyk($0376807f52def52f$var$hsl2rgb(args));
}
function $0376807f52def52f$var$hsl2keyword(args) {
    return $0376807f52def52f$var$rgb2keyword($0376807f52def52f$var$hsl2rgb(args));
}
function $0376807f52def52f$var$hsv2rgb(hsv) {
    var h = hsv[0] / 60, s = hsv[1] / 100, v = hsv[2] / 100, hi = Math.floor(h) % 6;
    var f = h - Math.floor(h), p = 255 * v * (1 - s), q = 255 * v * (1 - s * f), t = 255 * v * (1 - s * (1 - f)), v = 255 * v;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
}
function $0376807f52def52f$var$hsv2hsl(hsv) {
    var h = hsv[0], s = hsv[1] / 100, v = hsv[2] / 100, sl, l;
    l = (2 - s) * v;
    sl = s * v;
    sl /= l <= 1 ? l : 2 - l;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
}
function $0376807f52def52f$var$hsv2hwb(args) {
    return $0376807f52def52f$var$rgb2hwb($0376807f52def52f$var$hsv2rgb(args));
}
function $0376807f52def52f$var$hsv2cmyk(args) {
    return $0376807f52def52f$var$rgb2cmyk($0376807f52def52f$var$hsv2rgb(args));
}
function $0376807f52def52f$var$hsv2keyword(args) {
    return $0376807f52def52f$var$rgb2keyword($0376807f52def52f$var$hsv2rgb(args));
}
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function $0376807f52def52f$var$hwb2rgb(hwb) {
    var h = hwb[0] / 360, wh = hwb[1] / 100, bl = hwb[2] / 100, ratio = wh + bl, i, v, f, n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) != 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
}
function $0376807f52def52f$var$hwb2hsl(args) {
    return $0376807f52def52f$var$rgb2hsl($0376807f52def52f$var$hwb2rgb(args));
}
function $0376807f52def52f$var$hwb2hsv(args) {
    return $0376807f52def52f$var$rgb2hsv($0376807f52def52f$var$hwb2rgb(args));
}
function $0376807f52def52f$var$hwb2cmyk(args) {
    return $0376807f52def52f$var$rgb2cmyk($0376807f52def52f$var$hwb2rgb(args));
}
function $0376807f52def52f$var$hwb2keyword(args) {
    return $0376807f52def52f$var$rgb2keyword($0376807f52def52f$var$hwb2rgb(args));
}
function $0376807f52def52f$var$cmyk2rgb(cmyk) {
    var c = cmyk[0] / 100, m = cmyk[1] / 100, y = cmyk[2] / 100, k = cmyk[3] / 100, r1, g1, b1;
    r1 = 1 - Math.min(1, c * (1 - k) + k);
    g1 = 1 - Math.min(1, m * (1 - k) + k);
    b1 = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r1 * 255,
        g1 * 255,
        b1 * 255
    ];
}
function $0376807f52def52f$var$cmyk2hsl(args) {
    return $0376807f52def52f$var$rgb2hsl($0376807f52def52f$var$cmyk2rgb(args));
}
function $0376807f52def52f$var$cmyk2hsv(args) {
    return $0376807f52def52f$var$rgb2hsv($0376807f52def52f$var$cmyk2rgb(args));
}
function $0376807f52def52f$var$cmyk2hwb(args) {
    return $0376807f52def52f$var$rgb2hwb($0376807f52def52f$var$cmyk2rgb(args));
}
function $0376807f52def52f$var$cmyk2keyword(args) {
    return $0376807f52def52f$var$rgb2keyword($0376807f52def52f$var$cmyk2rgb(args));
}
function $0376807f52def52f$var$xyz2rgb(xyz) {
    var x = xyz[0] / 100, y = xyz[1] / 100, z = xyz[2] / 100, r1, g1, b1;
    r1 = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g1 = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b1 = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r1 = r1 > 0.0031308 ? 1.055 * Math.pow(r1, 1.0 / 2.4) - 0.055 : r1 = r1 * 12.92;
    g1 = g1 > 0.0031308 ? 1.055 * Math.pow(g1, 1.0 / 2.4) - 0.055 : g1 = g1 * 12.92;
    b1 = b1 > 0.0031308 ? 1.055 * Math.pow(b1, 1.0 / 2.4) - 0.055 : b1 = b1 * 12.92;
    r1 = Math.min(Math.max(0, r1), 1);
    g1 = Math.min(Math.max(0, g1), 1);
    b1 = Math.min(Math.max(0, b1), 1);
    return [
        r1 * 255,
        g1 * 255,
        b1 * 255
    ];
}
function $0376807f52def52f$var$xyz2lab(xyz) {
    var x = xyz[0], y = xyz[1], z = xyz[2], l, a, b1;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b1 = 200 * (y - z);
    return [
        l,
        a,
        b1
    ];
}
function $0376807f52def52f$var$xyz2lch(args) {
    return $0376807f52def52f$var$lab2lch($0376807f52def52f$var$xyz2lab(args));
}
function $0376807f52def52f$var$lab2xyz(lab) {
    var l = lab[0], a = lab[1], b1 = lab[2], x, y, z, y2;
    if (l <= 8) {
        y = l * 100 / 903.3;
        y2 = 7.787 * (y / 100) + 16 / 116;
    } else {
        y = 100 * Math.pow((l + 16) / 116, 3);
        y2 = Math.pow(y / 100, 1 / 3);
    }
    x = x / 95.047 <= 0.008856 ? x = 95.047 * (a / 500 + y2 - 16 / 116) / 7.787 : 95.047 * Math.pow(a / 500 + y2, 3);
    z = z / 108.883 <= 0.008859 ? z = 108.883 * (y2 - b1 / 200 - 16 / 116) / 7.787 : 108.883 * Math.pow(y2 - b1 / 200, 3);
    return [
        x,
        y,
        z
    ];
}
function $0376807f52def52f$var$lab2lch(lab) {
    var l = lab[0], a = lab[1], b1 = lab[2], hr, h, c;
    hr = Math.atan2(b1, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b1 * b1);
    return [
        l,
        c,
        h
    ];
}
function $0376807f52def52f$var$lab2rgb(args) {
    return $0376807f52def52f$var$xyz2rgb($0376807f52def52f$var$lab2xyz(args));
}
function $0376807f52def52f$var$lch2lab(lch) {
    var l = lch[0], c = lch[1], h = lch[2], a, b1, hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b1 = c * Math.sin(hr);
    return [
        l,
        a,
        b1
    ];
}
function $0376807f52def52f$var$lch2xyz(args) {
    return $0376807f52def52f$var$lab2xyz($0376807f52def52f$var$lch2lab(args));
}
function $0376807f52def52f$var$lch2rgb(args) {
    return $0376807f52def52f$var$lab2rgb($0376807f52def52f$var$lch2lab(args));
}
function $0376807f52def52f$var$keyword2rgb(keyword) {
    return $0376807f52def52f$var$cssKeywords[keyword];
}
function $0376807f52def52f$var$keyword2hsl(args) {
    return $0376807f52def52f$var$rgb2hsl($0376807f52def52f$var$keyword2rgb(args));
}
function $0376807f52def52f$var$keyword2hsv(args) {
    return $0376807f52def52f$var$rgb2hsv($0376807f52def52f$var$keyword2rgb(args));
}
function $0376807f52def52f$var$keyword2hwb(args) {
    return $0376807f52def52f$var$rgb2hwb($0376807f52def52f$var$keyword2rgb(args));
}
function $0376807f52def52f$var$keyword2cmyk(args) {
    return $0376807f52def52f$var$rgb2cmyk($0376807f52def52f$var$keyword2rgb(args));
}
function $0376807f52def52f$var$keyword2lab(args) {
    return $0376807f52def52f$var$rgb2lab($0376807f52def52f$var$keyword2rgb(args));
}
function $0376807f52def52f$var$keyword2xyz(args) {
    return $0376807f52def52f$var$rgb2xyz($0376807f52def52f$var$keyword2rgb(args));
}
var $0376807f52def52f$var$cssKeywords = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
var $0376807f52def52f$var$reverseKeywords = {};
for(var $0376807f52def52f$var$key in $0376807f52def52f$var$cssKeywords)$0376807f52def52f$var$reverseKeywords[JSON.stringify($0376807f52def52f$var$cssKeywords[$0376807f52def52f$var$key])] = $0376807f52def52f$var$key;

});




parcelRegister("3E14C", function(module, exports) {

$parcel$export(module.exports, "parse", () => $2a75f0b55cf115f5$export$98e6a39c04603d36, (v) => $2a75f0b55cf115f5$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "style", () => $2a75f0b55cf115f5$export$1d567c320f4763bc, (v) => $2a75f0b55cf115f5$export$1d567c320f4763bc = v);
$parcel$export(module.exports, "names", () => $2a75f0b55cf115f5$export$e4b2ac9215619f8d, (v) => $2a75f0b55cf115f5$export$e4b2ac9215619f8d = v);
$parcel$export(module.exports, "relativeLuminance", () => $2a75f0b55cf115f5$export$d1b97a5b9a804090, (v) => $2a75f0b55cf115f5$export$d1b97a5b9a804090 = v);
$parcel$export(module.exports, "contrastRatio", () => $2a75f0b55cf115f5$export$e73df0c08bfd3ec3, (v) => $2a75f0b55cf115f5$export$e73df0c08bfd3ec3 = v);
$parcel$export(module.exports, "offsetHSL", () => $2a75f0b55cf115f5$export$9e2d6609c60778e3, (v) => $2a75f0b55cf115f5$export$9e2d6609c60778e3 = v);
$parcel$export(module.exports, "blend", () => $2a75f0b55cf115f5$export$fdb28526eb2966c3, (v) => $2a75f0b55cf115f5$export$fdb28526eb2966c3 = v);
$parcel$export(module.exports, "hexToRGBA", () => $2a75f0b55cf115f5$export$7229be6d7219ee6a, (v) => $2a75f0b55cf115f5$export$7229be6d7219ee6a = v);
$parcel$export(module.exports, "RGBAToHex", () => $2a75f0b55cf115f5$export$c17087725a57bc38, (v) => $2a75f0b55cf115f5$export$c17087725a57bc38 = v);
$parcel$export(module.exports, "RGBAToHSLA", () => $2a75f0b55cf115f5$export$9692d29026594724, (v) => $2a75f0b55cf115f5$export$9692d29026594724 = v);
$parcel$export(module.exports, "HSLAToRGBA", () => $2a75f0b55cf115f5$export$a152a867259fe9a4, (v) => $2a75f0b55cf115f5$export$a152a867259fe9a4 = v);
var $2a75f0b55cf115f5$export$98e6a39c04603d36;
var $2a75f0b55cf115f5$export$1d567c320f4763bc;
var $2a75f0b55cf115f5$export$e4b2ac9215619f8d;
var $2a75f0b55cf115f5$export$d1b97a5b9a804090;
// Extracted from @tmcw / wcag-contrast
// https://github.com/tmcw/wcag-contrast
var $2a75f0b55cf115f5$export$e73df0c08bfd3ec3;
var $2a75f0b55cf115f5$export$9e2d6609c60778e3;
var $2a75f0b55cf115f5$export$fdb28526eb2966c3;
// Exposed but not yet documented
var $2a75f0b55cf115f5$export$7229be6d7219ee6a;
var $2a75f0b55cf115f5$export$c17087725a57bc38;
var $2a75f0b55cf115f5$export$9692d29026594724;
var $2a75f0b55cf115f5$export$a152a867259fe9a4;

var $6iX1H = parcelRequire("6iX1H");

var $gbYv7 = parcelRequire("gbYv7");

var $aWPUy = parcelRequire("aWPUy");

var $eRu9L = parcelRequire("eRu9L");

var $eCMji = parcelRequire("eCMji");

var $1DNy0 = parcelRequire("1DNy0");
$2a75f0b55cf115f5$export$98e6a39c04603d36 = $6iX1H.parse;
$2a75f0b55cf115f5$export$1d567c320f4763bc = $6iX1H.style;
$2a75f0b55cf115f5$export$e4b2ac9215619f8d = $gbYv7;
$2a75f0b55cf115f5$export$d1b97a5b9a804090 = function relativeLuminance(color) {
    var result = $2a75f0b55cf115f5$export$98e6a39c04603d36(color);
    if (!result) return null;
    return $aWPUy(result.rgb);
};
$2a75f0b55cf115f5$export$e73df0c08bfd3ec3 = function contrastRatio(colorA, colorB) {
    var a = $2a75f0b55cf115f5$export$d1b97a5b9a804090(colorA);
    var b = $2a75f0b55cf115f5$export$d1b97a5b9a804090(colorB);
    if (a == null || b == null) return null;
    var l1 = Math.max(a, b);
    var l2 = Math.min(a, b);
    return (l1 + 0.05) / (l2 + 0.05);
};
$2a75f0b55cf115f5$export$9e2d6609c60778e3 = function(color, h, s, l) {
    var result = $2a75f0b55cf115f5$export$98e6a39c04603d36(color);
    if (!result) return null;
    result.hsla[0] += h || 0;
    result.hsla[1] = Math.max(0, Math.min(100, result.hsla[1] + (s || 0)));
    result.hsla[2] = Math.max(0, Math.min(100, result.hsla[2] + (l || 0)));
    return $2a75f0b55cf115f5$export$98e6a39c04603d36({
        hsla: result.hsla
    });
};
$2a75f0b55cf115f5$export$fdb28526eb2966c3 = function(background, foreground, opacity) {
    var bg = $2a75f0b55cf115f5$export$98e6a39c04603d36(background);
    var fg = $2a75f0b55cf115f5$export$98e6a39c04603d36(foreground);
    if (bg == null || fg == null) return null;
    var c0 = bg.rgba;
    var c1 = fg.rgba;
    opacity = typeof opacity === 'number' && isFinite(opacity) ? opacity : 1.0;
    var alpha = opacity * c1[3];
    if (alpha >= 1) // foreground is opaque so no blend required
    return fg;
    for(var i = 0; i < 3; i++)c1[i] = c1[i] * alpha + c0[i] * (c0[3] * (1 - alpha));
    c1[3] = Math.max(0, Math.min(1, alpha + c0[3] * (1 - alpha)));
    return $2a75f0b55cf115f5$export$98e6a39c04603d36(c1); // re-parse to get new metadata
};
$2a75f0b55cf115f5$export$7229be6d7219ee6a = $eCMji;
$2a75f0b55cf115f5$export$c17087725a57bc38 = $1DNy0;
$2a75f0b55cf115f5$export$9692d29026594724 = $eRu9L.RGBAToHSLA;
$2a75f0b55cf115f5$export$a152a867259fe9a4 = $eRu9L.HSLAToRGBA;

});
parcelRegister("6iX1H", function(module, exports) {

$parcel$export(module.exports, "parse", () => $497235f3b483b83a$export$98e6a39c04603d36, (v) => $497235f3b483b83a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "style", () => $497235f3b483b83a$export$1d567c320f4763bc, (v) => $497235f3b483b83a$export$1d567c320f4763bc = v);
var $497235f3b483b83a$export$98e6a39c04603d36;
var $497235f3b483b83a$export$1d567c320f4763bc;

var $gbYv7 = parcelRequire("gbYv7");

var $eRu9L = parcelRequire("eRu9L");

var $eCMji = parcelRequire("eCMji");

var $1DNy0 = parcelRequire("1DNy0");

var $6HPEi = parcelRequire("6HPEi");
function $497235f3b483b83a$var$parseStyle(str) {
    if (typeof str !== 'string') throw new TypeError('Color parsing must be performed on a string parameter');
    str = str.toLowerCase();
    if (str in $gbYv7) str = $gbYv7[str];
    else if (str === 'transparent') str = '#00000000';
    var rgba, hsla, hex;
    if (/^#[a-f0-9]+$/.test(str)) {
        rgba = $eCMji(str);
        hex = $1DNy0(rgba);
        hsla = $eRu9L.RGBAToHSLA(rgba);
    } else {
        var match = /^((?:rgb|hsl)a?)\s*\(([^)]*)\)/.exec(str);
        if (!match) return null;
        var type = match[1].replace(/a$/, '');
        var parts = match[2].replace(/^\s+|\s+$/g, '').split(/\s*,\s*/).map(function(n, i) {
            // opaque part
            if (i <= 2) return Math.round(parseFloat(n) || 0);
            else {
                n = parseFloat(n);
                if (typeof n !== 'number' || !isFinite(n)) n = 1;
                return n;
            }
        });
        // fill in alpha with 1.0 by default
        if (typeof parts[3] === 'undefined' || !isFinite(parts[3])) parts[3] = 1;
        if (type === 'rgb') {
            hsla = $eRu9L.RGBAToHSLA(parts);
            rgba = parts;
        } else if (type === 'hsl') {
            rgba = $eRu9L.HSLAToRGBA(parts);
            parts[0] = $6HPEi(parts[0], 0, 360);
            hsla = parts;
        }
        hex = $1DNy0(rgba);
    }
    if (!rgba && !hex && !hsla) return null;
    var ret = {
        hex: hex,
        alpha: rgba[3],
        rgb: rgba.slice(0, 3),
        rgba: rgba,
        hsl: hsla.slice(0, 3),
        hsla: hsla
    };
    return ret;
}
$497235f3b483b83a$export$98e6a39c04603d36 = $497235f3b483b83a$var$parseColor;
function $497235f3b483b83a$var$parseColor(color) {
    if (typeof color === 'string') return $497235f3b483b83a$var$parseStyle(color);
    else if (Array.isArray(color) && color.length >= 3) {
        var rgbStr = $497235f3b483b83a$var$rgbStyle(color[0], color[1], color[2], color[3]);
        return $497235f3b483b83a$var$parseStyle(rgbStr);
    } else if (color && typeof color === 'object') {
        var str;
        if (color.hex) str = color.hex;
        else if (color.rgba) str = $497235f3b483b83a$var$rgbStyle(color.rgba[0], color.rgba[1], color.rgba[2], color.rgba[3]);
        else if (color.hsla) str = $497235f3b483b83a$var$hslStyle(color.hsla[0], color.hsla[1], color.hsla[2], color.hsla[3]);
        else if (color.rgb) str = $497235f3b483b83a$var$rgbStyle(color.rgb[0], color.rgb[1], color.rgb[2]);
        else if (color.hsl) str = $497235f3b483b83a$var$hslStyle(color.hsl[0], color.hsl[1], color.hsl[2]);
        if (str) return $497235f3b483b83a$var$parseStyle(str);
    }
    return null;
}
$497235f3b483b83a$export$1d567c320f4763bc = $497235f3b483b83a$var$style;
function $497235f3b483b83a$var$style(color) {
    var result = $497235f3b483b83a$export$98e6a39c04603d36(color);
    if (result) {
        var rgba = result.rgba;
        return $497235f3b483b83a$var$rgbStyle(rgba[0], rgba[1], rgba[2], rgba[3]);
    }
    return null;
}
function $497235f3b483b83a$var$rgbStyle(r, g, b, a) {
    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));
    if (a === 1 || !isFinite(a) || typeof a === 'undefined') return 'rgb(' + [
        r,
        g,
        b
    ].join(', ') + ')';
    else {
        a = Math.max(0, Math.min(1, a));
        return 'rgba(' + [
            r,
            g,
            b,
            a
        ].join(', ') + ')';
    }
}
function $497235f3b483b83a$var$hslStyle(h, s, l, a) {
    h = $6HPEi(h, 0, 360);
    h = Math.max(0, Math.min(360, Math.round(h)));
    s = Math.max(0, Math.min(100, Math.round(s)));
    l = Math.max(0, Math.min(100, Math.round(l)));
    if (a === 1 || !isFinite(a) || typeof a === 'undefined') return 'hsl(' + [
        h,
        s,
        l
    ].join(', ') + ')';
    else {
        a = Math.max(0, Math.min(1, a));
        return 'hsla(' + [
            h,
            s,
            l,
            a
        ].join(', ') + ')';
    }
}

});
parcelRegister("gbYv7", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});

parcelRegister("eRu9L", function(module, exports) {

$parcel$export(module.exports, "RGBAToHSLA", () => $ad1d685d502f9994$export$9692d29026594724, (v) => $ad1d685d502f9994$export$9692d29026594724 = v);
$parcel$export(module.exports, "HSLAToRGBA", () => $ad1d685d502f9994$export$a152a867259fe9a4, (v) => $ad1d685d502f9994$export$a152a867259fe9a4 = v);
var $ad1d685d502f9994$export$9692d29026594724;
var $ad1d685d502f9994$export$a152a867259fe9a4;

var $icDYp = parcelRequire("icDYp");

var $kHru7 = parcelRequire("kHru7");

var $6HPEi = parcelRequire("6HPEi");
$ad1d685d502f9994$export$9692d29026594724 = $ad1d685d502f9994$var$RGBAToHSLA;
function $ad1d685d502f9994$var$RGBAToHSLA(rgba) {
    var floatHSL = $kHru7([
        rgba[0] / 255,
        rgba[1] / 255,
        rgba[2] / 255
    ]);
    return [
        Math.max(0, Math.min(360, Math.round(floatHSL[0] * 360))),
        Math.max(0, Math.min(100, Math.round(floatHSL[1] * 100))),
        Math.max(0, Math.min(100, Math.round(floatHSL[2] * 100))),
        rgba[3]
    ];
}
$ad1d685d502f9994$export$a152a867259fe9a4 = $ad1d685d502f9994$var$HSLAToRGBA;
function $ad1d685d502f9994$var$HSLAToRGBA(hsla) {
    var hue = $6HPEi(hsla[0], 0, 360);
    var floatRGB = $icDYp([
        hue / 360,
        hsla[1] / 100,
        hsla[2] / 100
    ]);
    return [
        Math.max(0, Math.min(255, Math.round(floatRGB[0] * 255))),
        Math.max(0, Math.min(255, Math.round(floatRGB[1] * 255))),
        Math.max(0, Math.min(255, Math.round(floatRGB[2] * 255))),
        hsla[3]
    ];
}

});
parcelRegister("icDYp", function(module, exports) {
module.exports = $d4085adf28691e31$var$hsl2rgb;
function $d4085adf28691e31$var$hsl2rgb(hsl) {
    var h = hsl[0], s = hsl[1], l = hsl[2], t1, t2, t3, rgb, val;
    if (s === 0) {
        val = l;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val;
    }
    return rgb;
}

});

parcelRegister("kHru7", function(module, exports) {
module.exports = $f11d24b85cba7ff2$var$rgb2hsl;
function $f11d24b85cba7ff2$var$rgb2hsl(rgb) {
    var r = rgb[0], g = rgb[1], b = rgb[2], min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h / 360,
        s,
        l
    ];
}

});


parcelRegister("eCMji", function(module, exports) {
module.exports = $aa5a16b703fc36e0$var$hexToRGBA;
function $aa5a16b703fc36e0$var$hexToRGBA(str) {
    if (typeof str !== 'string') throw new TypeError('Hex code parsing must be performed on a string parameter');
    str = str.toLowerCase();
    if (!/^#[a-f0-9]+$/.test(str)) return null;
    var hex = str.replace(/^#/, '');
    var alpha = 1;
    if (hex.length === 8) {
        alpha = parseInt(hex.slice(6, 8), 16) / 255;
        hex = hex.slice(0, 6);
    }
    if (hex.length === 4) {
        alpha = parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
        hex = hex.slice(0, 3);
    }
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    var num = parseInt(hex, 16);
    var red = num >> 16;
    var green = num >> 8 & 255;
    var blue = num & 255;
    return [
        red,
        green,
        blue,
        alpha
    ];
}

});

parcelRegister("1DNy0", function(module, exports) {
module.exports = $131fde0ccfc555b1$var$rgbaToHex;
function $131fde0ccfc555b1$var$rgbaToHex(rgba) {
    if (!rgba || !Array.isArray(rgba)) throw new TypeError('Must specify an array to convert into a hex code');
    var r = Math.max(0, Math.min(255, Math.round(rgba[0] || 0)));
    var g = Math.max(0, Math.min(255, Math.round(rgba[1] || 0)));
    var b = Math.max(0, Math.min(255, Math.round(rgba[2] || 0)));
    var alpha = rgba[3];
    if (typeof alpha === 'undefined' || !isFinite(alpha)) alpha = 1;
    var a = Math.max(0, Math.min(255, Math.round(alpha * 255)));
    var alphaParam = a === 255 ? '' : (a | 256).toString(16).slice(1);
    var result = (b | g << 8 | r << 16 | 16777216).toString(16).slice(1) + alphaParam;
    return '#' + result;
}

});


parcelRegister("aWPUy", function(module, exports) {
// Extracted from @tmcw / wcag-contrast
// https://github.com/tmcw/relative-luminance/blob/master/index.js
// # Relative luminance
// http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
// https://en.wikipedia.org/wiki/Luminance_(relative)
// https://en.wikipedia.org/wiki/Luminosity_function
// https://en.wikipedia.org/wiki/Rec._709#Luma_coefficients
// red, green, and blue coefficients
var $7f8796a22ab37df2$var$rc = 0.2126;
var $7f8796a22ab37df2$var$gc = 0.7152;
var $7f8796a22ab37df2$var$bc = 0.0722;
// low-gamma adjust coefficient
var $7f8796a22ab37df2$var$lowc = 1 / 12.92;
function $7f8796a22ab37df2$var$adjustGamma(a) {
    return Math.pow((a + 0.055) / 1.055, 2.4);
}
module.exports = $7f8796a22ab37df2$var$relativeLuminance;
function $7f8796a22ab37df2$var$relativeLuminance(rgb) {
    var rsrgb = rgb[0] / 255;
    var gsrgb = rgb[1] / 255;
    var bsrgb = rgb[2] / 255;
    var r = rsrgb <= 0.03928 ? rsrgb * $7f8796a22ab37df2$var$lowc : $7f8796a22ab37df2$var$adjustGamma(rsrgb);
    var g = gsrgb <= 0.03928 ? gsrgb * $7f8796a22ab37df2$var$lowc : $7f8796a22ab37df2$var$adjustGamma(gsrgb);
    var b = bsrgb <= 0.03928 ? bsrgb * $7f8796a22ab37df2$var$lowc : $7f8796a22ab37df2$var$adjustGamma(bsrgb);
    return r * $7f8796a22ab37df2$var$rc + g * $7f8796a22ab37df2$var$gc + b * $7f8796a22ab37df2$var$bc;
}

});


parcelRegister("dgGOd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $956li = parcelRequire("956li");
Object.keys($956li).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $956li[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $956li[key];
        }
    });
});

var $g59rY = parcelRequire("g59rY");
Object.keys($g59rY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $g59rY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $g59rY[key];
        }
    });
});

var $ktC8t = parcelRequire("ktC8t");
Object.keys($ktC8t).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $ktC8t[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $ktC8t[key];
        }
    });
});

var $dI0L2 = parcelRequire("dI0L2");
Object.keys($dI0L2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dI0L2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $dI0L2[key];
        }
    });
});

var $fbKwz = parcelRequire("fbKwz");
Object.keys($fbKwz).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $fbKwz[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $fbKwz[key];
        }
    });
});

var $hzX1e = parcelRequire("hzX1e");
Object.keys($hzX1e).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $hzX1e[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $hzX1e[key];
        }
    });
});

var $jAo2H = parcelRequire("jAo2H");
Object.keys($jAo2H).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $jAo2H[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $jAo2H[key];
        }
    });
});

var $8uR6b = parcelRequire("8uR6b");
Object.keys($8uR6b).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8uR6b[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $8uR6b[key];
        }
    });
});

var $3nGFO = parcelRequire("3nGFO");
Object.keys($3nGFO).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $3nGFO[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $3nGFO[key];
        }
    });
});

var $7LsMo = parcelRequire("7LsMo");
Object.keys($7LsMo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $7LsMo[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $7LsMo[key];
        }
    });
});

var $1zO8d = parcelRequire("1zO8d");
Object.keys($1zO8d).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $1zO8d[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $1zO8d[key];
        }
    });
});

var $2zu1c = parcelRequire("2zu1c");
Object.keys($2zu1c).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $2zu1c[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $2zu1c[key];
        }
    });
});

var $dihg2 = parcelRequire("dihg2");
Object.keys($dihg2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $dihg2[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $dihg2[key];
        }
    });
});

var $aVn1i = parcelRequire("aVn1i");
Object.keys($aVn1i).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aVn1i[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $aVn1i[key];
        }
    });
});

var $aa7fR = parcelRequire("aa7fR");
Object.keys($aa7fR).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $aa7fR[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $aa7fR[key];
        }
    });
});

var $8MXtw = parcelRequire("8MXtw");
Object.keys($8MXtw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $8MXtw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $8MXtw[key];
        }
    });
});

var $b5SqY = parcelRequire("b5SqY");
Object.keys($b5SqY).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b5SqY[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $b5SqY[key];
        }
    });
});

var $b3mJ7 = parcelRequire("b3mJ7");
Object.keys($b3mJ7).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $b3mJ7[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $b3mJ7[key];
        }
    });
});

});
parcelRegister("956li", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateDirection = $69c98026b789ef05$var$calculateDirection;

var $kDZPj = parcelRequire("kDZPj");
function $69c98026b789ef05$var$calculateDirection(trace) {
    var direction;
    var negative = $kDZPj.TraceDirectionKey.NEGATIVE;
    var positive = $kDZPj.TraceDirectionKey.POSITIVE;
    var current = trace[trace.length - 1];
    var previous = trace[trace.length - 2] || 0;
    if (trace.every(function(i) {
        return i === 0;
    })) return $kDZPj.TraceDirectionKey.NONE;
    direction = current > previous ? positive : negative;
    if (current === 0) direction = previous < 0 ? positive : negative;
    return direction;
}

});
parcelRegister("kDZPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TraceDirectionKey = module.exports.Direction = module.exports.Axis = void 0;
var $f07768a5524ebf9d$var$TraceDirectionKey;
module.exports.TraceDirectionKey = $f07768a5524ebf9d$var$TraceDirectionKey;
(function(TraceDirectionKey) {
    TraceDirectionKey["NEGATIVE"] = "NEGATIVE";
    TraceDirectionKey["POSITIVE"] = "POSITIVE";
    TraceDirectionKey["NONE"] = "NONE";
})($f07768a5524ebf9d$var$TraceDirectionKey || (module.exports.TraceDirectionKey = $f07768a5524ebf9d$var$TraceDirectionKey = {}));
var $f07768a5524ebf9d$var$Direction;
module.exports.Direction = $f07768a5524ebf9d$var$Direction;
(function(Direction) {
    Direction["TOP"] = "TOP";
    Direction["LEFT"] = "LEFT";
    Direction["RIGHT"] = "RIGHT";
    Direction["BOTTOM"] = "BOTTOM";
    Direction["NONE"] = "NONE";
})($f07768a5524ebf9d$var$Direction || (module.exports.Direction = $f07768a5524ebf9d$var$Direction = {}));
var $f07768a5524ebf9d$var$Axis;
module.exports.Axis = $f07768a5524ebf9d$var$Axis;
(function(Axis) {
    Axis["X"] = "x";
    Axis["Y"] = "y";
})($f07768a5524ebf9d$var$Axis || (module.exports.Axis = $f07768a5524ebf9d$var$Axis = {}));

});


parcelRegister("g59rY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateDirectionDelta = $bb5471923f725e9b$var$calculateDirectionDelta;

var $kDZPj = parcelRequire("kDZPj");

var $1zO8d = parcelRequire("1zO8d");
function $bb5471923f725e9b$var$calculateDirectionDelta(traceDirections) {
    var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var length = traceDirections.length;
    var i = length - 1;
    var direction = $kDZPj.TraceDirectionKey.NONE;
    for(; i >= 0; i--){
        var current = traceDirections[i];
        var currentKey = (0, $1zO8d.getDirectionKey)(current);
        var currentValue = (0, $1zO8d.getDirectionValue)(current[currentKey]);
        var prev = traceDirections[i - 1] || {};
        var prevKey = (0, $1zO8d.getDirectionKey)(prev);
        var prevValue = (0, $1zO8d.getDirectionValue)(prev[prevKey]);
        var difference = (0, $1zO8d.getDifference)(currentValue, prevValue);
        if (difference >= delta) {
            direction = currentKey;
            break;
        } else direction = prevKey;
    }
    return direction;
}

});
parcelRegister("1zO8d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveAxisDirection = module.exports.getDirectionValue = module.exports.getDirectionKey = module.exports.getDifference = void 0;

var $kDZPj = parcelRequire("kDZPj");
var $125ff260cd2ea9d3$var$getDirectionKey = function getDirectionKey() {
    var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = Object.keys(object).toString();
    switch(key){
        case $kDZPj.TraceDirectionKey.POSITIVE:
            return $kDZPj.TraceDirectionKey.POSITIVE;
        case $kDZPj.TraceDirectionKey.NEGATIVE:
            return $kDZPj.TraceDirectionKey.NEGATIVE;
        default:
            return $kDZPj.TraceDirectionKey.NONE;
    }
};
module.exports.getDirectionKey = $125ff260cd2ea9d3$var$getDirectionKey;
var $125ff260cd2ea9d3$var$getDirectionValue = function getDirectionValue() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return values[values.length - 1] || 0;
};
module.exports.getDirectionValue = $125ff260cd2ea9d3$var$getDirectionValue;
var $125ff260cd2ea9d3$var$getDifference = function getDifference() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Math.abs(x - y);
};
module.exports.getDifference = $125ff260cd2ea9d3$var$getDifference;
var $125ff260cd2ea9d3$var$resolveAxisDirection = function resolveAxisDirection(axis, key) {
    var negative = $kDZPj.Direction.LEFT;
    var positive = $kDZPj.Direction.RIGHT;
    var direction = $kDZPj.Direction.NONE;
    if (axis === $kDZPj.Axis.Y) {
        negative = $kDZPj.Direction.BOTTOM;
        positive = $kDZPj.Direction.TOP;
    }
    if (key === $kDZPj.TraceDirectionKey.NEGATIVE) direction = negative;
    if (key === $kDZPj.TraceDirectionKey.POSITIVE) direction = positive;
    return direction;
};
module.exports.resolveAxisDirection = $125ff260cd2ea9d3$var$resolveAxisDirection;

});


parcelRegister("ktC8t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateDuration = $ee84190867a70232$var$calculateDuration;
function $ee84190867a70232$var$calculateDuration() {
    var prevTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var nextTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return prevTime ? nextTime - prevTime : 0;
}

});

parcelRegister("dI0L2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateMovingPosition = $9faff8e1259ec9db$var$calculateMovingPosition;
function $9faff8e1259ec9db$var$calculateMovingPosition(e) {
    if ('changedTouches' in e) {
        var touches = e.changedTouches && e.changedTouches[0];
        return {
            x: touches && touches.clientX,
            y: touches && touches.clientY
        };
    }
    return {
        x: e.clientX,
        y: e.clientY
    };
}

});

parcelRegister("fbKwz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculatePosition = $b0ebf8e07d337d38$var$calculatePosition;

var $b3mJ7 = parcelRequire("b3mJ7");

var $8MXtw = parcelRequire("8MXtw");

var $ktC8t = parcelRequire("ktC8t");

var $jAo2H = parcelRequire("jAo2H");

var $kDZPj = parcelRequire("kDZPj");
function $b0ebf8e07d337d38$var$calculatePosition(state, options) {
    var start = state.start, x = state.x, y = state.y, traceX = state.traceX, traceY = state.traceY;
    var rotatePosition = options.rotatePosition, directionDelta = options.directionDelta;
    var deltaX = rotatePosition.x - x;
    var deltaY = y - rotatePosition.y;
    var absX = Math.abs(deltaX);
    var absY = Math.abs(deltaY);
    (0, $b3mJ7.updateTrace)(traceX, deltaX);
    (0, $b3mJ7.updateTrace)(traceY, deltaY);
    var directionX = (0, $8MXtw.resolveDirection)(traceX, $kDZPj.Axis.X, directionDelta);
    var directionY = (0, $8MXtw.resolveDirection)(traceY, $kDZPj.Axis.Y, directionDelta);
    var duration = (0, $ktC8t.calculateDuration)(start, Date.now());
    var velocity = (0, $jAo2H.calculateVelocity)(absX, absY, duration);
    return {
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        directionX: directionX,
        directionY: directionY,
        duration: duration,
        positionX: rotatePosition.x,
        positionY: rotatePosition.y,
        velocity: velocity
    };
}

});
parcelRegister("b3mJ7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.updateTrace = $80c19a8ee7916569$var$updateTrace;
function $80c19a8ee7916569$var$updateTrace(trace, value) {
    var last = trace[trace.length - 1];
    if (last !== value) trace.push(value);
    return trace;
}

});

parcelRegister("8MXtw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDirection = $6660f0f96881735d$var$resolveDirection;

var $956li = parcelRequire("956li");

var $hzX1e = parcelRequire("hzX1e");

var $g59rY = parcelRequire("g59rY");

var $1zO8d = parcelRequire("1zO8d");

var $kDZPj = parcelRequire("kDZPj");
function $6660f0f96881735d$var$resolveDirection(trace) {
    var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $kDZPj.Axis.X;
    var directionDelta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (directionDelta) {
        var directions = (0, $hzX1e.calculateTraceDirections)(trace);
        var _direction = (0, $g59rY.calculateDirectionDelta)(directions, directionDelta);
        return (0, $1zO8d.resolveAxisDirection)(axis, _direction);
    }
    var direction = (0, $956li.calculateDirection)(trace);
    return (0, $1zO8d.resolveAxisDirection)(axis, direction);
}

});
parcelRegister("hzX1e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateTraceDirections = $ccc37c7dca9c005e$var$calculateTraceDirections;

var $kDZPj = parcelRequire("kDZPj");
function $ccc37c7dca9c005e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ccc37c7dca9c005e$var$calculateTraceDirections() {
    var trace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var ticks = [];
    var positive = $kDZPj.TraceDirectionKey.POSITIVE;
    var negative = $kDZPj.TraceDirectionKey.NEGATIVE;
    var i = 0;
    var tick = [];
    var direction = $kDZPj.TraceDirectionKey.NONE;
    for(; i < trace.length; i++){
        var current = trace[i];
        var prev = trace[i - 1];
        if (tick.length) {
            var currentDirection = current > prev ? positive : negative;
            if (direction === $kDZPj.TraceDirectionKey.NONE) direction = currentDirection;
            if (currentDirection === direction) tick.push(current);
            else {
                ticks.push($ccc37c7dca9c005e$var$_defineProperty({}, direction, tick.slice()));
                tick = [];
                tick.push(current);
                direction = currentDirection;
            }
        } else {
            if (current !== 0) direction = current > 0 ? positive : negative;
            tick.push(current);
        }
    }
    if (tick.length) ticks.push($ccc37c7dca9c005e$var$_defineProperty({}, direction, tick));
    return ticks;
}

});


parcelRegister("jAo2H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateVelocity = $e424077572602b8f$var$calculateVelocity;
function $e424077572602b8f$var$calculateVelocity(x, y, time) {
    var magnitude = Math.sqrt(x * x + y * y);
    return magnitude / (time || 1);
}

});


parcelRegister("8uR6b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkIsMoreThanSingleTouches = void 0;
var $0198aeb72eb0237e$var$checkIsMoreThanSingleTouches = function checkIsMoreThanSingleTouches(e) {
    return Boolean(e.touches && e.touches.length > 1);
};
module.exports.checkIsMoreThanSingleTouches = $0198aeb72eb0237e$var$checkIsMoreThanSingleTouches;

});

parcelRegister("3nGFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkIsPassiveSupported = $27649f24e2d1cbeb$var$checkIsPassiveSupported;
module.exports.noop = void 0;

var $2zu1c = parcelRequire("2zu1c");
function $27649f24e2d1cbeb$var$checkIsPassiveSupported(isPassiveSupported) {
    if (typeof isPassiveSupported === 'boolean') return isPassiveSupported;
    var proxy = {
        isPassiveSupported: isPassiveSupported
    };
    try {
        var options = (0, $2zu1c.createOptions)(proxy);
        window.addEventListener('checkIsPassiveSupported', $27649f24e2d1cbeb$var$noop, options);
        window.removeEventListener('checkIsPassiveSupported', $27649f24e2d1cbeb$var$noop, options);
    } catch (err) {}
    return proxy.isPassiveSupported;
}
var $27649f24e2d1cbeb$var$noop = function noop() {};
module.exports.noop = $27649f24e2d1cbeb$var$noop;

});
parcelRegister("2zu1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createOptions = $1df622b0d1130d84$var$createOptions;
function $1df622b0d1130d84$var$createOptions() {
    var proxy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    Object.defineProperty(proxy, 'passive', {
        get: function get() {
            this.isPassiveSupported = true;
            return true;
        },
        enumerable: true
    });
    return proxy;
}

});


parcelRegister("7LsMo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkIsTouchEventsSupported = void 0;
function $5a733f32dcd99878$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5a733f32dcd99878$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5a733f32dcd99878$var$_typeof(obj);
}
var $5a733f32dcd99878$var$checkIsTouchEventsSupported = function checkIsTouchEventsSupported() {
    return (typeof window === "undefined" ? "undefined" : $5a733f32dcd99878$var$_typeof(window)) === 'object' && ('ontouchstart' in window || Boolean(window.navigator.maxTouchPoints));
};
module.exports.checkIsTouchEventsSupported = $5a733f32dcd99878$var$checkIsTouchEventsSupported;

});

parcelRegister("dihg2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getInitialState = void 0;
function $9ada57cb3d1b9dc7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9ada57cb3d1b9dc7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9ada57cb3d1b9dc7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9ada57cb3d1b9dc7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9ada57cb3d1b9dc7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9ada57cb3d1b9dc7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9ada57cb3d1b9dc7$var$getInitialState = function getInitialState() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $9ada57cb3d1b9dc7$var$_objectSpread({
        x: 0,
        y: 0,
        start: 0,
        isSwiping: false,
        traceX: [],
        traceY: []
    }, options);
};
module.exports.getInitialState = $9ada57cb3d1b9dc7$var$getInitialState;

});

parcelRegister("aVn1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getInitialProps = void 0;
function $7f41158216a1ed68$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7f41158216a1ed68$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7f41158216a1ed68$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7f41158216a1ed68$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7f41158216a1ed68$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7f41158216a1ed68$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $7f41158216a1ed68$var$getInitialProps = function getInitialProps() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return $7f41158216a1ed68$var$_objectSpread({
        element: null,
        target: null,
        delta: 10,
        directionDelta: 0,
        rotationAngle: 0,
        mouseTrackingEnabled: false,
        touchTrackingEnabled: true,
        preventDefaultTouchmoveEvent: false,
        preventTrackingOnMouseleave: false
    }, props);
};
module.exports.getInitialProps = $7f41158216a1ed68$var$getInitialProps;

});

parcelRegister("aa7fR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getOptions = $7660773547670bfa$var$getOptions;
function $7660773547670bfa$var$getOptions() {
    var isPassiveSupported = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (isPassiveSupported) return {
        passive: false
    };
    return {};
}

});

parcelRegister("b5SqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rotateByAngle = $813a62cdadda50cf$var$rotateByAngle;
function $813a62cdadda50cf$var$rotateByAngle(position) {
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (angle === 0) return position;
    var x = position.x, y = position.y;
    var angleInRadians = Math.PI / 180 * angle;
    var rotatedX = x * Math.cos(angleInRadians) + y * Math.sin(angleInRadians);
    var rotatedY = y * Math.cos(angleInRadians) - x * Math.sin(angleInRadians);
    return {
        x: rotatedX,
        y: rotatedY
    };
}

});


parcelRegister("lcARq", function(module, exports) {
function $f6f74fb7b59d37b4$var$backInOut(t) {
    var s = 2.5949095;
    if ((t *= 2) < 1) return 0.5 * (t * t * ((s + 1) * t - s));
    return 0.5 * ((t -= 2) * t * ((s + 1) * t + s) + 2);
}
module.exports = $f6f74fb7b59d37b4$var$backInOut;

});

parcelRegister("jHF83", function(module, exports) {
function $e581efd44d2e0b21$var$backIn(t) {
    var s = 1.70158;
    return t * t * ((s + 1) * t - s);
}
module.exports = $e581efd44d2e0b21$var$backIn;

});

parcelRegister("10NOt", function(module, exports) {
function $0bcc6e5f3c8ee3a7$var$backOut(t) {
    var s = 1.70158;
    return --t * t * ((s + 1) * t + s) + 1;
}
module.exports = $0bcc6e5f3c8ee3a7$var$backOut;

});

parcelRegister("7pUQu", function(module, exports) {

var $2IXAh = parcelRequire("2IXAh");
function $5666f68d97f9d249$var$bounceInOut(t) {
    return t < 0.5 ? 0.5 * (1.0 - $2IXAh(1.0 - t * 2.0)) : 0.5 * $2IXAh(t * 2.0 - 1.0) + 0.5;
}
module.exports = $5666f68d97f9d249$var$bounceInOut;

});
parcelRegister("2IXAh", function(module, exports) {
function $1fbde8fbc7365716$var$bounceOut(t) {
    var a = 4.0 / 11.0;
    var b = 8.0 / 11.0;
    var c = 0.9;
    var ca = 4356.0 / 361.0;
    var cb = 35442.0 / 1805.0;
    var cc = 16061.0 / 1805.0;
    var t2 = t * t;
    return t < a ? 7.5625 * t2 : t < b ? 9.075 * t2 - 9.9 * t + 3.4 : t < c ? ca * t2 - cb * t + cc : 10.8 * t * t - 20.52 * t + 10.72;
}
module.exports = $1fbde8fbc7365716$var$bounceOut;

});


parcelRegister("aaGnN", function(module, exports) {

var $2IXAh = parcelRequire("2IXAh");
function $767bb6e61564f6a3$var$bounceIn(t) {
    return 1.0 - $2IXAh(1.0 - t);
}
module.exports = $767bb6e61564f6a3$var$bounceIn;

});

parcelRegister("3jp57", function(module, exports) {
function $26969a1cbc6cf3c8$var$circInOut(t) {
    if ((t *= 2) < 1) return -0.5 * (Math.sqrt(1 - t * t) - 1);
    return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
}
module.exports = $26969a1cbc6cf3c8$var$circInOut;

});

parcelRegister("h1eFd", function(module, exports) {
function $c63de79543a45b8f$var$circIn(t) {
    return 1.0 - Math.sqrt(1.0 - t * t);
}
module.exports = $c63de79543a45b8f$var$circIn;

});

parcelRegister("9G85D", function(module, exports) {
function $70be4fc4fe5cd926$var$circOut(t) {
    return Math.sqrt(1 - --t * t);
}
module.exports = $70be4fc4fe5cd926$var$circOut;

});

parcelRegister("54dqr", function(module, exports) {
function $3b07bd8110c846f6$var$cubicInOut(t) {
    return t < 0.5 ? 4.0 * t * t * t : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
}
module.exports = $3b07bd8110c846f6$var$cubicInOut;

});

parcelRegister("laFj9", function(module, exports) {
function $f69a9306d8c92c37$var$cubicIn(t) {
    return t * t * t;
}
module.exports = $f69a9306d8c92c37$var$cubicIn;

});

parcelRegister("l8CBG", function(module, exports) {
function $f6384ad5892db511$var$cubicOut(t) {
    var f = t - 1.0;
    return f * f * f + 1.0;
}
module.exports = $f6384ad5892db511$var$cubicOut;

});

parcelRegister("4Zcfl", function(module, exports) {
function $3a165bcf3af19622$var$elasticInOut(t) {
    return t < 0.5 ? 0.5 * Math.sin(13 * Math.PI / 2 * 2.0 * t) * Math.pow(2.0, 10.0 * (2.0 * t - 1.0)) : 0.5 * Math.sin(-13 * Math.PI / 2 * (2.0 * t - 1.0 + 1.0)) * Math.pow(2.0, -10 * (2.0 * t - 1.0)) + 1.0;
}
module.exports = $3a165bcf3af19622$var$elasticInOut;

});

parcelRegister("5Coxo", function(module, exports) {
function $417389034bbf3abe$var$elasticIn(t) {
    return Math.sin(13.0 * t * Math.PI / 2) * Math.pow(2.0, 10.0 * (t - 1.0));
}
module.exports = $417389034bbf3abe$var$elasticIn;

});

parcelRegister("7Pty0", function(module, exports) {
function $5b3437572069a99a$var$elasticOut(t) {
    return Math.sin(-13 * (t + 1.0) * Math.PI / 2) * Math.pow(2.0, -10 * t) + 1.0;
}
module.exports = $5b3437572069a99a$var$elasticOut;

});

parcelRegister("ktErU", function(module, exports) {
function $03d8de85f4dfe12a$var$expoInOut(t) {
    return t === 0.0 || t === 1.0 ? t : t < 0.5 ? 0.5 * Math.pow(2.0, 20.0 * t - 10.0) : -0.5 * Math.pow(2.0, 10.0 - t * 20.0) + 1.0;
}
module.exports = $03d8de85f4dfe12a$var$expoInOut;

});

parcelRegister("1U6DE", function(module, exports) {
function $16302ba7f4a8d28f$var$expoIn(t) {
    return t === 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0));
}
module.exports = $16302ba7f4a8d28f$var$expoIn;

});

parcelRegister("kFT4v", function(module, exports) {
function $f0d25b17b7479d3d$var$expoOut(t) {
    return t === 1.0 ? t : 1.0 - Math.pow(2.0, -10 * t);
}
module.exports = $f0d25b17b7479d3d$var$expoOut;

});

parcelRegister("eG8qR", function(module, exports) {
function $aafb8761b6ab4373$var$linear(t) {
    return t;
}
module.exports = $aafb8761b6ab4373$var$linear;

});

parcelRegister("gqHJW", function(module, exports) {
function $bf6100eafe863f22$var$quadInOut(t) {
    t /= 0.5;
    if (t < 1) return 0.5 * t * t;
    t--;
    return -0.5 * (t * (t - 2) - 1);
}
module.exports = $bf6100eafe863f22$var$quadInOut;

});

parcelRegister("8IRFy", function(module, exports) {
function $659c10601085b660$var$quadIn(t) {
    return t * t;
}
module.exports = $659c10601085b660$var$quadIn;

});

parcelRegister("j8e1d", function(module, exports) {
function $ded9a37d3c81908f$var$quadOut(t) {
    return -t * (t - 2.0);
}
module.exports = $ded9a37d3c81908f$var$quadOut;

});

parcelRegister("fa2P2", function(module, exports) {
function $b099fa994fef6343$var$quarticInOut(t) {
    return t < 0.5 ? 8 * Math.pow(t, 4.0) : -8 * Math.pow(t - 1.0, 4.0) + 1.0;
}
module.exports = $b099fa994fef6343$var$quarticInOut;

});

parcelRegister("jNt6y", function(module, exports) {
function $e6992b8081139524$var$quarticIn(t) {
    return Math.pow(t, 4.0);
}
module.exports = $e6992b8081139524$var$quarticIn;

});

parcelRegister("eHHjv", function(module, exports) {
function $ab46ae05e49e09de$var$quarticOut(t) {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
}
module.exports = $ab46ae05e49e09de$var$quarticOut;

});

parcelRegister("7sd8a", function(module, exports) {
function $56d5557162be4b43$var$qinticInOut(t) {
    if ((t *= 2) < 1) return 0.5 * t * t * t * t * t;
    return 0.5 * ((t -= 2) * t * t * t * t + 2);
}
module.exports = $56d5557162be4b43$var$qinticInOut;

});

parcelRegister("9wzDY", function(module, exports) {
function $6ef2c055102f95c1$var$qinticIn(t) {
    return t * t * t * t * t;
}
module.exports = $6ef2c055102f95c1$var$qinticIn;

});

parcelRegister("2mAMC", function(module, exports) {
function $1b8a2b3a82038b79$var$qinticOut(t) {
    return --t * t * t * t * t + 1;
}
module.exports = $1b8a2b3a82038b79$var$qinticOut;

});

parcelRegister("ldnK0", function(module, exports) {
function $f71d3a5b14754b6e$var$sineInOut(t) {
    return -0.5 * (Math.cos(Math.PI * t) - 1);
}
module.exports = $f71d3a5b14754b6e$var$sineInOut;

});

parcelRegister("5bWUt", function(module, exports) {
function $3c7bad1e7ba886ed$var$sineIn(t) {
    var v = Math.cos(t * Math.PI * 0.5);
    if (Math.abs(v) < 1e-14) return 1;
    else return 1 - v;
}
module.exports = $3c7bad1e7ba886ed$var$sineIn;

});

parcelRegister("3JbFx", function(module, exports) {
function $2b6ea04605093f25$var$sineOut(t) {
    return Math.sin(t * Math.PI / 2);
}
module.exports = $2b6ea04605093f25$var$sineOut;

});


var $7382cc169ba6fa55$exports = {};
var $7382cc169ba6fa55$var$u = 'undefined', $7382cc169ba6fa55$var$o = 'object';




(function(klass) {
    $7382cc169ba6fa55$var$o === "object" ? $7382cc169ba6fa55$exports = klass : $7382cc169ba6fa55$var$u !== typeof Meteor ? Ways = klass : this.Ways = klass;
})($7382cc169ba6fa55$var$_module.apply(null, [
    $7382cc169ba6fa55$var$u !== typeof Happens ? Happens : (parcelRequire("jTtr8")),
    $7382cc169ba6fa55$var$u !== typeof WaysWay ? WaysWay : (parcelRequire("iUhcu")),
    $7382cc169ba6fa55$var$u !== typeof WaysFlow ? WaysFlow : (parcelRequire("kikqP")),
    $7382cc169ba6fa55$var$u !== typeof Meteor && Meteor.isClient ? WaysAddressBar : $7382cc169ba6fa55$var$u !== typeof Meteor ? null : (parcelRequire("1sNs2"))
]));
function $7382cc169ba6fa55$var$_module(Happens1, Way, Flow, AddresssBar) {
    'use strict';
    // Config
    var flow = null;
    var mode = null;
    var plugin = null;
    var routes = [];
    var base_path = null;
    var current_pathname = null;
    Happens1(Ways1);
    /**
   * Sets up a new route
   * @param {String} pattern      Pattern string
   * @param {Function} runner     Route's action runner
   * @param {Function} destroyer  Optional, Route's action destroyer (flow mode)
   * @param {String} dependency   Optional, specifies a dependency by pattern
   */ function Ways1(pattern, runner, destroyer, dependency) {
        if (flow && arguments.length < 3) throw new Error('In `flow` mode you must to pass at least 3 args.');
        var route = new Way(pattern, runner, destroyer, dependency);
        routes.push(route);
        return route;
    }
    Ways1.flow = function(m) {
        routes = [];
        if ((mode = m) != null) flow = new Flow(routes, mode);
    };
    Ways1.use = function(plug) {
        plugin = new plug(base_path);
        plugin.on('url:change', plugin_url_change);
    };
    Ways1.basepath = function(path) {
        base_path = path;
    };
    Ways1.pathname = function() {
        if (plugin) return plugin.pathname();
        else return current_pathname;
    };
    Ways1.go = function(url, title, state) {
        if (base_path) {
            url = url.split(base_path).pop();
            url = base_path + url;
        }
        if (plugin) plugin.push(url, title, state);
        else dispatch(url);
    };
    Ways1.go.silent = function(url, title, state) {
        if (plugin) plugin.replace(url, title, state);
    };
    Ways1.reset = function() {
        if (plugin) plugin.off('url:change', plugin_url_change);
        flow = null;
        mode = null;
        plugin = null;
        routes = [];
        current_pathname = null;
    };
    Ways1.addressbar = AddresssBar || {
        error: 'addressbar plugin can be used only in the client'
    };
    function plugin_url_change(url) {
        var u = plugin.pathname();
        if (base_path) u = u.split(base_path).pop();
        dispatch(u);
    }
    function dispatch(url) {
        var i, route, url = '/' + url.replace(/^[\/]+|[\/]+$/mg, '');
        for(i in routes)if ((route = routes[i]).matcher.test(url)) {
            Ways1.emit("url:change", current_pathname = url);
            return flow ? flow.run(url, route) : route.run(url);
        }
        throw new Error("Route not found for url '" + url + "'");
    }
    return Ways1;
}


// Gets all non-builtin properties up the prototype chain.
const $1dd800e365bb90af$var$getAllProperties = (object)=>{
    const properties = new Set();
    do for (const key of Reflect.ownKeys(object))properties.add([
        object,
        key
    ]);
    while ((object = Reflect.getPrototypeOf(object)) && object !== Object.prototype);
    return properties;
};
function $1dd800e365bb90af$export$2e2bcd8739ae039(self, { include: include, exclude: exclude } = {}) {
    const filter = (key)=>{
        const match = (pattern)=>typeof pattern === 'string' ? key === pattern : pattern.test(key);
        if (include) return include.some(match); // eslint-disable-line unicorn/no-array-callback-reference
        if (exclude) return !exclude.some(match); // eslint-disable-line unicorn/no-array-callback-reference
        return true;
    };
    for (const [object, key] of $1dd800e365bb90af$var$getAllProperties(self.constructor.prototype)){
        if (key === 'constructor' || !filter(key)) continue;
        const descriptor = Reflect.getOwnPropertyDescriptor(object, key);
        if (descriptor && typeof descriptor.value === 'function') self[key] = self[key].bind(self);
    }
    return self;
}



let $7c9350f720ca2356$var$parser = new DOMParser();
var $7c9350f720ca2356$export$2e2bcd8739ae039 = (html)=>{
    let el = $7c9350f720ca2356$var$parser.parseFromString(html, 'text/html');
    return el.body.firstChild;
};


/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $f70f7eb6404ce619$export$3545e07a80636437 = '144';
const $f70f7eb6404ce619$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $f70f7eb6404ce619$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $f70f7eb6404ce619$export$3237e1f2c1ea1f44 = 0;
const $f70f7eb6404ce619$export$b9a7b4fc5cb15f9b = 1;
const $f70f7eb6404ce619$export$b8058bcc7037d3f3 = 2;
const $f70f7eb6404ce619$export$f24be24dcddeac0d = 3;
const $f70f7eb6404ce619$export$346307dbae2b7447 = 0;
const $f70f7eb6404ce619$export$5813f879eee7cd88 = 1;
const $f70f7eb6404ce619$export$a47c4b43a1be34f0 = 2;
const $f70f7eb6404ce619$export$896ae1ade6c829c4 = 3;
const $f70f7eb6404ce619$export$2ede184fc2998901 = 0;
const $f70f7eb6404ce619$export$d9f0486e75b5ace = 1;
const $f70f7eb6404ce619$export$3b296b6f144d5b03 = 2;
const $f70f7eb6404ce619$export$63b8d6b580fc65ba = 0;
const $f70f7eb6404ce619$export$5b29a26d96ee6af0 = 1;
const $f70f7eb6404ce619$export$777d8f9551c2216b = 2;
const $f70f7eb6404ce619$export$cdfa06f868e2e467 = 3;
const $f70f7eb6404ce619$export$4138e1c684b46a20 = 4;
const $f70f7eb6404ce619$export$eda4864c68df1fa2 = 5;
const $f70f7eb6404ce619$export$20183a0484ce21a0 = 100;
const $f70f7eb6404ce619$export$73e0df5177988548 = 101;
const $f70f7eb6404ce619$export$28e582859cbec660 = 102;
const $f70f7eb6404ce619$export$c8c1508da8d0600c = 103;
const $f70f7eb6404ce619$export$99948c02fb51055f = 104;
const $f70f7eb6404ce619$export$2110f05edf778d3d = 200;
const $f70f7eb6404ce619$export$8805bad65e24940e = 201;
const $f70f7eb6404ce619$export$7fbe15b28d28cf52 = 202;
const $f70f7eb6404ce619$export$947829af9f2c17f6 = 203;
const $f70f7eb6404ce619$export$d5773124e86cf28c = 204;
const $f70f7eb6404ce619$export$11d468cc7f19e971 = 205;
const $f70f7eb6404ce619$export$a78aed1ca2a87192 = 206;
const $f70f7eb6404ce619$export$5d0fe17fd8773bac = 207;
const $f70f7eb6404ce619$export$ef5f2dd8ffac5574 = 208;
const $f70f7eb6404ce619$export$56b85b2686ab16 = 209;
const $f70f7eb6404ce619$export$c05e2a1fc8609506 = 210;
const $f70f7eb6404ce619$export$69025ce147cee220 = 0;
const $f70f7eb6404ce619$export$7182eb52ea3b3f04 = 1;
const $f70f7eb6404ce619$export$eedccec66ab7ebe = 2;
const $f70f7eb6404ce619$export$296f78a0b892f81a = 3;
const $f70f7eb6404ce619$export$a60d398fc7b7590e = 4;
const $f70f7eb6404ce619$export$7d7234c1240a1fc4 = 5;
const $f70f7eb6404ce619$export$c5e2c52991f30937 = 6;
const $f70f7eb6404ce619$export$2f843afa843d8916 = 7;
const $f70f7eb6404ce619$export$e50ac29801f1774d = 0;
const $f70f7eb6404ce619$export$9f9d94f963c85479 = 1;
const $f70f7eb6404ce619$export$e641dc52bc3494aa = 2;
const $f70f7eb6404ce619$export$9fcb6b4294603b2 = 0;
const $f70f7eb6404ce619$export$98f52c2a46c598ca = 1;
const $f70f7eb6404ce619$export$74b25e54b3bcd548 = 2;
const $f70f7eb6404ce619$export$932b3dd283d4a366 = 3;
const $f70f7eb6404ce619$export$a0d98fe6d7e4af64 = 4;
const $f70f7eb6404ce619$export$2c7b09c1e9abfb5e = 5;
const $f70f7eb6404ce619$export$1beec6768cbb3d2d = 300;
const $f70f7eb6404ce619$export$8759762a6477f2c4 = 301;
const $f70f7eb6404ce619$export$dc59f8aed047f61d = 302;
const $f70f7eb6404ce619$export$d64030b316d3b087 = 303;
const $f70f7eb6404ce619$export$ee99d97d46898098 = 304;
const $f70f7eb6404ce619$export$dbf3e70ff37af79 = 306;
const $f70f7eb6404ce619$export$533346c8e8dac0f5 = 1000;
const $f70f7eb6404ce619$export$9d9334239a5a5e06 = 1001;
const $f70f7eb6404ce619$export$c7e7c00b14f51a4f = 1002;
const $f70f7eb6404ce619$export$727aa5ec3fe39bf0 = 1003;
const $f70f7eb6404ce619$export$d129e38cf6feaa8c = 1004;
const $f70f7eb6404ce619$export$14a4936464a36496 = 1004;
const $f70f7eb6404ce619$export$d2327c1afe5bfdf2 = 1005;
const $f70f7eb6404ce619$export$cbc5b7f5647595d8 = 1005;
const $f70f7eb6404ce619$export$8a72f490b25c56c8 = 1006;
const $f70f7eb6404ce619$export$19a719f377145a13 = 1007;
const $f70f7eb6404ce619$export$dbe96bee3fe9dbf0 = 1007;
const $f70f7eb6404ce619$export$5d8599b6a933fb1b = 1008;
const $f70f7eb6404ce619$export$90d80f1e3506775f = 1008;
const $f70f7eb6404ce619$export$2e8ce08d3f6f5e10 = 1009;
const $f70f7eb6404ce619$export$545fce0311a9796a = 1010;
const $f70f7eb6404ce619$export$88572337f312435f = 1011;
const $f70f7eb6404ce619$export$c63dc51868b06a9d = 1012;
const $f70f7eb6404ce619$export$5c612977753abe2 = 1013;
const $f70f7eb6404ce619$export$c3c7fc4518ebba96 = 1014;
const $f70f7eb6404ce619$export$f6d331659b644596 = 1015;
const $f70f7eb6404ce619$export$2697304443f382bc = 1016;
const $f70f7eb6404ce619$export$b3969b01faf587f2 = 1017;
const $f70f7eb6404ce619$export$18886f8ae33e90de = 1018;
const $f70f7eb6404ce619$export$6c8ea339bfab1301 = 1020;
const $f70f7eb6404ce619$export$988473390501ed4b = 1021;
const $f70f7eb6404ce619$export$7c67423a5ee6f5eb = 1022; // @deprecated since r137
const $f70f7eb6404ce619$export$3f8bb04b555a363c = 1023;
const $f70f7eb6404ce619$export$cc09ccbf6d1ed449 = 1024;
const $f70f7eb6404ce619$export$9053a81c4a69c289 = 1025;
const $f70f7eb6404ce619$export$c1b6b5136be58045 = 1026;
const $f70f7eb6404ce619$export$1e113ac2d0905829 = 1027;
const $f70f7eb6404ce619$export$4e041a7967d15c4b = 1028;
const $f70f7eb6404ce619$export$aa92e870a709d190 = 1029;
const $f70f7eb6404ce619$export$6cdf0b461c7ce8a0 = 1030;
const $f70f7eb6404ce619$export$1ba1c45f9f77d4d7 = 1031;
const $f70f7eb6404ce619$export$c200e7d26f592f21 = 1033;
const $f70f7eb6404ce619$export$21d1799c6d552fc0 = 33776;
const $f70f7eb6404ce619$export$afa304c3e981b668 = 33777;
const $f70f7eb6404ce619$export$d2a1a68024a3e56c = 33778;
const $f70f7eb6404ce619$export$9a79c424327dacf9 = 33779;
const $f70f7eb6404ce619$export$19ada9bbb1af3573 = 35840;
const $f70f7eb6404ce619$export$d0f0355bb3d948e4 = 35841;
const $f70f7eb6404ce619$export$b82296714358084c = 35842;
const $f70f7eb6404ce619$export$b71692456c47b6c3 = 35843;
const $f70f7eb6404ce619$export$6ab91af2d757aee7 = 36196;
const $f70f7eb6404ce619$export$7800993ef8106a6a = 37492;
const $f70f7eb6404ce619$export$23ed8300a860e7d8 = 37496;
const $f70f7eb6404ce619$export$dc5570b4a2b92d48 = 37808;
const $f70f7eb6404ce619$export$68880cd325f8b2fb = 37809;
const $f70f7eb6404ce619$export$7d2c0be323373d95 = 37810;
const $f70f7eb6404ce619$export$22b52da301fc3a3e = 37811;
const $f70f7eb6404ce619$export$c009e2cb4a66485e = 37812;
const $f70f7eb6404ce619$export$118fff5afa255b63 = 37813;
const $f70f7eb6404ce619$export$120713c829ae0667 = 37814;
const $f70f7eb6404ce619$export$c79eeabbf53313e9 = 37815;
const $f70f7eb6404ce619$export$443cf6567cdd6424 = 37816;
const $f70f7eb6404ce619$export$6573984fc9840780 = 37817;
const $f70f7eb6404ce619$export$e7aee563f30091de = 37818;
const $f70f7eb6404ce619$export$2eb8634622ddeab7 = 37819;
const $f70f7eb6404ce619$export$202b1ce7b5d25742 = 37820;
const $f70f7eb6404ce619$export$18ab77abd087e467 = 37821;
const $f70f7eb6404ce619$export$ce40b115e188bc81 = 36492;
const $f70f7eb6404ce619$export$d62fdc9d1b1cccad = 2200;
const $f70f7eb6404ce619$export$dfaf4422ce096e29 = 2201;
const $f70f7eb6404ce619$export$f8f6f2041b78e210 = 2202;
const $f70f7eb6404ce619$export$995b32462a65e855 = 2300;
const $f70f7eb6404ce619$export$30fac1aace31cf4d = 2301;
const $f70f7eb6404ce619$export$198b11ff4c72bb30 = 2302;
const $f70f7eb6404ce619$export$7f795934b84ab523 = 2400;
const $f70f7eb6404ce619$export$24a4ccb5099273b5 = 2401;
const $f70f7eb6404ce619$export$8e8c3ecdcd8e1fee = 2402;
const $f70f7eb6404ce619$export$bcfbbdcf8de7f8cd = 2500;
const $f70f7eb6404ce619$export$d875e029ef558d3 = 2501;
const $f70f7eb6404ce619$export$4c28c87c2dc84758 = 0;
const $f70f7eb6404ce619$export$b23a071aa286eb29 = 1;
const $f70f7eb6404ce619$export$f0d8293634f88842 = 2;
const $f70f7eb6404ce619$export$7207336e4151a112 = 3000;
const $f70f7eb6404ce619$export$f32388edbb32674 = 3001;
const $f70f7eb6404ce619$export$deeb383078690b50 = 3200;
const $f70f7eb6404ce619$export$8f910f4c4f73df11 = 3201;
const $f70f7eb6404ce619$export$2852a58ebdac27b8 = 0;
const $f70f7eb6404ce619$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $f70f7eb6404ce619$export$bfcb490c2dd3db51 = '';
const $f70f7eb6404ce619$export$561f394b24edfcaa = 'srgb';
const $f70f7eb6404ce619$export$42429b3acfb233a4 = 'srgb-linear';
const $f70f7eb6404ce619$export$69433f11f42d5527 = 0;
const $f70f7eb6404ce619$export$9f542ae4b5baca34 = 7680;
const $f70f7eb6404ce619$export$8a4f28336ef203d3 = 7681;
const $f70f7eb6404ce619$export$2928c0231297c036 = 7682;
const $f70f7eb6404ce619$export$c0e9611c8a15f9a8 = 7683;
const $f70f7eb6404ce619$export$9c2c08927385dcc4 = 34055;
const $f70f7eb6404ce619$export$7c74ea00fa1315e6 = 34056;
const $f70f7eb6404ce619$export$22e2e5726612443 = 5386;
const $f70f7eb6404ce619$export$1343870698229224 = 512;
const $f70f7eb6404ce619$export$8e1d8ed281997fa6 = 513;
const $f70f7eb6404ce619$export$55648a1cde8329a7 = 514;
const $f70f7eb6404ce619$export$2dff107857e6aca2 = 515;
const $f70f7eb6404ce619$export$6f93765ab2f451a2 = 516;
const $f70f7eb6404ce619$export$6f3fb2d2440f2b76 = 517;
const $f70f7eb6404ce619$export$4119cf7b4c98fd5a = 518;
const $f70f7eb6404ce619$export$14cf96713ddd97a8 = 519;
const $f70f7eb6404ce619$export$763e8360f4d7f77d = 35044;
const $f70f7eb6404ce619$export$8505d14ac8546ca = 35048;
const $f70f7eb6404ce619$export$721e63549e51d81e = 35040;
const $f70f7eb6404ce619$export$415731dc4f48e299 = 35045;
const $f70f7eb6404ce619$export$9e809946455f13bc = 35049;
const $f70f7eb6404ce619$export$2ed9499a35b5f832 = 35041;
const $f70f7eb6404ce619$export$32ab2503ea19469a = 35046;
const $f70f7eb6404ce619$export$ab4022c2c3f86315 = 35050;
const $f70f7eb6404ce619$export$ba7f1db36a76a970 = 35042;
const $f70f7eb6404ce619$export$43600cc67fabd9f = '100';
const $f70f7eb6404ce619$export$f63012db5506e7dd = '300 es';
const $f70f7eb6404ce619$export$ca1dce8b5e1de74d = 1035; // fallback for WebGL 1
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $f70f7eb6404ce619$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $f70f7eb6404ce619$var$_seed = 1234567;
const $f70f7eb6404ce619$var$DEG2RAD = Math.PI / 180;
const $f70f7eb6404ce619$var$RAD2DEG = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $f70f7eb6404ce619$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $f70f7eb6404ce619$var$_lut[d0 & 0xff] + $f70f7eb6404ce619$var$_lut[d0 >> 8 & 0xff] + $f70f7eb6404ce619$var$_lut[d0 >> 16 & 0xff] + $f70f7eb6404ce619$var$_lut[d0 >> 24 & 0xff] + '-' + $f70f7eb6404ce619$var$_lut[d1 & 0xff] + $f70f7eb6404ce619$var$_lut[d1 >> 8 & 0xff] + '-' + $f70f7eb6404ce619$var$_lut[d1 >> 16 & 0x0f | 0x40] + $f70f7eb6404ce619$var$_lut[d1 >> 24 & 0xff] + '-' + $f70f7eb6404ce619$var$_lut[d2 & 0x3f | 0x80] + $f70f7eb6404ce619$var$_lut[d2 >> 8 & 0xff] + '-' + $f70f7eb6404ce619$var$_lut[d2 >> 16 & 0xff] + $f70f7eb6404ce619$var$_lut[d2 >> 24 & 0xff] + $f70f7eb6404ce619$var$_lut[d3 & 0xff] + $f70f7eb6404ce619$var$_lut[d3 >> 8 & 0xff] + $f70f7eb6404ce619$var$_lut[d3 >> 16 & 0xff] + $f70f7eb6404ce619$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $f70f7eb6404ce619$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $f70f7eb6404ce619$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $f70f7eb6404ce619$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $f70f7eb6404ce619$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $f70f7eb6404ce619$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $f70f7eb6404ce619$var$damp(x, y, lambda, dt) {
    return $f70f7eb6404ce619$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $f70f7eb6404ce619$var$pingpong(x, length = 1) {
    return length - Math.abs($f70f7eb6404ce619$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $f70f7eb6404ce619$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $f70f7eb6404ce619$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $f70f7eb6404ce619$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $f70f7eb6404ce619$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $f70f7eb6404ce619$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $f70f7eb6404ce619$var$seededRandom(s) {
    if (s !== undefined) $f70f7eb6404ce619$var$_seed = s;
    // Mulberry32 generator
    let t = $f70f7eb6404ce619$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $f70f7eb6404ce619$var$degToRad(degrees) {
    return degrees * $f70f7eb6404ce619$var$DEG2RAD;
}
function $f70f7eb6404ce619$var$radToDeg(radians) {
    return radians * $f70f7eb6404ce619$var$RAD2DEG;
}
function $f70f7eb6404ce619$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $f70f7eb6404ce619$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $f70f7eb6404ce619$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $f70f7eb6404ce619$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $f70f7eb6404ce619$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $f70f7eb6404ce619$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
var $f70f7eb6404ce619$export$6a7ef315a0d1ef07 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    DEG2RAD: $f70f7eb6404ce619$var$DEG2RAD,
    RAD2DEG: $f70f7eb6404ce619$var$RAD2DEG,
    generateUUID: $f70f7eb6404ce619$var$generateUUID,
    clamp: $f70f7eb6404ce619$var$clamp,
    euclideanModulo: $f70f7eb6404ce619$var$euclideanModulo,
    mapLinear: $f70f7eb6404ce619$var$mapLinear,
    inverseLerp: $f70f7eb6404ce619$var$inverseLerp,
    lerp: $f70f7eb6404ce619$var$lerp,
    damp: $f70f7eb6404ce619$var$damp,
    pingpong: $f70f7eb6404ce619$var$pingpong,
    smoothstep: $f70f7eb6404ce619$var$smoothstep,
    smootherstep: $f70f7eb6404ce619$var$smootherstep,
    randInt: $f70f7eb6404ce619$var$randInt,
    randFloat: $f70f7eb6404ce619$var$randFloat,
    randFloatSpread: $f70f7eb6404ce619$var$randFloatSpread,
    seededRandom: $f70f7eb6404ce619$var$seededRandom,
    degToRad: $f70f7eb6404ce619$var$degToRad,
    radToDeg: $f70f7eb6404ce619$var$radToDeg,
    isPowerOfTwo: $f70f7eb6404ce619$var$isPowerOfTwo,
    ceilPowerOfTwo: $f70f7eb6404ce619$var$ceilPowerOfTwo,
    floorPowerOfTwo: $f70f7eb6404ce619$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $f70f7eb6404ce619$var$setQuaternionFromProperEuler,
    normalize: $f70f7eb6404ce619$var$normalize,
    denormalize: $f70f7eb6404ce619$var$denormalize
});
class $f70f7eb6404ce619$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $f70f7eb6404ce619$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $f70f7eb6404ce619$export$8ff26dafa08918 {
    constructor(){
        $f70f7eb6404ce619$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
function $f70f7eb6404ce619$var$arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $f70f7eb6404ce619$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $f70f7eb6404ce619$var$getTypedArray(type, buffer) {
    return new $f70f7eb6404ce619$var$TYPED_ARRAYS[type](buffer);
}
function $f70f7eb6404ce619$var$createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $f70f7eb6404ce619$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $f70f7eb6404ce619$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
// JavaScript RGB-to-RGB transforms, defined as
// FN[InputColorSpace][OutputColorSpace] callback functions.
const $f70f7eb6404ce619$var$FN = {
    [$f70f7eb6404ce619$export$561f394b24edfcaa]: {
        [$f70f7eb6404ce619$export$42429b3acfb233a4]: $f70f7eb6404ce619$var$SRGBToLinear
    },
    [$f70f7eb6404ce619$export$42429b3acfb233a4]: {
        [$f70f7eb6404ce619$export$561f394b24edfcaa]: $f70f7eb6404ce619$var$LinearToSRGB
    }
};
const $f70f7eb6404ce619$export$5e6fd513f44698c = {
    legacyMode: true,
    get workingColorSpace () {
        return $f70f7eb6404ce619$export$42429b3acfb233a4;
    },
    set workingColorSpace (colorSpace){
        console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
    },
    convert: function(color, sourceColorSpace, targetColorSpace) {
        if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
        if ($f70f7eb6404ce619$var$FN[sourceColorSpace] && $f70f7eb6404ce619$var$FN[sourceColorSpace][targetColorSpace] !== undefined) {
            const fn = $f70f7eb6404ce619$var$FN[sourceColorSpace][targetColorSpace];
            color.r = fn(color.r);
            color.g = fn(color.g);
            color.b = fn(color.b);
            return color;
        }
        throw new Error('Unsupported color space conversion.');
    },
    fromWorkingColorSpace: function(color, targetColorSpace) {
        return this.convert(color, this.workingColorSpace, targetColorSpace);
    },
    toWorkingColorSpace: function(color, sourceColorSpace) {
        return this.convert(color, sourceColorSpace, this.workingColorSpace);
    }
};
const $f70f7eb6404ce619$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $f70f7eb6404ce619$var$_rgb = {
    r: 0,
    g: 0,
    b: 0
};
const $f70f7eb6404ce619$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $f70f7eb6404ce619$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $f70f7eb6404ce619$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function $f70f7eb6404ce619$var$toComponents(source, target) {
    target.r = source.r;
    target.g = source.g;
    target.b = source.b;
    return target;
}
class $f70f7eb6404ce619$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === 'number') this.setHex(value);
        else if (typeof value === 'string') this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace1 = $f70f7eb6404ce619$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setRGB(r, g, b, colorSpace1 = $f70f7eb6404ce619$export$42429b3acfb233a4) {
        this.r = r;
        this.g = g;
        this.b = b;
        $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setHSL(h, s, l, colorSpace1 = $f70f7eb6404ce619$export$42429b3acfb233a4) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $f70f7eb6404ce619$var$euclideanModulo(h, 1);
        s = $f70f7eb6404ce619$var$clamp(s, 0, 1);
        l = $f70f7eb6404ce619$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $f70f7eb6404ce619$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $f70f7eb6404ce619$var$hue2rgb(q, p, h);
            this.b = $f70f7eb6404ce619$var$hue2rgb(q, p, h - 1 / 3);
        }
        $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
        return this;
    }
    setStyle(style, colorSpace1 = $f70f7eb6404ce619$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseFloat(color[2]) / 100;
                        const l = parseFloat(color[3]) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l, colorSpace1);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                $f70f7eb6404ce619$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace1);
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style, colorSpace1);
        return this;
    }
    setColorName(style, colorSpace1 = $f70f7eb6404ce619$export$561f394b24edfcaa) {
        // color keywords
        const hex = $f70f7eb6404ce619$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace1);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $f70f7eb6404ce619$var$SRGBToLinear(color.r);
        this.g = $f70f7eb6404ce619$var$SRGBToLinear(color.g);
        this.b = $f70f7eb6404ce619$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $f70f7eb6404ce619$var$LinearToSRGB(color.r);
        this.g = $f70f7eb6404ce619$var$LinearToSRGB(color.g);
        this.b = $f70f7eb6404ce619$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace1 = $f70f7eb6404ce619$export$561f394b24edfcaa) {
        $f70f7eb6404ce619$export$5e6fd513f44698c.fromWorkingColorSpace($f70f7eb6404ce619$var$toComponents(this, $f70f7eb6404ce619$var$_rgb), colorSpace1);
        return $f70f7eb6404ce619$var$clamp($f70f7eb6404ce619$var$_rgb.r * 255, 0, 255) << 16 ^ $f70f7eb6404ce619$var$clamp($f70f7eb6404ce619$var$_rgb.g * 255, 0, 255) << 8 ^ $f70f7eb6404ce619$var$clamp($f70f7eb6404ce619$var$_rgb.b * 255, 0, 255) << 0;
    }
    getHexString(colorSpace1 = $f70f7eb6404ce619$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace1).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace1 = $f70f7eb6404ce619$export$42429b3acfb233a4) {
        // h,s,l ranges are in 0.0 - 1.0
        $f70f7eb6404ce619$export$5e6fd513f44698c.fromWorkingColorSpace($f70f7eb6404ce619$var$toComponents(this, $f70f7eb6404ce619$var$_rgb), colorSpace1);
        const r = $f70f7eb6404ce619$var$_rgb.r, g = $f70f7eb6404ce619$var$_rgb.g, b = $f70f7eb6404ce619$var$_rgb.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace1 = $f70f7eb6404ce619$export$42429b3acfb233a4) {
        $f70f7eb6404ce619$export$5e6fd513f44698c.fromWorkingColorSpace($f70f7eb6404ce619$var$toComponents(this, $f70f7eb6404ce619$var$_rgb), colorSpace1);
        target.r = $f70f7eb6404ce619$var$_rgb.r;
        target.g = $f70f7eb6404ce619$var$_rgb.g;
        target.b = $f70f7eb6404ce619$var$_rgb.b;
        return target;
    }
    getStyle(colorSpace1 = $f70f7eb6404ce619$export$561f394b24edfcaa) {
        $f70f7eb6404ce619$export$5e6fd513f44698c.fromWorkingColorSpace($f70f7eb6404ce619$var$toComponents(this, $f70f7eb6404ce619$var$_rgb), colorSpace1);
        if (colorSpace1 !== $f70f7eb6404ce619$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace1} ${$f70f7eb6404ce619$var$_rgb.r} ${$f70f7eb6404ce619$var$_rgb.g} ${$f70f7eb6404ce619$var$_rgb.b})`;
        return `rgb(${$f70f7eb6404ce619$var$_rgb.r * 255 | 0},${$f70f7eb6404ce619$var$_rgb.g * 255 | 0},${$f70f7eb6404ce619$var$_rgb.b * 255 | 0})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($f70f7eb6404ce619$var$_hslA);
        $f70f7eb6404ce619$var$_hslA.h += h;
        $f70f7eb6404ce619$var$_hslA.s += s;
        $f70f7eb6404ce619$var$_hslA.l += l;
        this.setHSL($f70f7eb6404ce619$var$_hslA.h, $f70f7eb6404ce619$var$_hslA.s, $f70f7eb6404ce619$var$_hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($f70f7eb6404ce619$var$_hslA);
        color.getHSL($f70f7eb6404ce619$var$_hslB);
        const h = $f70f7eb6404ce619$var$lerp($f70f7eb6404ce619$var$_hslA.h, $f70f7eb6404ce619$var$_hslB.h, alpha);
        const s = $f70f7eb6404ce619$var$lerp($f70f7eb6404ce619$var$_hslA.s, $f70f7eb6404ce619$var$_hslB.s, alpha);
        const l = $f70f7eb6404ce619$var$lerp($f70f7eb6404ce619$var$_hslA.l, $f70f7eb6404ce619$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
$f70f7eb6404ce619$export$892596cec99bc70e.NAMES = $f70f7eb6404ce619$var$_colorKeywords;
let $f70f7eb6404ce619$var$_canvas;
class $f70f7eb6404ce619$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($f70f7eb6404ce619$var$_canvas === undefined) $f70f7eb6404ce619$var$_canvas = $f70f7eb6404ce619$var$createElementNS('canvas');
            $f70f7eb6404ce619$var$_canvas.width = image.width;
            $f70f7eb6404ce619$var$_canvas.height = image.height;
            const context = $f70f7eb6404ce619$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $f70f7eb6404ce619$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $f70f7eb6404ce619$var$createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $f70f7eb6404ce619$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($f70f7eb6404ce619$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $f70f7eb6404ce619$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
class $f70f7eb6404ce619$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.data = data;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($f70f7eb6404ce619$var$serializeImage(data[i].image));
                else url.push($f70f7eb6404ce619$var$serializeImage(data[i]));
            } else // texture
            url = $f70f7eb6404ce619$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $f70f7eb6404ce619$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $f70f7eb6404ce619$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $f70f7eb6404ce619$var$textureId = 0;
class $f70f7eb6404ce619$export$5431306cf43de24a extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(image = $f70f7eb6404ce619$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $f70f7eb6404ce619$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $f70f7eb6404ce619$export$9d9334239a5a5e06, wrapT = $f70f7eb6404ce619$export$9d9334239a5a5e06, magFilter = $f70f7eb6404ce619$export$8a72f490b25c56c8, minFilter = $f70f7eb6404ce619$export$5d8599b6a933fb1b, format = $f70f7eb6404ce619$export$3f8bb04b555a363c, type = $f70f7eb6404ce619$export$2e8ce08d3f6f5e10, anisotropy = 1, encoding = $f70f7eb6404ce619$export$7207336e4151a112){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $f70f7eb6404ce619$var$textureId++
        });
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.name = '';
        this.source = new $f70f7eb6404ce619$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $f70f7eb6404ce619$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.center = new $f70f7eb6404ce619$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $f70f7eb6404ce619$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
        //
        // Also changing the encoding after already used by a Material will not automatically make the Material
        // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
        this.encoding = encoding;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (JSON.stringify(this.userData) !== '{}') output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $f70f7eb6404ce619$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $f70f7eb6404ce619$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $f70f7eb6404ce619$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $f70f7eb6404ce619$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $f70f7eb6404ce619$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $f70f7eb6404ce619$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $f70f7eb6404ce619$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
}
$f70f7eb6404ce619$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$f70f7eb6404ce619$export$5431306cf43de24a.DEFAULT_MAPPING = $f70f7eb6404ce619$export$1beec6768cbb3d2d;
class $f70f7eb6404ce619$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $f70f7eb6404ce619$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $f70f7eb6404ce619$export$3c052beb2e51e23f extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(width, height, options = {}){
        super();
        this.isWebGLRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        this.texture = new $f70f7eb6404ce619$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.isRenderTargetTexture = true;
        this.texture.flipY = false;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $f70f7eb6404ce619$export$8a72f490b25c56c8;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
        this.samples = options.samples !== undefined ? options.samples : 0;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.texture.image.depth = depth;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.texture.isRenderTargetTexture = true;
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $f70f7eb6404ce619$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $f70f7eb6404ce619$export$dfac6c8e811406a3 extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.minFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.wrapR = $f70f7eb6404ce619$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $f70f7eb6404ce619$export$c77a02c11ed180c7 extends $f70f7eb6404ce619$export$3c052beb2e51e23f {
    constructor(width, height, depth){
        super(width, height);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $f70f7eb6404ce619$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $f70f7eb6404ce619$export$d7a3086320f856db extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in DataTexture3D directly.
        //
        //	const texture = new THREE.DataTexture3D( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.minFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.wrapR = $f70f7eb6404ce619$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $f70f7eb6404ce619$export$7ee06591009639df extends $f70f7eb6404ce619$export$3c052beb2e51e23f {
    constructor(width, height, depth){
        super(width, height);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $f70f7eb6404ce619$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $f70f7eb6404ce619$export$bd934554fb721730 extends $f70f7eb6404ce619$export$3c052beb2e51e23f {
    constructor(width, height, count, options = {}){
        super(width, height, options);
        this.isWebGLMultipleRenderTargets = true;
        const texture = this.texture;
        this.texture = [];
        for(let i = 0; i < count; i++){
            this.texture[i] = texture.clone();
            this.texture[i].isRenderTargetTexture = true;
        }
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.texture.length; i < il; i++){
                this.texture[i].image.width = width;
                this.texture[i].image.height = height;
                this.texture[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
        return this;
    }
    copy(source) {
        this.dispose();
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.viewport.set(0, 0, this.width, this.height);
        this.scissor.set(0, 0, this.width, this.height);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.texture.length = 0;
        for(let i = 0, il = source.texture.length; i < il; i++){
            this.texture[i] = source.texture[i].clone();
            this.texture[i].isRenderTargetTexture = true;
        }
        return this;
    }
}
class $f70f7eb6404ce619$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($f70f7eb6404ce619$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // Derived from http://planning.cs.uiuc.edu/node198.html
        // Note, this source uses w, x, y, z ordering,
        // so we swap the order below.
        const u1 = Math.random();
        const sqrt1u1 = Math.sqrt(1 - u1);
        const sqrtu1 = Math.sqrt(u1);
        const u2 = 2 * Math.PI * Math.random();
        const u3 = 2 * Math.PI * Math.random();
        return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $f70f7eb6404ce619$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $f70f7eb6404ce619$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($f70f7eb6404ce619$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($f70f7eb6404ce619$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $f70f7eb6404ce619$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($f70f7eb6404ce619$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($f70f7eb6404ce619$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($f70f7eb6404ce619$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
        const u = (Math.random() - 0.5) * 2;
        const t = Math.random() * Math.PI * 2;
        const f = Math.sqrt(1 - u ** 2);
        this.x = f * Math.cos(t);
        this.y = f * Math.sin(t);
        this.z = u;
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $f70f7eb6404ce619$var$_vector$c = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_quaternion$4 = /*@__PURE__*/ new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
class $f70f7eb6404ce619$export$6f7d5a9418ab2aa3 {
    constructor(min = new $f70f7eb6404ce619$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $f70f7eb6404ce619$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $f70f7eb6404ce619$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count; i < l; i++){
                    $f70f7eb6404ce619$var$_vector$b.fromBufferAttribute(position, i).applyMatrix4(object.matrixWorld);
                    this.expandByPoint($f70f7eb6404ce619$var$_vector$b);
                }
            } else {
                if (geometry.boundingBox === null) geometry.computeBoundingBox();
                $f70f7eb6404ce619$var$_box$3.copy(geometry.boundingBox);
                $f70f7eb6404ce619$var$_box$3.applyMatrix4(object.matrixWorld);
                this.union($f70f7eb6404ce619$var$_box$3);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $f70f7eb6404ce619$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $f70f7eb6404ce619$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($f70f7eb6404ce619$var$_center);
        $f70f7eb6404ce619$var$_extents.subVectors(this.max, $f70f7eb6404ce619$var$_center);
        // translate triangle to aabb origin
        $f70f7eb6404ce619$var$_v0$2.subVectors(triangle.a, $f70f7eb6404ce619$var$_center);
        $f70f7eb6404ce619$var$_v1$7.subVectors(triangle.b, $f70f7eb6404ce619$var$_center);
        $f70f7eb6404ce619$var$_v2$3.subVectors(triangle.c, $f70f7eb6404ce619$var$_center);
        // compute edge vectors for triangle
        $f70f7eb6404ce619$var$_f0.subVectors($f70f7eb6404ce619$var$_v1$7, $f70f7eb6404ce619$var$_v0$2);
        $f70f7eb6404ce619$var$_f1.subVectors($f70f7eb6404ce619$var$_v2$3, $f70f7eb6404ce619$var$_v1$7);
        $f70f7eb6404ce619$var$_f2.subVectors($f70f7eb6404ce619$var$_v0$2, $f70f7eb6404ce619$var$_v2$3);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$f70f7eb6404ce619$var$_f0.z,
            $f70f7eb6404ce619$var$_f0.y,
            0,
            -$f70f7eb6404ce619$var$_f1.z,
            $f70f7eb6404ce619$var$_f1.y,
            0,
            -$f70f7eb6404ce619$var$_f2.z,
            $f70f7eb6404ce619$var$_f2.y,
            $f70f7eb6404ce619$var$_f0.z,
            0,
            -$f70f7eb6404ce619$var$_f0.x,
            $f70f7eb6404ce619$var$_f1.z,
            0,
            -$f70f7eb6404ce619$var$_f1.x,
            $f70f7eb6404ce619$var$_f2.z,
            0,
            -$f70f7eb6404ce619$var$_f2.x,
            -$f70f7eb6404ce619$var$_f0.y,
            $f70f7eb6404ce619$var$_f0.x,
            0,
            -$f70f7eb6404ce619$var$_f1.y,
            $f70f7eb6404ce619$var$_f1.x,
            0,
            -$f70f7eb6404ce619$var$_f2.y,
            $f70f7eb6404ce619$var$_f2.x,
            0
        ];
        if (!$f70f7eb6404ce619$var$satForAxes(axes, $f70f7eb6404ce619$var$_v0$2, $f70f7eb6404ce619$var$_v1$7, $f70f7eb6404ce619$var$_v2$3, $f70f7eb6404ce619$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$f70f7eb6404ce619$var$satForAxes(axes, $f70f7eb6404ce619$var$_v0$2, $f70f7eb6404ce619$var$_v1$7, $f70f7eb6404ce619$var$_v2$3, $f70f7eb6404ce619$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $f70f7eb6404ce619$var$_triangleNormal.crossVectors($f70f7eb6404ce619$var$_f0, $f70f7eb6404ce619$var$_f1);
        axes = [
            $f70f7eb6404ce619$var$_triangleNormal.x,
            $f70f7eb6404ce619$var$_triangleNormal.y,
            $f70f7eb6404ce619$var$_triangleNormal.z
        ];
        return $f70f7eb6404ce619$var$satForAxes(axes, $f70f7eb6404ce619$var$_v0$2, $f70f7eb6404ce619$var$_v1$7, $f70f7eb6404ce619$var$_v2$3, $f70f7eb6404ce619$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $f70f7eb6404ce619$var$_vector$b.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        this.getCenter(target.center);
        target.radius = this.getSize($f70f7eb6404ce619$var$_vector$b).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $f70f7eb6404ce619$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $f70f7eb6404ce619$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $f70f7eb6404ce619$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $f70f7eb6404ce619$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $f70f7eb6404ce619$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $f70f7eb6404ce619$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $f70f7eb6404ce619$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $f70f7eb6404ce619$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($f70f7eb6404ce619$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $f70f7eb6404ce619$var$_points = [
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699()
];
const $f70f7eb6404ce619$var$_vector$b = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_box$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $f70f7eb6404ce619$var$_v0$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v1$7 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v2$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
// triangle edge vectors
const $f70f7eb6404ce619$var$_f0 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_f1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_f2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_center = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_extents = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_triangleNormal = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_testAxis = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
function $f70f7eb6404ce619$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $f70f7eb6404ce619$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($f70f7eb6404ce619$var$_testAxis.x) + extents.y * Math.abs($f70f7eb6404ce619$var$_testAxis.y) + extents.z * Math.abs($f70f7eb6404ce619$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($f70f7eb6404ce619$var$_testAxis);
        const p1 = v1.dot($f70f7eb6404ce619$var$_testAxis);
        const p2 = v2.dot($f70f7eb6404ce619$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $f70f7eb6404ce619$var$_box$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$6f7d5a9418ab2aa3();
const $f70f7eb6404ce619$var$_v1$6 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_toFarthestPoint = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_toPoint = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$805e8b72413ccaba {
    constructor(center = new $f70f7eb6404ce619$export$64b5c384219d3699(), radius = -1){
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $f70f7eb6404ce619$var$_box$2.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
        $f70f7eb6404ce619$var$_toPoint.subVectors(point, this.center);
        const lengthSq = $f70f7eb6404ce619$var$_toPoint.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            const length = Math.sqrt(lengthSq);
            const missingRadiusHalf = (length - this.radius) * 0.5;
            // Nudge this sphere towards the target point. Add half the missing distance to radius,
            // and the other half to position. This gives a tighter enclosure, instead of if
            // the whole missing distance were just added to radius.
            this.center.add($f70f7eb6404ce619$var$_toPoint.multiplyScalar(missingRadiusHalf / length));
            this.radius += missingRadiusHalf;
        }
        return this;
    }
    union(sphere) {
        // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
        // To enclose another sphere into this sphere, we only need to enclose two points:
        // 1) Enclose the farthest point on the other sphere into this sphere.
        // 2) Enclose the opposite point of the farthest point into this sphere.
        if (this.center.equals(sphere.center) === true) $f70f7eb6404ce619$var$_toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
        else $f70f7eb6404ce619$var$_toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
        this.expandByPoint($f70f7eb6404ce619$var$_v1$6.copy(sphere.center).add($f70f7eb6404ce619$var$_toFarthestPoint));
        this.expandByPoint($f70f7eb6404ce619$var$_v1$6.copy(sphere.center).sub($f70f7eb6404ce619$var$_toFarthestPoint));
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $f70f7eb6404ce619$var$_vector$a = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_segCenter = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_segDir = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_diff = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_edge1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_edge2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_normal$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$a186db52eed6d40e {
    constructor(origin = new $f70f7eb6404ce619$export$64b5c384219d3699(), direction = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $f70f7eb6404ce619$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $f70f7eb6404ce619$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $f70f7eb6404ce619$var$_vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return $f70f7eb6404ce619$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $f70f7eb6404ce619$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $f70f7eb6404ce619$var$_segDir.copy(v1).sub(v0).normalize();
        $f70f7eb6404ce619$var$_diff.copy(this.origin).sub($f70f7eb6404ce619$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($f70f7eb6404ce619$var$_segDir);
        const b0 = $f70f7eb6404ce619$var$_diff.dot(this.direction);
        const b1 = -$f70f7eb6404ce619$var$_diff.dot($f70f7eb6404ce619$var$_segDir);
        const c = $f70f7eb6404ce619$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($f70f7eb6404ce619$var$_segDir).multiplyScalar(s1).add($f70f7eb6404ce619$var$_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $f70f7eb6404ce619$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $f70f7eb6404ce619$var$_vector$a.dot(this.direction);
        const d2 = $f70f7eb6404ce619$var$_vector$a.dot($f70f7eb6404ce619$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $f70f7eb6404ce619$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $f70f7eb6404ce619$var$_edge1.subVectors(b, a);
        $f70f7eb6404ce619$var$_edge2.subVectors(c, a);
        $f70f7eb6404ce619$var$_normal$1.crossVectors($f70f7eb6404ce619$var$_edge1, $f70f7eb6404ce619$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($f70f7eb6404ce619$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $f70f7eb6404ce619$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($f70f7eb6404ce619$var$_edge2.crossVectors($f70f7eb6404ce619$var$_diff, $f70f7eb6404ce619$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($f70f7eb6404ce619$var$_edge1.cross($f70f7eb6404ce619$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $f70f7eb6404ce619$var$_diff.dot($f70f7eb6404ce619$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $f70f7eb6404ce619$export$2ae72fc923e5eb5 {
    constructor(){
        $f70f7eb6404ce619$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $f70f7eb6404ce619$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $f70f7eb6404ce619$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $f70f7eb6404ce619$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $f70f7eb6404ce619$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($f70f7eb6404ce619$var$_zero, q, $f70f7eb6404ce619$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $f70f7eb6404ce619$var$_z.subVectors(eye, target);
        if ($f70f7eb6404ce619$var$_z.lengthSq() === 0) // eye and target are in the same position
        $f70f7eb6404ce619$var$_z.z = 1;
        $f70f7eb6404ce619$var$_z.normalize();
        $f70f7eb6404ce619$var$_x.crossVectors(up, $f70f7eb6404ce619$var$_z);
        if ($f70f7eb6404ce619$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $f70f7eb6404ce619$var$_z.x += 0.0001;
            else $f70f7eb6404ce619$var$_z.z += 0.0001;
            $f70f7eb6404ce619$var$_z.normalize();
            $f70f7eb6404ce619$var$_x.crossVectors(up, $f70f7eb6404ce619$var$_z);
        }
        $f70f7eb6404ce619$var$_x.normalize();
        $f70f7eb6404ce619$var$_y.crossVectors($f70f7eb6404ce619$var$_z, $f70f7eb6404ce619$var$_x);
        te[0] = $f70f7eb6404ce619$var$_x.x;
        te[4] = $f70f7eb6404ce619$var$_y.x;
        te[8] = $f70f7eb6404ce619$var$_z.x;
        te[1] = $f70f7eb6404ce619$var$_x.y;
        te[5] = $f70f7eb6404ce619$var$_y.y;
        te[9] = $f70f7eb6404ce619$var$_z.y;
        te[2] = $f70f7eb6404ce619$var$_x.z;
        te[6] = $f70f7eb6404ce619$var$_y.z;
        te[10] = $f70f7eb6404ce619$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $f70f7eb6404ce619$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $f70f7eb6404ce619$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $f70f7eb6404ce619$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $f70f7eb6404ce619$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $f70f7eb6404ce619$var$_m1$2.elements[0] *= invSX;
        $f70f7eb6404ce619$var$_m1$2.elements[1] *= invSX;
        $f70f7eb6404ce619$var$_m1$2.elements[2] *= invSX;
        $f70f7eb6404ce619$var$_m1$2.elements[4] *= invSY;
        $f70f7eb6404ce619$var$_m1$2.elements[5] *= invSY;
        $f70f7eb6404ce619$var$_m1$2.elements[6] *= invSY;
        $f70f7eb6404ce619$var$_m1$2.elements[8] *= invSZ;
        $f70f7eb6404ce619$var$_m1$2.elements[9] *= invSZ;
        $f70f7eb6404ce619$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($f70f7eb6404ce619$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $f70f7eb6404ce619$var$_v1$5 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_m1$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_zero = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 0);
const $f70f7eb6404ce619$var$_one = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(1, 1, 1);
const $f70f7eb6404ce619$var$_x = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_y = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_z = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_matrix$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_quaternion$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
class $f70f7eb6404ce619$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $f70f7eb6404ce619$export$d93cc409a0768c5f.DefaultOrder){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($f70f7eb6404ce619$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$f70f7eb6404ce619$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($f70f7eb6404ce619$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$f70f7eb6404ce619$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($f70f7eb6404ce619$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$f70f7eb6404ce619$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $f70f7eb6404ce619$var$_matrix$1.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($f70f7eb6404ce619$var$_matrix$1, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $f70f7eb6404ce619$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($f70f7eb6404ce619$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
    // @deprecated since r138, 02cf0df1cb4575d5842fef9c85bb5a89fe020d53
    toVector3() {
        console.error('THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead');
    }
}
$f70f7eb6404ce619$export$d93cc409a0768c5f.DefaultOrder = 'XYZ';
$f70f7eb6404ce619$export$d93cc409a0768c5f.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
class $f70f7eb6404ce619$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $f70f7eb6404ce619$var$_object3DId = 0;
const $f70f7eb6404ce619$var$_v1$4 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_q1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
const $f70f7eb6404ce619$var$_m1$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_target = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_position$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_scale$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_quaternion$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
const $f70f7eb6404ce619$var$_xAxis = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(1, 0, 0);
const $f70f7eb6404ce619$var$_yAxis = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
const $f70f7eb6404ce619$var$_zAxis = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 1);
const $f70f7eb6404ce619$var$_addedEvent = {
    type: 'added'
};
const $f70f7eb6404ce619$var$_removedEvent = {
    type: 'removed'
};
class $f70f7eb6404ce619$export$e4dd07dff30cc924 extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $f70f7eb6404ce619$var$_object3DId++
        });
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultUp.clone();
        const position = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const rotation = new $f70f7eb6404ce619$export$d93cc409a0768c5f();
        const quaternion = new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
        const scale = new $f70f7eb6404ce619$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $f70f7eb6404ce619$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $f70f7eb6404ce619$export$8ff26dafa08918()
            }
        });
        this.matrix = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.matrixWorld = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate;
        this.matrixWorldNeedsUpdate = false;
        this.matrixWorldAutoUpdate = $f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultMatrixWorldAutoUpdate; // checked by the renderer
        this.layers = new $f70f7eb6404ce619$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $f70f7eb6404ce619$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($f70f7eb6404ce619$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $f70f7eb6404ce619$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($f70f7eb6404ce619$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($f70f7eb6404ce619$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($f70f7eb6404ce619$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($f70f7eb6404ce619$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $f70f7eb6404ce619$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($f70f7eb6404ce619$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($f70f7eb6404ce619$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($f70f7eb6404ce619$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($f70f7eb6404ce619$var$_zAxis, distance);
    }
    localToWorld(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        return vector.applyMatrix4($f70f7eb6404ce619$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $f70f7eb6404ce619$var$_target.copy(x);
        else $f70f7eb6404ce619$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $f70f7eb6404ce619$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $f70f7eb6404ce619$var$_m1$1.lookAt($f70f7eb6404ce619$var$_position$3, $f70f7eb6404ce619$var$_target, this.up);
        else $f70f7eb6404ce619$var$_m1$1.lookAt($f70f7eb6404ce619$var$_target, $f70f7eb6404ce619$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($f70f7eb6404ce619$var$_m1$1);
        if (parent) {
            $f70f7eb6404ce619$var$_m1$1.extractRotation(parent.matrixWorld);
            $f70f7eb6404ce619$var$_q1.setFromRotationMatrix($f70f7eb6404ce619$var$_m1$1);
            this.quaternion.premultiply($f70f7eb6404ce619$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($f70f7eb6404ce619$var$_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($f70f7eb6404ce619$var$_removedEvent);
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent($f70f7eb6404ce619$var$_removedEvent);
        }
        this.children.length = 0;
        return this;
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $f70f7eb6404ce619$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $f70f7eb6404ce619$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($f70f7eb6404ce619$var$_m1$1);
        this.add(object);
        object.updateWorldMatrix(false, true);
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($f70f7eb6404ce619$var$_position$3, target, $f70f7eb6404ce619$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($f70f7eb6404ce619$var$_position$3, $f70f7eb6404ce619$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            if (child.matrixWorldAutoUpdate === true || force === true) child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null && parent.matrixWorldAutoUpdate === true) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                if (child.matrixWorldAutoUpdate === true) child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.5,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultUp = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
$f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultMatrixAutoUpdate = true;
$f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultMatrixWorldAutoUpdate = true;
const $f70f7eb6404ce619$var$_v0$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v1$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v2$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v3$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vab = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vac = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vbc = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vap = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vbp = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vcp = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$5a465592bfe74b48 {
    constructor(a = new $f70f7eb6404ce619$export$64b5c384219d3699(), b = new $f70f7eb6404ce619$export$64b5c384219d3699(), c = new $f70f7eb6404ce619$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $f70f7eb6404ce619$var$_v0$1.subVectors(a, b);
        target.cross($f70f7eb6404ce619$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $f70f7eb6404ce619$var$_v0$1.subVectors(c, a);
        $f70f7eb6404ce619$var$_v1$3.subVectors(b, a);
        $f70f7eb6404ce619$var$_v2$2.subVectors(point, a);
        const dot00 = $f70f7eb6404ce619$var$_v0$1.dot($f70f7eb6404ce619$var$_v0$1);
        const dot01 = $f70f7eb6404ce619$var$_v0$1.dot($f70f7eb6404ce619$var$_v1$3);
        const dot02 = $f70f7eb6404ce619$var$_v0$1.dot($f70f7eb6404ce619$var$_v2$2);
        const dot11 = $f70f7eb6404ce619$var$_v1$3.dot($f70f7eb6404ce619$var$_v1$3);
        const dot12 = $f70f7eb6404ce619$var$_v1$3.dot($f70f7eb6404ce619$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, $f70f7eb6404ce619$var$_v3$1);
        return $f70f7eb6404ce619$var$_v3$1.x >= 0 && $f70f7eb6404ce619$var$_v3$1.y >= 0 && $f70f7eb6404ce619$var$_v3$1.x + $f70f7eb6404ce619$var$_v3$1.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, $f70f7eb6404ce619$var$_v3$1);
        target.set(0, 0);
        target.addScaledVector(uv1, $f70f7eb6404ce619$var$_v3$1.x);
        target.addScaledVector(uv2, $f70f7eb6404ce619$var$_v3$1.y);
        target.addScaledVector(uv3, $f70f7eb6404ce619$var$_v3$1.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $f70f7eb6404ce619$var$_v0$1.subVectors(c, b);
        $f70f7eb6404ce619$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $f70f7eb6404ce619$var$_v0$1.cross($f70f7eb6404ce619$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $f70f7eb6404ce619$var$_v0$1.subVectors(this.c, this.b);
        $f70f7eb6404ce619$var$_v1$3.subVectors(this.a, this.b);
        return $f70f7eb6404ce619$var$_v0$1.cross($f70f7eb6404ce619$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $f70f7eb6404ce619$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $f70f7eb6404ce619$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return $f70f7eb6404ce619$export$5a465592bfe74b48.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return $f70f7eb6404ce619$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $f70f7eb6404ce619$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $f70f7eb6404ce619$var$_vab.subVectors(b, a);
        $f70f7eb6404ce619$var$_vac.subVectors(c, a);
        $f70f7eb6404ce619$var$_vap.subVectors(p, a);
        const d1 = $f70f7eb6404ce619$var$_vab.dot($f70f7eb6404ce619$var$_vap);
        const d2 = $f70f7eb6404ce619$var$_vac.dot($f70f7eb6404ce619$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $f70f7eb6404ce619$var$_vbp.subVectors(p, b);
        const d3 = $f70f7eb6404ce619$var$_vab.dot($f70f7eb6404ce619$var$_vbp);
        const d4 = $f70f7eb6404ce619$var$_vac.dot($f70f7eb6404ce619$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($f70f7eb6404ce619$var$_vab, v);
        }
        $f70f7eb6404ce619$var$_vcp.subVectors(p, c);
        const d5 = $f70f7eb6404ce619$var$_vab.dot($f70f7eb6404ce619$var$_vcp);
        const d6 = $f70f7eb6404ce619$var$_vac.dot($f70f7eb6404ce619$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($f70f7eb6404ce619$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $f70f7eb6404ce619$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($f70f7eb6404ce619$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($f70f7eb6404ce619$var$_vab, v).addScaledVector($f70f7eb6404ce619$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
let $f70f7eb6404ce619$var$materialId = 0;
class $f70f7eb6404ce619$export$a2d8b23205c25948 extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $f70f7eb6404ce619$var$materialId++
        });
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $f70f7eb6404ce619$export$5b29a26d96ee6af0;
        this.side = $f70f7eb6404ce619$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.blendSrc = $f70f7eb6404ce619$export$d5773124e86cf28c;
        this.blendDst = $f70f7eb6404ce619$export$11d468cc7f19e971;
        this.blendEquation = $f70f7eb6404ce619$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.depthFunc = $f70f7eb6404ce619$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $f70f7eb6404ce619$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $f70f7eb6404ce619$export$9f542ae4b5baca34;
        this.stencilZFail = $f70f7eb6404ce619$export$9f542ae4b5baca34;
        this.stencilZPass = $f70f7eb6404ce619$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $f70f7eb6404ce619$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $f70f7eb6404ce619$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.colorWrite = this.colorWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
class $f70f7eb6404ce619$export$55cbcc9b622fe1f5 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $f70f7eb6404ce619$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
const $f70f7eb6404ce619$var$_vector$9 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vector2$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
class $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized === true;
        this.usage = $f70f7eb6404ce619$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector2$1.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $f70f7eb6404ce619$var$_vector2$1.x, $f70f7eb6404ce619$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$9.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$9.x, $f70f7eb6404ce619$var$_vector$9.y, $f70f7eb6404ce619$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$9.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$9.x, $f70f7eb6404ce619$var$_vector$9.y, $f70f7eb6404ce619$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$9.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$9.x, $f70f7eb6404ce619$var$_vector$9.y, $f70f7eb6404ce619$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$9.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$9.x, $f70f7eb6404ce619$var$_vector$9.y, $f70f7eb6404ce619$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $f70f7eb6404ce619$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $f70f7eb6404ce619$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $f70f7eb6404ce619$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $f70f7eb6404ce619$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $f70f7eb6404ce619$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $f70f7eb6404ce619$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $f70f7eb6404ce619$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $f70f7eb6404ce619$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $f70f7eb6404ce619$var$normalize(x, this.array);
            y = $f70f7eb6404ce619$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $f70f7eb6404ce619$var$normalize(x, this.array);
            y = $f70f7eb6404ce619$var$normalize(y, this.array);
            z = $f70f7eb6404ce619$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $f70f7eb6404ce619$var$normalize(x, this.array);
            y = $f70f7eb6404ce619$var$normalize(y, this.array);
            z = $f70f7eb6404ce619$var$normalize(z, this.array);
            w = $f70f7eb6404ce619$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $f70f7eb6404ce619$export$763e8360f4d7f77d) data.usage = this.usage;
        if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
        return data;
    }
    // @deprecated
    copyColorsArray() {
        console.error('THREE.BufferAttribute: copyColorsArray() was removed in r144.');
    }
    copyVector2sArray() {
        console.error('THREE.BufferAttribute: copyVector2sArray() was removed in r144.');
    }
    copyVector3sArray() {
        console.error('THREE.BufferAttribute: copyVector3sArray() was removed in r144.');
    }
    copyVector4sArray() {
        console.error('THREE.BufferAttribute: copyVector4sArray() was removed in r144.');
    }
}
//
class $f70f7eb6404ce619$export$f9ff2d6a20248cbf extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$cacc90cf35d11cdd extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$baaa85a1a812c157 extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$2b755a102ccdcefe extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$640a853f68025f2e extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$46b369aed2968a0a extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$7eb8c9fa25cd5bd6 extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$dbd3698c64958d69 extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
}
class $f70f7eb6404ce619$export$cbe7a62641830ebd extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
class $f70f7eb6404ce619$export$9e0ade74842adbb8 extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float64Array(array), itemSize, normalized);
    }
}
let $f70f7eb6404ce619$var$_id$1 = 0;
const $f70f7eb6404ce619$var$_m1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_obj = /*@__PURE__*/ new $f70f7eb6404ce619$export$e4dd07dff30cc924();
const $f70f7eb6404ce619$var$_offset = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_box$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$6f7d5a9418ab2aa3();
const $f70f7eb6404ce619$var$_boxMorphTargets = /*@__PURE__*/ new $f70f7eb6404ce619$export$6f7d5a9418ab2aa3();
const $f70f7eb6404ce619$var$_vector$8 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$b7be63a67df8959 extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $f70f7eb6404ce619$var$_id$1++
        });
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($f70f7eb6404ce619$var$arrayNeedsUint32(index) ? $f70f7eb6404ce619$export$7eb8c9fa25cd5bd6 : $f70f7eb6404ce619$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $f70f7eb6404ce619$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $f70f7eb6404ce619$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($f70f7eb6404ce619$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $f70f7eb6404ce619$var$_m1.makeRotationX(angle);
        this.applyMatrix4($f70f7eb6404ce619$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $f70f7eb6404ce619$var$_m1.makeRotationY(angle);
        this.applyMatrix4($f70f7eb6404ce619$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $f70f7eb6404ce619$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($f70f7eb6404ce619$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $f70f7eb6404ce619$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($f70f7eb6404ce619$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $f70f7eb6404ce619$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($f70f7eb6404ce619$var$_m1);
        return this;
    }
    lookAt(vector) {
        $f70f7eb6404ce619$var$_obj.lookAt(vector);
        $f70f7eb6404ce619$var$_obj.updateMatrix();
        this.applyMatrix4($f70f7eb6404ce619$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($f70f7eb6404ce619$var$_offset).negate();
        this.translate($f70f7eb6404ce619$var$_offset.x, $f70f7eb6404ce619$var$_offset.y, $f70f7eb6404ce619$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(position, 3));
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $f70f7eb6404ce619$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new $f70f7eb6404ce619$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $f70f7eb6404ce619$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $f70f7eb6404ce619$var$_box$1.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $f70f7eb6404ce619$var$_vector$8.addVectors(this.boundingBox.min, $f70f7eb6404ce619$var$_box$1.min);
                    this.boundingBox.expandByPoint($f70f7eb6404ce619$var$_vector$8);
                    $f70f7eb6404ce619$var$_vector$8.addVectors(this.boundingBox.max, $f70f7eb6404ce619$var$_box$1.max);
                    this.boundingBox.expandByPoint($f70f7eb6404ce619$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($f70f7eb6404ce619$var$_box$1.min);
                    this.boundingBox.expandByPoint($f70f7eb6404ce619$var$_box$1.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $f70f7eb6404ce619$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new $f70f7eb6404ce619$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $f70f7eb6404ce619$var$_box$1.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $f70f7eb6404ce619$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $f70f7eb6404ce619$var$_vector$8.addVectors($f70f7eb6404ce619$var$_box$1.min, $f70f7eb6404ce619$var$_boxMorphTargets.min);
                    $f70f7eb6404ce619$var$_box$1.expandByPoint($f70f7eb6404ce619$var$_vector$8);
                    $f70f7eb6404ce619$var$_vector$8.addVectors($f70f7eb6404ce619$var$_box$1.max, $f70f7eb6404ce619$var$_boxMorphTargets.max);
                    $f70f7eb6404ce619$var$_box$1.expandByPoint($f70f7eb6404ce619$var$_vector$8);
                } else {
                    $f70f7eb6404ce619$var$_box$1.expandByPoint($f70f7eb6404ce619$var$_boxMorphTargets.min);
                    $f70f7eb6404ce619$var$_box$1.expandByPoint($f70f7eb6404ce619$var$_boxMorphTargets.max);
                }
            }
            $f70f7eb6404ce619$var$_box$1.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $f70f7eb6404ce619$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($f70f7eb6404ce619$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $f70f7eb6404ce619$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $f70f7eb6404ce619$var$_offset.fromBufferAttribute(position, j);
                        $f70f7eb6404ce619$var$_vector$8.add($f70f7eb6404ce619$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($f70f7eb6404ce619$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $f70f7eb6404ce619$export$8dea267bd6bde117(new Float32Array(4 * nVertices), 4));
        const tangents = this.getAttribute('tangent').array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new $f70f7eb6404ce619$export$64b5c384219d3699();
            tan2[i] = new $f70f7eb6404ce619$export$64b5c384219d3699();
        }
        const vA = new $f70f7eb6404ce619$export$64b5c384219d3699(), vB = new $f70f7eb6404ce619$export$64b5c384219d3699(), vC = new $f70f7eb6404ce619$export$64b5c384219d3699(), uvA = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), uvB = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), uvC = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), sdir = new $f70f7eb6404ce619$export$64b5c384219d3699(), tdir = new $f70f7eb6404ce619$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new $f70f7eb6404ce619$export$64b5c384219d3699(), tmp2 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const n = new $f70f7eb6404ce619$export$64b5c384219d3699(), n2 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $f70f7eb6404ce619$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $f70f7eb6404ce619$export$64b5c384219d3699(), pB = new $f70f7eb6404ce619$export$64b5c384219d3699(), pC = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const nA = new $f70f7eb6404ce619$export$64b5c384219d3699(), nB = new $f70f7eb6404ce619$export$64b5c384219d3699(), nC = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const cb = new $f70f7eb6404ce619$export$64b5c384219d3699(), ab = new $f70f7eb6404ce619$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    // @deprecated since r144
    merge() {
        console.error('THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead.');
        return this;
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $f70f7eb6404ce619$var$_vector$8.fromBufferAttribute(normals, i);
            $f70f7eb6404ce619$var$_vector$8.normalize();
            normals.setXYZ(i, $f70f7eb6404ce619$var$_vector$8.x, $f70f7eb6404ce619$var$_vector$8.y, $f70f7eb6404ce619$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $f70f7eb6404ce619$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $f70f7eb6404ce619$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        // geometry generator parameters
        if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $f70f7eb6404ce619$var$_inverseMatrix$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_ray$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$a186db52eed6d40e();
const $f70f7eb6404ce619$var$_sphere$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$805e8b72413ccaba();
const $f70f7eb6404ce619$var$_vA$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vB$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vC$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_tempA = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_tempB = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_tempC = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_morphA = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_morphB = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_morphC = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_uvA$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_uvB$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_uvC$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_intersectionPoint = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_intersectionPointWorld = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$e176487c05830cc5 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(geometry = new $f70f7eb6404ce619$export$b7be63a67df8959(), material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $f70f7eb6404ce619$var$_sphere$3.copy(geometry.boundingSphere);
        $f70f7eb6404ce619$var$_sphere$3.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($f70f7eb6404ce619$var$_sphere$3) === false) return;
        //
        $f70f7eb6404ce619$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $f70f7eb6404ce619$var$_ray$2.copy(raycaster.ray).applyMatrix4($f70f7eb6404ce619$var$_inverseMatrix$2);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if ($f70f7eb6404ce619$var$_ray$2.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        const uv = geometry.attributes.uv;
        const uv2 = geometry.attributes.uv2;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $f70f7eb6404ce619$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $f70f7eb6404ce619$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $f70f7eb6404ce619$var$checkBufferGeometryIntersection(this, material, raycaster, $f70f7eb6404ce619$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $f70f7eb6404ce619$var$checkBufferGeometryIntersection(this, groupMaterial, raycaster, $f70f7eb6404ce619$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $f70f7eb6404ce619$var$checkBufferGeometryIntersection(this, material, raycaster, $f70f7eb6404ce619$var$_ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $f70f7eb6404ce619$var$checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $f70f7eb6404ce619$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== $f70f7eb6404ce619$export$3b296b6f144d5b03, point);
    if (intersect === null) return null;
    $f70f7eb6404ce619$var$_intersectionPointWorld.copy(point);
    $f70f7eb6404ce619$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($f70f7eb6404ce619$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $f70f7eb6404ce619$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $f70f7eb6404ce619$var$checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    $f70f7eb6404ce619$var$_vA$1.fromBufferAttribute(position, a);
    $f70f7eb6404ce619$var$_vB$1.fromBufferAttribute(position, b);
    $f70f7eb6404ce619$var$_vC$1.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (morphPosition && morphInfluences) {
        $f70f7eb6404ce619$var$_morphA.set(0, 0, 0);
        $f70f7eb6404ce619$var$_morphB.set(0, 0, 0);
        $f70f7eb6404ce619$var$_morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            $f70f7eb6404ce619$var$_tempA.fromBufferAttribute(morphAttribute, a);
            $f70f7eb6404ce619$var$_tempB.fromBufferAttribute(morphAttribute, b);
            $f70f7eb6404ce619$var$_tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                $f70f7eb6404ce619$var$_morphA.addScaledVector($f70f7eb6404ce619$var$_tempA, influence);
                $f70f7eb6404ce619$var$_morphB.addScaledVector($f70f7eb6404ce619$var$_tempB, influence);
                $f70f7eb6404ce619$var$_morphC.addScaledVector($f70f7eb6404ce619$var$_tempC, influence);
            } else {
                $f70f7eb6404ce619$var$_morphA.addScaledVector($f70f7eb6404ce619$var$_tempA.sub($f70f7eb6404ce619$var$_vA$1), influence);
                $f70f7eb6404ce619$var$_morphB.addScaledVector($f70f7eb6404ce619$var$_tempB.sub($f70f7eb6404ce619$var$_vB$1), influence);
                $f70f7eb6404ce619$var$_morphC.addScaledVector($f70f7eb6404ce619$var$_tempC.sub($f70f7eb6404ce619$var$_vC$1), influence);
            }
        }
        $f70f7eb6404ce619$var$_vA$1.add($f70f7eb6404ce619$var$_morphA);
        $f70f7eb6404ce619$var$_vB$1.add($f70f7eb6404ce619$var$_morphB);
        $f70f7eb6404ce619$var$_vC$1.add($f70f7eb6404ce619$var$_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, $f70f7eb6404ce619$var$_vA$1);
        object.boneTransform(b, $f70f7eb6404ce619$var$_vB$1);
        object.boneTransform(c, $f70f7eb6404ce619$var$_vC$1);
    }
    const intersection = $f70f7eb6404ce619$var$checkIntersection(object, material, raycaster, ray, $f70f7eb6404ce619$var$_vA$1, $f70f7eb6404ce619$var$_vB$1, $f70f7eb6404ce619$var$_vC$1, $f70f7eb6404ce619$var$_intersectionPoint);
    if (intersection) {
        if (uv) {
            $f70f7eb6404ce619$var$_uvA$1.fromBufferAttribute(uv, a);
            $f70f7eb6404ce619$var$_uvB$1.fromBufferAttribute(uv, b);
            $f70f7eb6404ce619$var$_uvC$1.fromBufferAttribute(uv, c);
            intersection.uv = $f70f7eb6404ce619$export$5a465592bfe74b48.getUV($f70f7eb6404ce619$var$_intersectionPoint, $f70f7eb6404ce619$var$_vA$1, $f70f7eb6404ce619$var$_vB$1, $f70f7eb6404ce619$var$_vC$1, $f70f7eb6404ce619$var$_uvA$1, $f70f7eb6404ce619$var$_uvB$1, $f70f7eb6404ce619$var$_uvC$1, new $f70f7eb6404ce619$export$c977b3e384af9ae1());
        }
        if (uv2) {
            $f70f7eb6404ce619$var$_uvA$1.fromBufferAttribute(uv2, a);
            $f70f7eb6404ce619$var$_uvB$1.fromBufferAttribute(uv2, b);
            $f70f7eb6404ce619$var$_uvC$1.fromBufferAttribute(uv2, c);
            intersection.uv2 = $f70f7eb6404ce619$export$5a465592bfe74b48.getUV($f70f7eb6404ce619$var$_intersectionPoint, $f70f7eb6404ce619$var$_vA$1, $f70f7eb6404ce619$var$_vB$1, $f70f7eb6404ce619$var$_vC$1, $f70f7eb6404ce619$var$_uvA$1, $f70f7eb6404ce619$var$_uvB$1, $f70f7eb6404ce619$var$_uvC$1, new $f70f7eb6404ce619$export$c977b3e384af9ae1());
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $f70f7eb6404ce619$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $f70f7eb6404ce619$export$5a465592bfe74b48.getNormal($f70f7eb6404ce619$var$_vA$1, $f70f7eb6404ce619$var$_vB$1, $f70f7eb6404ce619$var$_vC$1, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class $f70f7eb6404ce619$export$33e43285f7406bd5 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $f70f7eb6404ce619$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $f70f7eb6404ce619$var$cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $f70f7eb6404ce619$var$mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $f70f7eb6404ce619$var$cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $f70f7eb6404ce619$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
// Legacy
const $f70f7eb6404ce619$export$d8ecdf8615bfea69 = {
    clone: $f70f7eb6404ce619$var$cloneUniforms,
    merge: $f70f7eb6404ce619$var$mergeUniforms
};
var $f70f7eb6404ce619$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $f70f7eb6404ce619$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $f70f7eb6404ce619$export$83c7d75d550a8b0d extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $f70f7eb6404ce619$var$default_vertex;
        this.fragmentShader = $f70f7eb6404ce619$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.extensions = {
            derivatives: false,
            fragDepth: false,
            drawBuffers: false,
            shaderTextureLOD: false // set to use shader texture LOD
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv2': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $f70f7eb6404ce619$var$cloneUniforms(source.uniforms);
        this.uniformsGroups = $f70f7eb6404ce619$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $f70f7eb6404ce619$export$79f141de891a5fed extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $f70f7eb6404ce619$export$74e4ae24825f68d7 extends $f70f7eb6404ce619$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $f70f7eb6404ce619$var$RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($f70f7eb6404ce619$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $f70f7eb6404ce619$var$RAD2DEG * 2 * Math.atan(Math.tan($f70f7eb6404ce619$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($f70f7eb6404ce619$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $f70f7eb6404ce619$var$fov = 90, $f70f7eb6404ce619$var$aspect = 1;
class $f70f7eb6404ce619$export$d0cdd0bd804995de extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        const cameraPX = new $f70f7eb6404ce619$export$74e4ae24825f68d7($f70f7eb6404ce619$var$fov, $f70f7eb6404ce619$var$aspect, near, far);
        cameraPX.layers = this.layers;
        cameraPX.up.set(0, -1, 0);
        cameraPX.lookAt(new $f70f7eb6404ce619$export$64b5c384219d3699(1, 0, 0));
        this.add(cameraPX);
        const cameraNX = new $f70f7eb6404ce619$export$74e4ae24825f68d7($f70f7eb6404ce619$var$fov, $f70f7eb6404ce619$var$aspect, near, far);
        cameraNX.layers = this.layers;
        cameraNX.up.set(0, -1, 0);
        cameraNX.lookAt(new $f70f7eb6404ce619$export$64b5c384219d3699(-1, 0, 0));
        this.add(cameraNX);
        const cameraPY = new $f70f7eb6404ce619$export$74e4ae24825f68d7($f70f7eb6404ce619$var$fov, $f70f7eb6404ce619$var$aspect, near, far);
        cameraPY.layers = this.layers;
        cameraPY.up.set(0, 0, 1);
        cameraPY.lookAt(new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0));
        this.add(cameraPY);
        const cameraNY = new $f70f7eb6404ce619$export$74e4ae24825f68d7($f70f7eb6404ce619$var$fov, $f70f7eb6404ce619$var$aspect, near, far);
        cameraNY.layers = this.layers;
        cameraNY.up.set(0, 0, -1);
        cameraNY.lookAt(new $f70f7eb6404ce619$export$64b5c384219d3699(0, -1, 0));
        this.add(cameraNY);
        const cameraPZ = new $f70f7eb6404ce619$export$74e4ae24825f68d7($f70f7eb6404ce619$var$fov, $f70f7eb6404ce619$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        cameraPZ.up.set(0, -1, 0);
        cameraPZ.lookAt(new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 1));
        this.add(cameraPZ);
        const cameraNZ = new $f70f7eb6404ce619$export$74e4ae24825f68d7($f70f7eb6404ce619$var$fov, $f70f7eb6404ce619$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        cameraNZ.up.set(0, -1, 0);
        cameraNZ.lookAt(new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, -1));
        this.add(cameraNZ);
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const renderTarget = this.renderTarget;
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentToneMapping = renderer.toneMapping;
        const currentXrEnabled = renderer.xr.enabled;
        renderer.toneMapping = $f70f7eb6404ce619$export$9fcb6b4294603b2;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.toneMapping = currentToneMapping;
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $f70f7eb6404ce619$export$ee2e5a18258a4049 extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $f70f7eb6404ce619$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $f70f7eb6404ce619$export$ac386671d651941e extends $f70f7eb6404ce619$export$3c052beb2e51e23f {
    constructor(size, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $f70f7eb6404ce619$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $f70f7eb6404ce619$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $f70f7eb6404ce619$export$33e43285f7406bd5(5, 5, 5);
        const material = new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $f70f7eb6404ce619$var$cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $f70f7eb6404ce619$export$d9f0486e75b5ace,
            blending: $f70f7eb6404ce619$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $f70f7eb6404ce619$export$5d8599b6a933fb1b) texture.minFilter = $f70f7eb6404ce619$export$8a72f490b25c56c8;
        const camera = new $f70f7eb6404ce619$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
const $f70f7eb6404ce619$var$_vector1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vector2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_normalMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$8ff26dafa08918();
class $f70f7eb6404ce619$export$7ff5ac152ef991b0 {
    constructor(normal = new $f70f7eb6404ce619$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $f70f7eb6404ce619$var$_vector1.subVectors(c, b).cross($f70f7eb6404ce619$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        const direction = line.delta($f70f7eb6404ce619$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $f70f7eb6404ce619$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($f70f7eb6404ce619$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $f70f7eb6404ce619$var$_sphere$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$805e8b72413ccaba();
const $f70f7eb6404ce619$var$_vector$7 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$35efe6f4c85463d2 {
    constructor(p0 = new $f70f7eb6404ce619$export$7ff5ac152ef991b0(), p1 = new $f70f7eb6404ce619$export$7ff5ac152ef991b0(), p2 = new $f70f7eb6404ce619$export$7ff5ac152ef991b0(), p3 = new $f70f7eb6404ce619$export$7ff5ac152ef991b0(), p4 = new $f70f7eb6404ce619$export$7ff5ac152ef991b0(), p5 = new $f70f7eb6404ce619$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $f70f7eb6404ce619$var$_sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere($f70f7eb6404ce619$var$_sphere$2);
    }
    intersectsSprite(sprite) {
        $f70f7eb6404ce619$var$_sphere$2.center.set(0, 0, 0);
        $f70f7eb6404ce619$var$_sphere$2.radius = 0.7071067811865476;
        $f70f7eb6404ce619$var$_sphere$2.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($f70f7eb6404ce619$var$_sphere$2);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $f70f7eb6404ce619$var$_vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $f70f7eb6404ce619$var$_vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $f70f7eb6404ce619$var$_vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($f70f7eb6404ce619$var$_vector$7) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $f70f7eb6404ce619$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $f70f7eb6404ce619$var$WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        else if (array instanceof Uint8ClampedArray) type = 5121;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class $f70f7eb6404ce619$export$967d831af31f69ce extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
var $f70f7eb6404ce619$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var $f70f7eb6404ce619$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $f70f7eb6404ce619$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var $f70f7eb6404ce619$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $f70f7eb6404ce619$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $f70f7eb6404ce619$var$begin_vertex = "vec3 transformed = vec3( position );";
var $f70f7eb6404ce619$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $f70f7eb6404ce619$var$bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\n#ifdef USE_IRIDESCENCE\n\tvec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif";
var $f70f7eb6404ce619$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\t return vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat R21 = R12;\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $f70f7eb6404ce619$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $f70f7eb6404ce619$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $f70f7eb6404ce619$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $f70f7eb6404ce619$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $f70f7eb6404ce619$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $f70f7eb6404ce619$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $f70f7eb6404ce619$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $f70f7eb6404ce619$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var $f70f7eb6404ce619$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var $f70f7eb6404ce619$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $f70f7eb6404ce619$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $f70f7eb6404ce619$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var $f70f7eb6404ce619$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $f70f7eb6404ce619$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $f70f7eb6404ce619$var$encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $f70f7eb6404ce619$var$encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $f70f7eb6404ce619$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $f70f7eb6404ce619$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $f70f7eb6404ce619$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $f70f7eb6404ce619$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $f70f7eb6404ce619$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $f70f7eb6404ce619$var$lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var $f70f7eb6404ce619$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $f70f7eb6404ce619$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $f70f7eb6404ce619$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert\n#define Material_LightProbeLOD( material )\t(0)";
var $f70f7eb6404ce619$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $f70f7eb6404ce619$var$envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif";
var $f70f7eb6404ce619$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $f70f7eb6404ce619$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var $f70f7eb6404ce619$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $f70f7eb6404ce619$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var $f70f7eb6404ce619$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );\n\t#else\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $f70f7eb6404ce619$var$lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $f70f7eb6404ce619$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var $f70f7eb6404ce619$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $f70f7eb6404ce619$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $f70f7eb6404ce619$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $f70f7eb6404ce619$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $f70f7eb6404ce619$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $f70f7eb6404ce619$var$map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $f70f7eb6404ce619$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $f70f7eb6404ce619$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $f70f7eb6404ce619$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $f70f7eb6404ce619$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var $f70f7eb6404ce619$var$normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $f70f7eb6404ce619$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif";
var $f70f7eb6404ce619$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var $f70f7eb6404ce619$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var $f70f7eb6404ce619$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $f70f7eb6404ce619$var$output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $f70f7eb6404ce619$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var $f70f7eb6404ce619$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $f70f7eb6404ce619$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $f70f7eb6404ce619$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $f70f7eb6404ce619$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $f70f7eb6404ce619$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $f70f7eb6404ce619$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $f70f7eb6404ce619$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var $f70f7eb6404ce619$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$shadowmap_vertex = "#if defined( USE_SHADOWMAP ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_COORDS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $f70f7eb6404ce619$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $f70f7eb6404ce619$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var $f70f7eb6404ce619$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $f70f7eb6404ce619$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $f70f7eb6404ce619$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $f70f7eb6404ce619$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $f70f7eb6404ce619$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $f70f7eb6404ce619$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $f70f7eb6404ce619$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );\n#endif";
var $f70f7eb6404ce619$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif";
var $f70f7eb6404ce619$var$uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var $f70f7eb6404ce619$var$uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var $f70f7eb6404ce619$var$uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var $f70f7eb6404ce619$var$uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var $f70f7eb6404ce619$var$uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var $f70f7eb6404ce619$var$uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var $f70f7eb6404ce619$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $f70f7eb6404ce619$var$vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $f70f7eb6404ce619$var$fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tgl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n\t#endif\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $f70f7eb6404ce619$var$fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $f70f7eb6404ce619$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
const $f70f7eb6404ce619$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $f70f7eb6404ce619$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $f70f7eb6404ce619$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $f70f7eb6404ce619$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $f70f7eb6404ce619$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $f70f7eb6404ce619$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $f70f7eb6404ce619$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
const $f70f7eb6404ce619$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $f70f7eb6404ce619$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
const $f70f7eb6404ce619$export$955f9f2e84c43c8b = {
    alphamap_fragment: $f70f7eb6404ce619$var$alphamap_fragment,
    alphamap_pars_fragment: $f70f7eb6404ce619$var$alphamap_pars_fragment,
    alphatest_fragment: $f70f7eb6404ce619$var$alphatest_fragment,
    alphatest_pars_fragment: $f70f7eb6404ce619$var$alphatest_pars_fragment,
    aomap_fragment: $f70f7eb6404ce619$var$aomap_fragment,
    aomap_pars_fragment: $f70f7eb6404ce619$var$aomap_pars_fragment,
    begin_vertex: $f70f7eb6404ce619$var$begin_vertex,
    beginnormal_vertex: $f70f7eb6404ce619$var$beginnormal_vertex,
    bsdfs: $f70f7eb6404ce619$var$bsdfs,
    iridescence_fragment: $f70f7eb6404ce619$var$iridescence_fragment,
    bumpmap_pars_fragment: $f70f7eb6404ce619$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $f70f7eb6404ce619$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $f70f7eb6404ce619$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $f70f7eb6404ce619$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $f70f7eb6404ce619$var$clipping_planes_vertex,
    color_fragment: $f70f7eb6404ce619$var$color_fragment,
    color_pars_fragment: $f70f7eb6404ce619$var$color_pars_fragment,
    color_pars_vertex: $f70f7eb6404ce619$var$color_pars_vertex,
    color_vertex: $f70f7eb6404ce619$var$color_vertex,
    common: $f70f7eb6404ce619$var$common,
    cube_uv_reflection_fragment: $f70f7eb6404ce619$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $f70f7eb6404ce619$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $f70f7eb6404ce619$var$displacementmap_pars_vertex,
    displacementmap_vertex: $f70f7eb6404ce619$var$displacementmap_vertex,
    emissivemap_fragment: $f70f7eb6404ce619$var$emissivemap_fragment,
    emissivemap_pars_fragment: $f70f7eb6404ce619$var$emissivemap_pars_fragment,
    encodings_fragment: $f70f7eb6404ce619$var$encodings_fragment,
    encodings_pars_fragment: $f70f7eb6404ce619$var$encodings_pars_fragment,
    envmap_fragment: $f70f7eb6404ce619$var$envmap_fragment,
    envmap_common_pars_fragment: $f70f7eb6404ce619$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $f70f7eb6404ce619$var$envmap_pars_fragment,
    envmap_pars_vertex: $f70f7eb6404ce619$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $f70f7eb6404ce619$var$envmap_physical_pars_fragment,
    envmap_vertex: $f70f7eb6404ce619$var$envmap_vertex,
    fog_vertex: $f70f7eb6404ce619$var$fog_vertex,
    fog_pars_vertex: $f70f7eb6404ce619$var$fog_pars_vertex,
    fog_fragment: $f70f7eb6404ce619$var$fog_fragment,
    fog_pars_fragment: $f70f7eb6404ce619$var$fog_pars_fragment,
    gradientmap_pars_fragment: $f70f7eb6404ce619$var$gradientmap_pars_fragment,
    lightmap_fragment: $f70f7eb6404ce619$var$lightmap_fragment,
    lightmap_pars_fragment: $f70f7eb6404ce619$var$lightmap_pars_fragment,
    lights_lambert_fragment: $f70f7eb6404ce619$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $f70f7eb6404ce619$var$lights_lambert_pars_fragment,
    lights_pars_begin: $f70f7eb6404ce619$var$lights_pars_begin,
    lights_toon_fragment: $f70f7eb6404ce619$var$lights_toon_fragment,
    lights_toon_pars_fragment: $f70f7eb6404ce619$var$lights_toon_pars_fragment,
    lights_phong_fragment: $f70f7eb6404ce619$var$lights_phong_fragment,
    lights_phong_pars_fragment: $f70f7eb6404ce619$var$lights_phong_pars_fragment,
    lights_physical_fragment: $f70f7eb6404ce619$var$lights_physical_fragment,
    lights_physical_pars_fragment: $f70f7eb6404ce619$var$lights_physical_pars_fragment,
    lights_fragment_begin: $f70f7eb6404ce619$var$lights_fragment_begin,
    lights_fragment_maps: $f70f7eb6404ce619$var$lights_fragment_maps,
    lights_fragment_end: $f70f7eb6404ce619$var$lights_fragment_end,
    logdepthbuf_fragment: $f70f7eb6404ce619$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $f70f7eb6404ce619$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $f70f7eb6404ce619$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $f70f7eb6404ce619$var$logdepthbuf_vertex,
    map_fragment: $f70f7eb6404ce619$var$map_fragment,
    map_pars_fragment: $f70f7eb6404ce619$var$map_pars_fragment,
    map_particle_fragment: $f70f7eb6404ce619$var$map_particle_fragment,
    map_particle_pars_fragment: $f70f7eb6404ce619$var$map_particle_pars_fragment,
    metalnessmap_fragment: $f70f7eb6404ce619$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $f70f7eb6404ce619$var$metalnessmap_pars_fragment,
    morphcolor_vertex: $f70f7eb6404ce619$var$morphcolor_vertex,
    morphnormal_vertex: $f70f7eb6404ce619$var$morphnormal_vertex,
    morphtarget_pars_vertex: $f70f7eb6404ce619$var$morphtarget_pars_vertex,
    morphtarget_vertex: $f70f7eb6404ce619$var$morphtarget_vertex,
    normal_fragment_begin: $f70f7eb6404ce619$var$normal_fragment_begin,
    normal_fragment_maps: $f70f7eb6404ce619$var$normal_fragment_maps,
    normal_pars_fragment: $f70f7eb6404ce619$var$normal_pars_fragment,
    normal_pars_vertex: $f70f7eb6404ce619$var$normal_pars_vertex,
    normal_vertex: $f70f7eb6404ce619$var$normal_vertex,
    normalmap_pars_fragment: $f70f7eb6404ce619$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $f70f7eb6404ce619$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $f70f7eb6404ce619$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $f70f7eb6404ce619$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $f70f7eb6404ce619$var$iridescence_pars_fragment,
    output_fragment: $f70f7eb6404ce619$var$output_fragment,
    packing: $f70f7eb6404ce619$var$packing,
    premultiplied_alpha_fragment: $f70f7eb6404ce619$var$premultiplied_alpha_fragment,
    project_vertex: $f70f7eb6404ce619$var$project_vertex,
    dithering_fragment: $f70f7eb6404ce619$var$dithering_fragment,
    dithering_pars_fragment: $f70f7eb6404ce619$var$dithering_pars_fragment,
    roughnessmap_fragment: $f70f7eb6404ce619$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $f70f7eb6404ce619$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $f70f7eb6404ce619$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $f70f7eb6404ce619$var$shadowmap_pars_vertex,
    shadowmap_vertex: $f70f7eb6404ce619$var$shadowmap_vertex,
    shadowmask_pars_fragment: $f70f7eb6404ce619$var$shadowmask_pars_fragment,
    skinbase_vertex: $f70f7eb6404ce619$var$skinbase_vertex,
    skinning_pars_vertex: $f70f7eb6404ce619$var$skinning_pars_vertex,
    skinning_vertex: $f70f7eb6404ce619$var$skinning_vertex,
    skinnormal_vertex: $f70f7eb6404ce619$var$skinnormal_vertex,
    specularmap_fragment: $f70f7eb6404ce619$var$specularmap_fragment,
    specularmap_pars_fragment: $f70f7eb6404ce619$var$specularmap_pars_fragment,
    tonemapping_fragment: $f70f7eb6404ce619$var$tonemapping_fragment,
    tonemapping_pars_fragment: $f70f7eb6404ce619$var$tonemapping_pars_fragment,
    transmission_fragment: $f70f7eb6404ce619$var$transmission_fragment,
    transmission_pars_fragment: $f70f7eb6404ce619$var$transmission_pars_fragment,
    uv_pars_fragment: $f70f7eb6404ce619$var$uv_pars_fragment,
    uv_pars_vertex: $f70f7eb6404ce619$var$uv_pars_vertex,
    uv_vertex: $f70f7eb6404ce619$var$uv_vertex,
    uv2_pars_fragment: $f70f7eb6404ce619$var$uv2_pars_fragment,
    uv2_pars_vertex: $f70f7eb6404ce619$var$uv2_pars_vertex,
    uv2_vertex: $f70f7eb6404ce619$var$uv2_vertex,
    worldpos_vertex: $f70f7eb6404ce619$var$worldpos_vertex,
    background_vert: $f70f7eb6404ce619$var$vertex$g,
    background_frag: $f70f7eb6404ce619$var$fragment$g,
    cube_vert: $f70f7eb6404ce619$var$vertex$f,
    cube_frag: $f70f7eb6404ce619$var$fragment$f,
    depth_vert: $f70f7eb6404ce619$var$vertex$e,
    depth_frag: $f70f7eb6404ce619$var$fragment$e,
    distanceRGBA_vert: $f70f7eb6404ce619$var$vertex$d,
    distanceRGBA_frag: $f70f7eb6404ce619$var$fragment$d,
    equirect_vert: $f70f7eb6404ce619$var$vertex$c,
    equirect_frag: $f70f7eb6404ce619$var$fragment$c,
    linedashed_vert: $f70f7eb6404ce619$var$vertex$b,
    linedashed_frag: $f70f7eb6404ce619$var$fragment$b,
    meshbasic_vert: $f70f7eb6404ce619$var$vertex$a,
    meshbasic_frag: $f70f7eb6404ce619$var$fragment$a,
    meshlambert_vert: $f70f7eb6404ce619$var$vertex$9,
    meshlambert_frag: $f70f7eb6404ce619$var$fragment$9,
    meshmatcap_vert: $f70f7eb6404ce619$var$vertex$8,
    meshmatcap_frag: $f70f7eb6404ce619$var$fragment$8,
    meshnormal_vert: $f70f7eb6404ce619$var$vertex$7,
    meshnormal_frag: $f70f7eb6404ce619$var$fragment$7,
    meshphong_vert: $f70f7eb6404ce619$var$vertex$6,
    meshphong_frag: $f70f7eb6404ce619$var$fragment$6,
    meshphysical_vert: $f70f7eb6404ce619$var$vertex$5,
    meshphysical_frag: $f70f7eb6404ce619$var$fragment$5,
    meshtoon_vert: $f70f7eb6404ce619$var$vertex$4,
    meshtoon_frag: $f70f7eb6404ce619$var$fragment$4,
    points_vert: $f70f7eb6404ce619$var$vertex$3,
    points_frag: $f70f7eb6404ce619$var$fragment$3,
    shadow_vert: $f70f7eb6404ce619$var$vertex$2,
    shadow_frag: $f70f7eb6404ce619$var$fragment$2,
    sprite_vert: $f70f7eb6404ce619$var$vertex$1,
    sprite_frag: $f70f7eb6404ce619$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $f70f7eb6404ce619$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$8ff26dafa08918()
        },
        uv2Transform: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$8ff26dafa08918()
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        } // basic, lambert, phong
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$8ff26dafa08918()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new $f70f7eb6404ce619$export$8ff26dafa08918()
        }
    }
};
const $f70f7eb6404ce619$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.specularmap,
            $f70f7eb6404ce619$export$6643083551874bf5.envmap,
            $f70f7eb6404ce619$export$6643083551874bf5.aomap,
            $f70f7eb6404ce619$export$6643083551874bf5.lightmap,
            $f70f7eb6404ce619$export$6643083551874bf5.fog
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.specularmap,
            $f70f7eb6404ce619$export$6643083551874bf5.envmap,
            $f70f7eb6404ce619$export$6643083551874bf5.aomap,
            $f70f7eb6404ce619$export$6643083551874bf5.lightmap,
            $f70f7eb6404ce619$export$6643083551874bf5.emissivemap,
            $f70f7eb6404ce619$export$6643083551874bf5.bumpmap,
            $f70f7eb6404ce619$export$6643083551874bf5.normalmap,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            $f70f7eb6404ce619$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.specularmap,
            $f70f7eb6404ce619$export$6643083551874bf5.envmap,
            $f70f7eb6404ce619$export$6643083551874bf5.aomap,
            $f70f7eb6404ce619$export$6643083551874bf5.lightmap,
            $f70f7eb6404ce619$export$6643083551874bf5.emissivemap,
            $f70f7eb6404ce619$export$6643083551874bf5.bumpmap,
            $f70f7eb6404ce619$export$6643083551874bf5.normalmap,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            $f70f7eb6404ce619$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.envmap,
            $f70f7eb6404ce619$export$6643083551874bf5.aomap,
            $f70f7eb6404ce619$export$6643083551874bf5.lightmap,
            $f70f7eb6404ce619$export$6643083551874bf5.emissivemap,
            $f70f7eb6404ce619$export$6643083551874bf5.bumpmap,
            $f70f7eb6404ce619$export$6643083551874bf5.normalmap,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            $f70f7eb6404ce619$export$6643083551874bf5.roughnessmap,
            $f70f7eb6404ce619$export$6643083551874bf5.metalnessmap,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            $f70f7eb6404ce619$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.aomap,
            $f70f7eb6404ce619$export$6643083551874bf5.lightmap,
            $f70f7eb6404ce619$export$6643083551874bf5.emissivemap,
            $f70f7eb6404ce619$export$6643083551874bf5.bumpmap,
            $f70f7eb6404ce619$export$6643083551874bf5.normalmap,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            $f70f7eb6404ce619$export$6643083551874bf5.gradientmap,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            $f70f7eb6404ce619$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000)
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.bumpmap,
            $f70f7eb6404ce619$export$6643083551874bf5.normalmap,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.points,
            $f70f7eb6404ce619$export$6643083551874bf5.fog
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.bumpmap,
            $f70f7eb6404ce619$export$6643083551874bf5.normalmap,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.sprite,
            $f70f7eb6404ce619$export$6643083551874bf5.fog
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new $f70f7eb6404ce619$export$8ff26dafa08918()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.background_frag
    },
    cube: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.common,
            $f70f7eb6404ce619$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
            $f70f7eb6404ce619$export$6643083551874bf5.lights,
            $f70f7eb6404ce619$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.shadow_frag
    }
};
$f70f7eb6404ce619$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ $f70f7eb6404ce619$var$mergeUniforms([
        $f70f7eb6404ce619$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphysical_frag
};
function $f70f7eb6404ce619$var$WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene) {
        let forceClear = false;
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === 'additive') background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.mapping === $f70f7eb6404ce619$export$dbf3e70ff37af79)) {
            if (boxMesh === undefined) {
                boxMesh = new $f70f7eb6404ce619$export$e176487c05830cc5(new $f70f7eb6404ce619$export$33e43285f7406bd5(1, 1, 1), new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
                    name: 'BackgroundCubeMaterial',
                    uniforms: $f70f7eb6404ce619$var$cloneUniforms($f70f7eb6404ce619$export$bee4a7d47f8f5014.cube.uniforms),
                    vertexShader: $f70f7eb6404ce619$export$bee4a7d47f8f5014.cube.vertexShader,
                    fragmentShader: $f70f7eb6404ce619$export$bee4a7d47f8f5014.cube.fragmentShader,
                    side: $f70f7eb6404ce619$export$d9f0486e75b5ace,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new $f70f7eb6404ce619$export$e176487c05830cc5(new $f70f7eb6404ce619$export$967d831af31f69ce(2, 2), new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
                    name: 'BackgroundMaterial',
                    uniforms: $f70f7eb6404ce619$var$cloneUniforms($f70f7eb6404ce619$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $f70f7eb6404ce619$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $f70f7eb6404ce619$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: $f70f7eb6404ce619$export$2ede184fc2998901,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function $f70f7eb6404ce619$var$WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(object, geometry, program, index);
            if (updateBuffers) saveCache(object, geometry, program, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(34962, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $f70f7eb6404ce619$var$WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $f70f7eb6404ce619$var$WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        drawBuffers: drawBuffers,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function $f70f7eb6404ce619$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new $f70f7eb6404ce619$export$7ff5ac152ef991b0(), viewNormalMatrix = new $f70f7eb6404ce619$export$8ff26dafa08918(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $f70f7eb6404ce619$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === $f70f7eb6404ce619$export$d64030b316d3b087) texture.mapping = $f70f7eb6404ce619$export$8759762a6477f2c4;
        else if (mapping === $f70f7eb6404ce619$export$ee99d97d46898098) texture.mapping = $f70f7eb6404ce619$export$dc59f8aed047f61d;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
            const mapping = texture.mapping;
            if (mapping === $f70f7eb6404ce619$export$d64030b316d3b087 || mapping === $f70f7eb6404ce619$export$ee99d97d46898098) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new $f70f7eb6404ce619$export$ac386671d651941e(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $f70f7eb6404ce619$export$9ebf355ee4ed261b extends $f70f7eb6404ce619$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
const $f70f7eb6404ce619$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $f70f7eb6404ce619$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $f70f7eb6404ce619$var$MAX_SAMPLES = 20;
const $f70f7eb6404ce619$var$_flatCamera = /*@__PURE__*/ new $f70f7eb6404ce619$export$9ebf355ee4ed261b();
const $f70f7eb6404ce619$var$_clearColor = /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e();
let $f70f7eb6404ce619$var$_oldTarget = null;
// Golden Ratio
const $f70f7eb6404ce619$var$PHI = (1 + Math.sqrt(5)) / 2;
const $f70f7eb6404ce619$var$INV_PHI = 1 / $f70f7eb6404ce619$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $f70f7eb6404ce619$var$_axisDirections = [
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(1, 1, 1),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(-1, 1, 1),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(1, 1, -1),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(-1, 1, -1),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(0, $f70f7eb6404ce619$var$PHI, $f70f7eb6404ce619$var$INV_PHI),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(0, $f70f7eb6404ce619$var$PHI, -$f70f7eb6404ce619$var$INV_PHI),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699($f70f7eb6404ce619$var$INV_PHI, 0, $f70f7eb6404ce619$var$PHI),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(-$f70f7eb6404ce619$var$INV_PHI, 0, $f70f7eb6404ce619$var$PHI),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699($f70f7eb6404ce619$var$PHI, $f70f7eb6404ce619$var$INV_PHI, 0),
    /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699(-$f70f7eb6404ce619$var$PHI, $f70f7eb6404ce619$var$INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $f70f7eb6404ce619$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $f70f7eb6404ce619$var$_oldTarget = this._renderer.getRenderTarget();
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $f70f7eb6404ce619$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $f70f7eb6404ce619$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($f70f7eb6404ce619$var$_oldTarget);
        outputTarget.scissorTest = false;
        $f70f7eb6404ce619$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === $f70f7eb6404ce619$export$8759762a6477f2c4 || texture.mapping === $f70f7eb6404ce619$export$dc59f8aed047f61d) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $f70f7eb6404ce619$var$_oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: $f70f7eb6404ce619$export$8a72f490b25c56c8,
            minFilter: $f70f7eb6404ce619$export$8a72f490b25c56c8,
            generateMipmaps: false,
            type: $f70f7eb6404ce619$export$2697304443f382bc,
            format: $f70f7eb6404ce619$export$3f8bb04b555a363c,
            encoding: $f70f7eb6404ce619$export$7207336e4151a112,
            depthBuffer: false
        };
        const cubeUVRenderTarget = $f70f7eb6404ce619$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $f70f7eb6404ce619$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $f70f7eb6404ce619$var$_createPlanes(_lodMax));
            this._blurMaterial = $f70f7eb6404ce619$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new $f70f7eb6404ce619$export$e176487c05830cc5(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $f70f7eb6404ce619$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new $f70f7eb6404ce619$export$74e4ae24825f68d7(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($f70f7eb6404ce619$var$_clearColor);
        renderer.toneMapping = $f70f7eb6404ce619$export$9fcb6b4294603b2;
        renderer.autoClear = false;
        const backgroundMaterial = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            name: 'PMREM.Background',
            side: $f70f7eb6404ce619$export$d9f0486e75b5ace,
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new $f70f7eb6404ce619$export$e176487c05830cc5(new $f70f7eb6404ce619$export$33e43285f7406bd5(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($f70f7eb6404ce619$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $f70f7eb6404ce619$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === $f70f7eb6404ce619$export$8759762a6477f2c4 || texture.mapping === $f70f7eb6404ce619$export$dc59f8aed047f61d;
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $f70f7eb6404ce619$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $f70f7eb6404ce619$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $f70f7eb6404ce619$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $f70f7eb6404ce619$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < this._lodPlanes.length; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $f70f7eb6404ce619$var$_axisDirections[(i - 1) % $f70f7eb6404ce619$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new $f70f7eb6404ce619$export$e176487c05830cc5(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $f70f7eb6404ce619$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $f70f7eb6404ce619$var$MAX_SAMPLES;
        if (samples > $f70f7eb6404ce619$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$f70f7eb6404ce619$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $f70f7eb6404ce619$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $f70f7eb6404ce619$var$LOD_MIN ? lodOut - _lodMax + $f70f7eb6404ce619$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $f70f7eb6404ce619$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $f70f7eb6404ce619$var$_flatCamera);
    }
}
function $f70f7eb6404ce619$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $f70f7eb6404ce619$var$LOD_MIN + 1 + $f70f7eb6404ce619$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $f70f7eb6404ce619$var$LOD_MIN) sigma = $f70f7eb6404ce619$var$EXTRA_LOD_SIGMA[i - lodMax + $f70f7eb6404ce619$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new $f70f7eb6404ce619$export$b7be63a67df8959();
        planes.setAttribute('position', new $f70f7eb6404ce619$export$8dea267bd6bde117(position, positionSize));
        planes.setAttribute('uv', new $f70f7eb6404ce619$export$8dea267bd6bde117(uv, uvSize));
        planes.setAttribute('faceIndex', new $f70f7eb6404ce619$export$8dea267bd6bde117(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $f70f7eb6404ce619$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $f70f7eb6404ce619$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new $f70f7eb6404ce619$export$3c052beb2e51e23f(width, height, params);
    cubeUVRenderTarget.texture.mapping = $f70f7eb6404ce619$export$dbf3e70ff37af79;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $f70f7eb6404ce619$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $f70f7eb6404ce619$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($f70f7eb6404ce619$var$MAX_SAMPLES);
    const poleAxis = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
    const shaderMaterial = new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $f70f7eb6404ce619$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $f70f7eb6404ce619$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: $f70f7eb6404ce619$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $f70f7eb6404ce619$var$_getEquirectMaterial() {
    return new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $f70f7eb6404ce619$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: $f70f7eb6404ce619$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $f70f7eb6404ce619$var$_getCubemapMaterial() {
    return new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $f70f7eb6404ce619$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: $f70f7eb6404ce619$export$63b8d6b580fc65ba,
        depthTest: false,
        depthWrite: false
    });
}
function $f70f7eb6404ce619$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $f70f7eb6404ce619$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === $f70f7eb6404ce619$export$d64030b316d3b087 || mapping === $f70f7eb6404ce619$export$ee99d97d46898098;
            const isCubeMap = mapping === $f70f7eb6404ce619$export$8759762a6477f2c4 || mapping === $f70f7eb6404ce619$export$dc59f8aed047f61d;
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
                    texture.needsPMREMUpdate = false;
                    let renderTarget = cubeUVmaps.get(texture);
                    if (pmremGenerator === null) pmremGenerator = new $f70f7eb6404ce619$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (cubeUVmaps.has(texture)) return cubeUVmaps.get(texture).texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $f70f7eb6404ce619$export$6add42717753e221(renderer);
                            const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $f70f7eb6404ce619$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $f70f7eb6404ce619$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new ($f70f7eb6404ce619$var$arrayNeedsUint32(indices) ? $f70f7eb6404ce619$export$7eb8c9fa25cd5bd6 : $f70f7eb6404ce619$export$640a853f68025f2e)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $f70f7eb6404ce619$var$WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function $f70f7eb6404ce619$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $f70f7eb6404ce619$var$numericalSort(a, b) {
    return a[0] - b[0];
}
function $f70f7eb6404ce619$var$absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function $f70f7eb6404ce619$var$WebGLMorphtargets(gl, capabilities, textures) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const morphTextures = new WeakMap();
    const morph = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        if (capabilities.isWebGL2 === true) {
            // instead of using attributes, the WebGL 2 code path encodes morph targets
            // into an array of data textures. Each layer represents a single morph target.
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            let entry = morphTextures.get(geometry);
            if (entry === undefined || entry.count !== morphTargetsCount) {
                if (entry !== undefined) entry.texture.dispose();
                const hasMorphPosition = geometry.morphAttributes.position !== undefined;
                const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
                const hasMorphColors = geometry.morphAttributes.color !== undefined;
                const morphTargets = geometry.morphAttributes.position || [];
                const morphNormals = geometry.morphAttributes.normal || [];
                const morphColors = geometry.morphAttributes.color || [];
                let vertexDataCount = 0;
                if (hasMorphPosition === true) vertexDataCount = 1;
                if (hasMorphNormals === true) vertexDataCount = 2;
                if (hasMorphColors === true) vertexDataCount = 3;
                let width = geometry.attributes.position.count * vertexDataCount;
                let height = 1;
                if (width > capabilities.maxTextureSize) {
                    height = Math.ceil(width / capabilities.maxTextureSize);
                    width = capabilities.maxTextureSize;
                }
                const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
                const texture = new $f70f7eb6404ce619$export$dfac6c8e811406a3(buffer, width, height, morphTargetsCount);
                texture.type = $f70f7eb6404ce619$export$f6d331659b644596;
                texture.needsUpdate = true;
                // fill buffer
                const vertexDataStride = vertexDataCount * 4;
                for(let i = 0; i < morphTargetsCount; i++){
                    const morphTarget = morphTargets[i];
                    const morphNormal = morphNormals[i];
                    const morphColor = morphColors[i];
                    const offset = width * height * 4 * i;
                    for(let j = 0; j < morphTarget.count; j++){
                        const stride = j * vertexDataStride;
                        if (hasMorphPosition === true) {
                            morph.fromBufferAttribute(morphTarget, j);
                            buffer[offset + stride + 0] = morph.x;
                            buffer[offset + stride + 1] = morph.y;
                            buffer[offset + stride + 2] = morph.z;
                            buffer[offset + stride + 3] = 0;
                        }
                        if (hasMorphNormals === true) {
                            morph.fromBufferAttribute(morphNormal, j);
                            buffer[offset + stride + 4] = morph.x;
                            buffer[offset + stride + 5] = morph.y;
                            buffer[offset + stride + 6] = morph.z;
                            buffer[offset + stride + 7] = 0;
                        }
                        if (hasMorphColors === true) {
                            morph.fromBufferAttribute(morphColor, j);
                            buffer[offset + stride + 8] = morph.x;
                            buffer[offset + stride + 9] = morph.y;
                            buffer[offset + stride + 10] = morph.z;
                            buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                        }
                    }
                }
                entry = {
                    count: morphTargetsCount,
                    texture: texture,
                    size: new $f70f7eb6404ce619$export$c977b3e384af9ae1(width, height)
                };
                morphTextures.set(geometry, entry);
                function disposeTexture() {
                    texture.dispose();
                    morphTextures.delete(geometry);
                    geometry.removeEventListener('dispose', disposeTexture);
                }
                geometry.addEventListener('dispose', disposeTexture);
            }
            //
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
            program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
            program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
        } else {
            // When object doesn't have morph target influences defined, we treat it as a 0-length array
            // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
            const length = objectInfluences === undefined ? 0 : objectInfluences.length;
            let influences = influencesList[geometry.id];
            if (influences === undefined || influences.length !== length) {
                // initialise list
                influences = [];
                for(let i = 0; i < length; i++)influences[i] = [
                    i,
                    0
                ];
                influencesList[geometry.id] = influences;
            }
            // Collect influences
            for(let i = 0; i < length; i++){
                const influence = influences[i];
                influence[0] = i;
                influence[1] = objectInfluences[i];
            }
            influences.sort($f70f7eb6404ce619$var$absNumericalSort);
            for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
                workInfluences[i][0] = influences[i][0];
                workInfluences[i][1] = influences[i][1];
            } else {
                workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
                workInfluences[i][1] = 0;
            }
            workInfluences.sort($f70f7eb6404ce619$var$numericalSort);
            const morphTargets = geometry.morphAttributes.position;
            const morphNormals = geometry.morphAttributes.normal;
            let morphInfluencesSum = 0;
            for(let i = 0; i < 8; i++){
                const influence = workInfluences[i];
                const index = influence[0];
                const value = influence[1];
                if (index !== Number.MAX_SAFE_INTEGER && value) {
                    if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                    if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                    morphInfluences[i] = value;
                    morphInfluencesSum += value;
                } else {
                    if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                    if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                    morphInfluences[i] = 0;
                }
            }
            // GLSL shader uses formula baseinfluence * base + sum(target * influence)
            // This allows us to switch between absolute morphs and relative morphs without changing shader code
            // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
        }
    }
    return {
        update: update
    };
}
function $f70f7eb6404ce619$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $f70f7eb6404ce619$var$emptyTexture = /*@__PURE__*/ new $f70f7eb6404ce619$export$5431306cf43de24a();
const $f70f7eb6404ce619$var$emptyArrayTexture = /*@__PURE__*/ new $f70f7eb6404ce619$export$dfac6c8e811406a3();
const $f70f7eb6404ce619$var$empty3dTexture = /*@__PURE__*/ new $f70f7eb6404ce619$export$d7a3086320f856db();
const $f70f7eb6404ce619$var$emptyCubeTexture = /*@__PURE__*/ new $f70f7eb6404ce619$export$ee2e5a18258a4049();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $f70f7eb6404ce619$var$arrayCacheF32 = [];
const $f70f7eb6404ce619$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $f70f7eb6404ce619$var$mat4array = new Float32Array(16);
const $f70f7eb6404ce619$var$mat3array = new Float32Array(9);
const $f70f7eb6404ce619$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $f70f7eb6404ce619$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $f70f7eb6404ce619$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $f70f7eb6404ce619$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $f70f7eb6404ce619$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $f70f7eb6404ce619$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $f70f7eb6404ce619$var$allocTexUnits(textures, n) {
    let r = $f70f7eb6404ce619$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $f70f7eb6404ce619$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $f70f7eb6404ce619$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $f70f7eb6404ce619$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $f70f7eb6404ce619$var$copyArray(cache, v);
    }
}
function $f70f7eb6404ce619$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $f70f7eb6404ce619$var$copyArray(cache, v);
    }
}
function $f70f7eb6404ce619$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $f70f7eb6404ce619$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $f70f7eb6404ce619$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $f70f7eb6404ce619$var$copyArray(cache, v);
    } else {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, elements)) return;
        $f70f7eb6404ce619$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $f70f7eb6404ce619$var$mat2array);
        $f70f7eb6404ce619$var$copyArray(cache, elements);
    }
}
function $f70f7eb6404ce619$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $f70f7eb6404ce619$var$copyArray(cache, v);
    } else {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, elements)) return;
        $f70f7eb6404ce619$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $f70f7eb6404ce619$var$mat3array);
        $f70f7eb6404ce619$var$copyArray(cache, elements);
    }
}
function $f70f7eb6404ce619$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $f70f7eb6404ce619$var$copyArray(cache, v);
    } else {
        if ($f70f7eb6404ce619$var$arraysEqual(cache, elements)) return;
        $f70f7eb6404ce619$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $f70f7eb6404ce619$var$mat4array);
        $f70f7eb6404ce619$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $f70f7eb6404ce619$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array)
function $f70f7eb6404ce619$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    $f70f7eb6404ce619$var$copyArray(cache, v);
}
function $f70f7eb6404ce619$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    $f70f7eb6404ce619$var$copyArray(cache, v);
}
function $f70f7eb6404ce619$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    $f70f7eb6404ce619$var$copyArray(cache, v);
}
// Single unsigned integer
function $f70f7eb6404ce619$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array)
function $f70f7eb6404ce619$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
    gl.uniform2uiv(this.addr, v);
    $f70f7eb6404ce619$var$copyArray(cache, v);
}
function $f70f7eb6404ce619$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
    gl.uniform3uiv(this.addr, v);
    $f70f7eb6404ce619$var$copyArray(cache, v);
}
function $f70f7eb6404ce619$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if ($f70f7eb6404ce619$var$arraysEqual(cache, v)) return;
    gl.uniform4uiv(this.addr, v);
    $f70f7eb6404ce619$var$copyArray(cache, v);
}
// Single texture (2D / Cube)
function $f70f7eb6404ce619$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2D(v || $f70f7eb6404ce619$var$emptyTexture, unit);
}
function $f70f7eb6404ce619$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $f70f7eb6404ce619$var$empty3dTexture, unit);
}
function $f70f7eb6404ce619$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $f70f7eb6404ce619$var$emptyCubeTexture, unit);
}
function $f70f7eb6404ce619$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $f70f7eb6404ce619$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $f70f7eb6404ce619$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $f70f7eb6404ce619$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $f70f7eb6404ce619$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $f70f7eb6404ce619$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $f70f7eb6404ce619$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $f70f7eb6404ce619$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $f70f7eb6404ce619$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $f70f7eb6404ce619$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $f70f7eb6404ce619$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $f70f7eb6404ce619$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $f70f7eb6404ce619$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $f70f7eb6404ce619$var$setValueV4i; // _VEC4
        case 0x1405:
            return $f70f7eb6404ce619$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $f70f7eb6404ce619$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $f70f7eb6404ce619$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $f70f7eb6404ce619$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $f70f7eb6404ce619$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $f70f7eb6404ce619$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $f70f7eb6404ce619$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $f70f7eb6404ce619$var$setValueT2DArray1;
    }
}
// Array of scalars
function $f70f7eb6404ce619$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $f70f7eb6404ce619$var$setValueV2fArray(gl, v) {
    const data = $f70f7eb6404ce619$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $f70f7eb6404ce619$var$setValueV3fArray(gl, v) {
    const data = $f70f7eb6404ce619$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $f70f7eb6404ce619$var$setValueV4fArray(gl, v) {
    const data = $f70f7eb6404ce619$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $f70f7eb6404ce619$var$setValueM2Array(gl, v) {
    const data = $f70f7eb6404ce619$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $f70f7eb6404ce619$var$setValueM3Array(gl, v) {
    const data = $f70f7eb6404ce619$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $f70f7eb6404ce619$var$setValueM4Array(gl, v) {
    const data = $f70f7eb6404ce619$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $f70f7eb6404ce619$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $f70f7eb6404ce619$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $f70f7eb6404ce619$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $f70f7eb6404ce619$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $f70f7eb6404ce619$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $f70f7eb6404ce619$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $f70f7eb6404ce619$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $f70f7eb6404ce619$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $f70f7eb6404ce619$var$setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = $f70f7eb6404ce619$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $f70f7eb6404ce619$var$emptyTexture, units[i]);
}
function $f70f7eb6404ce619$var$setValueT3DArray(gl, v, textures) {
    const n = v.length;
    const units = $f70f7eb6404ce619$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $f70f7eb6404ce619$var$empty3dTexture, units[i]);
}
function $f70f7eb6404ce619$var$setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = $f70f7eb6404ce619$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $f70f7eb6404ce619$var$emptyCubeTexture, units[i]);
}
function $f70f7eb6404ce619$var$setValueT2DArrayArray(gl, v, textures) {
    const n = v.length;
    const units = $f70f7eb6404ce619$var$allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $f70f7eb6404ce619$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $f70f7eb6404ce619$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $f70f7eb6404ce619$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $f70f7eb6404ce619$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $f70f7eb6404ce619$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $f70f7eb6404ce619$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $f70f7eb6404ce619$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $f70f7eb6404ce619$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $f70f7eb6404ce619$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $f70f7eb6404ce619$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $f70f7eb6404ce619$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $f70f7eb6404ce619$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $f70f7eb6404ce619$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $f70f7eb6404ce619$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $f70f7eb6404ce619$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $f70f7eb6404ce619$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $f70f7eb6404ce619$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $f70f7eb6404ce619$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $f70f7eb6404ce619$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $f70f7eb6404ce619$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $f70f7eb6404ce619$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $f70f7eb6404ce619$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.setValue = $f70f7eb6404ce619$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $f70f7eb6404ce619$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.size = activeInfo.size;
        this.setValue = $f70f7eb6404ce619$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $f70f7eb6404ce619$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $f70f7eb6404ce619$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $f70f7eb6404ce619$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $f70f7eb6404ce619$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $f70f7eb6404ce619$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $f70f7eb6404ce619$var$RePathPart.exec(path), matchEnd = $f70f7eb6404ce619$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $f70f7eb6404ce619$var$addUniform(container, subscript === undefined ? new $f70f7eb6404ce619$var$SingleUniform(id, activeInfo, addr) : new $f70f7eb6404ce619$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $f70f7eb6404ce619$var$StructuredUniform(id);
                $f70f7eb6404ce619$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $f70f7eb6404ce619$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, 35718);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $f70f7eb6404ce619$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $f70f7eb6404ce619$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let $f70f7eb6404ce619$var$programIdCount = 0;
function $f70f7eb6404ce619$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
function $f70f7eb6404ce619$var$getEncodingComponents(encoding) {
    switch(encoding){
        case $f70f7eb6404ce619$export$7207336e4151a112:
            return [
                'Linear',
                '( value )'
            ];
        case $f70f7eb6404ce619$export$f32388edbb32674:
            return [
                'sRGB',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function $f70f7eb6404ce619$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $f70f7eb6404ce619$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $f70f7eb6404ce619$var$getTexelEncodingFunction(functionName, encoding) {
    const components = $f70f7eb6404ce619$var$getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function $f70f7eb6404ce619$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case $f70f7eb6404ce619$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case $f70f7eb6404ce619$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case $f70f7eb6404ce619$export$932b3dd283d4a366:
            toneMappingName = 'OptimizedCineon';
            break;
        case $f70f7eb6404ce619$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case $f70f7eb6404ce619$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function $f70f7eb6404ce619$var$generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter($f70f7eb6404ce619$var$filterEmptyLine).join('\n');
}
function $f70f7eb6404ce619$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $f70f7eb6404ce619$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === 35674) locationSize = 2;
        if (info.type === 35675) locationSize = 3;
        if (info.type === 35676) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $f70f7eb6404ce619$var$filterEmptyLine(string) {
    return string !== '';
}
function $f70f7eb6404ce619$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $f70f7eb6404ce619$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $f70f7eb6404ce619$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $f70f7eb6404ce619$var$resolveIncludes(string) {
    return string.replace($f70f7eb6404ce619$var$includePattern, $f70f7eb6404ce619$var$includeReplacer);
}
function $f70f7eb6404ce619$var$includeReplacer(match, include) {
    const string = $f70f7eb6404ce619$export$955f9f2e84c43c8b[include];
    if (string === undefined) throw new Error('Can not resolve #include <' + include + '>');
    return $f70f7eb6404ce619$var$resolveIncludes(string);
}
// Unroll Loops
const $f70f7eb6404ce619$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $f70f7eb6404ce619$var$unrollLoops(string) {
    return string.replace($f70f7eb6404ce619$var$unrollLoopPattern, $f70f7eb6404ce619$var$loopReplacer);
}
function $f70f7eb6404ce619$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $f70f7eb6404ce619$var$generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $f70f7eb6404ce619$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === $f70f7eb6404ce619$export$5813f879eee7cd88) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === $f70f7eb6404ce619$export$a47c4b43a1be34f0) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === $f70f7eb6404ce619$export$896ae1ade6c829c4) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $f70f7eb6404ce619$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $f70f7eb6404ce619$export$8759762a6477f2c4:
        case $f70f7eb6404ce619$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case $f70f7eb6404ce619$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $f70f7eb6404ce619$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case $f70f7eb6404ce619$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $f70f7eb6404ce619$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case $f70f7eb6404ce619$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case $f70f7eb6404ce619$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case $f70f7eb6404ce619$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $f70f7eb6404ce619$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $f70f7eb6404ce619$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $f70f7eb6404ce619$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $f70f7eb6404ce619$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $f70f7eb6404ce619$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $f70f7eb6404ce619$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $f70f7eb6404ce619$var$generateCubeUVSize(parameters);
    const customExtensions = parameters.isWebGL2 ? '' : $f70f7eb6404ce619$var$generateExtensions(parameters);
    const customDefines = $f70f7eb6404ce619$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter($f70f7eb6404ce619$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter($f70f7eb6404ce619$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $f70f7eb6404ce619$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($f70f7eb6404ce619$var$filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            $f70f7eb6404ce619$var$generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== $f70f7eb6404ce619$export$9fcb6b4294603b2 ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== $f70f7eb6404ce619$export$9fcb6b4294603b2 ? $f70f7eb6404ce619$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== $f70f7eb6404ce619$export$9fcb6b4294603b2 ? $f70f7eb6404ce619$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $f70f7eb6404ce619$export$955f9f2e84c43c8b['encodings_pars_fragment'],
            $f70f7eb6404ce619$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($f70f7eb6404ce619$var$filterEmptyLine).join('\n');
    }
    vertexShader = $f70f7eb6404ce619$var$resolveIncludes(vertexShader);
    vertexShader = $f70f7eb6404ce619$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $f70f7eb6404ce619$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $f70f7eb6404ce619$var$resolveIncludes(fragmentShader);
    fragmentShader = $f70f7eb6404ce619$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $f70f7eb6404ce619$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $f70f7eb6404ce619$var$unrollLoops(vertexShader);
    fragmentShader = $f70f7eb6404ce619$var$unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            'precision mediump sampler2DArray;',
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === $f70f7eb6404ce619$export$f63012db5506e7dd ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === $f70f7eb6404ce619$export$f63012db5506e7dd ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $f70f7eb6404ce619$var$WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = $f70f7eb6404ce619$var$WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = $f70f7eb6404ce619$var$getShaderErrors(gl, glVertexShader, 'vertex');
            const fragmentErrors = $f70f7eb6404ce619$var$getShaderErrors(gl, glFragmentShader, 'fragment');
            console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, 35715) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new $f70f7eb6404ce619$var$WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = $f70f7eb6404ce619$var$fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = $f70f7eb6404ce619$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $f70f7eb6404ce619$var$_id = 0;
class $f70f7eb6404ce619$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $f70f7eb6404ce619$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $f70f7eb6404ce619$var$WebGLShaderStage {
    constructor(code){
        this.id = $f70f7eb6404ce619$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $f70f7eb6404ce619$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new $f70f7eb6404ce619$export$89312ce47c0ca777();
    const _customShaders = new $f70f7eb6404ce619$var$WebGLShaderCache();
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === $f70f7eb6404ce619$export$dbf3e70ff37af79 ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $f70f7eb6404ce619$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const useAlphaTest = material.alphaTest > 0;
        const useClearcoat = material.clearcoat > 0;
        const useIridescence = material.iridescence > 0;
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : $f70f7eb6404ce619$export$7207336e4151a112,
            map: !!material.map,
            matcap: !!material.matcap,
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            lightMap: !!material.lightMap,
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === $f70f7eb6404ce619$export$9990ad26f9db5b2c,
            tangentSpaceNormalMap: material.normalMapType === $f70f7eb6404ce619$export$2852a58ebdac27b8,
            decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === $f70f7eb6404ce619$export$f32388edbb32674,
            clearcoat: useClearcoat,
            clearcoatMap: useClearcoat && !!material.clearcoatMap,
            clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
            iridescence: useIridescence,
            iridescenceMap: useIridescence && !!material.iridescenceMap,
            iridescenceThicknessMap: useIridescence && !!material.iridescenceThicknessMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            specularIntensityMap: !!material.specularIntensityMap,
            specularColorMap: !!material.specularColorMap,
            opaque: material.transparent === false && material.blending === $f70f7eb6404ce619$export$5b29a26d96ee6af0,
            alphaMap: !!material.alphaMap,
            alphaTest: useAlphaTest,
            gradientMap: !!material.gradientMap,
            sheen: material.sheen > 0,
            sheenColorMap: !!material.sheenColorMap,
            sheenRoughnessMap: !!material.sheenRoughnessMap,
            transmission: material.transmission > 0,
            transmissionMap: !!material.transmissionMap,
            thicknessMap: !!material.thicknessMap,
            combine: material.combine,
            vertexTangents: !!material.normalMap && !!geometry.attributes.tangent,
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.iridescenceMap || !!material.iridescenceThicknessMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: fog && fog.isFogExp2,
            flatShading: !!material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : $f70f7eb6404ce619$export$9fcb6b4294603b2,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === $f70f7eb6404ce619$export$3b296b6f144d5b03,
            flipSided: material.side === $f70f7eb6404ce619$export$d9f0486e75b5ace,
            useDepthPacking: !!material.depthPacking,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputEncoding);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputEncoding);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.combine);
        array.push(parameters.vertexUvs);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.isWebGL2) _programLayers.enable(0);
        if (parameters.supportsVertexTextures) _programLayers.enable(1);
        if (parameters.instancing) _programLayers.enable(2);
        if (parameters.instancingColor) _programLayers.enable(3);
        if (parameters.map) _programLayers.enable(4);
        if (parameters.matcap) _programLayers.enable(5);
        if (parameters.envMap) _programLayers.enable(6);
        if (parameters.lightMap) _programLayers.enable(7);
        if (parameters.aoMap) _programLayers.enable(8);
        if (parameters.emissiveMap) _programLayers.enable(9);
        if (parameters.bumpMap) _programLayers.enable(10);
        if (parameters.normalMap) _programLayers.enable(11);
        if (parameters.objectSpaceNormalMap) _programLayers.enable(12);
        if (parameters.tangentSpaceNormalMap) _programLayers.enable(13);
        if (parameters.clearcoat) _programLayers.enable(14);
        if (parameters.clearcoatMap) _programLayers.enable(15);
        if (parameters.clearcoatRoughnessMap) _programLayers.enable(16);
        if (parameters.clearcoatNormalMap) _programLayers.enable(17);
        if (parameters.iridescence) _programLayers.enable(18);
        if (parameters.iridescenceMap) _programLayers.enable(19);
        if (parameters.iridescenceThicknessMap) _programLayers.enable(20);
        if (parameters.displacementMap) _programLayers.enable(21);
        if (parameters.specularMap) _programLayers.enable(22);
        if (parameters.roughnessMap) _programLayers.enable(23);
        if (parameters.metalnessMap) _programLayers.enable(24);
        if (parameters.gradientMap) _programLayers.enable(25);
        if (parameters.alphaMap) _programLayers.enable(26);
        if (parameters.alphaTest) _programLayers.enable(27);
        if (parameters.vertexColors) _programLayers.enable(28);
        if (parameters.vertexAlphas) _programLayers.enable(29);
        if (parameters.vertexUvs) _programLayers.enable(30);
        if (parameters.vertexTangents) _programLayers.enable(31);
        if (parameters.uvsVertexOnly) _programLayers.enable(32);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.skinning) _programLayers.enable(4);
        if (parameters.morphTargets) _programLayers.enable(5);
        if (parameters.morphNormals) _programLayers.enable(6);
        if (parameters.morphColors) _programLayers.enable(7);
        if (parameters.premultipliedAlpha) _programLayers.enable(8);
        if (parameters.shadowMapEnabled) _programLayers.enable(9);
        if (parameters.physicallyCorrectLights) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.specularIntensityMap) _programLayers.enable(15);
        if (parameters.specularColorMap) _programLayers.enable(16);
        if (parameters.transmission) _programLayers.enable(17);
        if (parameters.transmissionMap) _programLayers.enable(18);
        if (parameters.thicknessMap) _programLayers.enable(19);
        if (parameters.sheen) _programLayers.enable(20);
        if (parameters.sheenColorMap) _programLayers.enable(21);
        if (parameters.sheenRoughnessMap) _programLayers.enable(22);
        if (parameters.decodeVideoTexture) _programLayers.enable(23);
        if (parameters.opaque) _programLayers.enable(24);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $f70f7eb6404ce619$export$bee4a7d47f8f5014[shaderID];
            uniforms = $f70f7eb6404ce619$export$d8ecdf8615bfea69.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $f70f7eb6404ce619$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $f70f7eb6404ce619$var$WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $f70f7eb6404ce619$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $f70f7eb6404ce619$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $f70f7eb6404ce619$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $f70f7eb6404ce619$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $f70f7eb6404ce619$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $f70f7eb6404ce619$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $f70f7eb6404ce619$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $f70f7eb6404ce619$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $f70f7eb6404ce619$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $f70f7eb6404ce619$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        color: new $f70f7eb6404ce619$export$892596cec99bc70e()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        direction: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        color: new $f70f7eb6404ce619$export$892596cec99bc70e(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        color: new $f70f7eb6404ce619$export$892596cec99bc70e(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        skyColor: new $f70f7eb6404ce619$export$892596cec99bc70e(),
                        groundColor: new $f70f7eb6404ce619$export$892596cec99bc70e()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new $f70f7eb6404ce619$export$892596cec99bc70e(),
                        position: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        halfWidth: new $f70f7eb6404ce619$export$64b5c384219d3699(),
                        halfHeight: new $f70f7eb6404ce619$export$64b5c384219d3699()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $f70f7eb6404ce619$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $f70f7eb6404ce619$export$c977b3e384af9ae1()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $f70f7eb6404ce619$export$c977b3e384af9ae1()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new $f70f7eb6404ce619$export$c977b3e384af9ae1(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $f70f7eb6404ce619$var$nextVersion = 0;
function $f70f7eb6404ce619$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $f70f7eb6404ce619$var$WebGLLights(extensions, capabilities) {
    const cache = new $f70f7eb6404ce619$var$UniformsCache();
    const shadowCache = $f70f7eb6404ce619$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new $f70f7eb6404ce619$export$64b5c384219d3699());
    const vector3 = new $f70f7eb6404ce619$export$64b5c384219d3699();
    const matrix4 = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
    const matrix42 = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
    function setup(lights, physicallyCorrectLights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($f70f7eb6404ce619$var$shadowCastingAndTexturingLightsFirst);
        // artist-friendly light intensity scaling factor
        const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity * scaleFactor;
                g += color.g * intensity * scaleFactor;
                b += color.b * intensity * scaleFactor;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = $f70f7eb6404ce619$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $f70f7eb6404ce619$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = $f70f7eb6404ce619$export$6643083551874bf5.LTC_FLOAT_1;
                    state.rectAreaLTC2 = $f70f7eb6404ce619$export$6643083551874bf5.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = $f70f7eb6404ce619$export$6643083551874bf5.LTC_HALF_1;
                    state.rectAreaLTC2 = $f70f7eb6404ce619$export$6643083551874bf5.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            state.version = $f70f7eb6404ce619$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $f70f7eb6404ce619$var$WebGLRenderState(extensions, capabilities) {
    const lights = new $f70f7eb6404ce619$var$WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights(physicallyCorrectLights) {
        lights.setup(lightsArray, physicallyCorrectLights);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $f70f7eb6404ce619$var$WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $f70f7eb6404ce619$var$WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $f70f7eb6404ce619$var$WebGLRenderState(extensions, capabilities);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
class $f70f7eb6404ce619$export$2698c22ec13825db extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $f70f7eb6404ce619$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $f70f7eb6404ce619$export$33e187ed002f2a19 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.referencePosition = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nearDistance = 1;
        this.farDistance = 1000;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.referencePosition.copy(source.referencePosition);
        this.nearDistance = source.nearDistance;
        this.farDistance = source.farDistance;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
const $f70f7eb6404ce619$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $f70f7eb6404ce619$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $f70f7eb6404ce619$var$WebGLShadowMap(_renderer, _objects, _capabilities) {
    let _frustum = new $f70f7eb6404ce619$export$35efe6f4c85463d2();
    const _shadowMapSize = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), _viewportSize = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), _viewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3(), _depthMaterial = new $f70f7eb6404ce619$export$2698c22ec13825db({
        depthPacking: $f70f7eb6404ce619$export$8f910f4c4f73df11
    }), _distanceMaterial = new $f70f7eb6404ce619$export$33e187ed002f2a19(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
    const shadowSide = {
        0: $f70f7eb6404ce619$export$d9f0486e75b5ace,
        1: $f70f7eb6404ce619$export$2ede184fc2998901,
        2: $f70f7eb6404ce619$export$3b296b6f144d5b03
    };
    const shadowMaterialVertical = new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $f70f7eb6404ce619$export$c977b3e384af9ae1()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $f70f7eb6404ce619$var$vertex,
        fragmentShader: $f70f7eb6404ce619$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new $f70f7eb6404ce619$export$b7be63a67df8959();
    fullScreenTri.setAttribute('position', new $f70f7eb6404ce619$export$8dea267bd6bde117(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new $f70f7eb6404ce619$export$e176487c05830cc5(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = $f70f7eb6404ce619$export$5813f879eee7cd88;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending($f70f7eb6404ce619$export$63b8d6b580fc65ba);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null) {
                const pars = this.type !== $f70f7eb6404ce619$export$896ae1ade6c829c4 ? {
                    minFilter: $f70f7eb6404ce619$export$727aa5ec3fe39bf0,
                    magFilter: $f70f7eb6404ce619$export$727aa5ec3fe39bf0
                } : {};
                shadow.map = new $f70f7eb6404ce619$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === $f70f7eb6404ce619$export$896ae1ade6c829c4) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new $f70f7eb6404ce619$export$3c052beb2e51e23f(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === $f70f7eb6404ce619$export$896ae1ade6c829c4) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === $f70f7eb6404ce619$export$896ae1ade6c829c4) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function $f70f7eb6404ce619$var$WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
        let currentColorMask = null;
        const currentColorClear = new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case $f70f7eb6404ce619$export$69025ce147cee220:
                            gl.depthFunc(512);
                            break;
                        case $f70f7eb6404ce619$export$7182eb52ea3b3f04:
                            gl.depthFunc(519);
                            break;
                        case $f70f7eb6404ce619$export$eedccec66ab7ebe:
                            gl.depthFunc(513);
                            break;
                        case $f70f7eb6404ce619$export$296f78a0b892f81a:
                            gl.depthFunc(515);
                            break;
                        case $f70f7eb6404ce619$export$a60d398fc7b7590e:
                            gl.depthFunc(514);
                            break;
                        case $f70f7eb6404ce619$export$7d7234c1240a1fc4:
                            gl.depthFunc(518);
                            break;
                        case $f70f7eb6404ce619$export$c5e2c52991f30937:
                            gl.depthFunc(516);
                            break;
                        case $f70f7eb6404ce619$export$2f843afa843d8916:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgamMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(3088);
    const viewportParam = gl.getParameter(2978);
    const currentScissor = new $f70f7eb6404ce619$export$fa7daccca11cdbe3().fromArray(scissorParam);
    const currentViewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3().fromArray(viewportParam);
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc($f70f7eb6404ce619$export$296f78a0b892f81a);
    setFlipSided(false);
    setCullFace($f70f7eb6404ce619$export$b9a7b4fc5cb15f9b);
    enable(2884);
    setBlending($f70f7eb6404ce619$export$63b8d6b580fc65ba);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            if (isWebGL2) {
                // 36009 is equivalent to 36160
                if (target === 36009) currentBoundFramebuffers[36160] = framebuffer;
                if (target === 36160) currentBoundFramebuffers[36009] = framebuffer;
            }
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            if (renderTarget.isWebGLMultipleRenderTargets) {
                const textures = renderTarget.texture;
                if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
                    for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = 36064 + i;
                    drawBuffers.length = textures.length;
                    needsUpdate = true;
                }
            } else if (drawBuffers[0] !== 36064) {
                drawBuffers[0] = 36064;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== 1029) {
            drawBuffers[0] = 1029;
            needsUpdate = true;
        }
        if (needsUpdate) {
            if (capabilities.isWebGL2) gl.drawBuffers(drawBuffers);
            else extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [$f70f7eb6404ce619$export$20183a0484ce21a0]: 32774,
        [$f70f7eb6404ce619$export$73e0df5177988548]: 32778,
        [$f70f7eb6404ce619$export$28e582859cbec660]: 32779
    };
    if (isWebGL2) {
        equationToGL[$f70f7eb6404ce619$export$c8c1508da8d0600c] = 32775;
        equationToGL[$f70f7eb6404ce619$export$99948c02fb51055f] = 32776;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[$f70f7eb6404ce619$export$c8c1508da8d0600c] = extension.MIN_EXT;
            equationToGL[$f70f7eb6404ce619$export$99948c02fb51055f] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [$f70f7eb6404ce619$export$2110f05edf778d3d]: 0,
        [$f70f7eb6404ce619$export$8805bad65e24940e]: 1,
        [$f70f7eb6404ce619$export$7fbe15b28d28cf52]: 768,
        [$f70f7eb6404ce619$export$d5773124e86cf28c]: 770,
        [$f70f7eb6404ce619$export$c05e2a1fc8609506]: 776,
        [$f70f7eb6404ce619$export$ef5f2dd8ffac5574]: 774,
        [$f70f7eb6404ce619$export$a78aed1ca2a87192]: 772,
        [$f70f7eb6404ce619$export$947829af9f2c17f6]: 769,
        [$f70f7eb6404ce619$export$11d468cc7f19e971]: 771,
        [$f70f7eb6404ce619$export$56b85b2686ab16]: 775,
        [$f70f7eb6404ce619$export$5d0fe17fd8773bac]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === $f70f7eb6404ce619$export$63b8d6b580fc65ba) {
            if (currentBlendingEnabled === true) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== $f70f7eb6404ce619$export$eda4864c68df1fa2) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== $f70f7eb6404ce619$export$20183a0484ce21a0 || currentBlendEquationAlpha !== $f70f7eb6404ce619$export$20183a0484ce21a0) {
                    gl.blendEquation(32774);
                    currentBlendEquation = $f70f7eb6404ce619$export$20183a0484ce21a0;
                    currentBlendEquationAlpha = $f70f7eb6404ce619$export$20183a0484ce21a0;
                }
                if (premultipliedAlpha) switch(blending){
                    case $f70f7eb6404ce619$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case $f70f7eb6404ce619$export$777d8f9551c2216b:
                        gl.blendFunc(1, 1);
                        break;
                    case $f70f7eb6404ce619$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $f70f7eb6404ce619$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case $f70f7eb6404ce619$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case $f70f7eb6404ce619$export$777d8f9551c2216b:
                        gl.blendFunc(770, 1);
                        break;
                    case $f70f7eb6404ce619$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case $f70f7eb6404ce619$export$4138e1c684b46a20:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === $f70f7eb6404ce619$export$3b296b6f144d5b03 ? disable(2884) : enable(2884);
        let flipSided = material.side === $f70f7eb6404ce619$export$d9f0486e75b5ace;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === $f70f7eb6404ce619$export$5b29a26d96ee6af0 && material.transparent === false ? setBlending($f70f7eb6404ce619$export$63b8d6b580fc65ba) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(32926) : disable(32926);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== $f70f7eb6404ce619$export$3237e1f2c1ea1f44) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === $f70f7eb6404ce619$export$b9a7b4fc5cb15f9b) gl.cullFace(1029);
                else if (cullFace === $f70f7eb6404ce619$export$b8058bcc7037d3f3) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgamMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgamMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgamMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(uniformsGroup) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(uniformsGroup, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(3042);
        gl.disable(2884);
        gl.disable(2929);
        gl.disable(32823);
        gl.disable(3089);
        gl.disable(2960);
        gl.disable(32926);
        gl.blendEquation(32774);
        gl.blendFunc(1, 0);
        gl.blendFuncSeparate(1, 0, 1, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(513);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(519, 0, 0xffffffff);
        gl.stencilOp(7680, 7680, 7680);
        gl.clearStencil(0);
        gl.cullFace(1029);
        gl.frontFace(2305);
        gl.polygonOffset(0, 0);
        gl.activeTexture(33984);
        gl.bindFramebuffer(36160, null);
        if (isWebGL2 === true) {
            gl.bindFramebuffer(36009, null);
            gl.bindFramebuffer(36008, null);
        }
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $f70f7eb6404ce619$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = /OculusBrowser/g.test(navigator.userAgent);
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : $f70f7eb6404ce619$var$createElementNS('canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? $f70f7eb6404ce619$var$floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo$1(image) {
        return $f70f7eb6404ce619$var$isPowerOfTwo(image.width) && $f70f7eb6404ce619$var$isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== $f70f7eb6404ce619$export$9d9334239a5a5e06 || texture.wrapT !== $f70f7eb6404ce619$export$9d9334239a5a5e06 || texture.minFilter !== $f70f7eb6404ce619$export$727aa5ec3fe39bf0 && texture.minFilter !== $f70f7eb6404ce619$export$8a72f490b25c56c8;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== $f70f7eb6404ce619$export$727aa5ec3fe39bf0 && texture.minFilter !== $f70f7eb6404ce619$export$8a72f490b25c56c8;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getInternalFormat(internalFormatName, glFormat, glType, encoding, isVideoTexture = false) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 33319) {
            if (glType === 5126) internalFormat = 33328;
            if (glType === 5131) internalFormat = 33327;
            if (glType === 5121) internalFormat = 33323;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = encoding === $f70f7eb6404ce619$export$f32388edbb32674 && isVideoTexture === false ? 35907 : 32856;
            if (glType === 32819) internalFormat = 32854;
            if (glType === 32820) internalFormat = 32855;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getMipLevels(texture, image, supportsMips) {
        if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== $f70f7eb6404ce619$export$727aa5ec3fe39bf0 && texture.minFilter !== $f70f7eb6404ce619$export$8a72f490b25c56c8) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === $f70f7eb6404ce619$export$727aa5ec3fe39bf0 || f === $f70f7eb6404ce619$export$d129e38cf6feaa8c || f === $f70f7eb6404ce619$export$d2327c1afe5bfdf2) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglTexture !== undefined) {
            _gl.deleteTexture(textureProperties.__webglTexture);
            info.memory.textures--;
        }
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        if (renderTarget.isWebGLMultipleRenderTargets) for(let i = 0, il = texture.length; i < il; i++){
            const attachmentProperties = properties.get(texture[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(texture[i]);
        }
        properties.remove(texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.encoding);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [$f70f7eb6404ce619$export$533346c8e8dac0f5]: 10497,
        [$f70f7eb6404ce619$export$9d9334239a5a5e06]: 33071,
        [$f70f7eb6404ce619$export$c7e7c00b14f51a4f]: 33648
    };
    const filterToGL = {
        [$f70f7eb6404ce619$export$727aa5ec3fe39bf0]: 9728,
        [$f70f7eb6404ce619$export$d129e38cf6feaa8c]: 9984,
        [$f70f7eb6404ce619$export$d2327c1afe5bfdf2]: 9986,
        [$f70f7eb6404ce619$export$8a72f490b25c56c8]: 9729,
        [$f70f7eb6404ce619$export$19a719f377145a13]: 9985,
        [$f70f7eb6404ce619$export$5d8599b6a933fb1b]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== $f70f7eb6404ce619$export$9d9334239a5a5e06 || texture.wrapT !== $f70f7eb6404ce619$export$9d9334239a5a5e06) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== $f70f7eb6404ce619$export$727aa5ec3fe39bf0 && texture.minFilter !== $f70f7eb6404ce619$export$8a72f490b25c56c8) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            if (texture.type === $f70f7eb6404ce619$export$f6d331659b644596 && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2
            if (isWebGL2 === false && texture.type === $f70f7eb6404ce619$export$2697304443f382bc && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataArrayTexture) textureType = 35866;
        if (texture.isData3DTexture) textureType = 32879;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        if (source.version !== source.__currentVersion || forceUpload === true) {
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
            let image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
            image = verifyColorSpace(texture, image);
            const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding);
            let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
            setTextureParameters(textureType, texture, supportsMips);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = source.__currentVersion === undefined || forceUpload === true;
            const levels = getMipLevels(texture, image, supportsMips);
            if (texture.isDepthTexture) {
                // populate depth texture with dummy data
                glInternalFormat = 6402;
                if (isWebGL2) {
                    if (texture.type === $f70f7eb6404ce619$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (texture.type === $f70f7eb6404ce619$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                    else if (texture.type === $f70f7eb6404ce619$export$6c8ea339bfab1301) glInternalFormat = 35056;
                    else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
                } else if (texture.type === $f70f7eb6404ce619$export$f6d331659b644596) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
                // validation checks for WebGL 1
                if (texture.format === $f70f7eb6404ce619$export$c1b6b5136be58045 && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                {
                    if (texture.type !== $f70f7eb6404ce619$export$c63dc51868b06a9d && texture.type !== $f70f7eb6404ce619$export$c3c7fc4518ebba96) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                        texture.type = $f70f7eb6404ce619$export$c3c7fc4518ebba96;
                        glType = utils.convert(texture.type);
                    }
                }
                if (texture.format === $f70f7eb6404ce619$export$1e113ac2d0905829 && glInternalFormat === 6402) {
                    // Depth stencil textures need the DEPTH_STENCIL internal format
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    glInternalFormat = 34041;
                    // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                    // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                    // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                    if (texture.type !== $f70f7eb6404ce619$export$6c8ea339bfab1301) {
                        console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                        texture.type = $f70f7eb6404ce619$export$6c8ea339bfab1301;
                        glType = utils.convert(texture.type);
                    }
                }
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    if (texture.format !== $f70f7eb6404ce619$export$3f8bb04b555a363c) {
                        if (glFormat !== null) {
                            if (useTexStorage) state.compressedTexSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                            else state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                    } else if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                    else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
                    state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(3553, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0 && supportsMips) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) state.texSubImage2D(3553, i, 0, 0, glFormat, glType, mipmap);
                        else state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
                    state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType);
            source.__currentVersion = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        if (source.version !== source.__currentVersion || forceUpload === true) {
            _gl.pixelStorei(37440, texture.flipY);
            _gl.pixelStorei(37441, texture.premultiplyAlpha);
            _gl.pixelStorei(3317, texture.unpackAlignment);
            _gl.pixelStorei(37443, 0);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils.convert(texture.format, texture.encoding), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
            const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
            const allocateMemory = source.__currentVersion === undefined || forceUpload === true;
            let levels = getMipLevels(texture, image, supportsMips);
            setTextureParameters(34067, texture, supportsMips);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== $f70f7eb6404ce619$export$3f8bb04b555a363c) {
                            if (glFormat !== null) {
                                if (useTexStorage) state.compressedTexSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                else state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else if (useTexStorage) state.texSubImage2D(34069 + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) state.texSubImage2D(34069 + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    else state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) state.texSubImage2D(34069 + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        else state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
            generateMipmap(34067);
            source.__currentVersion = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
        const glFormat = utils.convert(texture.format, texture.encoding);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const renderTargetProperties = properties.get(renderTarget);
        if (!renderTargetProperties.__hasExternalTextures) {
            if (textureTarget === 32879 || textureTarget === 35866) state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(36160, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
        state.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample || useMultisampledRTT(renderTarget)) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === $f70f7eb6404ce619$export$f6d331659b644596) glInternalFormat = 36012;
                    else if (depthTexture.type === $f70f7eb6404ce619$export$c3c7fc4518ebba96) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            const samples = getRenderTargetSamples(renderTarget);
            if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
                renderTarget.texture
            ];
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.encoding);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === $f70f7eb6404ce619$export$c1b6b5136be58045) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === $f70f7eb6404ce619$export$1e113ac2d0905829) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        state.bindFramebuffer(36160, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        if (renderTarget.isWebGLMultipleRenderTargets !== true) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) {
                if (capabilities.drawBuffers) {
                    const textures = renderTarget.texture;
                    for(let i = 0, il = textures.length; i < il; i++){
                        const attachmentProperties = properties.get(textures[i]);
                        if (attachmentProperties.__webglTexture === undefined) {
                            attachmentProperties.__webglTexture = _gl.createTexture();
                            info.memory.textures++;
                        }
                    }
                } else console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
            }
            if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                const textures = isMultipleRenderTargets ? texture : [
                    texture
                ];
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.encoding);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(36161, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(36160, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(34067);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            const textures = renderTarget.texture;
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(3553, attachmentProperties.__webglTexture);
                setTextureParameters(3553, attachment, supportsMips);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i, 3553);
                if (textureNeedsGenerateMipmaps(attachment, supportsMips)) generateMipmap(3553);
            }
            state.unbindTexture();
        } else {
            let glTextureType = 3553;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
                if (isWebGL2) glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
                else console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
            }
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
        const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [
            renderTarget.texture
        ];
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
                const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(target, webglTexture);
                generateMipmap(target);
                state.unbindTexture();
            }
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
            const textures = renderTarget.isWebGLMultipleRenderTargets ? renderTarget.texture : [
                renderTarget.texture
            ];
            const width = renderTarget.width;
            const height = renderTarget.height;
            let mask = 16384;
            const invalidationArray = [];
            const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
            const renderTargetProperties = properties.get(renderTarget);
            const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
            // If MRT we need to remove FBO attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, null);
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, null, 0);
            }
            state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
            state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
            for(let i = 0; i < textures.length; i++){
                invalidationArray.push(36064 + i);
                if (renderTarget.depthBuffer) invalidationArray.push(depthStyle);
                const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;
                if (ignoreDepthValues === false) {
                    if (renderTarget.depthBuffer) mask |= 256;
                    if (renderTarget.stencilBuffer) mask |= 1024;
                }
                if (isMultipleRenderTargets) _gl.framebufferRenderbuffer(36008, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                if (ignoreDepthValues === true) {
                    _gl.invalidateFramebuffer(36008, [
                        depthStyle
                    ]);
                    _gl.invalidateFramebuffer(36009, [
                        depthStyle
                    ]);
                }
                if (isMultipleRenderTargets) {
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    _gl.framebufferTexture2D(36009, 36064, 3553, webglTexture, 0);
                }
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                if (supportsInvalidateFramebuffer) _gl.invalidateFramebuffer(36008, invalidationArray);
            }
            state.bindFramebuffer(36008, null);
            state.bindFramebuffer(36009, null);
            // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
            if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.framebufferRenderbuffer(36160, 36064 + i, 36161, renderTargetProperties.__webglColorRenderbuffer[i]);
                const webglTexture = properties.get(textures[i]).__webglTexture;
                state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
                _gl.framebufferTexture2D(36009, 36064 + i, 3553, webglTexture, 0);
            }
            state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const encoding = texture.encoding;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === $f70f7eb6404ce619$export$ca1dce8b5e1de74d) return image;
        if (encoding !== $f70f7eb6404ce619$export$7207336e4151a112) {
            // sRGB
            if (encoding === $f70f7eb6404ce619$export$f32388edbb32674) {
                if (isWebGL2 === false) {
                    // in WebGL 1, try to use EXT_sRGB extension and unsized formats
                    if (extensions.has('EXT_sRGB') === true && format === $f70f7eb6404ce619$export$3f8bb04b555a363c) {
                        texture.format = $f70f7eb6404ce619$export$ca1dce8b5e1de74d;
                        // it's not possible to generate mips in WebGL 1 with this extension
                        texture.minFilter = $f70f7eb6404ce619$export$8a72f490b25c56c8;
                        texture.generateMipmaps = false;
                    } else // slow fallback (CPU decode)
                    image = $f70f7eb6404ce619$export$698882cf06df44aa.sRGBToLinear(image);
                } else // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
                if (format !== $f70f7eb6404ce619$export$3f8bb04b555a363c || type !== $f70f7eb6404ce619$export$2e8ce08d3f6f5e10) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture encoding:', encoding);
        }
        return image;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $f70f7eb6404ce619$export$ddaebcad857649a8(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p, encoding = null) {
        let extension;
        if (p === $f70f7eb6404ce619$export$2e8ce08d3f6f5e10) return 5121;
        if (p === $f70f7eb6404ce619$export$b3969b01faf587f2) return 32819;
        if (p === $f70f7eb6404ce619$export$18886f8ae33e90de) return 32820;
        if (p === $f70f7eb6404ce619$export$545fce0311a9796a) return 5120;
        if (p === $f70f7eb6404ce619$export$88572337f312435f) return 5122;
        if (p === $f70f7eb6404ce619$export$c63dc51868b06a9d) return 5123;
        if (p === $f70f7eb6404ce619$export$5c612977753abe2) return 5124;
        if (p === $f70f7eb6404ce619$export$c3c7fc4518ebba96) return 5125;
        if (p === $f70f7eb6404ce619$export$f6d331659b644596) return 5126;
        if (p === $f70f7eb6404ce619$export$2697304443f382bc) {
            if (isWebGL2) return 5131;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === $f70f7eb6404ce619$export$988473390501ed4b) return 6406;
        if (p === $f70f7eb6404ce619$export$3f8bb04b555a363c) return 6408;
        if (p === $f70f7eb6404ce619$export$cc09ccbf6d1ed449) return 6409;
        if (p === $f70f7eb6404ce619$export$9053a81c4a69c289) return 6410;
        if (p === $f70f7eb6404ce619$export$c1b6b5136be58045) return 6402;
        if (p === $f70f7eb6404ce619$export$1e113ac2d0905829) return 34041;
        if (p === $f70f7eb6404ce619$export$4e041a7967d15c4b) return 6403;
        // @deprecated since r137
        if (p === $f70f7eb6404ce619$export$7c67423a5ee6f5eb) {
            console.warn('THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228');
            return 6408;
        }
        // WebGL 1 sRGB fallback
        if (p === $f70f7eb6404ce619$export$ca1dce8b5e1de74d) {
            extension = extensions.get('EXT_sRGB');
            if (extension !== null) return extension.SRGB_ALPHA_EXT;
            else return null;
        }
        // WebGL2 formats.
        if (p === $f70f7eb6404ce619$export$aa92e870a709d190) return 36244;
        if (p === $f70f7eb6404ce619$export$6cdf0b461c7ce8a0) return 33319;
        if (p === $f70f7eb6404ce619$export$1ba1c45f9f77d4d7) return 33320;
        if (p === $f70f7eb6404ce619$export$c200e7d26f592f21) return 36249;
        // S3TC
        if (p === $f70f7eb6404ce619$export$21d1799c6d552fc0 || p === $f70f7eb6404ce619$export$afa304c3e981b668 || p === $f70f7eb6404ce619$export$d2a1a68024a3e56c || p === $f70f7eb6404ce619$export$9a79c424327dacf9) {
            if (encoding === $f70f7eb6404ce619$export$f32388edbb32674) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === $f70f7eb6404ce619$export$21d1799c6d552fc0) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === $f70f7eb6404ce619$export$afa304c3e981b668) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === $f70f7eb6404ce619$export$d2a1a68024a3e56c) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === $f70f7eb6404ce619$export$9a79c424327dacf9) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === $f70f7eb6404ce619$export$21d1799c6d552fc0) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === $f70f7eb6404ce619$export$afa304c3e981b668) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === $f70f7eb6404ce619$export$d2a1a68024a3e56c) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === $f70f7eb6404ce619$export$9a79c424327dacf9) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === $f70f7eb6404ce619$export$19ada9bbb1af3573 || p === $f70f7eb6404ce619$export$d0f0355bb3d948e4 || p === $f70f7eb6404ce619$export$b82296714358084c || p === $f70f7eb6404ce619$export$b71692456c47b6c3) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === $f70f7eb6404ce619$export$19ada9bbb1af3573) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === $f70f7eb6404ce619$export$d0f0355bb3d948e4) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === $f70f7eb6404ce619$export$b82296714358084c) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === $f70f7eb6404ce619$export$b71692456c47b6c3) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC1
        if (p === $f70f7eb6404ce619$export$6ab91af2d757aee7) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        // ETC2
        if (p === $f70f7eb6404ce619$export$7800993ef8106a6a || p === $f70f7eb6404ce619$export$23ed8300a860e7d8) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === $f70f7eb6404ce619$export$7800993ef8106a6a) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === $f70f7eb6404ce619$export$23ed8300a860e7d8) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === $f70f7eb6404ce619$export$dc5570b4a2b92d48 || p === $f70f7eb6404ce619$export$68880cd325f8b2fb || p === $f70f7eb6404ce619$export$7d2c0be323373d95 || p === $f70f7eb6404ce619$export$22b52da301fc3a3e || p === $f70f7eb6404ce619$export$c009e2cb4a66485e || p === $f70f7eb6404ce619$export$118fff5afa255b63 || p === $f70f7eb6404ce619$export$120713c829ae0667 || p === $f70f7eb6404ce619$export$c79eeabbf53313e9 || p === $f70f7eb6404ce619$export$443cf6567cdd6424 || p === $f70f7eb6404ce619$export$6573984fc9840780 || p === $f70f7eb6404ce619$export$e7aee563f30091de || p === $f70f7eb6404ce619$export$2eb8634622ddeab7 || p === $f70f7eb6404ce619$export$202b1ce7b5d25742 || p === $f70f7eb6404ce619$export$18ab77abd087e467) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === $f70f7eb6404ce619$export$dc5570b4a2b92d48) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === $f70f7eb6404ce619$export$68880cd325f8b2fb) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === $f70f7eb6404ce619$export$7d2c0be323373d95) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === $f70f7eb6404ce619$export$22b52da301fc3a3e) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === $f70f7eb6404ce619$export$c009e2cb4a66485e) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === $f70f7eb6404ce619$export$118fff5afa255b63) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === $f70f7eb6404ce619$export$120713c829ae0667) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === $f70f7eb6404ce619$export$c79eeabbf53313e9) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === $f70f7eb6404ce619$export$443cf6567cdd6424) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === $f70f7eb6404ce619$export$6573984fc9840780) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === $f70f7eb6404ce619$export$e7aee563f30091de) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === $f70f7eb6404ce619$export$2eb8634622ddeab7) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === $f70f7eb6404ce619$export$202b1ce7b5d25742) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === $f70f7eb6404ce619$export$18ab77abd087e467) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === $f70f7eb6404ce619$export$ce40b115e188bc81) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === $f70f7eb6404ce619$export$ce40b115e188bc81) return encoding === $f70f7eb6404ce619$export$f32388edbb32674 ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        //
        if (p === $f70f7eb6404ce619$export$6c8ea339bfab1301) {
            if (isWebGL2) return 34042;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
class $f70f7eb6404ce619$export$56b937d9e5581166 extends $f70f7eb6404ce619$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $f70f7eb6404ce619$export$eb2fcfdbd7ba97d4 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
const $f70f7eb6404ce619$var$_moveEvent = {
    type: 'move'
};
class $f70f7eb6404ce619$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new $f70f7eb6404ce619$export$eb2fcfdbd7ba97d4();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new $f70f7eb6404ce619$export$eb2fcfdbd7ba97d4();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new $f70f7eb6404ce619$export$64b5c384219d3699();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new $f70f7eb6404ce619$export$64b5c384219d3699();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new $f70f7eb6404ce619$export$eb2fcfdbd7ba97d4();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new $f70f7eb6404ce619$export$64b5c384219d3699();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new $f70f7eb6404ce619$export$64b5c384219d3699();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new $f70f7eb6404ce619$export$eb2fcfdbd7ba97d4();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($f70f7eb6404ce619$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
}
class $f70f7eb6404ce619$export$fc830aa069cc8c2f extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format){
        format = format !== undefined ? format : $f70f7eb6404ce619$export$c1b6b5136be58045;
        if (format !== $f70f7eb6404ce619$export$c1b6b5136be58045 && format !== $f70f7eb6404ce619$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $f70f7eb6404ce619$export$c1b6b5136be58045) type = $f70f7eb6404ce619$export$c3c7fc4518ebba96;
        if (type === undefined && format === $f70f7eb6404ce619$export$1e113ac2d0905829) type = $f70f7eb6404ce619$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
    }
}
class $f70f7eb6404ce619$var$WebXRManager extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        //
        const cameraL = new $f70f7eb6404ce619$export$74e4ae24825f68d7();
        cameraL.layers.enable(1);
        cameraL.viewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
        const cameraR = new $f70f7eb6404ce619$export$74e4ae24825f68d7();
        cameraR.layers.enable(2);
        cameraR.viewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraVR = new $f70f7eb6404ce619$export$56b937d9e5581166();
        cameraVR.layers.enable(1);
        cameraVR.layers.enable(2);
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $f70f7eb6404ce619$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $f70f7eb6404ce619$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $f70f7eb6404ce619$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) controller.dispatchEvent({
                type: event.type,
                data: event.inputSource
            });
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                    const layerInit = {
                        antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                        alpha: attributes.alpha,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    newRenderTarget = new $f70f7eb6404ce619$export$3c052beb2e51e23f(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: $f70f7eb6404ce619$export$3f8bb04b555a363c,
                        type: $f70f7eb6404ce619$export$2e8ce08d3f6f5e10,
                        encoding: renderer.outputEncoding,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? 35056 : 33190;
                        depthFormat = attributes.stencil ? $f70f7eb6404ce619$export$1e113ac2d0905829 : $f70f7eb6404ce619$export$c1b6b5136be58045;
                        depthType = attributes.stencil ? $f70f7eb6404ce619$export$6c8ea339bfab1301 : $f70f7eb6404ce619$export$c3c7fc4518ebba96;
                    }
                    const projectionlayerInit = {
                        colorFormat: 32856,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    newRenderTarget = new $f70f7eb6404ce619$export$3c052beb2e51e23f(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: $f70f7eb6404ce619$export$3f8bb04b555a363c,
                        type: $f70f7eb6404ce619$export$2e8ce08d3f6f5e10,
                        depthTexture: new $f70f7eb6404ce619$export$fc830aa069cc8c2f(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        encoding: renderer.outputEncoding,
                        samples: attributes.antialias ? 4 : 0
                    });
                    const renderTargetProperties = renderer.properties.get(newRenderTarget);
                    renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                // Set foveation to maximum.
                this.setFoveation(1.0);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].dispatchEvent({
                        type: 'disconnected',
                        data: inputSource
                    });
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.dispatchEvent({
                    type: 'connected',
                    data: inputSource
                });
            }
        }
        //
        const cameraLPos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const cameraRPos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Find the union of the frustum values of the cameras and scale
            // the values so that the near plane's position does not change in world space,
            // although must now be relative to the new union camera.
            const near2 = near + zOffset;
            const far2 = far + zOffset;
            const left2 = left - xOffset;
            const right2 = right + (ipd - xOffset);
            const top2 = topFov * far / far2 * near2;
            const bottom2 = bottomFov * far / far2 * near2;
            camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            cameraVR.near = cameraR.near = cameraL.near = camera.near;
            cameraVR.far = cameraR.far = cameraL.far = camera.far;
            if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraVR.near,
                    depthFar: cameraVR.far
                });
                _currentDepthNear = cameraVR.near;
                _currentDepthFar = cameraVR.far;
            }
            const parent = camera.parent;
            const cameras = cameraVR.cameras;
            updateCamera(cameraVR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
            // update user camera and its children
            camera.matrix.copy(cameraVR.matrix);
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            const children = camera.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        };
        this.getCamera = function() {
            return cameraVR;
        };
        this.getFoveation = function() {
            if (glProjLayer !== null) return glProjLayer.fixedFoveation;
            if (glBaseLayer !== null) return glBaseLayer.fixedFoveation;
            return undefined;
        };
        this.setFoveation = function(foveation) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            if (glProjLayer !== null) glProjLayer.fixedFoveation = foveation;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = foveation;
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraVRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraVR's camera list
                if (views.length !== cameraVR.cameras.length) {
                    cameraVR.cameras.length = 0;
                    cameraVRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new $f70f7eb6404ce619$export$74e4ae24825f68d7();
                        camera.layers.enable(i);
                        camera.viewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) cameraVR.matrix.copy(camera.matrix);
                    if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            xrFrame = null;
        }
        const animation = new $f70f7eb6404ce619$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
function $f70f7eb6404ce619$var$WebGLMaterials(renderer, properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === $f70f7eb6404ce619$export$d9f0486e75b5ace) uniforms.bumpScale.value *= -1;
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === $f70f7eb6404ce619$export$d9f0486e75b5ace) uniforms.normalScale.value.negate();
        }
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            // artist-friendly light intensity scaling factor
            const scaleFactor = renderer.physicallyCorrectLights !== true ? Math.PI : 1;
            uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        // 13. iridescence map
        // 14. iridescence thickness map
        // 15. specular intensity map
        // 16. specular tint map
        // 17. transmission map
        // 18. thickness map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        else if (material.iridescenceMap) uvScaleMap = material.iridescenceMap;
        else if (material.iridescenceThicknessMap) uvScaleMap = material.iridescenceThicknessMap;
        else if (material.specularIntensityMap) uvScaleMap = material.specularIntensityMap;
        else if (material.specularColorMap) uvScaleMap = material.specularColorMap;
        else if (material.transmissionMap) uvScaleMap = material.transmissionMap;
        else if (material.thicknessMap) uvScaleMap = material.thicknessMap;
        else if (material.sheenColorMap) uvScaleMap = material.sheenColorMap;
        else if (material.sheenRoughnessMap) uvScaleMap = material.sheenRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) uniforms.sheenColorMap.value = material.sheenColorMap;
            if (material.sheenRoughnessMap) uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
            if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                if (material.side === $f70f7eb6404ce619$export$d9f0486e75b5ace) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) uniforms.iridescenceMap.value = material.iridescenceMap;
            if (material.iridescenceThicknessMap) uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) uniforms.thicknessMap.value = material.thicknessMap;
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularIntensityMap) uniforms.specularIntensityMap.value = material.specularIntensityMap;
        if (material.specularColorMap) uniforms.specularColorMap.value = material.specularColorMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $f70f7eb6404ce619$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = capabilities.isWebGL2 ? gl.getParameter(35375) : 0; // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(35345, buffer);
        gl.bufferData(35345, size, usage);
        gl.bindBuffer(35345, null);
        gl.bindBufferBase(35345, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(35345, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniform = uniforms[i];
            // partly update the buffer if necessary
            if (hasUniformChanged(uniform, i, cache) === true) {
                const value = uniform.value;
                const offset = uniform.__offset;
                if (typeof value === 'number') {
                    uniform.__data[0] = value;
                    gl.bufferSubData(35345, offset, uniform.__data);
                } else {
                    if (uniform.value.isMatrix3) {
                        // manually converting 3x3 to 3x4
                        uniform.__data[0] = uniform.value.elements[0];
                        uniform.__data[1] = uniform.value.elements[1];
                        uniform.__data[2] = uniform.value.elements[2];
                        uniform.__data[3] = uniform.value.elements[0];
                        uniform.__data[4] = uniform.value.elements[3];
                        uniform.__data[5] = uniform.value.elements[4];
                        uniform.__data[6] = uniform.value.elements[5];
                        uniform.__data[7] = uniform.value.elements[0];
                        uniform.__data[8] = uniform.value.elements[6];
                        uniform.__data[9] = uniform.value.elements[7];
                        uniform.__data[10] = uniform.value.elements[8];
                        uniform.__data[11] = uniform.value.elements[0];
                    } else value.toArray(uniform.__data);
                    gl.bufferSubData(35345, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(35345, null);
    }
    function hasUniformChanged(uniform, index, cache) {
        const value = uniform.value;
        if (cache[index] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number') cache[index] = value;
            else cache[index] = value.clone();
            return true;
        } else {
            // compare current value with cached entry
            if (typeof value === 'number') {
                if (cache[index] !== value) {
                    cache[index] = value;
                    return true;
                }
            } else {
                const cachedObject = cache[index];
                if (cachedObject.equals(value) === false) {
                    cachedObject.copy(value);
                    return true;
                }
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        let chunkOffset = 0; // offset within a single chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniform = uniforms[i];
            const info = getUniformSize(uniform);
            // the following two properties will be used for partial buffer updates
            uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
            uniform.__offset = offset;
            //
            if (i > 0) {
                chunkOffset = offset % chunkSize;
                const remainingSizeInChunk = chunkSize - chunkOffset;
                // check for chunk overflow
                if (chunkOffset !== 0 && remainingSizeInChunk - info.boundary < 0) {
                    // add padding and adjust offset
                    offset += chunkSize - chunkOffset;
                    uniform.__offset = offset;
                }
            }
            offset += info.storage;
        }
        // ensure correct final padding
        chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(uniform) {
        const value = uniform.value;
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number') {
            // float/int
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
function $f70f7eb6404ce619$var$createCanvasElement() {
    const canvas = $f70f7eb6404ce619$var$createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
function $f70f7eb6404ce619$export$f6cc00ef28d7cf97(parameters = {}) {
    this.isWebGLRenderer = true;
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : $f70f7eb6404ce619$var$createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default', _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let _alpha;
    if (_context !== null) _alpha = _context.getContextAttributes().alpha;
    else _alpha = parameters.alpha !== undefined ? parameters.alpha : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its list and state isolated from the parent render call.
    const renderListStack = [];
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.outputEncoding = $f70f7eb6404ce619$export$7207336e4151a112;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = $f70f7eb6404ce619$export$9fcb6b4294603b2;
    this.toneMappingExposure = 1.0;
    //
    Object.defineProperties(this, {
        // @deprecated since r136, 0e21088102b4de7e0a0a33140620b7a3424b9e6d
        gammaFactor: {
            get: function() {
                console.warn('THREE.WebGLRenderer: .gammaFactor has been removed.');
                return 2;
            },
            set: function() {
                console.warn('THREE.WebGLRenderer: .gammaFactor has been removed.');
            }
        }
    });
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
    const _currentScissor = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 0, _width, _height);
    const _scissor = new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new $f70f7eb6404ce619$export$35efe6f4c85463d2();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // transmission
    let _transmissionRenderTarget = null;
    // camera matrices cache
    const _projScreenMatrix = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
    const _vector2 = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
    const _vector3 = new $f70f7eb6404ce619$export$64b5c384219d3699();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: true,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // OffscreenCanvas does not have setAttribute, see #22811
        if ('setAttribute' in _canvas) _canvas.setAttribute('data-engine', `three.js r${$f70f7eb6404ce619$export$3545e07a80636437}`);
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener('webglcontextlost', onContextLost, false);
        _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
        _canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
        if (_gl === null) {
            const contextNames = [
                'webgl2',
                'webgl',
                'experimental-webgl'
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                else throw new Error('Error creating WebGL context.');
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                'rangeMin': 1,
                'rangeMax': 1,
                'precision': 1
            };
        };
    } catch (error) {
        console.error('THREE.WebGLRenderer: ' + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping, shadowMap;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates, uniformsGroups;
    function initGLContext() {
        extensions = new $f70f7eb6404ce619$var$WebGLExtensions(_gl);
        capabilities = new $f70f7eb6404ce619$var$WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new $f70f7eb6404ce619$export$ddaebcad857649a8(_gl, extensions, capabilities);
        state = new $f70f7eb6404ce619$var$WebGLState(_gl, extensions, capabilities);
        info = new $f70f7eb6404ce619$var$WebGLInfo();
        properties = new $f70f7eb6404ce619$var$WebGLProperties();
        textures = new $f70f7eb6404ce619$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new $f70f7eb6404ce619$var$WebGLCubeMaps(_this);
        cubeuvmaps = new $f70f7eb6404ce619$var$WebGLCubeUVMaps(_this);
        attributes = new $f70f7eb6404ce619$var$WebGLAttributes(_gl, capabilities);
        bindingStates = new $f70f7eb6404ce619$var$WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new $f70f7eb6404ce619$var$WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new $f70f7eb6404ce619$var$WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new $f70f7eb6404ce619$var$WebGLMorphtargets(_gl, capabilities, textures);
        clipping = new $f70f7eb6404ce619$var$WebGLClipping(properties);
        programCache = new $f70f7eb6404ce619$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
        materials = new $f70f7eb6404ce619$var$WebGLMaterials(_this, properties);
        renderLists = new $f70f7eb6404ce619$var$WebGLRenderLists();
        renderStates = new $f70f7eb6404ce619$var$WebGLRenderStates(extensions, capabilities);
        background = new $f70f7eb6404ce619$var$WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
        shadowMap = new $f70f7eb6404ce619$var$WebGLShadowMap(_this, objects, capabilities);
        uniformsGroups = new $f70f7eb6404ce619$var$WebGLUniformsGroups(_gl, info, capabilities, state);
        bufferRenderer = new $f70f7eb6404ce619$var$WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new $f70f7eb6404ce619$var$WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.shadowMap = shadowMap;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new $f70f7eb6404ce619$var$WebXRManager(_this, _gl);
    this.xr = xr;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + 'px';
            _canvas.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color = true, depth = true, stencil = true) {
        let bits = 0;
        if (color) bits |= 16384;
        if (depth) bits |= 256;
        if (stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener('webglcontextlost', onContextLost, false);
        _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
        _canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        cubeuvmaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        uniformsGroups.dispose();
        programCache.dispose();
        xr.dispose();
        xr.removeEventListener('sessionstart', onXRSessionStart);
        xr.removeEventListener('sessionend', onXRSessionEnd);
        if (_transmissionRenderTarget) {
            _transmissionRenderTarget.dispose();
            _transmissionRenderTarget = null;
        }
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log('THREE.WebGLRenderer: Context Lost.');
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log('THREE.WebGLRenderer: Context Restored.');
        _isContextLost = false;
        const infoAutoReset = info.autoReset;
        const shadowMapEnabled = shadowMap.enabled;
        const shadowMapAutoUpdate = shadowMap.autoUpdate;
        const shadowMapNeedsUpdate = shadowMap.needsUpdate;
        const shadowMapType = shadowMap.type;
        initGLContext();
        info.autoReset = infoAutoReset;
        shadowMap.enabled = shadowMapEnabled;
        shadowMap.autoUpdate = shadowMapAutoUpdate;
        shadowMap.needsUpdate = shadowMapNeedsUpdate;
        shadowMap.type = shadowMapType;
    }
    function onContextCreationError(event) {
        console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReferences(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReferences(material) {
        const programs = properties.get(material).programs;
        if (programs !== undefined) {
            programs.forEach(function(program) {
                programCache.releaseProgram(program);
            });
            if (material.isShaderMaterial) programCache.releaseShaderCache(material);
        }
    }
    // Buffer rendering
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, geometry, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        function prepare(material, scene, object) {
            if (material.transparent === true && material.side === $f70f7eb6404ce619$export$3b296b6f144d5b03) {
                material.side = $f70f7eb6404ce619$export$d9f0486e75b5ace;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $f70f7eb6404ce619$export$2ede184fc2998901;
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = $f70f7eb6404ce619$export$3b296b6f144d5b03;
            } else getProgram(material, scene, object);
        }
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    prepare(material2, scene, object);
                }
                else prepare(material, scene, object);
            }
        });
        renderStateStack.pop();
        currentRenderState = null;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    function onXRSessionStart() {
        animation.stop();
    }
    function onXRSessionEnd() {
        animation.start();
    }
    const animation = new $f70f7eb6404ce619$var$WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof self !== 'undefined') animation.setContext(self);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    xr.addEventListener('sessionstart', onXRSessionStart);
    xr.addEventListener('sessionend', onXRSessionEnd);
    // Rendering
    this.render = function(scene, camera) {
        if (camera !== undefined && camera.isCamera !== true) {
            console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
            return;
        }
        if (_isContextLost === true) return;
        // update scene graph
        if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) {
            if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
            camera = xr.getCamera(); // use XR camera for rendering
        }
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, renderListStack.length);
        currentRenderList.init();
        renderListStack.push(currentRenderList);
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        //
        background.render(currentRenderList, scene);
        // render scene
        currentRenderState.setupLights(_this.physicallyCorrectLights);
        if (camera.isArrayCamera) {
            const cameras = camera.cameras;
            for(let i = 0, l = cameras.length; i < l; i++){
                const camera2 = cameras[i];
                renderScene(currentRenderList, scene, camera2, camera2.viewport);
            }
        } else renderScene(currentRenderList, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
        }
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        // _gl.finish();
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        renderListStack.pop();
        if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
        else currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderScene(currentRenderList, scene, camera, viewport) {
        const opaqueObjects = currentRenderList.opaque;
        const transmissiveObjects = currentRenderList.transmissive;
        const transparentObjects = currentRenderList.transparent;
        currentRenderState.setupLightsView(camera);
        if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
        if (viewport) state.viewport(_currentViewport.copy(viewport));
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
    }
    function renderTransmissionPass(opaqueObjects, scene, camera) {
        const isWebGL2 = capabilities.isWebGL2;
        if (_transmissionRenderTarget === null) _transmissionRenderTarget = new $f70f7eb6404ce619$export$3c052beb2e51e23f(1, 1, {
            generateMipmaps: true,
            type: extensions.has('EXT_color_buffer_half_float') ? $f70f7eb6404ce619$export$2697304443f382bc : $f70f7eb6404ce619$export$2e8ce08d3f6f5e10,
            minFilter: $f70f7eb6404ce619$export$5d8599b6a933fb1b,
            samples: isWebGL2 && _antialias === true ? 4 : 0
        });
        _this.getDrawingBufferSize(_vector2);
        if (isWebGL2) _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
        else _transmissionRenderTarget.setSize($f70f7eb6404ce619$var$floorPowerOfTwo(_vector2.x), $f70f7eb6404ce619$var$floorPowerOfTwo(_vector2.y));
        //
        const currentRenderTarget = _this.getRenderTarget();
        _this.setRenderTarget(_transmissionRenderTarget);
        _this.clear();
        // Turn off the features which can affect the frag color for opaque objects pass.
        // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
        const currentToneMapping = _this.toneMapping;
        _this.toneMapping = $f70f7eb6404ce619$export$9fcb6b4294603b2;
        renderObjects(opaqueObjects, scene, camera);
        _this.toneMapping = currentToneMapping;
        textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
        textures.updateRenderTargetMipmap(_transmissionRenderTarget);
        _this.setRenderTarget(currentRenderTarget);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        material.onBeforeRender(_this, scene, camera, geometry, object, group);
        if (material.transparent === true && material.side === $f70f7eb6404ce619$export$3b296b6f144d5b03) {
            material.side = $f70f7eb6404ce619$export$d9f0486e75b5ace;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $f70f7eb6404ce619$export$2ede184fc2998901;
            material.needsUpdate = true;
            _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            material.side = $f70f7eb6404ce619$export$3b296b6f144d5b03;
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function getProgram(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let programs = materialProperties.programs;
        // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
        if (programs === undefined) {
            // new material
            material.addEventListener('dispose', onMaterialDispose);
            programs = new Map();
            materialProperties.programs = programs;
        }
        let program = programs.get(programCacheKey);
        if (program !== undefined) // early out if program and light state is identical
        {
            if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                updateCommonMaterialProperties(material, parameters);
                return program;
            }
        } else {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBuild(object, parameters, _this);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            programs.set(programCacheKey, program);
            materialProperties.uniforms = parameters.uniforms;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
        updateCommonMaterialProperties(material, parameters);
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
            uniforms.spotLightMap.value = lights.state.spotLightMap;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = program.getUniforms();
        const uniformsList = $f70f7eb6404ce619$var$WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.currentProgram = program;
        materialProperties.uniformsList = uniformsList;
        return program;
    }
    function updateCommonMaterialProperties(material, parameters) {
        const materialProperties = properties.get(material);
        materialProperties.outputEncoding = parameters.outputEncoding;
        materialProperties.instancing = parameters.instancing;
        materialProperties.skinning = parameters.skinning;
        materialProperties.morphTargets = parameters.morphTargets;
        materialProperties.morphNormals = parameters.morphNormals;
        materialProperties.morphColors = parameters.morphColors;
        materialProperties.morphTargetsCount = parameters.morphTargetsCount;
        materialProperties.numClippingPlanes = parameters.numClippingPlanes;
        materialProperties.numIntersection = parameters.numClipIntersection;
        materialProperties.vertexAlphas = parameters.vertexAlphas;
        materialProperties.vertexTangents = parameters.vertexTangents;
        materialProperties.toneMapping = parameters.toneMapping;
    }
    function setProgram(camera, scene, geometry, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : $f70f7eb6404ce619$export$7207336e4151a112;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
        const vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
        const morphTargets = !!geometry.morphAttributes.position;
        const morphNormals = !!geometry.morphAttributes.normal;
        const morphColors = !!geometry.morphAttributes.color;
        const toneMapping = material.toneMapped ? _this.toneMapping : $f70f7eb6404ce619$export$9fcb6b4294603b2;
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        //
        let needsProgramChange = false;
        if (material.version === materialProperties.__version) {
            if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
            else if (materialProperties.outputEncoding !== encoding) needsProgramChange = true;
            else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
            else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
            else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
            else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
            else if (materialProperties.envMap !== envMap) needsProgramChange = true;
            else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
            else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
            else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
            else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
            else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
            else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
            else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
            else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
        } else {
            needsProgramChange = true;
            materialProperties.__version = material.version;
        }
        //
        let program = materialProperties.currentProgram;
        if (needsProgramChange === true) program = getProgram(material, scene, object);
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
        }
        // skinning and morph target uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone and morph texture must go before other textures
        // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
        if (object.isSkinnedMesh) {
            p_uniforms.setOptional(_gl, object, 'bindMatrix');
            p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
            const skeleton = object.skeleton;
            if (skeleton) {
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                } else console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
            }
        }
        const morphAttributes = geometry.morphAttributes;
        if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) morphtargets.update(object, geometry, material, program);
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
        }
        // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
        if (material.isMeshGouraudMaterial && material.envMap !== null) {
            m_uniforms.envMap.value = envMap;
            m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
            $f70f7eb6404ce619$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            $f70f7eb6404ce619$var$WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
        // common matrices
        p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
        p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
        p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
        // UBOs
        if (material.isShaderMaterial || material.isRawShaderMaterial) {
            const groups = material.uniformsGroups;
            for(let i = 0, l = groups.length; i < l; i++)if (capabilities.isWebGL2) {
                const group = groups[i];
                uniformsGroups.update(group, program);
                uniformsGroups.bind(group, program);
            } else console.warn('THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.');
        }
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
        properties.get(renderTarget.texture).__webglTexture = colorTexture;
        properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__hasExternalTextures = true;
        if (renderTargetProperties.__hasExternalTextures) {
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        }
    };
    this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
        const renderTargetProperties = properties.get(renderTarget);
        renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
        renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        let useDefaultFramebuffer = true;
        if (renderTarget) {
            const renderTargetProperties = properties.get(renderTarget);
            if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                // We need to make sure to rebind the framebuffer.
                state.bindFramebuffer(36160, null);
                useDefaultFramebuffer = false;
            } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
            else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
            textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
        }
        let framebuffer = null;
        let isCube = false;
        let isRenderTarget3D = false;
        if (renderTarget) {
            const texture = renderTarget.texture;
            if (texture.isData3DTexture || texture.isDataArrayTexture) isRenderTarget3D = true;
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        const framebufferBound = state.bindFramebuffer(36160, framebuffer);
        if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        } else if (isRenderTarget3D) {
            const textureProperties = properties.get(renderTarget.texture);
            const layer = activeCubeFace || 0;
            _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
        }
        _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            state.bindFramebuffer(36160, framebuffer);
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== $f70f7eb6404ce619$export$3f8bb04b555a363c && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                }
                const halfFloatSupportedByExt = textureType === $f70f7eb6404ce619$export$2697304443f382bc && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                if (textureType !== $f70f7eb6404ce619$export$2e8ce08d3f6f5e10 && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
                !(textureType === $f70f7eb6404ce619$export$f6d331659b644596 && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                }
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
            } finally{
                // restore framebuffer of current render target if necessary
                const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                state.bindFramebuffer(36160, framebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        textures.setTexture2D(texture, 0);
        _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
        if (_this.isWebGL1Renderer) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
            return;
        }
        const width = sourceBox.max.x - sourceBox.min.x + 1;
        const height = sourceBox.max.y - sourceBox.min.y + 1;
        const depth = sourceBox.max.z - sourceBox.min.z + 1;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        let glTarget;
        if (dstTexture.isData3DTexture) {
            textures.setTexture3D(dstTexture, 0);
            glTarget = 32879;
        } else if (dstTexture.isDataArrayTexture) {
            textures.setTexture2DArray(dstTexture, 0);
            glTarget = 35866;
        } else {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
            return;
        }
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        const unpackRowLen = _gl.getParameter(3314);
        const unpackImageHeight = _gl.getParameter(32878);
        const unpackSkipPixels = _gl.getParameter(3316);
        const unpackSkipRows = _gl.getParameter(3315);
        const unpackSkipImages = _gl.getParameter(32877);
        const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
        _gl.pixelStorei(3314, image.width);
        _gl.pixelStorei(32878, image.height);
        _gl.pixelStorei(3316, sourceBox.min.x);
        _gl.pixelStorei(3315, sourceBox.min.y);
        _gl.pixelStorei(32877, sourceBox.min.z);
        if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
        else if (srcTexture.isCompressedTexture) {
            console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');
            _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
        } else _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
        _gl.pixelStorei(3314, unpackRowLen);
        _gl.pixelStorei(32878, unpackImageHeight);
        _gl.pixelStorei(3316, unpackSkipPixels);
        _gl.pixelStorei(3315, unpackSkipRows);
        _gl.pixelStorei(32877, unpackSkipImages);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
        else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
        else if (texture.isDataArrayTexture) textures.setTexture2DArray(texture, 0);
        else textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        _currentActiveCubeFace = 0;
        _currentActiveMipmapLevel = 0;
        _currentRenderTarget = null;
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: this
    }));
}
class $f70f7eb6404ce619$export$a2f65229194348f9 extends $f70f7eb6404ce619$export$f6cc00ef28d7cf97 {
}
$f70f7eb6404ce619$export$a2f65229194348f9.prototype.isWebGL1Renderer = true;
class $f70f7eb6404ce619$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $f70f7eb6404ce619$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $f70f7eb6404ce619$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $f70f7eb6404ce619$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $f70f7eb6404ce619$export$38af1803e3442a7f extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
    // @deprecated
    get autoUpdate() {
        console.warn('THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.');
        return this.matrixWorldAutoUpdate;
    }
    set autoUpdate(value) {
        console.warn('THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144.');
        this.matrixWorldAutoUpdate = value;
    }
}
class $f70f7eb6404ce619$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $f70f7eb6404ce619$export$763e8360f4d7f77d;
        this.updateRange = {
            offset: 0,
            count: -1
        };
        this.version = 0;
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $f70f7eb6404ce619$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $f70f7eb6404ce619$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $f70f7eb6404ce619$var$_vector$6 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized === true;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$6.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$6.applyMatrix4(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$6.x, $f70f7eb6404ce619$var$_vector$6.y, $f70f7eb6404ce619$var$_vector$6.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$6.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$6.applyNormalMatrix(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$6.x, $f70f7eb6404ce619$var$_vector$6.y, $f70f7eb6404ce619$var$_vector$6.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $f70f7eb6404ce619$var$_vector$6.fromBufferAttribute(this, i);
            $f70f7eb6404ce619$var$_vector$6.transformDirection(m);
            this.setXYZ(i, $f70f7eb6404ce619$var$_vector$6.x, $f70f7eb6404ce619$var$_vector$6.y, $f70f7eb6404ce619$var$_vector$6.z);
        }
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $f70f7eb6404ce619$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $f70f7eb6404ce619$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $f70f7eb6404ce619$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $f70f7eb6404ce619$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $f70f7eb6404ce619$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $f70f7eb6404ce619$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $f70f7eb6404ce619$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $f70f7eb6404ce619$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $f70f7eb6404ce619$var$normalize(x, this.array);
            y = $f70f7eb6404ce619$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $f70f7eb6404ce619$var$normalize(x, this.array);
            y = $f70f7eb6404ce619$var$normalize(y, this.array);
            z = $f70f7eb6404ce619$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $f70f7eb6404ce619$var$normalize(x, this.array);
            y = $f70f7eb6404ce619$var$normalize(y, this.array);
            z = $f70f7eb6404ce619$var$normalize(z, this.array);
            w = $f70f7eb6404ce619$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $f70f7eb6404ce619$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $f70f7eb6404ce619$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $f70f7eb6404ce619$export$5ec7dd1c6994bf8e extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $f70f7eb6404ce619$var$_geometry;
const $f70f7eb6404ce619$var$_intersectPoint = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_worldScale = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_mvPosition = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_alignedPosition = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_rotatedPosition = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_viewWorldMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_vA = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vB = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_vC = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_uvA = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_uvB = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
const $f70f7eb6404ce619$var$_uvC = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
class $f70f7eb6404ce619$export$3075603db8e6204c extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(material){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($f70f7eb6404ce619$var$_geometry === undefined) {
            $f70f7eb6404ce619$var$_geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $f70f7eb6404ce619$export$3d5cd879f108f53f(float32Array, 5);
            $f70f7eb6404ce619$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $f70f7eb6404ce619$var$_geometry.setAttribute('position', new $f70f7eb6404ce619$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $f70f7eb6404ce619$var$_geometry.setAttribute('uv', new $f70f7eb6404ce619$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $f70f7eb6404ce619$var$_geometry;
        this.material = material !== undefined ? material : new $f70f7eb6404ce619$export$5ec7dd1c6994bf8e();
        this.center = new $f70f7eb6404ce619$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $f70f7eb6404ce619$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $f70f7eb6404ce619$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $f70f7eb6404ce619$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $f70f7eb6404ce619$var$_worldScale.multiplyScalar(-$f70f7eb6404ce619$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $f70f7eb6404ce619$var$transformVertex($f70f7eb6404ce619$var$_vA.set(-0.5, -0.5, 0), $f70f7eb6404ce619$var$_mvPosition, center, $f70f7eb6404ce619$var$_worldScale, sin, cos);
        $f70f7eb6404ce619$var$transformVertex($f70f7eb6404ce619$var$_vB.set(0.5, -0.5, 0), $f70f7eb6404ce619$var$_mvPosition, center, $f70f7eb6404ce619$var$_worldScale, sin, cos);
        $f70f7eb6404ce619$var$transformVertex($f70f7eb6404ce619$var$_vC.set(0.5, 0.5, 0), $f70f7eb6404ce619$var$_mvPosition, center, $f70f7eb6404ce619$var$_worldScale, sin, cos);
        $f70f7eb6404ce619$var$_uvA.set(0, 0);
        $f70f7eb6404ce619$var$_uvB.set(1, 0);
        $f70f7eb6404ce619$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($f70f7eb6404ce619$var$_vA, $f70f7eb6404ce619$var$_vB, $f70f7eb6404ce619$var$_vC, false, $f70f7eb6404ce619$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $f70f7eb6404ce619$var$transformVertex($f70f7eb6404ce619$var$_vB.set(-0.5, 0.5, 0), $f70f7eb6404ce619$var$_mvPosition, center, $f70f7eb6404ce619$var$_worldScale, sin, cos);
            $f70f7eb6404ce619$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($f70f7eb6404ce619$var$_vA, $f70f7eb6404ce619$var$_vC, $f70f7eb6404ce619$var$_vB, false, $f70f7eb6404ce619$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($f70f7eb6404ce619$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $f70f7eb6404ce619$var$_intersectPoint.clone(),
            uv: $f70f7eb6404ce619$export$5a465592bfe74b48.getUV($f70f7eb6404ce619$var$_intersectPoint, $f70f7eb6404ce619$var$_vA, $f70f7eb6404ce619$var$_vB, $f70f7eb6404ce619$var$_vC, $f70f7eb6404ce619$var$_uvA, $f70f7eb6404ce619$var$_uvB, $f70f7eb6404ce619$var$_uvC, new $f70f7eb6404ce619$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $f70f7eb6404ce619$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $f70f7eb6404ce619$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $f70f7eb6404ce619$var$_rotatedPosition.x = cos * $f70f7eb6404ce619$var$_alignedPosition.x - sin * $f70f7eb6404ce619$var$_alignedPosition.y;
        $f70f7eb6404ce619$var$_rotatedPosition.y = sin * $f70f7eb6404ce619$var$_alignedPosition.x + cos * $f70f7eb6404ce619$var$_alignedPosition.y;
    } else $f70f7eb6404ce619$var$_rotatedPosition.copy($f70f7eb6404ce619$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $f70f7eb6404ce619$var$_rotatedPosition.x;
    vertexPosition.y += $f70f7eb6404ce619$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($f70f7eb6404ce619$var$_viewWorldMatrix);
}
const $f70f7eb6404ce619$var$_v1$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v2$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$112e7237be0c5f30 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $f70f7eb6404ce619$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($f70f7eb6404ce619$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $f70f7eb6404ce619$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $f70f7eb6404ce619$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $f70f7eb6404ce619$var$_v1$2.distanceTo($f70f7eb6404ce619$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
}
const $f70f7eb6404ce619$var$_basePosition = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_skinIndex = /*@__PURE__*/ new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
const $f70f7eb6404ce619$var$_skinWeight = /*@__PURE__*/ new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
const $f70f7eb6404ce619$var$_vector$5 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_matrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
class $f70f7eb6404ce619$export$b303577035157ecf extends $f70f7eb6404ce619$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = 'attached';
        this.bindMatrix = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $f70f7eb6404ce619$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    boneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $f70f7eb6404ce619$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $f70f7eb6404ce619$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $f70f7eb6404ce619$var$_basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $f70f7eb6404ce619$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $f70f7eb6404ce619$var$_skinIndex.getComponent(i);
                $f70f7eb6404ce619$var$_matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector($f70f7eb6404ce619$var$_vector$5.copy($f70f7eb6404ce619$var$_basePosition).applyMatrix4($f70f7eb6404ce619$var$_matrix), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
class $f70f7eb6404ce619$export$b127726e56765aa4 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $f70f7eb6404ce619$export$b691f601014eabe1 extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0, minFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $f70f7eb6404ce619$var$_offsetMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_identityMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
class $f70f7eb6404ce619$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.boneTextureSize = 0;
        this.frame = -1;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $f70f7eb6404ce619$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $f70f7eb6404ce619$var$_identityMatrix;
            $f70f7eb6404ce619$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $f70f7eb6404ce619$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $f70f7eb6404ce619$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = $f70f7eb6404ce619$var$ceilPowerOfTwo(size);
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $f70f7eb6404ce619$export$b691f601014eabe1(boneMatrices, size, size, $f70f7eb6404ce619$export$3f8bb04b555a363c, $f70f7eb6404ce619$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        this.boneTextureSize = size;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $f70f7eb6404ce619$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $f70f7eb6404ce619$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $f70f7eb6404ce619$export$32ea87a8b54d744a extends $f70f7eb6404ce619$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $f70f7eb6404ce619$var$_instanceLocalMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_instanceWorldMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_instanceIntersects = [];
const $f70f7eb6404ce619$var$_mesh = /*@__PURE__*/ new $f70f7eb6404ce619$export$e176487c05830cc5();
class $f70f7eb6404ce619$export$f3c979c331175ad7 extends $f70f7eb6404ce619$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $f70f7eb6404ce619$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.count = count;
        this.frustumCulled = false;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $f70f7eb6404ce619$var$_mesh.geometry = this.geometry;
        $f70f7eb6404ce619$var$_mesh.material = this.material;
        if ($f70f7eb6404ce619$var$_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $f70f7eb6404ce619$var$_instanceLocalMatrix);
            $f70f7eb6404ce619$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $f70f7eb6404ce619$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $f70f7eb6404ce619$var$_mesh.matrixWorld = $f70f7eb6404ce619$var$_instanceWorldMatrix;
            $f70f7eb6404ce619$var$_mesh.raycast(raycaster, $f70f7eb6404ce619$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $f70f7eb6404ce619$var$_instanceIntersects.length; i < l; i++){
                const intersect = $f70f7eb6404ce619$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $f70f7eb6404ce619$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $f70f7eb6404ce619$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $f70f7eb6404ce619$export$fbaaa33907730a0c extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff);
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $f70f7eb6404ce619$var$_start$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_end$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_inverseMatrix$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_ray$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$a186db52eed6d40e();
const $f70f7eb6404ce619$var$_sphere$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$805e8b72413ccaba();
class $f70f7eb6404ce619$export$17d680238e50603e extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(geometry = new $f70f7eb6404ce619$export$b7be63a67df8959(), material = new $f70f7eb6404ce619$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $f70f7eb6404ce619$var$_start$1.fromBufferAttribute(positionAttribute, i - 1);
                $f70f7eb6404ce619$var$_end$1.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $f70f7eb6404ce619$var$_start$1.distanceTo($f70f7eb6404ce619$var$_end$1);
            }
            geometry.setAttribute('lineDistance', new $f70f7eb6404ce619$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $f70f7eb6404ce619$var$_sphere$1.copy(geometry.boundingSphere);
        $f70f7eb6404ce619$var$_sphere$1.applyMatrix4(matrixWorld);
        $f70f7eb6404ce619$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($f70f7eb6404ce619$var$_sphere$1) === false) return;
        //
        $f70f7eb6404ce619$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $f70f7eb6404ce619$var$_ray$1.copy(raycaster.ray).applyMatrix4($f70f7eb6404ce619$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const vEnd = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const interSegment = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const interRay = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                vStart.fromBufferAttribute(positionAttribute, a);
                vEnd.fromBufferAttribute(positionAttribute, b);
                const distSq = $f70f7eb6404ce619$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = $f70f7eb6404ce619$var$_ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
const $f70f7eb6404ce619$var$_start = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_end = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$ff1ed10fedfdd604 extends $f70f7eb6404ce619$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $f70f7eb6404ce619$var$_start.fromBufferAttribute(positionAttribute, i);
                $f70f7eb6404ce619$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $f70f7eb6404ce619$var$_start.distanceTo($f70f7eb6404ce619$var$_end);
            }
            geometry.setAttribute('lineDistance', new $f70f7eb6404ce619$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $f70f7eb6404ce619$export$f85a24d745e4f17d extends $f70f7eb6404ce619$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $f70f7eb6404ce619$export$a178c45366ce5d6b extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $f70f7eb6404ce619$var$_inverseMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_ray = /*@__PURE__*/ new $f70f7eb6404ce619$export$a186db52eed6d40e();
const $f70f7eb6404ce619$var$_sphere = /*@__PURE__*/ new $f70f7eb6404ce619$export$805e8b72413ccaba();
const $f70f7eb6404ce619$var$_position$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$1c787534cb11aa3e extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(geometry = new $f70f7eb6404ce619$export$b7be63a67df8959(), material = new $f70f7eb6404ce619$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $f70f7eb6404ce619$var$_sphere.copy(geometry.boundingSphere);
        $f70f7eb6404ce619$var$_sphere.applyMatrix4(matrixWorld);
        $f70f7eb6404ce619$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($f70f7eb6404ce619$var$_sphere) === false) return;
        //
        $f70f7eb6404ce619$var$_inverseMatrix.copy(matrixWorld).invert();
        $f70f7eb6404ce619$var$_ray.copy(raycaster.ray).applyMatrix4($f70f7eb6404ce619$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $f70f7eb6404ce619$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $f70f7eb6404ce619$var$testPoint($f70f7eb6404ce619$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $f70f7eb6404ce619$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $f70f7eb6404ce619$var$testPoint($f70f7eb6404ce619$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $f70f7eb6404ce619$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $f70f7eb6404ce619$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $f70f7eb6404ce619$export$64b5c384219d3699();
        $f70f7eb6404ce619$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
class $f70f7eb6404ce619$export$6e09d1edf8d5a25c extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $f70f7eb6404ce619$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $f70f7eb6404ce619$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $f70f7eb6404ce619$export$9270d786f73ce6fe extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(width, height, format){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.format = format;
        this.magFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.minFilter = $f70f7eb6404ce619$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $f70f7eb6404ce619$export$3466bac9141a5cc4 extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $f70f7eb6404ce619$export$f7189e49152d1c13 extends $f70f7eb6404ce619$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $f70f7eb6404ce619$export$c977b3e384af9ae1() : new $f70f7eb6404ce619$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const mat = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $f70f7eb6404ce619$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $f70f7eb6404ce619$export$64b5c384219d3699();
        binormals[0] = new $f70f7eb6404ce619$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($f70f7eb6404ce619$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($f70f7eb6404ce619$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $f70f7eb6404ce619$export$3f87a931616cde04 extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget) {
        const point = optionalTarget || new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $f70f7eb6404ce619$export$b1eedc9aab6300e8 extends $f70f7eb6404ce619$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $f70f7eb6404ce619$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $f70f7eb6404ce619$var$tmp = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$px = /*@__PURE__*/ new $f70f7eb6404ce619$var$CubicPoly();
const $f70f7eb6404ce619$var$py = /*@__PURE__*/ new $f70f7eb6404ce619$var$CubicPoly();
const $f70f7eb6404ce619$var$pz = /*@__PURE__*/ new $f70f7eb6404ce619$var$CubicPoly();
class $f70f7eb6404ce619$export$b9146b27c24b744c extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $f70f7eb6404ce619$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $f70f7eb6404ce619$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $f70f7eb6404ce619$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $f70f7eb6404ce619$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $f70f7eb6404ce619$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $f70f7eb6404ce619$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $f70f7eb6404ce619$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $f70f7eb6404ce619$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $f70f7eb6404ce619$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $f70f7eb6404ce619$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($f70f7eb6404ce619$var$px.calc(weight), $f70f7eb6404ce619$var$py.calc(weight), $f70f7eb6404ce619$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $f70f7eb6404ce619$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $f70f7eb6404ce619$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $f70f7eb6404ce619$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $f70f7eb6404ce619$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $f70f7eb6404ce619$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $f70f7eb6404ce619$var$QuadraticBezier(t, p0, p1, p2) {
    return $f70f7eb6404ce619$var$QuadraticBezierP0(t, p0) + $f70f7eb6404ce619$var$QuadraticBezierP1(t, p1) + $f70f7eb6404ce619$var$QuadraticBezierP2(t, p2);
}
//
function $f70f7eb6404ce619$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $f70f7eb6404ce619$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $f70f7eb6404ce619$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $f70f7eb6404ce619$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $f70f7eb6404ce619$var$CubicBezier(t, p0, p1, p2, p3) {
    return $f70f7eb6404ce619$var$CubicBezierP0(t, p0) + $f70f7eb6404ce619$var$CubicBezierP1(t, p1) + $f70f7eb6404ce619$var$CubicBezierP2(t, p2) + $f70f7eb6404ce619$var$CubicBezierP3(t, p3);
}
class $f70f7eb6404ce619$export$e36650d36468bb39 extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), v1 = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), v2 = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), v3 = new $f70f7eb6404ce619$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($f70f7eb6404ce619$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $f70f7eb6404ce619$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $f70f7eb6404ce619$export$13d5f1c9525f246c extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $f70f7eb6404ce619$export$64b5c384219d3699(), v1 = new $f70f7eb6404ce619$export$64b5c384219d3699(), v2 = new $f70f7eb6404ce619$export$64b5c384219d3699(), v3 = new $f70f7eb6404ce619$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($f70f7eb6404ce619$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $f70f7eb6404ce619$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $f70f7eb6404ce619$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $f70f7eb6404ce619$export$ab2e07e76531a47e extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), v2 = new $f70f7eb6404ce619$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget) {
        const tangent = optionalTarget || new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        tangent.copy(this.v2).sub(this.v1).normalize();
        return tangent;
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $f70f7eb6404ce619$export$1fdfd9d9cf487600 extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $f70f7eb6404ce619$export$64b5c384219d3699(), v2 = new $f70f7eb6404ce619$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $f70f7eb6404ce619$export$5938c4ee491a43ad extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), v1 = new $f70f7eb6404ce619$export$c977b3e384af9ae1(), v2 = new $f70f7eb6404ce619$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($f70f7eb6404ce619$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $f70f7eb6404ce619$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $f70f7eb6404ce619$export$bf3f4c7e459f90fc extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $f70f7eb6404ce619$export$64b5c384219d3699(), v1 = new $f70f7eb6404ce619$export$64b5c384219d3699(), v2 = new $f70f7eb6404ce619$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($f70f7eb6404ce619$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $f70f7eb6404ce619$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $f70f7eb6404ce619$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $f70f7eb6404ce619$export$d3bdd77da77afc1b extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $f70f7eb6404ce619$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($f70f7eb6404ce619$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $f70f7eb6404ce619$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $f70f7eb6404ce619$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $f70f7eb6404ce619$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $f70f7eb6404ce619$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $f70f7eb6404ce619$export$b9146b27c24b744c,
    CubicBezierCurve: $f70f7eb6404ce619$export$e36650d36468bb39,
    CubicBezierCurve3: $f70f7eb6404ce619$export$13d5f1c9525f246c,
    EllipseCurve: $f70f7eb6404ce619$export$3f87a931616cde04,
    LineCurve: $f70f7eb6404ce619$export$ab2e07e76531a47e,
    LineCurve3: $f70f7eb6404ce619$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $f70f7eb6404ce619$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $f70f7eb6404ce619$export$bf3f4c7e459f90fc,
    SplineCurve: $f70f7eb6404ce619$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $f70f7eb6404ce619$export$4aaf9b66af1bbf2c extends $f70f7eb6404ce619$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new $f70f7eb6404ce619$export$ab2e07e76531a47e(endPoint, startPoint));
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $f70f7eb6404ce619$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $f70f7eb6404ce619$export$4b2950bdac9b6ee9 extends $f70f7eb6404ce619$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $f70f7eb6404ce619$export$ab2e07e76531a47e(this.currentPoint.clone(), new $f70f7eb6404ce619$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $f70f7eb6404ce619$export$5938c4ee491a43ad(this.currentPoint.clone(), new $f70f7eb6404ce619$export$c977b3e384af9ae1(aCPx, aCPy), new $f70f7eb6404ce619$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $f70f7eb6404ce619$export$e36650d36468bb39(this.currentPoint.clone(), new $f70f7eb6404ce619$export$c977b3e384af9ae1(aCP1x, aCP1y), new $f70f7eb6404ce619$export$c977b3e384af9ae1(aCP2x, aCP2y), new $f70f7eb6404ce619$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $f70f7eb6404ce619$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $f70f7eb6404ce619$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $f70f7eb6404ce619$export$6d839803fcd1882c extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(points = [
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0, -0.5),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0.5, 0),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $f70f7eb6404ce619$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const uv = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const curNormal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const prevNormal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $f70f7eb6404ce619$export$41680e8551036033 extends $f70f7eb6404ce619$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            height: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $f70f7eb6404ce619$export$d5c0e8d607467193 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const uv = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $f70f7eb6404ce619$export$68f745719dbe5198 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
            const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $f70f7eb6404ce619$export$a7a48974f285c9b3 extends $f70f7eb6404ce619$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $f70f7eb6404ce619$export$60e57a7d3f20ff65 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const b = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const c = new $f70f7eb6404ce619$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const b = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const c = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const centroid = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const uvA = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
            const uvB = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
            const uvC = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $f70f7eb6404ce619$export$c0babfeb8708fc9c extends $f70f7eb6404ce619$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $f70f7eb6404ce619$var$_v0 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v1$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_normal = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_triangle = /*@__PURE__*/ new $f70f7eb6404ce619$export$5a465592bfe74b48();
class $f70f7eb6404ce619$export$4730b1542707547f extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($f70f7eb6404ce619$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $f70f7eb6404ce619$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $f70f7eb6404ce619$var$_triangle.getNormal($f70f7eb6404ce619$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $f70f7eb6404ce619$var$_triangle[vertKeys[j]];
                    const v1 = $f70f7eb6404ce619$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($f70f7eb6404ce619$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $f70f7eb6404ce619$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $f70f7eb6404ce619$var$_v0.fromBufferAttribute(positionAttr, index0);
                $f70f7eb6404ce619$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($f70f7eb6404ce619$var$_v0.x, $f70f7eb6404ce619$var$_v0.y, $f70f7eb6404ce619$var$_v0.z);
                vertices.push($f70f7eb6404ce619$var$_v1$1.x, $f70f7eb6404ce619$var$_v1$1.y, $f70f7eb6404ce619$var$_v1$1.z);
            }
            this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
class $f70f7eb6404ce619$export$6428a7f2611ef1fa extends $f70f7eb6404ce619$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const $f70f7eb6404ce619$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $f70f7eb6404ce619$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $f70f7eb6404ce619$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        $f70f7eb6404ce619$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $f70f7eb6404ce619$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $f70f7eb6404ce619$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $f70f7eb6404ce619$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $f70f7eb6404ce619$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $f70f7eb6404ce619$var$equals(last, last.next)) {
        $f70f7eb6404ce619$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $f70f7eb6404ce619$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($f70f7eb6404ce619$var$equals(p, p.next) || $f70f7eb6404ce619$var$area(p.prev, p, p.next) === 0)) {
            $f70f7eb6404ce619$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $f70f7eb6404ce619$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $f70f7eb6404ce619$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $f70f7eb6404ce619$var$isEarHashed(ear, minX, minY, invSize) : $f70f7eb6404ce619$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $f70f7eb6404ce619$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $f70f7eb6404ce619$var$earcutLinked($f70f7eb6404ce619$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $f70f7eb6404ce619$var$cureLocalIntersections($f70f7eb6404ce619$var$filterPoints(ear), triangles, dim);
                $f70f7eb6404ce619$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $f70f7eb6404ce619$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $f70f7eb6404ce619$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($f70f7eb6404ce619$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if ($f70f7eb6404ce619$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $f70f7eb6404ce619$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $f70f7eb6404ce619$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($f70f7eb6404ce619$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = $f70f7eb6404ce619$var$zOrder(minTX, minTY, minX, minY, invSize), maxZ = $f70f7eb6404ce619$var$zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $f70f7eb6404ce619$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $f70f7eb6404ce619$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && $f70f7eb6404ce619$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $f70f7eb6404ce619$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $f70f7eb6404ce619$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $f70f7eb6404ce619$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && $f70f7eb6404ce619$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && $f70f7eb6404ce619$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $f70f7eb6404ce619$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$f70f7eb6404ce619$var$equals(a, b) && $f70f7eb6404ce619$var$intersects(a, p, p.next, b) && $f70f7eb6404ce619$var$locallyInside(a, b) && $f70f7eb6404ce619$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            $f70f7eb6404ce619$var$removeNode(p);
            $f70f7eb6404ce619$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $f70f7eb6404ce619$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $f70f7eb6404ce619$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $f70f7eb6404ce619$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $f70f7eb6404ce619$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $f70f7eb6404ce619$var$filterPoints(a, a.next);
                c = $f70f7eb6404ce619$var$filterPoints(c, c.next);
                // run earcut on each half
                $f70f7eb6404ce619$var$earcutLinked(a, triangles, dim, minX, minY, invSize);
                $f70f7eb6404ce619$var$earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $f70f7eb6404ce619$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $f70f7eb6404ce619$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($f70f7eb6404ce619$var$getLeftmost(list));
    }
    queue.sort($f70f7eb6404ce619$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $f70f7eb6404ce619$var$eliminateHole(queue[i], outerNode);
        outerNode = $f70f7eb6404ce619$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $f70f7eb6404ce619$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $f70f7eb6404ce619$var$eliminateHole(hole, outerNode) {
    outerNode = $f70f7eb6404ce619$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = $f70f7eb6404ce619$var$splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        $f70f7eb6404ce619$var$filterPoints(outerNode, outerNode.next);
        $f70f7eb6404ce619$var$filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $f70f7eb6404ce619$var$findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $f70f7eb6404ce619$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($f70f7eb6404ce619$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $f70f7eb6404ce619$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $f70f7eb6404ce619$var$sectorContainsSector(m, p) {
    return $f70f7eb6404ce619$var$area(m.prev, m, p.prev) < 0 && $f70f7eb6404ce619$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $f70f7eb6404ce619$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = $f70f7eb6404ce619$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $f70f7eb6404ce619$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $f70f7eb6404ce619$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $f70f7eb6404ce619$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $f70f7eb6404ce619$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $f70f7eb6404ce619$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $f70f7eb6404ce619$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$f70f7eb6404ce619$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($f70f7eb6404ce619$var$locallyInside(a, b) && $f70f7eb6404ce619$var$locallyInside(b, a) && $f70f7eb6404ce619$var$middleInside(a, b) && // locally visible
    ($f70f7eb6404ce619$var$area(a.prev, a, b.prev) || $f70f7eb6404ce619$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $f70f7eb6404ce619$var$equals(a, b) && $f70f7eb6404ce619$var$area(a.prev, a, a.next) > 0 && $f70f7eb6404ce619$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $f70f7eb6404ce619$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $f70f7eb6404ce619$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $f70f7eb6404ce619$var$intersects(p1, q1, p2, q2) {
    const o1 = $f70f7eb6404ce619$var$sign($f70f7eb6404ce619$var$area(p1, q1, p2));
    const o2 = $f70f7eb6404ce619$var$sign($f70f7eb6404ce619$var$area(p1, q1, q2));
    const o3 = $f70f7eb6404ce619$var$sign($f70f7eb6404ce619$var$area(p2, q2, p1));
    const o4 = $f70f7eb6404ce619$var$sign($f70f7eb6404ce619$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $f70f7eb6404ce619$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $f70f7eb6404ce619$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $f70f7eb6404ce619$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $f70f7eb6404ce619$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $f70f7eb6404ce619$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $f70f7eb6404ce619$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $f70f7eb6404ce619$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $f70f7eb6404ce619$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $f70f7eb6404ce619$var$locallyInside(a, b) {
    return $f70f7eb6404ce619$var$area(a.prev, a, a.next) < 0 ? $f70f7eb6404ce619$var$area(a, b, a.next) >= 0 && $f70f7eb6404ce619$var$area(a, a.prev, b) >= 0 : $f70f7eb6404ce619$var$area(a, b, a.prev) < 0 || $f70f7eb6404ce619$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $f70f7eb6404ce619$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $f70f7eb6404ce619$var$splitPolygon(a, b) {
    const a2 = new $f70f7eb6404ce619$var$Node(a.i, a.x, a.y), b2 = new $f70f7eb6404ce619$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $f70f7eb6404ce619$var$insertNode(i, x, y, last) {
    const p = new $f70f7eb6404ce619$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $f70f7eb6404ce619$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $f70f7eb6404ce619$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $f70f7eb6404ce619$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $f70f7eb6404ce619$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $f70f7eb6404ce619$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $f70f7eb6404ce619$var$removeDupEndPts(contour);
        $f70f7eb6404ce619$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($f70f7eb6404ce619$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $f70f7eb6404ce619$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $f70f7eb6404ce619$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $f70f7eb6404ce619$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $f70f7eb6404ce619$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $f70f7eb6404ce619$export$598697a1efa63ca7 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(shapes = new $f70f7eb6404ce619$export$6428a7f2611ef1fa([
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0.5, 0.5),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(-0.5, 0.5),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(-0.5, -0.5),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $f70f7eb6404ce619$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $f70f7eb6404ce619$export$64b5c384219d3699();
                normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
                position2 = new $f70f7eb6404ce619$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$f70f7eb6404ce619$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($f70f7eb6404ce619$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $f70f7eb6404ce619$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $f70f7eb6404ce619$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $f70f7eb6404ce619$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $f70f7eb6404ce619$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $f70f7eb6404ce619$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $f70f7eb6404ce619$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $f70f7eb6404ce619$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(a_x, a_y),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(b_x, b_y),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $f70f7eb6404ce619$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $f70f7eb6404ce619$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $f70f7eb6404ce619$export$9567cc828c9535da extends $f70f7eb6404ce619$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $f70f7eb6404ce619$export$1954e2b809fe361e extends $f70f7eb6404ce619$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $f70f7eb6404ce619$export$68cb731f50f614af extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const uv = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $f70f7eb6404ce619$export$57a29a1c803e9065 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(shapes = new $f70f7eb6404ce619$export$6428a7f2611ef1fa([
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0, 0.5),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(-0.5, -0.5),
        new $f70f7eb6404ce619$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($f70f7eb6404ce619$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($f70f7eb6404ce619$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $f70f7eb6404ce619$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $f70f7eb6404ce619$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $f70f7eb6404ce619$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $f70f7eb6404ce619$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $f70f7eb6404ce619$export$1b417fc3b307a251 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $f70f7eb6404ce619$export$fb3f7adc68bd6e02 extends $f70f7eb6404ce619$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $f70f7eb6404ce619$export$a2312a2a1fa56495 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $f70f7eb6404ce619$export$77e9bfadfb9ab8c8 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const P1 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const P2 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const B = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const T = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const N = new $f70f7eb6404ce619$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    static fromJSON(data) {
        return new $f70f7eb6404ce619$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $f70f7eb6404ce619$export$7897d9d48904490c extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(path = new $f70f7eb6404ce619$export$bf3f4c7e459f90fc(new $f70f7eb6404ce619$export$64b5c384219d3699(-1, -1, 0), new $f70f7eb6404ce619$export$64b5c384219d3699(-1, 1, 0), new $f70f7eb6404ce619$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const normal = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const uv = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        let P = new $f70f7eb6404ce619$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $f70f7eb6404ce619$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $f70f7eb6404ce619$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $f70f7eb6404ce619$export$7897d9d48904490c(new $f70f7eb6404ce619$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $f70f7eb6404ce619$export$4b739da06d24892b extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $f70f7eb6404ce619$export$64b5c384219d3699();
            const end = new $f70f7eb6404ce619$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($f70f7eb6404ce619$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($f70f7eb6404ce619$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        }
    }
}
function $f70f7eb6404ce619$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $f70f7eb6404ce619$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $f70f7eb6404ce619$export$33e43285f7406bd5,
    CapsuleGeometry: $f70f7eb6404ce619$export$41680e8551036033,
    CircleGeometry: $f70f7eb6404ce619$export$d5c0e8d607467193,
    ConeGeometry: $f70f7eb6404ce619$export$a7a48974f285c9b3,
    CylinderGeometry: $f70f7eb6404ce619$export$68f745719dbe5198,
    DodecahedronGeometry: $f70f7eb6404ce619$export$c0babfeb8708fc9c,
    EdgesGeometry: $f70f7eb6404ce619$export$4730b1542707547f,
    ExtrudeGeometry: $f70f7eb6404ce619$export$598697a1efa63ca7,
    IcosahedronGeometry: $f70f7eb6404ce619$export$9567cc828c9535da,
    LatheGeometry: $f70f7eb6404ce619$export$6d839803fcd1882c,
    OctahedronGeometry: $f70f7eb6404ce619$export$1954e2b809fe361e,
    PlaneGeometry: $f70f7eb6404ce619$export$967d831af31f69ce,
    PolyhedronGeometry: $f70f7eb6404ce619$export$60e57a7d3f20ff65,
    RingGeometry: $f70f7eb6404ce619$export$68cb731f50f614af,
    ShapeGeometry: $f70f7eb6404ce619$export$57a29a1c803e9065,
    SphereGeometry: $f70f7eb6404ce619$export$1b417fc3b307a251,
    TetrahedronGeometry: $f70f7eb6404ce619$export$fb3f7adc68bd6e02,
    TorusGeometry: $f70f7eb6404ce619$export$a2312a2a1fa56495,
    TorusKnotGeometry: $f70f7eb6404ce619$export$77e9bfadfb9ab8c8,
    TubeGeometry: $f70f7eb6404ce619$export$7897d9d48904490c,
    WireframeGeometry: $f70f7eb6404ce619$export$4b739da06d24892b
});
class $f70f7eb6404ce619$export$e8564da406055a3 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $f70f7eb6404ce619$export$21c421a2e1df9d22 extends $f70f7eb6404ce619$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $f70f7eb6404ce619$export$f2980790215acccd extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.defines = {
            'STANDARD': ''
        };
        this.type = 'MeshStandardMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $f70f7eb6404ce619$export$2852a58ebdac27b8;
        this.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $f70f7eb6404ce619$export$28d04986c4269c9f extends $f70f7eb6404ce619$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $f70f7eb6404ce619$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = 0.0;
        this.attenuationColor = new $f70f7eb6404ce619$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $f70f7eb6404ce619$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._sheen = 0.0;
        this._clearcoat = 0;
        this._iridescence = 0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $f70f7eb6404ce619$export$24c72f71cbaf0678 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $f70f7eb6404ce619$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $f70f7eb6404ce619$export$2852a58ebdac27b8;
        this.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $f70f7eb6404ce619$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $f70f7eb6404ce619$export$df893cf97e765622 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $f70f7eb6404ce619$export$2852a58ebdac27b8;
        this.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $f70f7eb6404ce619$export$bfe8c0a091f41ae7 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $f70f7eb6404ce619$export$2852a58ebdac27b8;
        this.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $f70f7eb6404ce619$export$5023a9a8114806b8 extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $f70f7eb6404ce619$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $f70f7eb6404ce619$export$2852a58ebdac27b8;
        this.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.combine = $f70f7eb6404ce619$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $f70f7eb6404ce619$export$6f5fef6235ec12ee extends $f70f7eb6404ce619$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $f70f7eb6404ce619$export$2852a58ebdac27b8;
        this.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $f70f7eb6404ce619$export$327886a3efaeaebe extends $f70f7eb6404ce619$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// same as Array.prototype.slice, but also works on typed arrays
function $f70f7eb6404ce619$var$arraySlice(array, from, to) {
    if ($f70f7eb6404ce619$var$isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
    // but array.subarray(from) or array.subarray(from, len) is correct
    return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
    return array.slice(from, to);
}
// converts an array to a specific type
function $f70f7eb6404ce619$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $f70f7eb6404ce619$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $f70f7eb6404ce619$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $f70f7eb6404ce619$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $f70f7eb6404ce619$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $f70f7eb6404ce619$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $f70f7eb6404ce619$var$convertArray(times, track.times.constructor);
        track.values = $f70f7eb6404ce619$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $f70f7eb6404ce619$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = $f70f7eb6404ce619$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = $f70f7eb6404ce619$var$arraySlice(referenceTrack.values, startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = $f70f7eb6404ce619$var$arraySlice(interpolant.resultBuffer, startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $f70f7eb6404ce619$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $f70f7eb6404ce619$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $f70f7eb6404ce619$export$d875e029ef558d3;
    return targetClip;
}
var $f70f7eb6404ce619$export$7ee8caa573e71ad1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    arraySlice: $f70f7eb6404ce619$var$arraySlice,
    convertArray: $f70f7eb6404ce619$var$convertArray,
    isTypedArray: $f70f7eb6404ce619$var$isTypedArray,
    getKeyframeOrder: $f70f7eb6404ce619$var$getKeyframeOrder,
    sortedArray: $f70f7eb6404ce619$var$sortedArray,
    flattenJSON: $f70f7eb6404ce619$var$flattenJSON,
    subclip: $f70f7eb6404ce619$var$subclip,
    makeClipAdditive: $f70f7eb6404ce619$var$makeClipAdditive
});
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $f70f7eb6404ce619$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $f70f7eb6404ce619$export$3646682e7a3959 extends $f70f7eb6404ce619$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $f70f7eb6404ce619$export$7f795934b84ab523,
            endingEnd: $f70f7eb6404ce619$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $f70f7eb6404ce619$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $f70f7eb6404ce619$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $f70f7eb6404ce619$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $f70f7eb6404ce619$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $f70f7eb6404ce619$export$a8e6009059f51e1a extends $f70f7eb6404ce619$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $f70f7eb6404ce619$export$fb9758ef7ef8d5cc extends $f70f7eb6404ce619$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $f70f7eb6404ce619$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $f70f7eb6404ce619$var$convertArray(times, this.TimeBufferType);
        this.values = $f70f7eb6404ce619$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $f70f7eb6404ce619$var$convertArray(track.times, Array),
                'values': $f70f7eb6404ce619$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $f70f7eb6404ce619$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $f70f7eb6404ce619$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $f70f7eb6404ce619$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $f70f7eb6404ce619$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $f70f7eb6404ce619$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $f70f7eb6404ce619$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $f70f7eb6404ce619$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $f70f7eb6404ce619$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $f70f7eb6404ce619$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = $f70f7eb6404ce619$var$arraySlice(times, from, to);
            this.values = $f70f7eb6404ce619$var$arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($f70f7eb6404ce619$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = $f70f7eb6404ce619$var$arraySlice(this.times), values = $f70f7eb6404ce619$var$arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $f70f7eb6404ce619$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = $f70f7eb6404ce619$var$arraySlice(times, 0, writeIndex);
            this.values = $f70f7eb6404ce619$var$arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = $f70f7eb6404ce619$var$arraySlice(this.times, 0);
        const values = $f70f7eb6404ce619$var$arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$f70f7eb6404ce619$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$f70f7eb6404ce619$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$f70f7eb6404ce619$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $f70f7eb6404ce619$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $f70f7eb6404ce619$export$d3a344b98cf0b775 extends $f70f7eb6404ce619$export$b0e479f45b7006d6 {
}
$f70f7eb6404ce619$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$f70f7eb6404ce619$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$f70f7eb6404ce619$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $f70f7eb6404ce619$export$995b32462a65e855;
$f70f7eb6404ce619$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$f70f7eb6404ce619$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $f70f7eb6404ce619$export$83444c5d885347d8 extends $f70f7eb6404ce619$export$b0e479f45b7006d6 {
}
$f70f7eb6404ce619$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $f70f7eb6404ce619$export$d45f0d1a4d9a9314 extends $f70f7eb6404ce619$export$b0e479f45b7006d6 {
}
$f70f7eb6404ce619$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $f70f7eb6404ce619$export$2db1cfb7923d931e extends $f70f7eb6404ce619$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$f70f7eb6404ce619$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $f70f7eb6404ce619$export$b8043f12b5aafbd7 extends $f70f7eb6404ce619$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $f70f7eb6404ce619$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$f70f7eb6404ce619$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
$f70f7eb6404ce619$export$b8043f12b5aafbd7.prototype.DefaultInterpolation = $f70f7eb6404ce619$export$30fac1aace31cf4d;
$f70f7eb6404ce619$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $f70f7eb6404ce619$export$6ce41d4f3a8df9cd extends $f70f7eb6404ce619$export$b0e479f45b7006d6 {
}
$f70f7eb6404ce619$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$f70f7eb6404ce619$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$f70f7eb6404ce619$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $f70f7eb6404ce619$export$995b32462a65e855;
$f70f7eb6404ce619$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$f70f7eb6404ce619$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $f70f7eb6404ce619$export$5ce2dcb4cc9f2bff extends $f70f7eb6404ce619$export$b0e479f45b7006d6 {
}
$f70f7eb6404ce619$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $f70f7eb6404ce619$export$d942c706bf23829c {
    constructor(name, duration = -1, tracks, blendMode = $f70f7eb6404ce619$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($f70f7eb6404ce619$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($f70f7eb6404ce619$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $f70f7eb6404ce619$var$getKeyframeOrder(times);
            times = $f70f7eb6404ce619$var$sortedArray(times, 1, order);
            values = $f70f7eb6404ce619$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $f70f7eb6404ce619$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $f70f7eb6404ce619$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $f70f7eb6404ce619$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($f70f7eb6404ce619$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($f70f7eb6404ce619$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($f70f7eb6404ce619$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $f70f7eb6404ce619$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $f70f7eb6404ce619$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $f70f7eb6404ce619$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $f70f7eb6404ce619$export$83444c5d885347d8;
        case 'quaternion':
            return $f70f7eb6404ce619$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $f70f7eb6404ce619$export$d3a344b98cf0b775;
        case 'string':
            return $f70f7eb6404ce619$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $f70f7eb6404ce619$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $f70f7eb6404ce619$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $f70f7eb6404ce619$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $f70f7eb6404ce619$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $f70f7eb6404ce619$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $f70f7eb6404ce619$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $f70f7eb6404ce619$export$99cc795e99919eed();
class $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $f70f7eb6404ce619$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
const $f70f7eb6404ce619$var$loading = {};
class $f70f7eb6404ce619$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $f70f7eb6404ce619$export$98435a25b5cf7b2b extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $f70f7eb6404ce619$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($f70f7eb6404ce619$var$loading[url] !== undefined) {
            $f70f7eb6404ce619$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $f70f7eb6404ce619$var$loading[url] = [];
        $f70f7eb6404ce619$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $f70f7eb6404ce619$var$loading[url];
                const reader = response.body.getReader();
                const contentLength = response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $f70f7eb6404ce619$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $f70f7eb6404ce619$export$94affb487e701bf2.add(url, data);
            const callbacks = $f70f7eb6404ce619$var$loading[url];
            delete $f70f7eb6404ce619$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $f70f7eb6404ce619$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $f70f7eb6404ce619$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $f70f7eb6404ce619$export$29711c7e14f61db extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $f70f7eb6404ce619$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $f70f7eb6404ce619$export$bd73ce947a280350 extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $f70f7eb6404ce619$export$3466bac9141a5cc4();
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $f70f7eb6404ce619$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $f70f7eb6404ce619$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $f70f7eb6404ce619$export$8905ce1c7a2464a1 extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $f70f7eb6404ce619$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $f70f7eb6404ce619$var$createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            $f70f7eb6404ce619$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $f70f7eb6404ce619$export$2ec114afc2cf6308 extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $f70f7eb6404ce619$export$ee2e5a18258a4049();
        const loader = new $f70f7eb6404ce619$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $f70f7eb6404ce619$export$792d8a18f2c55855 extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $f70f7eb6404ce619$export$b691f601014eabe1();
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $f70f7eb6404ce619$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $f70f7eb6404ce619$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $f70f7eb6404ce619$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $f70f7eb6404ce619$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $f70f7eb6404ce619$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $f70f7eb6404ce619$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $f70f7eb6404ce619$export$fd1bfc71f64c538c extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $f70f7eb6404ce619$export$5431306cf43de24a();
        const loader = new $f70f7eb6404ce619$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $f70f7eb6404ce619$export$6ecadb6ed240d696 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
class $f70f7eb6404ce619$export$8d474f55edbb9624 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.groundColor = new $f70f7eb6404ce619$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $f70f7eb6404ce619$var$_projScreenMatrix$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_lightPositionWorld$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_lookTarget$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $f70f7eb6404ce619$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $f70f7eb6404ce619$export$35efe6f4c85463d2();
        this._frameExtents = new $f70f7eb6404ce619$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $f70f7eb6404ce619$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($f70f7eb6404ce619$var$_lightPositionWorld$1);
        $f70f7eb6404ce619$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($f70f7eb6404ce619$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $f70f7eb6404ce619$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($f70f7eb6404ce619$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $f70f7eb6404ce619$var$SpotLightShadow extends $f70f7eb6404ce619$var$LightShadow {
    constructor(){
        super(new $f70f7eb6404ce619$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $f70f7eb6404ce619$var$RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $f70f7eb6404ce619$export$81495cbb73897362 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 1){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay; // for physically correct lights, should be 2.
        this.map = null;
        this.shadow = new $f70f7eb6404ce619$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $f70f7eb6404ce619$var$_projScreenMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_lightPositionWorld = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_lookTarget = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$var$PointLightShadow extends $f70f7eb6404ce619$var$LightShadow {
    constructor(){
        super(new $f70f7eb6404ce619$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $f70f7eb6404ce619$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $f70f7eb6404ce619$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $f70f7eb6404ce619$export$64b5c384219d3699(1, 0, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(-1, 0, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 1),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, -1),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 1),
            new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $f70f7eb6404ce619$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($f70f7eb6404ce619$var$_lightPositionWorld);
        $f70f7eb6404ce619$var$_lookTarget.copy(camera.position);
        $f70f7eb6404ce619$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($f70f7eb6404ce619$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$f70f7eb6404ce619$var$_lightPositionWorld.x, -$f70f7eb6404ce619$var$_lightPositionWorld.y, -$f70f7eb6404ce619$var$_lightPositionWorld.z);
        $f70f7eb6404ce619$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($f70f7eb6404ce619$var$_projScreenMatrix);
    }
}
class $f70f7eb6404ce619$export$4c9c1cb3f0b6f455 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 1){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay; // for physically correct lights, should be 2.
        this.shadow = new $f70f7eb6404ce619$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $f70f7eb6404ce619$var$DirectionalLightShadow extends $f70f7eb6404ce619$var$LightShadow {
    constructor(){
        super(new $f70f7eb6404ce619$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $f70f7eb6404ce619$export$3fea33cc9972c868 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($f70f7eb6404ce619$export$e4dd07dff30cc924.DefaultUp);
        this.updateMatrix();
        this.target = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.shadow = new $f70f7eb6404ce619$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $f70f7eb6404ce619$export$af279bfef9ec2c96 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $f70f7eb6404ce619$export$61db2d908bbd2429 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $f70f7eb6404ce619$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $f70f7eb6404ce619$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $f70f7eb6404ce619$export$e7ef036e309b38d2 extends $f70f7eb6404ce619$export$6ecadb6ed240d696 {
    constructor(sh = new $f70f7eb6404ce619$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $f70f7eb6404ce619$export$3bd6d323353dcf96 extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = $f70f7eb6404ce619$export$3bd6d323353dcf96.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $f70f7eb6404ce619$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $f70f7eb6404ce619$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $f70f7eb6404ce619$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $f70f7eb6404ce619$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $f70f7eb6404ce619$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $f70f7eb6404ce619$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $f70f7eb6404ce619$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $f70f7eb6404ce619$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $f70f7eb6404ce619$export$e8564da406055a3,
            SpriteMaterial: $f70f7eb6404ce619$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $f70f7eb6404ce619$export$21c421a2e1df9d22,
            ShaderMaterial: $f70f7eb6404ce619$export$83c7d75d550a8b0d,
            PointsMaterial: $f70f7eb6404ce619$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $f70f7eb6404ce619$export$28d04986c4269c9f,
            MeshStandardMaterial: $f70f7eb6404ce619$export$f2980790215acccd,
            MeshPhongMaterial: $f70f7eb6404ce619$export$24c72f71cbaf0678,
            MeshToonMaterial: $f70f7eb6404ce619$export$df893cf97e765622,
            MeshNormalMaterial: $f70f7eb6404ce619$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $f70f7eb6404ce619$export$5023a9a8114806b8,
            MeshDepthMaterial: $f70f7eb6404ce619$export$2698c22ec13825db,
            MeshDistanceMaterial: $f70f7eb6404ce619$export$33e187ed002f2a19,
            MeshBasicMaterial: $f70f7eb6404ce619$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $f70f7eb6404ce619$export$6f5fef6235ec12ee,
            LineDashedMaterial: $f70f7eb6404ce619$export$327886a3efaeaebe,
            LineBasicMaterial: $f70f7eb6404ce619$export$fbaaa33907730a0c,
            Material: $f70f7eb6404ce619$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $f70f7eb6404ce619$export$b5d2dc08d867e41a {
    static decodeText(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $f70f7eb6404ce619$export$231f009cbe414146 extends $f70f7eb6404ce619$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const data = super.toJSON(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $f70f7eb6404ce619$export$dc275bb96327833a extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $f70f7eb6404ce619$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $f70f7eb6404ce619$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $f70f7eb6404ce619$export$231f009cbe414146() : new $f70f7eb6404ce619$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $f70f7eb6404ce619$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $f70f7eb6404ce619$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $f70f7eb6404ce619$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $f70f7eb6404ce619$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $f70f7eb6404ce619$export$32ea87a8b54d744a : $f70f7eb6404ce619$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            if (attribute.updateRange !== undefined) {
                bufferAttribute.updateRange.offset = attribute.updateRange.offset;
                bufferAttribute.updateRange.count = attribute.updateRange.count;
            }
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $f70f7eb6404ce619$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $f70f7eb6404ce619$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $f70f7eb6404ce619$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $f70f7eb6404ce619$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $f70f7eb6404ce619$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $f70f7eb6404ce619$export$40110c8505c5ad19 extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $f70f7eb6404ce619$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $f70f7eb6404ce619$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $f70f7eb6404ce619$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $f70f7eb6404ce619$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $f70f7eb6404ce619$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $f70f7eb6404ce619$var$Geometries) geometry = $f70f7eb6404ce619$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $f70f7eb6404ce619$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $f70f7eb6404ce619$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $f70f7eb6404ce619$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $f70f7eb6404ce619$export$99cc795e99919eed(onLoad);
            loader = new $f70f7eb6404ce619$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $f70f7eb6404ce619$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $f70f7eb6404ce619$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $f70f7eb6404ce619$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $f70f7eb6404ce619$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $f70f7eb6404ce619$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $f70f7eb6404ce619$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $f70f7eb6404ce619$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $f70f7eb6404ce619$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $f70f7eb6404ce619$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $f70f7eb6404ce619$export$b691f601014eabe1();
                else texture = new $f70f7eb6404ce619$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $f70f7eb6404ce619$var$TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $f70f7eb6404ce619$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $f70f7eb6404ce619$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $f70f7eb6404ce619$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $f70f7eb6404ce619$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $f70f7eb6404ce619$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $f70f7eb6404ce619$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $f70f7eb6404ce619$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $f70f7eb6404ce619$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                }
                break;
            case 'PerspectiveCamera':
                object = new $f70f7eb6404ce619$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $f70f7eb6404ce619$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $f70f7eb6404ce619$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $f70f7eb6404ce619$export$3fea33cc9972c868(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new $f70f7eb6404ce619$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $f70f7eb6404ce619$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $f70f7eb6404ce619$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new $f70f7eb6404ce619$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $f70f7eb6404ce619$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $f70f7eb6404ce619$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $f70f7eb6404ce619$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $f70f7eb6404ce619$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'LOD':
                object = new $f70f7eb6404ce619$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $f70f7eb6404ce619$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $f70f7eb6404ce619$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $f70f7eb6404ce619$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $f70f7eb6404ce619$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $f70f7eb6404ce619$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $f70f7eb6404ce619$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $f70f7eb6404ce619$export$b127726e56765aa4();
                break;
            default:
                object = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
}
const $f70f7eb6404ce619$var$TEXTURE_MAPPING = {
    UVMapping: $f70f7eb6404ce619$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $f70f7eb6404ce619$export$8759762a6477f2c4,
    CubeRefractionMapping: $f70f7eb6404ce619$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $f70f7eb6404ce619$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $f70f7eb6404ce619$export$ee99d97d46898098,
    CubeUVReflectionMapping: $f70f7eb6404ce619$export$dbf3e70ff37af79
};
const $f70f7eb6404ce619$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $f70f7eb6404ce619$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $f70f7eb6404ce619$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $f70f7eb6404ce619$export$c7e7c00b14f51a4f
};
const $f70f7eb6404ce619$var$TEXTURE_FILTER = {
    NearestFilter: $f70f7eb6404ce619$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $f70f7eb6404ce619$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $f70f7eb6404ce619$export$d2327c1afe5bfdf2,
    LinearFilter: $f70f7eb6404ce619$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $f70f7eb6404ce619$export$19a719f377145a13,
    LinearMipmapLinearFilter: $f70f7eb6404ce619$export$5d8599b6a933fb1b
};
class $f70f7eb6404ce619$export$52286b55c4a9b51f extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $f70f7eb6404ce619$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $f70f7eb6404ce619$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
}
let $f70f7eb6404ce619$var$_context;
const $f70f7eb6404ce619$export$fcbc63750ec2a81f = {
    getContext: function() {
        if ($f70f7eb6404ce619$var$_context === undefined) $f70f7eb6404ce619$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $f70f7eb6404ce619$var$_context;
    },
    setContext: function(value) {
        $f70f7eb6404ce619$var$_context = value;
    }
};
class $f70f7eb6404ce619$export$d8d5fccfbf47714e extends $f70f7eb6404ce619$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $f70f7eb6404ce619$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $f70f7eb6404ce619$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
}
class $f70f7eb6404ce619$export$2f22dadc8bc42820 extends $f70f7eb6404ce619$export$e7ef036e309b38d2 {
    constructor(skyColor, groundColor, intensity = 1){
        super(undefined, intensity);
        this.isHemisphereLightProbe = true;
        const color1 = new $f70f7eb6404ce619$export$892596cec99bc70e().set(skyColor);
        const color2 = new $f70f7eb6404ce619$export$892596cec99bc70e().set(groundColor);
        const sky = new $f70f7eb6404ce619$export$64b5c384219d3699(color1.r, color1.g, color1.b);
        const ground = new $f70f7eb6404ce619$export$64b5c384219d3699(color2.r, color2.g, color2.b);
        // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
        const c0 = Math.sqrt(Math.PI);
        const c1 = c0 * Math.sqrt(0.75);
        this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
        this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
    }
}
class $f70f7eb6404ce619$export$afe310a21c86023d extends $f70f7eb6404ce619$export$e7ef036e309b38d2 {
    constructor(color, intensity = 1){
        super(undefined, intensity);
        this.isAmbientLightProbe = true;
        const color1 = new $f70f7eb6404ce619$export$892596cec99bc70e().set(color);
        // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
        this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
    }
}
const $f70f7eb6404ce619$var$_eyeRight = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_eyeLeft = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_projectionMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
class $f70f7eb6404ce619$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $f70f7eb6404ce619$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $f70f7eb6404ce619$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $f70f7eb6404ce619$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($f70f7eb6404ce619$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $f70f7eb6404ce619$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $f70f7eb6404ce619$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $f70f7eb6404ce619$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $f70f7eb6404ce619$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($f70f7eb6404ce619$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $f70f7eb6404ce619$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $f70f7eb6404ce619$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($f70f7eb6404ce619$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($f70f7eb6404ce619$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($f70f7eb6404ce619$var$_eyeRight);
    }
}
class $f70f7eb6404ce619$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $f70f7eb6404ce619$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $f70f7eb6404ce619$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $f70f7eb6404ce619$var$now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const $f70f7eb6404ce619$var$_position$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_quaternion$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
const $f70f7eb6404ce619$var$_scale$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_orientation$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$8a1b810c6fde8951 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $f70f7eb6404ce619$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $f70f7eb6404ce619$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($f70f7eb6404ce619$var$_position$1, $f70f7eb6404ce619$var$_quaternion$1, $f70f7eb6404ce619$var$_scale$1);
        $f70f7eb6404ce619$var$_orientation$1.set(0, 0, -1).applyQuaternion($f70f7eb6404ce619$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($f70f7eb6404ce619$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($f70f7eb6404ce619$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($f70f7eb6404ce619$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($f70f7eb6404ce619$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($f70f7eb6404ce619$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($f70f7eb6404ce619$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($f70f7eb6404ce619$var$_position$1.x, $f70f7eb6404ce619$var$_position$1.y, $f70f7eb6404ce619$var$_position$1.z);
            listener.setOrientation($f70f7eb6404ce619$var$_orientation$1.x, $f70f7eb6404ce619$var$_orientation$1.y, $f70f7eb6404ce619$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $f70f7eb6404ce619$export$153755f98d9861de extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const $f70f7eb6404ce619$var$_position = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_quaternion = /*@__PURE__*/ new $f70f7eb6404ce619$export$23d6a54f0bbc85a3();
const $f70f7eb6404ce619$var$_scale = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_orientation = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$4b3e397ef1832507 extends $f70f7eb6404ce619$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($f70f7eb6404ce619$var$_position, $f70f7eb6404ce619$var$_quaternion, $f70f7eb6404ce619$var$_scale);
        $f70f7eb6404ce619$var$_orientation.set(0, 0, 1).applyQuaternion($f70f7eb6404ce619$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($f70f7eb6404ce619$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($f70f7eb6404ce619$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($f70f7eb6404ce619$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($f70f7eb6404ce619$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($f70f7eb6404ce619$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($f70f7eb6404ce619$var$_orientation.z, endTime);
        } else {
            panner.setPosition($f70f7eb6404ce619$var$_position.x, $f70f7eb6404ce619$var$_position.y, $f70f7eb6404ce619$var$_position.z);
            panner.setOrientation($f70f7eb6404ce619$var$_orientation.x, $f70f7eb6404ce619$var$_orientation.y, $f70f7eb6404ce619$var$_orientation.z);
        }
    }
}
class $f70f7eb6404ce619$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $f70f7eb6404ce619$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $f70f7eb6404ce619$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $f70f7eb6404ce619$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $f70f7eb6404ce619$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $f70f7eb6404ce619$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $f70f7eb6404ce619$var$_reservedRe = new RegExp('[' + $f70f7eb6404ce619$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $f70f7eb6404ce619$var$_wordChar = '[^' + $f70f7eb6404ce619$var$_RESERVED_CHARS_RE + ']';
const $f70f7eb6404ce619$var$_wordCharOrDot = '[^' + $f70f7eb6404ce619$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $f70f7eb6404ce619$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $f70f7eb6404ce619$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $f70f7eb6404ce619$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $f70f7eb6404ce619$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $f70f7eb6404ce619$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $f70f7eb6404ce619$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $f70f7eb6404ce619$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $f70f7eb6404ce619$var$_wordChar);
const $f70f7eb6404ce619$var$_trackRe = new RegExp("^" + $f70f7eb6404ce619$var$_directoryRe + $f70f7eb6404ce619$var$_nodeRe + $f70f7eb6404ce619$var$_objectRe + $f70f7eb6404ce619$var$_propertyRe + '$');
const $f70f7eb6404ce619$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $f70f7eb6404ce619$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $f70f7eb6404ce619$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $f70f7eb6404ce619$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $f70f7eb6404ce619$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $f70f7eb6404ce619$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $f70f7eb6404ce619$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $f70f7eb6404ce619$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($f70f7eb6404ce619$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $f70f7eb6404ce619$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($f70f7eb6404ce619$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $f70f7eb6404ce619$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$f70f7eb6404ce619$export$7bf70fcf9f891893.Composite = $f70f7eb6404ce619$var$Composite;
$f70f7eb6404ce619$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$f70f7eb6404ce619$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$f70f7eb6404ce619$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._getValue_direct,
    $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._getValue_array,
    $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$f70f7eb6404ce619$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_direct,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_array,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $f70f7eb6404ce619$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $f70f7eb6404ce619$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $f70f7eb6404ce619$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $f70f7eb6404ce619$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $f70f7eb6404ce619$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $f70f7eb6404ce619$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $f70f7eb6404ce619$var$AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $f70f7eb6404ce619$export$7f795934b84ab523,
            endingEnd: $f70f7eb6404ce619$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $f70f7eb6404ce619$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $f70f7eb6404ce619$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $f70f7eb6404ce619$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $f70f7eb6404ce619$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $f70f7eb6404ce619$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $f70f7eb6404ce619$export$24a4ccb5099273b5;
            settings.endingEnd = $f70f7eb6404ce619$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $f70f7eb6404ce619$export$24a4ccb5099273b5 : $f70f7eb6404ce619$export$7f795934b84ab523;
            else settings.endingStart = $f70f7eb6404ce619$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $f70f7eb6404ce619$export$24a4ccb5099273b5 : $f70f7eb6404ce619$export$7f795934b84ab523;
            else settings.endingEnd = $f70f7eb6404ce619$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $f70f7eb6404ce619$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $f70f7eb6404ce619$export$fbd77e5aefaa0102 extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $f70f7eb6404ce619$export$dfe0af1ca1acb78a($f70f7eb6404ce619$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $f70f7eb6404ce619$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $f70f7eb6404ce619$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $f70f7eb6404ce619$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $f70f7eb6404ce619$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $f70f7eb6404ce619$var$AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $f70f7eb6404ce619$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $f70f7eb6404ce619$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $f70f7eb6404ce619$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $f70f7eb6404ce619$var$id = 0;
class $f70f7eb6404ce619$export$c412d5ffe1f79209 extends $f70f7eb6404ce619$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $f70f7eb6404ce619$var$id++
        });
        this.name = '';
        this.usage = $f70f7eb6404ce619$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++)this.uniforms.push(uniformsSource[i].clone());
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $f70f7eb6404ce619$export$25ec0e1af1389358 extends $f70f7eb6404ce619$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $f70f7eb6404ce619$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
class $f70f7eb6404ce619$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $f70f7eb6404ce619$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $f70f7eb6404ce619$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    intersectObject(object, recursive = true, intersects = []) {
        $f70f7eb6404ce619$var$intersectObject(object, this, intersects, recursive);
        intersects.sort($f70f7eb6404ce619$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$f70f7eb6404ce619$var$intersectObject(objects[i], this, intersects, recursive);
        intersects.sort($f70f7eb6404ce619$var$ascSort);
        return intersects;
    }
}
function $f70f7eb6404ce619$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $f70f7eb6404ce619$var$intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$f70f7eb6404ce619$var$intersectObject(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class $f70f7eb6404ce619$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($f70f7eb6404ce619$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $f70f7eb6404ce619$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $f70f7eb6404ce619$var$_vector$4 = /*@__PURE__*/ new $f70f7eb6404ce619$export$c977b3e384af9ae1();
class $f70f7eb6404ce619$export$60f553fa130f08b0 {
    constructor(min = new $f70f7eb6404ce619$export$c977b3e384af9ae1(Infinity, Infinity), max = new $f70f7eb6404ce619$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $f70f7eb6404ce619$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = $f70f7eb6404ce619$var$_vector$4.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $f70f7eb6404ce619$var$_startP = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_startEnd = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$e0ba6359f1954fd3 {
    constructor(start = new $f70f7eb6404ce619$export$64b5c384219d3699(), end = new $f70f7eb6404ce619$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $f70f7eb6404ce619$var$_startP.subVectors(point, this.start);
        $f70f7eb6404ce619$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $f70f7eb6404ce619$var$_startEnd.dot($f70f7eb6404ce619$var$_startEnd);
        const startEnd_startP = $f70f7eb6404ce619$var$_startEnd.dot($f70f7eb6404ce619$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $f70f7eb6404ce619$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $f70f7eb6404ce619$var$_vector$3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$4b14638ffdd81e68 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(positions, 3));
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $f70f7eb6404ce619$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $f70f7eb6404ce619$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($f70f7eb6404ce619$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $f70f7eb6404ce619$var$_vector$2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_boneMatrix = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
const $f70f7eb6404ce619$var$_matrixWorldInv = /*@__PURE__*/ new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
class $f70f7eb6404ce619$export$5277df3c9e732259 extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $f70f7eb6404ce619$var$getBoneList(object);
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $f70f7eb6404ce619$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $f70f7eb6404ce619$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $f70f7eb6404ce619$export$cbe7a62641830ebd(colors, 3));
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $f70f7eb6404ce619$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $f70f7eb6404ce619$var$_boneMatrix.multiplyMatrices($f70f7eb6404ce619$var$_matrixWorldInv, bone.matrixWorld);
                $f70f7eb6404ce619$var$_vector$2.setFromMatrixPosition($f70f7eb6404ce619$var$_boneMatrix);
                position.setXYZ(j, $f70f7eb6404ce619$var$_vector$2.x, $f70f7eb6404ce619$var$_vector$2.y, $f70f7eb6404ce619$var$_vector$2.z);
                $f70f7eb6404ce619$var$_boneMatrix.multiplyMatrices($f70f7eb6404ce619$var$_matrixWorldInv, bone.parent.matrixWorld);
                $f70f7eb6404ce619$var$_vector$2.setFromMatrixPosition($f70f7eb6404ce619$var$_boneMatrix);
                position.setXYZ(j + 1, $f70f7eb6404ce619$var$_vector$2.x, $f70f7eb6404ce619$var$_vector$2.y, $f70f7eb6404ce619$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function $f70f7eb6404ce619$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $f70f7eb6404ce619$var$getBoneList(object.children[i]));
    return boneList;
}
class $f70f7eb6404ce619$export$9a9291685b9e4023 extends $f70f7eb6404ce619$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $f70f7eb6404ce619$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $f70f7eb6404ce619$var$_vector$1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_color1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e();
const $f70f7eb6404ce619$var$_color2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$892596cec99bc70e();
class $f70f7eb6404ce619$export$8dca15f13f4f8172 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new $f70f7eb6404ce619$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $f70f7eb6404ce619$export$8dea267bd6bde117(colors, 3));
        this.add(new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $f70f7eb6404ce619$var$_color1.copy(this.light.color);
            $f70f7eb6404ce619$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $f70f7eb6404ce619$var$_color1 : $f70f7eb6404ce619$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt($f70f7eb6404ce619$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $f70f7eb6404ce619$export$3875d39926561055 extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $f70f7eb6404ce619$export$892596cec99bc70e(color1);
        color2 = new $f70f7eb6404ce619$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $f70f7eb6404ce619$export$cbe7a62641830ebd(colors, 3));
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
}
class $f70f7eb6404ce619$export$361430a10f533cd3 extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $f70f7eb6404ce619$export$892596cec99bc70e(color1);
        color2 = new $f70f7eb6404ce619$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $f70f7eb6404ce619$export$cbe7a62641830ebd(colors, 3));
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
}
const $f70f7eb6404ce619$var$_v1 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v2 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_v3 = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
class $f70f7eb6404ce619$export$f8e434dc14203e7d extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $f70f7eb6404ce619$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $f70f7eb6404ce619$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        $f70f7eb6404ce619$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $f70f7eb6404ce619$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $f70f7eb6404ce619$var$_v3.subVectors($f70f7eb6404ce619$var$_v2, $f70f7eb6404ce619$var$_v1);
        this.lightPlane.lookAt($f70f7eb6404ce619$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($f70f7eb6404ce619$var$_v2);
        this.targetLine.scale.z = $f70f7eb6404ce619$var$_v3.length();
    }
}
const $f70f7eb6404ce619$var$_vector = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
const $f70f7eb6404ce619$var$_camera = /*@__PURE__*/ new $f70f7eb6404ce619$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $f70f7eb6404ce619$export$ed8e93f853cd795 extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $f70f7eb6404ce619$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $f70f7eb6404ce619$export$892596cec99bc70e(0xff0000);
        const colorUp = new $f70f7eb6404ce619$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $f70f7eb6404ce619$export$892596cec99bc70e(0xffffff);
        const colorCross = new $f70f7eb6404ce619$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $f70f7eb6404ce619$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        $f70f7eb6404ce619$var$setPoint('c', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, 0, -1);
        $f70f7eb6404ce619$var$setPoint('t', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, 0, 1);
        // near
        $f70f7eb6404ce619$var$setPoint('n1', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w, -h, -1);
        $f70f7eb6404ce619$var$setPoint('n2', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w, -h, -1);
        $f70f7eb6404ce619$var$setPoint('n3', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w, h, -1);
        $f70f7eb6404ce619$var$setPoint('n4', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w, h, -1);
        // far
        $f70f7eb6404ce619$var$setPoint('f1', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w, -h, 1);
        $f70f7eb6404ce619$var$setPoint('f2', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w, -h, 1);
        $f70f7eb6404ce619$var$setPoint('f3', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w, h, 1);
        $f70f7eb6404ce619$var$setPoint('f4', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w, h, 1);
        // up
        $f70f7eb6404ce619$var$setPoint('u1', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w * 0.7, h * 1.1, -1);
        $f70f7eb6404ce619$var$setPoint('u2', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w * 0.7, h * 1.1, -1);
        $f70f7eb6404ce619$var$setPoint('u3', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, h * 2, -1);
        // cross
        $f70f7eb6404ce619$var$setPoint('cf1', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w, 0, 1);
        $f70f7eb6404ce619$var$setPoint('cf2', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w, 0, 1);
        $f70f7eb6404ce619$var$setPoint('cf3', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, -h, 1);
        $f70f7eb6404ce619$var$setPoint('cf4', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, h, 1);
        $f70f7eb6404ce619$var$setPoint('cn1', pointMap, geometry, $f70f7eb6404ce619$var$_camera, -w, 0, -1);
        $f70f7eb6404ce619$var$setPoint('cn2', pointMap, geometry, $f70f7eb6404ce619$var$_camera, w, 0, -1);
        $f70f7eb6404ce619$var$setPoint('cn3', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, -h, -1);
        $f70f7eb6404ce619$var$setPoint('cn4', pointMap, geometry, $f70f7eb6404ce619$var$_camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $f70f7eb6404ce619$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $f70f7eb6404ce619$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $f70f7eb6404ce619$var$_vector.x, $f70f7eb6404ce619$var$_vector.y, $f70f7eb6404ce619$var$_vector.z);
    }
}
const $f70f7eb6404ce619$var$_box = /*@__PURE__*/ new $f70f7eb6404ce619$export$6f7d5a9418ab2aa3();
class $f70f7eb6404ce619$export$38a664cc862a6a9d extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setIndex(new $f70f7eb6404ce619$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $f70f7eb6404ce619$var$_box.setFromObject(this.object);
        if ($f70f7eb6404ce619$var$_box.isEmpty()) return;
        const min = $f70f7eb6404ce619$var$_box.min;
        const max = $f70f7eb6404ce619$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
}
class $f70f7eb6404ce619$export$ce39f4bb96c9a290 extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setIndex(new $f70f7eb6404ce619$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class $f70f7eb6404ce619$export$a34fe8156c66e5d7 extends $f70f7eb6404ce619$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $f70f7eb6404ce619$export$e176487c05830cc5(geometry2, new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
}
const $f70f7eb6404ce619$var$_axis = /*@__PURE__*/ new $f70f7eb6404ce619$export$64b5c384219d3699();
let $f70f7eb6404ce619$var$_lineGeometry, $f70f7eb6404ce619$var$_coneGeometry;
class $f70f7eb6404ce619$export$a3008e7bd8d2cbe7 extends $f70f7eb6404ce619$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 1), origin = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($f70f7eb6404ce619$var$_lineGeometry === undefined) {
            $f70f7eb6404ce619$var$_lineGeometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
            $f70f7eb6404ce619$var$_lineGeometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $f70f7eb6404ce619$var$_coneGeometry = new $f70f7eb6404ce619$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $f70f7eb6404ce619$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $f70f7eb6404ce619$export$17d680238e50603e($f70f7eb6404ce619$var$_lineGeometry, new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $f70f7eb6404ce619$export$e176487c05830cc5($f70f7eb6404ce619$var$_coneGeometry, new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $f70f7eb6404ce619$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($f70f7eb6404ce619$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class $f70f7eb6404ce619$export$6c8303f35b8578fd extends $f70f7eb6404ce619$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $f70f7eb6404ce619$export$cbe7a62641830ebd(colors, 3));
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $f70f7eb6404ce619$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $f70f7eb6404ce619$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $f70f7eb6404ce619$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $f70f7eb6404ce619$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $f70f7eb6404ce619$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $f70f7eb6404ce619$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $f70f7eb6404ce619$var$_tables = /*@__PURE__*/ $f70f7eb6404ce619$var$_generateTables();
function $f70f7eb6404ce619$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $f70f7eb6404ce619$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $f70f7eb6404ce619$var$clamp(val, -65504, 65504);
    $f70f7eb6404ce619$var$_tables.floatView[0] = val;
    const f = $f70f7eb6404ce619$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $f70f7eb6404ce619$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $f70f7eb6404ce619$var$_tables.shiftTable[e]);
}
// float16 to float32
function $f70f7eb6404ce619$var$fromHalfFloat(val) {
    const m = val >> 10;
    $f70f7eb6404ce619$var$_tables.uint32View[0] = $f70f7eb6404ce619$var$_tables.mantissaTable[$f70f7eb6404ce619$var$_tables.offsetTable[m] + (val & 0x3ff)] + $f70f7eb6404ce619$var$_tables.exponentTable[m];
    return $f70f7eb6404ce619$var$_tables.floatView[0];
}
var $f70f7eb6404ce619$export$11ce8b759162cc80 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    toHalfFloat: $f70f7eb6404ce619$var$toHalfFloat,
    fromHalfFloat: $f70f7eb6404ce619$var$fromHalfFloat
});
// r134, d65e0af06644fe5a84a6fc0e372f4318f95a04c0
function $f70f7eb6404ce619$export$960665a8431ecff6() {
    console.error('THREE.ImmediateRenderObject has been removed.');
}
// r138, 48b05d3500acc084df50be9b4c90781ad9b8cb17
class $f70f7eb6404ce619$export$cb2022643d3c928d extends $f70f7eb6404ce619$export$3c052beb2e51e23f {
    constructor(width, height, options){
        console.error('THREE.WebGLMultisampleRenderTarget has been removed. Use a normal render target and set the "samples" property to greater 0 to enable multisampling.');
        super(width, height, options);
        this.samples = 4;
    }
}
// r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
class $f70f7eb6404ce619$export$e38bf4541665bbbd extends $f70f7eb6404ce619$export$dfac6c8e811406a3 {
    constructor(data, width, height, depth){
        console.warn('THREE.DataTexture2DArray has been renamed to DataArrayTexture.');
        super(data, width, height, depth);
    }
}
// r138, f9cd9cab03b7b64244e304900a3a2eeaa3a588ce
class $f70f7eb6404ce619$export$ef03cdc98340bab4 extends $f70f7eb6404ce619$export$d7a3086320f856db {
    constructor(data, width, height, depth){
        console.warn('THREE.DataTexture3D has been renamed to Data3DTexture.');
        super(data, width, height, depth);
    }
}
// r144
class $f70f7eb6404ce619$export$ab3456a079aa7d80 extends $f70f7eb6404ce619$export$33e43285f7406bd5 {
    constructor(width, height, depth, widthSegments, heightSegments, depthSegments){
        console.warn('THREE.BoxBufferGeometry has been renamed to THREE.BoxGeometry.');
        super(width, height, depth, widthSegments, heightSegments, depthSegments);
    }
}
// r144
class $f70f7eb6404ce619$export$f036d76f832848a extends $f70f7eb6404ce619$export$41680e8551036033 {
    constructor(radius, length, capSegments, radialSegments){
        console.warn('THREE.CapsuleBufferGeometry has been renamed to THREE.CapsuleGeometry.');
        super(radius, length, capSegments, radialSegments);
    }
}
// r144
class $f70f7eb6404ce619$export$3f74fe60decf7462 extends $f70f7eb6404ce619$export$d5c0e8d607467193 {
    constructor(radius, segments, thetaStart, thetaLength){
        console.warn('THREE.CircleBufferGeometry has been renamed to THREE.CircleGeometry.');
        super(radius, segments, thetaStart, thetaLength);
    }
}
// r144
class $f70f7eb6404ce619$export$59d971120dc8b6e7 extends $f70f7eb6404ce619$export$a7a48974f285c9b3 {
    constructor(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn('THREE.ConeBufferGeometry has been renamed to THREE.ConeGeometry.');
        super(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
// r144
class $f70f7eb6404ce619$export$d4345c83207d7c68 extends $f70f7eb6404ce619$export$68f745719dbe5198 {
    constructor(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength){
        console.warn('THREE.CylinderBufferGeometry has been renamed to THREE.CylinderGeometry.');
        super(radiusTop, radiusBottom, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    }
}
// r144
class $f70f7eb6404ce619$export$37cd4e52cce48c4c extends $f70f7eb6404ce619$export$c0babfeb8708fc9c {
    constructor(radius, detail){
        console.warn('THREE.DodecahedronBufferGeometry has been renamed to THREE.DodecahedronGeometry.');
        super(radius, detail);
    }
}
// r144
class $f70f7eb6404ce619$export$91836d01b9f75a58 extends $f70f7eb6404ce619$export$598697a1efa63ca7 {
    constructor(shapes, options){
        console.warn('THREE.ExtrudeBufferGeometry has been renamed to THREE.ExtrudeGeometry.');
        super(shapes, options);
    }
}
// r144
class $f70f7eb6404ce619$export$731fd4feef063ea2 extends $f70f7eb6404ce619$export$9567cc828c9535da {
    constructor(radius, detail){
        console.warn('THREE.IcosahedronBufferGeometry has been renamed to THREE.IcosahedronGeometry.');
        super(radius, detail);
    }
}
// r144
class $f70f7eb6404ce619$export$dc3e1273c1dd9240 extends $f70f7eb6404ce619$export$6d839803fcd1882c {
    constructor(points, segments, phiStart, phiLength){
        console.warn('THREE.LatheBufferGeometry has been renamed to THREE.LatheGeometry.');
        super(points, segments, phiStart, phiLength);
    }
}
// r144
class $f70f7eb6404ce619$export$8e05fc91596f4752 extends $f70f7eb6404ce619$export$1954e2b809fe361e {
    constructor(radius, detail){
        console.warn('THREE.OctahedronBufferGeometry has been renamed to THREE.OctahedronGeometry.');
        super(radius, detail);
    }
}
// r144
class $f70f7eb6404ce619$export$e789a11a194ca4e0 extends $f70f7eb6404ce619$export$967d831af31f69ce {
    constructor(width, height, widthSegments, heightSegments){
        console.warn('THREE.PlaneBufferGeometry has been renamed to THREE.PlaneGeometry.');
        super(width, height, widthSegments, heightSegments);
    }
}
// r144
class $f70f7eb6404ce619$export$38789b531813345c extends $f70f7eb6404ce619$export$60e57a7d3f20ff65 {
    constructor(vertices, indices, radius, detail){
        console.warn('THREE.PolyhedronBufferGeometry has been renamed to THREE.PolyhedronGeometry.');
        super(vertices, indices, radius, detail);
    }
}
// r144
class $f70f7eb6404ce619$export$ee8b85b34b7d9cad extends $f70f7eb6404ce619$export$68cb731f50f614af {
    constructor(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength){
        console.warn('THREE.RingBufferGeometry has been renamed to THREE.RingGeometry.');
        super(innerRadius, outerRadius, thetaSegments, phiSegments, thetaStart, thetaLength);
    }
}
// r144
class $f70f7eb6404ce619$export$233afc324766bed8 extends $f70f7eb6404ce619$export$57a29a1c803e9065 {
    constructor(shapes, curveSegments){
        console.warn('THREE.ShapeBufferGeometry has been renamed to THREE.ShapeGeometry.');
        super(shapes, curveSegments);
    }
}
// r144
class $f70f7eb6404ce619$export$d5d06a966fec4192 extends $f70f7eb6404ce619$export$1b417fc3b307a251 {
    constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength){
        console.warn('THREE.SphereBufferGeometry has been renamed to THREE.SphereGeometry.');
        super(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength);
    }
}
// r144
class $f70f7eb6404ce619$export$369e08f62a796c65 extends $f70f7eb6404ce619$export$fb3f7adc68bd6e02 {
    constructor(radius, detail){
        console.warn('THREE.TetrahedronBufferGeometry has been renamed to THREE.TetrahedronGeometry.');
        super(radius, detail);
    }
}
// r144
class $f70f7eb6404ce619$export$19d55f905fa4f2cb extends $f70f7eb6404ce619$export$a2312a2a1fa56495 {
    constructor(radius, tube, radialSegments, tubularSegments, arc){
        console.warn('THREE.TorusBufferGeometry has been renamed to THREE.TorusGeometry.');
        super(radius, tube, radialSegments, tubularSegments, arc);
    }
}
// r144
class $f70f7eb6404ce619$export$2b32466f4274fe5c extends $f70f7eb6404ce619$export$77e9bfadfb9ab8c8 {
    constructor(radius, tube, tubularSegments, radialSegments, p, q){
        console.warn('THREE.TorusKnotBufferGeometry has been renamed to THREE.TorusKnotGeometry.');
        super(radius, tube, tubularSegments, radialSegments, p, q);
    }
}
// r144
class $f70f7eb6404ce619$export$d97a193ce44e691b extends $f70f7eb6404ce619$export$7897d9d48904490c {
    constructor(path, tubularSegments, radius, radialSegments, closed){
        console.warn('THREE.TubeBufferGeometry has been renamed to THREE.TubeGeometry.');
        super(path, tubularSegments, radius, radialSegments, closed);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $f70f7eb6404ce619$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $f70f7eb6404ce619$export$3545e07a80636437;
}



class $6d108ce629b3bd63$var$GLApp {
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
    }
    init() {
        this.initThree();
        this.addListeners();
        this.resize();
    }
    initThree() {
        this.renderer = new $f70f7eb6404ce619$export$f6cc00ef28d7cf97({
            antialias: true,
            alpha: true
        });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.domElement.classList.add('gl-app');
        this.clock = new $f70f7eb6404ce619$export$9735c82c4bae3302();
    }
    addListeners() {
        window.addEventListener('resize', this.resize);
    }
    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    resize(vw, vh) {
        if (!this.renderer) return;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
}
var $6d108ce629b3bd63$export$2e2bcd8739ae039 = new $6d108ce629b3bd63$var$GLApp();


// import dateformat from 'dateformat';


var $f1z04 = parcelRequire("f1z04");
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $f1z04 = parcelRequire("f1z04");
var $4daeca3a962ccad2$var$_win, $4daeca3a962ccad2$var$_doc, $4daeca3a962ccad2$var$_docElement, $4daeca3a962ccad2$var$_pluginInitted, $4daeca3a962ccad2$var$_tempDiv, $4daeca3a962ccad2$var$_tempDivStyler, $4daeca3a962ccad2$var$_recentSetterPlugin, $4daeca3a962ccad2$var$_reverting, $4daeca3a962ccad2$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4daeca3a962ccad2$var$_transformProps = {}, $4daeca3a962ccad2$var$_RAD2DEG = 180 / Math.PI, $4daeca3a962ccad2$var$_DEG2RAD = Math.PI / 180, $4daeca3a962ccad2$var$_atan2 = Math.atan2, $4daeca3a962ccad2$var$_bigNum = 1e8, $4daeca3a962ccad2$var$_capsExp = /([A-Z])/g, $4daeca3a962ccad2$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $4daeca3a962ccad2$var$_complexExp = /[\s,\(]\S/, $4daeca3a962ccad2$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $4daeca3a962ccad2$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $4daeca3a962ccad2$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $4daeca3a962ccad2$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$4daeca3a962ccad2$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $4daeca3a962ccad2$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $4daeca3a962ccad2$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $4daeca3a962ccad2$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $4daeca3a962ccad2$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $4daeca3a962ccad2$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $4daeca3a962ccad2$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $4daeca3a962ccad2$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $4daeca3a962ccad2$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $4daeca3a962ccad2$var$_transformProp = "transform", $4daeca3a962ccad2$var$_transformOriginProp = $4daeca3a962ccad2$var$_transformProp + "Origin", $4daeca3a962ccad2$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in $4daeca3a962ccad2$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $4daeca3a962ccad2$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $4daeca3a962ccad2$var$_get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : $4daeca3a962ccad2$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === $4daeca3a962ccad2$var$_transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return $4daeca3a962ccad2$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($4daeca3a962ccad2$var$_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($4daeca3a962ccad2$var$_transformOriginProp, isNotCSS, "");
        }
        property = $4daeca3a962ccad2$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $4daeca3a962ccad2$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $4daeca3a962ccad2$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($4daeca3a962ccad2$var$_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $4daeca3a962ccad2$var$_reverting();
        if ((!i || !i.isStart) && !style[$4daeca3a962ccad2$var$_transformProp]) {
            $4daeca3a962ccad2$var$_removeIndependentTransforms(style);
            if (cache.zOrigin && style[$4daeca3a962ccad2$var$_transformOriginProp]) {
                style[$4daeca3a962ccad2$var$_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $4daeca3a962ccad2$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $4daeca3a962ccad2$var$_revertStyle,
        save: $4daeca3a962ccad2$var$_saveStyle
    };
    target._gsap || (0, $f1z04.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, $4daeca3a962ccad2$var$_supports3D, $4daeca3a962ccad2$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $4daeca3a962ccad2$var$_doc.createElementNS ? $4daeca3a962ccad2$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $4daeca3a962ccad2$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : $4daeca3a962ccad2$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $4daeca3a962ccad2$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($4daeca3a962ccad2$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $4daeca3a962ccad2$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $4daeca3a962ccad2$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $4daeca3a962ccad2$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $4daeca3a962ccad2$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($4daeca3a962ccad2$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $4daeca3a962ccad2$var$_prefixes[i] : "") + property;
}, $4daeca3a962ccad2$var$_initCore = function _initCore() {
    if ($4daeca3a962ccad2$var$_windowExists() && window.document) {
        $4daeca3a962ccad2$var$_win = window;
        $4daeca3a962ccad2$var$_doc = $4daeca3a962ccad2$var$_win.document;
        $4daeca3a962ccad2$var$_docElement = $4daeca3a962ccad2$var$_doc.documentElement;
        $4daeca3a962ccad2$var$_tempDiv = $4daeca3a962ccad2$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $4daeca3a962ccad2$var$_tempDivStyler = $4daeca3a962ccad2$export$a232bb0480ae674a("div");
        $4daeca3a962ccad2$var$_transformProp = $4daeca3a962ccad2$export$8cbef5dd49a09c8b($4daeca3a962ccad2$var$_transformProp);
        $4daeca3a962ccad2$var$_transformOriginProp = $4daeca3a962ccad2$var$_transformProp + "Origin";
        $4daeca3a962ccad2$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $4daeca3a962ccad2$var$_supports3D = !!$4daeca3a962ccad2$export$8cbef5dd49a09c8b("perspective");
        $4daeca3a962ccad2$var$_reverting = (0, $f1z04.gsap).core.reverting;
        $4daeca3a962ccad2$var$_pluginInitted = 1;
    }
}, $4daeca3a962ccad2$var$_getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = $4daeca3a962ccad2$export$a232bb0480ae674a("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    $4daeca3a962ccad2$var$_docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    $4daeca3a962ccad2$var$_docElement.removeChild(svg);
    return bbox;
}, $4daeca3a962ccad2$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $4daeca3a962ccad2$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $4daeca3a962ccad2$var$_getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = $4daeca3a962ccad2$var$_getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$4daeca3a962ccad2$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$4daeca3a962ccad2$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $4daeca3a962ccad2$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $4daeca3a962ccad2$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$4daeca3a962ccad2$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in $4daeca3a962ccad2$var$_transformProps && property !== $4daeca3a962ccad2$var$_transformOriginProp) property = $4daeca3a962ccad2$var$_transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace($4daeca3a962ccad2$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $4daeca3a962ccad2$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $f1z04.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $4daeca3a962ccad2$var$_renderNonTweeningValueOnlyAtEnd : $4daeca3a962ccad2$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $4daeca3a962ccad2$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $4daeca3a962ccad2$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$4daeca3a962ccad2$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $4daeca3a962ccad2$var$_tempDiv.style, horizontal = $4daeca3a962ccad2$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $4daeca3a962ccad2$var$_nonConvertibleUnits[unit] || $4daeca3a962ccad2$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $4daeca3a962ccad2$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($4daeca3a962ccad2$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $f1z04._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $4daeca3a962ccad2$var$_doc || !parent.appendChild) parent = $4daeca3a962ccad2$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $f1z04._ticker).time && !cache.uncache) return (0, $f1z04._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : $4daeca3a962ccad2$var$_removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !$4daeca3a962ccad2$var$_nonStandardLayouts[$4daeca3a962ccad2$var$_getComputedProperty(parent, "display")] && (style.position = $4daeca3a962ccad2$var$_getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild($4daeca3a962ccad2$var$_tempDiv);
            px = $4daeca3a962ccad2$var$_tempDiv[measureProperty];
            parent.removeChild($4daeca3a962ccad2$var$_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, $f1z04._getCache)(parent);
            cache.time = (0, $f1z04._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $f1z04._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $4daeca3a962ccad2$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $4daeca3a962ccad2$var$_pluginInitted || $4daeca3a962ccad2$var$_initCore();
    if (property in $4daeca3a962ccad2$var$_propertyAliases && property !== "transform") {
        property = $4daeca3a962ccad2$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($4daeca3a962ccad2$var$_transformProps[property] && property !== "transform") {
        value = $4daeca3a962ccad2$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $4daeca3a962ccad2$var$_firstTwoOnly($4daeca3a962ccad2$var$_getComputedProperty(target, $4daeca3a962ccad2$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $4daeca3a962ccad2$var$_specialProps[property] && $4daeca3a962ccad2$var$_specialProps[property](target, property, unit) || $4daeca3a962ccad2$var$_getComputedProperty(target, property) || (0, $f1z04._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $4daeca3a962ccad2$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $4daeca3a962ccad2$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $4daeca3a962ccad2$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $4daeca3a962ccad2$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $4daeca3a962ccad2$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $f1z04.PropTween)(this._pt, target.style, prop, 0, 1, (0, $f1z04._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = $4daeca3a962ccad2$var$_getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = $4daeca3a962ccad2$var$_getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : $4daeca3a962ccad2$var$_removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, $f1z04._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $f1z04._numWithUnitExp)) || [];
    endValues = end.match((0, $f1z04._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $f1z04._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $f1z04._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $f1z04._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $f1z04._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $4daeca3a962ccad2$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $4daeca3a962ccad2$var$_renderNonTweeningValueOnlyAtEnd : $4daeca3a962ccad2$var$_renderNonTweeningValue;
    (0, $f1z04._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $4daeca3a962ccad2$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $4daeca3a962ccad2$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $4daeca3a962ccad2$var$_keywordToPercent[x] || x;
    split[1] = $4daeca3a962ccad2$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $4daeca3a962ccad2$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($4daeca3a962ccad2$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $4daeca3a962ccad2$var$_transformOriginProp : $4daeca3a962ccad2$var$_transformProp;
                }
                $4daeca3a962ccad2$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $4daeca3a962ccad2$var$_removeProperty(target, $4daeca3a962ccad2$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                $4daeca3a962ccad2$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $4daeca3a962ccad2$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$4daeca3a962ccad2$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $f1z04.PropTween)(plugin._pt, target, property, 0, 0, $4daeca3a962ccad2$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $4daeca3a962ccad2$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $4daeca3a962ccad2$var$_rotationalProperties = {}, $4daeca3a962ccad2$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $4daeca3a962ccad2$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $4daeca3a962ccad2$var$_getComputedProperty(target, $4daeca3a962ccad2$var$_transformProp);
    return $4daeca3a962ccad2$var$_isNullTransform(matrixString) ? $4daeca3a962ccad2$var$_identity2DMatrix : matrixString.substr(7).match((0, $f1z04._numExp)).map((0, $f1z04._round));
}, $4daeca3a962ccad2$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $f1z04._getCache)(target), style = target.style, matrix = $4daeca3a962ccad2$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $4daeca3a962ccad2$var$_identity2DMatrix : matrix;
    } else if (matrix === $4daeca3a962ccad2$var$_identity2DMatrix && !target.offsetParent && target !== $4daeca3a962ccad2$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $4daeca3a962ccad2$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $4daeca3a962ccad2$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $4daeca3a962ccad2$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $4daeca3a962ccad2$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $4daeca3a962ccad2$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $4daeca3a962ccad2$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $4daeca3a962ccad2$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== $4daeca3a962ccad2$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$4daeca3a962ccad2$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $4daeca3a962ccad2$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $4daeca3a962ccad2$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $4daeca3a962ccad2$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $4daeca3a962ccad2$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $4daeca3a962ccad2$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $f1z04.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $4daeca3a962ccad2$var$_getComputedProperty(target, $4daeca3a962ccad2$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $4daeca3a962ccad2$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$4daeca3a962ccad2$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$4daeca3a962ccad2$var$_transformProp] !== "none" ? cs[$4daeca3a962ccad2$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $4daeca3a962ccad2$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $4daeca3a962ccad2$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $4daeca3a962ccad2$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $4daeca3a962ccad2$var$_atan2(b, a) * $4daeca3a962ccad2$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $4daeca3a962ccad2$var$_atan2(c, d) * $4daeca3a962ccad2$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $4daeca3a962ccad2$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $4daeca3a962ccad2$var$_atan2(a32, a33);
            rotationX = angle * $4daeca3a962ccad2$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $4daeca3a962ccad2$var$_atan2(-c, a33);
            rotationY = angle * $4daeca3a962ccad2$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $4daeca3a962ccad2$var$_atan2(b, a);
            rotation = angle * $4daeca3a962ccad2$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $f1z04._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $f1z04._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $4daeca3a962ccad2$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $4daeca3a962ccad2$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$4daeca3a962ccad2$var$_isNullTransform($4daeca3a962ccad2$var$_getComputedProperty(target, $4daeca3a962ccad2$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $f1z04._round)(scaleX);
    cache.scaleY = (0, $f1z04._round)(scaleY);
    cache.rotation = (0, $f1z04._round)(rotation) + deg;
    cache.rotationX = (0, $f1z04._round)(rotationX) + deg;
    cache.rotationY = (0, $f1z04._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[$4daeca3a962ccad2$var$_transformOriginProp] = $4daeca3a962ccad2$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $f1z04._config).force3D;
    cache.renderTransform = cache.svg ? $4daeca3a962ccad2$var$_renderSVGTransforms : $4daeca3a962ccad2$var$_supports3D ? $4daeca3a962ccad2$var$_renderCSSTransforms : $4daeca3a962ccad2$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $4daeca3a962ccad2$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$4daeca3a962ccad2$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $f1z04.getUnit)(start);
    return (0, $f1z04._round)(parseFloat(start) + parseFloat($4daeca3a962ccad2$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $4daeca3a962ccad2$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $4daeca3a962ccad2$var$_renderCSSTransforms(ratio, cache);
}, $4daeca3a962ccad2$var$_zeroDeg = "0deg", $4daeca3a962ccad2$var$_zeroPx = "0px", $4daeca3a962ccad2$var$_endParenthesis = ") ", $4daeca3a962ccad2$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $4daeca3a962ccad2$var$_zeroDeg || rotationY !== $4daeca3a962ccad2$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $4daeca3a962ccad2$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $4daeca3a962ccad2$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $4daeca3a962ccad2$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $4daeca3a962ccad2$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $4daeca3a962ccad2$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $4daeca3a962ccad2$var$_zeroPx) transforms += "perspective(" + transformPerspective + $4daeca3a962ccad2$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $4daeca3a962ccad2$var$_zeroPx || y !== $4daeca3a962ccad2$var$_zeroPx || z !== $4daeca3a962ccad2$var$_zeroPx) transforms += z !== $4daeca3a962ccad2$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $4daeca3a962ccad2$var$_endParenthesis;
    if (rotation !== $4daeca3a962ccad2$var$_zeroDeg) transforms += "rotate(" + rotation + $4daeca3a962ccad2$var$_endParenthesis;
    if (rotationY !== $4daeca3a962ccad2$var$_zeroDeg) transforms += "rotateY(" + rotationY + $4daeca3a962ccad2$var$_endParenthesis;
    if (rotationX !== $4daeca3a962ccad2$var$_zeroDeg) transforms += "rotateX(" + rotationX + $4daeca3a962ccad2$var$_endParenthesis;
    if (skewX !== $4daeca3a962ccad2$var$_zeroDeg || skewY !== $4daeca3a962ccad2$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $4daeca3a962ccad2$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $4daeca3a962ccad2$var$_endParenthesis;
    target.style[$4daeca3a962ccad2$var$_transformProp] = transforms || "translate(0, 0)";
}, $4daeca3a962ccad2$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $4daeca3a962ccad2$var$_DEG2RAD;
        skewX *= $4daeca3a962ccad2$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $4daeca3a962ccad2$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $f1z04._round)(a11);
        a21 = (0, $f1z04._round)(a21);
        a12 = (0, $f1z04._round)(a12);
        a22 = (0, $f1z04._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $4daeca3a962ccad2$var$_convertToUnit(target, "x", x, "px");
        ty = $4daeca3a962ccad2$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $f1z04._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $f1z04._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $f1z04._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $f1z04._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$4daeca3a962ccad2$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $4daeca3a962ccad2$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $f1z04._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $4daeca3a962ccad2$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $4daeca3a962ccad2$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $4daeca3a962ccad2$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $f1z04.PropTween)(plugin._pt, target, property, startNum, change, $4daeca3a962ccad2$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $4daeca3a962ccad2$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $4daeca3a962ccad2$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $4daeca3a962ccad2$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$4daeca3a962ccad2$var$_transformProp] = transforms;
        endCache = $4daeca3a962ccad2$var$_parseTransform(target, 1);
        $4daeca3a962ccad2$var$_removeProperty(target, $4daeca3a962ccad2$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$4daeca3a962ccad2$var$_transformProp];
        style[$4daeca3a962ccad2$var$_transformProp] = transforms;
        endCache = $4daeca3a962ccad2$var$_parseTransform(target, 1);
        style[$4daeca3a962ccad2$var$_transformProp] = startValue;
    }
    for(p in $4daeca3a962ccad2$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $f1z04.getUnit)(startValue);
            endUnit = (0, $f1z04.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $4daeca3a962ccad2$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $f1z04.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $4daeca3a962ccad2$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $4daeca3a962ccad2$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $f1z04._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $4daeca3a962ccad2$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $4daeca3a962ccad2$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $4daeca3a962ccad2$export$855822f522f18eef = {
    name: "css",
    register: $4daeca3a962ccad2$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $4daeca3a962ccad2$var$_pluginInitted || $4daeca3a962ccad2$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $4daeca3a962ccad2$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $f1z04._plugins)[p] && (0, $f1z04._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $4daeca3a962ccad2$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $f1z04._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $f1z04._colorExp).lastIndex = 0;
                if (!(0, $f1z04._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $f1z04.getUnit)(startValue);
                    endUnit = (0, $f1z04.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $4daeca3a962ccad2$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $f1z04._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $f1z04._replaceRandom)(startValue));
                    (0, $f1z04.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, $f1z04._config).units[p] || (0, $f1z04.getUnit)($4daeca3a962ccad2$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $4daeca3a962ccad2$var$_get(target, p)); // can't work with relative values
                } else startValue = $4daeca3a962ccad2$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $4daeca3a962ccad2$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $4daeca3a962ccad2$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $4daeca3a962ccad2$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $4daeca3a962ccad2$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $4daeca3a962ccad2$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = $4daeca3a962ccad2$var$_getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $4daeca3a962ccad2$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $f1z04.PropTween)(this._pt, style, $4daeca3a962ccad2$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $f1z04.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $f1z04._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $4daeca3a962ccad2$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($4daeca3a962ccad2$var$_transformOriginProp, 0, style[$4daeca3a962ccad2$var$_transformOriginProp]);
                        endValue = $4daeca3a962ccad2$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $4daeca3a962ccad2$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $4daeca3a962ccad2$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $4daeca3a962ccad2$var$_addNonTweeningPT(this, style, p, $4daeca3a962ccad2$var$_firstTwoOnly(startValue), $4daeca3a962ccad2$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $4daeca3a962ccad2$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $4daeca3a962ccad2$var$_rotationalProperties) {
                        $4daeca3a962ccad2$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $f1z04._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $4daeca3a962ccad2$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $4daeca3a962ccad2$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $4daeca3a962ccad2$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$4daeca3a962ccad2$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $f1z04.getUnit)(endValue) || (p in (0, $f1z04._config).units ? (0, $f1z04._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $4daeca3a962ccad2$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $f1z04.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $f1z04._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $4daeca3a962ccad2$var$_renderRoundedCSSProp : $4daeca3a962ccad2$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $4daeca3a962ccad2$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $f1z04._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $4daeca3a962ccad2$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $f1z04._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$4daeca3a962ccad2$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $4daeca3a962ccad2$var$_get,
    aliases: $4daeca3a962ccad2$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $4daeca3a962ccad2$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $4daeca3a962ccad2$var$_transformProps && property !== $4daeca3a962ccad2$var$_transformOriginProp && (target._gsap.x || $4daeca3a962ccad2$var$_get(target, "x")) ? plugin && $4daeca3a962ccad2$var$_recentSetterPlugin === plugin ? property === "scale" ? $4daeca3a962ccad2$var$_setterScale : $4daeca3a962ccad2$var$_setterTransform : ($4daeca3a962ccad2$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $4daeca3a962ccad2$var$_setterScaleWithRender : $4daeca3a962ccad2$var$_setterTransformWithRender) : target.style && !(0, $f1z04._isUndefined)(target.style[property]) ? $4daeca3a962ccad2$var$_setterCSSStyle : ~property.indexOf("-") ? $4daeca3a962ccad2$var$_setterCSSProp : (0, $f1z04._getSetter)(target, property);
    },
    core: {
        _removeProperty: $4daeca3a962ccad2$var$_removeProperty,
        _getMatrix: $4daeca3a962ccad2$var$_getMatrix
    }
};
(0, $f1z04.gsap).utils.checkPrefix = $4daeca3a962ccad2$export$8cbef5dd49a09c8b;
(0, $f1z04.gsap).core.getStyleSaver = $4daeca3a962ccad2$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $f1z04._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $4daeca3a962ccad2$var$_transformProps[name] = 1;
    });
    (0, $f1z04._forEachName)(rotation, function(name) {
        (0, $f1z04._config).units[name] = "deg";
        $4daeca3a962ccad2$var$_rotationalProperties[name] = 1;
    });
    $4daeca3a962ccad2$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $f1z04._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $4daeca3a962ccad2$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $f1z04._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $f1z04._config).units[name] = "px";
});
(0, $f1z04.gsap).registerPlugin($4daeca3a962ccad2$export$855822f522f18eef);


var $c5f6ad5335c7d493$export$99ee26438460406a = (0, $f1z04.gsap).registerPlugin((0, $4daeca3a962ccad2$export$855822f522f18eef)) || (0, $f1z04.gsap), // to protect from tree shaking
$c5f6ad5335c7d493$export$7b23975ad686bf91 = $c5f6ad5335c7d493$export$99ee26438460406a.core.Tween;





var $6ab0340c5ed2956f$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6ab0340c5ed2956f$var$R = typeof Reflect === 'object' ? Reflect : null;
var $6ab0340c5ed2956f$var$ReflectApply = $6ab0340c5ed2956f$var$R && typeof $6ab0340c5ed2956f$var$R.apply === 'function' ? $6ab0340c5ed2956f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $6ab0340c5ed2956f$var$ReflectOwnKeys;
if ($6ab0340c5ed2956f$var$R && typeof $6ab0340c5ed2956f$var$R.ownKeys === 'function') $6ab0340c5ed2956f$var$ReflectOwnKeys = $6ab0340c5ed2956f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $6ab0340c5ed2956f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $6ab0340c5ed2956f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $6ab0340c5ed2956f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $6ab0340c5ed2956f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $6ab0340c5ed2956f$var$EventEmitter() {
    $6ab0340c5ed2956f$var$EventEmitter.init.call(this);
}
$6ab0340c5ed2956f$exports = $6ab0340c5ed2956f$var$EventEmitter;
$6ab0340c5ed2956f$exports.once = $6ab0340c5ed2956f$var$once;
// Backwards-compat with node 0.10.x
$6ab0340c5ed2956f$var$EventEmitter.EventEmitter = $6ab0340c5ed2956f$var$EventEmitter;
$6ab0340c5ed2956f$var$EventEmitter.prototype._events = undefined;
$6ab0340c5ed2956f$var$EventEmitter.prototype._eventsCount = 0;
$6ab0340c5ed2956f$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $6ab0340c5ed2956f$var$defaultMaxListeners = 10;
function $6ab0340c5ed2956f$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($6ab0340c5ed2956f$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $6ab0340c5ed2956f$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $6ab0340c5ed2956f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $6ab0340c5ed2956f$var$defaultMaxListeners = arg;
    }
});
$6ab0340c5ed2956f$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6ab0340c5ed2956f$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $6ab0340c5ed2956f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $6ab0340c5ed2956f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $6ab0340c5ed2956f$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$6ab0340c5ed2956f$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $6ab0340c5ed2956f$var$_getMaxListeners(this);
};
$6ab0340c5ed2956f$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $6ab0340c5ed2956f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $6ab0340c5ed2956f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$6ab0340c5ed2956f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $6ab0340c5ed2956f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $6ab0340c5ed2956f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $6ab0340c5ed2956f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $6ab0340c5ed2956f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$6ab0340c5ed2956f$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $6ab0340c5ed2956f$var$_addListener(this, type, listener, false);
};
$6ab0340c5ed2956f$var$EventEmitter.prototype.on = $6ab0340c5ed2956f$var$EventEmitter.prototype.addListener;
$6ab0340c5ed2956f$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $6ab0340c5ed2956f$var$_addListener(this, type, listener, true);
};
function $6ab0340c5ed2956f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $6ab0340c5ed2956f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $6ab0340c5ed2956f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$6ab0340c5ed2956f$var$EventEmitter.prototype.once = function once(type, listener) {
    $6ab0340c5ed2956f$var$checkListener(listener);
    this.on(type, $6ab0340c5ed2956f$var$_onceWrap(this, type, listener));
    return this;
};
$6ab0340c5ed2956f$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $6ab0340c5ed2956f$var$checkListener(listener);
    this.prependListener(type, $6ab0340c5ed2956f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$6ab0340c5ed2956f$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $6ab0340c5ed2956f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $6ab0340c5ed2956f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$6ab0340c5ed2956f$var$EventEmitter.prototype.off = $6ab0340c5ed2956f$var$EventEmitter.prototype.removeListener;
$6ab0340c5ed2956f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $6ab0340c5ed2956f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $6ab0340c5ed2956f$var$unwrapListeners(evlistener) : $6ab0340c5ed2956f$var$arrayClone(evlistener, evlistener.length);
}
$6ab0340c5ed2956f$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $6ab0340c5ed2956f$var$_listeners(this, type, true);
};
$6ab0340c5ed2956f$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $6ab0340c5ed2956f$var$_listeners(this, type, false);
};
$6ab0340c5ed2956f$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $6ab0340c5ed2956f$var$listenerCount.call(emitter, type);
};
$6ab0340c5ed2956f$var$EventEmitter.prototype.listenerCount = $6ab0340c5ed2956f$var$listenerCount;
function $6ab0340c5ed2956f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$6ab0340c5ed2956f$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $6ab0340c5ed2956f$var$ReflectOwnKeys(this._events) : [];
};
function $6ab0340c5ed2956f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $6ab0340c5ed2956f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $6ab0340c5ed2956f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $6ab0340c5ed2956f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $6ab0340c5ed2956f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $6ab0340c5ed2956f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $6ab0340c5ed2956f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $6ab0340c5ed2956f$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $6ab0340c5ed2956f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}



class $f1489fac31bae754$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($6ab0340c5ed2956f$exports))) {
    get enabled() {
        return this._enabled;
    }
    constructor(camera, el){
        super();
        this.camera = camera;
        this.el = el || window;
        this.plane = new $f70f7eb6404ce619$export$7ff5ac152ef991b0();
        this.raycaster = new $f70f7eb6404ce619$export$8b7aaceff00bd2f();
        this.mouse = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        this.offset = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.intersection = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.objects = [];
        this.hovered = null;
        this.selected = null;
        this.isDown = false;
        this.enable();
    }
    enable() {
        if (this.enabled) return;
        this.addListeners();
        this._enabled = true;
    }
    disable() {
        if (!this.enabled) return;
        this.removeListeners();
        this._enabled = false;
        this.el.style.cursor = 'initial';
    }
    addListeners() {
        this.handlerTouchStart = this.onTouchStart.bind(this);
        this.handlerTouchMove = this.onTouchMove.bind(this);
        this.handlerTouchEnd = this.onTouchEnd.bind(this);
        this.handlerMouseDown = this.onMouseDown.bind(this);
        this.handlerMouseMove = this.onMouseMove.bind(this);
        this.handlerMouseUp = this.onMouseUp.bind(this);
        this.handlerMouseLeave = this.onMouseLeave.bind(this);
        this.el.addEventListener('touchstart', this.handlerTouchStart);
        this.el.addEventListener('touchmove', this.handlerTouchMove);
        this.el.addEventListener('touchend', this.handlerTouchEnd);
        this.el.addEventListener('mousedown', this.handlerMouseDown);
        this.el.addEventListener('mousemove', this.handlerMouseMove);
        this.el.addEventListener('mouseup', this.handlerMouseUp);
        this.el.addEventListener('mouseleave', this.handlerMouseLeave);
    }
    removeListeners() {
        this.el.removeEventListener('touchstart', this.handlerTouchStart);
        this.el.removeEventListener('touchmove', this.handlerTouchMove);
        this.el.removeEventListener('touchend', this.handlerTouchEnd);
        this.el.removeEventListener('mousedown', this.handlerMouseDown);
        this.el.removeEventListener('mousemove', this.handlerMouseMove);
        this.el.removeEventListener('mouseup', this.handlerMouseUp);
        this.el.removeEventListener('mouseleave', this.handlerMouseLeave);
    }
    resize(x, y, width, height) {
        if (x || y || width || height) this.rect = {
            x: x,
            y: y,
            width: width,
            height: height
        };
        else if (this.el === window) this.rect = {
            x: 0,
            y: 0,
            width: window.innerWidth,
            height: window.innerHeight
        };
        else this.rect = this.el.getBoundingClientRect();
    }
    onMove(e) {
        const t = e.touches ? e.touches[0] : e;
        const touch = {
            x: t.clientX,
            y: t.clientY
        };
        this.mouse.x = (touch.x - this.rect.x) / this.rect.width * 2 - 1;
        this.mouse.y = -((touch.y - this.rect.y) / this.rect.height) * 2 + 1;
        this.raycaster.setFromCamera(this.mouse, this.camera);
        /*
    // is dragging
    if (this.selected && this.isDown) {
      if (this.raycaster.ray.intersectPlane(this.plane, this.intersection)) {
        this.emit('interactive-drag', { object: this.selected, position: this.intersection.sub(this.offset) });
      }
      return;
    }
    */ const intersects = this.raycaster.intersectObjects(this.objects);
        if (intersects.length > 0) {
            this.intersectionData = intersects[0];
            // pass through: emit move and continue through next intersected object
            if (intersects[0].object.passThrough) {
                // this.emit('interactive-over', { object: intersects[0].object });
                this.emit('interactive-move', {
                    object: intersects[0].object,
                    intersectionData: this.intersectionData
                });
                const index = intersects.findIndex((e)=>!e.object.passThrough);
                if (index != -1) this.intersectionData = intersects[index];
            }
            const object = this.intersectionData.object;
            this.plane.setFromNormalAndCoplanarPoint(this.camera.getWorldDirection(this.plane.normal), object.position);
            if (this.hovered !== object) {
                this.emit('interactive-out', {
                    object: this.hovered
                });
                this.emit('interactive-over', {
                    object: object
                });
                this.hovered = object;
                this.el.style.cursor = 'pointer';
            } else this.emit('interactive-move', {
                object: object,
                intersectionData: this.intersectionData
            });
        } else {
            this.intersectionData = null;
            if (this.hovered !== null) {
                this.emit('interactive-out', {
                    object: this.hovered
                });
                this.hovered = null;
                this.el.style.cursor = 'initial';
            }
        }
    }
    onDown(e) {
        this.isDown = true;
        this.onMove(e);
        this.emit('interactive-down', {
            object: this.hovered,
            previous: this.selected,
            intersectionData: this.intersectionData
        });
        this.selected = this.hovered;
        if (this.selected) {
            if (this.raycaster.ray.intersectPlane(this.plane, this.intersection)) this.offset.copy(this.intersection).sub(this.selected.position);
        }
    }
    onUp(e) {
        this.isDown = false;
        this.emit('interactive-up', {
            object: this.hovered
        });
    }
    onTouchStart(e) {
        this.isTouch = true;
        this.onDown(e);
    }
    onTouchMove(e) {
        this.isTouch = true;
        this.onMove(e);
    }
    onTouchEnd(e) {
        this.isTouch = true;
        this.onUp(e);
    }
    onMouseDown(e) {
        if (!this.isTouch) this.onDown(e);
    }
    onMouseMove(e) {
        if (!this.isTouch) this.onMove(e);
    }
    onMouseUp(e) {
        if (!this.isTouch) this.onUp(e);
    }
    onMouseLeave(e) {
        this.onUp(e);
        this.emit('interactive-out', {
            object: this.hovered
        });
        this.hovered = null;
    }
}


const $d1a28c8d5f44cae3$export$d07517a676ce386f = {
    mobile: 480,
    tablet: 900,
    desktop: 1024,
    wide: 1600
};
let $d1a28c8d5f44cae3$var$_isMobile = false;
const $d1a28c8d5f44cae3$export$4ac03e21946e1081 = (state)=>{
    $d1a28c8d5f44cae3$var$_isMobile = state;
};
const $d1a28c8d5f44cae3$export$d0a8044dce8ff2fc = ()=>{
    return $d1a28c8d5f44cae3$var$_isMobile;
};
const $d1a28c8d5f44cae3$export$6788812c4e6611e6 = (breakpoint, cb)=>{
    const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);
    if (mediaQuery.matches) // Then trigger an alert
    return cb();
};
const $d1a28c8d5f44cae3$export$a40009bd2c363351 = (breakpoint, cb)=>{
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    if (mediaQuery.matches) // Then trigger an alert
    return cb();
};





const $90da350a0f6b1a38$var$_box = new (0, $f70f7eb6404ce619$export$6f7d5a9418ab2aa3)();
const $90da350a0f6b1a38$var$_vector = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
class $90da350a0f6b1a38$export$5b1256aa5274bf8 extends (0, $f70f7eb6404ce619$export$231f009cbe414146) {
    constructor(){
        super();
        this.isLineSegmentsGeometry = true;
        this.type = 'LineSegmentsGeometry';
        const positions = [
            -1,
            2,
            0,
            1,
            2,
            0,
            -1,
            1,
            0,
            1,
            1,
            0,
            -1,
            0,
            0,
            1,
            0,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const uvs = [
            -1,
            2,
            1,
            2,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -2,
            1,
            -2
        ];
        const index = [
            0,
            2,
            1,
            2,
            3,
            1,
            2,
            4,
            3,
            4,
            5,
            3,
            4,
            6,
            5,
            6,
            7,
            5
        ];
        this.setIndex(index);
        this.setAttribute('position', new (0, $f70f7eb6404ce619$export$cbe7a62641830ebd)(positions, 3));
        this.setAttribute('uv', new (0, $f70f7eb6404ce619$export$cbe7a62641830ebd)(uvs, 2));
    }
    applyMatrix4(matrix) {
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined) {
            start.applyMatrix4(matrix);
            end.applyMatrix4(matrix);
            start.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    setPositions(array) {
        let lineSegments;
        if (array instanceof Float32Array) lineSegments = array;
        else if (Array.isArray(array)) lineSegments = new Float32Array(array);
        const instanceBuffer = new (0, $f70f7eb6404ce619$export$25ec0e1af1389358)(lineSegments, 6, 1); // xyz, xyz
        this.setAttribute('instanceStart', new (0, $f70f7eb6404ce619$export$920b6d07334599c7)(instanceBuffer, 3, 0)); // xyz
        this.setAttribute('instanceEnd', new (0, $f70f7eb6404ce619$export$920b6d07334599c7)(instanceBuffer, 3, 3)); // xyz
        //
        this.computeBoundingBox();
        this.computeBoundingSphere();
        return this;
    }
    setColors(array) {
        let colors;
        if (array instanceof Float32Array) colors = array;
        else if (Array.isArray(array)) colors = new Float32Array(array);
        const instanceColorBuffer = new (0, $f70f7eb6404ce619$export$25ec0e1af1389358)(colors, 6, 1); // rgb, rgb
        this.setAttribute('instanceColorStart', new (0, $f70f7eb6404ce619$export$920b6d07334599c7)(instanceColorBuffer, 3, 0)); // rgb
        this.setAttribute('instanceColorEnd', new (0, $f70f7eb6404ce619$export$920b6d07334599c7)(instanceColorBuffer, 3, 3)); // rgb
        return this;
    }
    fromWireframeGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromEdgesGeometry(geometry) {
        this.setPositions(geometry.attributes.position.array);
        return this;
    }
    fromMesh(mesh) {
        this.fromWireframeGeometry(new (0, $f70f7eb6404ce619$export$4b739da06d24892b)(mesh.geometry));
        // set colors, maybe
        return this;
    }
    fromLineSegments(lineSegments) {
        const geometry = lineSegments.geometry;
        this.setPositions(geometry.attributes.position.array); // assumes non-indexed
        // set colors, maybe
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new (0, $f70f7eb6404ce619$export$6f7d5a9418ab2aa3)();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            this.boundingBox.setFromBufferAttribute(start);
            $90da350a0f6b1a38$var$_box.setFromBufferAttribute(end);
            this.boundingBox.union($90da350a0f6b1a38$var$_box);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new (0, $f70f7eb6404ce619$export$805e8b72413ccaba)();
        if (this.boundingBox === null) this.computeBoundingBox();
        const start = this.attributes.instanceStart;
        const end = this.attributes.instanceEnd;
        if (start !== undefined && end !== undefined) {
            const center = this.boundingSphere.center;
            this.boundingBox.getCenter(center);
            let maxRadiusSq = 0;
            for(let i = 0, il = start.count; i < il; i++){
                $90da350a0f6b1a38$var$_vector.fromBufferAttribute(start, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($90da350a0f6b1a38$var$_vector));
                $90da350a0f6b1a38$var$_vector.fromBufferAttribute(end, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($90da350a0f6b1a38$var$_vector));
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.', this);
        }
    }
    toJSON() {
    // todo
    }
    applyMatrix(matrix) {
        console.warn('THREE.LineSegmentsGeometry: applyMatrix() has been renamed to applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
}


/**
 * parameters = {
 *  color: <hex>,
 *  linewidth: <float>,
 *  dashed: <boolean>,
 *  dashScale: <float>,
 *  dashSize: <float>,
 *  dashOffset: <float>,
 *  gapSize: <float>,
 *  resolution: <Vector2>, // to be set by renderer
 * }
 */ 
(0, $f70f7eb6404ce619$export$6643083551874bf5).line = {
    worldUnits: {
        value: 1
    },
    linewidth: {
        value: 1
    },
    resolution: {
        value: new (0, $f70f7eb6404ce619$export$c977b3e384af9ae1)(1, 1)
    },
    dashOffset: {
        value: 0
    },
    dashScale: {
        value: 1
    },
    dashSize: {
        value: 1
    },
    gapSize: {
        value: 1
    } // todo FIX - maybe change to totalSize
};
(0, $f70f7eb6404ce619$export$bee4a7d47f8f5014)['line'] = {
    uniforms: (0, $f70f7eb6404ce619$export$d8ecdf8615bfea69).merge([
        (0, $f70f7eb6404ce619$export$6643083551874bf5).common,
        (0, $f70f7eb6404ce619$export$6643083551874bf5).fog,
        (0, $f70f7eb6404ce619$export$6643083551874bf5).line
    ]),
    vertexShader: /* glsl */ `
		#include <common>
		#include <color_pars_vertex>
		#include <fog_pars_vertex>
		#include <logdepthbuf_pars_vertex>
		#include <clipping_planes_pars_vertex>

		uniform float linewidth;
		uniform vec2 resolution;

		attribute vec3 instanceStart;
		attribute vec3 instanceEnd;

		attribute vec3 instanceColorStart;
		attribute vec3 instanceColorEnd;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#ifdef USE_DASH

			uniform float dashScale;
			attribute float instanceDistanceStart;
			attribute float instanceDistanceEnd;
			varying float vLineDistance;

		#endif

		void trimSegment( const in vec4 start, inout vec4 end ) {

			// trim end segment so it terminates between the camera plane and the near plane

			// conservative estimate of the near plane
			float a = projectionMatrix[ 2 ][ 2 ]; // 3nd entry in 3th column
			float b = projectionMatrix[ 3 ][ 2 ]; // 3nd entry in 4th column
			float nearEstimate = - 0.5 * b / a;

			float alpha = ( nearEstimate - start.z ) / ( end.z - start.z );

			end.xyz = mix( start.xyz, end.xyz, alpha );

		}

		void main() {

			#ifdef USE_COLOR

				vColor.xyz = ( position.y < 0.5 ) ? instanceColorStart : instanceColorEnd;

			#endif

			#ifdef USE_DASH

				vLineDistance = ( position.y < 0.5 ) ? dashScale * instanceDistanceStart : dashScale * instanceDistanceEnd;
				vUv = uv;

			#endif

			float aspect = resolution.x / resolution.y;

			// camera space
			vec4 start = modelViewMatrix * vec4( instanceStart, 1.0 );
			vec4 end = modelViewMatrix * vec4( instanceEnd, 1.0 );

			#ifdef WORLD_UNITS

				worldStart = start.xyz;
				worldEnd = end.xyz;

			#else

				vUv = uv;

			#endif

			// special case for perspective projection, and segments that terminate either in, or behind, the camera plane
			// clearly the gpu firmware has a way of addressing this issue when projecting into ndc space
			// but we need to perform ndc-space calculations in the shader, so we must address this issue directly
			// perhaps there is a more elegant solution -- WestLangley

			bool perspective = ( projectionMatrix[ 2 ][ 3 ] == - 1.0 ); // 4th entry in the 3rd column

			if ( perspective ) {

				if ( start.z < 0.0 && end.z >= 0.0 ) {

					trimSegment( start, end );

				} else if ( end.z < 0.0 && start.z >= 0.0 ) {

					trimSegment( end, start );

				}

			}

			// clip space
			vec4 clipStart = projectionMatrix * start;
			vec4 clipEnd = projectionMatrix * end;

			// ndc space
			vec3 ndcStart = clipStart.xyz / clipStart.w;
			vec3 ndcEnd = clipEnd.xyz / clipEnd.w;

			// direction
			vec2 dir = ndcEnd.xy - ndcStart.xy;

			// account for clip-space aspect ratio
			dir.x *= aspect;
			dir = normalize( dir );

			#ifdef WORLD_UNITS

				// get the offset direction as perpendicular to the view vector
				vec3 worldDir = normalize( end.xyz - start.xyz );
				vec3 offset;
				if ( position.y < 0.5 ) {

					offset = normalize( cross( start.xyz, worldDir ) );

				} else {

					offset = normalize( cross( end.xyz, worldDir ) );

				}

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				float forwardOffset = dot( worldDir, vec3( 0.0, 0.0, 1.0 ) );

				// don't extend the line if we're rendering dashes because we
				// won't be rendering the endcaps
				#ifndef USE_DASH

					// extend the line bounds to encompass  endcaps
					start.xyz += - worldDir * linewidth * 0.5;
					end.xyz += worldDir * linewidth * 0.5;

					// shift the position of the quad so it hugs the forward edge of the line
					offset.xy -= dir * forwardOffset;
					offset.z += 0.5;

				#endif

				// endcaps
				if ( position.y > 1.0 || position.y < 0.0 ) {

					offset.xy += dir * 2.0 * forwardOffset;

				}

				// adjust for linewidth
				offset *= linewidth * 0.5;

				// set the world position
				worldPos = ( position.y < 0.5 ) ? start : end;
				worldPos.xyz += offset;

				// project the worldpos
				vec4 clip = projectionMatrix * worldPos;

				// shift the depth of the projected points so the line
				// segments overlap neatly
				vec3 clipPose = ( position.y < 0.5 ) ? ndcStart : ndcEnd;
				clip.z = clipPose.z * clip.w;

			#else

				vec2 offset = vec2( dir.y, - dir.x );
				// undo aspect ratio adjustment
				dir.x /= aspect;
				offset.x /= aspect;

				// sign flip
				if ( position.x < 0.0 ) offset *= - 1.0;

				// endcaps
				if ( position.y < 0.0 ) {

					offset += - dir;

				} else if ( position.y > 1.0 ) {

					offset += dir;

				}

				// adjust for linewidth
				offset *= linewidth;

				// adjust for clip-space to screen-space conversion // maybe resolution should be based on viewport ...
				offset /= resolution.y;

				// select end
				vec4 clip = ( position.y < 0.5 ) ? clipStart : clipEnd;

				// back to clip space
				offset *= clip.w;

				clip.xy += offset;

			#endif

			gl_Position = clip;

			vec4 mvPosition = ( position.y < 0.5 ) ? start : end; // this is an approximation

			#include <logdepthbuf_vertex>
			#include <clipping_planes_vertex>
			#include <fog_vertex>

		}
		`,
    fragmentShader: /* glsl */ `
		uniform vec3 diffuse;
		uniform float opacity;
		uniform float linewidth;

		#ifdef USE_DASH

			uniform float dashOffset;
			uniform float dashSize;
			uniform float gapSize;

		#endif

		varying float vLineDistance;

		#ifdef WORLD_UNITS

			varying vec4 worldPos;
			varying vec3 worldStart;
			varying vec3 worldEnd;

			#ifdef USE_DASH

				varying vec2 vUv;

			#endif

		#else

			varying vec2 vUv;

		#endif

		#include <common>
		#include <color_pars_fragment>
		#include <fog_pars_fragment>
		#include <logdepthbuf_pars_fragment>
		#include <clipping_planes_pars_fragment>

		vec2 closestLineToLine(vec3 p1, vec3 p2, vec3 p3, vec3 p4) {

			float mua;
			float mub;

			vec3 p13 = p1 - p3;
			vec3 p43 = p4 - p3;

			vec3 p21 = p2 - p1;

			float d1343 = dot( p13, p43 );
			float d4321 = dot( p43, p21 );
			float d1321 = dot( p13, p21 );
			float d4343 = dot( p43, p43 );
			float d2121 = dot( p21, p21 );

			float denom = d2121 * d4343 - d4321 * d4321;

			float numer = d1343 * d4321 - d1321 * d4343;

			mua = numer / denom;
			mua = clamp( mua, 0.0, 1.0 );
			mub = ( d1343 + d4321 * ( mua ) ) / d4343;
			mub = clamp( mub, 0.0, 1.0 );

			return vec2( mua, mub );

		}

		void main() {

			#include <clipping_planes_fragment>

			#ifdef USE_DASH

				if ( vUv.y < - 1.0 || vUv.y > 1.0 ) discard; // discard endcaps

				if ( mod( vLineDistance + dashOffset, dashSize + gapSize ) > dashSize ) discard; // todo - FIX

			#endif

			float alpha = opacity;

			#ifdef WORLD_UNITS

				// Find the closest points on the view ray and the line segment
				vec3 rayEnd = normalize( worldPos.xyz ) * 1e5;
				vec3 lineDir = worldEnd - worldStart;
				vec2 params = closestLineToLine( worldStart, worldEnd, vec3( 0.0, 0.0, 0.0 ), rayEnd );

				vec3 p1 = worldStart + lineDir * params.x;
				vec3 p2 = rayEnd * params.y;
				vec3 delta = p1 - p2;
				float len = length( delta );
				float norm = len / linewidth;

				#ifndef USE_DASH

					#ifdef USE_ALPHA_TO_COVERAGE

						float dnorm = fwidth( norm );
						alpha = 1.0 - smoothstep( 0.5 - dnorm, 0.5 + dnorm, norm );

					#else

						if ( norm > 0.5 ) {

							discard;

						}

					#endif

				#endif

			#else

				#ifdef USE_ALPHA_TO_COVERAGE

					// artifacts appear on some hardware if a derivative is taken within a conditional
					float a = vUv.x;
					float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
					float len2 = a * a + b * b;
					float dlen = fwidth( len2 );

					if ( abs( vUv.y ) > 1.0 ) {

						alpha = 1.0 - smoothstep( 1.0 - dlen, 1.0 + dlen, len2 );

					}

				#else

					if ( abs( vUv.y ) > 1.0 ) {

						float a = vUv.x;
						float b = ( vUv.y > 0.0 ) ? vUv.y - 1.0 : vUv.y + 1.0;
						float len2 = a * a + b * b;

						if ( len2 > 1.0 ) discard;

					}

				#endif

			#endif

			vec4 diffuseColor = vec4( diffuse, alpha );

			#include <logdepthbuf_fragment>
			#include <color_fragment>

			gl_FragColor = vec4( diffuseColor.rgb, alpha );

			#include <tonemapping_fragment>
			#include <encodings_fragment>
			#include <fog_fragment>
			#include <premultiplied_alpha_fragment>

		}
		`
};
class $dd054968e1e8a14b$export$d19cd1378966f3d3 extends (0, $f70f7eb6404ce619$export$83c7d75d550a8b0d) {
    constructor(parameters){
        super({
            type: 'LineMaterial',
            uniforms: (0, $f70f7eb6404ce619$export$d8ecdf8615bfea69).clone((0, $f70f7eb6404ce619$export$bee4a7d47f8f5014)['line'].uniforms),
            vertexShader: (0, $f70f7eb6404ce619$export$bee4a7d47f8f5014)['line'].vertexShader,
            fragmentShader: (0, $f70f7eb6404ce619$export$bee4a7d47f8f5014)['line'].fragmentShader,
            clipping: true // required for clipping support
        });
        this.isLineMaterial = true;
        Object.defineProperties(this, {
            color: {
                enumerable: true,
                get: function() {
                    return this.uniforms.diffuse.value;
                },
                set: function(value) {
                    this.uniforms.diffuse.value = value;
                }
            },
            worldUnits: {
                enumerable: true,
                get: function() {
                    return 'WORLD_UNITS' in this.defines;
                },
                set: function(value) {
                    if (value === true) this.defines.WORLD_UNITS = '';
                    else delete this.defines.WORLD_UNITS;
                }
            },
            linewidth: {
                enumerable: true,
                get: function() {
                    return this.uniforms.linewidth.value;
                },
                set: function(value) {
                    this.uniforms.linewidth.value = value;
                }
            },
            dashed: {
                enumerable: true,
                get: function() {
                    return Boolean('USE_DASH' in this.defines);
                },
                set (value) {
                    if (Boolean(value) !== Boolean('USE_DASH' in this.defines)) this.needsUpdate = true;
                    if (value === true) this.defines.USE_DASH = '';
                    else delete this.defines.USE_DASH;
                }
            },
            dashScale: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashScale.value;
                },
                set: function(value) {
                    this.uniforms.dashScale.value = value;
                }
            },
            dashSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashSize.value;
                },
                set: function(value) {
                    this.uniforms.dashSize.value = value;
                }
            },
            dashOffset: {
                enumerable: true,
                get: function() {
                    return this.uniforms.dashOffset.value;
                },
                set: function(value) {
                    this.uniforms.dashOffset.value = value;
                }
            },
            gapSize: {
                enumerable: true,
                get: function() {
                    return this.uniforms.gapSize.value;
                },
                set: function(value) {
                    this.uniforms.gapSize.value = value;
                }
            },
            opacity: {
                enumerable: true,
                get: function() {
                    return this.uniforms.opacity.value;
                },
                set: function(value) {
                    this.uniforms.opacity.value = value;
                }
            },
            resolution: {
                enumerable: true,
                get: function() {
                    return this.uniforms.resolution.value;
                },
                set: function(value) {
                    this.uniforms.resolution.value.copy(value);
                }
            },
            alphaToCoverage: {
                enumerable: true,
                get: function() {
                    return Boolean('USE_ALPHA_TO_COVERAGE' in this.defines);
                },
                set: function(value) {
                    if (Boolean(value) !== Boolean('USE_ALPHA_TO_COVERAGE' in this.defines)) this.needsUpdate = true;
                    if (value === true) {
                        this.defines.USE_ALPHA_TO_COVERAGE = '';
                        this.extensions.derivatives = true;
                    } else {
                        delete this.defines.USE_ALPHA_TO_COVERAGE;
                        this.extensions.derivatives = false;
                    }
                }
            }
        });
        this.setValues(parameters);
    }
}


const $1a9182091b2dc4b8$var$_start = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
const $1a9182091b2dc4b8$var$_end = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
const $1a9182091b2dc4b8$var$_start4 = new (0, $f70f7eb6404ce619$export$fa7daccca11cdbe3)();
const $1a9182091b2dc4b8$var$_end4 = new (0, $f70f7eb6404ce619$export$fa7daccca11cdbe3)();
const $1a9182091b2dc4b8$var$_ssOrigin = new (0, $f70f7eb6404ce619$export$fa7daccca11cdbe3)();
const $1a9182091b2dc4b8$var$_ssOrigin3 = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
const $1a9182091b2dc4b8$var$_mvMatrix = new (0, $f70f7eb6404ce619$export$2ae72fc923e5eb5)();
const $1a9182091b2dc4b8$var$_line = new (0, $f70f7eb6404ce619$export$e0ba6359f1954fd3)();
const $1a9182091b2dc4b8$var$_closestPoint = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
const $1a9182091b2dc4b8$var$_box = new (0, $f70f7eb6404ce619$export$6f7d5a9418ab2aa3)();
const $1a9182091b2dc4b8$var$_sphere = new (0, $f70f7eb6404ce619$export$805e8b72413ccaba)();
const $1a9182091b2dc4b8$var$_clipToWorldVector = new (0, $f70f7eb6404ce619$export$fa7daccca11cdbe3)();
let $1a9182091b2dc4b8$var$_ray, $1a9182091b2dc4b8$var$_instanceStart, $1a9182091b2dc4b8$var$_instanceEnd, $1a9182091b2dc4b8$var$_lineWidth;
// Returns the margin required to expand by in world space given the distance from the camera,
// line width, resolution, and camera projection
function $1a9182091b2dc4b8$var$getWorldSpaceHalfWidth(camera, distance, resolution) {
    // transform into clip space, adjust the x and y values by the pixel width offset, then
    // transform back into world space to get world offset. Note clip space is [-1, 1] so full
    // width does not need to be halved.
    $1a9182091b2dc4b8$var$_clipToWorldVector.set(0, 0, -distance, 1.0).applyMatrix4(camera.projectionMatrix);
    $1a9182091b2dc4b8$var$_clipToWorldVector.multiplyScalar(1.0 / $1a9182091b2dc4b8$var$_clipToWorldVector.w);
    $1a9182091b2dc4b8$var$_clipToWorldVector.x = $1a9182091b2dc4b8$var$_lineWidth / resolution.width;
    $1a9182091b2dc4b8$var$_clipToWorldVector.y = $1a9182091b2dc4b8$var$_lineWidth / resolution.height;
    $1a9182091b2dc4b8$var$_clipToWorldVector.applyMatrix4(camera.projectionMatrixInverse);
    $1a9182091b2dc4b8$var$_clipToWorldVector.multiplyScalar(1.0 / $1a9182091b2dc4b8$var$_clipToWorldVector.w);
    return Math.abs(Math.max($1a9182091b2dc4b8$var$_clipToWorldVector.x, $1a9182091b2dc4b8$var$_clipToWorldVector.y));
}
function $1a9182091b2dc4b8$var$raycastWorldUnits(lineSegments, intersects) {
    for(let i = 0, l = $1a9182091b2dc4b8$var$_instanceStart.count; i < l; i++){
        $1a9182091b2dc4b8$var$_line.start.fromBufferAttribute($1a9182091b2dc4b8$var$_instanceStart, i);
        $1a9182091b2dc4b8$var$_line.end.fromBufferAttribute($1a9182091b2dc4b8$var$_instanceEnd, i);
        const pointOnLine = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
        const point = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
        $1a9182091b2dc4b8$var$_ray.distanceSqToSegment($1a9182091b2dc4b8$var$_line.start, $1a9182091b2dc4b8$var$_line.end, point, pointOnLine);
        const isInside = point.distanceTo(pointOnLine) < $1a9182091b2dc4b8$var$_lineWidth * 0.5;
        if (isInside) intersects.push({
            point: point,
            pointOnLine: pointOnLine,
            distance: $1a9182091b2dc4b8$var$_ray.origin.distanceTo(point),
            object: lineSegments,
            face: null,
            faceIndex: i,
            uv: null,
            uv2: null
        });
    }
}
function $1a9182091b2dc4b8$var$raycastScreenSpace(lineSegments, camera, intersects) {
    const projectionMatrix = camera.projectionMatrix;
    const material = lineSegments.material;
    const resolution = material.resolution;
    const matrixWorld = lineSegments.matrixWorld;
    const geometry = lineSegments.geometry;
    const instanceStart = geometry.attributes.instanceStart;
    const instanceEnd = geometry.attributes.instanceEnd;
    const near = -camera.near;
    //
    // pick a point 1 unit out along the ray to avoid the ray origin
    // sitting at the camera origin which will cause "w" to be 0 when
    // applying the projection matrix.
    $1a9182091b2dc4b8$var$_ray.at(1, $1a9182091b2dc4b8$var$_ssOrigin);
    // ndc space [ - 1.0, 1.0 ]
    $1a9182091b2dc4b8$var$_ssOrigin.w = 1;
    $1a9182091b2dc4b8$var$_ssOrigin.applyMatrix4(camera.matrixWorldInverse);
    $1a9182091b2dc4b8$var$_ssOrigin.applyMatrix4(projectionMatrix);
    $1a9182091b2dc4b8$var$_ssOrigin.multiplyScalar(1 / $1a9182091b2dc4b8$var$_ssOrigin.w);
    // screen space
    $1a9182091b2dc4b8$var$_ssOrigin.x *= resolution.x / 2;
    $1a9182091b2dc4b8$var$_ssOrigin.y *= resolution.y / 2;
    $1a9182091b2dc4b8$var$_ssOrigin.z = 0;
    $1a9182091b2dc4b8$var$_ssOrigin3.copy($1a9182091b2dc4b8$var$_ssOrigin);
    $1a9182091b2dc4b8$var$_mvMatrix.multiplyMatrices(camera.matrixWorldInverse, matrixWorld);
    for(let i = 0, l = instanceStart.count; i < l; i++){
        $1a9182091b2dc4b8$var$_start4.fromBufferAttribute(instanceStart, i);
        $1a9182091b2dc4b8$var$_end4.fromBufferAttribute(instanceEnd, i);
        $1a9182091b2dc4b8$var$_start4.w = 1;
        $1a9182091b2dc4b8$var$_end4.w = 1;
        // camera space
        $1a9182091b2dc4b8$var$_start4.applyMatrix4($1a9182091b2dc4b8$var$_mvMatrix);
        $1a9182091b2dc4b8$var$_end4.applyMatrix4($1a9182091b2dc4b8$var$_mvMatrix);
        // skip the segment if it's entirely behind the camera
        const isBehindCameraNear = $1a9182091b2dc4b8$var$_start4.z > near && $1a9182091b2dc4b8$var$_end4.z > near;
        if (isBehindCameraNear) continue;
        // trim the segment if it extends behind camera near
        if ($1a9182091b2dc4b8$var$_start4.z > near) {
            const deltaDist = $1a9182091b2dc4b8$var$_start4.z - $1a9182091b2dc4b8$var$_end4.z;
            const t = ($1a9182091b2dc4b8$var$_start4.z - near) / deltaDist;
            $1a9182091b2dc4b8$var$_start4.lerp($1a9182091b2dc4b8$var$_end4, t);
        } else if ($1a9182091b2dc4b8$var$_end4.z > near) {
            const deltaDist = $1a9182091b2dc4b8$var$_end4.z - $1a9182091b2dc4b8$var$_start4.z;
            const t = ($1a9182091b2dc4b8$var$_end4.z - near) / deltaDist;
            $1a9182091b2dc4b8$var$_end4.lerp($1a9182091b2dc4b8$var$_start4, t);
        }
        // clip space
        $1a9182091b2dc4b8$var$_start4.applyMatrix4(projectionMatrix);
        $1a9182091b2dc4b8$var$_end4.applyMatrix4(projectionMatrix);
        // ndc space [ - 1.0, 1.0 ]
        $1a9182091b2dc4b8$var$_start4.multiplyScalar(1 / $1a9182091b2dc4b8$var$_start4.w);
        $1a9182091b2dc4b8$var$_end4.multiplyScalar(1 / $1a9182091b2dc4b8$var$_end4.w);
        // screen space
        $1a9182091b2dc4b8$var$_start4.x *= resolution.x / 2;
        $1a9182091b2dc4b8$var$_start4.y *= resolution.y / 2;
        $1a9182091b2dc4b8$var$_end4.x *= resolution.x / 2;
        $1a9182091b2dc4b8$var$_end4.y *= resolution.y / 2;
        // create 2d segment
        $1a9182091b2dc4b8$var$_line.start.copy($1a9182091b2dc4b8$var$_start4);
        $1a9182091b2dc4b8$var$_line.start.z = 0;
        $1a9182091b2dc4b8$var$_line.end.copy($1a9182091b2dc4b8$var$_end4);
        $1a9182091b2dc4b8$var$_line.end.z = 0;
        // get closest point on ray to segment
        const param = $1a9182091b2dc4b8$var$_line.closestPointToPointParameter($1a9182091b2dc4b8$var$_ssOrigin3, true);
        $1a9182091b2dc4b8$var$_line.at(param, $1a9182091b2dc4b8$var$_closestPoint);
        // check if the intersection point is within clip space
        const zPos = (0, $f70f7eb6404ce619$export$6a7ef315a0d1ef07).lerp($1a9182091b2dc4b8$var$_start4.z, $1a9182091b2dc4b8$var$_end4.z, param);
        const isInClipSpace = zPos >= -1 && zPos <= 1;
        const isInside = $1a9182091b2dc4b8$var$_ssOrigin3.distanceTo($1a9182091b2dc4b8$var$_closestPoint) < $1a9182091b2dc4b8$var$_lineWidth * 0.5;
        if (isInClipSpace && isInside) {
            $1a9182091b2dc4b8$var$_line.start.fromBufferAttribute(instanceStart, i);
            $1a9182091b2dc4b8$var$_line.end.fromBufferAttribute(instanceEnd, i);
            $1a9182091b2dc4b8$var$_line.start.applyMatrix4(matrixWorld);
            $1a9182091b2dc4b8$var$_line.end.applyMatrix4(matrixWorld);
            const pointOnLine = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
            const point = new (0, $f70f7eb6404ce619$export$64b5c384219d3699)();
            $1a9182091b2dc4b8$var$_ray.distanceSqToSegment($1a9182091b2dc4b8$var$_line.start, $1a9182091b2dc4b8$var$_line.end, point, pointOnLine);
            intersects.push({
                point: point,
                pointOnLine: pointOnLine,
                distance: $1a9182091b2dc4b8$var$_ray.origin.distanceTo(point),
                object: lineSegments,
                face: null,
                faceIndex: i,
                uv: null,
                uv2: null
            });
        }
    }
}
class $1a9182091b2dc4b8$export$6eda8f258bdba8c5 extends (0, $f70f7eb6404ce619$export$e176487c05830cc5) {
    constructor(geometry = new (0, $90da350a0f6b1a38$export$5b1256aa5274bf8)(), material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.isLineSegments2 = true;
        this.type = 'LineSegments2';
    }
    // for backwards-compatibility, but could be a method of LineSegmentsGeometry...
    computeLineDistances() {
        const geometry = this.geometry;
        const instanceStart = geometry.attributes.instanceStart;
        const instanceEnd = geometry.attributes.instanceEnd;
        const lineDistances = new Float32Array(2 * instanceStart.count);
        for(let i = 0, j = 0, l = instanceStart.count; i < l; i++, j += 2){
            $1a9182091b2dc4b8$var$_start.fromBufferAttribute(instanceStart, i);
            $1a9182091b2dc4b8$var$_end.fromBufferAttribute(instanceEnd, i);
            lineDistances[j] = j === 0 ? 0 : lineDistances[j - 1];
            lineDistances[j + 1] = lineDistances[j] + $1a9182091b2dc4b8$var$_start.distanceTo($1a9182091b2dc4b8$var$_end);
        }
        const instanceDistanceBuffer = new (0, $f70f7eb6404ce619$export$25ec0e1af1389358)(lineDistances, 2, 1); // d0, d1
        geometry.setAttribute('instanceDistanceStart', new (0, $f70f7eb6404ce619$export$920b6d07334599c7)(instanceDistanceBuffer, 1, 0)); // d0
        geometry.setAttribute('instanceDistanceEnd', new (0, $f70f7eb6404ce619$export$920b6d07334599c7)(instanceDistanceBuffer, 1, 1)); // d1
        return this;
    }
    raycast(raycaster, intersects) {
        const worldUnits = this.material.worldUnits;
        const camera = raycaster.camera;
        if (camera === null && !worldUnits) console.error('LineSegments2: "Raycaster.camera" needs to be set in order to raycast against LineSegments2 while worldUnits is set to false.');
        const threshold = raycaster.params.Line2 !== undefined ? raycaster.params.Line2.threshold || 0 : 0;
        $1a9182091b2dc4b8$var$_ray = raycaster.ray;
        const matrixWorld = this.matrixWorld;
        const geometry = this.geometry;
        const material = this.material;
        $1a9182091b2dc4b8$var$_lineWidth = material.linewidth + threshold;
        $1a9182091b2dc4b8$var$_instanceStart = geometry.attributes.instanceStart;
        $1a9182091b2dc4b8$var$_instanceEnd = geometry.attributes.instanceEnd;
        // check if we intersect the sphere bounds
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $1a9182091b2dc4b8$var$_sphere.copy(geometry.boundingSphere).applyMatrix4(matrixWorld);
        // increase the sphere bounds by the worst case line screen space width
        let sphereMargin;
        if (worldUnits) sphereMargin = $1a9182091b2dc4b8$var$_lineWidth * 0.5;
        else {
            const distanceToSphere = Math.max(camera.near, $1a9182091b2dc4b8$var$_sphere.distanceToPoint($1a9182091b2dc4b8$var$_ray.origin));
            sphereMargin = $1a9182091b2dc4b8$var$getWorldSpaceHalfWidth(camera, distanceToSphere, material.resolution);
        }
        $1a9182091b2dc4b8$var$_sphere.radius += sphereMargin;
        if ($1a9182091b2dc4b8$var$_ray.intersectsSphere($1a9182091b2dc4b8$var$_sphere) === false) return;
        // check if we intersect the box bounds
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        $1a9182091b2dc4b8$var$_box.copy(geometry.boundingBox).applyMatrix4(matrixWorld);
        // increase the box bounds by the worst case line width
        let boxMargin;
        if (worldUnits) boxMargin = $1a9182091b2dc4b8$var$_lineWidth * 0.5;
        else {
            const distanceToBox = Math.max(camera.near, $1a9182091b2dc4b8$var$_box.distanceToPoint($1a9182091b2dc4b8$var$_ray.origin));
            boxMargin = $1a9182091b2dc4b8$var$getWorldSpaceHalfWidth(camera, distanceToBox, material.resolution);
        }
        $1a9182091b2dc4b8$var$_box.expandByScalar(boxMargin);
        if ($1a9182091b2dc4b8$var$_ray.intersectsBox($1a9182091b2dc4b8$var$_box) === false) return;
        if (worldUnits) $1a9182091b2dc4b8$var$raycastWorldUnits(this, intersects);
        else $1a9182091b2dc4b8$var$raycastScreenSpace(this, camera, intersects);
    }
}



class $c98643cc0e057f82$export$dcc17b59d0a74bb5 extends (0, $90da350a0f6b1a38$export$5b1256aa5274bf8) {
    constructor(){
        super();
        this.isLineGeometry = true;
        this.type = 'LineGeometry';
    }
    setPositions(array) {
        // converts [ x1, y1, z1,  x2, y2, z2, ... ] to pairs format
        const length = array.length - 3;
        const points = new Float32Array(2 * length);
        for(let i = 0; i < length; i += 3){
            points[2 * i] = array[i];
            points[2 * i + 1] = array[i + 1];
            points[2 * i + 2] = array[i + 2];
            points[2 * i + 3] = array[i + 3];
            points[2 * i + 4] = array[i + 4];
            points[2 * i + 5] = array[i + 5];
        }
        super.setPositions(points);
        return this;
    }
    setColors(array) {
        // converts [ r1, g1, b1,  r2, g2, b2, ... ] to pairs format
        const length = array.length - 3;
        const colors = new Float32Array(2 * length);
        for(let i = 0; i < length; i += 3){
            colors[2 * i] = array[i];
            colors[2 * i + 1] = array[i + 1];
            colors[2 * i + 2] = array[i + 2];
            colors[2 * i + 3] = array[i + 3];
            colors[2 * i + 4] = array[i + 4];
            colors[2 * i + 5] = array[i + 5];
        }
        super.setColors(colors);
        return this;
    }
    fromLine(line) {
        const geometry = line.geometry;
        this.setPositions(geometry.attributes.position.array); // assumes non-indexed
        // set colors, maybe
        return this;
    }
}



class $686e313a31645cea$export$4e6fcde58d84e955 extends (0, $1a9182091b2dc4b8$export$6eda8f258bdba8c5) {
    constructor(geometry = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)(), material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
        color: Math.random() * 0xffffff
    })){
        super(geometry, material);
        this.isLine2 = true;
        this.type = 'Line2';
    }
}





const $635efb6d1a1523e3$export$305c1428370ccc8b = (radius, phi = Math.PI)=>{
    const points = [];
    const num = 64;
    const slice = phi / (num - 1);
    for(let i = 0; i < num; i++){
        const vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        vec.x = Math.cos(i * slice) * radius;
        vec.y = Math.sin(i * slice) * radius;
        points.push(vec);
    }
    return new $f70f7eb6404ce619$export$b7be63a67df8959().setFromPoints(points);
};




class $eef12e9cf2a6c3a5$export$2e2bcd8739ae039 {
    constructor(menu){
        this.menu = menu;
        this.interactive = menu.interactive;
        this.radius = (0, $2343afc8a06b7454$export$96d096e28994f2e);
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.res = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        this.colorShow = new $f70f7eb6404ce619$export$892596cec99bc70e(0x666666);
        this.colorHide = new $f70f7eb6404ce619$export$892596cec99bc70e(0xCCCCCC);
        this.colorBack = new $f70f7eb6404ce619$export$892596cec99bc70e(0x333333);
        this.initSphere();
        this.initHitArea();
        this.initOutline();
        this.initEquator();
        this.resize();
    }
    initSphere() {
        const { radius: radius } = this;
        // invisible sphere intersecting with plane
        const geometry = new $f70f7eb6404ce619$export$1b417fc3b307a251(radius, 64, 32);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: 0xFF0000,
            wireframe: true
        });
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        // this.object3D.add(mesh);
        this.sphere = mesh;
    }
    initOutline() {
        const { radius: radius, menu: menu, colorShow: colorShow } = this;
        const material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: colorShow,
            linewidth: 1.5
        });
        const geoHalf = (0, $635efb6d1a1523e3$export$305c1428370ccc8b)(radius);
        const geometryN = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        const geometryS = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        geometryN.setPositions(geoHalf.attributes.position.array);
        geoHalf.rotateZ(Math.PI);
        geometryS.setPositions(geoHalf.attributes.position.array);
        const meshN = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometryN, material);
        const meshS = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometryS, material);
        // scale up slightly
        const scale = 1.005;
        meshN.scale.set(scale, scale, scale);
        meshS.scale.set(scale, scale, scale);
        // append directly to parent to avoid rotating with sphere
        menu.scene.add(meshN);
        menu.scene.add(meshS);
        this.rimN = meshN;
        this.rimS = meshS;
        this.outlineMaterial = material;
    }
    initEquator() {
        const { radius: radius, colorShow: colorShow, colorBack: colorBack } = this;
        const materialF = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: colorShow,
            linewidth: 1.5
        });
        const materialB = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: colorBack,
            linewidth: 1.5
        });
        const geoHalfF = (0, $635efb6d1a1523e3$export$305c1428370ccc8b)(radius);
        const geoHalfB = (0, $635efb6d1a1523e3$export$305c1428370ccc8b)(radius);
        const geometryF = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        const geometryB = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        geoHalfF.rotateX(Math.PI * 0.5);
        geoHalfF.rotateY(-(0, $2343afc8a06b7454$export$20299465b5ca1ccb));
        geometryF.setPositions(geoHalfF.attributes.position.array);
        geoHalfB.rotateX(Math.PI * -0.5);
        geoHalfB.rotateY(-(0, $2343afc8a06b7454$export$20299465b5ca1ccb));
        geometryB.setPositions(geoHalfB.attributes.position.array);
        const meshF = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometryF, materialF);
        const meshB = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometryB, materialB);
        this.object3D.add(meshF);
        this.object3D.add(meshB);
        this.equatorF = meshF;
        this.equatorB = meshB;
        this.equatorMaterialF = materialF;
        this.equatorMaterialB = materialB;
    }
    initHitArea() {
        const { radius: radius } = this;
        const geometry = new $f70f7eb6404ce619$export$1b417fc3b307a251(radius, 16, 16);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: 0x0000FF,
            visible: false
        });
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        mesh.hitSphere = true;
        mesh.passThrough = true;
        this.object3D.add(mesh);
        this.hitMesh = mesh;
        this.interactive.objects.push(mesh);
    }
    update(camera) {
        this.rimN.quaternion.copy(camera.quaternion);
        this.rimS.quaternion.copy(camera.quaternion);
    }
    show() {
        this.rimS.visible = true;
        this.rimN.visible = true;
        this.equatorMaterialF.color.copy(this.colorShow);
    }
    hide() {
        this.rimS.visible = false;
        this.rimN.visible = false;
        this.equatorMaterialF.color.copy(this.colorHide);
    }
    resize() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        if (this.outlineMaterial) this.outlineMaterial.resolution.copy(this.res);
        if (this.equatorMaterialF) this.equatorMaterialF.resolution.copy(this.res);
        if (this.equatorMaterialB) this.equatorMaterialB.resolution.copy(this.res);
    }
}













class $224590d5478972cd$export$2e2bcd8739ae039 {
    constructor({ arc: arc, index: index, extra: extra, goal: goal }){
        this.arc = arc;
        this.extra = extra;
        this.parent = arc || extra;
        this.interactive = this.parent.interactive;
        this.index = index;
        this.goal = goal;
        this.radius = index ? (0, $2343afc8a06b7454$export$9017f505fad9e6d4) * 0.8 : (0, $2343afc8a06b7454$export$9017f505fad9e6d4);
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true
        });
        this.colorOut = this.parent.colorOut;
        this.colorOver = this.parent.colorOver;
        this.scaleOut = 0.8;
        this.scaleOver = 1.0;
        this.initMesh();
    }
    initMesh() {
        const { radius: radius, object3D: object3D, colorOut: colorOut, colorOver: colorOver } = this;
        const { scaleOut: scaleOut, scaleOver: scaleOver } = this;
        let geometry, material, mesh, line, edges;
        // stroke
        geometry = new $f70f7eb6404ce619$export$1b417fc3b307a251(radius, 16);
        material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: colorOut,
            side: $f70f7eb6404ce619$export$d9f0486e75b5ace,
            transparent: true
        });
        mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        this.object3D.add(mesh);
        this.strokeMesh = mesh;
        // fill / hover
        geometry = new $f70f7eb6404ce619$export$1b417fc3b307a251(radius, 16);
        material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: 0x000000
        });
        mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        mesh.scale.set(scaleOut, scaleOut, 1);
        this.object3D.add(mesh);
        this.hoverMesh = mesh;
        // hit area
        const hitScale = this.extra ? 2.0 : 1.2;
        geometry = new $f70f7eb6404ce619$export$1b417fc3b307a251(radius * hitScale, 16);
        material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: 0xFF0000,
            visible: false
        });
        mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        this.object3D.add(mesh);
        this.hitArea = mesh;
        // add to interactive
        this.hitArea.arc = this.arc;
        this.hitArea.dot = this;
        this.interactive.objects.push(this.hitArea);
    }
    dispose() {
        const idx = this.interactive.objects.indexOf(this.hitArea);
        if (idx > -1) this.interactive.objects.splice(idx, 1);
        this.timeline.kill();
        this.object3D.clear();
        this.hitArea.arc = null;
        this.hitArea.dot = null;
        this.parent = null;
        this.arc = null;
        this.extra = null;
        this.goal = null;
        this.object3D = null;
        this.hoverMesh = null;
        this.strokeMesh = null;
        this.hitArea = null;
        this.interactive = null;
        this.timeline = null;
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onInteractiveOver(e) {
        const { hoverMesh: hoverMesh, timeline: timeline, colorOver: colorOver, scaleOver: scaleOver } = this;
        hoverMesh.material.color.copy(colorOver);
        timeline.clear();
        timeline.to(hoverMesh.scale, {
            x: scaleOver,
            y: scaleOver,
            z: scaleOver,
            duration: 0.5,
            ease: 'back.out'
        }, 0);
        timeline.play(0);
    }
    onInteractiveOut(e) {
        const { hoverMesh: hoverMesh, timeline: timeline, scaleOut: scaleOut } = this;
        hoverMesh.material.color.setHex(0x000000);
        timeline.clear();
        timeline.to(hoverMesh.scale, {
            x: scaleOut,
            y: scaleOut,
            z: scaleOut,
            duration: 0.01,
            ease: 'linear'
        }, 0);
        timeline.play(0);
    }
}


class $5abd92833eca8e5f$export$2e2bcd8739ae039 {
    constructor(arcs, sphere, goal){
        this.arcs = arcs;
        this.sphere = sphere;
        this.goal = goal;
        this.interactive = this.arcs.menu.interactive;
        this.vecA = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vecB = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vecC = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vecZ = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 1);
        this.peak = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.plane = new $f70f7eb6404ce619$export$7ff5ac152ef991b0();
        this.lineAB = new $f70f7eb6404ce619$export$e0ba6359f1954fd3();
        this.res = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true,
            onUpdate: ()=>this.updatePositions()
        });
        this.timelineOver = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true
        });
        this.tween = {
            u: goal.v,
            rot: (0, $2343afc8a06b7454$export$bd3a64669dedbde9)
        };
        this.colorOut = new $f70f7eb6404ce619$export$892596cec99bc70e(0x737143);
        this.colorOver = new $f70f7eb6404ce619$export$892596cec99bc70e(0xFFFFFF);
        this.hemisphere = goal.minute <= 45 ? (0, $2343afc8a06b7454$export$3acba1efa0a0b6c0) : (0, $2343afc8a06b7454$export$d03c84f99ceb2c09);
        this.initDots();
        this.initLine();
        this.updatePositions();
        this.initHitArea();
        this.resize();
    }
    initDots() {
        this.dots = [];
        for(let i = 0; i < 2; i++){
            const dot = new (0, $224590d5478972cd$export$2e2bcd8739ae039)({
                arc: this,
                index: i
            });
            this.dots.push(dot);
            this.object3D.add(dot.object3D);
        }
    }
    initLine() {
        const { object3D: object3D, colorOut: colorOut } = this;
        const geometry = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        const material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: colorOut,
            linewidth: 1.5,
            dashed: true,
            dashSize: 2,
            gapSize: 2,
            dashScale: 0.8,
            transparent: true
        });
        const line = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometry, material);
        object3D.add(line);
        this.line = line;
    }
    initHitArea() {
        const { object3D: object3D, curve: curve, interactive: interactive, colorOut: colorOut, vecA: vecA } = this;
        // remove old
        if (this.hitArea) {
            interactive.objects.splice(interactive.objects.indexOf(this.hitArea), 1);
            object3D.remove(this.hitArea);
        }
        const arcSegments = 100;
        const positions = [];
        const shape = new $f70f7eb6404ce619$export$6428a7f2611ef1fa();
        for(let i = 0; i < arcSegments; i++){
            const t = i / (arcSegments - 1);
            curve.getPoint(t, vecA);
            positions.push(vecA.x, vecA.y, vecA.z);
            if (!i) shape.moveTo(vecA.z, vecA.y);
            else shape.lineTo(vecA.z, vecA.y);
        }
        const geometry = new $f70f7eb6404ce619$export$57a29a1c803e9065(shape);
        geometry.rotateY(Math.PI * 0.5);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: colorOut,
            side: $f70f7eb6404ce619$export$3b296b6f144d5b03
        });
        material.visible = false;
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        mesh.position.x = positions[0];
        mesh.rotation.z = (0, $2343afc8a06b7454$export$bd3a64669dedbde9);
        mesh.scale.y = 1.15;
        object3D.add(mesh);
        this.hitArea = mesh;
        this.hitArea.arc = this;
    }
    updatePositions() {
        const { sphere: sphere, goal: goal, dots: dots, object3D: object3D, tween: tween } = this;
        const { vecA: vecA, vecB: vecB, vecC: vecC, vecZ: vecZ, plane: plane, lineAB: lineAB, peak: peak } = this;
        const radius = (0, $2343afc8a06b7454$export$96d096e28994f2e);
        let t, phi, half, signHalf;
        const intersectionPoints = [];
        let linePoints = [];
        // when t is exactly at 1 the intersection plane
        // is parallel to the yz-axis
        // make t stop slightly before 1 to get an angled plane
        // t = goal.u * 0.999;
        t = tween.u * 0.999;
        half = goal.half;
        signHalf = half == 1 ? 1 : -1;
        // front dot
        phi = (1 - t) * Math.PI;
        vecA.x = Math.cos(phi) * radius;
        vecA.z = Math.sin(phi) * radius;
        vecA.y = 0;
        dots[0].object3D.position.copy(vecA);
        // back dot
        vecB.x = Math.cos(-phi) * radius;
        vecB.z = Math.sin(-phi) * radius;
        vecB.y = 0;
        dots[1].object3D.position.copy(vecB);
        // point to define the intersection plane
        phi = tween.rot;
        vecC.set(0, radius * -signHalf, 0);
        vecC.applyAxisAngle(vecZ, phi);
        vecC.x += vecA.x;
        // intersection plane
        plane.setFromCoplanarPoints(vecA, vecB, vecC);
        intersectionPoints.length = 0;
        linePoints.length = 0;
        // http://jsfiddle.net/kirill321592/0fLnmq7c/12/
        // https://stackoverflow.com/questions/42348495/three-js-find-all-points-where-a-mesh-intersects-a-plane
        const { index: index } = sphere.sphere.geometry;
        const { position: position } = sphere.sphere.geometry.attributes;
        let intersects;
        for(let i = 0; i < index.count; i += 3){
            vecA.fromBufferAttribute(position, index.array[i + 0]);
            vecB.fromBufferAttribute(position, index.array[i + 1]);
            vecC.fromBufferAttribute(position, index.array[i + 2]);
            lineAB.set(vecA, vecB);
            // reuse vecC
            intersects = plane.intersectLine(lineAB, vecC);
            if (intersects) intersectionPoints.push(vecC.clone());
        }
        // clip points north/south hemispheres
        intersectionPoints.forEach((p)=>{
            if (half == 1 && p.y < 0) return;
            if (half == 2 && p.y > 0) return;
            linePoints.push(p);
        });
        // sort by y based on which side of z-axis
        let frntPoints = linePoints.filter((p)=>p.z >= 0);
        let backPoints = linePoints.filter((p)=>p.z < 0);
        frntPoints.sort((a, b)=>half == 2 ? b.y - a.y : a.y - b.y);
        backPoints.sort((a, b)=>half == 2 ? a.y - b.y : b.y - a.y);
        linePoints = frntPoints.concat(backPoints);
        // append first and last dots
        linePoints.splice(0, 0, dots[0].object3D.position);
        linePoints.push(dots[1].object3D.position);
        // peak-y
        peak.set(0, 0, 0);
        linePoints.forEach((p)=>{
            if (half == 1 && p.y > peak.y) peak.copy(p);
            if (half == 2 && p.y < peak.y) peak.copy(p);
        });
        this.updateCurve(linePoints);
    }
    updateCurve(points) {
        const { object3D: object3D, line: line, colorOut: colorOut, vecA: vecA } = this;
        const curve = new $f70f7eb6404ce619$export$b9146b27c24b744c(points);
        curve.curveType = 'centripetal';
        const arcSegments = 100;
        const positions = [];
        for(let i = 0; i < arcSegments; i++){
            const t = i / (arcSegments - 1);
            curve.getPoint(t, vecA);
            positions.push(vecA.x, vecA.y, vecA.z);
        }
        line.geometry.setPositions(positions);
        line.computeLineDistances();
        this.curve = curve;
    }
    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------
    activate(scope = this) {
        const idx = scope.interactive.objects.indexOf(scope.hitArea);
        if (idx == -1) scope.interactive.objects.push(scope.hitArea);
    }
    deactivate() {
        const idx = this.interactive.objects.indexOf(this.hitArea);
        if (idx > -1) this.interactive.objects.splice(idx, 1);
    }
    show() {
        const { timeline: timeline, tween: tween, goal: goal } = this;
        const halfU = goal.half == 1 ? 0 : 1;
        const duration = 1.5;
        timeline.clear();
        timeline.set(tween, {
            u: halfU
        }, 0);
        timeline.call(this.activate, [
            this
        ], 0.5);
        timeline.to(tween, {
            u: goal.v,
            duration: duration,
            ease: 'expo.out'
        }, goal.index * 0.1);
        timeline.play(0);
        this.object3D.visible = true;
    }
    hide(fullHide = false) {
        this.deactivate();
        if (fullHide) this.object3D.visible = false;
    }
    toggleHemisphere(_hemisphere) {
        const { line: line, dots: dots, hemisphere: hemisphere } = this;
        line.material.opacity = _hemisphere == hemisphere ? 1 : 0.35;
        dots.forEach((dot)=>dot.toggleHemisphere(_hemisphere));
    }
    dispose() {
        this.deactivate();
        this.timeline.kill();
        this.timelineOver.kill();
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.object3D.clear();
        this.dots.forEach((dot)=>dot.dispose());
        this.line = null;
        this.curve = null;
        this.hitArea = null;
        this.object3D = null;
        this.timeline = null;
        this.interactive = null;
        this.dots = null;
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onInteractiveOver(e) {
        const { timelineOver: timelineOver, line: line, dots: dots, colorOver: colorOver, arc: arc } = this;
        // if (e.object.arc != arc) return;
        if (!line) return;
        timelineOver.clear();
        timelineOver.to(line.material, {
            linewidth: 3,
            duration: 0.3,
            ease: 'quart.out'
        });
        timelineOver.play(0);
        line.material.color.copy(colorOver);
        line.material.dashed = false;
        dots.forEach((dot)=>dot.onInteractiveOver());
    }
    onInteractiveOut(e) {
        const { timelineOver: timelineOver, line: line, dots: dots, colorOut: colorOut, arc: arc } = this;
        // if (e.object.arc != arc) return;
        if (!line) return;
        timelineOver.clear();
        timelineOver.to(line.material, {
            linewidth: 1.5,
            duration: 0.2,
            ease: 'quart.out'
        });
        timelineOver.play(0);
        line.material.color.copy(colorOut);
        line.material.dashed = true;
        dots.forEach((dot)=>dot.onInteractiveOut());
    }
    onInteractiveDown(e) {
    // if (e.object != this.object3D) return;
    }
    resize() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        if (this.line) this.line.material.resolution.copy(this.res);
    }
}


class $efc7476e1863e1f8$export$2e2bcd8739ae039 {
    constructor(menu){
        this.menu = menu;
        this.arcs = [];
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
    }
    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------
    initData(matchDO) {
        // remove old
        this.object3D.clear();
        this.arcs.forEach((arc)=>arc.dispose());
        this.arcs.length = 0;
        // init new
        matchDO.goals.forEach((goal)=>{
            if (goal.extra) return;
            const arc = new (0, $5abd92833eca8e5f$export$2e2bcd8739ae039)(this, this.menu.sphere, goal);
            this.arcs.push(arc);
            this.object3D.add(arc.object3D);
        });
        this.matchDO = matchDO;
    }
    show() {
        this.arcs.forEach((arc)=>arc.show());
    }
    hide(fullHide = false) {
        this.arcs.forEach((arc)=>arc.hide(fullHide));
    }
    toggleHemisphere(hemisphere) {
        this.arcs.forEach((arc)=>arc.toggleHemisphere(hemisphere));
    }
    dispose() {
        this.object3D.clear();
        this.arcs.forEach((arc)=>arc.dispose());
        this.matchDO = null;
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    resize(vw, vh) {
        this.arcs.forEach((arc)=>arc.resize(vw, vh));
    }
}




class $6cb5bc20196b3aed$export$2e2bcd8739ae039 {
    constructor(menu){
        this.menu = menu;
        this.offset = new $f70f7eb6404ce619$export$c977b3e384af9ae1(10, 40);
        this.init();
    }
    init() {
        this.el = document.querySelector('.menu-label');
        this.elPlayer = this.el.querySelector('.player');
        this.elMinute = this.el.querySelector('.minute');
    }
    // parent can be MenuArc or MenuExtra
    show(parent, goal, dot) {
        const { menu: menu, offset: offset } = this;
        const { camera: camera } = menu;
        if (!parent || !parent.object3D) return;
        if (!goal) return;
        const vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const size = new $f70f7eb6404ce619$export$64b5c384219d3699();
        let x, y, ox, oy;
        parent.object3D.updateWorldMatrix(true, false);
        parent.object3D.getWorldPosition(vec);
        // add arc peak
        if (parent.peak) vec.add(parent.peak);
        else if (dot) vec.add(dot.object3D.position);
        vec.project(camera);
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(size);
        this.elPlayer.classList.add('show');
        this.elMinute.classList.add('show');
        const added = goal.added ? `+${goal.added}` : '';
        const detail = goal.detail ? `(${goal.detail})` : '';
        this.elPlayer.innerText = `${goal.player}`;
        this.elMinute.innerText = `${goal.minute}${added}'${detail}`;
        // exception: penalty shootout
        if (goal.shootout) this.elMinute.innerText = `${detail}`;
        x = (vec.x * 0.5 + 0.5) * size.x;
        y = (vec.y * -0.5 + 0.5) * size.y;
        ox = goal.half == 1 ? -offset.x - this.el.offsetWidth : offset.x - 10;
        oy = goal.half == 1 ? -offset.y : offset.y - 10;
        // exception: extra time
        if (dot) {
            vec.copy(dot.object3D.position);
            vec.setLength(20);
            // avoid division by zero
            if (!vec.y) vec.y = 0.0001;
            ox = vec.x > 0 ? vec.x : vec.x - this.el.offsetWidth;
            oy = Math.min(Math.abs(vec.y), 20) * -(vec.y / Math.abs(vec.y));
            if (oy < 0) oy -= this.el.offsetHeight;
        }
        x += ox;
        y += oy;
        this.el.style.left = `${~~x}px`;
        this.el.style.top = `${~~y}px`;
    }
    hide() {
        this.elPlayer.classList.remove('show');
        this.elMinute.classList.remove('show');
        this.elPlayer.innerText = ``;
        this.elMinute.innerText = ``;
    }
}



var $ffc23c2bb495c051$exports = {};






$ffc23c2bb495c051$exports = {
    random: (parcelRequire("52JaZ")),
    math: (parcelRequire("loLE8")),
    penplot: (parcelRequire("bOzLK")),
    geometry: (parcelRequire("gBee2")),
    shader: (parcelRequire("jFM7h")),
    color: (parcelRequire("3E14C"))
};




const $d3c84f174c93e09d$var$margin = 100;
class $d3c84f174c93e09d$export$2e2bcd8739ae039 {
    constructor(menu){
        this.menu = menu;
        this.camera = menu.camera;
        window.outro = this;
        this.initCanvas();
        this.initMesh();
    }
    initCanvas() {
        this.canvas = new $d3c84f174c93e09d$var$OutroCanvas();
    }
    initMesh() {
        const geometry = new $f70f7eb6404ce619$export$967d831af31f69ce(1, 1);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5();
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        this.object3D = mesh;
        this.object3D.visible = false;
    }
    show(delay) {
        this.object3D.visible = true;
        return this.canvas.show(delay);
    }
    hide() {
        this.object3D.visible = false;
        this.canvas.hide();
    }
    update() {
        this.canvas.draw();
        if (this.texture) this.texture.needsUpdate = true;
    }
    resize() {
        let scale;
        this.fovHeight = 2 * Math.tan(this.camera.fov * Math.PI / 180 / 2) * this.camera.position.z;
        this.fovRatio = window.innerHeight / this.fovHeight;
        // object scale
        scale = (0, $2343afc8a06b7454$export$96d096e28994f2e) * 2 + $d3c84f174c93e09d$var$margin * 2 / this.fovRatio;
        this.object3D.scale.set(scale, scale, 1);
        // canvas scale
        scale = ~~((0, $2343afc8a06b7454$export$96d096e28994f2e) * 2 * this.fovRatio) + $d3c84f174c93e09d$var$margin * 2;
        this.canvas.resize(scale);
        // cannot resize texture, it needs to be recreated
        if (this.texture) this.texture.dispose();
        this.texture = new $f70f7eb6404ce619$export$f7189e49152d1c13(this.canvas.canvas);
        this.object3D.material.map = this.texture;
        this.object3D.material.needsUpdate = true;
    }
}
// ---------------------------------------------------------------------------------------------
// CANVAS
// ---------------------------------------------------------------------------------------------
class $d3c84f174c93e09d$var$OutroCanvas {
    constructor(){
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d', {
            alpha: false
        });
        // this.canvas.style = 'position:absolute; top:0px; left:0px;';
        // document.body.appendChild(this.canvas)
        this.settings = {
            circScale: 0,
            innerRadius: 110,
            outerRadius: 300,
            dotRadius: 4,
            numRings: 9,
            ringsVisible: false,
            ringsRotation: 0,
            noiseThresh: 0.0,
            noiseFreq: 0.1,
            connectThresh: 0.8
        };
    // deferred to show
    // this.initRings();
    }
    initRings() {
        const { innerRadius: innerRadius, outerRadius: outerRadius, dotRadius: dotRadius, numRings: numRings } = this.settings;
        const deltaRadius = outerRadius - innerRadius - dotRadius;
        const sliceRadius = deltaRadius / (numRings - 1);
        const rings = [];
        // randomise noise threshold and frequency
        const noiseThresh = (0, $ffc23c2bb495c051$exports.random).range(-0.5, 0.0);
        const noiseFreq = 0.01;
        const connectThresh = (0, $ffc23c2bb495c051$exports.random).range(0.4, 0.8);
        for(let i = 0; i < numRings; i++){
            const ringRadius = innerRadius + sliceRadius * i;
            const numDots = ~~(ringRadius / dotRadius * 2);
            const slice = Math.PI * 2 / numDots;
            const ring = {
                angle: (0, $ffc23c2bb495c051$exports.random).range(0, Math.PI),
                index: i,
                radius: ringRadius,
                sliceRadius: sliceRadius,
                dots: []
            };
            for(let j = 0; j < numDots; j++){
                const angle = slice * j;
                const x = Math.sin(angle) * ringRadius;
                const y = Math.cos(angle) * ringRadius;
                const n = (0, $ffc23c2bb495c051$exports.random).noise2D(x, y, noiseFreq);
                if (n > noiseThresh) continue;
                const curr = {
                    angle: angle,
                    slice: slice,
                    ring: ring,
                    ringRadius: ringRadius,
                    index: j,
                    radius: dotRadius,
                    phi: 0,
                    tta: 0
                };
                const prev = j ? ring.dots[ring.dots.length - 1] : null;
                // assign curr as previous->next
                if (prev) prev.next = curr;
                ring.dots.push(curr);
            }
            rings.push(ring);
        }
        rings.forEach((ring)=>{
            // filter dots where next isn't immediate neighbour // keep only a small subset
            ring.dotsWithGap = ring.dots.filter((dot)=>dot.next?.index > dot.index + 1 && (0, $ffc23c2bb495c051$exports.random).value() > connectThresh);
            // filter some random dots to jump out of their orbits
            ring.dotsJumpOrbit = ring.dots.filter((dot)=>dot.next?.index == dot.index + 1 && (0, $ffc23c2bb495c051$exports.random).value() > 0.4);
        });
        this.rings = rings;
    }
    draw() {
        const { canvas: canvas, context: context, rings: rings, settings: settings } = this;
        const { circScale: circScale, outerRadius: outerRadius, ringsVisible: ringsVisible, ringsRotation: ringsRotation, dotRadius: dotRadius } = this.settings;
        const { width: width, height: height } = canvas;
        // match canvas scale to circle radius
        const scale = (width * 0.5 - $d3c84f174c93e09d$var$margin) / outerRadius;
        context.clearRect(0, 0, width, height);
        context.save();
        context.translate(width * 0.5, height * 0.5);
        context.scale(scale, scale);
        // big circle
        context.fillStyle = 'white';
        context.beginPath();
        context.arc(0, 0, outerRadius * circScale, 0, Math.PI * 2);
        context.fill();
        if (!ringsVisible) {
            context.restore();
            return;
        }
        context.strokeStyle = 'white';
        context.lineWidth = dotRadius * 2;
        context.lineCap = 'round';
        context.rotate(ringsRotation);
        // rings
        rings.forEach((ring)=>{
            context.rotate(ring.angle);
            ring.dots.forEach((dot)=>{
                const x = Math.cos(dot.angle) * dot.ringRadius;
                const y = Math.sin(dot.angle) * dot.ringRadius;
                context.beginPath();
                context.arc(x, y, dot.radius, 0, Math.PI * 2);
                context.fill();
            });
            ring.dotsWithGap.forEach((dot)=>{
                const iniAngle = dot.angle;
                const endAngle = dot.next.angle;
                const dltAngle = endAngle - iniAngle;
                const phi = iniAngle + dot.phi * dltAngle;
                const tta = iniAngle + dot.tta * dltAngle;
                const x = Math.cos(phi) * ring.radius;
                const y = Math.sin(phi) * ring.radius;
                context.beginPath();
                context.moveTo(x, y);
                context.arc(0, 0, ring.radius, phi, tta);
                context.stroke();
            });
            context.rotate(-ring.angle);
        });
        context.restore();
    }
    show(delay = 0) {
        this.initRings();
        const { settings: settings, rings: rings } = this;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        // expand quickly
        timeline.set(settings, {
            circScale: 0.8
        }, 0);
        timeline.to(settings, {
            circScale: 1.01,
            duration: 0.3,
            ease: 'expo.out'
        }, 0);
        // hide big circle
        timeline.set(settings, {
            circScale: 0,
            ringsVisible: 1,
            ringsRotation: Math.PI * -0.15
        }, delay);
        // reveal rings
        timeline.to(settings, {
            ringsRotation: 0,
            duration: 0.8,
            ease: 'quart.out'
        }, delay);
        // random delays for ring spins
        let rdelays = [];
        for(let i = 0; i < rings.length; i++)rdelays.push(i);
        rdelays = (0, $ffc23c2bb495c051$exports.random).shuffle(rdelays);
        // random delays for dots
        const delays = [
            0.0,
            0.2,
            0.3,
            0.4
        ];
        rings.forEach((ring)=>{
            // spin rings
            // const rdelay = rdelays[ring.index] * 0.1;
            const rdelay = 0.;
            const rduration = 0.2 + ring.index * 0.1;
            const angle = 0.1 + (rings.length - ring.index) * 0.04;
            timeline.to(ring, {
                angle: ring.angle + angle,
                duration: rduration,
                ease: 'quad.out'
            }, rdelay + delay);
            // jump dots
            ring.dotsJumpOrbit.forEach((dot)=>{
                const ddelay = (0, $ffc23c2bb495c051$exports.random).pick(delays);
                const sradius = (0, $ffc23c2bb495c051$exports.random).boolean() ? -ring.sliceRadius : ring.sliceRadius;
                timeline.to(dot, {
                    ringRadius: dot.ringRadius + sradius,
                    duration: 0.4,
                    ease: 'quad.out'
                }, ddelay + delay);
            });
            // connect dots
            ring.dotsWithGap.forEach((dot)=>{
                // const ddelay = random.pick(delays);
                const ddelay = 0;
                timeline.set(dot, {
                    tta: 1
                }, 0);
                timeline.to(dot, {
                    phi: 1,
                    duration: 0.6,
                    ease: 'quad.out'
                }, ddelay + delay);
            // timeline.to(dot, { tta: 1, duration: 0.4, ease: 'quad.out' }, ddelay + delay);
            // timeline.to(dot, { phi: 1, duration: 0.4, ease: 'quad.in'  }, ddelay + delay + 0.4);
            });
        });
        return timeline;
    }
    hide() {
        this.settings.ringsVisible = 0;
    }
    resize(size) {
        this.canvas.width = size;
        this.canvas.height = size;
    }
}











class $7f38d9dc444622f2$export$2e2bcd8739ae039 {
    constructor(menu){
        this.menu = menu;
        this.interactive = menu.interactive;
        this.vecA = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.radius = (0, $2343afc8a06b7454$export$e63e78834ae8a20f);
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.colorShow = new $f70f7eb6404ce619$export$892596cec99bc70e(0x333333);
        this.colorOut = new $f70f7eb6404ce619$export$892596cec99bc70e(0x737143);
        this.colorOver = new $f70f7eb6404ce619$export$892596cec99bc70e(0xFFFFFF);
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true,
            onUpdate: ()=>this.updatePositions()
        });
        this.tween = {
            rot: 0,
            phi: 0,
            u: 0
        };
        this.res = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        this.dots = [];
        this.initMaterial();
        // this.initOutline();
        this.resize();
    }
    initMaterial() {
        const { colorShow: colorShow } = this;
        const material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: colorShow,
            linewidth: 1.5
        });
        this.outlineMaterial = material;
    }
    initOutline() {
        const { radius: radius, menu: menu, colorShow: colorShow, outlineMaterial: outlineMaterial, ringN: ringN, ringS: ringS } = this;
        const { phi: phi, rot: rot } = this.tween;
        // remove old
        if (ringN) ringN.parent.remove(ringN);
        if (ringS) ringS.parent.remove(ringS);
        this.ringN = null;
        this.ringS = null;
        // skip if no angle yet
        if (!phi) return;
        const material = outlineMaterial;
        const geoHalf = (0, $635efb6d1a1523e3$export$305c1428370ccc8b)(radius, phi);
        const geometryN = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        const geometryS = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        geometryN.setPositions(geoHalf.attributes.position.array);
        geoHalf.rotateZ(Math.PI);
        geometryS.setPositions(geoHalf.attributes.position.array);
        const meshN = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometryN, material);
        const meshS = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometryS, material);
        // scale up slightly
        // const scale = 1.005;
        // meshN.scale.set(scale, scale, scale);
        // meshS.scale.set(scale, scale, scale);
        // rotate while showing
        meshN.rotation.z = rot;
        meshS.rotation.z = rot;
        // append directly to parent to avoid rotating with sphere
        menu.scene.add(meshN);
        menu.scene.add(meshS);
        // this.object3D.add(meshN);
        // this.object3D.add(meshS);
        this.ringN = meshN;
        this.ringS = meshS;
    }
    updatePositions() {
        this.initOutline();
        const { dots: dots, tween: tween } = this;
        const { vecA: vecA, peak: peak } = this;
        const radius = (0, $2343afc8a06b7454$export$e63e78834ae8a20f);
        let t, phi, half, signHalf, goal;
        dots.forEach((dot)=>{
            goal = dot.goal;
            t = goal.v * tween.u;
            half = goal.half;
            signHalf = half == 1 ? 1 : -1;
            // front dot
            phi = (1 - t) * Math.PI;
            vecA.x = Math.cos(phi * signHalf) * radius;
            vecA.y = Math.sin(phi * signHalf) * radius;
            vecA.z = 0;
            dot.object3D.position.copy(vecA);
        });
    }
    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------
    initData(matchDO) {
        // remove old
        this.object3D.clear();
        this.dots.forEach((dot)=>dot.dispose());
        this.dots.length = 0;
        // init new
        matchDO.goals.forEach((goal)=>{
            if (!goal.extra) return;
            const dot = new (0, $224590d5478972cd$export$2e2bcd8739ae039)({
                extra: this,
                goal: goal
            });
            this.dots.push(dot);
            // this.object3D.add(dot.object3D);
            this.menu.scene.add(dot.object3D);
        });
        this.matchDO = matchDO;
    }
    show() {
        if (!this.matchDO.hasExtra) return;
        const { timeline: timeline, tween: tween } = this;
        timeline.clear();
        timeline.set(tween, {
            rot: Math.PI * 0.5,
            phi: 0,
            u: 0
        }, 0);
        // timeline.call(this.activate, [ this ], 0.5);
        timeline.to(tween, {
            rot: Math.PI * -1,
            phi: Math.PI,
            duration: 1.5,
            ease: 'expo.inOut'
        }, 0.0);
        timeline.to(tween, {
            u: 1,
            duration: 1.5,
            ease: 'expo.out'
        }, 0.5);
        timeline.play(0);
    }
    hide() {
        const { timeline: timeline, tween: tween } = this;
        timeline.clear();
        // timeline.call(this.activate, [ this ], 0.5);
        timeline.to(tween, {
            rot: Math.PI * -1.2,
            phi: 0,
            duration: 1.0,
            ease: 'quart.in'
        }, 0.0);
        timeline.play(0);
        // remove dots immediately
        this.dots.forEach((dot)=>dot.dispose());
        this.dots.length = 0;
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    resize() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        if (this.outlineMaterial) this.outlineMaterial.resolution.copy(this.res);
    }
}


const $2343afc8a06b7454$export$3acba1efa0a0b6c0 = 'north';
const $2343afc8a06b7454$export$d03c84f99ceb2c09 = 'south';
const $2343afc8a06b7454$export$96d096e28994f2e = 100;
const $2343afc8a06b7454$export$e63e78834ae8a20f = 120;
const $2343afc8a06b7454$export$9017f505fad9e6d4 = 2.5;
const $2343afc8a06b7454$export$bd3a64669dedbde9 = 30 * Math.PI / 180;
const $2343afc8a06b7454$export$9c973009b5761080 = 0.25;
const $2343afc8a06b7454$export$20299465b5ca1ccb = -0.2;
class $2343afc8a06b7454$var$Menu {
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.initiated = false;
        this.direction = -1;
    }
    init(page) {
        this.page = page;
        this.matchDO = this.page.matchDO;
        this.lastMatchID = null;
        if (this.initiated) return;
        this.initiated = true;
        this.targetRotation = new $f70f7eb6404ce619$export$c977b3e384af9ae1($2343afc8a06b7454$export$9c973009b5761080, $2343afc8a06b7454$export$20299465b5ca1ccb);
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.arcs = [];
        this.initThree();
        this.initInteractiveControls();
        this.initSphere();
        this.initArcs();
        this.initExtra();
        this.initLabel();
        this.initOutro();
    }
    initThree() {
        this.camera = new $f70f7eb6404ce619$export$74e4ae24825f68d7(20, window.innerWidth / window.innerHeight, 1, 10000);
        this.camera.position.set(0, 0, 1000);
        this.scene = new $f70f7eb6404ce619$export$38af1803e3442a7f();
        // sub-object which rotates independently
        this.container = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.container.rotation.set($2343afc8a06b7454$export$9c973009b5761080, $2343afc8a06b7454$export$20299465b5ca1ccb, 0);
        this.scene.add(this.container);
    }
    initSphere() {
        this.sphere = new (0, $eef12e9cf2a6c3a5$export$2e2bcd8739ae039)(this);
        this.container.add(this.sphere.object3D);
    }
    initArcs() {
        this.arcs = new (0, $efc7476e1863e1f8$export$2e2bcd8739ae039)(this);
        this.container.add(this.arcs.object3D);
    }
    initExtra() {
        this.extra = new (0, $7f38d9dc444622f2$export$2e2bcd8739ae039)(this);
        this.container.add(this.extra.object3D);
    }
    initLabel() {
        this.label = new (0, $6cb5bc20196b3aed$export$2e2bcd8739ae039)(this);
    }
    initOutro() {
        this.outro = new (0, $d3c84f174c93e09d$export$2e2bcd8739ae039)(this);
        this.scene.add(this.outro.object3D);
    }
    initInteractiveControls() {
        this.interactive = new (0, $f1489fac31bae754$export$2e2bcd8739ae039)(this.camera, (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.domElement);
        this.interactive.addListener('interactive-over', this.onInteractiveOver);
        this.interactive.addListener('interactive-out', this.onInteractiveOut);
        this.interactive.addListener('interactive-move', this.onInteractiveMove);
        this.interactive.addListener('interactive-down', this.onInteractiveDown);
    }
    addListeners() {
        window.addEventListener('resize', this.resize);
    }
    removeListeners() {
        window.removeEventListener('resize', this.resize);
    }
    animate() {
        this.update();
        this.draw();
        this.raf = requestAnimationFrame(this.animate);
    }
    setDirection(direction) {
        this.direction = direction;
    }
    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------
    update() {
        const { camera: camera, container: container, targetRotation: targetRotation, freeCursor: freeCursor } = this;
        this.sphere.update(camera);
        this.outro.update();
        if (!freeCursor) return;
        container.rotation.x += (targetRotation.x - container.rotation.x) * 0.02;
        container.rotation.y += (targetRotation.y - container.rotation.y) * 0.02;
    }
    draw() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.render(this.scene, this.camera);
    }
    // prev = 1 / next = -1
    spin() {
        const { timeline: timeline, container: container, targetRotation: targetRotation } = this;
        timeline.clear();
        timeline.set(container.rotation, {
            x: Math.PI * 2 * this.direction + container.rotation.x
        }, 0);
        timeline.to(container.rotation, {
            x: $2343afc8a06b7454$export$9c973009b5761080,
            duration: 2.0,
            ease: 'expo.inOut'
        }, 0);
        timeline.play(0);
        this.arcs.hide();
        this.label.hide();
        this.extra.hide();
        targetRotation.x = $2343afc8a06b7454$export$9c973009b5761080;
        targetRotation.y = $2343afc8a06b7454$export$20299465b5ca1ccb;
        this.freeCursor = false;
        // update data mid-spin
        setTimeout(()=>{
            this.updateData();
        }, 1000);
    }
    halfSpin() {
        const { timeline: timeline, container: container, targetRotation: targetRotation } = this;
        // spin if not spinning yet
        if (!timeline.isActive()) {
            timeline.clear();
            timeline.set(container.rotation, {
                x: Math.PI * 1 * this.direction + container.rotation.x
            }, 0);
            timeline.to(container.rotation, {
                x: $2343afc8a06b7454$export$9c973009b5761080,
                duration: 1.0,
                ease: 'expo.out'
            }, 0);
            timeline.play(0);
        }
        this.updateData();
    }
    updateData() {
        // skip if still the same match
        if (this.lastMatchID == this.matchDO.id) return;
        this.lastMatchID = this.matchDO.id;
        this.arcs.initData(this.matchDO);
        this.extra.initData(this.matchDO);
        this.arcs.show();
        this.extra.show();
        this.freeCursor = true;
    }
    show() {
        this.container.rotation.z = 0;
        this.container.visible = true;
        this.interactive.enable();
        this.outro.hide();
        this.sphere.show();
        this.label.init();
        this.halfSpin();
        this.addListeners();
        this.animate();
        this.resize();
    }
    hide() {
        const { timeline: timeline, container: container } = this;
        this.interactive.disable();
        this.arcs.hide(true);
        this.label.hide();
        this.sphere.hide();
        this.freeCursor = false;
        // roll and disappear
        timeline.clear();
        timeline.to(container.rotation, {
            z: Math.PI * -0.5,
            duration: 0.5,
            ease: 'quart.in'
        }, 0.2);
        timeline.set(container, {
            visible: false
        }, 0.7);
        timeline.play(0);
        return this.outro.show(0.7);
    }
    stop() {
        cancelAnimationFrame(this.raf);
        this.removeListeners();
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onInteractiveOver(e) {
        if (!e.object) return;
        if (e.object.arc) {
            e.object.arc.onInteractiveOver(e);
            this.label.show(e.object.arc, e.object.arc.goal);
        }
        // triggered only on extra
        if (e.object.dot) {
            e.object.dot.onInteractiveOver(e);
            this.label.show(this.extra, e.object.dot.goal, e.object.dot);
        }
    }
    onInteractiveOut(e) {
        if (!e.object) return;
        if (e.object.arc) {
            e.object.arc.onInteractiveOut(e);
            this.label.hide();
        }
        // triggered only on extra
        if (e.object.dot) {
            e.object.dot.onInteractiveOut(e);
            this.label.hide();
        }
    }
    onInteractiveMove(e) {
        const { container: container, targetRotation: targetRotation } = this;
        if (!e.object || !e.object.hitSphere) return;
        const { point: point } = e.intersectionData;
        targetRotation.x = point.y / $2343afc8a06b7454$export$96d096e28994f2e * 0.05 + $2343afc8a06b7454$export$9c973009b5761080;
        targetRotation.y = point.x / $2343afc8a06b7454$export$96d096e28994f2e * -0.05 + $2343afc8a06b7454$export$20299465b5ca1ccb;
    }
    onInteractiveDown(e) {
        const target = e.object.arc || e.object.dot;
        if (!e.object || !target) return;
        const { goal: goal } = target;
        // trigger mouse out
        this.onInteractiveOut(e);
        // start hide sequence
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/goal/${goal.slug}`);
    }
    resize() {
        this.camera.zoom = window.innerWidth < (0, $d1a28c8d5f44cae3$export$d07517a676ce386f).wide ? 0.75 : 1;
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.arcs.resize();
        this.sphere.resize();
        this.interactive.resize();
        this.outro.resize();
    }
}
var $2343afc8a06b7454$export$2e2bcd8739ae039 = new $2343afc8a06b7454$var$Menu();


class $cdd0137e172eb2aa$export$2e2bcd8739ae039 {
    constructor(json){
        this.index = 0;
        this.name = '';
        this.slug = '';
        this.kits = [];
        this.badges = [];
        this.parse(json);
    }
    parse(json) {
        this.index = json.index;
        this.name = json.name;
        this.slug = json.slug;
        this.kits = json.kits;
        this.flag = json.flag;
        this.done = json.done;
        this.badges = json.badges || [];
    }
}


let $3fc4261274f65713$var$_teams = [];
const $3fc4261274f65713$export$3527acea17d79362 = async (data)=>{
    data.forEach((item, index)=>{
        $3fc4261274f65713$var$_teams.push(new (0, $cdd0137e172eb2aa$export$2e2bcd8739ae039)({
            index: index,
            ...item
        }));
    });
};
const $3fc4261274f65713$export$5a622455e94bac3 = ()=>{
    return $3fc4261274f65713$var$_teams;
};
const $3fc4261274f65713$export$491fe77f22ab2b51 = (slugOrName)=>{
    return $3fc4261274f65713$var$_teams.find((team)=>team.slug == slugOrName || team.name == slugOrName);
};




const $a5a3d7804ffbb687$export$6b5c1ceb16d01dc3 = Math.PI;
const $a5a3d7804ffbb687$export$f504979d7e0a75c7 = Math.PI / 2;
const $a5a3d7804ffbb687$export$6eec49b1a6289c4e = Math.PI * 2;
const $a5a3d7804ffbb687$export$cfa25d10e00ab635 = Math.PI / 4;
const $a5a3d7804ffbb687$export$870617f62e3187f1 = Math.PI / 180;
const $a5a3d7804ffbb687$export$3f91627dc85c5d57 = 180 / Math.PI;
const $a5a3d7804ffbb687$export$7d15b64cf5a3a4c4 = (num, min, max)=>{
    if (max < min) {
        const tmax = min;
        min = max;
        max = tmax;
    }
    if (num < min) return min;
    else if (num > max) return max;
    return num;
};
const $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f = (min, max, amount)=>{
    return min + amount * (max - min);
};
const $a5a3d7804ffbb687$export$871de8747c9eaa88 = (num, min1, max1, min2, max2, round = false, constrainMin = true, constrainMax = true)=>{
    if (constrainMin && num < min1) return min2;
    if (constrainMax && num > max1) return max2;
    const num1 = (num - min1) / (max1 - min1);
    const num2 = num1 * (max2 - min2) + min2;
    if (round) return Math.round(num2);
    return num2;
};
const $a5a3d7804ffbb687$export$842a2cf37af977e1 = (n, m)=>{
    return (n % m + m) % m;
};
const $a5a3d7804ffbb687$export$4385e60b38654f68 = (min, max)=>{
    if (Object.prototype.toString.call(min) === '[object Array]') return min[~~(Math.random() * min.length)];
    if (typeof max !== 'number') {
        max = min || 1;
        min = 0;
    }
    return min + Math.random() * (max - min);
};
const $a5a3d7804ffbb687$export$c5552dfdbc7cec71 = (n)=>{
    if (n > 0) return 1;
    else if (n < 0) return -1;
    else return 0;
};
const $a5a3d7804ffbb687$export$cdccc2fce8090a6f = (center, point, angle)=>{
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return {
        x: cos * (point.x - center.x) + sin * (point.y - center.y) + center.x,
        y: cos * (point.y - center.y) - sin * (point.x - center.x) + center.y
    };
};
const $a5a3d7804ffbb687$export$b465b7f8c1ade29b = (x, k = 1.0)=>{
    return Math.pow(4.0 * x * (1.0 - x), k);
};
const $a5a3d7804ffbb687$export$57790f9172054d97 = (x, k = 1.0)=>{
    const a = 0.5 * Math.pow(2.0 * (x < 0.5 ? x : 1.0 - x), k);
    return x < 0.5 ? a : 1.0 - a;
};
const $a5a3d7804ffbb687$export$c57dab19627697ef = (x, k = 1.0)=>{
    const h = k * x;
    return h * Math.exp(1.0 - h);
};
const $a5a3d7804ffbb687$export$267eb760cb73f794 = (min, max, noise2D, x = 0)=>{
    const n = noise2D ? noise2D(x, 99) * 0.5 + 0.5 : Math.random();
    return min + n * (max - min);
};
const $a5a3d7804ffbb687$export$3f1e74e9f72f2c7c = (arr, noise2D, x = 0)=>{
    const n = noise2D ? noise2D(x, 456) * 0.5 + 0.5 : Math.random();
    return arr[~~(n * arr.length)];
};
const $a5a3d7804ffbb687$export$cfa8447a34b05325 = (weights, noise2D, x = 0)=>{
    weights = weights || [];
    let totalWeight = 0;
    for(let i = 0; i < weights.length; i++)totalWeight += weights[i];
    let random = (noise2D(x, 5781) * 0.5 + 0.5) * totalWeight;
    for(let i = 0; i < weights.length; i++){
        if (random < weights[i]) return i;
        random -= weights[i];
    }
    return 0;
};


class $70d3f995ca993989$export$2e2bcd8739ae039 {
    constructor(match){
        this.match = match;
        this.index = 0;
        this.team = 'BRA';
        this.teamDO = (0, $3fc4261274f65713$export$491fe77f22ab2b51)(this.team);
        this.player = '';
        this.minute = 0;
        this.added = 0;
        this.paths = [];
        this.camera = null;
        this.half = null;
        this.halfMinute = 0;
        this.halfIndex = 0;
        this.extra = false;
    }
    parse(json) {
        this.meta = json.meta;
        this.match = json.match;
        this.team = json.team;
        this.teamDO = (0, $3fc4261274f65713$export$491fe77f22ab2b51)(json.team);
        this.kit = json.kit || 0;
        this.player = json.player;
        this.minute = json.minute || 0;
        this.added = json.added || 0;
        this.detail = json.detail;
        this.paths = json.paths;
        this.camera = json.camera;
        // pitch side
        this.leftSide = this.getSide();
        this.half = this.minute <= 45 ? 1 : 2;
        this.halfMinute = this.minute <= 45 ? this.minute : this.minute - 45;
        // extra time
        this.extra = this.minute > 90;
        // penalty shootout
        this.shootout = this.minute > 120;
        if (this.extra) {
            this.half = this.minute <= 105 ? 1 : 2;
            this.halfMinute = this.minute <= 105 ? this.minute - 90 : this.minute - 105;
        }
        this.halfAdded = this.halfMinute + this.added;
        // t : normalised minute per half
        // u : t padded to avoid small arcs close to 0' or 45'
        // v : u adjusted to avoid overlapping
        this.t = this.halfMinute / 45;
        this.u = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(this.t, 0, 1, 0.2, 0.8);
        this.v = this.u; // adjusted in MatchDO
        if (this.extra) {
            this.t = this.halfMinute / 15;
            this.u = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(this.t, 0, 1, 0.1, 0.9);
            this.v = this.u;
        }
        this.phi = (1 - this.u) * Math.PI;
    }
    // get side of the pitch
    // left: true / right: false (default)
    getSide() {
        let sumX = 0;
        this.paths.forEach((path)=>{
            path.anchors.forEach((anchor)=>{
                sumX += anchor[0];
            });
        });
        return sumX < 0;
    }
    get slug() {
        const match = (0, $5767c36b17e72441$export$26748ec468348572)(this.match);
        const added = this.added ? `-${this.added}` : ``;
        const detail = this.detail ? `-${this.detail.replace(/\./g, '')}` : ``;
        let _slug;
        _slug = `${match.name}-${this.team}-${this.minute}${added}-${this.player.trim()}${detail}`;
        _slug = _slug.replace(/\s+/g, '-'); // replace spaces with dashes
        _slug = _slug.normalize('NFKD').replace(/[^\w-]/g, ''); // convert diacritics to ascii i.e. áíó to aio
        return _slug;
    }
    serialize() {
        const { slug: slug, match: match, team: team, kit: kit, player: player, minute: minute, added: added, detail: detail, paths: paths, camera: camera } = this;
        return {
            meta: {
                build: AIV.version
            },
            slug: slug,
            match: match,
            team: team,
            kit: kit,
            player: player.trim(),
            minute: minute,
            added: added,
            detail: detail,
            paths: paths,
            camera: camera
        };
    }
}



class $2dbe60b75826fd8b$export$2e2bcd8739ae039 {
    constructor(data, index){
        this.data = data;
        this.index = index;
        this.name = '';
        this.id = 0;
        this.round = null;
        this.date = null;
        this.result = null;
        this.teams = [];
        this.teamDOs = [];
        this.goals = [];
        // parse
        this.id = data.id;
        this.round = data.round || '';
        this.date = new Date(data.date);
        this.teams = data.teams;
        this.result = data.result;
        this.winner = data.winner;
        this.done = !!data.result;
        this.hasExtra = data.result && !!data.result.extra;
        this.hasShootout = data.result && !!data.result.shootout;
        const padId = `${this.id}`.padStart(2, '0');
        this.name = `${padId} ${this.round} ${this.teams[0]} x ${this.teams[1]}`;
        data.teams.forEach((slug)=>{
            this.teamDOs.push((0, $3fc4261274f65713$export$491fe77f22ab2b51)(slug));
        });
    }
    async loadGoals() {
        let total = this.data.goals.length;
        let loaded = 0;
        return new Promise((resolve)=>{
            if (!this.data.goals.length) {
                loaded++;
                if (loaded >= total) {
                    this.processGoals();
                    resolve();
                }
            }
            this.data.goals.forEach((goal)=>{
                window.fetch(`/goals/${goal}.json`).then((response)=>{
                    return response.json();
                }).then((resource)=>{
                    const goal = new (0, $70d3f995ca993989$export$2e2bcd8739ae039)(this);
                    goal.parse(resource);
                    this.goals.push(goal);
                    loaded++;
                    if (loaded >= total) {
                        this.processGoals();
                        resolve();
                    }
                });
            });
        });
    }
    processGoals() {
        // sort by minute + added
        this.goals.sort((a, b)=>a.minute - b.minute || a.added - b.added);
        // set goal index i.e. 45+2' (1st half) needs to come before 46' (2nd half)
        this.goals.forEach((goal, index)=>goal.index = index);
        // sort by half minute + added
        this.goals.sort((a, b)=>a.halfMinute - b.halfMinute || a.half - b.half || a.added - b.added);
        // set halfIndex for convenience
        this.goals.forEach((goal, index)=>goal.halfIndex = index);
        // assign temporary props required for collision solving
        this.goals.forEach((goal, index)=>{
            goal.x = Math.cos(goal.phi) * (0, $2343afc8a06b7454$export$96d096e28994f2e);
            goal.fixed = !goal.t && !index || goal.t == 1 && index == this.goals.length - 1;
            goal.w = goal.fixed ? 0 : 1;
        });
        // nudge overlapping dots
        const solve = ()=>{
            let a, b, dx, diff;
            const minDist = (0, $2343afc8a06b7454$export$9017f505fad9e6d4) * 2;
            for(let i = 0; i < this.goals.length; i++){
                a = this.goals[i];
                for(let j = i + 1; j < this.goals.length; j++){
                    b = this.goals[j];
                    dx = b.x - a.x;
                    if (!dx) dx = 0.0001;
                    if (Math.abs(dx) >= minDist) continue;
                    diff = (minDist - dx) / (dx * (a.w + b.w));
                    a.x -= a.w * dx * diff;
                    b.x += b.w * dx * diff;
                }
            }
        };
        // iterate solve
        for(let i = 0; i < 5; i++)solve();
        // calculate the new t and phi (u and tta)
        this.goals.forEach((goal)=>{
            goal.tta = Math.acos(goal.x / (0, $2343afc8a06b7454$export$96d096e28994f2e));
            goal.v = 1 - goal.tta / Math.PI;
            // delete temporary props
            delete goal.x;
            delete goal.w;
            delete goal.fixed;
        });
        // exception penalty shootout
        const dh = (0, $2343afc8a06b7454$export$e63e78834ae8a20f) * Math.PI;
        const dd = (0, $2343afc8a06b7454$export$9017f505fad9e6d4) * 4 / dh;
        let count = [
            0,
            0
        ];
        let idxTeam, idxGoal, result;
        this.goals.filter((goal)=>goal.shootout).forEach((goal, index)=>{
            idxTeam = this.teams.indexOf(goal.team);
            idxGoal = count[idxTeam];
            result = this.result.shootout[idxTeam];
            goal.half = goal.team === this.teams[0] ? 1 : 2;
            goal.t = (goal.added - 1 - ~~(result * 0.5)) * dd;
            if (idxTeam) goal.t = 1 - goal.t;
            goal.v = goal.u = goal.t;
        });
    }
}


const $5767c36b17e72441$var$_matches = [];
let $5767c36b17e72441$var$_goal;
const $5767c36b17e72441$export$acc1ab225836dc50 = async (data)=>{
    let total = data.length;
    let loaded = 0;
    return new Promise((resolve)=>{
        data.forEach(async (item, index)=>{
            const match = new (0, $2dbe60b75826fd8b$export$2e2bcd8739ae039)(item, index);
            await match.loadGoals();
            $5767c36b17e72441$var$_matches.push(match);
            loaded++;
            if (loaded >= total) resolve();
        });
    });
};
const $5767c36b17e72441$export$23a6ace8b2687b5 = ()=>{
    let subset;
    // filter only finished matches
    subset = $5767c36b17e72441$var$_matches.filter((match)=>match.done);
    // sort by most recent
    subset.sort((a, b)=>new Date(b.date) - new Date(a.date));
    return subset[0];
};
const $5767c36b17e72441$export$d2b3d1cf7cc2f701 = ()=>{
    let groups = [];
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'A';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'B';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'C';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'D';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'E';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'F';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'G';
    }));
    groups.push($5767c36b17e72441$var$_matches.filter((match)=>{
        return match.round === 'H';
    }));
    // sort by date, oldest first
    groups.map((group)=>group.sort((a, b)=>new Date(a.date) - new Date(b.date)));
    return groups;
};
const $5767c36b17e72441$export$38c92103459846c4 = ()=>{
    const sequence = [
        49,
        50,
        53,
        54,
        51,
        52,
        55,
        56
    ];
    const result = [];
    sequence.forEach((id)=>{
        result.push($5767c36b17e72441$var$_matches.find((match)=>match.id === id));
    });
    return result;
};
const $5767c36b17e72441$export$4282b62008f37173 = ()=>{
    const sequence = [
        57,
        58,
        59,
        60
    ];
    const result = [];
    sequence.forEach((id)=>{
        result.push($5767c36b17e72441$var$_matches.find((match)=>match.id === id));
    });
    return result;
};
const $5767c36b17e72441$export$77b7674324dda541 = ()=>{
    const sequence = [
        61,
        62
    ];
    const result = [];
    sequence.forEach((id)=>{
        result.push($5767c36b17e72441$var$_matches.find((match)=>match.id === id));
    });
    return result;
};
const $5767c36b17e72441$export$558a61b9635b4c10 = ()=>{
    const sequence = [
        64
    ];
    const result = [];
    sequence.forEach((id)=>{
        result.push($5767c36b17e72441$var$_matches.find((match)=>match.id === id));
    });
    return result;
};
const $5767c36b17e72441$export$26748ec468348572 = (id)=>{
    return $5767c36b17e72441$var$_matches.find((m)=>m.id == id);
};
const $5767c36b17e72441$export$ab205615fc3a8e74 = ()=>{
    return $5767c36b17e72441$var$_matches;
};
const $5767c36b17e72441$export$ba887a4992d07990 = (id)=>{
    let subset;
    // filter only finished matches
    subset = $5767c36b17e72441$var$_matches.filter((match)=>match.done);
    // sort by most recent
    subset.sort((a, b)=>new Date(b.date) - new Date(a.date));
    // find index of given id
    const index = subset.findIndex((match)=>match.id == id);
    return index > 0 ? subset[index - 1] : false;
};
const $5767c36b17e72441$export$c19731b2c49ee4c9 = (id)=>{
    let subset;
    // filter only finished matches
    subset = $5767c36b17e72441$var$_matches.filter((match)=>match.done);
    // sort by most recent
    subset.sort((a, b)=>new Date(b.date) - new Date(a.date));
    // find index of given id
    const index = subset.findIndex((match)=>match.id == id);
    return index < $5767c36b17e72441$var$_matches.length - 1 ? subset[index + 1] : false;
};
const $5767c36b17e72441$export$eda215a895aa0ddc = (slug = null)=>{
    if (!slug) return $5767c36b17e72441$var$_goal;
    for(let i = 0; i < $5767c36b17e72441$var$_matches.length; i++){
        $5767c36b17e72441$var$_goal = $5767c36b17e72441$var$_matches[i].goals.find((goal)=>goal.slug == slug);
        if ($5767c36b17e72441$var$_goal) return $5767c36b17e72441$var$_goal;
    }
};
const $5767c36b17e72441$export$54e5dfa78c47e5be = (value)=>{
    $5767c36b17e72441$var$_goal = value;
};



var $be49739a81ddc7e0$exports = {};
$be49739a81ddc7e0$exports = import.meta.resolve("gUUA7");


var $70799b77ac3f2fb7$exports = {};
$70799b77ac3f2fb7$exports = import.meta.resolve("4d7aA");


var $d1674cd56b9772de$exports = {};
$d1674cd56b9772de$exports = import.meta.resolve("bQAO2");


var $28a5ba41f9e3532d$exports = {};
$28a5ba41f9e3532d$exports = import.meta.resolve("hGqOa");


var $b27833982715a60e$exports = {};
$b27833982715a60e$exports = import.meta.resolve("7au87");


var $09f6191de4e2b485$exports = {};
$09f6191de4e2b485$exports = import.meta.resolve("hMQtf");


var $f64e84b9c1c275a2$exports = {};
$f64e84b9c1c275a2$exports = import.meta.resolve("7ZduV");


var $5505b51fd816e261$exports = {};
$5505b51fd816e261$exports = import.meta.resolve("bLi0C");


var $77c1317bd18d60e2$exports = {};
$77c1317bd18d60e2$exports = import.meta.resolve("75Dj6");


var $0d1c1178ac3884c1$exports = {};
$0d1c1178ac3884c1$exports = import.meta.resolve("15iII");


var $4353d8bd1bdbccd1$exports = {};
$4353d8bd1bdbccd1$exports = import.meta.resolve("d2dsL");


var $1df8dc62106c814d$exports = {};
$1df8dc62106c814d$exports = import.meta.resolve("6Gucs");


var $a8daeedb202c6384$exports = {};
$a8daeedb202c6384$exports = import.meta.resolve("fNU5c");


var $3059d650b97abb76$exports = {};
$3059d650b97abb76$exports = import.meta.resolve("5QyVX");


var $c53768afb79c2257$exports = {};
$c53768afb79c2257$exports = import.meta.resolve("8AWAd");


var $a30cd3aa010388c9$exports = {};
$a30cd3aa010388c9$exports = import.meta.resolve("apScp");


var $0f87b944bc87f77f$exports = {};
$0f87b944bc87f77f$exports = import.meta.resolve("a0BPj");


var $d2a9d0a89f625ac1$exports = {};
$d2a9d0a89f625ac1$exports = import.meta.resolve("k33hV");


var $43ecb7d251a11b88$exports = {};
$43ecb7d251a11b88$exports = import.meta.resolve("4G3St");


var $25803e61d65a8926$exports = {};
$25803e61d65a8926$exports = import.meta.resolve("hKtAu");


var $7a479be62f6a6b84$exports = {};
$7a479be62f6a6b84$exports = import.meta.resolve("ii9cm");


var $84665e78e3c568da$exports = {};
$84665e78e3c568da$exports = import.meta.resolve("6D8Kd");


var $1d0fb3df6a0a32fa$exports = {};
$1d0fb3df6a0a32fa$exports = import.meta.resolve("5pGPX");


var $cf18d979d1cc5f46$exports = {};
$cf18d979d1cc5f46$exports = import.meta.resolve("eZYCE");


var $9d7a57fe7b2d5f99$exports = {};
$9d7a57fe7b2d5f99$exports = import.meta.resolve("dhF3l");


var $cc93d52dce92bb15$exports = {};
$cc93d52dce92bb15$exports = import.meta.resolve("aw0R8");


var $9e988c49ded2a1a7$exports = {};
$9e988c49ded2a1a7$exports = import.meta.resolve("5v3Mn");


var $d14431f4e1fae457$exports = {};
$d14431f4e1fae457$exports = import.meta.resolve("kVqDV");


var $b037ed1be5827c9e$exports = {};
$b037ed1be5827c9e$exports = import.meta.resolve("8ixop");


var $7ae4711625f5e45c$exports = {};
$7ae4711625f5e45c$exports = import.meta.resolve("jZWiF");


var $43d5e94f1cf0e9fb$exports = {};
$43d5e94f1cf0e9fb$exports = import.meta.resolve("1Ponh");


var $d4a0f237cb8052cf$exports = {};
$d4a0f237cb8052cf$exports = import.meta.resolve("8rQ7K");


console.log((0, (/*@__PURE__*/$parcel$interopDefault($be49739a81ddc7e0$exports))));
let $47ce2a8addeaceec$export$ceac1d294cf61000 = {
    ARG: (/*@__PURE__*/$parcel$interopDefault($be49739a81ddc7e0$exports)),
    AUS: (/*@__PURE__*/$parcel$interopDefault($70799b77ac3f2fb7$exports)),
    BEL: (/*@__PURE__*/$parcel$interopDefault($d1674cd56b9772de$exports)),
    BRA: (/*@__PURE__*/$parcel$interopDefault($28a5ba41f9e3532d$exports)),
    CAN: (/*@__PURE__*/$parcel$interopDefault($b27833982715a60e$exports)),
    CMR: (/*@__PURE__*/$parcel$interopDefault($09f6191de4e2b485$exports)),
    CRC: (/*@__PURE__*/$parcel$interopDefault($f64e84b9c1c275a2$exports)),
    CRO: (/*@__PURE__*/$parcel$interopDefault($5505b51fd816e261$exports)),
    DEN: (/*@__PURE__*/$parcel$interopDefault($77c1317bd18d60e2$exports)),
    ECU: (/*@__PURE__*/$parcel$interopDefault($0d1c1178ac3884c1$exports)),
    ENG: (/*@__PURE__*/$parcel$interopDefault($4353d8bd1bdbccd1$exports)),
    ESP: (/*@__PURE__*/$parcel$interopDefault($1df8dc62106c814d$exports)),
    FRA: (/*@__PURE__*/$parcel$interopDefault($a8daeedb202c6384$exports)),
    GER: (/*@__PURE__*/$parcel$interopDefault($3059d650b97abb76$exports)),
    GHA: (/*@__PURE__*/$parcel$interopDefault($c53768afb79c2257$exports)),
    IRN: (/*@__PURE__*/$parcel$interopDefault($a30cd3aa010388c9$exports)),
    JPN: (/*@__PURE__*/$parcel$interopDefault($0f87b944bc87f77f$exports)),
    KOR: (/*@__PURE__*/$parcel$interopDefault($d2a9d0a89f625ac1$exports)),
    KSA: (/*@__PURE__*/$parcel$interopDefault($43ecb7d251a11b88$exports)),
    MEX: (/*@__PURE__*/$parcel$interopDefault($25803e61d65a8926$exports)),
    MOR: (/*@__PURE__*/$parcel$interopDefault($7a479be62f6a6b84$exports)),
    NED: (/*@__PURE__*/$parcel$interopDefault($84665e78e3c568da$exports)),
    POL: (/*@__PURE__*/$parcel$interopDefault($1d0fb3df6a0a32fa$exports)),
    POR: (/*@__PURE__*/$parcel$interopDefault($cf18d979d1cc5f46$exports)),
    QAT: (/*@__PURE__*/$parcel$interopDefault($9d7a57fe7b2d5f99$exports)),
    SEN: (/*@__PURE__*/$parcel$interopDefault($cc93d52dce92bb15$exports)),
    SRB: (/*@__PURE__*/$parcel$interopDefault($9e988c49ded2a1a7$exports)),
    SUI: (/*@__PURE__*/$parcel$interopDefault($d14431f4e1fae457$exports)),
    TUN: (/*@__PURE__*/$parcel$interopDefault($b037ed1be5827c9e$exports)),
    URU: (/*@__PURE__*/$parcel$interopDefault($7ae4711625f5e45c$exports)),
    USA: (/*@__PURE__*/$parcel$interopDefault($43d5e94f1cf0e9fb$exports)),
    WAL: (/*@__PURE__*/$parcel$interopDefault($d4a0f237cb8052cf$exports))
};
let $47ce2a8addeaceec$var$totalImages = 0;
class $47ce2a8addeaceec$var$Loader {
    loadTeams() {
        return fetch('/data/teams.json').then((response)=>response.json()).then((data)=>{
            (0, $3fc4261274f65713$export$3527acea17d79362)(data);
        });
    }
    loadMatches() {
        return fetch('/data/matches.json').then((response)=>response.json()).then((data)=>{
            return (0, $5767c36b17e72441$export$acc1ab225836dc50)(data);
        });
    }
    loadFlags() {
        function loaded(resolve) {
            $47ce2a8addeaceec$var$totalImages++;
            if ($47ce2a8addeaceec$var$totalImages >= 32) resolve();
        }
        return new Promise((resolve)=>{
            for (const [key, value] of Object.entries($47ce2a8addeaceec$export$ceac1d294cf61000))fetch(value).then(()=>{
                loaded(resolve);
            });
        });
    }
    load() {
        return this.loadTeams().then(()=>{
            return this.loadMatches();
        }).then(()=>{
            return this.loadFlags();
        });
    }
}
var $47ce2a8addeaceec$export$2e2bcd8739ae039 = new $47ce2a8addeaceec$var$Loader();


class $9f74d666842c1b25$var$ResponsiveScale {
    initialize({ screenMin: screenMin, screenMax: screenMax, aspectRatio: aspectRatio }) {
        this.screenMin = screenMin;
        this.screenMax = screenMax;
        this.scaleMin = screenMin / screenMax;
        this.scaleMax = 1;
        this.aspectRatio = aspectRatio;
    }
    scale({ scaleMin: scaleMin, scaleMax: scaleMax, screenMin: screenMin, screenMax: screenMax, vertical: vertical }) {
        let unit = vertical ? window.innerHeight * 0.01 : window.innerWidth * 0.01;
        if (window.innerWidth > screenMin) this.scaleValue = scaleMin + (scaleMax - scaleMin) * (unit * 100 - screenMin) / (screenMax - screenMin);
    }
    resize() {
        this.scale({
            scaleMin: this.scaleMin,
            scaleMax: this.scaleMax,
            screenMin: this.screenMin,
            screenMax: this.screenMax,
            vertical: false
        });
        if (window.innerWidth / window.innerHeight >= Math.round(this.aspectRatio * 100) / 100) this.scale({
            scaleMin: this.scaleMin,
            scaleMax: this.scaleMax,
            screenMin: this.screenMin / this.aspectRatio,
            screenMax: this.screenMax / this.aspectRatio,
            vertical: true
        });
    }
    getValue(value) {
        return value * this.scaleValue / window.devicePixelRatio;
    }
    getScale() {
        return this.scaleValue;
    }
}
var $9f74d666842c1b25$export$2e2bcd8739ae039 = new $9f74d666842c1b25$var$ResponsiveScale();







var $e09ac0646f67242c$export$2e2bcd8739ae039 = ()=>{
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};


function $75d26185314efc0e$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"bt-toggle-view\"\u003E\u003Cdiv class=\"square\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"square-animation\"\u003E\u003C\u002Fdiv\u003E\u003Csvg viewBox=\"0 0 20 31\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M0 0V30.0175H3.99393V16.27H17.7835V12.9067H3.99393V3.36331H19.7174V0H0Z\" fill=\"white\"\u002F\u003E\n\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $75d26185314efc0e$export$2e2bcd8739ae039 = $75d26185314efc0e$var$template;


class $8390b6595972de14$export$2e2bcd8739ae039 {
    el = undefined;
    closed = false;
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($6ab0340c5ed2956f$exports)))();
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $75d26185314efc0e$export$2e2bcd8739ae039)());
        this.square = this.el.querySelector('.square');
        this.type = this.el.querySelector('svg');
        this.addEvents();
        return this.el;
    }
    addEvents() {
        this.el.addEventListener('click', this.onClick);
        if ((0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) return;
        this.el.querySelector('.square').addEventListener('mouseover', this.onEnter);
        this.el.querySelector('.square').addEventListener('mouseout', this.onLeave);
    }
    onEnter() {
        if ((0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) return;
        this.overTL = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({});
        this.overTL.to(this.square, {
            scaleX: 5,
            duration: 0.15,
            ease: 'expo.out',
            transformOrigin: 'top right'
        });
    }
    onLeave() {
        if ((0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) return;
        if (this.overTL) {
            this.overTL.clear();
            this.overTL.kill();
        }
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.square, {
            scaleX: 1,
            duration: 0.15,
            ease: 'expo.out',
            transformOrigin: 'top right'
        });
    }
    onClick() {
        this.events.emit('click');
    }
    setClosed(isClosed) {
        if (isClosed) this.el.classList.add('close');
        else this.el.classList.remove('close');
        this.closed = isClosed;
    }
}








function $f4a0b2cd2bb51973$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"layout-logo\"\u003E\u003Csvg viewBox=\"0 0 20 31\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M0 0V30.0175H3.99393V16.27H17.7835V12.9067H3.99393V3.36331H19.7174V0H0Z\" fill=\"white\"\u002F\u003E\n\u003C\u002Fsvg\u003E\u003Cdiv class=\"square\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $f4a0b2cd2bb51973$export$2e2bcd8739ae039 = $f4a0b2cd2bb51973$var$template;


class $b533c1c5fa41b2eb$export$2e2bcd8739ae039 {
    el = undefined;
    closed = false;
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($6ab0340c5ed2956f$exports)))();
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $f4a0b2cd2bb51973$export$2e2bcd8739ae039)());
        this.square = this.el.querySelector('.square');
        this.type = this.el.querySelector('svg');
        this.addEvents();
        return this.el;
    }
    addEvents() {
        this.el.addEventListener('click', this.onClick);
        if ((0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) return;
        this.el.addEventListener('mouseenter', this.onEnter);
        this.el.addEventListener('mouseleave', this.onLeave);
    }
    onEnter() {
        this.overTL = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({});
        this.overTL.set(this.square, {
            x: '0%',
            scaleX: 0,
            transformOrigin: 'top left'
        });
        this.overTL.to(this.square, {
            scaleX: 5,
            duration: 0.15,
            ease: 'expo.out',
            transformOrigin: 'top left'
        });
    // this.overTL.set(this.square, {
    //   x: '400%',
    //   duration: 0,
    //   ease: 'expo.out',
    //   transformOrigin: 'top right',
    // });
    // this.overTL.set(this.type, { opacity: 1 });
    // this.overTL.to(this.square, {
    //   scaleX: 1,
    //   duration: 0.15,
    //   ease: 'expo.out',
    //   transformOrigin: 'top right',
    // });
    }
    onLeave() {
        if (this.overTL) {
            this.overTL.clear();
            this.overTL.kill();
        }
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.square, {
            scaleX: 0,
            duration: 0.15,
            ease: 'expo.out',
            transformOrigin: 'top left'
        });
    }
    onClick() {
        this.events.emit('click');
    }
    setClosed(isClosed) {
        if (isClosed) this.el.classList.add('close');
        else this.el.classList.remove('close');
        this.closed = isClosed;
    }
}




function $f27d4477689ea348$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"layout\"\u003E\u003Cdiv class=\"preload\"\u003E\u003Cdiv class=\"preload-logo\"\u003E\u003Csvg viewBox=\"0 0 20 31\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M0 0V30.0175H3.99393V16.27H17.7835V12.9067H3.99393V3.36331H19.7174V0H0Z\" fill=\"white\"\u002F\u003E\n\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"preload-square\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"page\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $f27d4477689ea348$export$2e2bcd8739ae039 = $f27d4477689ea348$var$template;



let $73647fc189170cc1$var$initialized = false;
class $73647fc189170cc1$var$Layout {
    btToggle = undefined;
    preloadDone = false;
    preloadAnimationDone = false;
    section = 'match';
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        (0, $9f74d666842c1b25$export$2e2bcd8739ae039).initialize({
            screenMin: 1024,
            screenMax: 1920,
            aspectRation: 1920 / 1080
        });
        (0, $9f74d666842c1b25$export$2e2bcd8739ae039).resize();
    }
    render() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).init();
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $f27d4477689ea348$export$2e2bcd8739ae039)());
        this.btToggle = new (0, $8390b6595972de14$export$2e2bcd8739ae039)();
        document.querySelector('#root').appendChild(this.el);
        this.el.appendChild(this.btToggle.render());
        this.el.appendChild((0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.domElement);
        this.logo = new (0, $b533c1c5fa41b2eb$export$2e2bcd8739ae039)();
        this.el.appendChild(this.logo.render());
        this.preloadLogo = this.el.querySelector('.preload-logo');
        this.preloadSquare = this.el.querySelector('.preload-square');
        this.events();
    }
    resize() {
        (0, $9f74d666842c1b25$export$2e2bcd8739ae039).resize();
    }
    events() {
        this.btToggle.events.on('click', this.toggleView);
        this.logo.events.on('click', this.toggleView);
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).on('url:change', this.onPageChange);
    }
    onPageChange(url) {
        if (/matches/.test(url)) {
            this.section = 'matches';
            this.btToggle.setClosed(true);
        } else {
            this.section = 'match';
            this.btToggle.setClosed(false);
        }
    }
    toggleView() {
        let match = (0, $5767c36b17e72441$export$23a6ace8b2687b5)();
        if (this.section === 'matches') (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${match.id}`);
        else (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/matches`);
    }
    transitionIn(req, done) {
        if (this.initialized) {
            done();
            return;
        }
        this.render();
        this.preload(done);
        this.tlPreload = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: this.chechPreload
        });
        this.tlPreload.fromTo(this.preloadSquare, {
            opacity: 0
        }, {
            opacity: 1,
            duration: 1,
            ease: 'expo.out'
        });
        this.tlPreload.to(this.preloadLogo, {
            duration: 0,
            opacity: 1,
            duration: 1,
            ease: 'expo.out'
        }, 1);
        this.tlPreload.to(this.preloadLogo, {
            ease: 'expo.inOut',
            x: '-210%',
            duration: 1
        }, 1);
        this.tlPreload.to(this.preloadSquare, {
            ease: 'expo.inOut',
            x: '160%',
            duration: 1
        }, 1);
    }
    chechPreload() {
        this.preloadAnimationDone = true;
        if (this.preloadDone) {
            let latest = (0, $5767c36b17e72441$export$23a6ace8b2687b5)();
            this.outroPreload(()=>{
                this.preloadCallback();
                this.initialized = true;
                // ways.go(`/matches`);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).pathname().length < 2) (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${latest.id}`);
            });
        }
    }
    preload(cb) {
        (0, $47ce2a8addeaceec$export$2e2bcd8739ae039).load().then(()=>{
            let latest = (0, $5767c36b17e72441$export$23a6ace8b2687b5)();
            this.preloadDone = true;
            if (this.preloadAnimationDone) this.outroPreload(()=>{
                cb();
                this.initialized = true;
                (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${latest.id}`);
            });
            else this.preloadCallback = cb;
        // ways.go(`/matches`);
        });
    }
    outroPreload(cb) {
        this.tlPreload = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: cb
        });
        this.tlPreload.to(this.preloadSquare, {
            ease: 'expo.inOut',
            transformOrigin: 'top right',
            scaleX: 4,
            duration: 0.25
        });
        this.tlPreload.to(this.preloadLogo, {
            ease: 'expo.inOut',
            transformOrigin: 'top right',
            opacity: 0,
            duration: 0
        });
        this.tlPreload.set(this.preloadSquare, {
            ease: 'expo.inOut',
            x: '-140%',
            transformOrigin: 'top left'
        });
        this.tlPreload.to(this.preloadSquare, {
            ease: 'expo.out',
            transformOrigin: 'top left',
            scaleX: 0.0,
            duration: 0.15
        });
        this.tlPreload.to(this.preloadSquare, {
            width: 0.0
        }, '-=0.01');
        this.el.classList.add('show');
    }
    transitionOut(req, done) {
        done();
    }
    destroy() {}
}
var $73647fc189170cc1$export$2e2bcd8739ae039 = new $73647fc189170cc1$var$Layout();




var $3c26857907f7c85b$exports = {};
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $3c26857907f7c85b$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$3c26857907f7c85b$var$debounce.debounce = $3c26857907f7c85b$var$debounce;
$3c26857907f7c85b$exports = $3c26857907f7c85b$var$debounce;


var $27b84c32f3d45dfc$exports = {};
"use strict";
function $27b84c32f3d45dfc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $27b84c32f3d45dfc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $27b84c32f3d45dfc$var$_typeof(obj);
}
Object.defineProperty($27b84c32f3d45dfc$exports, "__esModule", {
    value: true
});
var $27b84c32f3d45dfc$var$_exportNames = {};
$27b84c32f3d45dfc$exports["default"] = void 0;

var $27b84c32f3d45dfc$var$Utils = $27b84c32f3d45dfc$var$_interopRequireWildcard((parcelRequire("dgGOd")));

var $kDZPj = parcelRequire("kDZPj");
Object.keys($kDZPj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($27b84c32f3d45dfc$var$_exportNames, key)) return;
    if (key in $27b84c32f3d45dfc$exports && $27b84c32f3d45dfc$exports[key] === $kDZPj[key]) return;
    Object.defineProperty($27b84c32f3d45dfc$exports, key, {
        enumerable: true,
        get: function get() {
            return $kDZPj[key];
        }
    });
});
function $27b84c32f3d45dfc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($27b84c32f3d45dfc$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $27b84c32f3d45dfc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $27b84c32f3d45dfc$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $27b84c32f3d45dfc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $27b84c32f3d45dfc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27b84c32f3d45dfc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $27b84c32f3d45dfc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $27b84c32f3d45dfc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $27b84c32f3d45dfc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $27b84c32f3d45dfc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $27b84c32f3d45dfc$var$VanillaSwipe = /*#__PURE__*/ function() {
    function VanillaSwipe(props) {
        $27b84c32f3d45dfc$var$_classCallCheck(this, VanillaSwipe);
        $27b84c32f3d45dfc$var$_defineProperty(this, "state", void 0);
        $27b84c32f3d45dfc$var$_defineProperty(this, "props", void 0);
        this.state = $27b84c32f3d45dfc$var$Utils.getInitialState();
        this.props = $27b84c32f3d45dfc$var$Utils.getInitialProps(props);
        this.handleSwipeStart = this.handleSwipeStart.bind(this);
        this.handleSwipeMove = this.handleSwipeMove.bind(this);
        this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleMouseUp = this.handleMouseUp.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }
    $27b84c32f3d45dfc$var$_createClass(VanillaSwipe, [
        {
            key: "init",
            value: function init() {
                this.setupTouchListeners();
                this.setupMouseListeners();
            }
        },
        {
            key: "update",
            value: function update(props) {
                var prevProps = this.props;
                var nextProps = Object.assign({}, prevProps, props);
                if (prevProps.element !== nextProps.element || prevProps.target !== nextProps.target) {
                    this.destroy();
                    this.props = nextProps;
                    this.init();
                    return;
                }
                this.props = nextProps;
                if (prevProps.mouseTrackingEnabled !== nextProps.mouseTrackingEnabled || prevProps.preventTrackingOnMouseleave !== nextProps.preventTrackingOnMouseleave) {
                    this.cleanupMouseListeners();
                    nextProps.mouseTrackingEnabled ? this.setupMouseListeners() : this.cleanupMouseListeners();
                }
                if (prevProps.touchTrackingEnabled !== nextProps.touchTrackingEnabled) {
                    this.cleanupTouchListeners();
                    nextProps.touchTrackingEnabled ? this.setupTouchListeners() : this.cleanupTouchListeners();
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.cleanupMouseListeners();
                this.cleanupTouchListeners();
                this.state = $27b84c32f3d45dfc$var$Utils.getInitialState();
                this.props = $27b84c32f3d45dfc$var$Utils.getInitialProps();
            }
        },
        {
            key: "setupTouchListeners",
            value: function setupTouchListeners() {
                var _this$props = this.props, element = _this$props.element, target = _this$props.target, touchTrackingEnabled = _this$props.touchTrackingEnabled;
                if (element && touchTrackingEnabled) {
                    var listener = target || element;
                    var isPassiveSupported = $27b84c32f3d45dfc$var$Utils.checkIsPassiveSupported();
                    var options = $27b84c32f3d45dfc$var$Utils.getOptions(isPassiveSupported);
                    listener.addEventListener('touchstart', this.handleSwipeStart, options);
                    listener.addEventListener('touchmove', this.handleSwipeMove, options);
                    listener.addEventListener('touchend', this.handleSwipeEnd, options);
                }
            }
        },
        {
            key: "cleanupTouchListeners",
            value: function cleanupTouchListeners() {
                var _this$props2 = this.props, element = _this$props2.element, target = _this$props2.target;
                var listener = target || element;
                if (listener) {
                    listener.removeEventListener('touchstart', this.handleSwipeStart);
                    listener.removeEventListener('touchmove', this.handleSwipeMove);
                    listener.removeEventListener('touchend', this.handleSwipeEnd);
                }
            }
        },
        {
            key: "setupMouseListeners",
            value: function setupMouseListeners() {
                var _this$props3 = this.props, element = _this$props3.element, mouseTrackingEnabled = _this$props3.mouseTrackingEnabled, preventTrackingOnMouseleave = _this$props3.preventTrackingOnMouseleave;
                if (mouseTrackingEnabled && element) {
                    element.addEventListener('mousedown', this.handleMouseDown);
                    element.addEventListener('mousemove', this.handleMouseMove);
                    element.addEventListener('mouseup', this.handleMouseUp);
                    if (preventTrackingOnMouseleave) element.addEventListener('mouseleave', this.handleMouseLeave);
                }
            }
        },
        {
            key: "cleanupMouseListeners",
            value: function cleanupMouseListeners() {
                var element = this.props.element;
                if (element) {
                    element.removeEventListener('mousedown', this.handleMouseDown);
                    element.removeEventListener('mousemove', this.handleMouseMove);
                    element.removeEventListener('mouseup', this.handleMouseUp);
                    element.removeEventListener('mouseleave', this.handleMouseLeave);
                }
            }
        },
        {
            key: "getEventData",
            value: function getEventData(e) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    directionDelta: 0
                };
                var rotationAngle = this.props.rotationAngle;
                var directionDelta = options.directionDelta;
                var movingPosition = $27b84c32f3d45dfc$var$Utils.calculateMovingPosition(e);
                var rotatePosition = $27b84c32f3d45dfc$var$Utils.rotateByAngle(movingPosition, rotationAngle);
                return $27b84c32f3d45dfc$var$Utils.calculatePosition(this.state, {
                    rotatePosition: rotatePosition,
                    directionDelta: directionDelta
                });
            }
        },
        {
            key: "handleSwipeStart",
            value: function handleSwipeStart(e) {
                if ($27b84c32f3d45dfc$var$Utils.checkIsMoreThanSingleTouches(e)) return;
                var rotationAngle = this.props.rotationAngle;
                var movingPosition = $27b84c32f3d45dfc$var$Utils.calculateMovingPosition(e);
                var _Utils$rotateByAngle = $27b84c32f3d45dfc$var$Utils.rotateByAngle(movingPosition, rotationAngle), x = _Utils$rotateByAngle.x, y = _Utils$rotateByAngle.y;
                this.state = $27b84c32f3d45dfc$var$Utils.getInitialState({
                    isSwiping: false,
                    start: Date.now(),
                    x: x,
                    y: y
                });
            }
        },
        {
            key: "handleSwipeMove",
            value: function handleSwipeMove(e) {
                var _this$state = this.state, x = _this$state.x, y = _this$state.y, isSwiping = _this$state.isSwiping;
                if (!x || !y || $27b84c32f3d45dfc$var$Utils.checkIsMoreThanSingleTouches(e)) return;
                var directionDelta = this.props.directionDelta || 0;
                var _this$getEventData = this.getEventData(e, {
                    directionDelta: directionDelta
                }), absX = _this$getEventData.absX, absY = _this$getEventData.absY, deltaX = _this$getEventData.deltaX, deltaY = _this$getEventData.deltaY, directionX = _this$getEventData.directionX, directionY = _this$getEventData.directionY, duration = _this$getEventData.duration, velocity = _this$getEventData.velocity;
                var _this$props4 = this.props, delta = _this$props4.delta, preventDefaultTouchmoveEvent = _this$props4.preventDefaultTouchmoveEvent, onSwipeStart = _this$props4.onSwipeStart, onSwiping = _this$props4.onSwiping;
                if (e.cancelable && preventDefaultTouchmoveEvent) e.preventDefault();
                if (absX < Number(delta) && absY < Number(delta) && !isSwiping) return;
                if (onSwipeStart && !isSwiping) onSwipeStart(e, {
                    deltaX: deltaX,
                    deltaY: deltaY,
                    absX: absX,
                    absY: absY,
                    directionX: directionX,
                    directionY: directionY,
                    duration: duration,
                    velocity: velocity
                });
                this.state.isSwiping = true;
                if (onSwiping) onSwiping(e, {
                    deltaX: deltaX,
                    deltaY: deltaY,
                    absX: absX,
                    absY: absY,
                    directionX: directionX,
                    directionY: directionY,
                    duration: duration,
                    velocity: velocity
                });
            }
        },
        {
            key: "handleSwipeEnd",
            value: function handleSwipeEnd(e) {
                var _this$props5 = this.props, onSwiped = _this$props5.onSwiped, onTap = _this$props5.onTap;
                if (this.state.isSwiping) {
                    var directionDelta = this.props.directionDelta || 0;
                    var position = this.getEventData(e, {
                        directionDelta: directionDelta
                    });
                    onSwiped && onSwiped(e, position);
                } else {
                    var _position = this.getEventData(e);
                    onTap && onTap(e, _position);
                }
                this.state = $27b84c32f3d45dfc$var$Utils.getInitialState();
            }
        },
        {
            key: "handleMouseDown",
            value: function handleMouseDown(e) {
                var target = this.props.target;
                if (target) {
                    if (target === e.target) this.handleSwipeStart(e);
                } else this.handleSwipeStart(e);
            }
        },
        {
            key: "handleMouseMove",
            value: function handleMouseMove(e) {
                this.handleSwipeMove(e);
            }
        },
        {
            key: "handleMouseUp",
            value: function handleMouseUp(e) {
                var isSwiping = this.state.isSwiping;
                var target = this.props.target;
                if (target) {
                    if (target === e.target || isSwiping) this.handleSwipeEnd(e);
                } else this.handleSwipeEnd(e);
            }
        },
        {
            key: "handleMouseLeave",
            value: function handleMouseLeave(e) {
                var isSwiping = this.state.isSwiping;
                if (isSwiping) this.handleSwipeEnd(e);
            }
        }
    ], [
        {
            key: "isTouchEventsSupported",
            value: function isTouchEventsSupported() {
                return $27b84c32f3d45dfc$var$Utils.checkIsTouchEventsSupported();
            }
        }
    ]);
    return VanillaSwipe;
}();
$27b84c32f3d45dfc$exports["default"] = $27b84c32f3d45dfc$var$VanillaSwipe;












function $627cf78ccdbb04e6$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $627cf78ccdbb04e6$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $627cf78ccdbb04e6$var$pug_classes(s, r) {
    return Array.isArray(s) ? $627cf78ccdbb04e6$var$pug_classes_array(s, r) : s && "object" == typeof s ? $627cf78ccdbb04e6$var$pug_classes_object(s) : s || "";
}
function $627cf78ccdbb04e6$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $627cf78ccdbb04e6$var$pug_classes(r[g])) && (c && a[g] && (s = $627cf78ccdbb04e6$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $627cf78ccdbb04e6$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $627cf78ccdbb04e6$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $627cf78ccdbb04e6$var$pug_escape(e) {
    var a = "" + e, t = $627cf78ccdbb04e6$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $627cf78ccdbb04e6$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $627cf78ccdbb04e6$var$pug_match_html = /["&<>]/;
function $627cf78ccdbb04e6$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(name1, score1, visitor1) {
        pug_html = pug_html + "\u003Cdiv" + $627cf78ccdbb04e6$var$pug_attr("class", $627cf78ccdbb04e6$var$pug_classes([
            "match-score",
            visitor1
        ], [
            false,
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"match-flag\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"score\"\u003E\u003Cp\u003E" + $627cf78ccdbb04e6$var$pug_escape(null == (pug_interp = score1) ? "" : pug_interp) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team\"\u003E\u003Cp\u003E" + $627cf78ccdbb04e6$var$pug_escape(null == (pug_interp = name1) ? "" : pug_interp) + "\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "name" in locals_for_with ? locals_for_with.name : typeof name !== 'undefined' ? name : undefined, "score" in locals_for_with ? locals_for_with.score : typeof score !== 'undefined' ? score : undefined, "visitor" in locals_for_with ? locals_for_with.visitor : typeof visitor !== 'undefined' ? visitor : undefined);
    return pug_html;
}
var $627cf78ccdbb04e6$export$2e2bcd8739ae039 = $627cf78ccdbb04e6$var$template;






function $9394b58e4f9c4754$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $9394b58e4f9c4754$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $9394b58e4f9c4754$var$pug_classes(s, r) {
    return Array.isArray(s) ? $9394b58e4f9c4754$var$pug_classes_array(s, r) : s && "object" == typeof s ? $9394b58e4f9c4754$var$pug_classes_object(s) : s || "";
}
function $9394b58e4f9c4754$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $9394b58e4f9c4754$var$pug_classes(r[g])) && (c && a[g] && (s = $9394b58e4f9c4754$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $9394b58e4f9c4754$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $9394b58e4f9c4754$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $9394b58e4f9c4754$var$pug_escape(e) {
    var a = "" + e, t = $9394b58e4f9c4754$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $9394b58e4f9c4754$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $9394b58e4f9c4754$var$pug_match_html = /["&<>]/;
function $9394b58e4f9c4754$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(type1) {
        pug_html = pug_html + "\u003Cdiv" + $9394b58e4f9c4754$var$pug_attr("class", $9394b58e4f9c4754$var$pug_classes([
            "cover-flag",
            type1
        ], [
            false,
            true
        ]), false, false) + "\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "type" in locals_for_with ? locals_for_with.type : typeof type !== 'undefined' ? type : undefined);
    return pug_html;
}
var $9394b58e4f9c4754$export$2e2bcd8739ae039 = $9394b58e4f9c4754$var$template;






function $5632d325ff8f16ef$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $5632d325ff8f16ef$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $5632d325ff8f16ef$var$pug_classes(s, r) {
    return Array.isArray(s) ? $5632d325ff8f16ef$var$pug_classes_array(s, r) : s && "object" == typeof s ? $5632d325ff8f16ef$var$pug_classes_object(s) : s || "";
}
function $5632d325ff8f16ef$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $5632d325ff8f16ef$var$pug_classes(r[g])) && (c && a[g] && (s = $5632d325ff8f16ef$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $5632d325ff8f16ef$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $5632d325ff8f16ef$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $5632d325ff8f16ef$var$pug_escape(e) {
    var a = "" + e, t = $5632d325ff8f16ef$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $5632d325ff8f16ef$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $5632d325ff8f16ef$var$pug_match_html = /["&<>]/;
function $5632d325ff8f16ef$var$pug_style(r) {
    if (!r) return "";
    if ("object" == typeof r) {
        var t = "";
        for(var e in r)$5632d325ff8f16ef$var$pug_has_own_property.call(r, e) && (t = t + e + ":" + r[e] + ";");
        return t;
    }
    return r + "";
}
function $5632d325ff8f16ef$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(asset1, colors1, type1) {
        pug_html = pug_html + "\u003Cdiv" + $5632d325ff8f16ef$var$pug_attr("class", $5632d325ff8f16ef$var$pug_classes([
            "flag",
            type1
        ], [
            false,
            true
        ]), false, false) + "\u003E";
        if (asset1) pug_html = pug_html + "\u003Cimg" + $5632d325ff8f16ef$var$pug_attr("src", asset1, true, false) + "\u002F\u003E";
        if (!asset1) (function() {
            var $$obj = colors1;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var color = $$obj[pug_index0];
                pug_html = pug_html + "\u003Cspan" + $5632d325ff8f16ef$var$pug_attr("style", $5632d325ff8f16ef$var$pug_style(`background-color: ${color}`), true, false) + "\u003E\u003C\u002Fspan\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var color = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Cspan" + $5632d325ff8f16ef$var$pug_attr("style", $5632d325ff8f16ef$var$pug_style(`background-color: ${color}`), true, false) + "\u003E\u003C\u002Fspan\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "asset" in locals_for_with ? locals_for_with.asset : typeof asset !== 'undefined' ? asset : undefined, "colors" in locals_for_with ? locals_for_with.colors : typeof colors !== 'undefined' ? colors : undefined, "type" in locals_for_with ? locals_for_with.type : typeof type !== 'undefined' ? type : undefined);
    return pug_html;
}
var $5632d325ff8f16ef$export$2e2bcd8739ae039 = $5632d325ff8f16ef$var$template;


class $efb56e6e6bc532d5$export$2e2bcd8739ae039 {
    constructor(data, style){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.data = data;
        this.big = style ? style.big : null;
        this.asset = style ? style.asset : null;
        this.show = style ? style.show : null;
        this.type = 'three';
        if (this.data && this.data.flag.length === 2) this.type = 'two';
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $5632d325ff8f16ef$export$2e2bcd8739ae039)({
            colors: this.data ? this.data.flag : [
                '#272727',
                '#1B1B1B',
                '#272727'
            ],
            type: this.type,
            show: this.show,
            asset: this.asset
        }));
        if (this.big) this.el.classList.add('big');
        this.parts = this.el.querySelectorAll('span');
        if (this.type === 'three') {
            this.topFlag = this.parts[0];
            this.middleFlag = this.parts[1];
            this.bottomFlag = this.parts[2];
        } else {
            this.topFlag = this.parts[0];
            this.bottomFlag = this.parts[1];
        }
        return this.el;
    }
    outro() {
        this.el.classList.remove('show');
    }
    intro() {
        if (this.tl) {
            this.tl.clear();
            this.tl.kill();
        }
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tl.add(()=>{
            this.el.classList.add('show');
        });
        return this.tl;
    }
}




class $05f6f981e2ce284a$export$2e2bcd8739ae039 {
    constructor(data, style){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.data = data;
        this.big = style ? style.big : null;
        this.visitor = style ? style.visitor : false;
        this.type = 'three';
        if (this.data && this.data.flag.length === 2) this.type = 'two';
    }
    render() {
        console.log((0, $47ce2a8addeaceec$export$ceac1d294cf61000), this.data.slug);
        this.flagSmall = new (0, $efb56e6e6bc532d5$export$2e2bcd8739ae039)(this.data, {
            big: this.big,
            asset: this.data ? (0, $47ce2a8addeaceec$export$ceac1d294cf61000)[this.data.slug] : null
        });
        this.flagBig = new (0, $efb56e6e6bc532d5$export$2e2bcd8739ae039)(this.data, {
            big: this.big
        });
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $9394b58e4f9c4754$export$2e2bcd8739ae039)());
        this.el.appendChild(this.flagSmall.render());
        this.el.appendChild(this.flagBig.render());
        this.flagSmallEl = this.flagSmall.el;
        this.flagBigElTop = this.flagBig.el.querySelectorAll('span')[0];
        this.flagBigElBottom = this.flagBig.el.querySelectorAll('span')[1];
        this.flagBigEl = this.flagBig.el;
        this.flagBig.el.style['pointer-events'] = 'none';
        return this.el;
    }
    out() {
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tl.to(this.flagSmallEl, {
            scale: 1
        });
    }
    over(visit) {
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tl.to(this.flagSmallEl, {
            scale: 2,
            duration: 0.1,
            ease: 'power4.out',
            transformOrigin: visit ? '0% 50%' : '100% 50%'
        });
        return this.tl;
    }
    outro() {
        // this.el.classList.remove('show');
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tl.set(this.flagSmallEl, {
            opacity: 0,
            scaleX: 5,
            x: this.visitor ? '-100%' : '100%',
            transformOrigin: this.visitor ? 'center right' : 'center left'
        });
        this.tl.set(this.flagBigEl, {
            scaleY: 2,
            x: this.visitor ? '-600%' : '600%',
            scaleX: 10,
            duration: 0.3,
            ease: 'power4.out',
            transformOrigin: 'center center'
        });
        this.tl.set(this.flagBigElBottom, {
            scaleY: 2,
            transformOrigin: 'bottom left'
        }, 0);
        this.tl.fromTo(this.flagBigElTop, {
            scaleY: 1,
            transformOrigin: 'top left'
        }, {
            scaleY: 2,
            duration: 0.35,
            ease: 'power.out',
            transformOrigin: 'top left'
        });
        this.tl.to(this.flagBigEl, {
            scaleY: 1.5,
            scaleX: 8,
            duration: 0.5,
            ease: 'power4.in',
            transformOrigin: 'center center'
        }, 0);
        this.tl.set(this.flagBigElTop, {
            scaleY: 0.8,
            ease: 'power.out',
            transformOrigin: 'top left'
        });
        this.tl.fromTo(this.flagBigEl, {
            opacity: 1
        }, {
            opacity: 0,
            duration: 0.01,
            ease: 'power4.out'
        }, '+=.05');
        this.tl.to(this.flagSmallEl, {
            opacity: 1,
            duration: 0,
            ease: 'power4.out'
        }, 0.45);
        this.tl.to(this.flagSmallEl, {
            x: '0%',
            duration: 0.1,
            ease: 'power4.out'
        }, 0.45);
        this.tl.to(this.flagSmallEl, {
            scaleX: 1,
            duration: 0.5,
            ease: 'power4.out'
        }, 0.5);
        return this.tl;
    }
    reset() {
        this.el.style.opacity = 0;
    }
    intro(scl) {
        let scale = scl || 1;
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tl.set(this.el, {
            opacity: 1
        });
        this.tl.add(this.flagBig.intro());
        this.tl.add(this.flagSmall.intro());
        this.tl.set(this.flagSmallEl, {
            opacity: 0,
            scaleX: 5 * scale,
            x: this.visitor ? '-100%' : '100%',
            transformOrigin: this.visitor ? 'center right' : 'center left'
        });
        this.tl.set(this.flagBigEl, {
            scaleY: 2 * scale,
            x: this.visitor ? `-${600 * scale}%` : `${600 * scale}%`,
            scaleX: 10 * scale,
            duration: 0.3,
            ease: 'power4.out',
            transformOrigin: 'center center'
        });
        if (!(0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) {
            this.tl.set(this.flagBigElBottom, {
                scaleY: 2,
                transformOrigin: 'bottom left'
            }, 0);
            this.tl.fromTo(this.flagBigElTop, {
                scaleY: 1,
                transformOrigin: 'top left'
            }, {
                scaleY: 2,
                duration: 0.35,
                ease: 'power.out',
                transformOrigin: 'top left'
            });
        }
        this.tl.to(this.flagBigEl, {
            scaleY: 1.5 * scale,
            scaleX: 8 * scale,
            duration: 0.5,
            ease: 'power4.in',
            transformOrigin: 'center center'
        }, 0);
        if (!(0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) this.tl.set(this.flagBigElTop, {
            scaleY: 0.8 * scale,
            ease: 'power.out',
            transformOrigin: 'top left'
        });
        this.tl.fromTo(this.flagBigEl, {
            opacity: 1
        }, {
            opacity: 0,
            duration: 0.01,
            ease: 'power4.out'
        }, '+=.05');
        this.tl.to(this.flagSmallEl, {
            opacity: 1,
            duration: 0,
            ease: 'power4.out'
        }, 0.45);
        this.tl.to(this.flagSmallEl, {
            x: '0%',
            duration: 0.1,
            ease: 'power4.out'
        }, 0.45);
        this.tl.to(this.flagSmallEl, {
            scaleX: 1,
            duration: 0.5,
            ease: 'power4.out'
        }, 0.5);
        return this.tl;
    }
}


/*!
 * CustomEase 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ /*!
 * paths 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $eff81e413b8925be$var$_svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $eff81e413b8925be$var$_numbersExp = /(?:(-)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, $eff81e413b8925be$var$_scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig, $eff81e413b8925be$var$_selectorExp = /(^[#\.][a-z]|[a-y][a-z])/i, $eff81e413b8925be$var$_DEG2RAD = Math.PI / 180, $eff81e413b8925be$var$_RAD2DEG = 180 / Math.PI, $eff81e413b8925be$var$_sin = Math.sin, $eff81e413b8925be$var$_cos = Math.cos, $eff81e413b8925be$var$_abs = Math.abs, $eff81e413b8925be$var$_sqrt = Math.sqrt, $eff81e413b8925be$var$_atan2 = Math.atan2, $eff81e413b8925be$var$_largeNum = 1e8, $eff81e413b8925be$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $eff81e413b8925be$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $eff81e413b8925be$var$_isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, $eff81e413b8925be$var$_temp = {}, $eff81e413b8925be$var$_temp2 = {}, $eff81e413b8925be$var$_roundingNum = 1e5, $eff81e413b8925be$var$_wrapProgress = function _wrapProgress(progress) {
    return Math.round((progress + $eff81e413b8925be$var$_largeNum) % 1 * $eff81e413b8925be$var$_roundingNum) / $eff81e413b8925be$var$_roundingNum || (progress < 0 ? 0 : 1);
}, //if progress lands on 1, the % will make it 0 which is why we || 1, but not if it's negative because it makes more sense for motion to end at 0 in that case.
$eff81e413b8925be$var$_round = function _round(value) {
    return Math.round(value * $eff81e413b8925be$var$_roundingNum) / $eff81e413b8925be$var$_roundingNum || 0;
}, $eff81e413b8925be$var$_roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 1e10) / 1e10 || 0;
}, $eff81e413b8925be$var$_splitSegment = function _splitSegment(rawPath, segIndex, i, t) {
    var segment = rawPath[segIndex], shift = t === 1 ? 6 : $eff81e413b8925be$export$bd9f14de8998b2c6(segment, i, t);
    if ((shift || !t) && shift + i + 2 < segment.length) {
        rawPath.splice(segIndex, 0, segment.slice(0, i + shift + 2));
        segment.splice(0, i + shift);
        return 1;
    }
}, $eff81e413b8925be$var$_getSampleIndex = function _getSampleIndex(samples, length, progress) {
    // slightly slower way than doing this (when there's no lookup): segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0;
    var l = samples.length, i = ~~(progress * l);
    if (samples[i] > length) {
        while(--i && samples[i] > length);
        i < 0 && (i = 0);
    } else {
        while(samples[++i] < length && i < l);
    }
    return i < l ? i : l - 1;
}, $eff81e413b8925be$var$_reverseRawPath = function _reverseRawPath(rawPath, skipOuter) {
    var i = rawPath.length;
    skipOuter || rawPath.reverse();
    while(i--)rawPath[i].reversed || $eff81e413b8925be$export$1c1e155a66a9b65a(rawPath[i]);
}, $eff81e413b8925be$var$_copyMetaData = function _copyMetaData(source, copy) {
    copy.totalLength = source.totalLength;
    if (source.samples) {
        //segment
        copy.samples = source.samples.slice(0);
        copy.lookup = source.lookup.slice(0);
        copy.minLength = source.minLength;
        copy.resolution = source.resolution;
    } else if (source.totalPoints) //rawPath
    copy.totalPoints = source.totalPoints;
    return copy;
}, //pushes a new segment into a rawPath, but if its starting values match the ending values of the last segment, it'll merge it into that same segment (to reduce the number of segments)
$eff81e413b8925be$var$_appendOrMerge = function _appendOrMerge(rawPath, segment) {
    var index = rawPath.length, prevSeg = rawPath[index - 1] || [], l = prevSeg.length;
    if (index && segment[0] === prevSeg[l - 2] && segment[1] === prevSeg[l - 1]) {
        segment = prevSeg.concat(segment.slice(2));
        index--;
    }
    rawPath[index] = segment;
}, $eff81e413b8925be$var$_bestDistance;
function $eff81e413b8925be$export$a7de45090ab95fc7(value) {
    value = $eff81e413b8925be$var$_isString(value) && $eff81e413b8925be$var$_selectorExp.test(value) ? document.querySelector(value) || value : value;
    var e = value.getAttribute ? value : 0, rawPath;
    if (e && (value = value.getAttribute("d"))) {
        //implements caching
        if (!e._gsPath) e._gsPath = {};
        rawPath = e._gsPath[value];
        return rawPath && !rawPath._dirty ? rawPath : e._gsPath[value] = $eff81e413b8925be$export$a9a6ab89eb1c2191(value);
    }
    return !value ? console.warn("Expecting a <path> element or an SVG path data string") : $eff81e413b8925be$var$_isString(value) ? $eff81e413b8925be$export$a9a6ab89eb1c2191(value) : $eff81e413b8925be$var$_isNumber(value[0]) ? [
        value
    ] : value;
} //copies a RawPath WITHOUT the length meta data (for speed)
function $eff81e413b8925be$export$e358367bf79edde2(rawPath) {
    var a = [], i = 0;
    for(; i < rawPath.length; i++)a[i] = $eff81e413b8925be$var$_copyMetaData(rawPath[i], rawPath[i].slice(0));
    return $eff81e413b8925be$var$_copyMetaData(rawPath, a);
}
function $eff81e413b8925be$export$1c1e155a66a9b65a(segment) {
    var i = 0, y;
    segment.reverse(); //this will invert the order y, x, y, x so we must flip it back.
    for(; i < segment.length; i += 2){
        y = segment[i];
        segment[i] = segment[i + 1];
        segment[i + 1] = y;
    }
    segment.reversed = !segment.reversed;
}
var $eff81e413b8925be$var$_createPath = function _createPath(e, ignore) {
    var path = document.createElementNS("http://www.w3.org/2000/svg", "path"), attr = [].slice.call(e.attributes), i = attr.length, name;
    ignore = "," + ignore + ",";
    while(--i > -1){
        name = attr[i].nodeName.toLowerCase(); //in Microsoft Edge, if you don't set the attribute with a lowercase name, it doesn't render correctly! Super weird.
        if (ignore.indexOf("," + name + ",") < 0) path.setAttributeNS(null, name, attr[i].nodeValue);
    }
    return path;
}, $eff81e413b8925be$var$_typeAttrs = {
    rect: "rx,ry,x,y,width,height",
    circle: "r,cx,cy",
    ellipse: "rx,ry,cx,cy",
    line: "x1,x2,y1,y2"
}, $eff81e413b8925be$var$_attrToObj = function _attrToObj(e, attrs) {
    var props = attrs ? attrs.split(",") : [], obj = {}, i = props.length;
    while(--i > -1)obj[props[i]] = +e.getAttribute(props[i]) || 0;
    return obj;
}; //converts an SVG shape like <circle>, <rect>, <polygon>, <polyline>, <ellipse>, etc. to a <path>, swapping it in and copying the attributes to match.
function $eff81e413b8925be$export$1a6b6149d6272140(element, swap) {
    var type = element.tagName.toLowerCase(), circ = 0.552284749831, data, x, y, r, ry, path, rcirc, rycirc, points, w, h, x2, x3, x4, x5, x6, y2, y3, y4, y5, y6, attr;
    if (type === "path" || !element.getBBox) return element;
    path = $eff81e413b8925be$var$_createPath(element, "x,y,width,height,cx,cy,rx,ry,r,x1,x2,y1,y2,points");
    attr = $eff81e413b8925be$var$_attrToObj(element, $eff81e413b8925be$var$_typeAttrs[type]);
    if (type === "rect") {
        r = attr.rx;
        ry = attr.ry || r;
        x = attr.x;
        y = attr.y;
        w = attr.width - r * 2;
        h = attr.height - ry * 2;
        if (r || ry) {
            //if there are rounded corners, render cubic beziers
            x2 = x + r * (1 - circ);
            x3 = x + r;
            x4 = x3 + w;
            x5 = x4 + r * circ;
            x6 = x4 + r;
            y2 = y + ry * (1 - circ);
            y3 = y + ry;
            y4 = y3 + h;
            y5 = y4 + ry * circ;
            y6 = y4 + ry;
            data = "M" + x6 + "," + y3 + " V" + y4 + " C" + [
                x6,
                y5,
                x5,
                y6,
                x4,
                y6,
                x4 - (x4 - x3) / 3,
                y6,
                x3 + (x4 - x3) / 3,
                y6,
                x3,
                y6,
                x2,
                y6,
                x,
                y5,
                x,
                y4,
                x,
                y4 - (y4 - y3) / 3,
                x,
                y3 + (y4 - y3) / 3,
                x,
                y3,
                x,
                y2,
                x2,
                y,
                x3,
                y,
                x3 + (x4 - x3) / 3,
                y,
                x4 - (x4 - x3) / 3,
                y,
                x4,
                y,
                x5,
                y,
                x6,
                y2,
                x6,
                y3
            ].join(",") + "z";
        } else data = "M" + (x + w) + "," + y + " v" + h + " h" + -w + " v" + -h + " h" + w + "z";
    } else if (type === "circle" || type === "ellipse") {
        if (type === "circle") {
            r = ry = attr.r;
            rycirc = r * circ;
        } else {
            r = attr.rx;
            ry = attr.ry;
            rycirc = ry * circ;
        }
        x = attr.cx;
        y = attr.cy;
        rcirc = r * circ;
        data = "M" + (x + r) + "," + y + " C" + [
            x + r,
            y + rycirc,
            x + rcirc,
            y + ry,
            x,
            y + ry,
            x - rcirc,
            y + ry,
            x - r,
            y + rycirc,
            x - r,
            y,
            x - r,
            y - rycirc,
            x - rcirc,
            y - ry,
            x,
            y - ry,
            x + rcirc,
            y - ry,
            x + r,
            y - rycirc,
            x + r,
            y
        ].join(",") + "z";
    } else if (type === "line") data = "M" + attr.x1 + "," + attr.y1 + " L" + attr.x2 + "," + attr.y2; //previously, we just converted to "Mx,y Lx,y" but Safari has bugs that cause that not to render properly when using a stroke-dasharray that's not fully visible! Using a cubic bezier fixes that issue.
    else if (type === "polyline" || type === "polygon") {
        points = (element.getAttribute("points") + "").match($eff81e413b8925be$var$_numbersExp) || [];
        x = points.shift();
        y = points.shift();
        data = "M" + x + "," + y + " L" + points.join(",");
        if (type === "polygon") data += "," + x + "," + y + "z";
    }
    path.setAttribute("d", $eff81e413b8925be$export$ced9e1d9be30c397(path._gsRawPath = $eff81e413b8925be$export$a9a6ab89eb1c2191(data)));
    if (swap && element.parentNode) {
        element.parentNode.insertBefore(path, element);
        element.parentNode.removeChild(element);
    }
    return path;
} //returns the rotation (in degrees) at a particular progress on a rawPath (the slope of the tangent)
function $eff81e413b8925be$export$d03e55696b4d7894(rawPath, progress) {
    var d = $eff81e413b8925be$var$getProgressData(rawPath, progress >= 1 ? 1 - 1e-9 : progress ? progress : 1e-9);
    return $eff81e413b8925be$var$getRotationAtBezierT(d.segment, d.i, d.t);
}
function $eff81e413b8925be$var$getRotationAtBezierT(segment, i, t) {
    var a = segment[i], b = segment[i + 2], c = segment[i + 4], x;
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    x = b + (c + (segment[i + 6] - c) * t - b) * t - a;
    a = segment[i + 1];
    b = segment[i + 3];
    c = segment[i + 5];
    a += (b - a) * t;
    b += (c - b) * t;
    a += (b - a) * t;
    return $eff81e413b8925be$var$_round($eff81e413b8925be$var$_atan2(b + (c + (segment[i + 7] - c) * t - b) * t - a, x) * $eff81e413b8925be$var$_RAD2DEG);
}
function $eff81e413b8925be$export$510a529ffd67482a(rawPath, start, end) {
    end = $eff81e413b8925be$var$_isUndefined(end) ? 1 : $eff81e413b8925be$var$_roundPrecise(end) || 0; // we must round to avoid issues like 4.15 / 8 = 0.8300000000000001 instead of 0.83 or 2.8 / 5 = 0.5599999999999999 instead of 0.56 and if someone is doing a loop like start: 2.8 / 0.5, end: 2.8 / 0.5 + 1.
    start = $eff81e413b8925be$var$_roundPrecise(start) || 0;
    var loops = Math.max(0, ~~($eff81e413b8925be$var$_abs(end - start) - 1e-8)), path = $eff81e413b8925be$export$e358367bf79edde2(rawPath);
    if (start > end) {
        start = 1 - start;
        end = 1 - end;
        $eff81e413b8925be$var$_reverseRawPath(path);
        path.totalLength = 0;
    }
    if (start < 0 || end < 0) {
        var offset = Math.abs(~~Math.min(start, end)) + 1;
        start += offset;
        end += offset;
    }
    path.totalLength || $eff81e413b8925be$export$cd44c6d3aa5b1098(path);
    var wrap = end > 1, s = $eff81e413b8925be$var$getProgressData(path, start, $eff81e413b8925be$var$_temp, true), e = $eff81e413b8925be$var$getProgressData(path, end, $eff81e413b8925be$var$_temp2), eSeg = e.segment, sSeg = s.segment, eSegIndex = e.segIndex, sSegIndex = s.segIndex, ei = e.i, si = s.i, sameSegment = sSegIndex === eSegIndex, sameBezier = ei === si && sameSegment, wrapsBehind, sShift, eShift, i, copy, totalSegments, l, j;
    if (wrap || loops) {
        wrapsBehind = eSegIndex < sSegIndex || sameSegment && ei < si || sameBezier && e.t < s.t;
        if ($eff81e413b8925be$var$_splitSegment(path, sSegIndex, si, s.t)) {
            sSegIndex++;
            if (!wrapsBehind) {
                eSegIndex++;
                if (sameBezier) {
                    e.t = (e.t - s.t) / (1 - s.t);
                    ei = 0;
                } else if (sameSegment) ei -= si;
            }
        }
        if (Math.abs(1 - (end - start)) < 1e-5) eSegIndex = sSegIndex - 1;
        else if (!e.t && eSegIndex) eSegIndex--;
        else if ($eff81e413b8925be$var$_splitSegment(path, eSegIndex, ei, e.t) && wrapsBehind) sSegIndex++;
        if (s.t === 1) sSegIndex = (sSegIndex + 1) % path.length;
        copy = [];
        totalSegments = path.length;
        l = 1 + totalSegments * loops;
        j = sSegIndex;
        l += (totalSegments - sSegIndex + eSegIndex) % totalSegments;
        for(i = 0; i < l; i++)$eff81e413b8925be$var$_appendOrMerge(copy, path[j++ % totalSegments]);
        path = copy;
    } else {
        eShift = e.t === 1 ? 6 : $eff81e413b8925be$export$bd9f14de8998b2c6(eSeg, ei, e.t);
        if (start !== end) {
            sShift = $eff81e413b8925be$export$bd9f14de8998b2c6(sSeg, si, sameBezier ? s.t / e.t : s.t);
            sameSegment && (eShift += sShift);
            eSeg.splice(ei + eShift + 2);
            (sShift || si) && sSeg.splice(0, si + sShift);
            i = path.length;
            while(i--)//chop off any extra segments
            (i < sSegIndex || i > eSegIndex) && path.splice(i, 1);
        } else {
            eSeg.angle = $eff81e413b8925be$var$getRotationAtBezierT(eSeg, ei + eShift, 0); //record the value before we chop because it'll be impossible to determine the angle after its length is 0!
            ei += eShift;
            s = eSeg[ei];
            e = eSeg[ei + 1];
            eSeg.length = eSeg.totalLength = 0;
            eSeg.totalPoints = path.totalPoints = 8;
            eSeg.push(s, e, s, e, s, e, s, e);
        }
    }
    path.totalLength = 0;
    return path;
} //measures a Segment according to its resolution (so if segment.resolution is 6, for example, it'll take 6 samples equally across each Bezier) and create/populate a "samples" Array that has the length up to each of those sample points (always increasing from the start) as well as a "lookup" array that's broken up according to the smallest distance between 2 samples. This gives us a very fast way of looking up a progress position rather than looping through all the points/Beziers. You can optionally have it only measure a subset, starting at startIndex and going for a specific number of beziers (remember, there are 3 x/y pairs each, for a total of 6 elements for each Bezier). It will also populate a "totalLength" property, but that's not generally super accurate because by default it'll only take 6 samples per Bezier. But for performance reasons, it's perfectly adequate for measuring progress values along the path. If you need a more accurate totalLength, either increase the resolution or use the more advanced bezierToPoints() method which keeps adding points until they don't deviate by more than a certain precision value.
function $eff81e413b8925be$var$measureSegment(segment, startIndex, bezierQty) {
    startIndex = startIndex || 0;
    if (!segment.samples) {
        segment.samples = [];
        segment.lookup = [];
    }
    var resolution = ~~segment.resolution || 12, inc = 1 / resolution, endIndex = bezierQty ? startIndex + bezierQty * 6 + 1 : segment.length, x1 = segment[startIndex], y1 = segment[startIndex + 1], samplesIndex = startIndex ? startIndex / 6 * resolution : 0, samples = segment.samples, lookup = segment.lookup, min = (startIndex ? segment.minLength : $eff81e413b8925be$var$_largeNum) || $eff81e413b8925be$var$_largeNum, prevLength = samples[samplesIndex + bezierQty * resolution - 1], length = startIndex ? samples[samplesIndex - 1] : 0, i, j, x4, x3, x2, xd, xd1, y4, y3, y2, yd, yd1, inv, t, lengthIndex, l, segLength;
    samples.length = lookup.length = 0;
    for(j = startIndex + 2; j < endIndex; j += 6){
        x4 = segment[j + 4] - x1;
        x3 = segment[j + 2] - x1;
        x2 = segment[j] - x1;
        y4 = segment[j + 5] - y1;
        y3 = segment[j + 3] - y1;
        y2 = segment[j + 1] - y1;
        xd = xd1 = yd = yd1 = 0;
        if ($eff81e413b8925be$var$_abs(x4) < .01 && $eff81e413b8925be$var$_abs(y4) < .01 && $eff81e413b8925be$var$_abs(x2) + $eff81e413b8925be$var$_abs(y2) < .01) //dump points that are sufficiently close (basically right on top of each other, making a bezier super tiny or 0 length)
        {
            if (segment.length > 8) {
                segment.splice(j, 6);
                j -= 6;
                endIndex -= 6;
            }
        } else for(i = 1; i <= resolution; i++){
            t = inc * i;
            inv = 1 - t;
            xd = xd1 - (xd1 = (t * t * x4 + 3 * inv * (t * x3 + inv * x2)) * t);
            yd = yd1 - (yd1 = (t * t * y4 + 3 * inv * (t * y3 + inv * y2)) * t);
            l = $eff81e413b8925be$var$_sqrt(yd * yd + xd * xd);
            if (l < min) min = l;
            length += l;
            samples[samplesIndex++] = length;
        }
        x1 += x4;
        y1 += y4;
    }
    if (prevLength) {
        prevLength -= length;
        for(; samplesIndex < samples.length; samplesIndex++)samples[samplesIndex] += prevLength;
    }
    if (samples.length && min) {
        segment.totalLength = segLength = samples[samples.length - 1] || 0;
        segment.minLength = min;
        if (segLength / min < 9999) {
            // if the lookup would require too many values (memory problem), we skip this and instead we use a loop to lookup values directly in the samples Array
            l = lengthIndex = 0;
            for(i = 0; i < segLength; i += min)lookup[l++] = samples[lengthIndex] < i ? ++lengthIndex : lengthIndex;
        }
    } else segment.totalLength = samples[0] = 0;
    return startIndex ? length - samples[startIndex / 2 - 1] : length;
}
function $eff81e413b8925be$export$cd44c6d3aa5b1098(rawPath, resolution) {
    var pathLength, points, i;
    for(i = pathLength = points = 0; i < rawPath.length; i++){
        rawPath[i].resolution = ~~resolution || 12; //steps per Bezier curve (anchor, 2 control points, to anchor)
        points += rawPath[i].length;
        pathLength += $eff81e413b8925be$var$measureSegment(rawPath[i]);
    }
    rawPath.totalPoints = points;
    rawPath.totalLength = pathLength;
    return rawPath;
} //divide segment[i] at position t (value between 0 and 1, progress along that particular cubic bezier segment that starts at segment[i]). Returns how many elements were spliced into the segment array (either 0 or 6)
function $eff81e413b8925be$export$bd9f14de8998b2c6(segment, i, t) {
    if (t <= 0 || t >= 1) return 0;
    var ax = segment[i], ay = segment[i + 1], cp1x = segment[i + 2], cp1y = segment[i + 3], cp2x = segment[i + 4], cp2y = segment[i + 5], bx = segment[i + 6], by = segment[i + 7], x1a = ax + (cp1x - ax) * t, x2 = cp1x + (cp2x - cp1x) * t, y1a = ay + (cp1y - ay) * t, y2 = cp1y + (cp2y - cp1y) * t, x1 = x1a + (x2 - x1a) * t, y1 = y1a + (y2 - y1a) * t, x2a = cp2x + (bx - cp2x) * t, y2a = cp2y + (by - cp2y) * t;
    x2 += (x2a - x2) * t;
    y2 += (y2a - y2) * t;
    segment.splice(i + 2, 4, $eff81e413b8925be$var$_round(x1a), $eff81e413b8925be$var$_round(y1a), $eff81e413b8925be$var$_round(x1), $eff81e413b8925be$var$_round(y1), $eff81e413b8925be$var$_round(x1 + (x2 - x1) * t), $eff81e413b8925be$var$_round(y1 + (y2 - y1) * t), $eff81e413b8925be$var$_round(x2), $eff81e413b8925be$var$_round(y2), $eff81e413b8925be$var$_round(x2a), $eff81e413b8925be$var$_round(y2a));
    segment.samples && segment.samples.splice(i / 6 * segment.resolution | 0, 0, 0, 0, 0, 0, 0, 0);
    return 6;
} // returns an object {path, segment, segIndex, i, t}
function $eff81e413b8925be$var$getProgressData(rawPath, progress, decoratee, pushToNextIfAtEnd) {
    decoratee = decoratee || {};
    rawPath.totalLength || $eff81e413b8925be$export$cd44c6d3aa5b1098(rawPath);
    if (progress < 0 || progress > 1) progress = $eff81e413b8925be$var$_wrapProgress(progress);
    var segIndex = 0, segment = rawPath[0], samples, resolution, length, min, max, i, t;
    if (!progress) {
        t = i = segIndex = 0;
        segment = rawPath[0];
    } else if (progress === 1) {
        t = 1;
        segIndex = rawPath.length - 1;
        segment = rawPath[segIndex];
        i = segment.length - 8;
    } else {
        if (rawPath.length > 1) {
            //speed optimization: most of the time, there's only one segment so skip the recursion.
            length = rawPath.totalLength * progress;
            max = i = 0;
            while((max += rawPath[i++].totalLength) < length)segIndex = i;
            segment = rawPath[segIndex];
            min = max - segment.totalLength;
            progress = (length - min) / (max - min) || 0;
        }
        samples = segment.samples;
        resolution = segment.resolution; //how many samples per cubic bezier chunk
        length = segment.totalLength * progress;
        i = segment.lookup.length ? segment.lookup[~~(length / segment.minLength)] || 0 : $eff81e413b8925be$var$_getSampleIndex(samples, length, progress);
        min = i ? samples[i - 1] : 0;
        max = samples[i];
        if (max < length) {
            min = max;
            max = samples[++i];
        }
        t = 1 / resolution * ((length - min) / (max - min) + i % resolution);
        i = ~~(i / resolution) * 6;
        if (pushToNextIfAtEnd && t === 1) {
            if (i + 6 < segment.length) {
                i += 6;
                t = 0;
            } else if (segIndex + 1 < rawPath.length) {
                i = t = 0;
                segment = rawPath[++segIndex];
            }
        }
    }
    decoratee.t = t;
    decoratee.i = i;
    decoratee.path = rawPath;
    decoratee.segment = segment;
    decoratee.segIndex = segIndex;
    return decoratee;
}
function $eff81e413b8925be$export$5fcb25b7d1608b70(rawPath, progress, includeAngle, point) {
    var segment = rawPath[0], result = point || {}, samples, resolution, length, min, max, i, t, a, inv;
    if (progress < 0 || progress > 1) progress = $eff81e413b8925be$var$_wrapProgress(progress);
    segment.lookup || $eff81e413b8925be$export$cd44c6d3aa5b1098(rawPath);
    if (rawPath.length > 1) {
        //speed optimization: most of the time, there's only one segment so skip the recursion.
        length = rawPath.totalLength * progress;
        max = i = 0;
        while((max += rawPath[i++].totalLength) < length)segment = rawPath[i];
        min = max - segment.totalLength;
        progress = (length - min) / (max - min) || 0;
    }
    samples = segment.samples;
    resolution = segment.resolution;
    length = segment.totalLength * progress;
    i = segment.lookup.length ? segment.lookup[progress < 1 ? ~~(length / segment.minLength) : segment.lookup.length - 1] || 0 : $eff81e413b8925be$var$_getSampleIndex(samples, length, progress);
    min = i ? samples[i - 1] : 0;
    max = samples[i];
    if (max < length) {
        min = max;
        max = samples[++i];
    }
    t = 1 / resolution * ((length - min) / (max - min) + i % resolution) || 0;
    inv = 1 - t;
    i = ~~(i / resolution) * 6;
    a = segment[i];
    result.x = $eff81e413b8925be$var$_round((t * t * (segment[i + 6] - a) + 3 * inv * (t * (segment[i + 4] - a) + inv * (segment[i + 2] - a))) * t + a);
    result.y = $eff81e413b8925be$var$_round((t * t * (segment[i + 7] - (a = segment[i + 1])) + 3 * inv * (t * (segment[i + 5] - a) + inv * (segment[i + 3] - a))) * t + a);
    if (includeAngle) result.angle = segment.totalLength ? $eff81e413b8925be$var$getRotationAtBezierT(segment, i, t >= 1 ? 1 - 1e-9 : t ? t : 1e-9) : segment.angle || 0;
    return result;
} //applies a matrix transform to RawPath (or a segment in a RawPath) and returns whatever was passed in (it transforms the values in the array(s), not a copy).
function $eff81e413b8925be$export$9210b538875bfe33(rawPath, a, b, c, d, tx, ty) {
    var j = rawPath.length, segment, l, i, x, y;
    while(--j > -1){
        segment = rawPath[j];
        l = segment.length;
        for(i = 0; i < l; i += 2){
            x = segment[i];
            y = segment[i + 1];
            segment[i] = x * a + y * c + tx;
            segment[i + 1] = x * b + y * d + ty;
        }
    }
    rawPath._dirty = 1;
    return rawPath;
} // translates SVG arc data into a segment (cubic beziers). Angle is in degrees.
function $eff81e413b8925be$var$arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
    if (lastX === x && lastY === y) return;
    rx = $eff81e413b8925be$var$_abs(rx);
    ry = $eff81e413b8925be$var$_abs(ry);
    var angleRad = angle % 360 * $eff81e413b8925be$var$_DEG2RAD, cosAngle = $eff81e413b8925be$var$_cos(angleRad), sinAngle = $eff81e413b8925be$var$_sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x) / 2, dy2 = (lastY - y) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
    if (radiiCheck > 1) {
        rx = $eff81e413b8925be$var$_sqrt(radiiCheck) * rx;
        ry = $eff81e413b8925be$var$_sqrt(radiiCheck) * ry;
    }
    var rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
    if (sq < 0) sq = 0;
    var coef = (largeArcFlag === sweepFlag ? -1 : 1) * $eff81e413b8925be$var$_sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x) / 2, sy2 = (lastY + y) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / $eff81e413b8925be$var$_sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / $eff81e413b8925be$var$_sqrt(temp * (vx * vx + vy * vy)));
    isNaN(angleExtent) && (angleExtent = PI); //rare edge case. Math.cos(-1) is NaN.
    if (!sweepFlag && angleExtent > 0) angleExtent -= TWOPI;
    else if (sweepFlag && angleExtent < 0) angleExtent += TWOPI;
    angleStart %= TWOPI;
    angleExtent %= TWOPI;
    var segments = Math.ceil($eff81e413b8925be$var$_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * $eff81e413b8925be$var$_sin(angleIncrement / 2) / (1 + $eff81e413b8925be$var$_cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i;
    for(i = 0; i < segments; i++){
        angle = angleStart + i * angleIncrement;
        x1 = $eff81e413b8925be$var$_cos(angle);
        y1 = $eff81e413b8925be$var$_sin(angle);
        ux = $eff81e413b8925be$var$_cos(angle += angleIncrement);
        uy = $eff81e413b8925be$var$_sin(angle);
        rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
    } //now transform according to the actual size of the ellipse/arc (the beziers were noramlized, between 0 and 1 on a circle).
    for(i = 0; i < rawPath.length; i += 2){
        x1 = rawPath[i];
        y1 = rawPath[i + 1];
        rawPath[i] = x1 * ma + y1 * mc + cx;
        rawPath[i + 1] = x1 * mb + y1 * md + cy;
    }
    rawPath[i - 2] = x; //always set the end to exactly where it's supposed to be
    rawPath[i - 1] = y;
    return rawPath;
} //Spits back a RawPath with absolute coordinates. Each segment starts with a "moveTo" command (x coordinate, then y) and then 2 control points (x, y, x, y), then anchor. The goal is to minimize memory and maximize speed.
function $eff81e413b8925be$export$a9a6ab89eb1c2191(d) {
    var a = (d + "").replace($eff81e413b8925be$var$_scientific, function(m) {
        var n = +m;
        return n < 0.0001 && n > -0.0001 ? 0 : n;
    }).match($eff81e413b8925be$var$_svgPathExp) || [], //some authoring programs spit out very small numbers in scientific notation like "1e-5", so make sure we round that down to 0 first.
    path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a.length, points = 0, errorMessage = "ERROR: malformed path: " + d, i, j, x, y, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function line(sx, sy, ex, ey) {
        difX = (ex - sx) / 3;
        difY = (ey - sy) / 3;
        segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
    };
    if (!d || !isNaN(a[0]) || isNaN(a[1])) {
        console.log(errorMessage);
        return path;
    }
    for(i = 0; i < elements; i++){
        prevCommand = command;
        if (isNaN(a[i])) {
            command = a[i].toUpperCase();
            isRelative = command !== a[i]; //lower case means relative
        } else //commands like "C" can be strung together without any new command characters between.
        i--;
        x = +a[i + 1];
        y = +a[i + 2];
        if (isRelative) {
            x += relativeX;
            y += relativeY;
        }
        if (!i) {
            startX = x;
            startY = y;
        } // "M" (move)
        if (command === "M") {
            if (segment) {
                if (segment.length < 8) //if the path data was funky and just had a M with no actual drawing anywhere, skip it.
                path.length -= 1;
                else points += segment.length;
            }
            relativeX = startX = x;
            relativeY = startY = y;
            segment = [
                x,
                y
            ];
            path.push(segment);
            i += 2;
            command = "L"; //an "M" with more than 2 values gets interpreted as "lineTo" commands ("L").
        // "C" (cubic bezier)
        } else if (command === "C") {
            if (!segment) segment = [
                0,
                0
            ];
            if (!isRelative) relativeX = relativeY = 0;
             //note: "*1" is just a fast/short way to cast the value as a Number. WAAAY faster in Chrome, slightly slower in Firefox.
            segment.push(x, y, relativeX + a[i + 3] * 1, relativeY + a[i + 4] * 1, relativeX += a[i + 5] * 1, relativeY += a[i + 6] * 1);
            i += 6; // "S" (continuation of cubic bezier)
        } else if (command === "S") {
            difX = relativeX;
            difY = relativeY;
            if (prevCommand === "C" || prevCommand === "S") {
                difX += relativeX - segment[segment.length - 4];
                difY += relativeY - segment[segment.length - 3];
            }
            if (!isRelative) relativeX = relativeY = 0;
            segment.push(difX, difY, x, y, relativeX += a[i + 3] * 1, relativeY += a[i + 4] * 1);
            i += 4; // "Q" (quadratic bezier)
        } else if (command === "Q") {
            difX = relativeX + (x - relativeX) * twoThirds;
            difY = relativeY + (y - relativeY) * twoThirds;
            if (!isRelative) relativeX = relativeY = 0;
            relativeX += a[i + 3] * 1;
            relativeY += a[i + 4] * 1;
            segment.push(difX, difY, relativeX + (x - relativeX) * twoThirds, relativeY + (y - relativeY) * twoThirds, relativeX, relativeY);
            i += 4; // "T" (continuation of quadratic bezier)
        } else if (command === "T") {
            difX = relativeX - segment[segment.length - 4];
            difY = relativeY - segment[segment.length - 3];
            segment.push(relativeX + difX, relativeY + difY, x + (relativeX + difX * 1.5 - x) * twoThirds, y + (relativeY + difY * 1.5 - y) * twoThirds, relativeX = x, relativeY = y);
            i += 2; // "H" (horizontal line)
        } else if (command === "H") {
            line(relativeX, relativeY, relativeX = x, relativeY);
            i += 1; // "V" (vertical line)
        } else if (command === "V") {
            //adjust values because the first (and only one) isn't x in this case, it's y.
            line(relativeX, relativeY, relativeX, relativeY = x + (isRelative ? relativeY - relativeX : 0));
            i += 1; // "L" (line) or "Z" (close)
        } else if (command === "L" || command === "Z") {
            if (command === "Z") {
                x = startX;
                y = startY;
                segment.closed = true;
            }
            if (command === "L" || $eff81e413b8925be$var$_abs(relativeX - x) > 0.5 || $eff81e413b8925be$var$_abs(relativeY - y) > 0.5) {
                line(relativeX, relativeY, x, y);
                if (command === "L") i += 2;
            }
            relativeX = x;
            relativeY = y; // "A" (arc)
        } else if (command === "A") {
            flag1 = a[i + 4];
            flag2 = a[i + 5];
            difX = a[i + 6];
            difY = a[i + 7];
            j = 7;
            if (flag1.length > 1) {
                // for cases when the flags are merged, like "a8 8 0 018 8" (the 0 and 1 flags are WITH the x value of 8, but it could also be "a8 8 0 01-8 8" so it may include x or not)
                if (flag1.length < 3) {
                    difY = difX;
                    difX = flag2;
                    j--;
                } else {
                    difY = flag2;
                    difX = flag1.substr(2);
                    j -= 2;
                }
                flag2 = flag1.charAt(1);
                flag1 = flag1.charAt(0);
            }
            beziers = $eff81e413b8925be$var$arcToSegment(relativeX, relativeY, +a[i + 1], +a[i + 2], +a[i + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
            i += j;
            if (beziers) for(j = 0; j < beziers.length; j++)segment.push(beziers[j]);
            relativeX = segment[segment.length - 2];
            relativeY = segment[segment.length - 1];
        } else console.log(errorMessage);
    }
    i = segment.length;
    if (i < 6) {
        //in case there's odd SVG like a M0,0 command at the very end.
        path.pop();
        i = 0;
    } else if (segment[0] === segment[i - 2] && segment[1] === segment[i - 1]) segment.closed = true;
    path.totalPoints = points + i;
    return path;
} //populates the points array in alternating x/y values (like [x, y, x, y...] instead of individual point objects [{x, y}, {x, y}...] to conserve memory and stay in line with how we're handling segment arrays
function $eff81e413b8925be$export$f86e11e84068dc85(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = $eff81e413b8925be$var$_abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = $eff81e413b8925be$var$_abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            x1,
            y1,
            x4,
            y4
        ];
        index = 2;
    }
    points.splice(index || points.length - 2, 0, x1234, y1234);
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        $eff81e413b8925be$export$f86e11e84068dc85(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        $eff81e413b8925be$export$f86e11e84068dc85(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 2 + (points.length - length));
    }
    return points;
}
function $eff81e413b8925be$export$e3b964ae0940782f(points, curviness) {
    if (curviness === void 0) curviness = 1;
    var x = points[0], y = 0, segment = [
        x,
        y
    ], i = 2;
    for(; i < points.length; i += 2)segment.push(x, y, points[i], y = (points[i] - x) * curviness / 2, x = points[i], -y);
    return segment;
} //points is an array of x/y points, like [x, y, x, y, x, y]
function $eff81e413b8925be$export$ae6dd21671b80694(points, curviness) {
    //points = simplifyPoints(points, tolerance);
    $eff81e413b8925be$var$_abs(points[0] - points[2]) < 1e-4 && $eff81e413b8925be$var$_abs(points[1] - points[3]) < 1e-4 && (points = points.slice(2)); // if the first two points are super close, dump the first one.
    var l = points.length - 2, x = +points[0], y = +points[1], nextX = +points[2], nextY = +points[3], segment = [
        x,
        y,
        x,
        y
    ], dx2 = nextX - x, dy2 = nextY - y, closed = Math.abs(points[l] - x) < 0.001 && Math.abs(points[l + 1] - y) < 0.001, prevX, prevY, i, dx1, dy1, r1, r2, r3, tl, mx1, mx2, mxm, my1, my2, mym;
    if (closed) {
        // if the start and end points are basically on top of each other, close the segment by adding the 2nd point to the end, and the 2nd-to-last point to the beginning (we'll remove them at the end, but this allows the curvature to look perfect)
        points.push(nextX, nextY);
        nextX = x;
        nextY = y;
        x = points[l - 2];
        y = points[l - 1];
        points.unshift(x, y);
        l += 4;
    }
    curviness = curviness || curviness === 0 ? +curviness : 1;
    for(i = 2; i < l; i += 2){
        prevX = x;
        prevY = y;
        x = nextX;
        y = nextY;
        nextX = +points[i + 2];
        nextY = +points[i + 3];
        if (x === nextX && y === nextY) continue;
        dx1 = dx2;
        dy1 = dy2;
        dx2 = nextX - x;
        dy2 = nextY - y;
        r1 = $eff81e413b8925be$var$_sqrt(dx1 * dx1 + dy1 * dy1); // r1, r2, and r3 correlate x and y (and z in the future). Basically 2D or 3D hypotenuse
        r2 = $eff81e413b8925be$var$_sqrt(dx2 * dx2 + dy2 * dy2);
        r3 = $eff81e413b8925be$var$_sqrt(Math.pow(dx2 / r2 + dx1 / r1, 2) + Math.pow(dy2 / r2 + dy1 / r1, 2));
        tl = (r1 + r2) * curviness * 0.25 / r3;
        mx1 = x - (x - prevX) * (r1 ? tl / r1 : 0);
        mx2 = x + (nextX - x) * (r2 ? tl / r2 : 0);
        mxm = x - (mx1 + ((mx2 - mx1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        my1 = y - (y - prevY) * (r1 ? tl / r1 : 0);
        my2 = y + (nextY - y) * (r2 ? tl / r2 : 0);
        mym = y - (my1 + ((my2 - my1) * (r1 * 3 / (r1 + r2) + 0.5) / 4 || 0));
        if (x !== prevX || y !== prevY) segment.push($eff81e413b8925be$var$_round(mx1 + mxm), $eff81e413b8925be$var$_round(my1 + mym), $eff81e413b8925be$var$_round(x), $eff81e413b8925be$var$_round(y), $eff81e413b8925be$var$_round(mx2 + mxm), $eff81e413b8925be$var$_round(my2 + mym));
    }
    x !== nextX || y !== nextY || segment.length < 4 ? segment.push($eff81e413b8925be$var$_round(nextX), $eff81e413b8925be$var$_round(nextY), $eff81e413b8925be$var$_round(nextX), $eff81e413b8925be$var$_round(nextY)) : segment.length -= 2;
    if (segment.length === 2) // only one point!
    segment.push(x, y, x, y, x, y);
    else if (closed) {
        segment.splice(0, 6);
        segment.length = segment.length - 6;
    }
    return segment;
} //returns the squared distance between an x/y coordinate and a segment between x1/y1 and x2/y2
function $eff81e413b8925be$var$pointToSegDist(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1, dy = y2 - y1, t;
    if (dx || dy) {
        t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return Math.pow(x - x1, 2) + Math.pow(y - y1, 2);
}
function $eff81e413b8925be$var$simplifyStep(points, first, last, tolerance, simplified) {
    var maxSqDist = tolerance, firstX = points[first], firstY = points[first + 1], lastX = points[last], lastY = points[last + 1], index, i, d;
    for(i = first + 2; i < last; i += 2){
        d = $eff81e413b8925be$var$pointToSegDist(points[i], points[i + 1], firstX, firstY, lastX, lastY);
        if (d > maxSqDist) {
            index = i;
            maxSqDist = d;
        }
    }
    if (maxSqDist > tolerance) {
        index - first > 2 && $eff81e413b8925be$var$simplifyStep(points, first, index, tolerance, simplified);
        simplified.push(points[index], points[index + 1]);
        last - index > 2 && $eff81e413b8925be$var$simplifyStep(points, index, last, tolerance, simplified);
    }
} //points is an array of x/y values like [x, y, x, y, x, y]
function $eff81e413b8925be$export$59627e036caae5e0(points, tolerance) {
    var prevX = parseFloat(points[0]), prevY = parseFloat(points[1]), temp = [
        prevX,
        prevY
    ], l = points.length - 2, i, x, y, dx, dy, result, last;
    tolerance = Math.pow(tolerance || 1, 2);
    for(i = 2; i < l; i += 2){
        x = parseFloat(points[i]);
        y = parseFloat(points[i + 1]);
        dx = prevX - x;
        dy = prevY - y;
        if (dx * dx + dy * dy > tolerance) {
            temp.push(x, y);
            prevX = x;
            prevY = y;
        }
    }
    temp.push(parseFloat(points[l]), parseFloat(points[l + 1]));
    last = temp.length - 2;
    result = [
        temp[0],
        temp[1]
    ];
    $eff81e413b8925be$var$simplifyStep(temp, 0, last, tolerance, result);
    result.push(temp[last], temp[last + 1]);
    return result;
}
function $eff81e413b8925be$var$getClosestProgressOnBezier(iterations, px, py, start, end, slices, x0, y0, x1, y1, x2, y2, x3, y3) {
    var inc = (end - start) / slices, best = 0, t = start, x, y, d, dx, dy, inv;
    $eff81e413b8925be$var$_bestDistance = $eff81e413b8925be$var$_largeNum;
    while(t <= end){
        inv = 1 - t;
        x = inv * inv * inv * x0 + 3 * inv * inv * t * x1 + 3 * inv * t * t * x2 + t * t * t * x3;
        y = inv * inv * inv * y0 + 3 * inv * inv * t * y1 + 3 * inv * t * t * y2 + t * t * t * y3;
        dx = x - px;
        dy = y - py;
        d = dx * dx + dy * dy;
        if (d < $eff81e413b8925be$var$_bestDistance) {
            $eff81e413b8925be$var$_bestDistance = d;
            best = t;
        }
        t += inc;
    }
    return iterations > 1 ? $eff81e413b8925be$var$getClosestProgressOnBezier(iterations - 1, px, py, Math.max(best - inc, 0), Math.min(best + inc, 1), slices, x0, y0, x1, y1, x2, y2, x3, y3) : best;
}
function $eff81e413b8925be$export$c7551252c2f97fc2(rawPath, x, y, slices) {
    //returns an object with the closest j, i, and t (j is the segment index, i is the index of the point in that segment, and t is the time/progress along that bezier)
    var closest = {
        j: 0,
        i: 0,
        t: 0
    }, bestDistance = $eff81e413b8925be$var$_largeNum, i, j, t, segment;
    for(j = 0; j < rawPath.length; j++){
        segment = rawPath[j];
        for(i = 0; i < segment.length; i += 6){
            t = $eff81e413b8925be$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices || 20, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
            if (bestDistance > $eff81e413b8925be$var$_bestDistance) {
                bestDistance = $eff81e413b8925be$var$_bestDistance;
                closest.j = j;
                closest.i = i;
                closest.t = t;
            }
        }
    }
    return closest;
} //subdivide a Segment closest to a specific x,y coordinate
function $eff81e413b8925be$export$179b6e586855bec6(x, y, segment, slices, iterations) {
    var l = segment.length, bestDistance = $eff81e413b8925be$var$_largeNum, bestT = 0, bestSegmentIndex = 0, t, i;
    slices = slices || 20;
    iterations = iterations || 3;
    for(i = 0; i < l; i += 6){
        t = $eff81e413b8925be$var$getClosestProgressOnBezier(1, x, y, 0, 1, slices, segment[i], segment[i + 1], segment[i + 2], segment[i + 3], segment[i + 4], segment[i + 5], segment[i + 6], segment[i + 7]);
        if (bestDistance > $eff81e413b8925be$var$_bestDistance) {
            bestDistance = $eff81e413b8925be$var$_bestDistance;
            bestT = t;
            bestSegmentIndex = i;
        }
    }
    t = $eff81e413b8925be$var$getClosestProgressOnBezier(iterations, x, y, bestT - 0.05, bestT + 0.05, slices, segment[bestSegmentIndex], segment[bestSegmentIndex + 1], segment[bestSegmentIndex + 2], segment[bestSegmentIndex + 3], segment[bestSegmentIndex + 4], segment[bestSegmentIndex + 5], segment[bestSegmentIndex + 6], segment[bestSegmentIndex + 7]);
    $eff81e413b8925be$export$bd9f14de8998b2c6(segment, bestSegmentIndex, t);
    return bestSegmentIndex + 6;
}
function $eff81e413b8925be$export$ced9e1d9be30c397(rawPath) {
    if ($eff81e413b8925be$var$_isNumber(rawPath[0])) //in case a segment is passed in instead
    rawPath = [
        rawPath
    ];
    var result = "", l = rawPath.length, sl, s, i, segment;
    for(s = 0; s < l; s++){
        segment = rawPath[s];
        result += "M" + $eff81e413b8925be$var$_round(segment[0]) + "," + $eff81e413b8925be$var$_round(segment[1]) + " C";
        sl = segment.length;
        for(i = 2; i < sl; i++)result += $eff81e413b8925be$var$_round(segment[i++]) + "," + $eff81e413b8925be$var$_round(segment[i++]) + " " + $eff81e413b8925be$var$_round(segment[i++]) + "," + $eff81e413b8925be$var$_round(segment[i++]) + " " + $eff81e413b8925be$var$_round(segment[i++]) + "," + $eff81e413b8925be$var$_round(segment[i]) + " ";
        if (segment.closed) result += "z";
    }
    return result;
} /*
// takes a segment with coordinates [x, y, x, y, ...] and converts the control points into angles and lengths [x, y, angle, length, angle, length, x, y, angle, length, ...] so that it animates more cleanly and avoids odd breaks/kinks. For example, if you animate from 1 o'clock to 6 o'clock, it'd just go directly/linearly rather than around. So the length would be very short in the middle of the tween.
export function cpCoordsToAngles(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		x, y, i;
	for (i = 0; i < segment.length; i+=6) {
		x = segment[i+2] - segment[i];
		y = segment[i+3] - segment[i+1];
		result[i+2] = Math.atan2(y, x);
		result[i+3] = Math.sqrt(x * x + y * y);
		x = segment[i+6] - segment[i+4];
		y = segment[i+7] - segment[i+5];
		result[i+4] = Math.atan2(y, x);
		result[i+5] = Math.sqrt(x * x + y * y);
	}
	return result;
}

// takes a segment that was converted with cpCoordsToAngles() to have angles and lengths instead of coordinates for the control points, and converts it BACK into coordinates.
export function cpAnglesToCoords(segment, copy) {
	var result = copy ? segment.slice(0) : segment,
		length = segment.length,
		rnd = 1000,
		angle, l, i, j;
	for (i = 0; i < length; i+=6) {
		angle = segment[i+2];
		l = segment[i+3]; //length
		result[i+2] = (((segment[i] + Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+3] = (((segment[i+1] + Math.sin(angle) * l) * rnd) | 0) / rnd;
		angle = segment[i+4];
		l = segment[i+5]; //length
		result[i+4] = (((segment[i+6] - Math.cos(angle) * l) * rnd) | 0) / rnd;
		result[i+5] = (((segment[i+7] - Math.sin(angle) * l) * rnd) | 0) / rnd;
	}
	return result;
}

//adds an "isSmooth" array to each segment and populates it with a boolean value indicating whether or not it's smooth (the control points have basically the same slope). For any smooth control points, it converts the coordinates into angle (x, in radians) and length (y) and puts them into the same index value in a smoothData array.
export function populateSmoothData(rawPath) {
	let j = rawPath.length,
		smooth, segment, x, y, x2, y2, i, l, a, a2, isSmooth, smoothData;
	while (--j > -1) {
		segment = rawPath[j];
		isSmooth = segment.isSmooth = segment.isSmooth || [0, 0, 0, 0];
		smoothData = segment.smoothData = segment.smoothData || [0, 0, 0, 0];
		isSmooth.length = 4;
		l = segment.length - 2;
		for (i = 6; i < l; i += 6) {
			x = segment[i] - segment[i - 2];
			y = segment[i + 1] - segment[i - 1];
			x2 = segment[i + 2] - segment[i];
			y2 = segment[i + 3] - segment[i + 1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			smooth = (Math.abs(a - a2) < 0.09);
			if (smooth) {
				smoothData[i - 2] = a;
				smoothData[i + 2] = a2;
				smoothData[i - 1] = _sqrt(x * x + y * y);
				smoothData[i + 3] = _sqrt(x2 * x2 + y2 * y2);
			}
			isSmooth.push(smooth, smooth, 0, 0, smooth, smooth);
		}
		//if the first and last points are identical, check to see if there's a smooth transition. We must handle this a bit differently due to their positions in the array.
		if (segment[l] === segment[0] && segment[l+1] === segment[1]) {
			x = segment[0] - segment[l-2];
			y = segment[1] - segment[l-1];
			x2 = segment[2] - segment[0];
			y2 = segment[3] - segment[1];
			a = _atan2(y, x);
			a2 = _atan2(y2, x2);
			if (Math.abs(a - a2) < 0.09) {
				smoothData[l-2] = a;
				smoothData[2] = a2;
				smoothData[l-1] = _sqrt(x * x + y * y);
				smoothData[3] = _sqrt(x2 * x2 + y2 * y2);
				isSmooth[l-2] = isSmooth[l-1] = true; //don't change indexes 2 and 3 because we'll trigger everything from the END, and this will optimize file size a bit.
			}
		}
	}
	return rawPath;
}
export function pointToScreen(svgElement, point) {
	if (arguments.length < 2) { //by default, take the first set of coordinates in the path as the point
		let rawPath = getRawPath(svgElement);
		point = svgElement.ownerSVGElement.createSVGPoint();
		point.x = rawPath[0][0];
		point.y = rawPath[0][1];
	}
	return point.matrixTransform(svgElement.getScreenCTM());
}
// takes a <path> and normalizes all of its coordinates to values between 0 and 1
export function normalizePath(path) {
  path = gsap.utils.toArray(path);
  if (!path[0].hasAttribute("d")) {
    path = gsap.utils.toArray(path[0].children);
  }
  if (path.length > 1) {
    path.forEach(normalizePath);
    return path;
  }
  let _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
      _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig,
      d = path[0].getAttribute("d"),
      a = d.replace(_scientific, m => { let n = +m; return (n < 0.0001 && n > -0.0001) ? 0 : n; }).match(_svgPathExp),
      nums = a.filter(n => !isNaN(n)).map(n => +n),
      normalize = gsap.utils.normalize(Math.min(...nums), Math.max(...nums)),
      finals = a.map(val => isNaN(val) ? val : normalize(+val)),
      s = "",
      prevWasCommand;
  finals.forEach((value, i) => {
    let isCommand = isNaN(value)
    s += (isCommand && i ? " " : prevWasCommand || !i ? "" : ",") + value;
    prevWasCommand = isCommand;
  });
  path[0].setAttribute("d", s);
}
*/ 


var $d7bce274927d21cc$var$gsap, $d7bce274927d21cc$var$_coreInitted, $d7bce274927d21cc$var$_getGSAP = function _getGSAP() {
    return $d7bce274927d21cc$var$gsap || typeof window !== "undefined" && ($d7bce274927d21cc$var$gsap = window.gsap) && $d7bce274927d21cc$var$gsap.registerPlugin && $d7bce274927d21cc$var$gsap;
}, $d7bce274927d21cc$var$_initCore = function _initCore() {
    $d7bce274927d21cc$var$gsap = $d7bce274927d21cc$var$_getGSAP();
    if ($d7bce274927d21cc$var$gsap) {
        $d7bce274927d21cc$var$gsap.registerEase("_CE", $d7bce274927d21cc$export$94f46869cc67acd8.create);
        $d7bce274927d21cc$var$_coreInitted = 1;
    } else console.warn("Please gsap.registerPlugin(CustomEase)");
}, $d7bce274927d21cc$var$_bigNum = 1e20, $d7bce274927d21cc$var$_round = function _round(value) {
    return ~~(value * 1000 + (value < 0 ? -0.5 : .5)) / 1000;
}, $d7bce274927d21cc$var$_bonusValidated = 1, //<name>CustomEase</name>
$d7bce274927d21cc$var$_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$d7bce274927d21cc$var$_needsParsingExp = /[cLlsSaAhHvVtTqQ]/g, $d7bce274927d21cc$var$_findMinimum = function _findMinimum(values) {
    var l = values.length, min = $d7bce274927d21cc$var$_bigNum, i;
    for(i = 1; i < l; i += 6)+values[i] < min && (min = +values[i]);
    return min;
}, //takes all the points and translates/scales them so that the x starts at 0 and ends at 1.
$d7bce274927d21cc$var$_normalize = function _normalize(values, height, originY) {
    if (!originY && originY !== 0) originY = Math.max(+values[values.length - 1], +values[1]);
    var tx = +values[0] * -1, ty = -originY, l = values.length, sx = 1 / (+values[l - 2] + tx), sy = -height || (Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0]) ? $d7bce274927d21cc$var$_findMinimum(values) + ty : +values[l - 1] + ty), i;
    if (sy) //typically y ends at 1 (so that the end values are reached)
    sy = 1 / sy;
    else //in case the ease returns to its beginning value, scale everything proportionally
    sy = -sx;
    for(i = 0; i < l; i += 2){
        values[i] = (+values[i] + tx) * sx;
        values[i + 1] = (+values[i + 1] + ty) * sy;
    }
}, //note that this function returns point objects like {x, y} rather than working with segments which are arrays with alternating x, y values as in the similar function in paths.js
$d7bce274927d21cc$var$_bezierToPoints = function _bezierToPoints(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
    var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx), length;
    if (!points) {
        points = [
            {
                x: x1,
                y: y1
            },
            {
                x: x4,
                y: y4
            }
        ];
        index = 1;
    }
    points.splice(index || points.length - 1, 0, {
        x: x1234,
        y: y1234
    });
    if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        _bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        _bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
    }
    return points;
};
var $d7bce274927d21cc$export$94f46869cc67acd8 = /*#__PURE__*/ function() {
    function CustomEase(id, data, config) {
        $d7bce274927d21cc$var$_coreInitted || $d7bce274927d21cc$var$_initCore();
        this.id = id;
        $d7bce274927d21cc$var$_bonusValidated && this.setData(data, config);
    }
    var _proto = CustomEase.prototype;
    _proto.setData = function setData(data, config) {
        config = config || {};
        data = data || "0,0,1,1";
        var values = data.match($d7bce274927d21cc$var$_numExp), closest = 1, points = [], lookup = [], precision = config.precision || 1, fast = precision <= 1, l, a1, a2, i, inc, j, point, prevPoint, p;
        this.data = data;
        if ($d7bce274927d21cc$var$_needsParsingExp.test(data) || ~data.indexOf("M") && data.indexOf("C") < 0) values = (0, $eff81e413b8925be$export$a9a6ab89eb1c2191)(data)[0];
        l = values.length;
        if (l === 4) {
            values.unshift(0, 0);
            values.push(1, 1);
            l = 8;
        } else if ((l - 2) % 6) throw "Invalid CustomEase";
        if (+values[0] !== 0 || +values[l - 2] !== 1) $d7bce274927d21cc$var$_normalize(values, config.height, config.originY);
        this.segment = values;
        for(i = 2; i < l; i += 6){
            a1 = {
                x: +values[i - 2],
                y: +values[i - 1]
            };
            a2 = {
                x: +values[i + 4],
                y: +values[i + 5]
            };
            points.push(a1, a2);
            $d7bce274927d21cc$var$_bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), points, points.length - 1);
        }
        l = points.length;
        for(i = 0; i < l; i++){
            point = points[i];
            prevPoint = points[i - 1] || point;
            if ((point.x > prevPoint.x || prevPoint.y !== point.y && prevPoint.x === point.x || point === prevPoint) && point.x <= 1) {
                //if a point goes BACKWARD in time or is a duplicate, just drop it. Also it shouldn't go past 1 on the x axis, as could happen in a string like "M0,0 C0,0 0.12,0.68 0.18,0.788 0.195,0.845 0.308,1 0.32,1 0.403,1.005 0.398,1 0.5,1 0.602,1 0.816,1.005 0.9,1 0.91,1 0.948,0.69 0.962,0.615 1.003,0.376 1,0 1,0".
                prevPoint.cx = point.x - prevPoint.x; //change in x between this point and the next point (performance optimization)
                prevPoint.cy = point.y - prevPoint.y;
                prevPoint.n = point;
                prevPoint.nx = point.x; //next point's x value (performance optimization, making lookups faster in getRatio()). Remember, the lookup will always land on a spot where it's either this point or the very next one (never beyond that)
                if (fast && i > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i - 2].cy / points[i - 2].cx) > 2) //if there's a sudden change in direction, prioritize accuracy over speed. Like a bounce ease - you don't want to risk the sampling chunks landing on each side of the bounce anchor and having it clipped off.
                fast = 0;
                if (prevPoint.cx < closest) {
                    if (!prevPoint.cx) {
                        prevPoint.cx = 0.001; //avoids math problems in getRatio() (dividing by zero)
                        if (i === l - 1) {
                            //in case the final segment goes vertical RIGHT at the end, make sure we end at the end.
                            prevPoint.x -= 0.001;
                            closest = Math.min(closest, 0.001);
                            fast = 0;
                        }
                    } else closest = prevPoint.cx;
                }
            } else {
                points.splice(i--, 1);
                l--;
            }
        }
        l = 1 / closest + 1 | 0;
        inc = 1 / l;
        j = 0;
        point = points[0];
        if (fast) {
            for(i = 0; i < l; i++){
                //for fastest lookups, we just sample along the path at equal x (time) distance. Uses more memory and is slightly less accurate for anchors that don't land on the sampling points, but for the vast majority of eases it's excellent (and fast).
                p = i * inc;
                if (point.nx < p) point = points[++j];
                a1 = point.y + (p - point.x) / point.cx * point.cy;
                lookup[i] = {
                    x: p,
                    cx: inc,
                    y: a1,
                    cy: 0,
                    nx: 9
                };
                if (i) lookup[i - 1].cy = a1 - lookup[i - 1].y;
            }
            j = points[points.length - 1];
            lookup[l - 1].cy = j.y - a1;
            lookup[l - 1].cx = j.x - lookup[lookup.length - 1].x; //make sure it lands EXACTLY where it should. Otherwise, it might be something like 0.9999999999 instead of 1.
        } else {
            //this option is more accurate, ensuring that EVERY anchor is hit perfectly. Clipping across a bounce, for example, would never happen.
            for(i = 0; i < l; i++){
                //build a lookup table based on the smallest distance so that we can instantly find the appropriate point (well, it'll either be that point or the very next one). We'll look up based on the linear progress. So it's it's 0.5 and the lookup table has 100 elements, it'd be like lookup[Math.floor(0.5 * 100)]
                if (point.nx < i * inc) point = points[++j];
                lookup[i] = point;
            }
            if (j < points.length - 1) lookup[i - 1] = points[points.length - 2];
        } //this._calcEnd = (points[points.length-1].y !== 1 || points[0].y !== 0); //ensures that we don't run into floating point errors. As long as we're starting at 0 and ending at 1, tell GSAP to skip the final calculation and use 0/1 as the factor.
        this.ease = function(p) {
            var point = lookup[p * l | 0] || lookup[l - 1];
            if (point.nx < p) point = point.n;
            return point.y + (p - point.x) / point.cx * point.cy;
        };
        this.ease.custom = this;
        this.id && $d7bce274927d21cc$var$gsap && $d7bce274927d21cc$var$gsap.registerEase(this.id, this.ease);
        return this;
    };
    _proto.getSVGData = function getSVGData(config) {
        return CustomEase.getSVGData(this, config);
    };
    CustomEase.create = function create(id, data, config) {
        return new CustomEase(id, data, config).ease;
    };
    CustomEase.register = function register(core) {
        $d7bce274927d21cc$var$gsap = core;
        $d7bce274927d21cc$var$_initCore();
    };
    CustomEase.get = function get(id) {
        return $d7bce274927d21cc$var$gsap.parseEase(id);
    };
    CustomEase.getSVGData = function getSVGData(ease, config) {
        config = config || {};
        var width = config.width || 100, height = config.height || 100, x = config.x || 0, y = (config.y || 0) + height, e = $d7bce274927d21cc$var$gsap.utils.toArray(config.path)[0], a, slope, i, inc, tx, ty, precision, threshold, prevX, prevY;
        if (config.invert) {
            height = -height;
            y = 0;
        }
        if (typeof ease === "string") ease = $d7bce274927d21cc$var$gsap.parseEase(ease);
        if (ease.custom) ease = ease.custom;
        if (ease instanceof CustomEase) a = (0, $eff81e413b8925be$export$ced9e1d9be30c397)((0, $eff81e413b8925be$export$9210b538875bfe33)([
            ease.segment
        ], width, 0, 0, -height, x, y));
        else {
            a = [
                x,
                y
            ];
            precision = Math.max(5, (config.precision || 1) * 200);
            inc = 1 / precision;
            precision += 2;
            threshold = 5 / precision;
            prevX = $d7bce274927d21cc$var$_round(x + inc * width);
            prevY = $d7bce274927d21cc$var$_round(y + ease(inc) * -height);
            slope = (prevY - y) / (prevX - x);
            for(i = 2; i < precision; i++){
                tx = $d7bce274927d21cc$var$_round(x + i * inc * width);
                ty = $d7bce274927d21cc$var$_round(y + ease(i * inc) * -height);
                if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i === precision - 1) {
                    //only add points when the slope changes beyond the threshold
                    a.push(prevX, prevY);
                    slope = (ty - prevY) / (tx - prevX);
                }
                prevX = tx;
                prevY = ty;
            }
            a = "M" + a.join(",");
        }
        e && e.setAttribute("d", a);
        return a;
    };
    return CustomEase;
}();
$d7bce274927d21cc$export$94f46869cc67acd8.version = "3.13.0";
$d7bce274927d21cc$export$94f46869cc67acd8.headless = true;
$d7bce274927d21cc$var$_getGSAP() && $d7bce274927d21cc$var$gsap.registerPlugin($d7bce274927d21cc$export$94f46869cc67acd8);



class $2d35a4fb2c638628$export$2e2bcd8739ae039 {
    el = undefined;
    closed = false;
    constructor({ team: team, score: score, visitor: visitor }){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.team = team;
        this.score = score;
        this.visitor = visitor;
        console.log(this.team);
        this.flag = new (0, $05f6f981e2ce284a$export$2e2bcd8739ae039)(this.team, {
            big: true,
            visitor: visitor
        });
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($6ab0340c5ed2956f$exports)))();
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $627cf78ccdbb04e6$export$2e2bcd8739ae039)({
            visitor: this.visitor ? 'match-score-visitor' : '',
            name: this.team.slug,
            score: this.score
        }));
        this.el.querySelector('.match-flag').appendChild(this.flag.render());
        this.flagEl = this.el.querySelector('.match-flag');
        this.scoreEl = this.el.querySelector('.score');
        this.teamEl = this.el.querySelector('.team');
        this.flag.intro();
        this.addEvents();
        return this.el;
    }
    addEvents() {
        this.el.addEventListener('click', this.onClick);
    }
    onClick() {
        this.events.emit('click');
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go('/matches');
    }
    transitionIn() {
        let from = this.visitor ? '-10%' : '10%';
        this.introTL = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.introTL.add(this.flag.intro(2));
        this.introTL.to(this.scoreEl, {
            duration: 0.1,
            ease: 'power4.inOut',
            opacity: 1
        }, 0.4);
        this.introTL.fromTo(this.scoreEl, {
            x: from
        }, {
            duration: 0.5,
            ease: 'power4.inOut',
            x: '0'
        }, 0.4);
        this.introTL.to(this.teamEl, {
            duration: 0.1,
            ease: 'power4.inOut',
            opacity: 1
        }, 0.5);
        this.introTL.fromTo(this.teamEl, {
            x: from
        }, {
            duration: 0.5,
            ease: 'power4.inOut',
            x: '0'
        }, 0.5);
        return this.introTL;
    }
    transitionOut() {
        let easing = (0, $d7bce274927d21cc$export$94f46869cc67acd8).create('custom', 'M0,0 C0,0 0.075,0.619 0.2,0.8 0.245,0.866 0.57,0.966 0.612,0.988 0.649,1.007 1,1 1,1 ');
        let from = `${-(0, $2343afc8a06b7454$export$2e2bcd8739ae039).direction * 30}vh`;
        let from2 = `${-(0, $2343afc8a06b7454$export$2e2bcd8739ae039).direction * 22}vh`;
        let from3 = `${-(0, $2343afc8a06b7454$export$2e2bcd8739ae039).direction * 25}vh`;
        this.outroTL = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.outroTL.to(this.scoreEl, {
            duration: 2,
            ease: 'power4.inOut',
            y: from
        }, 0);
        this.outroTL.to(this.teamEl, {
            duration: 2,
            ease: 'power4.inOut',
            y: from2
        }, 0);
        this.outroTL.to(this.flagEl, {
            duration: 2,
            ease: 'power4.inOut',
            y: from3
        }, 0);
        // this.outroTL = gsap.timeline();
        // this.outroTL.to(this.scoreEl, { duration: 0, opacity: 0 }, 0);
        // this.outroTL.to(this.teamEl, { duration: 0, opacity: 0 }, 0);
        // this.outroTL.add(this.flag.outro());
        return this.outroTL;
    }
}








function $2e855fbec7fe5471$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cbutton class=\"arrow-button\"\u003E\u003Cdiv class=\"line\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"icon\"\u003E\u003Csvg viewBox=\"0 0 8 4\" fill=\"none\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\n\u003Cpath d=\"M8 0H0L4 4L8 0Z\" fill=\"white\"\u002F\u003E\n\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E\u003C\u002Fbutton\u003E";
    return pug_html;
}
var $2e855fbec7fe5471$export$2e2bcd8739ae039 = $2e855fbec7fe5471$var$template;


class $a830ce6d12a62d72$export$2e2bcd8739ae039 {
    el = undefined;
    toggle = false;
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.events = new (0, (/*@__PURE__*/$parcel$interopDefault($6ab0340c5ed2956f$exports)))();
    }
    intro() {
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.el.style.opacity = 1;
        this.tl.set(this.line, {
            y: '-100%'
        }, 0);
        this.tl.set(this.arrow, {
            y: -60
        }, 0);
        this.tl.to(this.line, {
            y: '0%',
            duration: 0.2,
            ease: 'expo.out'
        }, 0);
        this.tl.to(this.arrow, {
            y: 0,
            duration: 0.2,
            ease: 'expo.out'
        }, 0);
        this.tl.to(this.arrow, {
            opacity: 1,
            duration: 0.05,
            ease: 'expo.out'
        }, 0.15);
        this.tl.to(this.line, {
            y: '100%',
            duration: 0.25,
            ease: 'expo.in'
        }, 0.15);
    }
    outro() {
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.el, {
            opacity: 0,
            duration: 0.1,
            ease: 'expo.out'
        });
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $2e855fbec7fe5471$export$2e2bcd8739ae039)());
        this.addEvents();
        this.line = this.el.querySelector('.line span');
        this.arrow = this.el.querySelector('.icon');
        return this.el;
    }
    addEvents() {
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).on('url:change', ()=>{
            this.toggle = false;
            this.el.classList.remove('fill');
        });
        this.el.addEventListener('click', this.onClick);
    }
    onClick() {
        if (this.toggle) {
            this.toggle = false;
            this.el.classList.remove('fill');
        } else {
            this.el.classList.add('fill');
            this.toggle = true;
        }
        this.events.emit('click');
    }
}



function $084bf96ab95880f0$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Csection class=\"match-section\"\u003E\u003Cdiv class=\"home\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"visitor\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"menu-label\"\u003E\u003Cdiv class=\"player\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"minute\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"scroll\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";
    return pug_html;
}
var $084bf96ab95880f0$export$2e2bcd8739ae039 = $084bf96ab95880f0$var$template;



const $9741e9da76fb5412$var$isTouchEventsSupported = (0, (/*@__PURE__*/$parcel$interopDefault($27b84c32f3d45dfc$exports))).isTouchEventsSupported();
let $9741e9da76fb5412$var$firstAccess = true;
class $9741e9da76fb5412$export$2e2bcd8739ae039 {
    scrolled = false;
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
    }
    render() {
        this.homeScore = new (0, $2d35a4fb2c638628$export$2e2bcd8739ae039)({
            team: this.matchDO.teamDOs[0],
            score: this.matchDO.result?.regular[0] || 0
        });
        this.visitorScore = new (0, $2d35a4fb2c638628$export$2e2bcd8739ae039)({
            team: this.matchDO.teamDOs[1],
            score: this.matchDO.result?.regular[1] || 0,
            visitor: true
        });
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $084bf96ab95880f0$export$2e2bcd8739ae039)());
        this.next = new (0, $a830ce6d12a62d72$export$2e2bcd8739ae039)();
        document.querySelector('.page').appendChild(this.el);
        this.el.querySelector('.home').appendChild(this.homeScore.render());
        this.el.querySelector('.visitor').appendChild(this.visitorScore.render());
        this.el.querySelector('.scroll').appendChild(this.next.render());
        (0, $2343afc8a06b7454$export$2e2bcd8739ae039).init(this);
        (0, $2343afc8a06b7454$export$2e2bcd8739ae039).show();
    }
    addListeners() {
        if ($9741e9da76fb5412$var$isTouchEventsSupported) {
            this.VS = new (0, (/*@__PURE__*/$parcel$interopDefault($27b84c32f3d45dfc$exports)))({
                element: window.document.body,
                directionDelta: 50,
                onSwipeStart: this.onSwipe,
                mouseTrackingEnabled: true
            });
            this.VS.init();
        }
        this.next.events.on('click', this.onArrrowClick);
        window.addEventListener('wheel', this.onWheel);
    }
    removeListeners() {
        if (this.VS) this.VS.destroy();
        this.next.events.off('click', this.onArrrowClick);
        window.removeEventListener('wheel', this.onWheel);
    }
    onArrrowClick() {
        let matchDO = (0, $5767c36b17e72441$export$c19731b2c49ee4c9)(this.matchDO.id);
        (0, $2343afc8a06b7454$export$2e2bcd8739ae039).setDirection(-1);
        this.scrolled = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${matchDO.id}`);
    }
    transitionIn(req, done) {
        this.scrolled = false;
        this.matchDO = (0, $5767c36b17e72441$export$26748ec468348572)(req.params.id);
        this.render();
        this.introTL = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: ()=>{
                this.addListeners();
            }
        });
        this.introTL.add(this.homeScore.transitionIn());
        this.introTL.add(this.visitorScore.transitionIn(), 0);
        if ($9741e9da76fb5412$var$firstAccess) {
            this.introTL.add(this.next.intro);
            $9741e9da76fb5412$var$firstAccess = false;
        }
        done();
    }
    transitionOut(req, done) {
        this.removeListeners();
        this.next.outro();
        if (/matches/.test((0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).__nextURL)) {
            this.dispose();
            done();
        } else if (/match/.test((0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).__nextURL)) {
            (0, $2343afc8a06b7454$export$2e2bcd8739ae039).spin(this.direction);
            this.outroTL = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
            this.outroTL.add(this.homeScore.transitionOut());
            this.outroTL.add(this.visitorScore.transitionOut(), 0);
            this.outroTL.add(()=>{
                this.dispose();
                done();
            }, 1);
        } else if (/goal/.test((0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).__nextURL)) {
            this.outroTL = (0, $2343afc8a06b7454$export$2e2bcd8739ae039).hide();
            this.outroTL.add(()=>{
                this.dispose();
                done();
            });
        // done();
        }
    }
    dispose() {
        (0, $2343afc8a06b7454$export$2e2bcd8739ae039).stop();
        this.el.parentNode.removeChild(this.el);
    }
    resize() {}
    onSwipe(e, swipeE) {
        if (!this.scrolled) {
            const down = swipeE.deltaY > 0;
            const currIndex = this.matchDO.id;
            const matchDO = down ? (0, $5767c36b17e72441$export$c19731b2c49ee4c9)(currIndex) : (0, $5767c36b17e72441$export$ba887a4992d07990)(currIndex);
            this.direction = down ? 1 : -1;
            if (matchDO) {
                (0, $2343afc8a06b7454$export$2e2bcd8739ae039).setDirection(this.direction);
                this.scrolled = true;
                (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${matchDO.id}`);
            }
        }
    }
    onWheel(e) {
        if (!this.scrolled) {
            const down = e.wheelDelta < 0;
            const currIndex = this.matchDO.id;
            const matchDO = down ? (0, $5767c36b17e72441$export$c19731b2c49ee4c9)(currIndex) : (0, $5767c36b17e72441$export$ba887a4992d07990)(currIndex);
            this.direction = down ? -1 : 1;
            if (matchDO) {
                (0, $2343afc8a06b7454$export$2e2bcd8739ae039).setDirection(this.direction);
                this.scrolled = true;
                (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${matchDO.id}`);
            }
        }
    }
}









function $6fc7af7232047c0d$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"match\"\u003E\u003Cdiv class=\"lines\"\u003E\u003Cdiv class=\"top\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"middle\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom\"\u003E\u003Cspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team team-1\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"team team-2\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $6fc7af7232047c0d$export$2e2bcd8739ae039 = $6fc7af7232047c0d$var$template;


class $ceb0840597d24a74$export$2e2bcd8739ae039 {
    data = undefined;
    flags = [];
    el = undefined;
    constructor(data){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.data = data;
    }
    intro() {
        let isSideB = this.el.parentNode.parentNode.classList.contains('side-b');
        let side = isSideB ? 'right' : 'left';
        let tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        tl.add(()=>{
            this.el.classList.add('show');
        });
        tl.add(this.flag1.intro(), 0);
        tl.add(this.flag2.intro(), 0);
        tl.fromTo(this.topline, {
            duration: 2,
            scaleX: 0
        }, {
            scaleX: 1,
            transformOrigin: `top ${side}`,
            ease: 'power4.out'
        }, 0.3);
        tl.fromTo(this.bottomLine, {
            duration: 2,
            scaleX: 0
        }, {
            scaleX: 1,
            transformOrigin: `top ${side}`,
            ease: 'power4.out'
        }, 0.3);
        tl.fromTo(this.middleLine, {
            duration: 2,
            scaleY: 0
        }, {
            scaleY: 1,
            transformOrigin: `center ${side}`,
            ease: 'power4.out'
        }, 0.5);
        setTimeout(()=>{
            this.events();
        }, 1000);
        return tl;
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $6fc7af7232047c0d$export$2e2bcd8739ae039)(this.data));
        this.topline = this.el.querySelector('.top');
        this.middleLine = this.el.querySelector('.middle');
        this.bottomLine = this.el.querySelector('.bottom');
        this.flag1 = new (0, $05f6f981e2ce284a$export$2e2bcd8739ae039)(this.data.teamDOs[0] ? this.data.teamDOs[0] : null);
        this.flag2 = new (0, $05f6f981e2ce284a$export$2e2bcd8739ae039)(this.data.teamDOs[1] ? this.data.teamDOs[1] : null);
        this.el.querySelector('.team-1').appendChild(this.flag1.render());
        this.el.querySelector('.team-2').appendChild(this.flag2.render());
        return this.el;
    }
    events() {
        if (this.data.result) {
            this.el.addEventListener('mouseenter', this.onOver);
            this.el.addEventListener('mouseleave', this.onOut);
            this.el.addEventListener('click', this.onClick);
        } else this.el.classList.add('disabled');
    }
    onClick() {
        if (!this.data.result) return;
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${this.data.id}`);
    }
    onOver() {
        this.el.classList.add('over');
    }
    onOut() {
        this.el.classList.remove('over');
    }
    outro() {
        this.el.classList.remove('show');
        this.flag1.reset();
        this.flag2.reset();
    }
}





function $6c731826ab35736c$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"knockout\"\u003E\u003Cdiv class=\"side-a\"\u003E\u003Cdiv class=\"round-16\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"quarters\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"semis\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"final\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"winner\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"side-b\"\u003E\u003Cdiv class=\"semis\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"quarters\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"round-16\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $6c731826ab35736c$export$2e2bcd8739ae039 = $6c731826ab35736c$var$template;







class $ca51b81967769d45$export$2e2bcd8739ae039 {
    el = undefined;
    flags = [];
    matches = [];
    sixteen = [];
    quarter = [];
    semi = [];
    final = [];
    render(parent) {
        this.parent = parent;
        this.sixteen = (0, $5767c36b17e72441$export$38c92103459846c4)();
        this.quarter = (0, $5767c36b17e72441$export$4282b62008f37173)();
        this.semi = (0, $5767c36b17e72441$export$77b7674324dda541)();
        this.final = (0, $5767c36b17e72441$export$558a61b9635b4c10)();
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $6c731826ab35736c$export$2e2bcd8739ae039)({
            round16: this.sixteen,
            quarters: this.quarter,
            semis: this.semi,
            final: this.final
        }));
        this.parent.appendChild(this.el);
        this.createSixteen();
        this.createQuarters();
        this.createSemis();
        this.createFinal();
        this.createWinner();
        setTimeout(()=>{
            this.resize();
        });
    }
    transitionIn() {
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.matches.forEach((m, i)=>{
            this.tl.add(m.intro(), i * 0.04);
        });
        this.tl.add(this.winnerFlag.intro(), 0.8);
        return this.tl;
    }
    transitionOut() {
        if (this.tl) {
            this.tl.clear();
            this.tl.kill();
        }
        this.matches.forEach((m, i)=>{
            m.outro();
        });
        this.winnerFlag.reset();
    }
    dispose() {
    // this.matches.forEach((m, i) => {
    //   m.classList.remove('over');
    // });
    }
    createSixteen() {
        this.sixteenA = this.el.querySelector('.side-a .round-16');
        this.sixteenB = this.el.querySelector('.side-b .round-16');
        this.sixteen.forEach((match, i)=>{
            let m = new (0, $ceb0840597d24a74$export$2e2bcd8739ae039)(match);
            this.matches.push(m);
            if (i < 4) this.sixteenA.appendChild(m.render());
            else this.sixteenB.appendChild(m.render());
        });
    }
    createQuarters() {
        this.quartersA = this.el.querySelector('.side-a .quarters');
        this.quartersB = this.el.querySelector('.side-b .quarters');
        this.quarter.forEach((match, i)=>{
            let m = new (0, $ceb0840597d24a74$export$2e2bcd8739ae039)(match);
            this.matches.push(m);
            if (i < 2) this.quartersA.appendChild(m.render());
            else this.quartersB.appendChild(m.render());
        });
    }
    createSemis() {
        this.quartersA = this.el.querySelector('.side-a .semis');
        this.quartersB = this.el.querySelector('.side-b .semis');
        this.semi.forEach((match, i)=>{
            let m = new (0, $ceb0840597d24a74$export$2e2bcd8739ae039)(match);
            this.matches.push(m);
            if (i < 1) this.quartersA.appendChild(m.render());
            else this.quartersB.appendChild(m.render());
        });
    }
    createFinal() {
        this.finalA = this.el.querySelector('.final');
        let m = new (0, $ceb0840597d24a74$export$2e2bcd8739ae039)(this.final[0]);
        this.matches.push(m);
        this.finalA.appendChild(m.render());
    }
    createWinner() {
        this.winner = this.el.querySelector('.winner');
        let win = (0, $3fc4261274f65713$export$491fe77f22ab2b51)(this.final[0].winner);
        console.log(win);
        this.winnerFlag = new (0, $05f6f981e2ce284a$export$2e2bcd8739ae039)(win, {
            big: true
        });
        this.winner.appendChild(this.winnerFlag.render());
    }
    resize() {
        if (!this.el) return;
        if (window.innerWidth < (0, $d1a28c8d5f44cae3$export$d07517a676ce386f).desktop) {
            let width = window.innerWidth / this.el.offsetHeight;
            let height = window.innerHeight / this.el.offsetWidth;
            if (width < 1.2 || height < 1.2) (0, $c5f6ad5335c7d493$export$99ee26438460406a).set(this.el, {
                rotate: 90,
                scaleY: width * 0.85,
                scaleX: height * 0.7
            });
        } else (0, $c5f6ad5335c7d493$export$99ee26438460406a).set(this.el, {
            scaleY: 1,
            scaleX: 1,
            rotate: 0
        });
    }
}








function $3c781bcfd639198b$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(groups1) {
        pug_html = pug_html + "\u003Cdiv class=\"groups\"\u003E";
        (function() {
            var $$obj = groups1;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var group = $$obj[pug_index0];
                pug_html = pug_html + "\u003Cdiv class=\"group\"\u003E";
                (function() {
                    var $$obj = group;
                    if ('number' == typeof $$obj.length) for(var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++){
                        var match = $$obj[pug_index1];
                        pug_html = pug_html + "\u003Cdiv class=\"group-match\"\u003E\u003C\u002Fdiv\u003E";
                    }
                    else {
                        var $$l = 0;
                        for(var pug_index1 in $$obj){
                            $$l++;
                            var match = $$obj[pug_index1];
                            pug_html = pug_html + "\u003Cdiv class=\"group-match\"\u003E\u003C\u002Fdiv\u003E";
                        }
                    }
                }).call(this);
                pug_html = pug_html + "\u003C\u002Fdiv\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var group = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Cdiv class=\"group\"\u003E";
                    (function() {
                        var $$obj = group;
                        if ('number' == typeof $$obj.length) for(var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++){
                            var match = $$obj[pug_index2];
                            pug_html = pug_html + "\u003Cdiv class=\"group-match\"\u003E\u003C\u002Fdiv\u003E";
                        }
                        else {
                            var $$l = 0;
                            for(var pug_index2 in $$obj){
                                $$l++;
                                var match = $$obj[pug_index2];
                                pug_html = pug_html + "\u003Cdiv class=\"group-match\"\u003E\u003C\u002Fdiv\u003E";
                            }
                        }
                    }).call(this);
                    pug_html = pug_html + "\u003C\u002Fdiv\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "groups" in locals_for_with ? locals_for_with.groups : typeof groups !== 'undefined' ? groups : undefined);
    return pug_html;
}
var $3c781bcfd639198b$export$2e2bcd8739ae039 = $3c781bcfd639198b$var$template;






class $3ae1b08c310cf9ff$export$2e2bcd8739ae039 {
    el = undefined;
    teams = [];
    matches = [];
    matchesDO = [];
    toggle = undefined;
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
    }
    render(parent) {
        this.parent = parent;
        this.groups = (0, $5767c36b17e72441$export$d2b3d1cf7cc2f701)();
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $3c781bcfd639198b$export$2e2bcd8739ae039)({
            groups: this.groups
        }));
        this.addTeams();
        setTimeout(()=>{
            this.resize();
        });
        return this.el;
    }
    addTeams() {
        this.matchesDO = [];
        this.matches = [];
        let columns = this.el.querySelectorAll('.group');
        columns.forEach((group, groupIndex)=>{
            let matches = group.querySelectorAll('.group-match');
            matches.forEach((match, matchIndex)=>{
                let m = this.groups[groupIndex][matchIndex];
                this.matchesDO.push(m);
                let team1 = new (0, $05f6f981e2ce284a$export$2e2bcd8739ae039)(m.done ? m.teamDOs[0] : null);
                let team2 = new (0, $05f6f981e2ce284a$export$2e2bcd8739ae039)(m.done ? m.teamDOs[1] : null);
                match.appendChild(team1.render());
                match.appendChild(team2.render());
                match.setAttribute('data-match-id', m.id);
                this.teams.push(team1);
                this.teams.push(team2);
                match.setAttribute('data-flag1-index', this.teams.length - 2);
                match.setAttribute('data-flag2-index', this.teams.length - 1);
                this.matches.push(match);
            });
        });
    }
    events() {
        this.matches.forEach((m, i)=>{
            let matchDO = this.matchesDO[i];
            if (matchDO.done) {
                m.addEventListener('mouseenter', this.onOver);
                m.addEventListener('mouseleave', this.onOut);
                m.addEventListener('click', this.onClick);
            } else m.style.pointerEvents = 'none';
        });
    }
    onClick(e) {
        let id = e.currentTarget.getAttribute('data-match-id');
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${id}`);
    }
    dispose() {
        this.matches.forEach((m, i)=>{
            m.classList.remove('over');
        });
    }
    onOver(e) {
        e.currentTarget.classList.add('over');
    }
    resetZIndex() {
        this.matches.forEach((match, matchIndex)=>{
            match.style.zIndex = 0;
        });
    }
    onOut(e) {
        e.currentTarget.classList.remove('over');
    }
    transitionIn() {
        if (this.tl) {
            this.tl.clear();
            this.tl.kill();
        }
        let delay = 0.007;
        if ((0, $e09ac0646f67242c$export$2e2bcd8739ae039)()) delay = 0.015;
        this.tl = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.teams.forEach((flag, i)=>{
            this.tl.add(flag.intro(), i * delay);
        });
        this.events();
        return this.tl;
    }
    transitionOut() {
        this.teams.forEach((flag, i)=>{
            flag.reset();
        });
        this.matches.forEach((m)=>{
            m.removeEventListener('mouseenter', this.onOver);
            m.removeEventListener('mouseleave', this.onOut);
            m.removeEventListener('click', this.onClick);
        });
        if (this.tl) {
            this.tl.clear();
            this.tl.kill();
        }
    }
    resize() {
        if (!this.el) return;
        if (window.innerWidth < (0, $d1a28c8d5f44cae3$export$d07517a676ce386f).desktop) {
            let width = window.innerWidth / this.el.offsetWidth;
            let height = window.innerHeight / this.el.offsetHeight;
            if (width < 1.2 || height < 1.2) {
                this.el.style.transform = 'initial';
                let margin = 50 / this.el.offsetWidth;
                (0, $c5f6ad5335c7d493$export$99ee26438460406a).set(this.el, {
                    scaleX: width - margin,
                    scaleY: height * 0.65
                });
            }
        } else (0, $c5f6ad5335c7d493$export$99ee26438460406a).set(this.el, {
            scaleY: 1,
            scaleX: 1
        });
    }
}





function $02610a95bbf00821$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Csection class=\"matches\"\u003E\u003Cdiv class=\"top-nav\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"bottom-nav\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"container\"\u003E\u003Cdiv class=\"group-table\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"knockout-table\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E";
    return pug_html;
}
var $02610a95bbf00821$export$2e2bcd8739ae039 = $02610a95bbf00821$var$template;



const $7b11f892fa3d25c5$var$isTouchEventsSupported = (0, (/*@__PURE__*/$parcel$interopDefault($27b84c32f3d45dfc$exports))).isTouchEventsSupported();
class $7b11f892fa3d25c5$var$Matches {
    rendered = false;
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.knockout = new (0, $ca51b81967769d45$export$2e2bcd8739ae039)();
        this.groups = new (0, $3ae1b08c310cf9ff$export$2e2bcd8739ae039)();
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $02610a95bbf00821$export$2e2bcd8739ae039)());
        this.btKnockout = new (0, $a830ce6d12a62d72$export$2e2bcd8739ae039)();
        this.btGroups = new (0, $a830ce6d12a62d72$export$2e2bcd8739ae039)();
        this.container = this.el.querySelector('.container');
        this.btToggle = this.el.querySelector('.toggle-view');
        this.knockout.render(this.el.querySelector('.knockout-table'));
        this.el.querySelector('.group-table').appendChild(this.groups.render());
        document.querySelector('.page').appendChild(this.el);
        this.el.querySelector('.bottom-nav').appendChild(this.btKnockout.render());
        this.el.querySelector('.top-nav').appendChild(this.btGroups.render());
        this.rendered = true;
    }
    transitionIn(req, done) {
        if (!this.rendered) this.render();
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.el, {
            x: '0%',
            ease: 'power4.inOut',
            duration: 0
        });
        this.gotoKnockout();
        this.events();
        done();
    }
    transitionOut(req, done) {
        this.view = 'knockout';
        this.gotoGroups();
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.el, {
            x: '-110%',
            ease: 'power4.inOut',
            duration: 0,
            onComplete: ()=>{
                this.groups.transitionOut();
                this.knockout.transitionOut();
            }
        });
        this.dispose();
        done();
    }
    dispose() {
        if (this.VS) this.VS.destroy();
        this.scrolled = false;
        this.btKnockout.events.off('click', this.gotoKnockout);
        this.btGroups.events.off('click', this.gotoGroups);
        this.groups.dispose();
        this.knockout.dispose();
        window.removeEventListener('wheel', this.onWheel);
    }
    gotoKnockout() {
        if (this.view === 'knockout') {
            this.scrolled = false;
            return;
        }
        this.view = 'knockout';
        this.btKnockout.outro();
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.container, {
            y: '-100vh',
            ease: 'expo.out',
            duration: 0.75
        });
        this.groups.transitionOut();
        this.btGroups.intro();
        this.knockout.transitionIn().add(()=>{
            this.scrolled = false;
        });
    }
    gotoGroups() {
        if (this.view === 'groups') {
            this.scrolled = false;
            return;
        }
        this.view = 'groups';
        this.btGroups.outro();
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(this.container, {
            y: '0vh',
            ease: 'expo.out',
            duration: 0.75
        });
        this.btKnockout.intro();
        this.groups.transitionIn().add(()=>{
            this.scrolled = false;
        });
        this.knockout.transitionOut();
    }
    events() {
        if ($7b11f892fa3d25c5$var$isTouchEventsSupported) {
            this.VS = new (0, (/*@__PURE__*/$parcel$interopDefault($27b84c32f3d45dfc$exports)))({
                element: window.document.body,
                directionDelta: 50,
                onSwipeStart: this.onSwipe,
                mouseTrackingEnabled: true
            });
            this.VS.init();
        }
        this.btKnockout.events.off('click', this.gotoKnockout);
        this.btKnockout.events.on('click', this.gotoKnockout);
        this.btGroups.events.off('click', this.gotoGroups);
        this.btGroups.events.on('click', this.gotoGroups);
        window.removeEventListener('wheel', this.onWheel);
        window.addEventListener('wheel', this.onWheel);
    }
    onSwipe(e, swipeE) {
        if (!this.scrolled) {
            const down = swipeE.deltaY > 0;
            this.direction = down ? 1 : -1;
            if (this.direction === -1) this.gotoGroups();
            else this.gotoKnockout();
        }
    }
    onWheel(e) {
        if (!this.scrolled) {
            this.scrolled = true;
            const down = e.wheelDelta < 0;
            this.direction = down ? -1 : 1;
            if (this.direction === 1) this.gotoGroups();
            else this.gotoKnockout();
        }
    }
    resize() {
        this.knockout.resize();
        this.groups.resize();
    }
}
var $7b11f892fa3d25c5$export$2e2bcd8739ae039 = new $7b11f892fa3d25c5$var$Matches();












let $f99d9b9bcbcf0b76$var$_gui;
let $f99d9b9bcbcf0b76$var$_icons;
const $f99d9b9bcbcf0b76$export$76fef7449090be6a = 'folder-path';
const $f99d9b9bcbcf0b76$export$b3ae4990585bc4b5 = 'folder-style';
const $f99d9b9bcbcf0b76$export$5ca3895f35d8816b = ()=>$f99d9b9bcbcf0b76$var$_gui;
const $f99d9b9bcbcf0b76$export$868f4a6767a7a840 = (value)=>$f99d9b9bcbcf0b76$var$_gui = value;
const $f99d9b9bcbcf0b76$export$d32270239fcfe90e = ()=>{
    const options = {};
    (0, $5767c36b17e72441$export$ab205615fc3a8e74)().sort((a, b)=>a.id - b.id).forEach((match)=>{
        options[match.name] = match.id;
    });
    return options;
};
const $f99d9b9bcbcf0b76$export$55403dcfae0e99a9 = ()=>{
    const options = {};
    (0, $3fc4261274f65713$export$5a622455e94bac3)().forEach((team)=>{
        options[team.name] = team.slug;
    });
    return options;
};
const $f99d9b9bcbcf0b76$export$4d0578830601a98b = ()=>{
    const options = {
        '': '',
        'pen.': 'pen.',
        'o.g.': 'o.g.'
    };
    return options;
};
const $f99d9b9bcbcf0b76$export$5f2cc9974f97683b = (iconMap)=>{
    $f99d9b9bcbcf0b76$var$_icons = iconMap;
};
const $f99d9b9bcbcf0b76$export$11e5e2379ae5b62d = (parent, params = {})=>{
    const folder = parent.addFolder(params);
    const el = folder.controller_.view.buttonElement;
    switch(params.type){
        case $f99d9b9bcbcf0b76$export$76fef7449090be6a:
            $f99d9b9bcbcf0b76$var$_addListeners(el, params);
            $f99d9b9bcbcf0b76$var$_addIconEye(el);
            $f99d9b9bcbcf0b76$var$_addIconTrash(el);
            break;
        case $f99d9b9bcbcf0b76$export$b3ae4990585bc4b5:
            $f99d9b9bcbcf0b76$var$_addListeners(el, params);
            $f99d9b9bcbcf0b76$var$_addIconEye(el);
            $f99d9b9bcbcf0b76$var$_addIconTrash(el);
            break;
    }
    return folder;
};
const $f99d9b9bcbcf0b76$var$_addListeners = (el, params)=>{
    el.addEventListener('click', (e)=>{
        // only intervene when a 'fa' element is clicked
        if (!e.target.classList.contains('fa')) return true;
        e.preventDefault();
        e.stopPropagation();
        if (e.target.classList.contains('fa-eye')) // expect a property/function onVisibleClick
        {
            if (params.onVisibleClick) params.onVisibleClick(!e.target.classList.toggle('disabled'));
        }
        if (e.target.classList.contains('fa-trash')) // expect a property/function onRemoveClick
        {
            if (params.onRemoveClick) params.onRemoveClick();
        }
    }, true);
};
const $f99d9b9bcbcf0b76$var$_addIconEye = (el)=>{
    let div, svg;
    div = document.createElement('div');
    div.classList.add('fa', 'fa-eye');
    el.appendChild(div);
    // svg = AsyncPreloader.items.get('fa-eye').documentElement;
    svg = $f99d9b9bcbcf0b76$var$_icons.get('fa-eye').documentElement;
    svg = svg.cloneNode(true);
    svg.classList.add('eye');
    div.appendChild(svg);
    svg = $f99d9b9bcbcf0b76$var$_icons.get('fa-eye-slash').documentElement;
    svg = svg.cloneNode(true);
    svg.classList.add('eye-slash');
    div.appendChild(svg);
};
const $f99d9b9bcbcf0b76$var$_addIconTrash = (el)=>{
    let div, svg;
    div = document.createElement('div');
    div.classList.add('fa', 'fa-trash');
    el.appendChild(div);
    svg = $f99d9b9bcbcf0b76$var$_icons.get('fa-trash').documentElement;
    svg = svg.cloneNode(true);
    div.appendChild(svg);
};
const $f99d9b9bcbcf0b76$export$7991a91610b2c96e = (parent, target, expanded)=>{
    if (!expanded) return;
    parent.children.forEach((child)=>{
        if (child.expanded == undefined) return;
        child.expanded = child == target;
    });
};










let $3e6ad3d87c16793a$var$alreadyTested = false;
let $3e6ad3d87c16793a$var$passiveSupported = false;
const $3e6ad3d87c16793a$var$_emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($6ab0340c5ed2956f$exports)))();
const $3e6ad3d87c16793a$export$bad24218ebd77223 = $3e6ad3d87c16793a$var$_emitter;
const $3e6ad3d87c16793a$export$4bf9923669ad6c63 = {
    EDIT_MODE_CHANGE: 'edit-mode-change',
    PATH_SELECT: 'path-select'
};
const $3e6ad3d87c16793a$export$a3ce694c55b83a0 = ()=>{
    const isSupported = ()=>{
        if ($3e6ad3d87c16793a$var$alreadyTested) return $3e6ad3d87c16793a$var$passiveSupported;
        $3e6ad3d87c16793a$var$alreadyTested = true;
        // Test via a getter in the options object to see if the passive property is accessed
        try {
            let opts1 = Object.defineProperty({}, 'passive', {
                get: ()=>{
                    $3e6ad3d87c16793a$var$passiveSupported = true;
                }
            });
            window.addEventListener('test', null, opts1);
        } catch (e) {
            return $3e6ad3d87c16793a$var$passiveSupported;
        }
        window.removeEventListener('test', null, opts);
        return $3e6ad3d87c16793a$var$passiveSupported;
    };
    return isSupported() ? {
        passive: true
    } : false;
};


class $c66d2cdc82603e69$export$2e2bcd8739ae039 {
    constructor(webgl){
        this.webgl = webgl;
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.width = 1000;
        this.height = 644;
        this.res = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        this.material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: 0x333333,
            linewidth: 1.5
        });
        this.initMesh();
        this.initHitArea();
        (0, $3e6ad3d87c16793a$export$bad24218ebd77223).addListener((0, $3e6ad3d87c16793a$export$4bf9923669ad6c63).EDIT_MODE_CHANGE, this.onEditModeChange.bind(this));
    }
    initMesh() {
        const { width: w, height: h } = this;
        const pathBounds = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().moveTo(w * -0.5, h * -0.5).lineTo(w * 0.5, h * -0.5).lineTo(w * 0.5, h * 0.5).lineTo(w * -0.5, h * 0.5).lineTo(w * -0.5, h * -0.5);
        const pathCenterLine = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().moveTo(0, h * -0.5).lineTo(0, h * 0.5);
        const pathArea = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().moveTo(w * -0.082, h * -0.31).lineTo(w * 0.082, h * -0.31).lineTo(w * 0.082, h * 0.31).lineTo(w * -0.082, h * 0.31);
        const pathSmallArea = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().moveTo(w * -0.025, h * -0.14).lineTo(w * 0.025, h * -0.14).lineTo(w * 0.025, h * 0.14).lineTo(w * -0.025, h * 0.14);
        const pathGoal = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().moveTo(w * 0.013, h * -0.06).lineTo(w * -0.013, h * -0.06).lineTo(w * -0.013, h * 0.06).lineTo(w * 0.013, h * 0.06);
        const pathCenterCircle = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().absarc(0, 0, w * 0.095, 0, Math.PI * 2);
        const pathAreaArc = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().absarc(0, 0, w * 0.095, Math.PI * 0.695, Math.PI * 1.305);
        const pathSpot = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9().absarc(0, 0, w * 0.002, 0, Math.PI * 2);
        const lineBounds = this.getLine(pathBounds);
        const lineCenterLine = this.getLine(pathCenterLine);
        const lineCenterCircle = this.getLine(pathCenterCircle);
        const lineCenterSpot = this.getLine(pathSpot);
        const lineAreaL = this.getLine(pathArea);
        const lineAreaR = this.getLine(pathArea);
        const lineSmallAreaL = this.getLine(pathSmallArea);
        const lineSmallAreaR = this.getLine(pathSmallArea);
        const lineAreaArcL = this.getLine(pathAreaArc);
        const lineAreaArcR = this.getLine(pathAreaArc);
        const lineSpotL = this.getLine(pathSpot);
        const lineSpotR = this.getLine(pathSpot);
        const lineGoalL = this.getLine(pathGoal);
        const lineGoalR = this.getLine(pathGoal);
        lineAreaL.position.x = w * -0.5 + w * 0.082;
        lineAreaR.position.x = w * 0.5 - w * 0.082;
        lineAreaR.rotation.y = Math.PI;
        lineSmallAreaL.position.x = w * -0.5 + w * 0.025;
        lineSmallAreaR.position.x = w * 0.5 - w * 0.025;
        lineSmallAreaR.rotation.y = Math.PI;
        lineGoalL.position.x = w * -0.5 - w * 0.013;
        lineGoalR.position.x = w * 0.5 + w * 0.013;
        lineGoalR.rotation.y = Math.PI;
        lineAreaArcL.position.x = w * 0.39;
        lineAreaArcR.position.x = w * -0.39;
        lineAreaArcR.rotation.y = Math.PI;
        lineSpotL.position.x = w * 0.39;
        lineSpotR.position.x = w * -0.39;
        this.object3D.add(lineBounds);
        this.object3D.add(lineCenterLine);
        this.object3D.add(lineCenterCircle);
        this.object3D.add(lineCenterSpot);
        this.object3D.add(lineAreaL);
        this.object3D.add(lineAreaR);
        this.object3D.add(lineSmallAreaL);
        this.object3D.add(lineSmallAreaR);
        this.object3D.add(lineAreaArcL);
        this.object3D.add(lineAreaArcR);
        this.object3D.add(lineSpotL);
        this.object3D.add(lineSpotR);
        this.object3D.add(lineGoalL);
        this.object3D.add(lineGoalR);
    }
    getLine(path) {
        const points = path.getPoints(20);
        const geoPoints = new $f70f7eb6404ce619$export$b7be63a67df8959().setFromPoints(points);
        const geometry = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        geometry.setPositions(geoPoints.attributes.position.array);
        const material = this.material;
        return new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometry, material);
    }
    initHitArea() {
        const { width: width, height: height } = this;
        const geometry = new $f70f7eb6404ce619$export$967d831af31f69ce(width * 1.2, height * 1.2);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: 0xFF0000,
            transparent: true,
            opacity: 0.2,
            visible: false
        });
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        this.object3D.add(mesh);
        this.hitArea = mesh;
    }
    onEditModeChange(value) {
    // this.object3D.visible = value;
    }
    resize() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        if (this.material) this.material.resolution.copy(this.res);
    }
}













class $70d7e2ec528e5953$export$2e2bcd8739ae039 {
    constructor(path, index, position){
        this.path = path;
        this.index = index;
        this.interactive = path.paths.webgl.interactive;
        this.transform = path.paths.webgl.transform;
        this.colorOver = new $f70f7eb6404ce619$export$892596cec99bc70e(0xFFFFFF);
        this.colorOut = new $f70f7eb6404ce619$export$892596cec99bc70e(0xCCCCCC);
        this.scaleOver = new $f70f7eb6404ce619$export$64b5c384219d3699(1.5, 1.5, 1.5);
        this.scaleOut = new $f70f7eb6404ce619$export$64b5c384219d3699(1.0, 1.0, 1.0);
        this.initMesh();
        this.position.copy(position);
    }
    initMesh() {
        const geometry = new $f70f7eb6404ce619$export$33e43285f7406bd5(5, 5, 5);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: this.colorOut
        });
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        mesh.anchor = this;
        this.object3D = mesh;
    }
    serialize() {
        return this.position.toArray();
    }
    get position() {
        return this.object3D.position;
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onInteractiveOver(e) {
        if (e.object != this.object3D) return;
        this.object3D.material.color.copy(this.colorOver);
        this.object3D.scale.copy(this.scaleOver);
    }
    onInteractiveOut(e) {
        if (e.object != this.object3D) return;
        this.object3D.material.color.copy(this.colorOut);
        this.object3D.scale.copy(this.scaleOut);
    }
    onInteractiveDown(e) {
        if (e.object != this.object3D) return;
        if (this.transform.object == this.object3D) return;
        this.transform.attach(this.object3D);
    }
}




const $22eea921ce8ffc08$var$OFFSET_CURVE = 'offset-curve';
const $22eea921ce8ffc08$var$OFFSET_GEOMETRY = 'offset-geometry';
class $22eea921ce8ffc08$export$2e2bcd8739ae039 {
    constructor(path, segment, index, options = {}){
        this.path = path;
        this.segment = segment;
        this.index = index;
        const { style: style, noise2D: noise2D, subpaths: subpaths, gap: gap = 12, dist: dist = 10, distAngle: distAngle = 0, spiral: spiral = 1, spiralGain: spiralGain = 1, parentPoints: parentPoints = 5, count: count = 100, twist: twist = 0 } = options;
        let _dist, _distAngle, _offsetType;
        switch(style){
            case 'Dots':
                _dist = (0, $a5a3d7804ffbb687$export$267eb760cb73f794)(0, dist, noise2D, index);
                _distAngle = distAngle;
                _offsetType = $22eea921ce8ffc08$var$OFFSET_GEOMETRY;
                break;
            case 'Spine':
                _dist = dist;
                _distAngle = distAngle;
                _offsetType = $22eea921ce8ffc08$var$OFFSET_CURVE;
                break;
        }
        this.settings = {
            dist: _dist,
            distAngle: _distAngle,
            offsetType: _offsetType,
            subpaths: subpaths,
            parentPoints: parentPoints,
            spiral: spiral,
            spiralGain: spiralGain,
            count: count,
            gap: gap,
            twist: twist
        };
        this.positions = [];
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vex = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.pos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.fwd = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nml = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.up = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
        this.initPositions();
        this.updateCurve();
        this.updatePositions();
    }
    initPositions() {
        const { path: path, segment: segment, positions: positions, vec: vec } = this;
        const { parentPoints: parentPoints } = this.settings;
        const range = segment.end - segment.ini;
        let t, u;
        for(let i = 0; i < parentPoints; i++){
            t = i / (parentPoints - 1);
            u = segment.ini + t * range;
            path.curve.getPointAt(u, vec);
            positions.push(vec.clone());
        }
    }
    updateCurve() {
        // remove old
        if (this.curve) this.object3D.remove(this.curve.mesh);
        // not enough points
        if (this.positions.length < 2) return;
        const { count: count, offsetType: offsetType } = this.settings;
        if (offsetType == $22eea921ce8ffc08$var$OFFSET_CURVE) {
            const { path: path, segment: segment, positions: positions, index: index } = this;
            const { vec: vec, pos: pos, fwd: fwd, up: up, nml: nml, vex: vex } = this;
            const { dist: dist, distAngle: distAngle, spiral: spiral, spiralGain: spiralGain, parentPoints: parentPoints, gap: gap, twist: twist, subpaths: subpaths } = this.settings;
            const range = segment.end - segment.ini;
            let t, u;
            positions.length = 0;
            for(let i = 0; i < parentPoints; i++){
                t = i / (parentPoints - 1);
                u = segment.ini + t * range;
                path.curve.getPoint(u, pos);
                path.curve.getTangent(u, fwd);
                // normal
                nml.copy(fwd).cross(up);
                u = (0, $a5a3d7804ffbb687$export$57790f9172054d97)(t, spiralGain);
                // rotated around forward
                vec.copy(nml);
                vec.applyAxisAngle(fwd, u * Math.PI * spiral - distAngle);
                vec.setLength(dist);
                vec.add(pos);
                fwd.set(1, 0, 0);
                // twist
                vex.copy(nml);
                vex.applyAxisAngle(fwd, u * -twist + Math.PI * 0.5);
                // vex.setLength(gap * index - subpaths * gap * 0.5 + gap * 0.5);
                vex.setLength(gap * index);
                vec.add(vex);
                positions.push(vec.clone());
            }
        }
        // create new
        const geometry = new $f70f7eb6404ce619$export$b7be63a67df8959();
        geometry.setAttribute('position', new $f70f7eb6404ce619$export$8dea267bd6bde117(new Float32Array(count * 3), 3));
        geometry.setAttribute('tangent', new $f70f7eb6404ce619$export$8dea267bd6bde117(new Float32Array(count * 3), 3));
        const color = this.path.color.clone().offsetHSL(0, 0, -0.2);
        const material = new $f70f7eb6404ce619$export$fbaaa33907730a0c({
            color: color
        });
        const mesh = new $f70f7eb6404ce619$export$17d680238e50603e(geometry, material);
        this.curve = new $f70f7eb6404ce619$export$b9146b27c24b744c(this.positions);
        this.curve.curveType = 'centripetal';
        this.curve.mesh = mesh;
        // this.curve.frenet = this.curve.computeFrenetFrames(count);
        this.object3D.add(mesh);
    }
    updatePositions() {
        if (!this.curve) return;
        if (this.curve.points.length < 2) return;
        const { curve: curve, index: index } = this;
        const { vec: vec, pos: pos, fwd: fwd, up: up } = this;
        const { dist: dist, distAngle: distAngle, spiral: spiral, spiralGain: spiralGain, count: count, offsetType: offsetType } = this.settings;
        const position = curve.mesh.geometry.attributes.position;
        const tangent = curve.mesh.geometry.attributes.tangent;
        let t, u;
        const idistAngle = distAngle + Math.PI * 0.33 * (index % 3) + Math.PI * 0.1 * index;
        for(let i = 0; i < count; i++){
            t = i / count;
            curve.getPoint(t, pos);
            curve.getTangent(t, fwd);
            if (offsetType == $22eea921ce8ffc08$var$OFFSET_GEOMETRY) {
                // normal
                vec.copy(fwd).cross(up);
                // fwd.copy(curve.frenet.tangents[i]);
                // vec.copy(curve.frenet.normals[i]);
                u = (0, $a5a3d7804ffbb687$export$57790f9172054d97)(t, spiralGain);
                // rotated around forward
                vec.applyAxisAngle(fwd, u * Math.PI * spiral + idistAngle);
                vec.setLength(dist);
                pos.add(vec);
            }
            position.setXYZ(i, pos.x, pos.y, pos.z);
            tangent.setXYZ(i, fwd.x, fwd.y, fwd.z);
        }
        position.needsUpdate = true;
        tangent.needsUpdate = true;
    }
    dispose() {
        this.object3D.clear();
        this.path = null;
        this.curve = null;
        this.object3D = null;
        this.positions = null;
    }
}



var $3dca7fe4af39e080$exports = {};
(function(root, factory) {
    $3dca7fe4af39e080$exports = factory();
})($3dca7fe4af39e080$exports, function() {
    'use strict';
    // From http://baagoe.com/en/RandomMusings/javascript/
    // importState to sync generator states
    Alea.importState = function(i) {
        var random = new Alea();
        random.importState(i);
        return random;
    };
    return Alea;
    function Alea() {
        return function(args) {
            // Johannes Baagøe <baagoe@baagoe.com>, 2010
            var s0 = 0;
            var s1 = 0;
            var s2 = 0;
            var c = 1;
            if (args.length == 0) args = [
                +new Date
            ];
            var mash = Mash();
            s0 = mash(' ');
            s1 = mash(' ');
            s2 = mash(' ');
            for(var i = 0; i < args.length; i++){
                s0 -= mash(args[i]);
                if (s0 < 0) s0 += 1;
                s1 -= mash(args[i]);
                if (s1 < 0) s1 += 1;
                s2 -= mash(args[i]);
                if (s2 < 0) s2 += 1;
            }
            mash = null;
            var random = function() {
                var t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.next = random;
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = 'Alea 0.9';
            random.args = args;
            // my own additions to sync state between two generators
            random.exportState = function() {
                return [
                    s0,
                    s1,
                    s2,
                    c
                ];
            };
            random.importState = function(i) {
                s0 = +i[0] || 0;
                s1 = +i[1] || 0;
                s2 = +i[2] || 0;
                c = +i[3] || 0;
            };
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = data.toString();
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        mash.version = 'Mash 0.9';
        return mash;
    }
});


/*
 * A fast javascript implementation of simplex noise by Jonas Wagner

Based on a speed-improved simplex noise algorithm for 2D, 3D and 4D in Java.
Which is based on example code by Stefan Gustavson (stegu@itn.liu.se).
With Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
Better rank ordering method by Stefan Gustavson in 2012.

 Copyright (c) 2024 Jonas Wagner

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */ // these __PURE__ comments help uglifyjs with dead code removal
//
const $396f98d271b2a856$var$SQRT3 = /*#__PURE__*/ Math.sqrt(3.0);
const $396f98d271b2a856$var$SQRT5 = /*#__PURE__*/ Math.sqrt(5.0);
const $396f98d271b2a856$var$F2 = 0.5 * ($396f98d271b2a856$var$SQRT3 - 1.0);
const $396f98d271b2a856$var$G2 = (3.0 - $396f98d271b2a856$var$SQRT3) / 6.0;
const $396f98d271b2a856$var$F3 = 1.0 / 3.0;
const $396f98d271b2a856$var$G3 = 1.0 / 6.0;
const $396f98d271b2a856$var$F4 = ($396f98d271b2a856$var$SQRT5 - 1.0) / 4.0;
const $396f98d271b2a856$var$G4 = (5.0 - $396f98d271b2a856$var$SQRT5) / 20.0;
// I'm really not sure why this | 0 (basically a coercion to int)
// is making this faster but I get ~5 million ops/sec more on the
// benchmarks across the board or a ~10% speedup.
const $396f98d271b2a856$var$fastFloor = (x)=>Math.floor(x) | 0;
const $396f98d271b2a856$var$grad2 = /*#__PURE__*/ new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]);
// double seems to be faster than single or int's
// probably because most operations are in double precision
const $396f98d271b2a856$var$grad3 = /*#__PURE__*/ new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
// double is a bit quicker here as well
const $396f98d271b2a856$var$grad4 = /*#__PURE__*/ new Float64Array([
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    -1,
    1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    1,
    0,
    1,
    1,
    -1,
    0,
    1,
    -1,
    1,
    0,
    1,
    -1,
    -1,
    0,
    -1,
    1,
    1,
    0,
    -1,
    1,
    -1,
    0,
    -1,
    -1,
    1,
    0,
    -1,
    -1,
    -1,
    0
]);
function $396f98d271b2a856$export$9de79e9646a874e5(random = Math.random) {
    const perm = $396f98d271b2a856$export$98cd52c6119fe283(random);
    // precalculating this yields a little ~3% performance improvement.
    const permGrad2x = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad2[v % 12 * 2]);
    const permGrad2y = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad2[v % 12 * 2 + 1]);
    return function noise2D(x, y) {
        // if(!isFinite(x) || !isFinite(y)) return 0;
        let n0 = 0; // Noise contributions from the three corners
        let n1 = 0;
        let n2 = 0;
        // Skew the input space to determine which simplex cell we're in
        const s = (x + y) * $396f98d271b2a856$var$F2; // Hairy factor for 2D
        const i = $396f98d271b2a856$var$fastFloor(x + s);
        const j = $396f98d271b2a856$var$fastFloor(y + s);
        const t = (i + j) * $396f98d271b2a856$var$G2;
        const X0 = i - t; // Unskew the cell origin back to (x,y) space
        const Y0 = j - t;
        const x0 = x - X0; // The x,y distances from the cell origin
        const y0 = y - Y0;
        // For the 2D case, the simplex shape is an equilateral triangle.
        // Determine which simplex we are in.
        let i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
        if (x0 > y0) {
            i1 = 1;
            j1 = 0;
        } else {
            i1 = 0;
            j1 = 1;
        } // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
        // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
        // c = (3-sqrt(3))/6
        const x1 = x0 - i1 + $396f98d271b2a856$var$G2; // Offsets for middle corner in (x,y) unskewed coords
        const y1 = y0 - j1 + $396f98d271b2a856$var$G2;
        const x2 = x0 - 1.0 + 2.0 * $396f98d271b2a856$var$G2; // Offsets for last corner in (x,y) unskewed coords
        const y2 = y0 - 1.0 + 2.0 * $396f98d271b2a856$var$G2;
        // Work out the hashed gradient indices of the three simplex corners
        const ii = i & 255;
        const jj = j & 255;
        // Calculate the contribution from the three corners
        let t0 = 0.5 - x0 * x0 - y0 * y0;
        if (t0 >= 0) {
            const gi0 = ii + perm[jj];
            const g0x = permGrad2x[gi0];
            const g0y = permGrad2y[gi0];
            t0 *= t0;
            // n0 = t0 * t0 * (grad2[gi0] * x0 + grad2[gi0 + 1] * y0); // (x,y) of grad3 used for 2D gradient
            n0 = t0 * t0 * (g0x * x0 + g0y * y0);
        }
        let t1 = 0.5 - x1 * x1 - y1 * y1;
        if (t1 >= 0) {
            const gi1 = ii + i1 + perm[jj + j1];
            const g1x = permGrad2x[gi1];
            const g1y = permGrad2y[gi1];
            t1 *= t1;
            // n1 = t1 * t1 * (grad2[gi1] * x1 + grad2[gi1 + 1] * y1);
            n1 = t1 * t1 * (g1x * x1 + g1y * y1);
        }
        let t2 = 0.5 - x2 * x2 - y2 * y2;
        if (t2 >= 0) {
            const gi2 = ii + 1 + perm[jj + 1];
            const g2x = permGrad2x[gi2];
            const g2y = permGrad2y[gi2];
            t2 *= t2;
            // n2 = t2 * t2 * (grad2[gi2] * x2 + grad2[gi2 + 1] * y2);
            n2 = t2 * t2 * (g2x * x2 + g2y * y2);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to return values in the interval [-1,1].
        return 70.0 * (n0 + n1 + n2);
    };
}
function $396f98d271b2a856$export$80cd39cae172f7fa(random = Math.random) {
    const perm = $396f98d271b2a856$export$98cd52c6119fe283(random);
    // precalculating these seems to yield a speedup of over 15%
    const permGrad3x = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad3[v % 12 * 3]);
    const permGrad3y = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad3[v % 12 * 3 + 1]);
    const permGrad3z = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad3[v % 12 * 3 + 2]);
    return function noise3D(x, y, z) {
        let n0, n1, n2, n3; // Noise contributions from the four corners
        // Skew the input space to determine which simplex cell we're in
        const s = (x + y + z) * $396f98d271b2a856$var$F3; // Very nice and simple skew factor for 3D
        const i = $396f98d271b2a856$var$fastFloor(x + s);
        const j = $396f98d271b2a856$var$fastFloor(y + s);
        const k = $396f98d271b2a856$var$fastFloor(z + s);
        const t = (i + j + k) * $396f98d271b2a856$var$G3;
        const X0 = i - t; // Unskew the cell origin back to (x,y,z) space
        const Y0 = j - t;
        const Z0 = k - t;
        const x0 = x - X0; // The x,y,z distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        // For the 3D case, the simplex shape is a slightly irregular tetrahedron.
        // Determine which simplex we are in.
        let i1, j1, k1; // Offsets for second corner of simplex in (i,j,k) coords
        let i2, j2, k2; // Offsets for third corner of simplex in (i,j,k) coords
        if (x0 >= y0) {
            if (y0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } else if (x0 >= z0) {
                i1 = 1;
                j1 = 0;
                k1 = 0;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 1;
                j2 = 0;
                k2 = 1;
            } // Z X Y order
        } else {
            if (y0 < z0) {
                i1 = 0;
                j1 = 0;
                k1 = 1;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else if (x0 < z0) {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 0;
                j2 = 1;
                k2 = 1;
            } else {
                i1 = 0;
                j1 = 1;
                k1 = 0;
                i2 = 1;
                j2 = 1;
                k2 = 0;
            } // Y X Z order
        }
        // A step of (1,0,0) in (i,j,k) means a step of (1-c,-c,-c) in (x,y,z),
        // a step of (0,1,0) in (i,j,k) means a step of (-c,1-c,-c) in (x,y,z), and
        // a step of (0,0,1) in (i,j,k) means a step of (-c,-c,1-c) in (x,y,z), where
        // c = 1/6.
        const x1 = x0 - i1 + $396f98d271b2a856$var$G3; // Offsets for second corner in (x,y,z) coords
        const y1 = y0 - j1 + $396f98d271b2a856$var$G3;
        const z1 = z0 - k1 + $396f98d271b2a856$var$G3;
        const x2 = x0 - i2 + 2.0 * $396f98d271b2a856$var$G3; // Offsets for third corner in (x,y,z) coords
        const y2 = y0 - j2 + 2.0 * $396f98d271b2a856$var$G3;
        const z2 = z0 - k2 + 2.0 * $396f98d271b2a856$var$G3;
        const x3 = x0 - 1.0 + 3.0 * $396f98d271b2a856$var$G3; // Offsets for last corner in (x,y,z) coords
        const y3 = y0 - 1.0 + 3.0 * $396f98d271b2a856$var$G3;
        const z3 = z0 - 1.0 + 3.0 * $396f98d271b2a856$var$G3;
        // Work out the hashed gradient indices of the four simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        // Calculate the contribution from the four corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
        if (t0 < 0) n0 = 0.0;
        else {
            const gi0 = ii + perm[jj + perm[kk]];
            t0 *= t0;
            n0 = t0 * t0 * (permGrad3x[gi0] * x0 + permGrad3y[gi0] * y0 + permGrad3z[gi0] * z0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
        if (t1 < 0) n1 = 0.0;
        else {
            const gi1 = ii + i1 + perm[jj + j1 + perm[kk + k1]];
            t1 *= t1;
            n1 = t1 * t1 * (permGrad3x[gi1] * x1 + permGrad3y[gi1] * y1 + permGrad3z[gi1] * z1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
        if (t2 < 0) n2 = 0.0;
        else {
            const gi2 = ii + i2 + perm[jj + j2 + perm[kk + k2]];
            t2 *= t2;
            n2 = t2 * t2 * (permGrad3x[gi2] * x2 + permGrad3y[gi2] * y2 + permGrad3z[gi2] * z2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
        if (t3 < 0) n3 = 0.0;
        else {
            const gi3 = ii + 1 + perm[jj + 1 + perm[kk + 1]];
            t3 *= t3;
            n3 = t3 * t3 * (permGrad3x[gi3] * x3 + permGrad3y[gi3] * y3 + permGrad3z[gi3] * z3);
        }
        // Add contributions from each corner to get the final noise value.
        // The result is scaled to stay just inside [-1,1]
        return 32.0 * (n0 + n1 + n2 + n3);
    };
}
function $396f98d271b2a856$export$8ec263ee3d525d98(random = Math.random) {
    const perm = $396f98d271b2a856$export$98cd52c6119fe283(random);
    // precalculating these leads to a ~10% speedup
    const permGrad4x = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad4[v % 32 * 4]);
    const permGrad4y = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad4[v % 32 * 4 + 1]);
    const permGrad4z = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad4[v % 32 * 4 + 2]);
    const permGrad4w = new Float64Array(perm).map((v)=>$396f98d271b2a856$var$grad4[v % 32 * 4 + 3]);
    return function noise4D(x, y, z, w) {
        let n0, n1, n2, n3, n4; // Noise contributions from the five corners
        // Skew the (x,y,z,w) space to determine which cell of 24 simplices we're in
        const s = (x + y + z + w) * $396f98d271b2a856$var$F4; // Factor for 4D skewing
        const i = $396f98d271b2a856$var$fastFloor(x + s);
        const j = $396f98d271b2a856$var$fastFloor(y + s);
        const k = $396f98d271b2a856$var$fastFloor(z + s);
        const l = $396f98d271b2a856$var$fastFloor(w + s);
        const t = (i + j + k + l) * $396f98d271b2a856$var$G4; // Factor for 4D unskewing
        const X0 = i - t; // Unskew the cell origin back to (x,y,z,w) space
        const Y0 = j - t;
        const Z0 = k - t;
        const W0 = l - t;
        const x0 = x - X0; // The x,y,z,w distances from the cell origin
        const y0 = y - Y0;
        const z0 = z - Z0;
        const w0 = w - W0;
        // For the 4D case, the simplex is a 4D shape I won't even try to describe.
        // To find out which of the 24 possible simplices we're in, we need to
        // determine the magnitude ordering of x0, y0, z0 and w0.
        // Six pair-wise comparisons are performed between each possible pair
        // of the four coordinates, and the results are used to rank the numbers.
        let rankx = 0;
        let ranky = 0;
        let rankz = 0;
        let rankw = 0;
        if (x0 > y0) rankx++;
        else ranky++;
        if (x0 > z0) rankx++;
        else rankz++;
        if (x0 > w0) rankx++;
        else rankw++;
        if (y0 > z0) ranky++;
        else rankz++;
        if (y0 > w0) ranky++;
        else rankw++;
        if (z0 > w0) rankz++;
        else rankw++;
        // simplex[c] is a 4-vector with the numbers 0, 1, 2 and 3 in some order.
        // Many values of c will never occur, since e.g. x>y>z>w makes x<z, y<w and x<w
        // impossible. Only the 24 indices which have non-zero entries make any sense.
        // We use a thresholding to set the coordinates in turn from the largest magnitude.
        // Rank 3 denotes the largest coordinate.
        // Rank 2 denotes the second largest coordinate.
        // Rank 1 denotes the second smallest coordinate.
        // The integer offsets for the second simplex corner
        const i1 = rankx >= 3 ? 1 : 0;
        const j1 = ranky >= 3 ? 1 : 0;
        const k1 = rankz >= 3 ? 1 : 0;
        const l1 = rankw >= 3 ? 1 : 0;
        // The integer offsets for the third simplex corner
        const i2 = rankx >= 2 ? 1 : 0;
        const j2 = ranky >= 2 ? 1 : 0;
        const k2 = rankz >= 2 ? 1 : 0;
        const l2 = rankw >= 2 ? 1 : 0;
        // The integer offsets for the fourth simplex corner
        const i3 = rankx >= 1 ? 1 : 0;
        const j3 = ranky >= 1 ? 1 : 0;
        const k3 = rankz >= 1 ? 1 : 0;
        const l3 = rankw >= 1 ? 1 : 0;
        // The fifth corner has all coordinate offsets = 1, so no need to compute that.
        const x1 = x0 - i1 + $396f98d271b2a856$var$G4; // Offsets for second corner in (x,y,z,w) coords
        const y1 = y0 - j1 + $396f98d271b2a856$var$G4;
        const z1 = z0 - k1 + $396f98d271b2a856$var$G4;
        const w1 = w0 - l1 + $396f98d271b2a856$var$G4;
        const x2 = x0 - i2 + 2.0 * $396f98d271b2a856$var$G4; // Offsets for third corner in (x,y,z,w) coords
        const y2 = y0 - j2 + 2.0 * $396f98d271b2a856$var$G4;
        const z2 = z0 - k2 + 2.0 * $396f98d271b2a856$var$G4;
        const w2 = w0 - l2 + 2.0 * $396f98d271b2a856$var$G4;
        const x3 = x0 - i3 + 3.0 * $396f98d271b2a856$var$G4; // Offsets for fourth corner in (x,y,z,w) coords
        const y3 = y0 - j3 + 3.0 * $396f98d271b2a856$var$G4;
        const z3 = z0 - k3 + 3.0 * $396f98d271b2a856$var$G4;
        const w3 = w0 - l3 + 3.0 * $396f98d271b2a856$var$G4;
        const x4 = x0 - 1.0 + 4.0 * $396f98d271b2a856$var$G4; // Offsets for last corner in (x,y,z,w) coords
        const y4 = y0 - 1.0 + 4.0 * $396f98d271b2a856$var$G4;
        const z4 = z0 - 1.0 + 4.0 * $396f98d271b2a856$var$G4;
        const w4 = w0 - 1.0 + 4.0 * $396f98d271b2a856$var$G4;
        // Work out the hashed gradient indices of the five simplex corners
        const ii = i & 255;
        const jj = j & 255;
        const kk = k & 255;
        const ll = l & 255;
        // Calculate the contribution from the five corners
        let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
        if (t0 < 0) n0 = 0.0;
        else {
            const gi0 = ii + perm[jj + perm[kk + perm[ll]]];
            t0 *= t0;
            n0 = t0 * t0 * (permGrad4x[gi0] * x0 + permGrad4y[gi0] * y0 + permGrad4z[gi0] * z0 + permGrad4w[gi0] * w0);
        }
        let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
        if (t1 < 0) n1 = 0.0;
        else {
            const gi1 = ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]];
            t1 *= t1;
            n1 = t1 * t1 * (permGrad4x[gi1] * x1 + permGrad4y[gi1] * y1 + permGrad4z[gi1] * z1 + permGrad4w[gi1] * w1);
        }
        let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
        if (t2 < 0) n2 = 0.0;
        else {
            const gi2 = ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]];
            t2 *= t2;
            n2 = t2 * t2 * (permGrad4x[gi2] * x2 + permGrad4y[gi2] * y2 + permGrad4z[gi2] * z2 + permGrad4w[gi2] * w2);
        }
        let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
        if (t3 < 0) n3 = 0.0;
        else {
            const gi3 = ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]];
            t3 *= t3;
            n3 = t3 * t3 * (permGrad4x[gi3] * x3 + permGrad4y[gi3] * y3 + permGrad4z[gi3] * z3 + permGrad4w[gi3] * w3);
        }
        let t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
        if (t4 < 0) n4 = 0.0;
        else {
            const gi4 = ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]];
            t4 *= t4;
            n4 = t4 * t4 * (permGrad4x[gi4] * x4 + permGrad4y[gi4] * y4 + permGrad4z[gi4] * z4 + permGrad4w[gi4] * w4);
        }
        // Sum up and scale the result to cover the range [-1,1]
        return 27.0 * (n0 + n1 + n2 + n3 + n4);
    };
}
function $396f98d271b2a856$export$98cd52c6119fe283(random) {
    const tableSize = 512;
    const p = new Uint8Array(tableSize);
    for(let i = 0; i < tableSize / 2; i++)p[i] = i;
    for(let i = 0; i < tableSize / 2 - 1; i++){
        const r = i + ~~(random() * (256 - i));
        const aux = p[i];
        p[i] = p[r];
        p[r] = aux;
    }
    for(let i = 256; i < tableSize; i++)p[i] = p[i - 256];
    return p;
}





const $66b949a687a6d7c0$export$372214499a215ae2 = 3.0;
class $66b949a687a6d7c0$export$2e2bcd8739ae039 {
    constructor(path, index){
        this.path = path;
        this.curve = path.curve;
        this.index = index;
        this.name = this.constructor.name;
        this.settings = {
            seed: 22 + index,
            range: {
                min: 0,
                max: 1
            }
        };
        this.noise2D = (0, $396f98d271b2a856$export$9de79e9646a874e5)((0, (/*@__PURE__*/$parcel$interopDefault($3dca7fe4af39e080$exports)))(this.settings.seed));
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tween = {
            ini: 0,
            end: 1,
            t: 0
        };
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
    }
    initData(data) {
        if (!data) return;
        this.settings = {
            ...this.settings,
            ...data.settings
        };
        this.onSeedChange();
    }
    updatePositions() {}
    updateColors() {}
    updateGUIColorRadio() {
        const { guiColorRadio: guiColorRadio, folder: folder, settings: settings } = this;
        const { colorIdx: colorIdx } = this.settings;
        let disabled;
        if (!folder) return;
        if (guiColorRadio) {
            disabled = guiColorRadio.disabled;
            folder.remove(guiColorRadio);
        }
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const idx = colorIdx % lng;
        const hex = kit.colors[idx];
        this.guiColorRadio = folder.addInput(settings, 'colorIdx', {
            view: 'radiogrid',
            groupName: 'colorIdx',
            size: [
                lng,
                1
            ],
            cells: (x, y)=>({
                    title: `${x}`,
                    value: x
                }),
            label: 'colorIdx',
            disabled: disabled
        }).on('change', ()=>{
            this.updateColors(true);
        });
        // hack element's background color
        const children = this.guiColorRadio.element.children[1].children[0].children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child.style.background = kit.colors[i % lng];
        }
    }
    serialize() {
        const { name: name, settings: settings } = this;
        return {
            name: name,
            settings: settings
        };
    }
    dispose() {
        this.timeline.kill();
        this.folder?.dispose();
        this.object3D.clear();
        this.object3D = null;
        this.path = null;
        this.curve = null;
        this.noise2D = null;
        this.timeline = null;
        this.folder = null;
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    preShow() {
        // immediate hide
        this.onShowUpdate(0);
    }
    showHide(showDelay = 0, hideDelay = 0, onComplete) {
        const { speed: speed } = this;
        const show = this.show();
        const hide = this.hide();
        const showDuration = $66b949a687a6d7c0$export$372214499a215ae2 * speed;
        const hideDuration = $66b949a687a6d7c0$export$372214499a215ae2 * speed;
        // the first path starts hiding when its show is complete
        if (!this.path.index) hideDelay += showDuration;
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: onComplete
        });
        this.timeline.add(show, showDelay);
        this.timeline.add(hide, hideDelay);
        this.timeline.play(0);
        // the others start hiding when the previous path hide is complete
        let hideComplete = this.timeline.duration();
        if (this.name == 'Poly') hideComplete = Math.min(this.timeline.duration(), $66b949a687a6d7c0$export$372214499a215ae2);
        return {
            showDuration: showDuration,
            hideComplete: hideComplete
        };
    }
    show() {
        const { tween: tween, path: path, speed: speed } = this;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.onShowUpdate(tween.end)
        });
        const duration = $66b949a687a6d7c0$export$372214499a215ae2 * speed;
        timeline.set(tween, {
            end: 0
        }, 0);
        timeline.to(tween, {
            end: 1,
            duration: duration,
            ease: 'sine.out'
        }, 0);
        return timeline;
    }
    hide() {
        const { tween: tween, path: path, speed: speed } = this;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.onHideUpdate(tween.ini)
        });
        const duration = $66b949a687a6d7c0$export$372214499a215ae2 * speed;
        timeline.set(tween, {
            ini: 0
        }, 0);
        timeline.to(tween, {
            ini: 1,
            duration: duration,
            ease: 'quad.in'
        }, 0);
        return timeline;
    }
    onShowUpdate(t) {}
    onHideUpdate(t) {}
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onEditModeChange(value) {}
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        if (!(0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)()) return;
        if (!parent) parent = this.path.folder;
        const onRemoveClick = ()=>{
            this.path.removeStyle(this.index);
        };
        const onVisibleClick = (value)=>{
            this.object3D.visible = value;
        };
        const onFold = (e)=>{
            (0, $f99d9b9bcbcf0b76$export$7991a91610b2c96e)(parent, e.target, e.expanded);
        };
        const { index: index, name: name, settings: settings } = this;
        const folder = (0, $f99d9b9bcbcf0b76$export$11e5e2379ae5b62d)(parent, {
            title: `${index}. ${name}`,
            type: (0, $f99d9b9bcbcf0b76$export$b3ae4990585bc4b5),
            onRemoveClick: onRemoveClick,
            onVisibleClick: onVisibleClick
        });
        folder.on('fold', onFold);
        folder.expanded = false;
        folder.addInput(settings, 'seed', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.onSeedChange.bind(this));
        folder.addInput(settings, 'range', {
            min: 0,
            max: 1
        }).on('change', this.onRangeChange.bind(this));
        this.folder = folder;
        return folder;
    }
    onSeedChange() {
        this.noise2D = (0, $396f98d271b2a856$export$9de79e9646a874e5)((0, (/*@__PURE__*/$parcel$interopDefault($3dca7fe4af39e080$exports)))(this.settings.seed));
        this.updatePositions();
    }
    onRangeChange() {
        this.updatePositions();
    }
    // ---------------------------------------------------------------------------------------------
    // GETTERS / SETTERS
    // ---------------------------------------------------------------------------------------------
    get speed() {
        const { path: path } = this;
        const { range: range } = this.settings;
        let _minSpeed = 0.2;
        let _length, _speed;
        _length = path ? path.curve.getLength() : 1000;
        if (range) _length *= range.max - range.min;
        _speed = _length * 0.001;
        _speed = Math.max(_minSpeed, _speed);
        return _speed;
    }
}






var $51fdfe9b2ce21e2b$exports = {};
$51fdfe9b2ce21e2b$exports = "#define GLSLIFY 1\nuniform float uBillboard;\n\nvarying vec2 vUv;\n\nvoid main() {\n\tvUv = uv;\n\n\t// billboard\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\n\tvec4 mvPosition = modelViewMatrix * vec4(0.0, 0.0, 0.0, 1.0);\n\tmvPosition.xy += position.xy * scale;\n\tvec4 bbPosition = projectionMatrix * mvPosition;\n\n\t// perspective\n\tvec4 ppPosition = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n\tgl_Position = mix(ppPosition, bbPosition, uBillboard);\n}\n";


var $07d9070fa52ea5b0$exports = {};
$07d9070fa52ea5b0$exports = "#define GLSLIFY 1\nuniform sampler2D uTexture;\nuniform vec2 uTextureSize;\nuniform vec3 uColor;\nuniform vec4 uFactor; // x: swap, y: pixelation, z: swap, w: random\nuniform vec4 uMask;\nuniform float uOutline;\nuniform float uThickness;\n\nvarying vec2 vUv;\n\n// ------------------------------------\n// SOBEL\n// ------------------------------------\n\n// https://www.shadertoy.com/view/Mdf3zr\nfloat lookup(vec2 p, float dx, float dy, float thickness) {\n\tfloat d = thickness * 0.03;\n\tvec2 uv = (p.xy + vec2(dx * d, dy * d));\n\tvec4 c = texture(uTexture, uv.xy);\n\t// return as luma\n\treturn 0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b;\n}\n\nfloat simpleSobel(vec2 p, float thickness) {\n\t// simple sobel edge detection\n\tfloat gx = 0.0;\n\tgx += -1.0 * lookup(p, -1.0, -1.0, thickness);\n\tgx += -2.0 * lookup(p, -1.0,  0.0, thickness);\n\tgx += -1.0 * lookup(p, -1.0,  1.0, thickness);\n\tgx +=  1.0 * lookup(p,  1.0, -1.0, thickness);\n\tgx +=  2.0 * lookup(p,  1.0,  0.0, thickness);\n\tgx +=  1.0 * lookup(p,  1.0,  1.0, thickness);\n\n\tfloat gy = 0.0;\n\tgy += -1.0 * lookup(p, -1.0, -1.0, thickness);\n\tgy += -2.0 * lookup(p,  0.0, -1.0, thickness);\n\tgy += -1.0 * lookup(p,  1.0, -1.0, thickness);\n\tgy +=  1.0 * lookup(p, -1.0,  1.0, thickness);\n\tgy +=  2.0 * lookup(p,  0.0,  1.0, thickness);\n\tgy +=  1.0 * lookup(p,  1.0,  1.0, thickness);\n\n\tfloat g = gx*gx + gy*gy;\n\n\treturn g;\n}\n\n// ------------------------------------\n// GLITCH / SWAP\n// ------------------------------------\n\n// https://www.shadertoy.com/view/XtyXzW\nfloat rand(vec2 co){\n\treturn fract(sin(dot(co.xy, vec2(12.9898, 78.233 + uFactor.w))) * 43758.5453);\n}\n\nvec2 glitchCoord(vec2 p, vec2 gridSize) {\n\tvec2 coord = floor(p / gridSize) * gridSize;;\n\tcoord += (gridSize / 2.0);\n\treturn coord;\n}\n\nvec4 swapCoords(vec2 seed, vec2 groupSize, vec2 subGrid, vec2 blockSize) {\n\tvec2 rand2 = vec2(rand(seed), rand(seed+.1));\n\tvec2 range = subGrid - (blockSize - 1.);\n\tvec2 coord = floor(rand2 * range) / subGrid;\n\tvec2 bottomLeft = coord * groupSize;\n\tvec2 realBlockSize = (groupSize / subGrid) * blockSize;\n\tvec2 topRight = bottomLeft + realBlockSize;\n\ttopRight -= groupSize / 2.;\n\tbottomLeft -= groupSize / 2.;\n\treturn vec4(bottomLeft, topRight);\n}\n\nfloat isInBlock(vec2 pos, vec4 block) {\n\tvec2 a = sign(pos - block.xy);\n\tvec2 b = sign(block.zw - pos);\n\treturn min(sign(a.x + a.y + b.x + b.y - 3.), 0.);\n}\n\nvec2 moveDiff(vec2 pos, vec4 swapA, vec4 swapB) {\n\tvec2 diff = swapB.xy - swapA.xy;\n\treturn diff * isInBlock(pos, swapA);\n}\n\nvoid swapBlocks(inout vec2 xy, float factor) {\n\tvec2 groupSize = vec2(0.5);\n\tvec2 subGrid = vec2(2.0);\n\tvec2 blockSize = vec2(1.0);\n\tvec2 seed = vec2(factor);\n\n\tvec2 groupOffset = glitchCoord(xy, groupSize);\n\tvec2 pos = xy - groupOffset;\n\n\tvec2 seedA = seed * groupOffset;\n\tvec2 seedB = seed * (groupOffset + .1);\n\n\tvec4 swapA = swapCoords(seedA, groupSize, subGrid, blockSize);\n\tvec4 swapB = swapCoords(seedB, groupSize, subGrid, blockSize);\n\n\tvec2 newPos = pos;\n\tnewPos += moveDiff(pos, swapA, swapB) * 1.0;\n\tnewPos += moveDiff(pos, swapB, swapA) * 1.0;\n\tpos = newPos;\n\n\txy = pos + groupOffset;\n}\n\nvoid main() {\n\tvec2 uv = vUv;\n\tvec4 color = vec4(0.0);\n\t\n\tvec2 uva = uv;\n\tfloat g = 0.0;\n\n\t// texture\n\tvec4 colTex = texture2D(uTexture, uv);\n\n\t// sobel outline\n\tg = clamp(simpleSobel(uv, uThickness), 0.0, 1.0);\n\tvec4 colSob = vec4(uColor * g, colTex.a * g);\n\n\t// glitch swap + sobel\n\tswapBlocks(uva, uFactor.z);\n\tg = clamp(simpleSobel(uva, 0.3), 0.0, 1.0);\n\tvec4 colSwp = vec4(uColor * g, colTex.a * g);\n\t// vec4 colSwp = texture2D(uTexture, uva);\n\n\t// pixelate + swap + sobel\n\tvec2 pix = vec2(uFactor.y, 0.02);\n\tuva = (uv - 0.5) / pix;\n\tuva -= fract(uva) - vec2(0.5);\n\tuva = uva * pix + 0.5;\n\n\tswapBlocks(uva, uFactor.x);\n\tg = clamp(simpleSobel(uva, 0.1), 0.0, 1.0);\n\tvec4 colPix = vec4(uColor * g, g);\n\t// vec4 colPix = texture2D(uTexture, uva);\n\n\t// large pixel masks\n\tpix = vec2(0.25, 0.25 * (uTextureSize.x / uTextureSize.y));\n\tuva = (uv - 0.5) / pix;\n\tuva -= fract(uva) - vec2(0.5);\n\tuva = uva * pix + 0.5;\n\n\tvec4 colMsk = vec4(0.0);\n\tcolMsk.r = step(rand(uva + 0.0) + 0.01, uMask.r);\n\tcolMsk.g = step(rand(uva + 2.0) + 0.01, uMask.g);\n\tcolMsk.b = step(rand(uva + 3.0) + 0.01, uMask.b);\n\n\t// final colour\n\tvec4 colOut = mix(colTex, colSob, uOutline);\n\n\t// animated masks\n\tcolor = mix(color, colPix, colMsk.r);\n\tcolor = mix(color, colSwp, colMsk.g);\n\tcolor = mix(color, colOut, colMsk.b);\n\n\tgl_FragColor = color;\n}\n";


class $5a8353e817d41133$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Badge';
        this.settings = {
            asset: '',
            offset: 0.25,
            size: 40,
            dist: 20,
            distAngle: 0,
            outline: false,
            thickness: 0.3,
            colorIdx: 0,
            animation: 'COMPLEX',
            ...this.settings
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.pos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.fwd = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nml = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.up = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
        this.loader = new $f70f7eb6404ce619$export$fd1bfc71f64c538c();
        this.lastAsset = null;
        this.lastTeam = null;
        this.tween = {
            ...this.tween
        };
        this.initData(data);
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { index: index } = this;
        const { outline: outline, thickness: thickness } = this.settings;
        const geometry = new $f70f7eb6404ce619$export$967d831af31f69ce(1, 1, 4, 4);
        const material = new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
            uniforms: {
                uColor: {
                    value: new $f70f7eb6404ce619$export$892596cec99bc70e(1, 1, 1)
                },
                uBillboard: {
                    value: 1
                },
                uTexture: {
                    value: null
                },
                uTextureSize: {
                    value: new $f70f7eb6404ce619$export$c977b3e384af9ae1()
                },
                uOutline: {
                    value: outline
                },
                uThickness: {
                    value: thickness
                },
                uFactor: {
                    value: new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0.0, 0.0, 0.0, index)
                },
                uMask: {
                    value: new $f70f7eb6404ce619$export$fa7daccca11cdbe3(0.0, 0.0, 1.0, 0.0)
                }
            },
            vertexShader: (/*@__PURE__*/$parcel$interopDefault($51fdfe9b2ce21e2b$exports)),
            fragmentShader: (/*@__PURE__*/$parcel$interopDefault($07d9070fa52ea5b0$exports)),
            transparent: true,
            depthWrite: false
        });
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        this.object3D = mesh;
    }
    updatePositions() {
        const { path: path, object3D: object3D, texture: texture, tween: tween } = this;
        const { vec: vec, pos: pos, fwd: fwd, nml: nml, up: up } = this;
        const { offset: offset, size: size, dist: dist, distAngle: distAngle } = this.settings;
        const aspect = texture ? texture.image.width / texture.image.height : 1;
        const scale = size;
        const u = offset;
        path.curve.getPointAt(u, pos);
        path.curve.getTangentAt(u, fwd);
        // normal
        nml.copy(fwd).cross(up);
        // rotated around forward
        vec.copy(nml);
        vec.applyAxisAngle(fwd, -distAngle);
        vec.setLength(dist);
        vec.add(pos);
        object3D.position.copy(vec);
        object3D.scale.set(scale * aspect, scale, scale);
    }
    updateColors(skipUpdateGUI) {
        const { object3D: object3D, guiColorRadio: guiColorRadio } = this;
        const { outline: outline, thickness: thickness, colorIdx: colorIdx } = this.settings;
        this.updateAssets();
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const hex = kit.colors[colorIdx % lng];
        object3D.material.uniforms.uOutline.value = outline;
        object3D.material.uniforms.uThickness.value = thickness;
        object3D.material.uniforms.uColor.value.setStyle(hex);
        if (!skipUpdateGUI) this.updateGUIColorRadio();
    }
    updateAssets() {
        const { guiAssets: guiAssets, folder: folder, settings: settings, object3D: object3D, texture: texture, lastAsset: lastAsset, lastTeam: lastTeam } = this;
        const { asset: asset } = this.settings;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const options = {};
        // skip it nothing changed
        if (asset == lastAsset && team == lastTeam) return;
        // remove old
        if (guiAssets) folder.remove(guiAssets);
        if (texture) texture.dispose();
        if (object3D) object3D.material.uniforms.uTexture.value = null;
        team.badges.forEach((badge)=>{
            options[badge] = badge;
        });
        if (folder) this.guiAssets = folder.addInput(settings, 'asset', {
            options: options,
            index: 0
        }).on('change', this.onAssetChange.bind(this));
        // set initial
        settings.asset = options[asset] || Object.values(options)[0];
        if (settings.asset) this.onAssetChange();
        // store old
        this.lastAsset = asset;
        this.lastTeam = team;
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    show() {
        this.offsetShowStarted = false;
        this.offsetHideStarted = false;
        this.offsetShowComplete = false;
        this.object3D.material.uniforms.uMask.value.set(0.0, 0.0, 0.0, 0.0);
        this.offsetShow();
        return super.show();
    }
    onShowUpdate(t) {
        const { offset: offset } = this.settings;
    // only call show when t reaches offset
    // if (this.offsetShowStarted) return;
    // if (!t || t < offset) return;
    // this.offsetShow();
    }
    offsetShow() {
        this.offsetShowStarted = true;
        const { animation: animation } = this.settings;
        const { uMask: uMask, uFactor: uFactor } = this.object3D.material.uniforms;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: ()=>this.onOffsetShowComplete()
        });
        let frame = 0;
        let rnd;
        if (animation == 'SIMPLE') {
            timeline.set(uMask.value, {
                x: 0.0,
                y: 0.0,
                z: 0.0
            }, 0);
            timeline.to(uMask.value, {
                y: 1.0,
                duration: 0.8,
                ease: 'quad.out'
            }, 0.2);
            timeline.to(uMask.value, {
                z: 1.0,
                duration: 1.0,
                ease: 'back.out'
            }, 0.4);
        }
        if (animation == 'COMPLEX') {
            timeline.set(uMask.value, {
                x: 0.0,
                y: 0.0,
                z: 0.0
            }, 0);
            timeline.to(uMask.value, {
                x: 1.0,
                duration: 0.8,
                ease: 'quad.out'
            }, 0);
            timeline.to(uMask.value, {
                y: 1.0,
                duration: 0.8,
                ease: 'quad.out'
            }, 0.2);
            timeline.to(uMask.value, {
                z: 1.0,
                duration: 1.0,
                ease: 'back.out'
            }, 0.8);
            rnd = Math.random() > 0.5 ? 0.5 : 0.3;
            timeline.set(uFactor.value, {
                x: 0.1,
                y: 0.4
            }, 0);
            timeline.to(uFactor.value, {
                y: rnd,
                duration: 0.8,
                ease: 'linear.out',
                onUpdate: ()=>{
                    if (frame > 20) {
                        uFactor.value.x += 0.02;
                        uFactor.value.z += 0.05;
                        frame = 0;
                    }
                    frame++;
                }
            }, 0);
        }
        this.timelineShow = timeline;
        return timeline;
    }
    onOffsetShowComplete() {
        this.offsetShowComplete = true;
        if (this.offsetHideStarted) this.offsetHide();
    }
    hide() {
        this.offsetHideStarted = false;
        return super.hide();
    }
    onHideUpdate(t) {
        const { offset: offset } = this.settings;
        // only call show when t reaches offset
        if (this.offsetHideStarted) return;
        if (!t || t < offset) return;
        this.offsetHide();
    }
    offsetHide() {
        this.offsetHideStarted = true;
        if (!this.offsetShowComplete) return;
        const { animation: animation } = this.settings;
        const { uMask: uMask, uFactor: uFactor } = this.object3D.material.uniforms;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        timeline.set(uMask.value, {
            x: 0.4,
            y: 1.0,
            z: 0.4
        }, 0);
        timeline.to(uMask.value, {
            x: 0.0,
            duration: 0.8,
            ease: 'quad.in'
        }, 0.0);
        timeline.to(uMask.value, {
            y: 0.0,
            duration: 0.8,
            ease: 'quad.in'
        }, 0.0);
        timeline.to(uMask.value, {
            z: 0.0,
            duration: 0.4,
            ease: 'linear.in'
        }, 0.0);
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        const animOptions = {
            SIMPLE: 'SIMPLE',
            COMPLEX: 'COMPLEX'
        };
        if (!folder) return;
        // remove default children
        while(folder.children.length)folder.remove(folder.children[0]);
        folder.addInput(settings, 'offset', {
            min: 0,
            max: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'size', {
            min: 1,
            max: 200,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'dist', {
            min: 1,
            max: 100
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'distAngle', {
            min: -Math.PI,
            max: Math.PI
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'outline').on('change', this.updateColors.bind(this));
        folder.addInput(settings, 'thickness', {
            min: 0,
            max: 1
        }).on('change', this.updateColors.bind(this));
        folder.addInput(settings, 'animation', {
            options: animOptions
        });
        return folder;
    }
    onAssetChange(e) {
        const { loader: loader, object3D: object3D } = this;
        const { asset: asset } = this.settings;
        const url = `/badges/${asset}.png`;
        loader.load(url, (texture)=>{
            // texture.minFilter = THREE.LinearFilter;
            object3D.material.uniforms.uTexture.value = texture;
            object3D.material.uniforms.uTextureSize.value.set(texture.image.width, texture.image.height);
            this.texture = texture;
            this.updatePositions();
        });
    }
}






var $15fdc39cf459155a$exports = {};
$15fdc39cf459155a$exports = "#define GLSLIFY 1\nvarying vec2 vUv;\nvarying vec3 vColor;\n\nvoid main() {\n\tvUv = uv;\n\tvColor = instanceColor;\n\n\tfloat scale = length(instanceMatrix[0].xyz);\n\n\tvec4 mvPosition = modelViewMatrix * instanceMatrix * vec4(0.0, 0.0, 0.0, 1.0);\n\tmvPosition.xyz += position * scale;\n\n\tgl_Position = projectionMatrix * mvPosition;\n}";


var $366fb73ed3337b36$exports = {};
$366fb73ed3337b36$exports = "#define GLSLIFY 1\nuniform vec3 uColor;\n\nvarying vec2 vUv;\nvarying vec3 vColor;\n\nfloat circle (vec2 uv, float radius) {\n\tvec2 dist = uv - vec2(0.5);\n\treturn 1.0 - smoothstep(radius - (radius * 0.02), radius + (radius * 0.02), dot(dist, dist) * 4.0);\n}\n\nvoid main() {\n\tvec2 uv = vUv;\n\tvec4 color = vec4(vColor, 1.0);\n\n\t// color.a = circle(uv, 1.0);\n\t// if (color.a < 0.5) discard;\n\n\tgl_FragColor = color;\n}";


class $c6f7f9eabf29ce40$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Candy';
        this.settings = {
            colorIdx: 0,
            radius: 15,
            count: 60,
            ...this.settings
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.tweens = [];
        this.initData(data);
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { count: count } = this.settings;
        const geometry = new $f70f7eb6404ce619$export$d5c0e8d607467193(0.5, 32);
        const material = new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
            vertexShader: (/*@__PURE__*/$parcel$interopDefault($15fdc39cf459155a$exports)),
            fragmentShader: (/*@__PURE__*/$parcel$interopDefault($366fb73ed3337b36$exports)),
            depthTest: false
        });
        const mesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
        this.object3D.add(mesh);
        this.mesh = mesh;
        // store tween properties
        for(let i = 0; i < count; i++)this.tweens.push({
            scl: 1
        });
    }
    updatePositions() {
        const { path: path, mesh: mesh, noise2D: noise2D, vec: vec, dummy: dummy, tweens: tweens } = this;
        const { count: count, radius: radius } = this.settings;
        let t, scale, tween;
        if (!mesh) return;
        for(let i = 0; i < count; i++){
            t = i / count;
            tween = tweens[i];
            path.curve.getPointAt(t, vec);
            scale = radius * tween.scl;
            dummy.position.copy(vec);
            dummy.scale.set(scale, scale, scale);
            dummy.updateMatrix();
            mesh.setMatrixAt(i, dummy.matrix);
        }
        mesh.instanceMatrix.needsUpdate = true;
    }
    updateColors() {
        const { count: count } = this.settings;
        const { index: index, mesh: mesh } = this;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e();
        for(let i = 0; i < count; i++){
            color.setStyle(kit.colors[i % lng]);
            mesh.setColorAt(i, color);
        }
        mesh.instanceColor.needsUpdate = true;
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    preShow() {
        // hide all on start
        this.tweens.forEach((tween, i)=>{
            tween.scl = 0;
        });
        this.updatePositions();
    }
    show() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            timeline.set(tween, {
                scl: 0
            }, 0);
            timeline.to(tween, {
                scl: 1,
                duration: 0.5,
                ease: 'expo.out'
            }, delay);
        });
        return timeline;
    }
    hide() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            timeline.to(tween, {
                scl: 0,
                duration: 0.2,
                ease: 'expo.in'
            }, delay);
        });
        return timeline;
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        // remove default children
        while(folder.children.length)folder.remove(folder.children[0]);
        folder.addInput(settings, 'count', {
            min: 1,
            max: 200,
            step: 1
        }).on('change', this.onCountChange.bind(this));
        folder.addInput(settings, 'radius', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        return folder;
    }
    onCountChange() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
        this.object3D.clear();
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
}








var $74a4bb2f7505f887$exports = {};































$74a4bb2f7505f887$exports = {
    'backInOut': (parcelRequire("lcARq")),
    'backIn': (parcelRequire("jHF83")),
    'backOut': (parcelRequire("10NOt")),
    'bounceInOut': (parcelRequire("7pUQu")),
    'bounceIn': (parcelRequire("aaGnN")),
    'bounceOut': (parcelRequire("2IXAh")),
    'circInOut': (parcelRequire("3jp57")),
    'circIn': (parcelRequire("h1eFd")),
    'circOut': (parcelRequire("9G85D")),
    'cubicInOut': (parcelRequire("54dqr")),
    'cubicIn': (parcelRequire("laFj9")),
    'cubicOut': (parcelRequire("l8CBG")),
    'elasticInOut': (parcelRequire("4Zcfl")),
    'elasticIn': (parcelRequire("5Coxo")),
    'elasticOut': (parcelRequire("7Pty0")),
    'expoInOut': (parcelRequire("ktErU")),
    'expoIn': (parcelRequire("1U6DE")),
    'expoOut': (parcelRequire("kFT4v")),
    'linear': (parcelRequire("eG8qR")),
    'quadInOut': (parcelRequire("gqHJW")),
    'quadIn': (parcelRequire("8IRFy")),
    'quadOut': (parcelRequire("j8e1d")),
    'quartInOut': (parcelRequire("fa2P2")),
    'quartIn': (parcelRequire("jNt6y")),
    'quartOut': (parcelRequire("eHHjv")),
    'quintInOut': (parcelRequire("7sd8a")),
    'quintIn': (parcelRequire("9wzDY")),
    'quintOut': (parcelRequire("2mAMC")),
    'sineInOut': (parcelRequire("ldnK0")),
    'sineIn': (parcelRequire("5bWUt")),
    'sineOut': (parcelRequire("3JbFx"))
};



var $9313361a67659bbf$export$2e2bcd8739ae039 = (x, low = 0, high = 1)=>{
    return (0, $8468fd6f5eb24449$export$96ec731ed4dcb222)((0, $8468fd6f5eb24449$export$8960430cfd85939f)(low, x), high);
};


var $43a5039491c3ef47$export$2e2bcd8739ae039 = (rgb)=>{
    rgb._clipped = false;
    rgb._unclipped = rgb.slice(0);
    for(let i = 0; i <= 3; i++){
        if (i < 3) {
            if (rgb[i] < 0 || rgb[i] > 255) rgb._clipped = true;
            rgb[i] = (0, $9313361a67659bbf$export$2e2bcd8739ae039)(rgb[i], 0, 255);
        } else if (i === 3) rgb[i] = (0, $9313361a67659bbf$export$2e2bcd8739ae039)(rgb[i], 0, 1);
    }
    return rgb;
};



// ported from jQuery's $.type
const $a84ecdc868ecfb74$var$classToType = {};
for (let name of [
    'Boolean',
    'Number',
    'String',
    'Function',
    'Array',
    'Date',
    'RegExp',
    'Undefined',
    'Null'
])$a84ecdc868ecfb74$var$classToType[`[object ${name}]`] = name.toLowerCase();
function $a84ecdc868ecfb74$export$2e2bcd8739ae039(obj) {
    return $a84ecdc868ecfb74$var$classToType[Object.prototype.toString.call(obj)] || 'object';
}



var $57db938010502b11$export$2e2bcd8739ae039 = (args, keyOrder = null)=>{
    // if called with more than 3 arguments, we return the arguments
    if (args.length >= 3) return Array.prototype.slice.call(args);
    // with less than 3 args we check if first arg is object
    // and use the keyOrder string to extract and sort properties
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args[0]) == 'object' && keyOrder) return keyOrder.split('').filter((k)=>args[0][k] !== undefined).map((k)=>args[0][k]);
    // otherwise we just return the first argument
    // (which we suppose is an array of args)
    return args[0];
};



var $35e36155cc60a4e9$export$2e2bcd8739ae039 = (args)=>{
    if (args.length < 2) return null;
    const l = args.length - 1;
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args[l]) == 'string') return args[l].toLowerCase();
    return null;
};


const { PI: $8468fd6f5eb24449$export$6b5c1ceb16d01dc3, min: $8468fd6f5eb24449$export$96ec731ed4dcb222, max: $8468fd6f5eb24449$export$8960430cfd85939f } = Math;
const $8468fd6f5eb24449$export$af54f71c879f5ba9 = $8468fd6f5eb24449$export$6b5c1ceb16d01dc3 * 2;
const $8468fd6f5eb24449$export$e734282486210baf = $8468fd6f5eb24449$export$6b5c1ceb16d01dc3 / 3;
const $8468fd6f5eb24449$export$460c4029b1a54a2e = $8468fd6f5eb24449$export$6b5c1ceb16d01dc3 / 180;
const $8468fd6f5eb24449$export$914076c8150813e5 = 180 / $8468fd6f5eb24449$export$6b5c1ceb16d01dc3;


var $3b8568da62f7dcaf$export$2e2bcd8739ae039 = {
    format: {},
    autodetect: []
};


class $b951312f83c9af91$var$Color {
    constructor(...args){
        const me = this;
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args[0]) === 'object' && args[0].constructor && args[0].constructor === this.constructor) // the argument is already a Color instance
        return args[0];
        // last argument could be the mode
        let mode = (0, $35e36155cc60a4e9$export$2e2bcd8739ae039)(args);
        let autodetect = false;
        if (!mode) {
            autodetect = true;
            if (!(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).sorted) {
                (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect = (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.sort((a, b)=>b.p - a.p);
                (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).sorted = true;
            }
            // auto-detect format
            for (let chk of (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect){
                mode = chk.test(...args);
                if (mode) break;
            }
        }
        if ((0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format[mode]) {
            const rgb = (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format[mode].apply(null, autodetect ? args : args.slice(0, -1));
            me._rgb = (0, $43a5039491c3ef47$export$2e2bcd8739ae039)(rgb);
        } else throw new Error('unknown format: ' + args);
        // add alpha channel
        if (me._rgb.length === 3) me._rgb.push(1);
    }
    toString() {
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(this.hex) == 'function') return this.hex();
        return `[${this._rgb.join(',')}]`;
    }
}
var $b951312f83c9af91$export$2e2bcd8739ae039 = $b951312f83c9af91$var$Color;


// this gets updated automatically
const $9db4381526d76d12$export$83d89fbfd8236492 = '2.6.0';


const $1f8e68471883117b$var$chroma = (...args)=>{
    return new $1f8e68471883117b$var$chroma.Color(...args);
};
$1f8e68471883117b$var$chroma.Color = (0, $b951312f83c9af91$export$2e2bcd8739ae039);
$1f8e68471883117b$var$chroma.version = (0, $9db4381526d76d12$export$83d89fbfd8236492);
var $1f8e68471883117b$export$2e2bcd8739ae039 = $1f8e68471883117b$var$chroma;







const $48faa590f49bbbfc$var$cmyk2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'cmyk');
    const [c, m, y, k] = args;
    const alpha = args.length > 4 ? args[4] : 1;
    if (k === 1) return [
        0,
        0,
        0,
        alpha
    ];
    return [
        c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
        m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
        y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
        alpha
    ];
};
var $48faa590f49bbbfc$export$2e2bcd8739ae039 = $48faa590f49bbbfc$var$cmyk2rgb;



const { max: $b850b8a70a6daaa9$var$max } = Math;
const $b850b8a70a6daaa9$var$rgb2cmyk = (...args)=>{
    let [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    r = r / 255;
    g = g / 255;
    b = b / 255;
    const k = 1 - $b850b8a70a6daaa9$var$max(r, $b850b8a70a6daaa9$var$max(g, b));
    const f = k < 1 ? 1 / (1 - k) : 0;
    const c = (1 - r - k) * f;
    const m = (1 - g - k) * f;
    const y = (1 - b - k) * f;
    return [
        c,
        m,
        y,
        k
    ];
};
var $b850b8a70a6daaa9$export$2e2bcd8739ae039 = $b850b8a70a6daaa9$var$rgb2cmyk;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.cmyk = function() {
    return (0, $b850b8a70a6daaa9$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).cmyk = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'cmyk');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.cmyk = (0, $48faa590f49bbbfc$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'cmyk');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 4) return 'cmyk';
    }
});








const $793c9d096aa55751$var$rnd = (a)=>Math.round(a * 100) / 100;
/*
 * supported arguments:
 * - hsl2css(h,s,l)
 * - hsl2css(h,s,l,a)
 * - hsl2css([h,s,l], mode)
 * - hsl2css([h,s,l,a], mode)
 * - hsl2css({h,s,l,a}, mode)
 */ const $793c9d096aa55751$var$hsl2css = (...args)=>{
    const hsla = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsla');
    let mode = (0, $35e36155cc60a4e9$export$2e2bcd8739ae039)(args) || 'lsa';
    hsla[0] = $793c9d096aa55751$var$rnd(hsla[0] || 0);
    hsla[1] = $793c9d096aa55751$var$rnd(hsla[1] * 100) + '%';
    hsla[2] = $793c9d096aa55751$var$rnd(hsla[2] * 100) + '%';
    if (mode === 'hsla' || hsla.length > 3 && hsla[3] < 1) {
        hsla[3] = hsla.length > 3 ? hsla[3] : 1;
        mode = 'hsla';
    } else hsla.length = 3;
    return `${mode}(${hsla.join(',')})`;
};
var $793c9d096aa55751$export$2e2bcd8739ae039 = $793c9d096aa55751$var$hsl2css;



/*
 * supported arguments:
 * - rgb2hsl(r,g,b)
 * - rgb2hsl(r,g,b,a)
 * - rgb2hsl([r,g,b])
 * - rgb2hsl([r,g,b,a])
 * - rgb2hsl({r,g,b,a})
 */ const $49bb6fb5a8fa17ee$var$rgb2hsl = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgba');
    let [r, g, b] = args;
    r /= 255;
    g /= 255;
    b /= 255;
    const minRgb = (0, $8468fd6f5eb24449$export$96ec731ed4dcb222)(r, g, b);
    const maxRgb = (0, $8468fd6f5eb24449$export$8960430cfd85939f)(r, g, b);
    const l = (maxRgb + minRgb) / 2;
    let s, h;
    if (maxRgb === minRgb) {
        s = 0;
        h = Number.NaN;
    } else s = l < 0.5 ? (maxRgb - minRgb) / (maxRgb + minRgb) : (maxRgb - minRgb) / (2 - maxRgb - minRgb);
    if (r == maxRgb) h = (g - b) / (maxRgb - minRgb);
    else if (g == maxRgb) h = 2 + (b - r) / (maxRgb - minRgb);
    else if (b == maxRgb) h = 4 + (r - g) / (maxRgb - minRgb);
    h *= 60;
    if (h < 0) h += 360;
    if (args.length > 3 && args[3] !== undefined) return [
        h,
        s,
        l,
        args[3]
    ];
    return [
        h,
        s,
        l
    ];
};
var $49bb6fb5a8fa17ee$export$2e2bcd8739ae039 = $49bb6fb5a8fa17ee$var$rgb2hsl;


const { round: $e289687d990fcb77$var$round } = Math;
/*
 * supported arguments:
 * - rgb2css(r,g,b)
 * - rgb2css(r,g,b,a)
 * - rgb2css([r,g,b], mode)
 * - rgb2css([r,g,b,a], mode)
 * - rgb2css({r,g,b,a}, mode)
 */ const $e289687d990fcb77$var$rgb2css = (...args)=>{
    const rgba = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgba');
    let mode = (0, $35e36155cc60a4e9$export$2e2bcd8739ae039)(args) || 'rgb';
    if (mode.substr(0, 3) == 'hsl') return (0, $793c9d096aa55751$export$2e2bcd8739ae039)((0, $49bb6fb5a8fa17ee$export$2e2bcd8739ae039)(rgba), mode);
    rgba[0] = $e289687d990fcb77$var$round(rgba[0]);
    rgba[1] = $e289687d990fcb77$var$round(rgba[1]);
    rgba[2] = $e289687d990fcb77$var$round(rgba[2]);
    if (mode === 'rgba' || rgba.length > 3 && rgba[3] < 1) {
        rgba[3] = rgba.length > 3 ? rgba[3] : 1;
        mode = 'rgba';
    }
    return `${mode}(${rgba.slice(0, mode === 'rgb' ? 3 : 4).join(',')})`;
};
var $e289687d990fcb77$export$2e2bcd8739ae039 = $e289687d990fcb77$var$rgb2css;



const { round: $1643c28364bcf931$var$round } = Math;
const $1643c28364bcf931$var$hsl2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsl');
    const [h, s, l] = args;
    let r, g, b;
    if (s === 0) r = g = b = l * 255;
    else {
        const t3 = [
            0,
            0,
            0
        ];
        const c = [
            0,
            0,
            0
        ];
        const t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const t1 = 2 * l - t2;
        const h_ = h / 360;
        t3[0] = h_ + 1 / 3;
        t3[1] = h_;
        t3[2] = h_ - 1 / 3;
        for(let i = 0; i < 3; i++){
            if (t3[i] < 0) t3[i] += 1;
            if (t3[i] > 1) t3[i] -= 1;
            if (6 * t3[i] < 1) c[i] = t1 + (t2 - t1) * 6 * t3[i];
            else if (2 * t3[i] < 1) c[i] = t2;
            else if (3 * t3[i] < 2) c[i] = t1 + (t2 - t1) * (2 / 3 - t3[i]) * 6;
            else c[i] = t1;
        }
        [r, g, b] = [
            $1643c28364bcf931$var$round(c[0] * 255),
            $1643c28364bcf931$var$round(c[1] * 255),
            $1643c28364bcf931$var$round(c[2] * 255)
        ];
    }
    if (args.length > 3) // keep alpha channel
    return [
        r,
        g,
        b,
        args[3]
    ];
    return [
        r,
        g,
        b,
        1
    ];
};
var $1643c28364bcf931$export$2e2bcd8739ae039 = $1643c28364bcf931$var$hsl2rgb;



const $85fad44feee7791d$var$RE_RGB = /^rgb\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*\)$/;
const $85fad44feee7791d$var$RE_RGBA = /^rgba\(\s*(-?\d+),\s*(-?\d+)\s*,\s*(-?\d+)\s*,\s*([01]|[01]?\.\d+)\)$/;
const $85fad44feee7791d$var$RE_RGB_PCT = /^rgb\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
const $85fad44feee7791d$var$RE_RGBA_PCT = /^rgba\(\s*(-?\d+(?:\.\d+)?)%,\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const $85fad44feee7791d$var$RE_HSL = /^hsl\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*\)$/;
const $85fad44feee7791d$var$RE_HSLA = /^hsla\(\s*(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)%\s*,\s*(-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)$/;
const { round: $85fad44feee7791d$var$round } = Math;
const $85fad44feee7791d$var$css2rgb = (css)=>{
    css = css.toLowerCase().trim();
    let m;
    if ((0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.named) try {
        return (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.named(css);
    // eslint-disable-next-line
    } catch (e) {}
    // rgb(250,20,0)
    if (m = css.match($85fad44feee7791d$var$RE_RGB)) {
        const rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = +rgb[i];
        rgb[3] = 1; // default alpha
        return rgb;
    }
    // rgba(250,20,0,0.4)
    if (m = css.match($85fad44feee7791d$var$RE_RGBA)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 4; i++)rgb[i] = +rgb[i];
        return rgb;
    }
    // rgb(100%,0%,0%)
    if (m = css.match($85fad44feee7791d$var$RE_RGB_PCT)) {
        const rgb = m.slice(1, 4);
        for(let i = 0; i < 3; i++)rgb[i] = $85fad44feee7791d$var$round(rgb[i] * 2.55);
        rgb[3] = 1; // default alpha
        return rgb;
    }
    // rgba(100%,0%,0%,0.4)
    if (m = css.match($85fad44feee7791d$var$RE_RGBA_PCT)) {
        const rgb = m.slice(1, 5);
        for(let i = 0; i < 3; i++)rgb[i] = $85fad44feee7791d$var$round(rgb[i] * 2.55);
        rgb[3] = +rgb[3];
        return rgb;
    }
    // hsl(0,100%,50%)
    if (m = css.match($85fad44feee7791d$var$RE_HSL)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $1643c28364bcf931$export$2e2bcd8739ae039)(hsl);
        rgb[3] = 1;
        return rgb;
    }
    // hsla(0,100%,50%,0.5)
    if (m = css.match($85fad44feee7791d$var$RE_HSLA)) {
        const hsl = m.slice(1, 4);
        hsl[1] *= 0.01;
        hsl[2] *= 0.01;
        const rgb = (0, $1643c28364bcf931$export$2e2bcd8739ae039)(hsl);
        rgb[3] = +m[4]; // default alpha = 1
        return rgb;
    }
};
$85fad44feee7791d$var$css2rgb.test = (s)=>{
    return $85fad44feee7791d$var$RE_RGB.test(s) || $85fad44feee7791d$var$RE_RGBA.test(s) || $85fad44feee7791d$var$RE_RGB_PCT.test(s) || $85fad44feee7791d$var$RE_RGBA_PCT.test(s) || $85fad44feee7791d$var$RE_HSL.test(s) || $85fad44feee7791d$var$RE_HSLA.test(s);
};
var $85fad44feee7791d$export$2e2bcd8739ae039 = $85fad44feee7791d$var$css2rgb;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.css = function(mode) {
    return (0, $e289687d990fcb77$export$2e2bcd8739ae039)(this._rgb, mode);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).css = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'css');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.css = (0, $85fad44feee7791d$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(h) === 'string' && (0, $85fad44feee7791d$export$2e2bcd8739ae039).test(h)) return 'css';
    }
});






(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.gl = (...args)=>{
    const rgb = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgba');
    rgb[0] *= 255;
    rgb[1] *= 255;
    rgb[2] *= 255;
    return rgb;
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).gl = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'gl');
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.gl = function() {
    const rgb = this._rgb;
    return [
        rgb[0] / 255,
        rgb[1] / 255,
        rgb[2] / 255,
        rgb[3]
    ];
};







const { floor: $c151eafe509960c9$var$floor } = Math;
/*
 * this is basically just HSV with some minor tweaks
 *
 * hue.. [0..360]
 * chroma .. [0..1]
 * grayness .. [0..1]
 */ const $c151eafe509960c9$var$hcg2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hcg');
    let [h, c, _g] = args;
    let r, g, b;
    _g = _g * 255;
    const _c = c * 255;
    if (c === 0) r = g = b = _g;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $c151eafe509960c9$var$floor(h);
        const f = h - i;
        const p = _g * (1 - c);
        const q = p + _c * (1 - f);
        const t = p + _c * f;
        const v = p + _c;
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $c151eafe509960c9$export$2e2bcd8739ae039 = $c151eafe509960c9$var$hcg2rgb;



const $6a67531f07b21d40$var$rgb2hcg = (...args)=>{
    const [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    const minRgb = (0, $8468fd6f5eb24449$export$96ec731ed4dcb222)(r, g, b);
    const maxRgb = (0, $8468fd6f5eb24449$export$8960430cfd85939f)(r, g, b);
    const delta = maxRgb - minRgb;
    const c = delta * 100 / 255;
    const _g = minRgb / (255 - delta) * 100;
    let h;
    if (delta === 0) h = Number.NaN;
    else {
        if (r === maxRgb) h = (g - b) / delta;
        if (g === maxRgb) h = 2 + (b - r) / delta;
        if (b === maxRgb) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        c,
        _g
    ];
};
var $6a67531f07b21d40$export$2e2bcd8739ae039 = $6a67531f07b21d40$var$rgb2hcg;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.hcg = function() {
    return (0, $6a67531f07b21d40$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).hcg = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'hcg');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.hcg = (0, $c151eafe509960c9$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 1,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hcg');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hcg';
    }
});






const $f838b8e082d144ff$var$RE_HEX = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
const $f838b8e082d144ff$var$RE_HEXA = /^#?([A-Fa-f0-9]{8}|[A-Fa-f0-9]{4})$/;
const $f838b8e082d144ff$var$hex2rgb = (hex)=>{
    if (hex.match($f838b8e082d144ff$var$RE_HEX)) {
        // remove optional leading #
        if (hex.length === 4 || hex.length === 7) hex = hex.substr(1);
        // expand short-notation to full six-digit
        if (hex.length === 3) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const u = parseInt(hex, 16);
        const r = u >> 16;
        const g = u >> 8 & 0xff;
        const b = u & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    // match rgba hex format, eg #FF000077
    if (hex.match($f838b8e082d144ff$var$RE_HEXA)) {
        if (hex.length === 5 || hex.length === 9) // remove optional leading #
        hex = hex.substr(1);
        // expand short-notation to full eight-digit
        if (hex.length === 4) {
            hex = hex.split('');
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
        }
        const u = parseInt(hex, 16);
        const r = u >> 24 & 0xff;
        const g = u >> 16 & 0xff;
        const b = u >> 8 & 0xff;
        const a = Math.round((u & 0xff) / 0xff * 100) / 100;
        return [
            r,
            g,
            b,
            a
        ];
    }
    // we used to check for css colors here
    // if _input.css? and rgb = _input.css hex
    //     return rgb
    throw new Error(`unknown hex color: ${hex}`);
};
var $f838b8e082d144ff$export$2e2bcd8739ae039 = $f838b8e082d144ff$var$hex2rgb;



const { round: $3650121ffcc295f7$var$round } = Math;
const $3650121ffcc295f7$var$rgb2hex = (...args)=>{
    let [r, g, b, a] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgba');
    let mode = (0, $35e36155cc60a4e9$export$2e2bcd8739ae039)(args) || 'auto';
    if (a === undefined) a = 1;
    if (mode === 'auto') mode = a < 1 ? 'rgba' : 'rgb';
    r = $3650121ffcc295f7$var$round(r);
    g = $3650121ffcc295f7$var$round(g);
    b = $3650121ffcc295f7$var$round(b);
    const u = r << 16 | g << 8 | b;
    let str = '000000' + u.toString(16); //#.toUpperCase();
    str = str.substr(str.length - 6);
    let hxa = '0' + $3650121ffcc295f7$var$round(a * 255).toString(16);
    hxa = hxa.substr(hxa.length - 2);
    switch(mode.toLowerCase()){
        case 'rgba':
            return `#${str}${hxa}`;
        case 'argb':
            return `#${hxa}${str}`;
        default:
            return `#${str}`;
    }
};
var $3650121ffcc295f7$export$2e2bcd8739ae039 = $3650121ffcc295f7$var$rgb2hex;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.hex = function(mode) {
    return (0, $3650121ffcc295f7$export$2e2bcd8739ae039)(this._rgb, mode);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).hex = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'hex');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.hex = (0, $f838b8e082d144ff$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 4,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(h) === 'string' && [
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ].indexOf(h.length) >= 0) return 'hex';
    }
});







const { cos: $74a3fb7c1c8557a9$var$cos } = Math;
/*
 * hue [0..360]
 * saturation [0..1]
 * intensity [0..1]
 */ const $74a3fb7c1c8557a9$var$hsi2rgb = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
    */ args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsi');
    let [h, s, i] = args;
    let r, g, b;
    if (isNaN(h)) h = 0;
    if (isNaN(s)) s = 0;
    // normalize hue
    if (h > 360) h -= 360;
    if (h < 0) h += 360;
    h /= 360;
    if (h < 1 / 3) {
        b = (1 - s) / 3;
        r = (1 + s * $74a3fb7c1c8557a9$var$cos((0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * h) / $74a3fb7c1c8557a9$var$cos((0, $8468fd6f5eb24449$export$e734282486210baf) - (0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * h)) / 3;
        g = 1 - (b + r);
    } else if (h < 2 / 3) {
        h -= 1 / 3;
        r = (1 - s) / 3;
        g = (1 + s * $74a3fb7c1c8557a9$var$cos((0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * h) / $74a3fb7c1c8557a9$var$cos((0, $8468fd6f5eb24449$export$e734282486210baf) - (0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * h)) / 3;
        b = 1 - (r + g);
    } else {
        h -= 2 / 3;
        g = (1 - s) / 3;
        b = (1 + s * $74a3fb7c1c8557a9$var$cos((0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * h) / $74a3fb7c1c8557a9$var$cos((0, $8468fd6f5eb24449$export$e734282486210baf) - (0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * h)) / 3;
        r = 1 - (g + b);
    }
    r = (0, $9313361a67659bbf$export$2e2bcd8739ae039)(i * r * 3);
    g = (0, $9313361a67659bbf$export$2e2bcd8739ae039)(i * g * 3);
    b = (0, $9313361a67659bbf$export$2e2bcd8739ae039)(i * b * 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        args.length > 3 ? args[3] : 1
    ];
};
var $74a3fb7c1c8557a9$export$2e2bcd8739ae039 = $74a3fb7c1c8557a9$var$hsi2rgb;



const { min: $2c87bba5afb67760$var$min, sqrt: $2c87bba5afb67760$var$sqrt, acos: $2c87bba5afb67760$var$acos } = Math;
const $2c87bba5afb67760$var$rgb2hsi = (...args)=>{
    /*
    borrowed from here:
    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
    */ let [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    r /= 255;
    g /= 255;
    b /= 255;
    let h;
    const min_ = $2c87bba5afb67760$var$min(r, g, b);
    const i = (r + g + b) / 3;
    const s = i > 0 ? 1 - min_ / i : 0;
    if (s === 0) h = NaN;
    else {
        h = (r - g + (r - b)) / 2;
        h /= $2c87bba5afb67760$var$sqrt((r - g) * (r - g) + (r - b) * (g - b));
        h = $2c87bba5afb67760$var$acos(h);
        if (b > g) h = (0, $8468fd6f5eb24449$export$af54f71c879f5ba9) - h;
        h /= (0, $8468fd6f5eb24449$export$af54f71c879f5ba9);
    }
    return [
        h * 360,
        s,
        i
    ];
};
var $2c87bba5afb67760$export$2e2bcd8739ae039 = $2c87bba5afb67760$var$rgb2hsi;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.hsi = function() {
    return (0, $2c87bba5afb67760$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).hsi = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'hsi');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.hsi = (0, $74a3fb7c1c8557a9$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsi');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsi';
    }
});








(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.hsl = function() {
    return (0, $49bb6fb5a8fa17ee$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).hsl = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'hsl');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.hsl = (0, $1643c28364bcf931$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsl');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsl';
    }
});







const { floor: $f070256930e8ddff$var$floor } = Math;
const $f070256930e8ddff$var$hsv2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsv');
    let [h, s, v] = args;
    let r, g, b;
    v *= 255;
    if (s === 0) r = g = b = v;
    else {
        if (h === 360) h = 0;
        if (h > 360) h -= 360;
        if (h < 0) h += 360;
        h /= 60;
        const i = $f070256930e8ddff$var$floor(h);
        const f = h - i;
        const p = v * (1 - s);
        const q = v * (1 - s * f);
        const t = v * (1 - s * (1 - f));
        switch(i){
            case 0:
                [r, g, b] = [
                    v,
                    t,
                    p
                ];
                break;
            case 1:
                [r, g, b] = [
                    q,
                    v,
                    p
                ];
                break;
            case 2:
                [r, g, b] = [
                    p,
                    v,
                    t
                ];
                break;
            case 3:
                [r, g, b] = [
                    p,
                    q,
                    v
                ];
                break;
            case 4:
                [r, g, b] = [
                    t,
                    p,
                    v
                ];
                break;
            case 5:
                [r, g, b] = [
                    v,
                    p,
                    q
                ];
                break;
        }
    }
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $f070256930e8ddff$export$2e2bcd8739ae039 = $f070256930e8ddff$var$hsv2rgb;



const { min: $f36407be4cae0dfa$var$min, max: $f36407be4cae0dfa$var$max } = Math;
/*
 * supported arguments:
 * - rgb2hsv(r,g,b)
 * - rgb2hsv([r,g,b])
 * - rgb2hsv({r,g,b})
 */ const $f36407be4cae0dfa$var$rgb2hsl = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    let [r, g, b] = args;
    const min_ = $f36407be4cae0dfa$var$min(r, g, b);
    const max_ = $f36407be4cae0dfa$var$max(r, g, b);
    const delta = max_ - min_;
    let h, s, v;
    v = max_ / 255.0;
    if (max_ === 0) {
        h = Number.NaN;
        s = 0;
    } else {
        s = delta / max_;
        if (r === max_) h = (g - b) / delta;
        if (g === max_) h = 2 + (b - r) / delta;
        if (b === max_) h = 4 + (r - g) / delta;
        h *= 60;
        if (h < 0) h += 360;
    }
    return [
        h,
        s,
        v
    ];
};
var $f36407be4cae0dfa$export$2e2bcd8739ae039 = $f36407be4cae0dfa$var$rgb2hsl;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.hsv = function() {
    return (0, $f36407be4cae0dfa$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).hsv = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'hsv');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.hsv = (0, $f070256930e8ddff$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hsv');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'hsv';
    }
});






var $dc78c652ecf850f2$export$2e2bcd8739ae039 = {
    // Corresponds roughly to RGB brighter/darker
    Kn: 18,
    // D65 standard referent
    Xn: 0.95047,
    Yn: 1,
    Zn: 1.08883,
    t0: 0.137931034,
    t1: 0.206896552,
    t2: 0.12841855,
    t3: 0.008856452 // t1 * t1 * t1
};



const { pow: $4dbb3730e23708c6$var$pow } = Math;
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $4dbb3730e23708c6$var$lab2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lab');
    const [l, a, b] = args;
    let x, y, z, r, g, b_;
    y = (l + 16) / 116;
    x = isNaN(a) ? y : y + a / 500;
    z = isNaN(b) ? y : y - b / 200;
    y = (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Yn * $4dbb3730e23708c6$var$lab_xyz(y);
    x = (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Xn * $4dbb3730e23708c6$var$lab_xyz(x);
    z = (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Zn * $4dbb3730e23708c6$var$lab_xyz(z);
    r = $4dbb3730e23708c6$var$xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z); // D65 -> sRGB
    g = $4dbb3730e23708c6$var$xyz_rgb(-0.969266 * x + 1.8760108 * y + 0.041556 * z);
    b_ = $4dbb3730e23708c6$var$xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
    return [
        r,
        g,
        b_,
        args.length > 3 ? args[3] : 1
    ];
};
const $4dbb3730e23708c6$var$xyz_rgb = (r)=>{
    return 255 * (r <= 0.00304 ? 12.92 * r : 1.055 * $4dbb3730e23708c6$var$pow(r, 1 / 2.4) - 0.055);
};
const $4dbb3730e23708c6$var$lab_xyz = (t)=>{
    return t > (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).t1 ? t * t * t : (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).t2 * (t - (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).t0);
};
var $4dbb3730e23708c6$export$2e2bcd8739ae039 = $4dbb3730e23708c6$var$lab2rgb;




const { pow: $ca59d6cf91d40464$var$pow } = Math;
const $ca59d6cf91d40464$var$rgb2lab = (...args)=>{
    const [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    const [x, y, z] = $ca59d6cf91d40464$var$rgb2xyz(r, g, b);
    const l = 116 * y - 16;
    return [
        l < 0 ? 0 : l,
        500 * (x - y),
        200 * (y - z)
    ];
};
const $ca59d6cf91d40464$var$rgb_xyz = (r)=>{
    if ((r /= 255) <= 0.04045) return r / 12.92;
    return $ca59d6cf91d40464$var$pow((r + 0.055) / 1.055, 2.4);
};
const $ca59d6cf91d40464$var$xyz_lab = (t)=>{
    if (t > (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).t3) return $ca59d6cf91d40464$var$pow(t, 1 / 3);
    return t / (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).t2 + (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).t0;
};
const $ca59d6cf91d40464$var$rgb2xyz = (r, g, b)=>{
    r = $ca59d6cf91d40464$var$rgb_xyz(r);
    g = $ca59d6cf91d40464$var$rgb_xyz(g);
    b = $ca59d6cf91d40464$var$rgb_xyz(b);
    const x = $ca59d6cf91d40464$var$xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Xn);
    const y = $ca59d6cf91d40464$var$xyz_lab((0.2126729 * r + 0.7151522 * g + 0.072175 * b) / (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Yn);
    const z = $ca59d6cf91d40464$var$xyz_lab((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Zn);
    return [
        x,
        y,
        z
    ];
};
var $ca59d6cf91d40464$export$2e2bcd8739ae039 = $ca59d6cf91d40464$var$rgb2lab;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.lab = function() {
    return (0, $ca59d6cf91d40464$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).lab = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'lab');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.lab = (0, $4dbb3730e23708c6$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 2,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lab');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'lab';
    }
});








const { sin: $e2ac126434724053$var$sin, cos: $e2ac126434724053$var$cos } = Math;
const $e2ac126434724053$var$lch2lab = (...args)=>{
    /*
    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel.
    These formulas were invented by David Dalrymple to obtain maximum contrast without going
    out of gamut if the parameters are in the range 0-1.

    A saturation multiplier was added by Gregor Aisch
    */ let [l, c, h] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lch');
    if (isNaN(h)) h = 0;
    h = h * (0, $8468fd6f5eb24449$export$460c4029b1a54a2e);
    return [
        l,
        $e2ac126434724053$var$cos(h) * c,
        $e2ac126434724053$var$sin(h) * c
    ];
};
var $e2ac126434724053$export$2e2bcd8739ae039 = $e2ac126434724053$var$lch2lab;



const $7f66e0352a1cac11$var$lch2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $e2ac126434724053$export$2e2bcd8739ae039)(l, c, h);
    const [r, g, b] = (0, $4dbb3730e23708c6$export$2e2bcd8739ae039)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $7f66e0352a1cac11$export$2e2bcd8739ae039 = $7f66e0352a1cac11$var$lch2rgb;




const $d81a66fd5675b400$var$hcl2rgb = (...args)=>{
    const hcl = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'hcl').reverse();
    return (0, $7f66e0352a1cac11$export$2e2bcd8739ae039)(...hcl);
};
var $d81a66fd5675b400$export$2e2bcd8739ae039 = $d81a66fd5675b400$var$hcl2rgb;





const { sqrt: $c5e6bd03411e3b62$var$sqrt, atan2: $c5e6bd03411e3b62$var$atan2, round: $c5e6bd03411e3b62$var$round } = Math;
const $c5e6bd03411e3b62$var$lab2lch = (...args)=>{
    const [l, a, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lab');
    const c = $c5e6bd03411e3b62$var$sqrt(a * a + b * b);
    let h = ($c5e6bd03411e3b62$var$atan2(b, a) * (0, $8468fd6f5eb24449$export$914076c8150813e5) + 360) % 360;
    if ($c5e6bd03411e3b62$var$round(c * 10000) === 0) h = Number.NaN;
    return [
        l,
        c,
        h
    ];
};
var $c5e6bd03411e3b62$export$2e2bcd8739ae039 = $c5e6bd03411e3b62$var$lab2lch;


const $7e0834e33bd55fbc$var$rgb2lch = (...args)=>{
    const [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    const [l, a, b_] = (0, $ca59d6cf91d40464$export$2e2bcd8739ae039)(r, g, b);
    return (0, $c5e6bd03411e3b62$export$2e2bcd8739ae039)(l, a, b_);
};
var $7e0834e33bd55fbc$export$2e2bcd8739ae039 = $7e0834e33bd55fbc$var$rgb2lch;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.lch = function() {
    return (0, $7e0834e33bd55fbc$export$2e2bcd8739ae039)(this._rgb);
};
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.hcl = function() {
    return (0, $7e0834e33bd55fbc$export$2e2bcd8739ae039)(this._rgb).reverse();
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).lch = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'lch');
(0, $1f8e68471883117b$export$2e2bcd8739ae039).hcl = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'hcl');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.lch = (0, $7f66e0352a1cac11$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.hcl = (0, $d81a66fd5675b400$export$2e2bcd8739ae039);
[
    'lch',
    'hcl'
].forEach((m)=>(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
        p: 2,
        test: (...args)=>{
            args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, m);
            if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return m;
        }
    }));





/**
	X11 color names

	http://www.w3.org/TR/css3-color/#svg-color
*/ const $bf9461bcb84256f4$var$w3cx11 = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkgrey: '#a9a9a9',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkslategrey: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    grey: '#808080',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    laserlemon: '#ffff54',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrod: '#fafad2',
    lightgoldenrodyellow: '#fafad2',
    lightgray: '#d3d3d3',
    lightgreen: '#90ee90',
    lightgrey: '#d3d3d3',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightslategrey: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    maroon2: '#7f0000',
    maroon3: '#b03060',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370db',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#db7093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    purple2: '#7f007f',
    purple3: '#a020f0',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#ffffff',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    yellowgreen: '#9acd32'
};
var $bf9461bcb84256f4$export$2e2bcd8739ae039 = $bf9461bcb84256f4$var$w3cx11;




(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.name = function() {
    const hex = (0, $3650121ffcc295f7$export$2e2bcd8739ae039)(this._rgb, 'rgb');
    for (let n of Object.keys((0, $bf9461bcb84256f4$export$2e2bcd8739ae039))){
        if ((0, $bf9461bcb84256f4$export$2e2bcd8739ae039)[n] === hex) return n.toLowerCase();
    }
    return hex;
};
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.named = (name)=>{
    name = name.toLowerCase();
    if ((0, $bf9461bcb84256f4$export$2e2bcd8739ae039)[name]) return (0, $f838b8e082d144ff$export$2e2bcd8739ae039)((0, $bf9461bcb84256f4$export$2e2bcd8739ae039)[name]);
    throw new Error('unknown color name: ' + name);
};
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (h, ...rest)=>{
        if (!rest.length && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(h) === 'string' && (0, $bf9461bcb84256f4$export$2e2bcd8739ae039)[h.toLowerCase()]) return 'named';
    }
});







const $c365b486fb0dff97$var$num2rgb = (num)=>{
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(num) == 'number' && num >= 0 && num <= 0xffffff) {
        const r = num >> 16;
        const g = num >> 8 & 0xff;
        const b = num & 0xff;
        return [
            r,
            g,
            b,
            1
        ];
    }
    throw new Error('unknown num color: ' + num);
};
var $c365b486fb0dff97$export$2e2bcd8739ae039 = $c365b486fb0dff97$var$num2rgb;



const $47a69dbcaa9e9c13$var$rgb2num = (...args)=>{
    const [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    return (r << 16) + (g << 8) + b;
};
var $47a69dbcaa9e9c13$export$2e2bcd8739ae039 = $47a69dbcaa9e9c13$var$rgb2num;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.num = function() {
    return (0, $47a69dbcaa9e9c13$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).num = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'num');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.num = (0, $c365b486fb0dff97$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 5,
    test: (...args)=>{
        if (args.length === 1 && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args[0]) === 'number' && args[0] >= 0 && args[0] <= 0xffffff) return 'num';
    }
});






const { round: $2a579050baf7cd07$var$round } = Math;
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.rgb = function(rnd = true) {
    if (rnd === false) return this._rgb.slice(0, 3);
    return this._rgb.slice(0, 3).map($2a579050baf7cd07$var$round);
};
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.rgba = function(rnd = true) {
    return this._rgb.slice(0, 4).map((v, i)=>{
        return i < 3 ? rnd === false ? v : $2a579050baf7cd07$var$round(v) : v;
    });
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).rgb = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'rgb');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.rgb = (...args)=>{
    const rgba = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgba');
    if (rgba[3] === undefined) rgba[3] = 1;
    return rgba;
};
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgba');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && (args.length === 3 || args.length === 4 && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args[3]) == 'number' && args[3] >= 0 && args[3] <= 1)) return 'rgb';
    }
});





/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 */ const { log: $6db986ab83d15578$var$log } = Math;
const $6db986ab83d15578$var$temperature2rgb = (kelvin)=>{
    const temp = kelvin / 100;
    let r, g, b;
    if (temp < 66) {
        r = 255;
        g = temp < 6 ? 0 : -155.25485562709179 - 0.44596950469579133 * (g = temp - 2) + 104.49216199393888 * $6db986ab83d15578$var$log(g);
        b = temp < 20 ? 0 : -254.76935184120902 + 0.8274096064007395 * (b = temp - 10) + 115.67994401066147 * $6db986ab83d15578$var$log(b);
    } else {
        r = 351.97690566805693 + 0.114206453784165 * (r = temp - 55) - 40.25366309332127 * $6db986ab83d15578$var$log(r);
        g = 325.4494125711974 + 0.07943456536662342 * (g = temp - 50) - 28.0852963507957 * $6db986ab83d15578$var$log(g);
        b = 255;
    }
    return [
        r,
        g,
        b,
        1
    ];
};
var $6db986ab83d15578$export$2e2bcd8739ae039 = $6db986ab83d15578$var$temperature2rgb;


/*
 * Based on implementation by Neil Bartlett
 * https://github.com/neilbartlett/color-temperature
 **/ 

const { round: $7e3e647f9b88182f$var$round } = Math;
const $7e3e647f9b88182f$var$rgb2temperature = (...args)=>{
    const rgb = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    const r = rgb[0], b = rgb[2];
    let minTemp = 1000;
    let maxTemp = 40000;
    const eps = 0.4;
    let temp;
    while(maxTemp - minTemp > eps){
        temp = (maxTemp + minTemp) * 0.5;
        const rgb = (0, $6db986ab83d15578$export$2e2bcd8739ae039)(temp);
        if (rgb[2] / rgb[0] >= b / r) maxTemp = temp;
        else minTemp = temp;
    }
    return $7e3e647f9b88182f$var$round(temp);
};
var $7e3e647f9b88182f$export$2e2bcd8739ae039 = $7e3e647f9b88182f$var$rgb2temperature;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.temp = (0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.kelvin = (0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.temperature = function() {
    return (0, $7e3e647f9b88182f$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).temp = (0, $1f8e68471883117b$export$2e2bcd8739ae039).kelvin = (0, $1f8e68471883117b$export$2e2bcd8739ae039).temperature = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'temp');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.temp = (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.kelvin = (0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.temperature = (0, $6db986ab83d15578$export$2e2bcd8739ae039);







const { pow: $ceb22701333a9a8e$var$pow, sign: $ceb22701333a9a8e$var$sign } = Math;
/*
 * L* [0..100]
 * a [-100..100]
 * b [-100..100]
 */ const $ceb22701333a9a8e$var$oklab2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lab');
    const [L, a, b] = args;
    const l = $ceb22701333a9a8e$var$pow(L + 0.3963377774 * a + 0.2158037573 * b, 3);
    const m = $ceb22701333a9a8e$var$pow(L - 0.1055613458 * a - 0.0638541728 * b, 3);
    const s = $ceb22701333a9a8e$var$pow(L - 0.0894841775 * a - 1.291485548 * b, 3);
    return [
        255 * $ceb22701333a9a8e$var$lrgb2rgb(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
        255 * $ceb22701333a9a8e$var$lrgb2rgb(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
        255 * $ceb22701333a9a8e$var$lrgb2rgb(-0.0041960863 * l - 0.7034186147 * m + 1.707614701 * s),
        args.length > 3 ? args[3] : 1
    ];
};
var $ceb22701333a9a8e$export$2e2bcd8739ae039 = $ceb22701333a9a8e$var$oklab2rgb;
function $ceb22701333a9a8e$var$lrgb2rgb(c) {
    const abs = Math.abs(c);
    if (abs > 0.0031308) return ($ceb22701333a9a8e$var$sign(c) || 1) * (1.055 * $ceb22701333a9a8e$var$pow(abs, 1 / 2.4) - 0.055);
    return c * 12.92;
}



const { cbrt: $883b28d13f2af41b$var$cbrt, pow: $883b28d13f2af41b$var$pow, sign: $883b28d13f2af41b$var$sign } = Math;
const $883b28d13f2af41b$var$rgb2oklab = (...args)=>{
    // OKLab color space implementation taken from
    // https://bottosson.github.io/posts/oklab/
    const [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    const [lr, lg, lb] = [
        $883b28d13f2af41b$var$rgb2lrgb(r / 255),
        $883b28d13f2af41b$var$rgb2lrgb(g / 255),
        $883b28d13f2af41b$var$rgb2lrgb(b / 255)
    ];
    const l = $883b28d13f2af41b$var$cbrt(0.4122214708 * lr + 0.5363325363 * lg + 0.0514459929 * lb);
    const m = $883b28d13f2af41b$var$cbrt(0.2119034982 * lr + 0.6806995451 * lg + 0.1073969566 * lb);
    const s = $883b28d13f2af41b$var$cbrt(0.0883024619 * lr + 0.2817188376 * lg + 0.6299787005 * lb);
    return [
        0.2104542553 * l + 0.793617785 * m - 0.0040720468 * s,
        1.9779984951 * l - 2.428592205 * m + 0.4505937099 * s,
        0.0259040371 * l + 0.7827717662 * m - 0.808675766 * s
    ];
};
var $883b28d13f2af41b$export$2e2bcd8739ae039 = $883b28d13f2af41b$var$rgb2oklab;
function $883b28d13f2af41b$var$rgb2lrgb(c) {
    const abs = Math.abs(c);
    if (abs < 0.04045) return c / 12.92;
    return ($883b28d13f2af41b$var$sign(c) || 1) * $883b28d13f2af41b$var$pow((abs + 0.055) / 1.055, 2.4);
}


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.oklab = function() {
    return (0, $883b28d13f2af41b$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).oklab = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'oklab');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.oklab = (0, $ceb22701333a9a8e$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'oklab');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'oklab';
    }
});









const $86d03efa97ebad42$var$oklch2rgb = (...args)=>{
    args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'lch');
    const [l, c, h] = args;
    const [L, a, b_] = (0, $e2ac126434724053$export$2e2bcd8739ae039)(l, c, h);
    const [r, g, b] = (0, $ceb22701333a9a8e$export$2e2bcd8739ae039)(L, a, b_);
    return [
        r,
        g,
        b,
        args.length > 3 ? args[3] : 1
    ];
};
var $86d03efa97ebad42$export$2e2bcd8739ae039 = $86d03efa97ebad42$var$oklch2rgb;





const $c7093d23ce740de3$var$rgb2oklch = (...args)=>{
    const [r, g, b] = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'rgb');
    const [l, a, b_] = (0, $883b28d13f2af41b$export$2e2bcd8739ae039)(r, g, b);
    return (0, $c5e6bd03411e3b62$export$2e2bcd8739ae039)(l, a, b_);
};
var $c7093d23ce740de3$export$2e2bcd8739ae039 = $c7093d23ce740de3$var$rgb2oklch;


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.oklch = function() {
    return (0, $c7093d23ce740de3$export$2e2bcd8739ae039)(this._rgb);
};
(0, $1f8e68471883117b$export$2e2bcd8739ae039).oklch = (...args)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args, 'oklch');
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).format.oklch = (0, $86d03efa97ebad42$export$2e2bcd8739ae039);
(0, $3b8568da62f7dcaf$export$2e2bcd8739ae039).autodetect.push({
    p: 3,
    test: (...args)=>{
        args = (0, $57db938010502b11$export$2e2bcd8739ae039)(args, 'oklch');
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(args) === 'array' && args.length === 3) return 'oklch';
    }
});




(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.alpha = function(a, mutate = false) {
    if (a !== undefined && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(a) === 'number') {
        if (mutate) {
            this._rgb[3] = a;
            return this;
        }
        return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
            this._rgb[0],
            this._rgb[1],
            this._rgb[2],
            a
        ], 'rgb');
    }
    return this._rgb[3];
};



(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.clipped = function() {
    return this._rgb._clipped || false;
};





(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.darken = function(amount = 1) {
    const me = this;
    const lab = me.lab();
    lab[0] -= (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Kn * amount;
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(lab, 'lab').alpha(me.alpha(), true);
};
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.brighten = function(amount = 1) {
    return this.darken(-amount);
};
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.darker = (0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.darken;
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.brighter = (0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.brighten;



(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.get = function(mc) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) return src[i];
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};




const { pow: $4b1b8be3b36e0d4f$var$pow } = Math;
const $4b1b8be3b36e0d4f$var$EPS = 1e-7;
const $4b1b8be3b36e0d4f$var$MAX_ITER = 20;
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.luminance = function(lum, mode = 'rgb') {
    if (lum !== undefined && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(lum) === 'number') {
        if (lum === 0) // return pure black
        return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
            0,
            0,
            0,
            this._rgb[3]
        ], 'rgb');
        if (lum === 1) // return pure white
        return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
            255,
            255,
            255,
            this._rgb[3]
        ], 'rgb');
        // compute new color using...
        let cur_lum = this.luminance();
        let max_iter = $4b1b8be3b36e0d4f$var$MAX_ITER;
        const test = (low, high)=>{
            const mid = low.interpolate(high, 0.5, mode);
            const lm = mid.luminance();
            if (Math.abs(lum - lm) < $4b1b8be3b36e0d4f$var$EPS || !max_iter--) // close enough
            return mid;
            return lm > lum ? test(low, mid) : test(mid, high);
        };
        const rgb = (cur_lum > lum ? test(new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
            0,
            0,
            0
        ]), this) : test(this, new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
            255,
            255,
            255
        ]))).rgb();
        return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
            ...rgb,
            this._rgb[3]
        ]);
    }
    return $4b1b8be3b36e0d4f$var$rgb2luminance(...this._rgb.slice(0, 3));
};
const $4b1b8be3b36e0d4f$var$rgb2luminance = (r, g, b)=>{
    // relative luminance
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    r = $4b1b8be3b36e0d4f$var$luminance_x(r);
    g = $4b1b8be3b36e0d4f$var$luminance_x(g);
    b = $4b1b8be3b36e0d4f$var$luminance_x(b);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const $4b1b8be3b36e0d4f$var$luminance_x = (x)=>{
    x /= 255;
    return x <= 0.03928 ? x / 12.92 : $4b1b8be3b36e0d4f$var$pow((x + 0.055) / 1.055, 2.4);
};





var $cc84929cefbc75dc$export$2e2bcd8739ae039 = {};


var $430a9490493133a9$export$2e2bcd8739ae039 = (col1, col2, f = 0.5, ...rest)=>{
    let mode = rest[0] || 'lrgb';
    if (!(0, $cc84929cefbc75dc$export$2e2bcd8739ae039)[mode] && !rest.length) // fall back to the first supported mode
    mode = Object.keys((0, $cc84929cefbc75dc$export$2e2bcd8739ae039))[0];
    if (!(0, $cc84929cefbc75dc$export$2e2bcd8739ae039)[mode]) throw new Error(`interpolation mode ${mode} is not defined`);
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(col1) !== 'object') col1 = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(col1);
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(col2) !== 'object') col2 = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(col2);
    return (0, $cc84929cefbc75dc$export$2e2bcd8739ae039)[mode](col1, col2, f).alpha(col1.alpha() + f * (col2.alpha() - col1.alpha()));
};


(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.mix = (0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.interpolate = function(col2, f = 0.5, ...rest) {
    return (0, $430a9490493133a9$export$2e2bcd8739ae039)(this, col2, f, ...rest);
};



(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.premultiply = function(mutate = false) {
    const rgb = this._rgb;
    const a = rgb[3];
    if (mutate) {
        this._rgb = [
            rgb[0] * a,
            rgb[1] * a,
            rgb[2] * a,
            a
        ];
        return this;
    } else return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
        rgb[0] * a,
        rgb[1] * a,
        rgb[2] * a,
        a
    ], 'rgb');
};





(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.saturate = function(amount = 1) {
    const me = this;
    const lch = me.lch();
    lch[1] += (0, $dc78c652ecf850f2$export$2e2bcd8739ae039).Kn * amount;
    if (lch[1] < 0) lch[1] = 0;
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(lch, 'lch').alpha(me.alpha(), true);
};
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.desaturate = function(amount = 1) {
    return this.saturate(-amount);
};




(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.set = function(mc, value, mutate = false) {
    const [mode, channel] = mc.split('.');
    const src = this[mode]();
    if (channel) {
        const i = mode.indexOf(channel) - (mode.substr(0, 2) === 'ok' ? 2 : 0);
        if (i > -1) {
            if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(value) == 'string') switch(value.charAt(0)){
                case '+':
                    src[i] += +value;
                    break;
                case '-':
                    src[i] += +value;
                    break;
                case '*':
                    src[i] *= +value.substr(1);
                    break;
                case '/':
                    src[i] /= +value.substr(1);
                    break;
                default:
                    src[i] = +value;
            }
            else if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(value) === 'number') src[i] = value;
            else throw new Error(`unsupported value for Color.set`);
            const out = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(src, mode);
            if (mutate) {
                this._rgb = out._rgb;
                return this;
            }
            return out;
        }
        throw new Error(`unknown channel ${channel} in mode ${mode}`);
    } else return src;
};





(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.tint = function(f = 0.5, ...rest) {
    return (0, $430a9490493133a9$export$2e2bcd8739ae039)(this, 'white', f, ...rest);
};
(0, $b951312f83c9af91$export$2e2bcd8739ae039).prototype.shade = function(f = 0.5, ...rest) {
    return (0, $430a9490493133a9$export$2e2bcd8739ae039)(this, 'black', f, ...rest);
};




const $87f320f71740731a$var$rgb = (col1, col2, f)=>{
    const xyz0 = col1._rgb;
    const xyz1 = col2._rgb;
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'rgb');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).rgb = $87f320f71740731a$var$rgb;
var $87f320f71740731a$export$2e2bcd8739ae039 = $87f320f71740731a$var$rgb;




const { sqrt: $b88492dd2467f590$var$sqrt, pow: $b88492dd2467f590$var$pow } = Math;
const $b88492dd2467f590$var$lrgb = (col1, col2, f)=>{
    const [x1, y1, z1] = col1._rgb;
    const [x2, y2, z2] = col2._rgb;
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)($b88492dd2467f590$var$sqrt($b88492dd2467f590$var$pow(x1, 2) * (1 - f) + $b88492dd2467f590$var$pow(x2, 2) * f), $b88492dd2467f590$var$sqrt($b88492dd2467f590$var$pow(y1, 2) * (1 - f) + $b88492dd2467f590$var$pow(y2, 2) * f), $b88492dd2467f590$var$sqrt($b88492dd2467f590$var$pow(z1, 2) * (1 - f) + $b88492dd2467f590$var$pow(z2, 2) * f), 'rgb');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).lrgb = $b88492dd2467f590$var$lrgb;
var $b88492dd2467f590$export$2e2bcd8739ae039 = $b88492dd2467f590$var$lrgb;





const $760435f7288f7c46$var$lab = (col1, col2, f)=>{
    const xyz0 = col1.lab();
    const xyz1 = col2.lab();
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'lab');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).lab = $760435f7288f7c46$var$lab;
var $760435f7288f7c46$export$2e2bcd8739ae039 = $760435f7288f7c46$var$lab;




var $85346ea0fbf7a4b3$export$2e2bcd8739ae039 = (col1, col2, f, m)=>{
    let xyz0, xyz1;
    if (m === 'hsl') {
        xyz0 = col1.hsl();
        xyz1 = col2.hsl();
    } else if (m === 'hsv') {
        xyz0 = col1.hsv();
        xyz1 = col2.hsv();
    } else if (m === 'hcg') {
        xyz0 = col1.hcg();
        xyz1 = col2.hcg();
    } else if (m === 'hsi') {
        xyz0 = col1.hsi();
        xyz1 = col2.hsi();
    } else if (m === 'lch' || m === 'hcl') {
        m = 'hcl';
        xyz0 = col1.hcl();
        xyz1 = col2.hcl();
    } else if (m === 'oklch') {
        xyz0 = col1.oklch().reverse();
        xyz1 = col2.oklch().reverse();
    }
    let hue0, hue1, sat0, sat1, lbv0, lbv1;
    if (m.substr(0, 1) === 'h' || m === 'oklch') {
        [hue0, sat0, lbv0] = xyz0;
        [hue1, sat1, lbv1] = xyz1;
    }
    let sat, hue, lbv, dh;
    if (!isNaN(hue0) && !isNaN(hue1)) {
        // both colors have hue
        if (hue1 > hue0 && hue1 - hue0 > 180) dh = hue1 - (hue0 + 360);
        else if (hue1 < hue0 && hue0 - hue1 > 180) dh = hue1 + 360 - hue0;
        else dh = hue1 - hue0;
        hue = hue0 + f * dh;
    } else if (!isNaN(hue0)) {
        hue = hue0;
        if ((lbv1 == 1 || lbv1 == 0) && m != 'hsv') sat = sat0;
    } else if (!isNaN(hue1)) {
        hue = hue1;
        if ((lbv0 == 1 || lbv0 == 0) && m != 'hsv') sat = sat1;
    } else hue = Number.NaN;
    if (sat === undefined) sat = sat0 + f * (sat1 - sat0);
    lbv = lbv0 + f * (lbv1 - lbv0);
    return m === 'oklch' ? new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
        lbv,
        sat,
        hue
    ], m) : new (0, $b951312f83c9af91$export$2e2bcd8739ae039)([
        hue,
        sat,
        lbv
    ], m);
};



const $c7b238a7d5d3aacf$var$lch = (col1, col2, f)=>{
    return (0, $85346ea0fbf7a4b3$export$2e2bcd8739ae039)(col1, col2, f, 'lch');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).lch = $c7b238a7d5d3aacf$var$lch;
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).hcl = $c7b238a7d5d3aacf$var$lch;
var $c7b238a7d5d3aacf$export$2e2bcd8739ae039 = $c7b238a7d5d3aacf$var$lch;





const $38431fcca1ebad3f$var$num = (col1, col2, f)=>{
    const c1 = col1.num();
    const c2 = col2.num();
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(c1 + f * (c2 - c1), 'num');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).num = $38431fcca1ebad3f$var$num;
var $38431fcca1ebad3f$export$2e2bcd8739ae039 = $38431fcca1ebad3f$var$num;





const $130688e9305a23f8$var$hcg = (col1, col2, f)=>{
    return (0, $85346ea0fbf7a4b3$export$2e2bcd8739ae039)(col1, col2, f, 'hcg');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).hcg = $130688e9305a23f8$var$hcg;
var $130688e9305a23f8$export$2e2bcd8739ae039 = $130688e9305a23f8$var$hcg;





const $5b8186ac50d10ab3$var$hsi = (col1, col2, f)=>{
    return (0, $85346ea0fbf7a4b3$export$2e2bcd8739ae039)(col1, col2, f, 'hsi');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).hsi = $5b8186ac50d10ab3$var$hsi;
var $5b8186ac50d10ab3$export$2e2bcd8739ae039 = $5b8186ac50d10ab3$var$hsi;





const $d53374317e5a7ee7$var$hsl = (col1, col2, f)=>{
    return (0, $85346ea0fbf7a4b3$export$2e2bcd8739ae039)(col1, col2, f, 'hsl');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).hsl = $d53374317e5a7ee7$var$hsl;
var $d53374317e5a7ee7$export$2e2bcd8739ae039 = $d53374317e5a7ee7$var$hsl;





const $cced7f141beb3dff$var$hsv = (col1, col2, f)=>{
    return (0, $85346ea0fbf7a4b3$export$2e2bcd8739ae039)(col1, col2, f, 'hsv');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).hsv = $cced7f141beb3dff$var$hsv;
var $cced7f141beb3dff$export$2e2bcd8739ae039 = $cced7f141beb3dff$var$hsv;





const $8f953d59f25089fc$var$oklab = (col1, col2, f)=>{
    const xyz0 = col1.oklab();
    const xyz1 = col2.oklab();
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), 'oklab');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).oklab = $8f953d59f25089fc$var$oklab;
var $8f953d59f25089fc$export$2e2bcd8739ae039 = $8f953d59f25089fc$var$oklab;





const $a110b8897e5124ec$var$oklch = (col1, col2, f)=>{
    return (0, $85346ea0fbf7a4b3$export$2e2bcd8739ae039)(col1, col2, f, 'oklch');
};
// register interpolator
(0, $cc84929cefbc75dc$export$2e2bcd8739ae039).oklch = $a110b8897e5124ec$var$oklch;
var $a110b8897e5124ec$export$2e2bcd8739ae039 = $a110b8897e5124ec$var$oklch;




const { pow: $8b62c96f4c32d2ec$var$pow, sqrt: $8b62c96f4c32d2ec$var$sqrt, PI: $8b62c96f4c32d2ec$var$PI, cos: $8b62c96f4c32d2ec$var$cos, sin: $8b62c96f4c32d2ec$var$sin, atan2: $8b62c96f4c32d2ec$var$atan2 } = Math;
var $8b62c96f4c32d2ec$export$2e2bcd8739ae039 = (colors, mode = 'lrgb', weights = null)=>{
    const l = colors.length;
    if (!weights) weights = Array.from(new Array(l)).map(()=>1);
    // normalize weights
    const k = l / weights.reduce(function(a, b) {
        return a + b;
    });
    weights.forEach((w, i)=>{
        weights[i] *= k;
    });
    // convert colors to Color objects
    colors = colors.map((c)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(c));
    if (mode === 'lrgb') return $8b62c96f4c32d2ec$var$_average_lrgb(colors, weights);
    const first = colors.shift();
    const xyz = first.get(mode);
    const cnt = [];
    let dx = 0;
    let dy = 0;
    // initial color
    for(let i = 0; i < xyz.length; i++){
        xyz[i] = (xyz[i] || 0) * weights[0];
        cnt.push(isNaN(xyz[i]) ? 0 : weights[0]);
        if (mode.charAt(i) === 'h' && !isNaN(xyz[i])) {
            const A = xyz[i] / 180 * $8b62c96f4c32d2ec$var$PI;
            dx += $8b62c96f4c32d2ec$var$cos(A) * weights[0];
            dy += $8b62c96f4c32d2ec$var$sin(A) * weights[0];
        }
    }
    let alpha = first.alpha() * weights[0];
    colors.forEach((c, ci)=>{
        const xyz2 = c.get(mode);
        alpha += c.alpha() * weights[ci + 1];
        for(let i = 0; i < xyz.length; i++)if (!isNaN(xyz2[i])) {
            cnt[i] += weights[ci + 1];
            if (mode.charAt(i) === 'h') {
                const A = xyz2[i] / 180 * $8b62c96f4c32d2ec$var$PI;
                dx += $8b62c96f4c32d2ec$var$cos(A) * weights[ci + 1];
                dy += $8b62c96f4c32d2ec$var$sin(A) * weights[ci + 1];
            } else xyz[i] += xyz2[i] * weights[ci + 1];
        }
    });
    for(let i = 0; i < xyz.length; i++)if (mode.charAt(i) === 'h') {
        let A = $8b62c96f4c32d2ec$var$atan2(dy / cnt[i], dx / cnt[i]) / $8b62c96f4c32d2ec$var$PI * 180;
        while(A < 0)A += 360;
        while(A >= 360)A -= 360;
        xyz[i] = A;
    } else xyz[i] = xyz[i] / cnt[i];
    alpha /= l;
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(xyz, mode).alpha(alpha > 0.99999 ? 1 : alpha, true);
};
const $8b62c96f4c32d2ec$var$_average_lrgb = (colors, weights)=>{
    const l = colors.length;
    const xyz = [
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < colors.length; i++){
        const col = colors[i];
        const f = weights[i] / l;
        const rgb = col._rgb;
        xyz[0] += $8b62c96f4c32d2ec$var$pow(rgb[0], 2) * f;
        xyz[1] += $8b62c96f4c32d2ec$var$pow(rgb[1], 2) * f;
        xyz[2] += $8b62c96f4c32d2ec$var$pow(rgb[2], 2) * f;
        xyz[3] += rgb[3] * f;
    }
    xyz[0] = $8b62c96f4c32d2ec$var$sqrt(xyz[0]);
    xyz[1] = $8b62c96f4c32d2ec$var$sqrt(xyz[1]);
    xyz[2] = $8b62c96f4c32d2ec$var$sqrt(xyz[2]);
    if (xyz[3] > 0.9999999) xyz[3] = 1;
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)((0, $43a5039491c3ef47$export$2e2bcd8739ae039)(xyz));
};


//
// interpolates between a set of colors uzing a bezier spline
//
// @requires utils lab


// minimal multi-purpose interface
// @requires utils color analyze


const { pow: $5720af7f3b38c136$var$pow } = Math;
function $5720af7f3b38c136$export$2e2bcd8739ae039(colors) {
    // constructor
    let _mode = 'rgb';
    let _nacol = (0, $1f8e68471883117b$export$2e2bcd8739ae039)('#ccc');
    let _spread = 0;
    // const _fixed = false;
    let _domain = [
        0,
        1
    ];
    let _pos = [];
    let _padding = [
        0,
        0
    ];
    let _classes = false;
    let _colors = [];
    let _out = false;
    let _min = 0;
    let _max = 1;
    let _correctLightness = false;
    let _colorCache = {};
    let _useCache = true;
    let _gamma = 1;
    // private methods
    const setColors = function(colors) {
        colors = colors || [
            '#fff',
            '#000'
        ];
        if (colors && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(colors) === 'string' && (0, $1f8e68471883117b$export$2e2bcd8739ae039).brewer && (0, $1f8e68471883117b$export$2e2bcd8739ae039).brewer[colors.toLowerCase()]) colors = (0, $1f8e68471883117b$export$2e2bcd8739ae039).brewer[colors.toLowerCase()];
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(colors) === 'array') {
            // handle single color
            if (colors.length === 1) colors = [
                colors[0],
                colors[0]
            ];
            // make a copy of the colors
            colors = colors.slice(0);
            // convert to chroma classes
            for(let c = 0; c < colors.length; c++)colors[c] = (0, $1f8e68471883117b$export$2e2bcd8739ae039)(colors[c]);
            // auto-fill color position
            _pos.length = 0;
            for(let c = 0; c < colors.length; c++)_pos.push(c / (colors.length - 1));
        }
        resetCache();
        return _colors = colors;
    };
    const getClass = function(value) {
        if (_classes != null) {
            const n = _classes.length - 1;
            let i = 0;
            while(i < n && value >= _classes[i])i++;
            return i - 1;
        }
        return 0;
    };
    let tMapLightness = (t)=>t;
    let tMapDomain = (t)=>t;
    // const classifyValue = function(value) {
    //     let val = value;
    //     if (_classes.length > 2) {
    //         const n = _classes.length-1;
    //         const i = getClass(value);
    //         const minc = _classes[0] + ((_classes[1]-_classes[0]) * (0 + (_spread * 0.5)));  // center of 1st class
    //         const maxc = _classes[n-1] + ((_classes[n]-_classes[n-1]) * (1 - (_spread * 0.5)));  // center of last class
    //         val = _min + ((((_classes[i] + ((_classes[i+1] - _classes[i]) * 0.5)) - minc) / (maxc-minc)) * (_max - _min));
    //     }
    //     return val;
    // };
    const getColor = function(val, bypassMap) {
        let col, t;
        if (bypassMap == null) bypassMap = false;
        if (isNaN(val) || val === null) return _nacol;
        if (!bypassMap) {
            if (_classes && _classes.length > 2) {
                // find the class
                const c = getClass(val);
                t = c / (_classes.length - 2);
            } else if (_max !== _min) // just interpolate between min/max
            t = (val - _min) / (_max - _min);
            else t = 1;
        } else t = val;
        // domain map
        t = tMapDomain(t);
        if (!bypassMap) t = tMapLightness(t); // lightness correction
        if (_gamma !== 1) t = $5720af7f3b38c136$var$pow(t, _gamma);
        t = _padding[0] + t * (1 - _padding[0] - _padding[1]);
        t = (0, $9313361a67659bbf$export$2e2bcd8739ae039)(t, 0, 1);
        const k = Math.floor(t * 10000);
        if (_useCache && _colorCache[k]) col = _colorCache[k];
        else {
            if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(_colors) === 'array') //for i in [0.._pos.length-1]
            for(let i = 0; i < _pos.length; i++){
                const p = _pos[i];
                if (t <= p) {
                    col = _colors[i];
                    break;
                }
                if (t >= p && i === _pos.length - 1) {
                    col = _colors[i];
                    break;
                }
                if (t > p && t < _pos[i + 1]) {
                    t = (t - p) / (_pos[i + 1] - p);
                    col = (0, $1f8e68471883117b$export$2e2bcd8739ae039).interpolate(_colors[i], _colors[i + 1], t, _mode);
                    break;
                }
            }
            else if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(_colors) === 'function') col = _colors(t);
            if (_useCache) _colorCache[k] = col;
        }
        return col;
    };
    var resetCache = ()=>_colorCache = {};
    setColors(colors);
    // public interface
    const f = function(v) {
        const c = (0, $1f8e68471883117b$export$2e2bcd8739ae039)(getColor(v));
        if (_out && c[_out]) return c[_out]();
        else return c;
    };
    f.classes = function(classes) {
        if (classes != null) {
            if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(classes) === 'array') {
                _classes = classes;
                _domain = [
                    classes[0],
                    classes[classes.length - 1]
                ];
            } else {
                const d = (0, $1f8e68471883117b$export$2e2bcd8739ae039).analyze(_domain);
                if (classes === 0) _classes = [
                    d.min,
                    d.max
                ];
                else _classes = (0, $1f8e68471883117b$export$2e2bcd8739ae039).limits(d, 'e', classes);
            }
            return f;
        }
        return _classes;
    };
    f.domain = function(domain) {
        if (!arguments.length) return _domain;
        _min = domain[0];
        _max = domain[domain.length - 1];
        _pos = [];
        const k = _colors.length;
        if (domain.length === k && _min !== _max) // update positions
        for (let d of Array.from(domain))_pos.push((d - _min) / (_max - _min));
        else {
            for(let c = 0; c < k; c++)_pos.push(c / (k - 1));
            if (domain.length > 2) {
                // set domain map
                const tOut = domain.map((d, i)=>i / (domain.length - 1));
                const tBreaks = domain.map((d)=>(d - _min) / (_max - _min));
                if (!tBreaks.every((val, i)=>tOut[i] === val)) tMapDomain = (t)=>{
                    if (t <= 0 || t >= 1) return t;
                    let i = 0;
                    while(t >= tBreaks[i + 1])i++;
                    const f = (t - tBreaks[i]) / (tBreaks[i + 1] - tBreaks[i]);
                    const out = tOut[i] + f * (tOut[i + 1] - tOut[i]);
                    return out;
                };
            }
        }
        _domain = [
            _min,
            _max
        ];
        return f;
    };
    f.mode = function(_m) {
        if (!arguments.length) return _mode;
        _mode = _m;
        resetCache();
        return f;
    };
    f.range = function(colors, _pos) {
        setColors(colors, _pos);
        return f;
    };
    f.out = function(_o) {
        _out = _o;
        return f;
    };
    f.spread = function(val) {
        if (!arguments.length) return _spread;
        _spread = val;
        return f;
    };
    f.correctLightness = function(v) {
        if (v == null) v = true;
        _correctLightness = v;
        resetCache();
        if (_correctLightness) tMapLightness = function(t) {
            const L0 = getColor(0, true).lab()[0];
            const L1 = getColor(1, true).lab()[0];
            const pol = L0 > L1;
            let L_actual = getColor(t, true).lab()[0];
            const L_ideal = L0 + (L1 - L0) * t;
            let L_diff = L_actual - L_ideal;
            let t0 = 0;
            let t1 = 1;
            let max_iter = 20;
            while(Math.abs(L_diff) > 1e-2 && max_iter-- > 0)(function() {
                if (pol) L_diff *= -1;
                if (L_diff < 0) {
                    t0 = t;
                    t += (t1 - t) * 0.5;
                } else {
                    t1 = t;
                    t += (t0 - t) * 0.5;
                }
                L_actual = getColor(t, true).lab()[0];
                return L_diff = L_actual - L_ideal;
            })();
            return t;
        };
        else tMapLightness = (t)=>t;
        return f;
    };
    f.padding = function(p) {
        if (p != null) {
            if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(p) === 'number') p = [
                p,
                p
            ];
            _padding = p;
            return f;
        } else return _padding;
    };
    f.colors = function(numColors, out) {
        // If no arguments are given, return the original colors that were provided
        if (arguments.length < 2) out = 'hex';
        let result = [];
        if (arguments.length === 0) result = _colors.slice(0);
        else if (numColors === 1) result = [
            f(0.5)
        ];
        else if (numColors > 1) {
            const dm = _domain[0];
            const dd = _domain[1] - dm;
            result = $5720af7f3b38c136$var$__range__(0, numColors, false).map((i)=>f(dm + i / (numColors - 1) * dd));
        } else {
            // returns all colors based on the defined classes
            colors = [];
            let samples = [];
            if (_classes && _classes.length > 2) for(let i = 1, end = _classes.length, asc = 1 <= end; asc ? i < end : i > end; asc ? i++ : i--)samples.push((_classes[i - 1] + _classes[i]) * 0.5);
            else samples = _domain;
            result = samples.map((v)=>f(v));
        }
        if ((0, $1f8e68471883117b$export$2e2bcd8739ae039)[out]) result = result.map((c)=>c[out]());
        return result;
    };
    f.cache = function(c) {
        if (c != null) {
            _useCache = c;
            return f;
        } else return _useCache;
    };
    f.gamma = function(g) {
        if (g != null) {
            _gamma = g;
            return f;
        } else return _gamma;
    };
    f.nodata = function(d) {
        if (d != null) {
            _nacol = (0, $1f8e68471883117b$export$2e2bcd8739ae039)(d);
            return f;
        } else return _nacol;
    };
    return f;
}
function $5720af7f3b38c136$var$__range__(left, right, inclusive) {
    let range = [];
    let ascending = left < right;
    let end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(let i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
}


// nth row of the pascal triangle
const $cfb729a2cae9b057$var$binom_row = function(n) {
    let row = [
        1,
        1
    ];
    for(let i = 1; i < n; i++){
        let newrow = [
            1
        ];
        for(let j = 1; j <= row.length; j++)newrow[j] = (row[j] || 0) + row[j - 1];
        row = newrow;
    }
    return row;
};
const $cfb729a2cae9b057$var$bezier = function(colors) {
    let I, lab0, lab1, lab2;
    colors = colors.map((c)=>new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(c));
    if (colors.length === 2) {
        // linear interpolation
        [lab0, lab1] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>lab0[i] + t * (lab1[i] - lab0[i]));
            return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length === 3) {
        // quadratic bezier interpolation
        [lab0, lab1, lab2] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
            return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length === 4) {
        // cubic bezier interpolation
        let lab3;
        [lab0, lab1, lab2, lab3] = colors.map((c)=>c.lab());
        I = function(t) {
            const lab = [
                0,
                1,
                2
            ].map((i)=>(1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
            return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else if (colors.length >= 5) {
        // general case (degree n bezier)
        let labs, row, n;
        labs = colors.map((c)=>c.lab());
        n = colors.length - 1;
        row = $cfb729a2cae9b057$var$binom_row(n);
        I = function(t) {
            const u = 1 - t;
            const lab = [
                0,
                1,
                2
            ].map((i)=>labs.reduce((sum, el, j)=>sum + row[j] * u ** (n - j) * t ** j * el[i], 0));
            return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(lab, 'lab');
        };
    } else throw new RangeError('No point in running bezier with only one color.');
    return I;
};
var $cfb729a2cae9b057$export$2e2bcd8739ae039 = (colors)=>{
    const f = $cfb729a2cae9b057$var$bezier(colors);
    f.scale = ()=>(0, $5720af7f3b38c136$export$2e2bcd8739ae039)(f);
    return f;
};


/*
 * interpolates between a set of colors uzing a bezier spline
 * blend mode formulas taken from https://web.archive.org/web/20180110014946/http://www.venture-ware.com/kevin/coding/lets-learn-math-photoshop-blend-modes/
 */ 

const $c1cde4b90175caa9$var$blend = (bottom, top, mode)=>{
    if (!$c1cde4b90175caa9$var$blend[mode]) throw new Error('unknown blend mode ' + mode);
    return $c1cde4b90175caa9$var$blend[mode](bottom, top);
};
const $c1cde4b90175caa9$var$blend_f = (f)=>(bottom, top)=>{
        const c0 = (0, $1f8e68471883117b$export$2e2bcd8739ae039)(top).rgb();
        const c1 = (0, $1f8e68471883117b$export$2e2bcd8739ae039)(bottom).rgb();
        return (0, $1f8e68471883117b$export$2e2bcd8739ae039).rgb(f(c0, c1));
    };
const $c1cde4b90175caa9$var$each = (f)=>(c0, c1)=>{
        const out = [];
        out[0] = f(c0[0], c1[0]);
        out[1] = f(c0[1], c1[1]);
        out[2] = f(c0[2], c1[2]);
        return out;
    };
const $c1cde4b90175caa9$var$normal = (a)=>a;
const $c1cde4b90175caa9$var$multiply = (a, b)=>a * b / 255;
const $c1cde4b90175caa9$var$darken = (a, b)=>a > b ? b : a;
const $c1cde4b90175caa9$var$lighten = (a, b)=>a > b ? a : b;
const $c1cde4b90175caa9$var$screen = (a, b)=>255 * (1 - (1 - a / 255) * (1 - b / 255));
const $c1cde4b90175caa9$var$overlay = (a, b)=>b < 128 ? 2 * a * b / 255 : 255 * (1 - 2 * (1 - a / 255) * (1 - b / 255));
const $c1cde4b90175caa9$var$burn = (a, b)=>255 * (1 - (1 - b / 255) / (a / 255));
const $c1cde4b90175caa9$var$dodge = (a, b)=>{
    if (a === 255) return 255;
    a = 255 * (b / 255) / (1 - a / 255);
    return a > 255 ? 255 : a;
};
// # add = (a,b) ->
// #     if (a + b > 255) then 255 else a + b
$c1cde4b90175caa9$var$blend.normal = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$normal));
$c1cde4b90175caa9$var$blend.multiply = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$multiply));
$c1cde4b90175caa9$var$blend.screen = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$screen));
$c1cde4b90175caa9$var$blend.overlay = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$overlay));
$c1cde4b90175caa9$var$blend.darken = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$darken));
$c1cde4b90175caa9$var$blend.lighten = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$lighten));
$c1cde4b90175caa9$var$blend.dodge = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$dodge));
$c1cde4b90175caa9$var$blend.burn = $c1cde4b90175caa9$var$blend_f($c1cde4b90175caa9$var$each($c1cde4b90175caa9$var$burn));
var // blend.add = blend_f(each(add));
$c1cde4b90175caa9$export$2e2bcd8739ae039 = $c1cde4b90175caa9$var$blend;


// cubehelix interpolation
// based on D.A. Green "A colour scheme for the display of astronomical intensity images"
// http://astron-soc.in/bulletin/11June/289392011.pdf


const { pow: $6bb2fb204ab64a74$var$pow, sin: $6bb2fb204ab64a74$var$sin, cos: $6bb2fb204ab64a74$var$cos } = Math;
function $6bb2fb204ab64a74$export$2e2bcd8739ae039(start = 300, rotations = -1.5, hue = 1, gamma = 1, lightness = [
    0,
    1
]) {
    let dh = 0, dl;
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(lightness) === 'array') dl = lightness[1] - lightness[0];
    else {
        dl = 0;
        lightness = [
            lightness,
            lightness
        ];
    }
    const f = function(fract) {
        const a = (0, $8468fd6f5eb24449$export$af54f71c879f5ba9) * ((start + 120) / 360 + rotations * fract);
        const l = $6bb2fb204ab64a74$var$pow(lightness[0] + dl * fract, gamma);
        const h = dh !== 0 ? hue[0] + fract * dh : hue;
        const amp = h * l * (1 - l) / 2;
        const cos_a = $6bb2fb204ab64a74$var$cos(a);
        const sin_a = $6bb2fb204ab64a74$var$sin(a);
        const r = l + amp * (-0.14861 * cos_a + 1.78277 * sin_a);
        const g = l + amp * (-0.29227 * cos_a - 0.90649 * sin_a);
        const b = l + amp * (1.97294 * cos_a);
        return (0, $1f8e68471883117b$export$2e2bcd8739ae039)((0, $43a5039491c3ef47$export$2e2bcd8739ae039)([
            r * 255,
            g * 255,
            b * 255,
            1
        ]));
    };
    f.start = function(s) {
        if (s == null) return start;
        start = s;
        return f;
    };
    f.rotations = function(r) {
        if (r == null) return rotations;
        rotations = r;
        return f;
    };
    f.gamma = function(g) {
        if (g == null) return gamma;
        gamma = g;
        return f;
    };
    f.hue = function(h) {
        if (h == null) return hue;
        hue = h;
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(hue) === 'array') {
            dh = hue[1] - hue[0];
            if (dh === 0) hue = hue[1];
        } else dh = 0;
        return f;
    };
    f.lightness = function(h) {
        if (h == null) return lightness;
        if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(h) === 'array') {
            lightness = h;
            dl = h[1] - h[0];
        } else {
            lightness = [
                h,
                h
            ];
            dl = 0;
        }
        return f;
    };
    f.scale = ()=>(0, $1f8e68471883117b$export$2e2bcd8739ae039).scale(f);
    f.hue(hue);
    return f;
}




const $52c36c05dc746f31$var$digits = '0123456789abcdef';
const { floor: $52c36c05dc746f31$var$floor, random: $52c36c05dc746f31$var$random } = Math;
var $52c36c05dc746f31$export$2e2bcd8739ae039 = ()=>{
    let code = '#';
    for(let i = 0; i < 6; i++)code += $52c36c05dc746f31$var$digits.charAt($52c36c05dc746f31$var$floor($52c36c05dc746f31$var$random() * 16));
    return new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(code, 'hex');
};




const { log: $b807a0bbf265e315$var$log, pow: $b807a0bbf265e315$var$pow, floor: $b807a0bbf265e315$var$floor, abs: $b807a0bbf265e315$var$abs } = Math;
function $b807a0bbf265e315$export$7cbcccfbecde6416(data, key = null) {
    const r = {
        min: Number.MAX_VALUE,
        max: Number.MAX_VALUE * -1,
        sum: 0,
        values: [],
        count: 0
    };
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(data) === 'object') data = Object.values(data);
    data.forEach((val)=>{
        if (key && (0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(val) === 'object') val = val[key];
        if (val !== undefined && val !== null && !isNaN(val)) {
            r.values.push(val);
            r.sum += val;
            if (val < r.min) r.min = val;
            if (val > r.max) r.max = val;
            r.count += 1;
        }
    });
    r.domain = [
        r.min,
        r.max
    ];
    r.limits = (mode, num)=>$b807a0bbf265e315$export$e331ca4ad6a82555(r, mode, num);
    return r;
}
function $b807a0bbf265e315$export$e331ca4ad6a82555(data, mode = 'equal', num = 7) {
    if ((0, $a84ecdc868ecfb74$export$2e2bcd8739ae039)(data) == 'array') data = $b807a0bbf265e315$export$7cbcccfbecde6416(data);
    const { min: min, max: max } = data;
    const values = data.values.sort((a, b)=>a - b);
    if (num === 1) return [
        min,
        max
    ];
    const limits1 = [];
    if (mode.substr(0, 1) === 'c') {
        // continuous
        limits1.push(min);
        limits1.push(max);
    }
    if (mode.substr(0, 1) === 'e') {
        // equal interval
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push(min + i / num * (max - min));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'l') {
        // log scale
        if (min <= 0) throw new Error('Logarithmic scales are only possible for values > 0');
        const min_log = Math.LOG10E * $b807a0bbf265e315$var$log(min);
        const max_log = Math.LOG10E * $b807a0bbf265e315$var$log(max);
        limits1.push(min);
        for(let i = 1; i < num; i++)limits1.push($b807a0bbf265e315$var$pow(10, min_log + i / num * (max_log - min_log)));
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'q') {
        // quantile scale
        limits1.push(min);
        for(let i = 1; i < num; i++){
            const p = (values.length - 1) * i / num;
            const pb = $b807a0bbf265e315$var$floor(p);
            if (pb === p) limits1.push(values[pb]);
            else {
                // p > pb
                const pr = p - pb;
                limits1.push(values[pb] * (1 - pr) + values[pb + 1] * pr);
            }
        }
        limits1.push(max);
    } else if (mode.substr(0, 1) === 'k') {
        // k-means clustering
        /*
        implementation based on
        http://code.google.com/p/figue/source/browse/trunk/figue.js#336
        simplified for 1-d input values
        */ let cluster;
        const n = values.length;
        const assignments = new Array(n);
        const clusterSizes = new Array(num);
        let repeat = true;
        let nb_iters = 0;
        let centroids = null;
        // get seed values
        centroids = [];
        centroids.push(min);
        for(let i = 1; i < num; i++)centroids.push(min + i / num * (max - min));
        centroids.push(max);
        while(repeat){
            // assignment step
            for(let j = 0; j < num; j++)clusterSizes[j] = 0;
            for(let i = 0; i < n; i++){
                const value = values[i];
                let mindist = Number.MAX_VALUE;
                let best;
                for(let j = 0; j < num; j++){
                    const dist = $b807a0bbf265e315$var$abs(centroids[j] - value);
                    if (dist < mindist) {
                        mindist = dist;
                        best = j;
                    }
                    clusterSizes[best]++;
                    assignments[i] = best;
                }
            }
            // update centroids step
            const newCentroids = new Array(num);
            for(let j = 0; j < num; j++)newCentroids[j] = null;
            for(let i = 0; i < n; i++){
                cluster = assignments[i];
                if (newCentroids[cluster] === null) newCentroids[cluster] = values[i];
                else newCentroids[cluster] += values[i];
            }
            for(let j = 0; j < num; j++)newCentroids[j] *= 1 / clusterSizes[j];
            // check convergence
            repeat = false;
            for(let j = 0; j < num; j++)if (newCentroids[j] !== centroids[j]) {
                repeat = true;
                break;
            }
            centroids = newCentroids;
            nb_iters++;
            if (nb_iters > 200) repeat = false;
        }
        // finished k-means clustering
        // the next part is borrowed from gabrielflor.it
        const kClusters = {};
        for(let j = 0; j < num; j++)kClusters[j] = [];
        for(let i = 0; i < n; i++){
            cluster = assignments[i];
            kClusters[cluster].push(values[i]);
        }
        let tmpKMeansBreaks = [];
        for(let j = 0; j < num; j++){
            tmpKMeansBreaks.push(kClusters[j][0]);
            tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
        }
        tmpKMeansBreaks = tmpKMeansBreaks.sort((a, b)=>a - b);
        limits1.push(tmpKMeansBreaks[0]);
        for(let i = 1; i < tmpKMeansBreaks.length; i += 2){
            const v = tmpKMeansBreaks[i];
            if (!isNaN(v) && limits1.indexOf(v) === -1) limits1.push(v);
        }
    }
    return limits1;
}




var $add94710b1b92906$export$2e2bcd8739ae039 = (a, b)=>{
    // WCAG contrast ratio
    // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
    a = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(a);
    b = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(b);
    const l1 = a.luminance();
    const l2 = b.luminance();
    return l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
};



const { sqrt: $4d0b78ec7ffb1f9c$var$sqrt, pow: $4d0b78ec7ffb1f9c$var$pow, min: $4d0b78ec7ffb1f9c$var$min, max: $4d0b78ec7ffb1f9c$var$max, atan2: $4d0b78ec7ffb1f9c$var$atan2, abs: $4d0b78ec7ffb1f9c$var$abs, cos: $4d0b78ec7ffb1f9c$var$cos, sin: $4d0b78ec7ffb1f9c$var$sin, exp: $4d0b78ec7ffb1f9c$var$exp, PI: $4d0b78ec7ffb1f9c$var$PI } = Math;
function $4d0b78ec7ffb1f9c$export$2e2bcd8739ae039(a, b, Kl = 1, Kc = 1, Kh = 1) {
    // Delta E (CIE 2000)
    // see http://www.brucelindbloom.com/index.html?Eqn_DeltaE_CIE2000.html
    var rad2deg = function(rad) {
        return 360 * rad / (2 * $4d0b78ec7ffb1f9c$var$PI);
    };
    var deg2rad = function(deg) {
        return 2 * $4d0b78ec7ffb1f9c$var$PI * deg / 360;
    };
    a = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(a);
    b = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(b);
    const [L1, a1, b1] = Array.from(a.lab());
    const [L2, a2, b2] = Array.from(b.lab());
    const avgL = (L1 + L2) / 2;
    const C1 = $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(a1, 2) + $4d0b78ec7ffb1f9c$var$pow(b1, 2));
    const C2 = $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(a2, 2) + $4d0b78ec7ffb1f9c$var$pow(b2, 2));
    const avgC = (C1 + C2) / 2;
    const G = 0.5 * (1 - $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(avgC, 7) / ($4d0b78ec7ffb1f9c$var$pow(avgC, 7) + $4d0b78ec7ffb1f9c$var$pow(25, 7))));
    const a1p = a1 * (1 + G);
    const a2p = a2 * (1 + G);
    const C1p = $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(a1p, 2) + $4d0b78ec7ffb1f9c$var$pow(b1, 2));
    const C2p = $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(a2p, 2) + $4d0b78ec7ffb1f9c$var$pow(b2, 2));
    const avgCp = (C1p + C2p) / 2;
    const arctan1 = rad2deg($4d0b78ec7ffb1f9c$var$atan2(b1, a1p));
    const arctan2 = rad2deg($4d0b78ec7ffb1f9c$var$atan2(b2, a2p));
    const h1p = arctan1 >= 0 ? arctan1 : arctan1 + 360;
    const h2p = arctan2 >= 0 ? arctan2 : arctan2 + 360;
    const avgHp = $4d0b78ec7ffb1f9c$var$abs(h1p - h2p) > 180 ? (h1p + h2p + 360) / 2 : (h1p + h2p) / 2;
    const T = 1 - 0.17 * $4d0b78ec7ffb1f9c$var$cos(deg2rad(avgHp - 30)) + 0.24 * $4d0b78ec7ffb1f9c$var$cos(deg2rad(2 * avgHp)) + 0.32 * $4d0b78ec7ffb1f9c$var$cos(deg2rad(3 * avgHp + 6)) - 0.2 * $4d0b78ec7ffb1f9c$var$cos(deg2rad(4 * avgHp - 63));
    let deltaHp = h2p - h1p;
    deltaHp = $4d0b78ec7ffb1f9c$var$abs(deltaHp) <= 180 ? deltaHp : h2p <= h1p ? deltaHp + 360 : deltaHp - 360;
    deltaHp = 2 * $4d0b78ec7ffb1f9c$var$sqrt(C1p * C2p) * $4d0b78ec7ffb1f9c$var$sin(deg2rad(deltaHp) / 2);
    const deltaL = L2 - L1;
    const deltaCp = C2p - C1p;
    const sl = 1 + 0.015 * $4d0b78ec7ffb1f9c$var$pow(avgL - 50, 2) / $4d0b78ec7ffb1f9c$var$sqrt(20 + $4d0b78ec7ffb1f9c$var$pow(avgL - 50, 2));
    const sc = 1 + 0.045 * avgCp;
    const sh = 1 + 0.015 * avgCp * T;
    const deltaTheta = 30 * $4d0b78ec7ffb1f9c$var$exp(-$4d0b78ec7ffb1f9c$var$pow((avgHp - 275) / 25, 2));
    const Rc = 2 * $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(avgCp, 7) / ($4d0b78ec7ffb1f9c$var$pow(avgCp, 7) + $4d0b78ec7ffb1f9c$var$pow(25, 7)));
    const Rt = -Rc * $4d0b78ec7ffb1f9c$var$sin(2 * deg2rad(deltaTheta));
    const result = $4d0b78ec7ffb1f9c$var$sqrt($4d0b78ec7ffb1f9c$var$pow(deltaL / (Kl * sl), 2) + $4d0b78ec7ffb1f9c$var$pow(deltaCp / (Kc * sc), 2) + $4d0b78ec7ffb1f9c$var$pow(deltaHp / (Kh * sh), 2) + Rt * (deltaCp / (Kc * sc)) * (deltaHp / (Kh * sh)));
    return $4d0b78ec7ffb1f9c$var$max(0, $4d0b78ec7ffb1f9c$var$min(100, result));
}



function $4d1624cfe3048d2c$export$2e2bcd8739ae039(a, b, mode = 'lab') {
    // Delta E (CIE 1976)
    // see http://www.brucelindbloom.com/index.html?Equations.html
    a = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(a);
    b = new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(b);
    const l1 = a.get(mode);
    const l2 = b.get(mode);
    let sum_sq = 0;
    for(let i in l1){
        const d = (l1[i] || 0) - (l2[i] || 0);
        sum_sq += d * d;
    }
    return Math.sqrt(sum_sq);
}



var $81784ebd924ed1d4$export$2e2bcd8739ae039 = (...args)=>{
    try {
        new (0, $b951312f83c9af91$export$2e2bcd8739ae039)(...args);
        return true;
    // eslint-disable-next-line
    } catch (e) {
        return false;
    }
};



// some pre-defined color scales:



var $bf3aa5913a5571bf$export$2e2bcd8739ae039 = {
    cool () {
        return (0, $5720af7f3b38c136$export$2e2bcd8739ae039)([
            (0, $1f8e68471883117b$export$2e2bcd8739ae039).hsl(180, 1, 0.9),
            (0, $1f8e68471883117b$export$2e2bcd8739ae039).hsl(250, 0.7, 0.4)
        ]);
    },
    hot () {
        return (0, $5720af7f3b38c136$export$2e2bcd8739ae039)([
            '#000',
            '#f00',
            '#ff0',
            '#fff'
        ], [
            0,
            0.25,
            0.75,
            1
        ]).mode('rgb');
    }
};



/**
    ColorBrewer colors for chroma.js

    Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The
    Pennsylvania State University.

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at
    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software distributed
    under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
    CONDITIONS OF ANY KIND, either express or implied. See the License for the
    specific language governing permissions and limitations under the License.
*/ const $6e7cd0a29de34293$var$colorbrewer = {
    // sequential
    OrRd: [
        '#fff7ec',
        '#fee8c8',
        '#fdd49e',
        '#fdbb84',
        '#fc8d59',
        '#ef6548',
        '#d7301f',
        '#b30000',
        '#7f0000'
    ],
    PuBu: [
        '#fff7fb',
        '#ece7f2',
        '#d0d1e6',
        '#a6bddb',
        '#74a9cf',
        '#3690c0',
        '#0570b0',
        '#045a8d',
        '#023858'
    ],
    BuPu: [
        '#f7fcfd',
        '#e0ecf4',
        '#bfd3e6',
        '#9ebcda',
        '#8c96c6',
        '#8c6bb1',
        '#88419d',
        '#810f7c',
        '#4d004b'
    ],
    Oranges: [
        '#fff5eb',
        '#fee6ce',
        '#fdd0a2',
        '#fdae6b',
        '#fd8d3c',
        '#f16913',
        '#d94801',
        '#a63603',
        '#7f2704'
    ],
    BuGn: [
        '#f7fcfd',
        '#e5f5f9',
        '#ccece6',
        '#99d8c9',
        '#66c2a4',
        '#41ae76',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlOrBr: [
        '#ffffe5',
        '#fff7bc',
        '#fee391',
        '#fec44f',
        '#fe9929',
        '#ec7014',
        '#cc4c02',
        '#993404',
        '#662506'
    ],
    YlGn: [
        '#ffffe5',
        '#f7fcb9',
        '#d9f0a3',
        '#addd8e',
        '#78c679',
        '#41ab5d',
        '#238443',
        '#006837',
        '#004529'
    ],
    Reds: [
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#a50f15',
        '#67000d'
    ],
    RdPu: [
        '#fff7f3',
        '#fde0dd',
        '#fcc5c0',
        '#fa9fb5',
        '#f768a1',
        '#dd3497',
        '#ae017e',
        '#7a0177',
        '#49006a'
    ],
    Greens: [
        '#f7fcf5',
        '#e5f5e0',
        '#c7e9c0',
        '#a1d99b',
        '#74c476',
        '#41ab5d',
        '#238b45',
        '#006d2c',
        '#00441b'
    ],
    YlGnBu: [
        '#ffffd9',
        '#edf8b1',
        '#c7e9b4',
        '#7fcdbb',
        '#41b6c4',
        '#1d91c0',
        '#225ea8',
        '#253494',
        '#081d58'
    ],
    Purples: [
        '#fcfbfd',
        '#efedf5',
        '#dadaeb',
        '#bcbddc',
        '#9e9ac8',
        '#807dba',
        '#6a51a3',
        '#54278f',
        '#3f007d'
    ],
    GnBu: [
        '#f7fcf0',
        '#e0f3db',
        '#ccebc5',
        '#a8ddb5',
        '#7bccc4',
        '#4eb3d3',
        '#2b8cbe',
        '#0868ac',
        '#084081'
    ],
    Greys: [
        '#ffffff',
        '#f0f0f0',
        '#d9d9d9',
        '#bdbdbd',
        '#969696',
        '#737373',
        '#525252',
        '#252525',
        '#000000'
    ],
    YlOrRd: [
        '#ffffcc',
        '#ffeda0',
        '#fed976',
        '#feb24c',
        '#fd8d3c',
        '#fc4e2a',
        '#e31a1c',
        '#bd0026',
        '#800026'
    ],
    PuRd: [
        '#f7f4f9',
        '#e7e1ef',
        '#d4b9da',
        '#c994c7',
        '#df65b0',
        '#e7298a',
        '#ce1256',
        '#980043',
        '#67001f'
    ],
    Blues: [
        '#f7fbff',
        '#deebf7',
        '#c6dbef',
        '#9ecae1',
        '#6baed6',
        '#4292c6',
        '#2171b5',
        '#08519c',
        '#08306b'
    ],
    PuBuGn: [
        '#fff7fb',
        '#ece2f0',
        '#d0d1e6',
        '#a6bddb',
        '#67a9cf',
        '#3690c0',
        '#02818a',
        '#016c59',
        '#014636'
    ],
    Viridis: [
        '#440154',
        '#482777',
        '#3f4a8a',
        '#31678e',
        '#26838f',
        '#1f9d8a',
        '#6cce5a',
        '#b6de2b',
        '#fee825'
    ],
    // diverging
    Spectral: [
        '#9e0142',
        '#d53e4f',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#e6f598',
        '#abdda4',
        '#66c2a5',
        '#3288bd',
        '#5e4fa2'
    ],
    RdYlGn: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee08b',
        '#ffffbf',
        '#d9ef8b',
        '#a6d96a',
        '#66bd63',
        '#1a9850',
        '#006837'
    ],
    RdBu: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#f7f7f7',
        '#d1e5f0',
        '#92c5de',
        '#4393c3',
        '#2166ac',
        '#053061'
    ],
    PiYG: [
        '#8e0152',
        '#c51b7d',
        '#de77ae',
        '#f1b6da',
        '#fde0ef',
        '#f7f7f7',
        '#e6f5d0',
        '#b8e186',
        '#7fbc41',
        '#4d9221',
        '#276419'
    ],
    PRGn: [
        '#40004b',
        '#762a83',
        '#9970ab',
        '#c2a5cf',
        '#e7d4e8',
        '#f7f7f7',
        '#d9f0d3',
        '#a6dba0',
        '#5aae61',
        '#1b7837',
        '#00441b'
    ],
    RdYlBu: [
        '#a50026',
        '#d73027',
        '#f46d43',
        '#fdae61',
        '#fee090',
        '#ffffbf',
        '#e0f3f8',
        '#abd9e9',
        '#74add1',
        '#4575b4',
        '#313695'
    ],
    BrBG: [
        '#543005',
        '#8c510a',
        '#bf812d',
        '#dfc27d',
        '#f6e8c3',
        '#f5f5f5',
        '#c7eae5',
        '#80cdc1',
        '#35978f',
        '#01665e',
        '#003c30'
    ],
    RdGy: [
        '#67001f',
        '#b2182b',
        '#d6604d',
        '#f4a582',
        '#fddbc7',
        '#ffffff',
        '#e0e0e0',
        '#bababa',
        '#878787',
        '#4d4d4d',
        '#1a1a1a'
    ],
    PuOr: [
        '#7f3b08',
        '#b35806',
        '#e08214',
        '#fdb863',
        '#fee0b6',
        '#f7f7f7',
        '#d8daeb',
        '#b2abd2',
        '#8073ac',
        '#542788',
        '#2d004b'
    ],
    // qualitative
    Set2: [
        '#66c2a5',
        '#fc8d62',
        '#8da0cb',
        '#e78ac3',
        '#a6d854',
        '#ffd92f',
        '#e5c494',
        '#b3b3b3'
    ],
    Accent: [
        '#7fc97f',
        '#beaed4',
        '#fdc086',
        '#ffff99',
        '#386cb0',
        '#f0027f',
        '#bf5b17',
        '#666666'
    ],
    Set1: [
        '#e41a1c',
        '#377eb8',
        '#4daf4a',
        '#984ea3',
        '#ff7f00',
        '#ffff33',
        '#a65628',
        '#f781bf',
        '#999999'
    ],
    Set3: [
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
    ],
    Dark2: [
        '#1b9e77',
        '#d95f02',
        '#7570b3',
        '#e7298a',
        '#66a61e',
        '#e6ab02',
        '#a6761d',
        '#666666'
    ],
    Paired: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928'
    ],
    Pastel2: [
        '#b3e2cd',
        '#fdcdac',
        '#cbd5e8',
        '#f4cae4',
        '#e6f5c9',
        '#fff2ae',
        '#f1e2cc',
        '#cccccc'
    ],
    Pastel1: [
        '#fbb4ae',
        '#b3cde3',
        '#ccebc5',
        '#decbe4',
        '#fed9a6',
        '#ffffcc',
        '#e5d8bd',
        '#fddaec',
        '#f2f2f2'
    ]
};
// add lowercase aliases for case-insensitive matches
for (let key of Object.keys($6e7cd0a29de34293$var$colorbrewer))$6e7cd0a29de34293$var$colorbrewer[key.toLowerCase()] = $6e7cd0a29de34293$var$colorbrewer[key];
var $6e7cd0a29de34293$export$2e2bcd8739ae039 = $6e7cd0a29de34293$var$colorbrewer;


Object.assign((0, $1f8e68471883117b$export$2e2bcd8739ae039), {
    average: $8b62c96f4c32d2ec$export$2e2bcd8739ae039,
    bezier: $cfb729a2cae9b057$export$2e2bcd8739ae039,
    blend: $c1cde4b90175caa9$export$2e2bcd8739ae039,
    cubehelix: $6bb2fb204ab64a74$export$2e2bcd8739ae039,
    mix: $430a9490493133a9$export$2e2bcd8739ae039,
    interpolate: (0, $430a9490493133a9$export$2e2bcd8739ae039),
    random: $52c36c05dc746f31$export$2e2bcd8739ae039,
    scale: $5720af7f3b38c136$export$2e2bcd8739ae039,
    analyze: $b807a0bbf265e315$export$7cbcccfbecde6416,
    contrast: $add94710b1b92906$export$2e2bcd8739ae039,
    deltaE: $4d0b78ec7ffb1f9c$export$2e2bcd8739ae039,
    distance: $4d1624cfe3048d2c$export$2e2bcd8739ae039,
    limits: $b807a0bbf265e315$export$e331ca4ad6a82555,
    valid: $81784ebd924ed1d4$export$2e2bcd8739ae039,
    scales: $bf3aa5913a5571bf$export$2e2bcd8739ae039,
    input: $3b8568da62f7dcaf$export$2e2bcd8739ae039,
    colors: $bf9461bcb84256f4$export$2e2bcd8739ae039,
    brewer: $6e7cd0a29de34293$export$2e2bcd8739ae039
});
var $9fb9299580b68b25$export$2e2bcd8739ae039 = (0, $1f8e68471883117b$export$2e2bcd8739ae039);







class $bb618cab4deb47b3$export$2e2bcd8739ae039 {
    constructor(parent, path, index, settings){
        this.parent = parent;
        this.path = path;
        this.index = index;
        this.settings = settings;
        this.playhead = {
            ini: 0,
            end: 1
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.prv = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nxt = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.mat = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        this.tween = {
            ini: 0,
            end: 1,
            spiral: 0,
            distAngle: 0
        };
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { size: size, count: count } = this.settings;
        const geometry = new $f70f7eb6404ce619$export$d5c0e8d607467193(0.5, 12);
        const material = new $f70f7eb6404ce619$export$83c7d75d550a8b0d({
            uniforms: {
                uColor: {
                    value: new $f70f7eb6404ce619$export$892596cec99bc70e(1, 1, 1)
                }
            },
            vertexShader: (/*@__PURE__*/$parcel$interopDefault($15fdc39cf459155a$exports)),
            fragmentShader: (/*@__PURE__*/$parcel$interopDefault($366fb73ed3337b36$exports)),
            transparent: true
        });
        const mesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
        this.object3D = mesh;
    }
    updatePositions() {
        const { path: path, object3D: object3D, vec: vec, prv: prv, nxt: nxt, mat: mat, dummy: dummy } = this;
        const { count: count, size: size, noise2D: noise2D } = this.settings;
        const { ini: ini, end: end } = this.playhead;
        const endSeg = end * count;
        const endFloor = Math.floor(endSeg);
        const endFract = endSeg % 1;
        const iniSeg = ini * count;
        const iniFloor = Math.floor(iniSeg);
        const iniFract = iniSeg % 1;
        let t, u, n, p, scale, angle;
        let deltaScale;
        let prevScale = 0;
        let maxDelta = 1.0;
        for(let i = 0; i < count; i++){
            t = i / count;
            p = Math.max(i - 1, 0);
            n = Math.min(i + 1, count - 1);
            vec.set(path.curve.mesh.geometry.attributes.position.getX(i), path.curve.mesh.geometry.attributes.position.getY(i), path.curve.mesh.geometry.attributes.position.getZ(i));
            prv.set(path.curve.mesh.geometry.attributes.position.getX(p), path.curve.mesh.geometry.attributes.position.getY(p), path.curve.mesh.geometry.attributes.position.getZ(p));
            nxt.set(path.curve.mesh.geometry.attributes.position.getX(n), path.curve.mesh.geometry.attributes.position.getY(n), path.curve.mesh.geometry.attributes.position.getZ(n));
            // angle between prev and next points
            angle = vec.clone().sub(prv).angleTo(nxt.sub(vec));
            if (i == n || i == p) angle = 0;
            // remap
            angle = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(angle, 0, Math.PI, 0.02, 1.0);
            // the more curvature the bigger
            scale = angle * size;
            // avoid abrupt variations in scale
            deltaScale = scale - prevScale;
            if (deltaScale > maxDelta) scale = prevScale + maxDelta;
            if (deltaScale < -maxDelta) scale = prevScale - maxDelta;
            prevScale = scale;
            // add a bit of randomness
            scale += (noise2D(t * 4, t * t) * 0.5 + 0.5) * size * 0.1;
            scale *= (0, $a5a3d7804ffbb687$export$b465b7f8c1ade29b)(t, 1);
            if (i == iniFloor - 0) scale *= 1 - iniFract;
            else if (i == endFloor + 1) scale *= (0, (/*@__PURE__*/$parcel$interopDefault($74a4bb2f7505f887$exports))).backOut(endFract);
            else if (i < iniFloor || i > endFloor) scale *= 0;
            dummy.position.copy(vec);
            dummy.scale.set(scale, scale, scale);
            dummy.updateMatrix();
            object3D.setMatrixAt(i, dummy.matrix);
        }
        object3D.instanceMatrix.needsUpdate = true;
    }
    updateColors() {
        const { noise2D: noise2D, count: count, seedColor: seedColor, chroma: chromaMode } = this.settings;
        const { index: index, object3D: object3D } = this;
        const { geometry: geometry } = object3D;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const idxA = (0, $a5a3d7804ffbb687$export$cfa8447a34b05325)(kit.weights, noise2D, index * 11 + seedColor);
        const idxB = (0, $a5a3d7804ffbb687$export$cfa8447a34b05325)(kit.weights, noise2D, index * 88 + seedColor);
        const hexA = kit.colors[idxA];
        const hexB = kit.colors[idxB];
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e();
        let grad;
        // see https://gka.github.io/chroma.js/
        if (chromaMode != 'none') grad = (0, $9fb9299580b68b25$export$2e2bcd8739ae039).scale([
            hexA,
            hexB
        ]).mode(chromaMode).gamma(1.5).colors(count);
        else color.setStyle(hexA);
        for(let i = 0; i < count; i++){
            if (grad) color.setStyle(grad[i]);
            object3D.setColorAt(i, color);
        }
        object3D.instanceColor.needsUpdate = true;
    }
    updatePlayhead(ini = 0, end = 1) {
        this.playhead.ini = ini;
        this.playhead.end = end;
        this.updatePositions();
    }
    show() {
        const { distAngle: distAngle, spiral: spiral, spiralGain: spiralGain, range: range } = this.settings;
        const { timeline: timeline, tween: tween, index: index, path: path, parent: parent } = this;
        const { ini: ini, end: end } = path.segment;
        const duration = (6.0 + ini) * parent.speed;
        const delay = index * (0.4 + 0.2) * parent.speed + range.min * (0, $66b949a687a6d7c0$export$372214499a215ae2) * parent.speed;
        const iniDistAngle = distAngle;
        const iniSpiral = spiral;
        timeline.clear();
        timeline.set(tween, {
            ini: 0,
            end: 0,
            distAngle: distAngle - Math.PI * 0.5,
            spiral: spiral * 0.1
        });
        timeline.to(tween, {
            end: 1,
            duration: duration,
            delay: delay,
            ease: 'quart.out',
            onUpdate: ()=>{
                this.updatePlayhead(tween.ini, tween.end);
            }
        });
        timeline.to(tween, {
            spiral: iniSpiral,
            distAngle: iniDistAngle,
            duration: duration * 0.5,
            delay: delay,
            ease: 'quart.out',
            onUpdate: ()=>{
                this.path.settings.distAngle = tween.distAngle;
                this.path.settings.spiral = tween.spiral;
                this.path.updatePositions();
            }
        }, 0);
        this.updatePlayhead(0, 0);
        return timeline;
    }
    hide() {
        const { tween: tween, index: index, path: path, parent: parent } = this;
        const { ini: ini, end: end } = path.segment;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline();
        const duration = ((0, $66b949a687a6d7c0$export$372214499a215ae2) + ini) * parent.speed;
        const delay = index * 0.4 * parent.speed;
        timeline.to(tween, {
            ini: 1,
            duration: duration,
            ease: 'quad.in',
            onUpdate: ()=>{
                this.updatePlayhead(tween.ini, tween.end);
            }
        }, delay);
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.path.dispose();
        this.object3D.clear();
        this.timeline.kill();
        this.timelineHide?.kill();
        this.path = null;
        this.object3D = null;
        this.timeline = null;
    }
}


class $d6155fbe0b75a5ab$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Dots';
        this.settings = {
            seedColor: 4,
            subpaths: 4,
            parentPoints: 7,
            count: 80,
            size: 70,
            spiral: 2,
            spiralGain: 2,
            dist: 35,
            distAngle: 2.6,
            chroma: 'lrgb',
            ...this.settings
        };
        this.subdots = [];
        this.initData(data);
        this.initGUI();
        this.updatePositions();
    }
    updateColors() {
        this.subdots.forEach((subdot)=>subdot.updateColors());
    }
    updatePositions() {
        const { noise2D: noise2D, settings: settings, name: name } = this;
        settings.noise2D = noise2D;
        // clear existing subdots
        this.object3D.clear();
        this.subdots.forEach((subdot)=>subdot.dispose());
        this.subdots.length = 0;
        // create new
        const options = {
            style: name,
            ...settings
        };
        const subpaths = this.path.getSubPaths(settings.subpaths, options);
        subpaths.forEach((subpath, index)=>{
            const subdot = new (0, $bb618cab4deb47b3$export$2e2bcd8739ae039)(this, subpath, index, settings);
            this.subdots.push(subdot);
            this.object3D.add(subdot.object3D);
            this.object3D.add(subpath.object3D);
        // subpath.object3D.visible = getEditMode();
        });
    }
    show() {
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true
        });
        this.subdots.forEach((subdot)=>{
            timeline.add(subdot.show(), 0);
        });
        this.timelineShow = timeline;
        return timeline;
    }
    hide() {
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true
        });
        this.subdots.forEach((subdot)=>{
            timeline.add(subdot.hide(), 0);
        });
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onEditModeChange(value) {
        this.subdots.forEach((subdot)=>{
            subdot.path.object3D.visible = value;
        });
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        const chromaOptions = {
            hsl: 'hsl',
            lab: 'lab',
            lrgb: 'lrgb',
            none: 'none'
        };
        if (!folder) return;
        folder.addInput(settings, 'subpaths', {
            min: 1,
            max: 8,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'parentPoints', {
            min: 2,
            max: 20,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'count', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'size', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'spiral', {
            min: -5,
            max: 5
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'spiralGain', {
            min: 1,
            max: 10
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'dist', {
            min: 1,
            max: 100
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'distAngle', {
            min: -Math.PI,
            max: Math.PI
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'seedColor', {
            min: 1,
            max: 50,
            step: 1
        }).on('change', this.updateColors.bind(this));
        folder.addInput(settings, 'chroma', {
            options: chromaOptions
        }).on('change', this.updateColors.bind(this));
        return folder;
    }
}









const $db9b855600f7f8d4$export$60d73fe034b5aaf3 = (sides = 3, outerRadius = 100, innerRadius = 80)=>{
    const phi = Math.PI * 2 / sides;
    const tta = Math.PI * 0.5;
    const shape = new $f70f7eb6404ce619$export$6428a7f2611ef1fa();
    const hole = new $f70f7eb6404ce619$export$4b2950bdac9b6ee9();
    let x, y;
    for(let i = 0; i < sides; i++){
        x = Math.cos(phi * i + tta) * outerRadius;
        y = Math.sin(phi * i + tta) * outerRadius;
        if (!i) shape.moveTo(x, y);
        else shape.lineTo(x, y);
    }
    for(let i = 0; i < sides; i++){
        x = Math.cos(phi * -i + tta) * innerRadius;
        y = Math.sin(phi * -i + tta) * innerRadius;
        if (!i) hole.moveTo(x, y);
        else hole.lineTo(x, y);
    }
    shape.holes.push(hole);
    return shape;
};


class $b1ef3c7633adf735$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Poly';
        this.settings = {
            radius: 25,
            sides: 4,
            innerRadius: 0.9,
            count: 60,
            colorIdx: 0,
            gradient: true,
            ...this.settings
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.prv = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nxt = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.up = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.tweens = [];
        this.initData(data);
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { count: count, sides: sides, innerRadius: innerRadius } = this.settings;
        const outerRadius = 1.0;
        const shape = (0, $db9b855600f7f8d4$export$60d73fe034b5aaf3)(sides, outerRadius, innerRadius);
        const geometry = new $f70f7eb6404ce619$export$598697a1efa63ca7(shape, {
            depth: 0.02,
            bevelEnabled: false
        });
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5();
        const mesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
        mesh.visible = innerRadius < outerRadius;
        this.object3D.add(mesh);
        this.mesh = mesh;
        const fillShape = (0, $db9b855600f7f8d4$export$60d73fe034b5aaf3)(sides, innerRadius, 0.0);
        const fillGeometry = new $f70f7eb6404ce619$export$57a29a1c803e9065(fillShape);
        const fillMaterial = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5({
            color: 0x000000,
            side: $f70f7eb6404ce619$export$3b296b6f144d5b03
        });
        const fillMesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(fillGeometry, fillMaterial, count);
        this.object3D.add(fillMesh);
        this.fillMesh = fillMesh;
        // store tween properties
        for(let i = 0; i < count; i++)this.tweens.push({
            scl: 1,
            rot: 0
        });
    }
    updatePositions() {
        const { path: path, mesh: mesh, fillMesh: fillMesh, noise2D: noise2D, vec: vec, prv: prv, nxt: nxt, up: up, dummy: dummy, tweens: tweens } = this;
        const { count: count, radius: radius, sides: sides, innerRadius: innerRadius } = this.settings;
        let t, u, n, p, scale, angle;
        let deltaScale;
        let prevScale = 0;
        let maxDelta = 3.0;
        let tween;
        if (!mesh) return;
        for(let i = 0; i < count; i++){
            t = i / count;
            p = Math.max((i - 1) / count, 0);
            n = Math.min((i + 1) / count, 1);
            path.curve.getPointAt(t, vec);
            path.curve.getPointAt(p, prv);
            path.curve.getPointAt(n, nxt);
            tween = tweens[i];
            scale = radius;
            // avoid abrupt variations in scale
            if (i) {
                deltaScale = scale - prevScale;
                if (deltaScale > maxDelta) scale = prevScale + maxDelta;
                if (deltaScale < -maxDelta) scale = prevScale - maxDelta;
            }
            prevScale = scale;
            // add a bit of randomness
            scale += (noise2D(t * 1, t * t) * 0.5 + 0.5) * radius * 0.1;
            scale *= tween.scl;
            // scale *= parabola(t, 0.2);
            dummy.position.copy(vec);
            dummy.scale.set(scale, scale, scale);
            dummy.lookAt(nxt);
            dummy.rotateOnAxis(nxt.set(0, 0, 1), tween.rot);
            dummy.updateMatrix();
            mesh.setMatrixAt(i, dummy.matrix);
            fillMesh.setMatrixAt(i, dummy.matrix);
        }
        mesh.instanceMatrix.needsUpdate = true;
        fillMesh.instanceMatrix.needsUpdate = true;
    }
    updateColors(skipUpdateGUI) {
        const { count: count, colorIdx: colorIdx, gradient: gradient } = this.settings;
        const { index: index, mesh: mesh, noise2D: noise2D } = this;
        if (!mesh) return;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const idx = colorIdx;
        const hexA = kit.colors[(idx + 0) % lng];
        const hexB = gradient ? kit.colors[(idx + 1) % lng] : (0, $9fb9299580b68b25$export$2e2bcd8739ae039)(hexA).darken(2);
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e();
        const grad = (0, $9fb9299580b68b25$export$2e2bcd8739ae039).scale([
            hexB,
            hexA
        ]).colors(count);
        for(let i = 0; i < count; i++){
            color.setStyle(grad[i]);
            mesh.setColorAt(i, color);
        }
        mesh.instanceColor.needsUpdate = true;
        if (!skipUpdateGUI) this.updateGUIColorRadio();
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    preShow() {
        // hide all on start
        this.tweens.forEach((tween, i)=>{
            tween.scl = 0;
        });
        this.updatePositions();
    }
    show() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            duration = Math.min((0, $66b949a687a6d7c0$export$372214499a215ae2) + 1.0, ((0, $66b949a687a6d7c0$export$372214499a215ae2) + 1.0) * speed + delay);
            timeline.set(tween, {
                scl: 0,
                rot: Math.PI * 1
            }, 0);
            timeline.to(tween, {
                rot: 0,
                duration: duration,
                ease: 'quint.out'
            }, delay);
            timeline.to(tween, {
                scl: 1,
                duration: 0.2,
                ease: 'linear.out'
            }, delay);
        });
        this.timelineShow = timeline;
        return timeline;
    }
    hide() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay, sx, sz;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            duration = 1.0;
            delay = i * delayStep;
            timeline.to(tween, {
                scl: 0,
                duration: 0.5,
                ease: 'back.in'
            }, delay);
        });
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        // remove default children
        while(folder.children.length)folder.remove(folder.children[0]);
        folder.addInput(settings, 'count', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.onGeometryChange.bind(this));
        folder.addInput(settings, 'sides', {
            min: 3,
            max: 8,
            step: 1
        }).on('change', this.onGeometryChange.bind(this));
        folder.addInput(settings, 'radius', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'innerRadius', {
            min: 0,
            max: 1
        }).on('change', this.onGeometryChange.bind(this));
        folder.addInput(settings, 'gradient').on('change', this.updateColors.bind(this));
        return folder;
    }
    onGeometryChange() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
        this.object3D.clear();
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
    onSeedChange() {
        super.onSeedChange();
        this.updateColors();
    }
}






class $ae40abe9dc982fb7$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Rhombus';
        this.settings = {
            colorIdx: 0,
            width: 8,
            height: 24,
            count: 60,
            ...this.settings
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.fwd = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.up = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
        this.sid = new $f70f7eb6404ce619$export$64b5c384219d3699(1, 0, 0);
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.tweens = [];
        this.initData(data);
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        this.settings.count = Math.ceil(this.path.curve.getLength() / this.settings.width);
        const { count: count, width: width, height: height } = this.settings;
        const shape = new $f70f7eb6404ce619$export$6428a7f2611ef1fa();
        shape.moveTo(width * -0.5, 0);
        shape.lineTo(0, height * 0.5);
        shape.lineTo(width * 0.5, 0);
        shape.lineTo(0, height * -0.5);
        const geometry = new $f70f7eb6404ce619$export$57a29a1c803e9065(shape);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5();
        material.side = $f70f7eb6404ce619$export$3b296b6f144d5b03;
        const mesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
        this.object3D.add(mesh);
        this.mesh = mesh;
        // store tween properties
        for(let i = 0; i < count; i++)this.tweens.push({
            scl: 1
        });
    }
    updatePositions() {
        const { path: path, mesh: mesh, noise2D: noise2D, vec: vec, fwd: fwd, up: up, sid: sid, dummy: dummy, tweens: tweens } = this;
        const { count: count } = this.settings;
        let t, scale, tween;
        if (!mesh) return;
        for(let i = 0; i < count; i++){
            t = i / count;
            tween = tweens[i];
            path.curve.getPointAt(t, vec);
            path.curve.getTangentAt(t, fwd);
            scale = 1 * tween.scl;
            // scale = 1;
            dummy.position.copy(vec);
            dummy.scale.set(scale, scale, scale);
            dummy.lookAt(fwd.add(vec));
            dummy.rotateOnAxis(up, Math.PI * 0.5);
            // dummy.rotateOnAxis(sid, Math.PI * 0.5);
            dummy.updateMatrix();
            mesh.setMatrixAt(i, dummy.matrix);
        }
        mesh.instanceMatrix.needsUpdate = true;
    }
    updateColors(skipUpdateGUI) {
        const { count: count, colorIdx: colorIdx } = this.settings;
        const { mesh: mesh } = this;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const hex = kit.colors[colorIdx % lng];
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e().setStyle(hex);
        for(let i = 0; i < count; i++)mesh.setColorAt(i, color);
        mesh.instanceColor.needsUpdate = true;
        if (!skipUpdateGUI) this.updateGUIColorRadio();
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    preShow() {
        // hide all on start
        this.tweens.forEach((tween, i)=>{
            tween.scl = 0;
        });
        this.updatePositions();
    }
    show() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            timeline.set(tween, {
                scl: 0
            }, 0);
            timeline.to(tween, {
                scl: 1,
                duration: 0.5,
                ease: 'expo.out'
            }, delay);
        });
        this.timelineShow = timeline;
        return timeline;
    }
    hide() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            timeline.to(tween, {
                scl: 0,
                duration: 0.2,
                ease: 'expo.in'
            }, delay);
        });
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        // remove default children
        while(folder.children.length)folder.remove(folder.children[0]);
        // folder.addInput(settings, 'count', 				{ min: 1, max: 200, step: 1 }).on('change', this.onCountChange.bind(this));
        // folder.addInput(settings, 'radius', 			{ min: 1, max: 100, step: 1 }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'width', {
            min: 1,
            max: 24,
            step: 1
        }).on('change', this.onCountChange.bind(this));
        folder.addInput(settings, 'height', {
            min: 1,
            max: 48,
            step: 1
        }).on('change', this.onCountChange.bind(this));
        return folder;
    }
    onCountChange() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
        this.object3D.clear();
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
}











class $6a1e0b90035151d3$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.settings = {
            segments: 7,
            height: 60,
            taperEdge: 1.00,
            taperFreq: 0.05,
            taperY: 8,
            rotXFreq: 0.02,
            rotZFreq: 0.05,
            ...this.settings
        };
        this.vec0 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vec1 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.mid0 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.mid1 = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vecA = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vecB = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.fwd = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.mid = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.up = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
        this.initGeometry();
    }
    initData(data) {
        if (!data) return;
        this.preventUpdate = true;
        super.initData(data);
        this.onGeometryChange();
        this.preventUpdate = false;
    }
    initGeometry() {
        const { segments: segments, height: height } = this.settings;
        this.geometry = new $f70f7eb6404ce619$export$967d831af31f69ce(segments * height, height, segments);
        // store the OG geometry
        this.ogeometry = this.geometry.clone();
    }
    updatePositions() {
        const { geometry: geometry, ogeometry: ogeometry, preventUpdate: preventUpdate } = this;
        const { taperEdge: taperEdge, taperFreq: taperFreq, rotXFreq: rotXFreq, rotZFreq: rotZFreq, segments: segments } = this.settings;
        const taperY = this.tween.taperY || this.settings.taperY;
        let taper, rotX, rotZ, t, u;
        if (!geometry) return;
        if (preventUpdate) return;
        // restore OG geometry
        geometry.copy(ogeometry);
        for(let i = 0; i < segments + 1; i++){
            t = i / segments;
            u = (0, $a5a3d7804ffbb687$export$b465b7f8c1ade29b)(t, 2);
            taper = this.noise2D(i * taperFreq * 2, taperY) * 0.5 + 0.5;
            // taper start from 0, end down to taperEdge
            taper *= t < 0.5 ? u : (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(1, u, taperEdge);
            rotX = this.noise2D(t * rotXFreq, 99);
            rotZ = this.noise2D(t * rotZFreq, 1) * 1.5;
            this.transformSegment(i, {
                taper: taper,
                rotX: rotX,
                rotZ: rotZ
            });
        }
        geometry.computeVertexNormals();
        // store the transformed geometry
        this.tgeometry = geometry.clone();
        return true;
    }
    transformSegment(index, { taper: taper = 1, rotX: rotX = 0, rotZ: rotZ = 0 }) {
        const { geometry: geometry, curve: curve, vecA: vecA, vecB: vecB, vec: vec, mid: mid, fwd: fwd, up: up } = this;
        const { segments: segments } = this.settings;
        const idxA = index;
        const idxB = index + segments + 1;
        const nxtA = index + 1;
        const range = this.tween.range || this.settings.range;
        const height = this.tween.height || this.settings.height;
        let t = index / segments;
        // adjust to range
        t = t * (range.max - range.min) + range.min;
        curve.getPoint(t, vec);
        vecA.copy(vec);
        vecB.copy(vec);
        vecA.y -= height * 0.5;
        vecB.y += height * 0.5;
        geometry.attributes.position.setXYZ(idxA, vecA.x, vecA.y, vecA.z);
        geometry.attributes.position.setXYZ(idxB, vecB.x, vecB.y, vecB.z);
        // segment A
        vecA.set(geometry.attributes.position.getX(idxA), geometry.attributes.position.getY(idxA), geometry.attributes.position.getZ(idxA));
        // segment B
        vecB.set(geometry.attributes.position.getX(idxB), geometry.attributes.position.getY(idxB), geometry.attributes.position.getZ(idxB));
        // axis of rotation: forward
        if (idxA < segments) {
            fwd.set(geometry.attributes.position.getX(nxtA), geometry.attributes.position.getY(nxtA), geometry.attributes.position.getZ(nxtA));
            fwd.sub(vecA).normalize();
        }
        // middle of A and B with origin at 0
        vec.subVectors(vecA, vecB).multiplyScalar(0.5);
        // middle of the segment
        mid.subVectors(vecA, vec);
        // rotate vector with origin at 0 (forward)
        vec.applyAxisAngle(fwd, rotX);
        // set axis to perpendicular
        fwd.cross(up);
        // rotate vector with origin at 0 (perpendicular)
        vec.applyAxisAngle(fwd, rotZ);
        // taper
        vec.multiplyScalar(taper);
        // set vertex A to middle + rotated vector
        vecA.addVectors(mid, vec);
        // set vertex B to middle - rotated vector
        vecB.subVectors(mid, vec);
        geometry.attributes.position.setXYZ(idxA, vecA.x, vecA.y, vecA.z);
        geometry.attributes.position.setXYZ(idxB, vecB.x, vecB.y, vecB.z);
        geometry.attributes.position.needsUpdate = true;
    }
    updatePlayhead(ini = 0, end = 1, isHidding = false) {
        const { vec0: vec0, vec1: vec1, mid0: mid0, mid1: mid1, vecA: vecA, vecB: vecB, mid: mid, vec: vec } = this;
        const { segments: segments } = this.settings;
        const { geometry: geometry, tgeometry: tgeometry } = this;
        const position = geometry.attributes.position;
        const tposition = tgeometry.attributes.position;
        const endSeg = end * segments;
        const endFloor = Math.floor(endSeg);
        const endFract = endSeg % 1;
        const iniSeg = ini * segments;
        const iniFloor = Math.floor(iniSeg);
        const iniFract = iniSeg % 1;
        let t, u, fract;
        for(let i = 0; i < segments + 1; i++){
            const idxA = i;
            const idxB = i + segments + 1;
            const iniA = iniFloor;
            const iniB = iniFloor + segments + 1;
            const endA = endFloor;
            const endB = endFloor + segments + 1;
            // define mid points/vectors for each segment
            // idxTA: can be iniA or endA
            // idxTB: can be iniB or endB
            const setMids = (idxTA, idxTB)=>{
                vecA.set(tposition.getX(idxTA + 0), tposition.getY(idxTA + 0), tposition.getZ(idxTA + 0));
                vecB.set(tposition.getX(idxTB + 0), tposition.getY(idxTB + 0), tposition.getZ(idxTB + 0));
                vec0.subVectors(vecB, vecA);
                mid0.copy(vec0).multiplyScalar(0.5).add(vecA);
                vecA.set(tposition.getX(idxTA + 1), tposition.getY(idxTA + 1), tposition.getZ(idxTA + 1));
                vecB.set(tposition.getX(idxTB + 1), tposition.getY(idxTB + 1), tposition.getZ(idxTB + 1));
                vec1.subVectors(vecB, vecA);
                mid1.copy(vec1).multiplyScalar(0.5).add(vecA);
                mid.subVectors(mid1, mid0);
            };
            const setPos = ()=>{
                // rotate edge
                vec1.applyAxisAngle(mid.clone().normalize(), Math.PI * 0.5 * (1 - fract));
                t = (0, (/*@__PURE__*/$parcel$interopDefault($74a4bb2f7505f887$exports))).quadInOut(fract);
                // t = 1 - t;
                u = isHidding ? 1 - t : t;
                position.setX(idxA, mid0.x + mid.x * fract - (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(vec0.x, vec1.x, t) * 0.5 * u);
                position.setY(idxA, mid0.y + mid.y * fract - (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(vec0.y, vec1.y, t) * 0.5 * u);
                position.setZ(idxA, mid0.z + mid.z * fract - (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(vec0.z, vec1.z, t) * 0.5 * u);
                position.setX(idxB, mid0.x + mid.x * fract + (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(vec0.x, vec1.x, t) * 0.5 * u);
                position.setY(idxB, mid0.y + mid.y * fract + (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(vec0.y, vec1.y, t) * 0.5 * u);
                position.setZ(idxB, mid0.z + mid.z * fract + (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(vec0.z, vec1.z, t) * 0.5 * u);
            };
            // snap to segment
            if (i > iniFloor && i <= endFloor) {
                position.setXYZ(idxA, tposition.getX(idxA), tposition.getY(idxA), tposition.getZ(idxA));
                position.setXYZ(idxB, tposition.getX(idxB), tposition.getY(idxB), tposition.getZ(idxB));
            } else if (i <= iniFloor) {
                fract = iniFract;
                setMids(iniA, iniB);
                setPos();
            } else if (i > endFloor) {
                fract = endFract;
                setMids(endA, endB);
                setPos();
            }
        }
        geometry.attributes.position.needsUpdate = true;
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        return folder;
    }
    onGeometryChange() {
        const { segments: segments, height: height } = this.settings;
        if (this.geometry) this.geometry.dispose();
        if (this.ogeometry) this.ogeometry.dispose();
        if (this.tgeometry) this.tgeometry.dispose();
        this.geometry = new $f70f7eb6404ce619$export$967d831af31f69ce(segments * height, height, segments);
        this.ogeometry = this.geometry.clone();
        this.object3D.geometry = this.geometry;
        this.updatePositions();
    }
}



class $3dd3304d9487f438$export$2e2bcd8739ae039 extends $f70f7eb6404ce619$export$f2980790215acccd {
    constructor(params){
        const { defines: defines, uniforms: uniforms, vertexShader: vertexShader, fragmentShader: fragmentShader } = params;
        delete params.defines;
        delete params.uniforms;
        delete params.vertexShader;
        delete params.fragmentShader;
        super(params);
        this.type = 'CustomMaterial';
        this.uniforms = $f70f7eb6404ce619$export$d8ecdf8615bfea69.merge([
            $f70f7eb6404ce619$export$bee4a7d47f8f5014.standard.uniforms,
            uniforms
        ]);
        this.defines = {
            USE_UV: '',
            ...defines
        };
        this.vertexShader = vertexShader || $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphysical_vert;
        this.fragmentShader = fragmentShader || $f70f7eb6404ce619$export$955f9f2e84c43c8b.meshphysical_frag;
    }
}


var $04594ff06cb029b3$exports = {};
$04594ff06cb029b3$exports = "#define GLSLIFY 1\n// CUSTOM\nuniform vec3 uColors[4];\nuniform int uNumColors;\nuniform int uUseLight;\nuniform float uVertical;\n\n#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\n\t// CUSTOM\n\tfloat idxH = vUv.y * float(uNumColors);\n\tfloat idxV = vUv.x * float(uNumColors);\n\tint idx = int(mix(idxH, idxV, uVertical));\n\tdiffuseColor.rgb = uColors[idx];\n\n\tvec4 storedDiffuse = diffuseColor;\n\n\t// float fSmooth = 0.001;\n\t// int idxA = int((vUv.x - fSmooth) * float(NUM_COLORS));\n\t// int idxB = int((vUv.x + fSmooth) * float(NUM_COLORS));\n\n\t// float fSlice = 1.0 / float(NUM_COLORS);\n\t// float fDelta = smoothstep(float(idxB) * fSlice - fSmooth, float(idxB) * fSlice + fSmooth, vUv.x);\n\n\t// diffuseColor.rgb = mix(uColors[idxA], uColors[idxB], fDelta);\n\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t// accumulation\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t// modulation\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\t// Sheen energy compensation approximation calculation can be found at the end of\n\t\t// https://drive.google.com/file/d/1T0D1VSyR4AllqIJTQAraEIzjlb5h4FKH/view?usp=sharing\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\n\t// CUSTOM\n\tif (uUseLight == 0) outgoingLight.rgb = storedDiffuse.rgb;\n\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";


class $f9b51eaf02f6ec25$export$2e2bcd8739ae039 extends (0, $6a1e0b90035151d3$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Ribbon';
        this.settings = {
            lights: true,
            vertical: false,
            numColors: 2,
            ...this.settings
        };
        this.initData(data);
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { geometry: geometry } = this;
        const { numColors: numColors, vertical: vertical } = this.settings;
        const colors = [];
        for(let i = 0; i < 4; i++)colors.push(new $f70f7eb6404ce619$export$892596cec99bc70e());
        const material = new (0, $3dd3304d9487f438$export$2e2bcd8739ae039)({
            uniforms: {
                uColors: {
                    value: colors
                },
                uNumColors: {
                    value: numColors
                },
                uVertical: {
                    value: vertical
                },
                uUseLight: {
                    value: 1
                }
            },
            fragmentShader: // fragmentShader: glslify(require('../shaders/ribbon-standard.frag')),
            (/*@__PURE__*/$parcel$interopDefault($04594ff06cb029b3$exports)),
            flatShading: true,
            side: $f70f7eb6404ce619$export$3b296b6f144d5b03
        });
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        this.object3D = mesh;
    }
    updateColors() {
        const { uniforms: uniforms } = this.object3D.material;
        const { numColors: numColors, vertical: vertical } = this.settings;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        kit.colors.forEach((color, i)=>{
            uniforms.uColors.value[i].setStyle(color);
        });
        // uniforms.uNumColors.value = kit.colors.length;
        uniforms.uNumColors.value = Math.min(numColors, kit.colors.length);
        uniforms.uVertical.value = vertical;
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    onShowUpdate(t) {
        const { tween: tween } = this;
        const { range: range } = this.settings;
        const end = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(t, range.min, range.max, 0, 1);
        this.updatePlayhead(0, end);
    }
    onHideUpdate(t) {
        const { tween: tween } = this;
        const { range: range } = this.settings;
        const ini = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(t, range.min, range.max, 0, 1);
        this.updatePlayhead(ini, 1, true);
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        folder.addInput(settings, 'segments', {
            min: 2,
            max: 100,
            step: 1
        }).on('change', this.onGeometryChange.bind(this));
        folder.addInput(settings, 'height', {
            min: 1,
            max: 200,
            step: 1
        }).on('change', this.onGeometryChange.bind(this));
        folder.addInput(settings, 'taperEdge', {
            min: 0,
            max: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'taperFreq', {
            min: 0,
            max: 1
        }).on('change', this.updatePositions.bind(this));
        // folder.addInput(settings, 'rotXFreq', 	{ min: 0, max: 1 }).on('change', this.updatePositions.bind(this));
        // folder.addInput(settings, 'rotZFreq', 	{ min: 0, max: 1 }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'numColors', {
            min: 0,
            max: 4,
            step: 1
        }).on('change', this.updateColors.bind(this));
        folder.addInput(settings, 'vertical').on('change', this.updateColors.bind(this));
        folder.addInput(settings, 'lights').on('change', this.onLightsChange.bind(this));
    }
    onLightsChange() {
        this.object3D.material.uniforms.uUseLight.value = this.settings.lights;
    }
}








class $1c355c5ede8405f4$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Ring';
        this.settings = {
            offset: 0.25,
            radius: 25,
            colorIdx: 0,
            innerRadius: 0.8,
            outerRadius: 0.98,
            billboard: false,
            sides: 10,
            ...this.settings
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.pos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.fwd = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nml = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.up = new $f70f7eb6404ce619$export$64b5c384219d3699(0, 1, 0);
        this.initData(data);
        this.tween = {
            scale: 1,
            innerRadius: this.settings.innerRadius,
            ...this.tween
        };
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
        this.restoreAnimationSettings();
    }
    initMesh() {
        const { outerRadius: outerRadius, sides: sides, radius: radius } = this.settings;
        const { innerRadius: innerRadius } = this.tween;
        // let inner = innerRadius < outerRadius ? innerRadius : outerRadius;
        // let outer = innerRadius < outerRadius ? outerRadius : innerRadius;
        let inner = innerRadius;
        let outer = outerRadius;
        const shape = (0, $db9b855600f7f8d4$export$60d73fe034b5aaf3)(sides, outer, inner);
        const geometry = new $f70f7eb6404ce619$export$598697a1efa63ca7(shape, {
            depth: 0.5,
            bevelEnabled: false
        });
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5();
        const mesh = new $f70f7eb6404ce619$export$e176487c05830cc5(geometry, material);
        // mesh.visible = innerRadius != outerRadius;
        mesh.visible = innerRadius < outerRadius;
        this.mesh = mesh;
        this.object3D.add(mesh);
    }
    updatePositions() {
        const { path: path, mesh: mesh, tween: tween } = this;
        const { vec: vec, pos: pos, fwd: fwd, nml: nml, up: up } = this;
        const { offset: offset, radius: radius } = this.settings;
        const { innerRadius: innerRadius } = this.tween;
        const scale = radius * 2 * tween.scale;
        const u = offset;
        if (!mesh) return;
        path.curve.getPointAt(u, pos);
        path.curve.getTangentAt(u, fwd);
        mesh.position.copy(pos);
        mesh.scale.set(scale, scale, 1);
        mesh.matrix.lookAt(pos, fwd.add(pos), up);
        mesh.quaternion.setFromRotationMatrix(mesh.matrix);
    }
    updateColors(skipUpdateGUI) {
        const { colorIdx: colorIdx } = this.settings;
        const { mesh: mesh } = this;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const hex = kit.colors[colorIdx % lng];
        mesh.material.color.setStyle(hex);
        if (!skipUpdateGUI) this.updateGUIColorRadio();
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    restoreAnimationSettings() {
        this.tween.innerRadius = this.settings.innerRadius;
    }
    show() {
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).killTweensOf(this.tween);
        this.offsetShowStarted = false;
        this.tween.scale = 0;
        this.restoreAnimationSettings();
        this.updatePositions();
        return super.show();
    }
    hide() {
        return super.hide();
    }
    onShowUpdate(t) {
        const { tween: tween, settings: settings } = this;
        const { offset: offset } = this.settings;
        // only call show when t reaches offset
        if (this.offsetShowStarted) return;
        if (!t || t < offset) return;
        this.offsetShow();
    }
    offsetShow() {
        this.offsetShowStarted = true;
        const { tween: tween, settings: settings } = this;
        // const timeline = gsap.timeline({ onUpdate: () => this.updatePositions() });
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.onGeometryChange()
        });
        timeline.to(tween, {
            scale: 1,
            duration: 0.7,
            ease: 'expo.out'
        }, 0.0);
        timeline.to(tween, {
            innerRadius: 1,
            duration: 2.0,
            ease: 'quart.inOut'
        }, 0.0);
        this.timelineShow = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    // since the ring hides automatically
    // we can make it visible by going back to edit mode
    onEditModeChange(value) {
        if (!value) return;
        this.tween.scale = 1;
        this.restoreAnimationSettings();
        this.onGeometryChange();
        this.updatePositions();
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        // remove default children
        while(folder.children.length)folder.remove(folder.children[0]);
        folder.addInput(settings, 'offset', {
            min: 0,
            max: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'sides', {
            min: 3,
            max: 16,
            step: 1
        }).on('change', this.onGeometryChange.bind(this));
        folder.addInput(settings, 'radius', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'innerRadius', {
            min: 0,
            max: 1
        }).on('change', this.onAnimationSettingsChange.bind(this));
        // folder.addInput(settings, 'outerRadius',	{ min: 0, max: 1  					}).on('change', this.onAnimationSettingsChange.bind(this));
        // folder.addInput(settings, 'billboard').on('change', this.updatePositions.bind(this));
        return folder;
    }
    onAnimationSettingsChange() {
        this.restoreAnimationSettings();
        this.onGeometryChange();
    }
    onGeometryChange() {
        const { object3D: object3D, mesh: mesh } = this;
        if (!object3D) return;
        // remove old
        if (mesh) mesh.geometry.dispose();
        if (mesh) mesh.material.dispose();
        object3D.clear();
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
}












class $959ad78b11524c41$export$2e2bcd8739ae039 {
    constructor(parent, path, index, settings){
        this.parent = parent;
        this.path = path;
        this.index = index;
        this.settings = settings;
        this.playhead = {
            ini: 0,
            end: 1
        };
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.pos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.mat = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.tweens = [];
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { count: count, size: size } = this.settings;
        const geometry = new $f70f7eb6404ce619$export$967d831af31f69ce(size * 0.5, size);
        geometry.rotateX(Math.PI * 0.5);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5();
        material.side = $f70f7eb6404ce619$export$3b296b6f144d5b03;
        const mesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
        this.object3D = mesh;
        // store tween properties
        for(let i = 0; i < count; i++)this.tweens.push({
            sx: 1,
            sz: 1,
            rot: 1
        });
    }
    updatePositions() {
        const { parent: parent, index: index, path: path, object3D: object3D, dummy: dummy, tweens: tweens, vec: vec, pos: pos, mat: mat } = this;
        const { count: count, noise2D: noise2D, twist: twist } = this.settings;
        let t, u;
        let sx, sy, sz;
        let tween, taperEdge;
        const rootSubSpine = parent.subspines[0];
        for(let i = 0; i < count; i++){
            t = i / count;
            u = (0, $a5a3d7804ffbb687$export$b465b7f8c1ade29b)(t, 1);
            tween = tweens[i];
            // get point on offset curve
            path.curve.getPointAt(t, pos);
            dummy.position.copy(pos);
            // look at a point on the original curve
            path.path.curve.getPoint(t, vec);
            // look at first subplane curve			
            if (index) {
                rootSubSpine.object3D.getMatrixAt(i, mat);
                vec.setFromMatrixPosition(mat);
            }
            dummy.lookAt(vec);
            // random rotation
            vec.sub(pos).normalize();
            dummy.rotateOnAxis(vec, noise2D(i * 0.02, index) * tween.rot);
            // random scale
            sy = 1;
            sz = noise2D(t * 2, index) * 0.5 + 0.5 + 0.5;
            sx = noise2D(sz, t + index) * 0.5 + 0.5;
            // taper edge
            if (index % 3 == 0) taperEdge = 1.0;
            if (index % 3 == 1) taperEdge = 0.6;
            if (index % 3 == 2) taperEdge = 0.8;
            sz *= t < 0.5 ? u : (0, $a5a3d7804ffbb687$export$3a89f8d6f6bf6c9f)(1, u, taperEdge);
            dummy.scale.set(sx, sy, sz);
            // tweened scale
            dummy.scale.x *= tween.sx;
            dummy.scale.z *= tween.sz;
            // hide the last ones so the end of the spine looks uneven
            if (index % 3 == 2 && i > count - 4) dummy.scale.x = 0;
            dummy.updateMatrix();
            object3D.setMatrixAt(i, dummy.matrix);
        }
        object3D.instanceMatrix.needsUpdate = true;
    }
    updateColors() {
        const { noise2D: noise2D, count: count } = this.settings;
        const { index: index, object3D: object3D } = this;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const idx = index % lng;
        const hexA = kit.colors[idx];
        const hexB = (0, $9fb9299580b68b25$export$2e2bcd8739ae039)(hexA).darken(2);
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e().setStyle(hexA);
        for(let i = 0; i < count; i++)object3D.setColorAt(i, color);
        object3D.instanceColor.needsUpdate = true;
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    show() {
        const { tweens: tweens, index: index, path: path, parent: parent } = this;
        const { size: size, noise2D: noise2D, count: count, animation: animation } = this.settings;
        let t, duration, delay, sx, sz;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * parent.speed / count;
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            duration = (0, $a5a3d7804ffbb687$export$c57dab19627697ef)(t, 2.5) * 0.5 + 0.2;
            delay = i * (delayStep + (1.0 - (0, (/*@__PURE__*/$parcel$interopDefault($74a4bb2f7505f887$exports))).quartOut(t)) * delayStep);
            delay += index * 0.45 * parent.speed;
            switch(animation){
                case 'S':
                    sx = 1;
                    sz = 0;
                    break;
                case 'L':
                    sx = 2;
                    sz = 5;
                    break;
                case 'XL':
                    sx = 1;
                    sz = 10;
                    break;
                case 'M':
                default:
                    sx = 5;
                    sz = 1;
                    break;
            }
            timeline.set(tween, {
                sx: 0,
                sz: 0,
                rot: -2
            }, 0);
            timeline.to(tween, {
                sx: sx,
                sz: sz,
                duration: duration,
                ease: 'back.out'
            }, delay);
            timeline.to(tween, {
                sx: 1,
                sz: 1,
                duration: duration,
                ease: 'quart.out'
            }, delay + duration);
            timeline.to(tween, {
                rot: 2,
                duration: duration * 3,
                ease: 'back.inOut'
            }, delay);
        });
        this.timelineShow = timeline;
        return timeline;
    }
    hide(immediate = false) {
        const { tweens: tweens, index: index, parent: parent } = this;
        const { count: count } = this.settings;
        if (immediate) {
            tweens.forEach((tween, i)=>{
                tween.sx = tween.sz = 0;
            });
            this.updatePositions();
            return;
        }
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * parent.speed / count;
        let t, duration, delay;
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            duration = 0.5;
            delay = i * 0.01;
            delay += index * 0.25 * parent.speed;
            timeline.to(tween, {
                sx: 2,
                duration: duration,
                ease: 'back.in'
            }, delay);
            timeline.to(tween, {
                sx: 0,
                sz: 0,
                duration: duration,
                ease: 'expo.in'
            }, delay + duration);
            timeline.to(tween, {
                rot: -2,
                duration: duration * 2,
                ease: 'quad.inOut'
            }, delay);
        });
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.path.dispose();
        this.object3D.clear();
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        this.path = null;
        this.object3D = null;
        this.timeline = null;
    }
}


class $fdac46b808fbf231$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Spine';
        this.settings = {
            subpaths: 3,
            parentPoints: 7,
            count: 100,
            size: 10,
            gap: 12,
            spiral: 0.5,
            twist: 0,
            dist: 10,
            distAngle: 2.4,
            animation: 'M',
            ...this.settings
        };
        this.subspines = [];
        this.initData(data);
        this.initGUI();
        this.updatePositions();
    }
    updateColors() {
        this.subspines.forEach((subspine)=>subspine.updateColors());
    }
    updatePositions() {
        const { noise2D: noise2D, settings: settings, name: name } = this;
        settings.noise2D = noise2D;
        // clear existing subspines
        this.object3D.clear();
        this.subspines.forEach((subspine)=>subspine.dispose());
        this.subspines.length = 0;
        const options = {
            style: name,
            ...settings
        };
        const subpaths = this.path.getSubPaths(settings.subpaths, options);
        subpaths.forEach((subpath, index)=>{
            const subspine = new (0, $959ad78b11524c41$export$2e2bcd8739ae039)(this, subpath, index, settings);
            this.subspines.push(subspine);
            this.object3D.add(subspine.object3D);
            this.object3D.add(subpath.object3D);
        // subpath.object3D.visible = getEditMode();
        });
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    preShow() {
        // hide all on start
        this.subspines.forEach((subspine)=>subspine.hide(true));
    }
    show() {
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true
        });
        this.subspines.forEach((subspine)=>{
            timeline.add(subspine.show(), 0);
        });
        this.timelineShow = timeline;
        return timeline;
    }
    hide() {
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            autoRemoveChildren: true
        });
        this.subspines.forEach((subspine)=>{
            timeline.add(subspine.hide(), 0);
        });
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    onEditModeChange(value) {
        this.subspines.forEach((subspine)=>{
            subspine.path.object3D.visible = value;
        });
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        const animOptions = {
            S: 'S',
            M: 'M',
            L: 'L',
            XL: 'XL'
        };
        if (!folder) return;
        folder.addInput(settings, 'subpaths', {
            min: 1,
            max: 6,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'parentPoints', {
            min: 2,
            max: 20,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'count', {
            min: 1,
            max: 200,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'size', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'gap', {
            min: 1,
            max: 100,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'spiral', {
            min: 0,
            max: 10
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'twist', {
            min: 0,
            max: Math.PI * 2
        }).on('change', this.updatePositions.bind(this));
        // folder.addInput(settings, 'spiralGain', 	{ min: 1, max: 10  }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'dist', {
            min: 1,
            max: 100
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'distAngle', {
            min: -Math.PI,
            max: Math.PI
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'animation', {
            options: animOptions
        });
        return folder;
    }
}








class $a375ea6537805684$export$2e2bcd8739ae039 extends (0, $66b949a687a6d7c0$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Twist';
        this.settings = {
            count: 80,
            size: 60,
            twistX: 2.5,
            twistY: 2.0,
            twistZ: 2.0,
            colorIdx: 0,
            gradient: true,
            ...this.settings
        };
        // initial count proportional to path length
        this.settings.count = ~~(path.curve.getLength() / 3);
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.pos = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.nxt = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.mat = new $f70f7eb6404ce619$export$2ae72fc923e5eb5();
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.tweens = [];
        this.initData(data);
        this.initMesh();
        this.initGUI();
        this.updatePositions();
        this.updateColors();
    }
    initMesh() {
        const { count: count, size: size } = this.settings;
        const geometry = new $f70f7eb6404ce619$export$33e43285f7406bd5(1, 0.5, 0.5);
        geometry.rotateX(Math.PI * 0.5);
        const material = new $f70f7eb6404ce619$export$55cbcc9b622fe1f5();
        material.side = $f70f7eb6404ce619$export$3b296b6f144d5b03;
        const mesh = new $f70f7eb6404ce619$export$f3c979c331175ad7(geometry, material, count);
        this.object3D.add(mesh);
        this.mesh = mesh;
        // store tween properties
        for(let i = 0; i < count; i++)this.tweens.push({
            scl: 1,
            tx: 1
        });
    }
    updatePositions() {
        const { index: index, path: path, mesh: mesh, dummy: dummy, tweens: tweens, vec: vec, nxt: nxt, pos: pos, mat: mat } = this;
        const { count: count, noise2D: noise2D, twistX: twistX, twistY: twistY, twistZ: twistZ, size: size } = this.settings;
        let t, n, u;
        let sx, sy, sz;
        let tween, taperEdge;
        if (!mesh) return;
        for(let i = 0; i < count; i++){
            t = i / count;
            n = Math.min((i + 1) / count, 1);
            // u = parabola(t, 1);
            tween = tweens[i];
            // get point on offset curve
            path.curve.getPointAt(t, pos);
            path.curve.getPointAt(n, nxt);
            sx = size * tween.scl;
            sy = 1 * tween.scl;
            sz = 1 * tween.scl;
            dummy.position.copy(pos);
            dummy.scale.set(sx, sy, sz);
            // dummy.lookAt(nxt);
            // dummy.rotateOnAxis(nxt.normalize(), t * Math.PI);
            dummy.rotation.set(0, 0, t * Math.PI);
            dummy.rotateOnAxis(nxt.set(0, 0, 1), t * Math.PI * twistZ);
            dummy.rotateOnAxis(nxt.set(1, 0, 0), t * -Math.PI * twistX);
            dummy.rotateOnAxis(nxt.set(0, 1, 0), t * Math.PI * twistY * tween.tx);
            dummy.updateMatrix();
            mesh.setMatrixAt(i, dummy.matrix);
        }
        mesh.instanceMatrix.needsUpdate = true;
    }
    updateColors(skipUpdateGUI) {
        const { count: count, colorIdx: colorIdx, gradient: gradient } = this.settings;
        const { mesh: mesh } = this;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const lng = kit.colors.length;
        const idx = colorIdx;
        const hexA = kit.colors[(idx + 0) % lng];
        const hexB = gradient ? kit.colors[(idx + 1) % lng] : (0, $9fb9299580b68b25$export$2e2bcd8739ae039)(hexA).darken(2);
        const color = new $f70f7eb6404ce619$export$892596cec99bc70e();
        const grad = (0, $9fb9299580b68b25$export$2e2bcd8739ae039).scale([
            hexB,
            hexA
        ]).colors(count);
        for(let i = 0; i < count; i++){
            color.setStyle(grad[i]);
            mesh.setColorAt(i, color);
        }
        mesh.instanceColor.needsUpdate = true;
        if (!skipUpdateGUI) this.updateGUIColorRadio();
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    preShow() {
        // hide all on start
        this.tweens.forEach((tween, i)=>{
            tween.scl = 0;
        });
        this.updatePositions();
    }
    show() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            timeline.set(tween, {
                scl: 0,
                tx: 0
            }, 0);
            timeline.to(tween, {
                scl: 1,
                tx: 1,
                duration: 1.0,
                ease: 'expo.out'
            }, delay);
        });
        this.timelineShow = timeline;
        return timeline;
    }
    hide() {
        const { tweens: tweens, index: index, speed: speed } = this;
        const { count: count } = this.settings;
        let t, duration, delay;
        const timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onUpdate: ()=>this.updatePositions()
        });
        const delayStep = (0, $66b949a687a6d7c0$export$372214499a215ae2) * speed / count;
        timeline.clear();
        tweens.forEach((tween, i)=>{
            t = i / tweens.length;
            delay = i * delayStep;
            timeline.to(tween, {
                scl: 0,
                duration: 0.2,
                ease: 'expo.in'
            }, delay);
        });
        this.timelineHide = timeline;
        return timeline;
    }
    dispose() {
        this.timelineShow?.kill();
        this.timelineHide?.kill();
        super.dispose();
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        // remove default children
        while(folder.children.length)folder.remove(folder.children[0]);
        folder.addInput(settings, 'count', {
            min: 1,
            max: 400,
            step: 1
        }).on('change', this.onCountChange.bind(this));
        folder.addInput(settings, 'size', {
            min: 1,
            max: 200,
            step: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'twistX', {
            min: 0,
            max: 5
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'twistY', {
            min: 0,
            max: 5
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'twistZ', {
            min: 0,
            max: 5
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'gradient').on('change', this.updateColors.bind(this));
    }
    onCountChange() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
        this.object3D.clear();
        this.initMesh();
        this.updatePositions();
        this.updateColors();
    }
}










class $9e5e442dfd5898ca$export$2e2bcd8739ae039 extends (0, $6a1e0b90035151d3$export$2e2bcd8739ae039) {
    constructor(path, index, data){
        super(path, index);
        this.name = 'Wire';
        this.settings = {
            ...this.settings,
            count: 8,
            segments: 7,
            height: 100,
            taperEdge: 1.0,
            colorIdx: 0
        };
        this.lines = [];
        this.tween = {
            taperY: this.settings.taperY,
            height: this.settings.height,
            range: {
                min: this.settings.range.min,
                max: this.settings.range.max
            },
            ...this.tween
        };
        this.initLines();
        this.initData(data);
        this.initGUI();
        this.restoreAnimationSettings();
        // HACK: Line2 needs to be recreated when segments change
        // I don't know why...
        this.removeAndRecreate();
    }
    initLines() {
        const { path: path } = this;
        const { count: count } = this.settings;
        for(let i = 0; i < count; i++){
            const geometry = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
            const material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
                linewidth: 2
            });
            const mesh = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometry, material);
            // use resolution stored in parent path
            material.resolution.copy(path.res);
            this.lines.push(mesh);
            this.object3D.add(mesh);
        }
    }
    updatePositions(skipParent) {
        if (skipParent != true) {
            if (!super.updatePositions()) return;
        }
        const { geometry: geometry, lines: lines, vec: vec, vecA: vecA, vecB: vecB } = this;
        const { segments: segments, count: count } = this.settings;
        let t, line, positions;
        for(let i = 0; i < count; i++){
            positions = [];
            line = lines[i];
            t = i / (count - 1);
            for(let j = 0; j < segments + 1; j++){
                const idxA = j;
                const idxB = j + segments + 1;
                // segment A
                vecA.set(geometry.attributes.position.getX(idxA), geometry.attributes.position.getY(idxA), geometry.attributes.position.getZ(idxA));
                // segment B
                vecB.set(geometry.attributes.position.getX(idxB), geometry.attributes.position.getY(idxB), geometry.attributes.position.getZ(idxB));
                vec.subVectors(vecB, vecA);
                vec.multiplyScalar(t);
                vec.add(vecA);
                positions.push(vec.x, vec.y, vec.z);
            }
            line.geometry.setPositions(positions);
            line.computeLineDistances();
        }
    }
    updateColors(skipUpdateGUI) {
        const { colorIdx: colorIdx } = this.settings;
        const { lines: lines } = this;
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        const team = goal.teamDO;
        const kit = team.kits[goal.kit];
        const hex = kit.colors[colorIdx];
        lines.forEach((line)=>line.material.color.setStyle(hex));
        if (!skipUpdateGUI) this.updateGUIColorRadio();
    }
    updatePlayhead(ini = 0, end = 1) {
        super.updatePlayhead(ini, end);
        this.updatePositions(true);
    }
    // ---------------------------------------------------------------------------------------------
    // MOTION
    // ---------------------------------------------------------------------------------------------
    restoreAnimationSettings() {
        this.tween.range.min = this.settings.range.min;
        this.tween.range.max = this.settings.range.max;
        this.tween.height = this.settings.height;
    }
    preShow() {
        this.lines.forEach((line)=>line.visible = false);
    }
    show() {
        this.restoreAnimationSettings();
        return super.show();
    }
    hide() {
        this.restoreAnimationSettings();
        return super.hide();
    }
    onShowUpdate(t) {
        const { tween: tween, settings: settings } = this;
        const { range: range } = this.settings;
        this.lines.forEach((line)=>line.visible = true);
        tween.range.max = (0, $a5a3d7804ffbb687$export$7d15b64cf5a3a4c4)(t, range.min, range.max);
        tween.height = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(t, range.min, range.max * 0.5, 1, settings.height);
        tween.taperY = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(t, range.min, range.max, 7, 8);
        this.updatePositions();
    }
    onHideUpdate(t) {
        const { tween: tween, settings: settings } = this;
        const { range: range } = this.settings;
        tween.range.min = (0, $a5a3d7804ffbb687$export$7d15b64cf5a3a4c4)(t, range.min, range.max);
        tween.height = (0, $a5a3d7804ffbb687$export$871de8747c9eaa88)(t, range.min, range.max, settings.height, 1);
        if (t >= 1) this.lines.forEach((line)=>line.visible = false);
        this.updatePositions();
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        const folder = super.initGUI(parent);
        const { settings: settings } = this;
        if (!folder) return;
        folder.addInput(settings, 'segments', {
            min: 2,
            max: 20,
            step: 1
        }).on('change', this.onSegmentsChange.bind(this));
        folder.addInput(settings, 'height', {
            min: 1,
            max: 200,
            step: 1
        }).on('change', this.onAnimationSettingsChange.bind(this));
        folder.addInput(settings, 'count', {
            min: 2,
            max: 10,
            step: 1
        }).on('change', this.onCountChange.bind(this));
        folder.addInput(settings, 'taperEdge', {
            min: 0,
            max: 1
        }).on('change', this.updatePositions.bind(this));
        folder.addInput(settings, 'taperFreq', {
            min: 0,
            max: 1
        }).on('change', this.onAnimationSettingsChange.bind(this));
    // folder.addInput(settings, 'rotXFreq', 	{ min: 0, max: 1 }).on('change', this.updatePositions.bind(this));
    // folder.addInput(settings, 'rotZFreq', 	{ min: 0, max: 1 }).on('change', this.updatePositions.bind(this));
    }
    onSegmentsChange() {
        this.restoreAnimationSettings();
        this.onGeometryChange();
        this.removeAndRecreate();
    }
    onAnimationSettingsChange() {
        this.restoreAnimationSettings();
        this.updatePositions();
    }
    onCountChange() {
        this.removeAndRecreate();
    }
    // LineGeometry.setPositions is not enough to update the geometry
    // so it needs to be removed and recreated
    removeAndRecreate() {
        // remove old
        this.object3D.clear();
        this.lines.length = 0;
        // recreate
        this.initLines();
        // update
        this.updatePositions();
        this.updateColors();
    }
    onRangeChange() {
        this.restoreAnimationSettings();
        this.updatePositions();
    }
}


class $c64c6e2d46975a07$export$2e2bcd8739ae039 {
    constructor(paths, index){
        this.paths = paths;
        this.index = index;
        this.arcSegments = 100;
        this.vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        this.res = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.styles = [];
        this.anchors = [];
        this.positions = [];
        this.colors = [
            new $f70f7eb6404ce619$export$892596cec99bc70e(0xFF7728),
            new $f70f7eb6404ce619$export$892596cec99bc70e(0xFFFA00),
            new $f70f7eb6404ce619$export$892596cec99bc70e(0x886CE4)
        ];
        this.emojis = [
            "\uD83D\uDFE7",
            "\uD83D\uDFE8",
            "\uD83D\uDFEA"
        ];
        this.color = this.colors[this.index % this.colors.length];
        this.emoji = this.emojis[this.index % this.emojis.length];
        this.selected = false;
        // store initial resolution
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.getSize(this.res);
        this.initStyles();
        this.initGUI();
        this.addListeners();
    }
    initStyles() {
        this.styleOptions = [
            {
                text: '',
                value: ''
            },
            {
                text: 'Badge',
                value: 'Badge',
                constrctr: (0, $5a8353e817d41133$export$2e2bcd8739ae039)
            },
            // { text: 'Candy', 				value: 'Candy', 			constrctr: Candy 	},
            {
                text: 'Dots',
                value: 'Dots',
                constrctr: (0, $d6155fbe0b75a5ab$export$2e2bcd8739ae039)
            },
            {
                text: 'Poly',
                value: 'Poly',
                constrctr: (0, $b1ef3c7633adf735$export$2e2bcd8739ae039)
            },
            {
                text: 'Rhombus',
                value: 'Rhombus',
                constrctr: (0, $ae40abe9dc982fb7$export$2e2bcd8739ae039)
            },
            {
                text: 'Ribbon',
                value: 'Ribbon',
                constrctr: (0, $f9b51eaf02f6ec25$export$2e2bcd8739ae039)
            },
            {
                text: 'Ring',
                value: 'Ring',
                constrctr: (0, $1c355c5ede8405f4$export$2e2bcd8739ae039)
            },
            {
                text: 'Spine',
                value: 'Spine',
                constrctr: (0, $fdac46b808fbf231$export$2e2bcd8739ae039)
            },
            {
                text: 'Twist',
                value: 'Twist',
                constrctr: (0, $a375ea6537805684$export$2e2bcd8739ae039)
            },
            {
                text: 'Wire',
                value: 'Wire',
                constrctr: (0, $9e5e442dfd5898ca$export$2e2bcd8739ae039)
            }
        ];
    }
    addListeners() {
        this.handlerEditModeChange = this.onEditModeChange.bind(this);
        (0, $3e6ad3d87c16793a$export$bad24218ebd77223).addListener((0, $3e6ad3d87c16793a$export$4bf9923669ad6c63).EDIT_MODE_CHANGE, this.handlerEditModeChange);
    }
    removeListeners() {
        (0, $3e6ad3d87c16793a$export$bad24218ebd77223).removeListener((0, $3e6ad3d87c16793a$export$4bf9923669ad6c63).EDIT_MODE_CHANGE, this.handlerEditModeChange);
    }
    addAnchor(pos) {
        const anchor = new (0, $70d7e2ec528e5953$export$2e2bcd8739ae039)(this, this.anchors.length, pos);
        this.anchors.push(anchor);
        this.object3D.add(anchor.object3D);
        this.positions.push(anchor.position);
        this.updateCurve();
        this.updatePositions();
        this.updateInteractive();
        this.paths.select(this.index);
        return anchor;
    }
    removeAnchor(index) {
        const anchor = this.anchors.find((a)=>a.index == index);
        if (!anchor) return;
        this.anchors.splice(anchor.index, 1);
        this.positions.splice(anchor.index, 1);
        this.object3D.remove(anchor.object3D);
        // reset indices
        this.anchors.forEach((a, i)=>a.index = i);
        this.updateCurve();
        this.updatePositions();
        this.updateInteractive();
        this.paths.select(this.index);
        return true;
    }
    addStyle(value, data) {
        if (!this.curve) return;
        const option = this.styleOptions.find((s)=>s.value == value);
        const style = new option.constrctr(this, this.styles.length, data);
        this.styles.push(style);
        this.object3D.add(style.object3D);
        // when loading from data, don't expand the folder automatically
        if (!data && style.folder) style.folder.expanded = true;
        return style;
    }
    removeStyle(index) {
        const style = this.styles.find((s)=>s.index == index);
        this.folder.remove(style.folder);
        this.styles.splice(style.index, 1);
        this.object3D.remove(style.object3D);
        style.dispose();
        // reset indices
        this.styles.forEach((s, i)=>{
            s.index = i;
            s.folder.title = `${s.index}. ${s.name}`;
        });
        return true;
    }
    updateCurve() {
        // remove old
        if (this.curve) this.object3D.remove(this.curve.mesh);
        this.curve = null;
        // not enough points
        if (this.positions.length < 2) return;
        const geometry = new (0, $c98643cc0e057f82$export$dcc17b59d0a74bb5)();
        const material = new (0, $dd054968e1e8a14b$export$d19cd1378966f3d3)({
            color: this.color,
            linewidth: 3
        });
        const mesh = new (0, $686e313a31645cea$export$4e6fcde58d84e955)(geometry, material);
        this.curve = new $f70f7eb6404ce619$export$b9146b27c24b744c(this.positions);
        this.curve.curveType = 'centripetal';
        this.curve.mesh = mesh;
        this.object3D.add(mesh);
        this.resize();
    }
    updatePositions() {
        if (!this.curve) return;
        if (this.curve.points.length < 2) return;
        const { vec: vec, curve: curve, arcSegments: arcSegments } = this;
        const positions = [];
        for(let i = 0; i < arcSegments; i++){
            const t = i / (arcSegments - 1);
            curve.getPoint(t, vec);
            positions.push(vec.x, vec.y, vec.z);
        }
        curve.mesh.geometry.setPositions(positions);
        curve.mesh.computeLineDistances();
        this.styles.forEach((style)=>style.updatePositions());
    }
    updateInteractive() {
        // handle in the parent
        this.paths.updateInteractive();
    }
    updateColors() {
        this.styles.forEach((style)=>style.updateColors());
    }
    show(delay = 0, onComplete) {
        let shortest = 999;
        let duration = 0;
        let show;
        if (this.timeline) this.timeline.kill();
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: onComplete
        });
        this.styles.forEach((style)=>{
            style.preShow();
            show = style.show();
            duration = Math.min(show.duration(), (0, $66b949a687a6d7c0$export$372214499a215ae2) * style.speed);
            if (duration < shortest) shortest = duration;
            this.timeline.add(show, delay);
        });
        this.timeline.play(0);
        return shortest;
    }
    hide(delay = 0, onComplete) {
        let shortest = 999;
        let duration = 0;
        let hide;
        if (this.timeline) this.timeline.kill();
        this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
            onComplete: onComplete
        });
        this.styles.forEach((style)=>{
            hide = style.hide();
            duration = Math.min(hide.duration(), (0, $66b949a687a6d7c0$export$372214499a215ae2) * style.speed);
            if (duration < shortest) shortest = duration;
            this.timeline.add(hide, delay);
        });
        this.timeline.play(0);
        return shortest;
    }
    showHide(showDelay = 0, hideDelay = 0, onPathComplete) {
        let shortestShow = 999;
        let shortestHide = 999;
        let countComplete = 0;
        if (this.timeline) this.timeline.kill();
        const onStyleComplete = ()=>{
            countComplete++;
            if (countComplete == this.styles.length) onPathComplete();
        };
        this.styles.forEach((style, index)=>{
            style.preShow();
            const { showDuration: showDuration, hideComplete: hideComplete } = style.showHide(showDelay, hideDelay, onStyleComplete);
            if (showDuration < shortestShow) shortestShow = showDuration;
            if (hideComplete < shortestHide) shortestHide = hideComplete;
        });
        return {
            showDuration: shortestShow,
            hideComplete: shortestHide
        };
    }
    reload(data) {
        data.anchors.forEach((a)=>{
            this.addAnchor(new $f70f7eb6404ce619$export$64b5c384219d3699().fromArray(a));
        });
        data.styles.forEach((s)=>{
            this.addStyle(s.name, s);
        });
        this.onEditModeChange(!!(0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)());
    }
    serialize() {
        return {
            anchors: this.anchors.map((anchor)=>anchor.serialize()),
            styles: this.styles.map((style)=>style.serialize())
        };
    }
    dispose() {
        this.styles.forEach((style)=>style.dispose());
        this.folder?.dispose();
        this.object3D.clear();
        this.removeListeners();
        this.styles = null;
        this.anchors = null;
        this.positions = null;
        this.object3D = null;
        this.folder = null;
    }
    // ---------------------------------------------------------------------------------------------
    // UTILS
    // ---------------------------------------------------------------------------------------------
    getSubPaths(num = 3, options = {}) {
        const { path: path } = this;
        const { noise2D: noise2D, range: range, style: style } = options;
        const vec = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const slice = (range.max - range.min) / num;
        const subpaths = [];
        let ini, end, ext;
        let segment, subpath;
        // Spine: always use ini:0 end:1
        if (style == 'Spine') {
            for(let i = 0; i < num; i++){
                ini = range.min;
                end = range.max;
                subpath = new (0, $22eea921ce8ffc08$export$2e2bcd8739ae039)(this, {
                    ini: ini,
                    end: end
                }, i, options);
                subpaths.push(subpath);
            }
            return subpaths;
        }
        // Dots: randomly overlapping segments
        // split a range [0,1] into num slices
        // extend ini and end of each segment to overlap
        for(let i = 0; i < num; i++){
            ini = (i + 0) * slice + range.min;
            end = (i + 1) * slice + range.min;
            // extend ini
            ext = (0, $a5a3d7804ffbb687$export$267eb760cb73f794)(slice * 1.0, slice * 2.0, noise2D, (i + 0) * 100);
            ini = (0, $a5a3d7804ffbb687$export$7d15b64cf5a3a4c4)(ini - ext, range.min, range.max);
            // extend end
            ext = (0, $a5a3d7804ffbb687$export$267eb760cb73f794)(slice * 0.5, slice * 2.0, noise2D, (i + 1) * 50);
            end = (0, $a5a3d7804ffbb687$export$7d15b64cf5a3a4c4)(end + ext, range.min, range.max);
            segment = {
                ini: ini,
                end: end
            };
            subpath = new (0, $22eea921ce8ffc08$export$2e2bcd8739ae039)(this, segment, i, options);
            subpaths.push(subpath);
        }
        return subpaths;
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    resize(vw, vh) {
        if (vw && vh) this.res.set(vw, vh);
        if (this.curve) this.curve.mesh.material.resolution.copy(this.res);
    }
    onEditModeChange(value) {
        this.curve.mesh.visible = value;
        this.anchors.forEach((anchor)=>{
            anchor.object3D.visible = value;
        });
        this.styles.forEach((style)=>style.onEditModeChange(value));
    }
    // ---------------------------------------------------------------------------------------------
    // GUI
    // ---------------------------------------------------------------------------------------------
    initGUI(parent) {
        if (!(0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)()) return;
        if (!parent) parent = (0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)().folderPaths;
        const onAddStyle = (e)=>{
            if (!e.value) return;
            e.target.value = '';
            this.addStyle(e.value);
        };
        const onRemoveClick = ()=>{
            this.paths.removePath(this.index);
        };
        const onVisibleClick = (value)=>{
            this.object3D.visible = value;
        };
        const onFold = (e)=>{
            (0, $f99d9b9bcbcf0b76$export$7991a91610b2c96e)(parent, e.target, e.expanded);
        };
        const { index: index, emoji: emoji } = this;
        const folder = (0, $f99d9b9bcbcf0b76$export$11e5e2379ae5b62d)(parent, {
            title: `${emoji} Path`,
            type: (0, $f99d9b9bcbcf0b76$export$76fef7449090be6a),
            onRemoveClick: onRemoveClick,
            onVisibleClick: onVisibleClick
        });
        folder.on('fold', onFold);
        folder.addBlade({
            view: 'list',
            label: '+ STYLE',
            options: this.styleOptions,
            value: this.styleOptions[0].value
        }).on('change', onAddStyle);
        this.folder = folder;
    }
}





class $721abd4006ac2ed7$export$2e2bcd8739ae039 {
    constructor(webgl){
        this.webgl = webgl;
        this.object3D = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.object3D.position.y = 5;
        this.paths = [];
        this.selected = null;
    }
    addPath() {
        const path = new (0, $c64c6e2d46975a07$export$2e2bcd8739ae039)(this, this.paths.length);
        this.paths.push(path);
        this.object3D.add(path.object3D);
        this.select(path.index);
        return path;
    }
    removePath(index) {
        const path = this.paths.find((p)=>p.index == index);
        if (!path) return;
        if ((0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)()) (0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)().folderPaths.remove(path.folder);
        this.paths.splice(path.index, 1);
        this.object3D.remove(path.object3D);
        path.dispose();
        // reset indices
        this.paths.forEach((p, i)=>p.index = i);
        // select last index
        this.select(this.paths.length - 1);
        this.updateInteractive();
    }
    updateInteractive() {
        const { interactive: interactive } = this.webgl;
        if (!interactive) return;
        // clear interactive list
        interactive.objects = [];
        // push anchors to interactive
        this.paths.forEach((path)=>{
            path.anchors.forEach((anchor)=>{
                interactive.objects.push(anchor.object3D);
            });
        });
    }
    updateColors() {
        this.paths.forEach((path)=>path.updateColors());
    }
    show(onComplete) {
        let delay = 0;
        let countComplete = 0;
        const onPathComplete = ()=>{
            countComplete++;
            if (onComplete && countComplete == this.paths.length) onComplete();
        };
        this.paths.forEach((path)=>delay += path.show(delay, onPathComplete));
    }
    hide(onComplete) {
        let delay = 0;
        let countComplete = 0;
        const onPathComplete = ()=>{
            countComplete++;
            if (onComplete && countComplete == this.paths.length) onComplete();
        };
        this.paths.forEach((path)=>delay += path.hide(delay, onPathComplete));
    }
    showHide(onComplete) {
        let showDelay = 0;
        let hideDelay = 1;
        let countComplete = 0;
        const onPathComplete = ()=>{
            countComplete++;
            if (onComplete && countComplete == this.paths.length) onComplete();
        };
        this.paths.forEach((path)=>{
            const { showDuration: showDuration, hideComplete: hideComplete } = path.showHide(showDelay, hideDelay, onPathComplete);
            // start showing next early
            showDelay += showDuration * 1.0;
            // start hiding next early
            hideDelay = hideComplete * 1.0;
        });
    }
    select(index = null) {
        this.paths.forEach((path)=>{
            path.selected = path.index == index;
        });
        this.selected = this.paths.find((path)=>path.selected);
        this.updateInteractive();
        (0, $3e6ad3d87c16793a$export$bad24218ebd77223).emit((0, $3e6ad3d87c16793a$export$4bf9923669ad6c63).PATH_SELECT, this.selected);
    }
    clear() {
        this.paths.forEach((path)=>path.dispose());
        this.paths = [];
        this.object3D.clear();
        this.select(null);
    }
    reload(goal) {
        // expand folder paths to avoid a Tweakpane bug
        if ((0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)() && (0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)().folderPaths) (0, $f99d9b9bcbcf0b76$export$5ca3895f35d8816b)().folderPaths.expanded = true;
        goal.paths.forEach((data)=>{
            this.addPath().reload(data);
        });
        // select last index
        this.select(this.paths.length - 1);
    }
    serialize() {
        return this.paths.map((path)=>path.serialize());
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    resize(vw, vh) {
        this.paths.forEach((path)=>path.resize(vw, vh));
    }
    onInteractiveOver(e) {
        if (!e.object || !e.object.anchor) return;
        e.object.anchor.onInteractiveOver(e);
    }
    onInteractiveOut(e) {
        if (!e.object || !e.object.anchor) return;
        e.object.anchor.onInteractiveOut(e);
    }
    onInteractiveDown(e) {
        if (!e.object || !e.object.anchor) return;
        e.object.anchor.onInteractiveDown(e);
        this.select(e.object.anchor.path.index);
    }
}


const $8bcd7fc541852d68$export$427cffc516e1246d = 'camera-top';
const $8bcd7fc541852d68$export$bf7b413a975ac826 = 'camera-free';
const $8bcd7fc541852d68$export$85b63003e6064cd0 = 'camera-center';
class $8bcd7fc541852d68$var$Trajectory {
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
        this.initiated = false;
    }
    init(page) {
        if (this.initiated) return;
        this.initiated = true;
        this.page = page;
        this.dummy = new $f70f7eb6404ce619$export$e4dd07dff30cc924();
        this.initThree();
        this.initPitch();
        this.initPaths();
        this.initLights();
    }
    initThree() {
        this.scene = new $f70f7eb6404ce619$export$38af1803e3442a7f();
        this.camera = new $f70f7eb6404ce619$export$74e4ae24825f68d7(50, window.innerWidth / window.innerHeight, 1, 10000);
        this.camera.position.set(0, 100, 1000);
        this.clock = new $f70f7eb6404ce619$export$9735c82c4bae3302();
    }
    initPitch() {
        this.pitch = new (0, $c66d2cdc82603e69$export$2e2bcd8739ae039)(this);
        this.pitch.object3D.rotation.x = Math.PI * -0.5;
        this.scene.add(this.pitch.object3D);
    }
    initPaths() {
        this.paths = new (0, $721abd4006ac2ed7$export$2e2bcd8739ae039)(this);
        this.scene.add(this.paths.object3D);
    }
    initLights() {
        this.lights = [];
        let light;
        light = new $f70f7eb6404ce619$export$3fea33cc9972c868(0xFFFFFF, 0.3);
        light.position.set(1, 1, 0);
        this.lights.push(light);
        light = new $f70f7eb6404ce619$export$3fea33cc9972c868(0xFFFFFF, 0.3);
        light.position.set(0, -1, 1);
        this.lights.push(light);
        light = new $f70f7eb6404ce619$export$af279bfef9ec2c96(0xFFFFFF, 0.6);
        this.lights.push(light);
        this.lights.forEach((light)=>this.scene.add(light));
    }
    initData() {
        const goal = (0, $5767c36b17e72441$export$eda215a895aa0ddc)();
        if (!goal) return;
        const sign = goal.leftSide ? 1 : -1;
        this.storedCamera = {
            free: {
                position: new $f70f7eb6404ce619$export$64b5c384219d3699(660, 220, 320),
                quaternion: new $f70f7eb6404ce619$export$23d6a54f0bbc85a3(-0.12, 0.52, 0.07, 0.83),
                target: new $f70f7eb6404ce619$export$64b5c384219d3699(0, 0, 0)
            },
            center: {
                position: new $f70f7eb6404ce619$export$64b5c384219d3699(100 * sign, 200, 0),
                quaternion: new $f70f7eb6404ce619$export$23d6a54f0bbc85a3(-0.1814, 0.6834 * sign, 0.1814 * sign, 0.6834),
                target: new $f70f7eb6404ce619$export$64b5c384219d3699(250 * -sign, 0, 0)
            }
        };
        this.restoreCamera(goal);
        this.paths.reload(goal);
    }
    addListeners() {
        window.addEventListener('resize', this.resize);
    }
    removeListeners() {
        window.removeEventListener('resize', this.resize);
    }
    restoreCamera(goal) {
        if (!goal.camera) return;
        const { position: p, quaternion: q, target: t } = goal.camera;
        this.storedCamera.free.position.set(p.x, p.y, p.z);
        this.storedCamera.free.quaternion.set(q.x, q.y, q.z, q.w);
        this.storedCamera.free.target.set(t.x, t.y, t.z);
        this.moveCamera($8bcd7fc541852d68$export$bf7b413a975ac826, true);
    }
    animate() {
        this.update();
        this.draw();
        this.raf = requestAnimationFrame(this.animate);
    }
    // ---------------------------------------------------------------------------------------------
    // PUBLIC
    // ---------------------------------------------------------------------------------------------
    update() {
        if (this.orbit?.enabled) this.orbit.update();
    }
    draw() {
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.render(this.scene, this.camera);
    }
    preShow() {
        this.scene.visible = false;
    }
    show(onComplete) {
        this.initData();
        this.addListeners();
        this.animate();
        this.resize();
        this.scene.visible = true;
        this.dualShow(onComplete);
    }
    // show once -> change camera -> show again
    dualShow(onComplete) {
        this.showCamera($8bcd7fc541852d68$export$85b63003e6064cd0);
        this.paths.show(()=>{
            this.showCamera($8bcd7fc541852d68$export$bf7b413a975ac826);
            this.paths.showHide(onComplete);
        });
    }
    stop() {
        this.paths.clear();
        cancelAnimationFrame(this.raf);
        this.removeListeners();
    }
    showCamera(label) {
        const { camera: camera, storedCamera: storedCamera } = this;
        // dry cut to camera position
        this.moveCamera(label, true);
        // stop existing animation
        if (this.timeline) this.timeline.kill();
        if (label == $8bcd7fc541852d68$export$85b63003e6064cd0) {
            const posA = storedCamera.center.position.clone();
            const tgtA = storedCamera.center.target.clone();
            // vecA between position and target
            const vecA = posA.clone().subVectors(posA, tgtA);
            // vecB: zoomed out vecA
            const vecB = vecA.clone().setLength(vecA.length() * 1.1);
            // add target back
            vecA.add(tgtA);
            vecB.add(tgtA);
            camera.position.copy(vecB);
            this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
                onUpdate: ()=>camera.lookAt(tgtA)
            });
            this.timeline.to(camera.position, {
                x: vecA.x,
                y: vecA.y,
                z: vecA.z,
                duration: 4,
                ease: 'quad.out'
            }, 0);
        }
        if (label == $8bcd7fc541852d68$export$bf7b413a975ac826) {
            const posA = storedCamera.free.position.clone();
            const tgtA = storedCamera.free.target.clone();
            const vec0 = new $f70f7eb6404ce619$export$c977b3e384af9ae1();
            // vecA between position and target
            const vecA = posA.clone().subVectors(posA, tgtA);
            // vecB: zoomed out vecA
            const vecB = vecA.clone().setLength(vecA.length() * 0.9);
            // vecC/vecD: shadow of vecB/vecA on the pitch
            const vecC = vec0.clone().set(vecB.x, vecB.z);
            const vecD = vec0.clone().set(vecA.x, vecA.z);
            // vecE/vecF: vecC/vecD rotated around center
            const vecE = vecC.clone().rotateAround(vec0, 0.05);
            const vecF = vecD.clone().rotateAround(vec0, -0.05);
            // vecG/vecH: initial/final rotation
            const vecG = posA.clone().set(vecE.x, vecB.y, vecE.y).add(tgtA);
            const vecH = posA.clone().set(vecF.x, vecA.y, vecF.y).add(tgtA);
            camera.position.copy(vecG);
            this.timeline = (0, $c5f6ad5335c7d493$export$99ee26438460406a).timeline({
                onUpdate: ()=>camera.lookAt(tgtA)
            });
            this.timeline.to(camera.position, {
                x: vecH.x,
                y: vecH.y,
                z: vecH.z,
                duration: 4,
                ease: 'quad.out'
            }, 0);
        }
    }
    moveCamera(label, immediate = false) {
        const { camera: camera, scene: scene, orbit: orbit, dummy: dummy, storedCamera: storedCamera } = this;
        const center = new $f70f7eb6404ce619$export$64b5c384219d3699();
        const tween = {
            value: 0
        };
        const duration = immediate ? 0 : 0.4;
        const onUpdate = ()=>{
            camera.quaternion.slerpQuaternions(camera.lastQuaternion, dummy.quaternion, tween.value);
        };
        const onComplete = ()=>{
            if (orbit) orbit.enabled = true;
        };
        if (label == $8bcd7fc541852d68$export$427cffc516e1246d) {
            dummy.position.set(0, 1000, 0);
            dummy.lookAt(center);
            dummy.quaternion.conjugate();
            if (orbit) orbit.target.copy(scene.position);
        } else if (label == $8bcd7fc541852d68$export$85b63003e6064cd0) {
            dummy.position.copy(storedCamera.center.position);
            dummy.quaternion.copy(storedCamera.center.quaternion);
            if (orbit) orbit.target.copy(storedCamera.center.target);
        } else {
            dummy.position.copy(storedCamera.free.position);
            dummy.quaternion.copy(storedCamera.free.quaternion);
            if (orbit) orbit.target.copy(storedCamera.free.target);
        }
        camera.lastQuaternion = camera.quaternion.clone();
        if (orbit) orbit.enabled = label != $8bcd7fc541852d68$export$427cffc516e1246d;
        const { position: dp } = dummy;
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(camera.position, {
            x: dp.x,
            y: dp.y,
            z: dp.z,
            duration: duration,
            ease: 'power2.out'
        });
        (0, $c5f6ad5335c7d493$export$99ee26438460406a).to(tween, {
            value: 1,
            duration: duration,
            ease: 'power2.out',
            onUpdate: onUpdate,
            onComplete: onComplete
        });
    }
    // ---------------------------------------------------------------------------------------------
    // EVENT HANDLERS
    // ---------------------------------------------------------------------------------------------
    resize(vw, vh, editMode = false) {
        if (!vw || vw instanceof Event) vw = window.innerWidth;
        if (!vh) vh = window.innerHeight;
        // override GLApp.resize
        (0, $6d108ce629b3bd63$export$2e2bcd8739ae039).renderer.setSize(vw, vh);
        this.camera.zoom = 1;
        if (vw < (0, $d1a28c8d5f44cae3$export$d07517a676ce386f).wide) this.camera.zoom = 0.75;
        if (vw < (0, $d1a28c8d5f44cae3$export$d07517a676ce386f).desktop) this.camera.zoom = 0.60;
        if (editMode) this.camera.zoom = 1;
        this.camera.aspect = vw / vh;
        this.camera.updateProjectionMatrix();
        this.pitch.resize();
    }
}
var $8bcd7fc541852d68$export$2e2bcd8739ae039 = new $8bcd7fc541852d68$var$Trajectory();


function $77befa589a1d8096$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Csection class=\"goal\"\u003E\u003C\u002Fsection\u003E";
    return pug_html;
}
var $77befa589a1d8096$export$2e2bcd8739ae039 = $77befa589a1d8096$var$template;



class $0c1dd5dcc6d5ce43$var$Goal {
    constructor(){
        (0, $1dd800e365bb90af$export$2e2bcd8739ae039)(this);
    }
    render() {
        this.el = (0, $7c9350f720ca2356$export$2e2bcd8739ae039)((0, $77befa589a1d8096$export$2e2bcd8739ae039)());
        document.querySelector('.page').appendChild(this.el);
        (0, $8bcd7fc541852d68$export$2e2bcd8739ae039).init(this);
        (0, $8bcd7fc541852d68$export$2e2bcd8739ae039).preShow();
    }
    transitionIn(req, done) {
        (0, $5767c36b17e72441$export$54e5dfa78c47e5be)((0, $5767c36b17e72441$export$eda215a895aa0ddc)(req.params.id));
        this.render();
        done();
        // start showHide sequence
        this.introTL = (0, $8bcd7fc541852d68$export$2e2bcd8739ae039).show(()=>{
            // navigate out when hide complete
            (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go(`/match/${(0, $5767c36b17e72441$export$eda215a895aa0ddc)().match}`);
        });
    }
    transitionOut(req, done) {
        (0, $8bcd7fc541852d68$export$2e2bcd8739ae039).stop();
        done();
    }
    dispose() {}
}
var $0c1dd5dcc6d5ce43$export$2e2bcd8739ae039 = new $0c1dd5dcc6d5ce43$var$Goal();


(0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).flow('destroy+run');
(0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).use((0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).addressbar);
let $4ee2f3ec9e8075e4$export$b3219800bda33a1f = (0, $73647fc189170cc1$export$2e2bcd8739ae039);
let $4ee2f3ec9e8075e4$export$de994efd351b291c = (0, $7b11f892fa3d25c5$export$2e2bcd8739ae039);
let $4ee2f3ec9e8075e4$export$8fc75e1e2d962b0f = (0, $0c1dd5dcc6d5ce43$export$2e2bcd8739ae039);
let $4ee2f3ec9e8075e4$var$currentMatch;
var $4ee2f3ec9e8075e4$export$2e2bcd8739ae039 = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports)))('/', $4ee2f3ec9e8075e4$export$b3219800bda33a1f.transitionIn, $4ee2f3ec9e8075e4$export$b3219800bda33a1f.transitionOut);
    (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports)))('/matches', $4ee2f3ec9e8075e4$export$de994efd351b291c.transitionIn, $4ee2f3ec9e8075e4$export$de994efd351b291c.transitionOut, '/');
    (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports)))('/match/:id', (req, done)=>{
        $4ee2f3ec9e8075e4$var$currentMatch = new (0, $9741e9da76fb5412$export$2e2bcd8739ae039)();
        $4ee2f3ec9e8075e4$var$currentMatch.transitionIn(req, done);
    }, (req, done)=>{
        if ($4ee2f3ec9e8075e4$var$currentMatch) $4ee2f3ec9e8075e4$var$currentMatch.transitionOut(req, done);
    }, '/');
    (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports)))('/goal/:id', $4ee2f3ec9e8075e4$export$8fc75e1e2d962b0f.transitionIn, $4ee2f3ec9e8075e4$export$8fc75e1e2d962b0f.transitionOut, '/');
    (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).go((0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).pathname().length > 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).pathname() : '/');
    // ways.go(`/`);
    (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).on('url:change', (url)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($7382cc169ba6fa55$exports))).__nextURL = url;
    });
    window.addEventListener('resize', ()=>{
        $4ee2f3ec9e8075e4$export$b3219800bda33a1f.resize();
        $4ee2f3ec9e8075e4$export$de994efd351b291c.resize();
        if ($4ee2f3ec9e8075e4$var$currentMatch) $4ee2f3ec9e8075e4$var$currentMatch.resize();
    });
};



var $f1z04 = parcelRequire("f1z04");

























var $f19d6f0c77b0f915$export$99ee26438460406a = (0, $f1z04.default).registerPlugin((0, $4daeca3a962ccad2$export$855822f522f18eef)) || (0, $f1z04.default), // to protect from tree shaking
$f19d6f0c77b0f915$export$7b23975ad686bf91 = $f19d6f0c77b0f915$export$99ee26438460406a.core.Tween;


window.addEventListener('DOMContentLoaded', (event)=>{
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // register gsap plugins once
    (0, $f19d6f0c77b0f915$export$99ee26438460406a).registerPlugin((0, $d7bce274927d21cc$export$94f46869cc67acd8));
    (0, $4ee2f3ec9e8075e4$export$2e2bcd8739ae039)();
});
window.addEventListener('resize', ()=>{
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});


//# sourceMappingURL=repo.27577329.js.map
